(function(){"use strict";try{if(typeof document<"u"){var e=document.createElement("style");e.appendChild(document.createTextNode("._unmatchedHeader_qcj19_1{opacity:.55}")),document.head.appendChild(e)}}catch(t){console.error("vite-plugin-css-injected-by-js",t)}})();
import { isRunningLocalPartnerApi as lI, getPartnerDevApiHeaders as dI, WidgetContextProvider as cI, makeExecuteQuery as uI, makeUseLazyQuery as mI, makeUseQuery as pI, makeUseMutation as fI, IntegrationModal as hI, useWidgetSettingsMutations as mr, useWidgetSettingsQuery as pr, useRenderConditions as fr, PartnerSettingsWrapper as hr, handleWidgetSubmit as yr, MisconfigurationBanner as gr, validateApiHostName as zl, mapLabels as ir, PartnerHookFormSecretText as $r, WidgetSettingsFormFooter as vr, useTracking as jn, useWidgetContext as hn, hasDownstreamApiForbiddenError as Ul, hasDownstreamApiAuthorizationError as Ml, DisplayErrors as $n, settingsToFormValues as Bl, useCopyWithDelay as Jt, defaultDateFormat as $t, displayAttributeValue as Bi, OAuthSettings as vi, useData as Cy, isDownstreamApiNotFoundError as yI, isDownstreamApiAuthorizationError as _w, isDownstreamApiPermissionError as gI, capitalizeFirstCharacter as xw, humanizeKey as vI, hasDownstreamApiTooManyRequestsError as kI, hasDownstreamApiPermissionError as Sw, PartnerHookFormBasicAuth as bI, hasDownstreamApiNotFoundError as Ca, getCountryNameFromCountryCode as _I, parseBoolean as xI, parseString as SI } from "lib-integrations-partner-support";
export * from "lib-integrations-partner-support";
import qe, { useMemo as Xn, useContext as ql, createContext as Fy, useState as pe, useEffect as Qe, useRef as Er, useCallback as ft, useReducer as NI, useLayoutEffect as jI, isValidElement as Nw, Fragment as wI, createElement as CI } from "react";
import { FlexBox as b, Switch as Vo, FieldLabel as jw, FieldWrapper as He, InputText as cr, InputSelectionList as pi, FormGrid as et, FormField as X, Text as $, Spinner as mn, Icon as he, Tooltip as Xe, List as Ye, Badge as Pn, Button as tt, IconButton as Qt, Tag as Jn, NavigationButton as It, Select as Tr, CollapseCard as xr, Box as lt, Modal as bt, ModalHead as _t, ModalBody as xt, ModalFoot as wt, Textarea as Wh, TagsInput as Hl, Image as Fa, Banner as Iy, FieldSwitch as ww, SelectionList as mt, Divider as Wl, FieldText as Wr, FieldTextarea as FI, CopyToClipboardButton as II, getSelectionListContext as $I, Avatar as $y, Timestamp as EI, Attachment as TI, EmptyState as zo, Table as ot, Checkbox as dv, TextWithHighlight as Cw, ErrorBoundaryContext as Fw } from "@dixa/lib-shared-habla";
import ct from "classnames";
import { ApolloLink as Ey, Observable as Iw, ApolloClient as RI, InMemoryCache as DI, createHttpLink as OI, ApolloProvider as PI, useApolloClient as AI, ApolloConsumer as LI, NetworkStatus as rr, isApolloError as $w, gql as Kl, ApolloError as Ew } from "@apollo/client";
import VI from "cross-fetch";
import { config as Uo } from "lib-shared-backend-config";
import Gn from "moment";
import "moment-timezone";
import { __rest as zI, __assign as bd } from "tslib";
function Ty(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var us = { exports: {} }, Ma = {};
var cv;
function UI() {
  if (cv) return Ma;
  cv = 1;
  var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, c, m) {
    var u, f = {}, h = null, k = null;
    m !== void 0 && (h = "" + m), c.key !== void 0 && (h = "" + c.key), c.ref !== void 0 && (k = c.ref);
    for (u in c) i.call(c, u) && !o.hasOwnProperty(u) && (f[u] = c[u]);
    if (l && l.defaultProps) for (u in c = l.defaultProps, c) f[u] === void 0 && (f[u] = c[u]);
    return { $$typeof: n, type: l, key: h, ref: k, props: f, _owner: a.current };
  }
  return Ma.Fragment = r, Ma.jsx = s, Ma.jsxs = s, Ma;
}
var Ba = {};
var uv;
function MI() {
  return uv || (uv = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), c = /* @__PURE__ */ Symbol.for("react.forward_ref"), m = /* @__PURE__ */ Symbol.for("react.suspense"), u = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), k = /* @__PURE__ */ Symbol.for("react.offscreen"), w = Symbol.iterator, N = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var d = w && t[w] || t[N];
      return typeof d == "function" ? d : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var d = arguments.length, p = new Array(d > 1 ? d - 1 : 0), y = 1; y < d; y++)
          p[y - 1] = arguments[y];
        O("error", t, p);
      }
    }
    function O(t, d, p) {
      {
        var y = _.ReactDebugCurrentFrame, C = y.getStackAddendum();
        C !== "" && (d += "%s", p = p.concat([C]));
        var T = p.map(function(S) {
          return String(S);
        });
        T.unshift("Warning: " + d), Function.prototype.apply.call(console[t], console, T);
      }
    }
    var R = !1, F = !1, I = !1, L = !1, W = !1, J;
    J = /* @__PURE__ */ Symbol.for("react.module.reference");
    function re(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || W || t === a || t === m || t === u || L || t === k || R || F || I || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === J || t.getModuleId !== void 0));
    }
    function K(t, d, p) {
      var y = t.displayName;
      if (y)
        return y;
      var C = d.displayName || d.name || "";
      return C !== "" ? p + "(" + C + ")" : p;
    }
    function Y(t) {
      return t.displayName || "Context";
    }
    function P(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var d = t;
            return Y(d) + ".Consumer";
          case s:
            var p = t;
            return Y(p._context) + ".Provider";
          case c:
            return K(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : P(t.type) || "Memo";
          case h: {
            var C = t, T = C._payload, S = C._init;
            try {
              return P(S(T));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, ie = 0, we, me, le, ge, V, be, Oe;
    function q() {
    }
    q.__reactDisabledLog = !0;
    function Ge() {
      {
        if (ie === 0) {
          we = console.log, me = console.info, le = console.warn, ge = console.error, V = console.group, be = console.groupCollapsed, Oe = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: q,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ie++;
      }
    }
    function sn() {
      {
        if (ie--, ie === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, t, {
              value: we
            }),
            info: B({}, t, {
              value: me
            }),
            warn: B({}, t, {
              value: le
            }),
            error: B({}, t, {
              value: ge
            }),
            group: B({}, t, {
              value: V
            }),
            groupCollapsed: B({}, t, {
              value: be
            }),
            groupEnd: B({}, t, {
              value: Oe
            })
          });
        }
        ie < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ie = _.ReactCurrentDispatcher, Ue;
    function De(t, d, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (C) {
            var y = C.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Ae;
    {
      var Je = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Je();
    }
    function Ee(t, d) {
      if (!t || Be)
        return "";
      {
        var p = Ae.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Be = !0;
      var C = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var T;
      T = Ie.current, Ie.current = null, Ge();
      try {
        if (d) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (ne) {
              y = ne;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (ne) {
              y = ne;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            y = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && y && typeof ne.stack == "string") {
          for (var x = ne.stack.split(`
`), Z = y.stack.split(`
`), A = x.length - 1, M = Z.length - 1; A >= 1 && M >= 0 && x[A] !== Z[M]; )
            M--;
          for (; A >= 1 && M >= 0; A--, M--)
            if (x[A] !== Z[M]) {
              if (A !== 1 || M !== 1)
                do
                  if (A--, M--, M < 0 || x[A] !== Z[M]) {
                    var ue = `
` + x[A].replace(" at new ", " at ");
                    return t.displayName && ue.includes("<anonymous>") && (ue = ue.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, ue), ue;
                  }
                while (A >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Ie.current = T, sn(), Error.prepareStackTrace = C;
      }
      var ze = t ? t.displayName || t.name : "", Te = ze ? De(ze) : "";
      return typeof t == "function" && Ae.set(t, Te), Te;
    }
    function Me(t, d, p) {
      return Ee(t, !1);
    }
    function en(t) {
      var d = t.prototype;
      return !!(d && d.isReactComponent);
    }
    function se(t, d, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ee(t, en(t));
      if (typeof t == "string")
        return De(t);
      switch (t) {
        case m:
          return De("Suspense");
        case u:
          return De("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case c:
            return Me(t.render);
          case f:
            return se(t.type, d, p);
          case h: {
            var y = t, C = y._payload, T = y._init;
            try {
              return se(T(C), d, p);
            } catch {
            }
          }
        }
      return "";
    }
    var de = Object.prototype.hasOwnProperty, Se = {}, Ve = _.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var d = t._owner, p = se(t.type, t._source, d ? d.type : null);
        Ve.setExtraStackFrame(p);
      } else
        Ve.setExtraStackFrame(null);
    }
    function kn(t, d, p, y, C) {
      {
        var T = Function.call.bind(de);
        for (var S in t)
          if (T(t, S)) {
            var x = void 0;
            try {
              if (typeof t[S] != "function") {
                var Z = Error((y || "React class") + ": " + p + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Z.name = "Invariant Violation", Z;
              }
              x = t[S](d, S, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (A) {
              x = A;
            }
            x && !(x instanceof Error) && (Pe(C), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, S, typeof x), Pe(null)), x instanceof Error && !(x.message in Se) && (Se[x.message] = !0, Pe(C), g("Failed %s type: %s", p, x.message), Pe(null));
          }
      }
    }
    var Q = Array.isArray;
    function E(t) {
      return Q(t);
    }
    function z(t) {
      {
        var d = typeof Symbol == "function" && Symbol.toStringTag, p = d && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function ae(t) {
      try {
        return ce(t), !1;
      } catch {
        return !0;
      }
    }
    function ce(t) {
      return "" + t;
    }
    function U(t) {
      if (ae(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", z(t)), ce(t);
    }
    var G = _.ReactCurrentOwner, ve = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, je, Re;
    function rn(t) {
      if (de.call(t, "ref")) {
        var d = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (d && d.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function bn(t) {
      if (de.call(t, "key")) {
        var d = Object.getOwnPropertyDescriptor(t, "key").get;
        if (d && d.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function an(t, d) {
      typeof t.ref == "string" && G.current;
    }
    function fn(t, d) {
      {
        var p = function() {
          je || (je = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", d));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function En(t, d) {
      {
        var p = function() {
          Re || (Re = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", d));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var _n = function(t, d, p, y, C, T, S) {
      var x = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: d,
        ref: p,
        props: S,
        // Record the component responsible for creating this element.
        _owner: T
      };
      return x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(x, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(x, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: C
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    };
    function Fn(t, d, p, y, C) {
      {
        var T, S = {}, x = null, Z = null;
        p !== void 0 && (U(p), x = "" + p), bn(d) && (U(d.key), x = "" + d.key), rn(d) && (Z = d.ref, an(d, C));
        for (T in d)
          de.call(d, T) && !ve.hasOwnProperty(T) && (S[T] = d[T]);
        if (t && t.defaultProps) {
          var A = t.defaultProps;
          for (T in A)
            S[T] === void 0 && (S[T] = A[T]);
        }
        if (x || Z) {
          var M = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          x && fn(S, M), Z && En(S, M);
        }
        return _n(t, x, Z, C, y, G.current, S);
      }
    }
    var Ze = _.ReactCurrentOwner, gn = _.ReactDebugCurrentFrame;
    function Le(t) {
      if (t) {
        var d = t._owner, p = se(t.type, t._source, d ? d.type : null);
        gn.setExtraStackFrame(p);
      } else
        gn.setExtraStackFrame(null);
    }
    var dn;
    dn = !1;
    function cn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function Nn() {
      {
        if (Ze.current) {
          var t = P(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Bn(t) {
      return "";
    }
    var Sn = {};
    function An(t) {
      {
        var d = Nn();
        if (!d) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (d = `

Check the top-level render call using <` + p + ">.");
        }
        return d;
      }
    }
    function vn(t, d) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = An(d);
        if (Sn[p])
          return;
        Sn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Ze.current && (y = " It was passed a child from " + P(t._owner.type) + "."), Le(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Le(null);
      }
    }
    function xn(t, d) {
      {
        if (typeof t != "object")
          return;
        if (E(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            cn(y) && vn(y, d);
          }
        else if (cn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var C = j(t);
          if (typeof C == "function" && C !== t.entries)
            for (var T = C.call(t), S; !(S = T.next()).done; )
              cn(S.value) && vn(S.value, d);
        }
      }
    }
    function Ln(t) {
      {
        var d = t.type;
        if (d == null || typeof d == "string")
          return;
        var p;
        if (typeof d == "function")
          p = d.propTypes;
        else if (typeof d == "object" && (d.$$typeof === c || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        d.$$typeof === f))
          p = d.propTypes;
        else
          return;
        if (p) {
          var y = P(d);
          kn(p, t.props, "prop", y, t);
        } else if (d.PropTypes !== void 0 && !dn) {
          dn = !0;
          var C = P(d);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", C || "Unknown");
        }
        typeof d.getDefaultProps == "function" && !d.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var d = Object.keys(t.props), p = 0; p < d.length; p++) {
          var y = d[p];
          if (y !== "children" && y !== "key") {
            Le(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Le(null);
            break;
          }
        }
        t.ref !== null && (Le(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Le(null));
      }
    }
    var Cn = {};
    function wn(t, d, p, y, C, T) {
      {
        var S = re(t);
        if (!S) {
          var x = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (x += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Z = Bn();
          Z ? x += Z : x += Nn();
          var A;
          t === null ? A = "null" : E(t) ? A = "array" : t !== void 0 && t.$$typeof === n ? (A = "<" + (P(t.type) || "Unknown") + " />", x = " Did you accidentally export a JSX literal instead of a component?") : A = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", A, x);
        }
        var M = Fn(t, d, p, C, T);
        if (M == null)
          return M;
        if (S) {
          var ue = d.children;
          if (ue !== void 0)
            if (y)
              if (E(ue)) {
                for (var ze = 0; ze < ue.length; ze++)
                  xn(ue[ze], t);
                Object.freeze && Object.freeze(ue);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              xn(ue, t);
        }
        if (de.call(d, "key")) {
          var Te = P(t), ne = Object.keys(d).filter(function(Kn) {
            return Kn !== "key";
          }), un = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Cn[Te + un]) {
            var Rn = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, un, Te, Rn, Te), Cn[Te + un] = !0;
          }
        }
        return t === i ? Vn(M) : Ln(M), M;
      }
    }
    function zn(t, d, p) {
      return wn(t, d, p, !0);
    }
    function qn(t, d, p) {
      return wn(t, d, p, !1);
    }
    var Un = qn, Wn = zn;
    Ba.Fragment = i, Ba.jsx = Un, Ba.jsxs = Wn;
  })()), Ba;
}
var mv;
function BI() {
  return mv || (mv = 1, process.env.NODE_ENV === "production" ? us.exports = UI() : us.exports = MI()), us.exports;
}
var Qn = BI();
function Tw(e, n) {
  return function() {
    return e.apply(n, arguments);
  };
}
const { toString: qI } = Object.prototype, { getPrototypeOf: ba } = Object, { iterator: Yo, toStringTag: Rw } = Symbol, ul = (({ hasOwnProperty: e }) => (n, r) => e.call(n, r))(Object.prototype), Mo = (e, n) => {
  let r = e;
  const i = [];
  for (; r != null && r !== Object.prototype; ) {
    if (i.indexOf(r) !== -1)
      return !1;
    if (i.push(r), ul(r, n))
      return !0;
    r = ba(r);
  }
  return !1;
}, HI = (e, n) => e != null && Mo(e, n) ? e[n] : void 0, Ry = /* @__PURE__ */ ((e) => (n) => {
  const r = qI.call(n);
  return e[r] || (e[r] = r.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), Rr = (e) => (e = e.toLowerCase(), (n) => Ry(n) === e), Gl = (e) => (n) => typeof n === e, { isArray: qi } = Array, _a = Gl("undefined");
function Ia(e) {
  return e !== null && !_a(e) && e.constructor !== null && !_a(e.constructor) && nr(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const Dw = Rr("ArrayBuffer");
function WI(e) {
  let n;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? n = ArrayBuffer.isView(e) : n = e && e.buffer && Dw(e.buffer), n;
}
const KI = Gl("string"), nr = Gl("function"), Ow = Gl("number"), $a = (e) => e !== null && typeof e == "object", GI = (e) => e === !0 || e === !1, Ys = (e) => {
  if (!$a(e))
    return !1;
  const n = ba(e);
  return (n === null || n === Object.prototype || ba(n) === null) && // Treat any genuine (non-Object.prototype-polluted) Symbol.toStringTag or
  // Symbol.iterator as evidence the value is a tagged/iterable type rather
  // than a plain object, while ignoring keys injected onto Object.prototype.
  !Mo(e, Rw) && !Mo(e, Yo);
}, YI = (e) => {
  if (!$a(e) || Ia(e))
    return !1;
  try {
    return Object.keys(e).length === 0 && Object.getPrototypeOf(e) === Object.prototype;
  } catch {
    return !1;
  }
}, JI = Rr("Date"), QI = Rr("File"), XI = (e) => !!(e && typeof e.uri < "u"), ZI = (e) => e && typeof e.getParts < "u", e$ = Rr("Blob"), n$ = Rr("FileList"), t$ = (e) => $a(e) && nr(e.pipe);
function r$() {
  return typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {};
}
const pv = r$(), fv = typeof pv.FormData < "u" ? pv.FormData : void 0, i$ = (e) => {
  if (!e) return !1;
  if (fv && e instanceof fv) return !0;
  const n = ba(e);
  if (!n || n === Object.prototype || !nr(e.append)) return !1;
  const r = Ry(e);
  return r === "formdata" || // detect form-data instance
  r === "object" && nr(e.toString) && e.toString() === "[object FormData]";
}, a$ = Rr("URLSearchParams"), [o$, s$, l$, d$] = [
  "ReadableStream",
  "Request",
  "Response",
  "Headers"
].map(Rr), c$ = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function Jo(e, n, { allOwnKeys: r = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let i, a;
  if (typeof e != "object" && (e = [e]), qi(e))
    for (i = 0, a = e.length; i < a; i++)
      n.call(null, e[i], i, e);
  else {
    if (Ia(e))
      return;
    const o = r ? Object.getOwnPropertyNames(e) : Object.keys(e), s = o.length;
    let l;
    for (i = 0; i < s; i++)
      l = o[i], n.call(null, e[l], l, e);
  }
}
function Pw(e, n) {
  if (Ia(e))
    return null;
  n = n.toLowerCase();
  const r = Object.keys(e);
  let i = r.length, a;
  for (; i-- > 0; )
    if (a = r[i], n === a.toLowerCase())
      return a;
  return null;
}
const Pi = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, Aw = (e) => !_a(e) && e !== Pi;
function Kh(...e) {
  const { caseless: n, skipUndefined: r } = Aw(this) && this || {}, i = {}, a = (o, s) => {
    if (s === "__proto__" || s === "constructor" || s === "prototype")
      return;
    const l = n && typeof s == "string" && Pw(i, s) || s, c = ul(i, l) ? i[l] : void 0;
    Ys(c) && Ys(o) ? i[l] = Kh(c, o) : Ys(o) ? i[l] = Kh({}, o) : qi(o) ? i[l] = o.slice() : (!r || !_a(o)) && (i[l] = o);
  };
  for (let o = 0, s = e.length; o < s; o++) {
    const l = e[o];
    if (!l || Ia(l) || (Jo(l, a), typeof l != "object" || qi(l)))
      continue;
    const c = Object.getOwnPropertySymbols(l);
    for (let m = 0; m < c.length; m++) {
      const u = c[m];
      x$.call(l, u) && a(l[u], u);
    }
  }
  return i;
}
const u$ = (e, n, r, { allOwnKeys: i } = {}) => (Jo(
  n,
  (a, o) => {
    r && nr(a) ? Object.defineProperty(e, o, {
      // Null-proto descriptor so a polluted Object.prototype.get cannot
      // hijack defineProperty's accessor-vs-data resolution.
      __proto__: null,
      value: Tw(a, r),
      writable: !0,
      enumerable: !0,
      configurable: !0
    }) : Object.defineProperty(e, o, {
      __proto__: null,
      value: a,
      writable: !0,
      enumerable: !0,
      configurable: !0
    });
  },
  { allOwnKeys: i }
), e), m$ = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), p$ = (e, n, r, i) => {
  e.prototype = Object.create(n.prototype, i), Object.defineProperty(e.prototype, "constructor", {
    __proto__: null,
    value: e,
    writable: !0,
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(e, "super", {
    __proto__: null,
    value: n.prototype
  }), r && Object.assign(e.prototype, r);
}, f$ = (e, n, r, i) => {
  let a, o, s;
  const l = {};
  if (n = n || {}, e == null) return n;
  do {
    for (a = Object.getOwnPropertyNames(e), o = a.length; o-- > 0; )
      s = a[o], (!i || i(s, e, n)) && !l[s] && (n[s] = e[s], l[s] = !0);
    e = r !== !1 && ba(e);
  } while (e && (!r || r(e, n)) && e !== Object.prototype);
  return n;
}, h$ = (e, n, r) => {
  e = String(e), (r === void 0 || r > e.length) && (r = e.length), r -= n.length;
  const i = e.indexOf(n, r);
  return i !== -1 && i === r;
}, y$ = (e) => {
  if (!e) return null;
  if (qi(e)) return e;
  let n = e.length;
  if (!Ow(n)) return null;
  const r = new Array(n);
  for (; n-- > 0; )
    r[n] = e[n];
  return r;
}, g$ = /* @__PURE__ */ ((e) => (n) => e && n instanceof e)(typeof Uint8Array < "u" && ba(Uint8Array)), v$ = (e, n) => {
  const i = (e && e[Yo]).call(e);
  let a;
  for (; (a = i.next()) && !a.done; ) {
    const o = a.value;
    n.call(e, o[0], o[1]);
  }
}, k$ = (e, n) => {
  let r;
  const i = [];
  for (; (r = e.exec(n)) !== null; )
    i.push(r);
  return i;
}, b$ = Rr("HTMLFormElement"), _$ = (e) => e.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function(r, i, a) {
  return i.toUpperCase() + a;
}), { propertyIsEnumerable: x$ } = Object.prototype, S$ = Rr("RegExp"), Lw = (e, n) => {
  const r = Object.getOwnPropertyDescriptors(e), i = {};
  Jo(r, (a, o) => {
    let s;
    (s = n(a, o, e)) !== !1 && (i[o] = s || a);
  }), Object.defineProperties(e, i);
}, N$ = (e) => {
  Lw(e, (n, r) => {
    if (nr(e) && ["arguments", "caller", "callee"].includes(r))
      return !1;
    const i = e[r];
    if (nr(i)) {
      if (n.enumerable = !1, "writable" in n) {
        n.writable = !1;
        return;
      }
      n.set || (n.set = () => {
        throw Error("Can not rewrite read-only method '" + r + "'");
      });
    }
  });
}, j$ = (e, n) => {
  const r = {}, i = (a) => {
    a.forEach((o) => {
      r[o] = !0;
    });
  };
  return qi(e) ? i(e) : i(String(e).split(n)), r;
}, w$ = () => {
}, C$ = (e, n) => e != null && Number.isFinite(e = +e) ? e : n;
function F$(e) {
  return !!(e && nr(e.append) && e[Rw] === "FormData" && e[Yo]);
}
const I$ = (e) => {
  const n = /* @__PURE__ */ new WeakSet(), r = (i) => {
    if ($a(i)) {
      if (n.has(i))
        return;
      if (Ia(i))
        return i;
      if (!("toJSON" in i)) {
        n.add(i);
        const a = qi(i) ? [] : {};
        return Jo(i, (o, s) => {
          const l = r(o);
          !_a(l) && (a[s] = l);
        }), n.delete(i), a;
      }
    }
    return i;
  };
  return r(e);
}, $$ = Rr("AsyncFunction"), E$ = (e) => e && ($a(e) || nr(e)) && nr(e.then) && nr(e.catch), Vw = ((e, n) => e ? setImmediate : n ? ((r, i) => (Pi.addEventListener(
  "message",
  ({ source: a, data: o }) => {
    a === Pi && o === r && i.length && i.shift()();
  },
  !1
), (a) => {
  i.push(a), Pi.postMessage(r, "*");
}))(`axios@${Math.random()}`, []) : (r) => setTimeout(r))(typeof setImmediate == "function", nr(Pi.postMessage)), T$ = typeof queueMicrotask < "u" ? queueMicrotask.bind(Pi) : typeof process < "u" && process.nextTick || Vw, zw = (e) => e != null && nr(e[Yo]), R$ = (e) => e != null && Mo(e, Yo) && zw(e), ye = {
  isArray: qi,
  isArrayBuffer: Dw,
  isBuffer: Ia,
  isFormData: i$,
  isArrayBufferView: WI,
  isString: KI,
  isNumber: Ow,
  isBoolean: GI,
  isObject: $a,
  isPlainObject: Ys,
  isEmptyObject: YI,
  isReadableStream: o$,
  isRequest: s$,
  isResponse: l$,
  isHeaders: d$,
  isUndefined: _a,
  isDate: JI,
  isFile: QI,
  isReactNativeBlob: XI,
  isReactNative: ZI,
  isBlob: e$,
  isRegExp: S$,
  isFunction: nr,
  isStream: t$,
  isURLSearchParams: a$,
  isTypedArray: g$,
  isFileList: n$,
  forEach: Jo,
  merge: Kh,
  extend: u$,
  trim: c$,
  stripBOM: m$,
  inherits: p$,
  toFlatObject: f$,
  kindOf: Ry,
  kindOfTest: Rr,
  endsWith: h$,
  toArray: y$,
  forEachEntry: v$,
  matchAll: k$,
  isHTMLForm: b$,
  hasOwnProperty: ul,
  hasOwnProp: ul,
  // an alias to avoid ESLint no-prototype-builtins detection
  hasOwnInPrototypeChain: Mo,
  getSafeProp: HI,
  reduceDescriptors: Lw,
  freezeMethods: N$,
  toObjectSet: j$,
  toCamelCase: _$,
  noop: w$,
  toFiniteNumber: C$,
  findKey: Pw,
  global: Pi,
  isContextDefined: Aw,
  isSpecCompliantForm: F$,
  toJSONObject: I$,
  isAsyncFn: $$,
  isThenable: E$,
  setImmediate: Vw,
  asap: T$,
  isIterable: zw,
  isSafeIterable: R$
}, D$ = ye.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), O$ = (e) => {
  const n = {};
  let r, i, a;
  return e && e.split(`
`).forEach(function(s) {
    a = s.indexOf(":"), r = s.substring(0, a).trim().toLowerCase(), i = s.substring(a + 1).trim(), !(!r || n[r] && D$[r]) && (r === "set-cookie" ? n[r] ? n[r].push(i) : n[r] = [i] : n[r] = n[r] ? n[r] + ", " + i : i);
  }), n;
};
function P$(e) {
  let n = 0, r = e.length;
  for (; n < r; ) {
    const i = e.charCodeAt(n);
    if (i !== 9 && i !== 32)
      break;
    n += 1;
  }
  for (; r > n; ) {
    const i = e.charCodeAt(r - 1);
    if (i !== 9 && i !== 32)
      break;
    r -= 1;
  }
  return n === 0 && r === e.length ? e : e.slice(n, r);
}
const A$ = new RegExp("[\\u0000-\\u0008\\u000a-\\u001f\\u007f]+", "g"), L$ = new RegExp("[^\\u0009\\u0020-\\u007e\\u0080-\\u00ff]+", "g");
function Dy(e, n) {
  return ye.isArray(e) ? e.map((r) => Dy(r, n)) : P$(String(e).replace(n, ""));
}
const V$ = (e) => Dy(e, A$), z$ = (e) => Dy(e, L$);
function Uw(e) {
  const n = /* @__PURE__ */ Object.create(null);
  return ye.forEach(e.toJSON(), (r, i) => {
    n[i] = z$(r);
  }), n;
}
const hv = /* @__PURE__ */ Symbol("internals");
function qa(e) {
  return e && String(e).trim().toLowerCase();
}
function Js(e) {
  return e === !1 || e == null ? e : ye.isArray(e) ? e.map(Js) : V$(String(e));
}
function U$(e) {
  const n = /* @__PURE__ */ Object.create(null), r = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let i;
  for (; i = r.exec(e); )
    n[i[1]] = i[2];
  return n;
}
const M$ = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function _d(e, n, r, i, a) {
  if (ye.isFunction(i))
    return i.call(this, n, r);
  if (a && (n = r), !!ye.isString(n)) {
    if (ye.isString(i))
      return n.indexOf(i) !== -1;
    if (ye.isRegExp(i))
      return i.test(n);
  }
}
function B$(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (n, r, i) => r.toUpperCase() + i);
}
function q$(e, n) {
  const r = ye.toCamelCase(" " + n);
  ["get", "set", "has"].forEach((i) => {
    Object.defineProperty(e, i + r, {
      // Null-proto descriptor so a polluted Object.prototype.get cannot turn
      // this data descriptor into an accessor descriptor on the way in.
      __proto__: null,
      value: function(a, o, s) {
        return this[i].call(this, n, a, o, s);
      },
      configurable: !0
    });
  });
}
let Ut = class {
  constructor(n) {
    n && this.set(n);
  }
  set(n, r, i) {
    const a = this;
    function o(l, c, m) {
      const u = qa(c);
      if (!u)
        return;
      const f = ye.findKey(a, u);
      (!f || a[f] === void 0 || m === !0 || m === void 0 && a[f] !== !1) && (a[f || c] = Js(l));
    }
    const s = (l, c) => ye.forEach(l, (m, u) => o(m, u, c));
    if (ye.isPlainObject(n) || n instanceof this.constructor)
      s(n, r);
    else if (ye.isString(n) && (n = n.trim()) && !M$(n))
      s(O$(n), r);
    else if (ye.isObject(n) && ye.isSafeIterable(n)) {
      let l = /* @__PURE__ */ Object.create(null), c, m;
      for (const u of n) {
        if (!ye.isArray(u))
          throw new TypeError("Object iterator must return a key-value pair");
        m = u[0], ye.hasOwnProp(l, m) ? (c = l[m], l[m] = ye.isArray(c) ? [...c, u[1]] : [c, u[1]]) : l[m] = u[1];
      }
      s(l, r);
    } else
      n != null && o(r, n, i);
    return this;
  }
  get(n, r) {
    if (n = qa(n), n) {
      const i = ye.findKey(this, n);
      if (i) {
        const a = this[i];
        if (!r)
          return a;
        if (r === !0)
          return U$(a);
        if (ye.isFunction(r))
          return r.call(this, a, i);
        if (ye.isRegExp(r))
          return r.exec(a);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(n, r) {
    if (n = qa(n), n) {
      const i = ye.findKey(this, n);
      return !!(i && this[i] !== void 0 && (!r || _d(this, this[i], i, r)));
    }
    return !1;
  }
  delete(n, r) {
    const i = this;
    let a = !1;
    function o(s) {
      if (s = qa(s), s) {
        const l = ye.findKey(i, s);
        l && (!r || _d(i, i[l], l, r)) && (delete i[l], a = !0);
      }
    }
    return ye.isArray(n) ? n.forEach(o) : o(n), a;
  }
  clear(n) {
    const r = Object.keys(this);
    let i = r.length, a = !1;
    for (; i--; ) {
      const o = r[i];
      (!n || _d(this, this[o], o, n, !0)) && (delete this[o], a = !0);
    }
    return a;
  }
  normalize(n) {
    const r = this, i = {};
    return ye.forEach(this, (a, o) => {
      const s = ye.findKey(i, o);
      if (s) {
        r[s] = Js(a), delete r[o];
        return;
      }
      const l = n ? B$(o) : String(o).trim();
      l !== o && delete r[o], r[l] = Js(a), i[l] = !0;
    }), this;
  }
  concat(...n) {
    return this.constructor.concat(this, ...n);
  }
  toJSON(n) {
    const r = /* @__PURE__ */ Object.create(null);
    return ye.forEach(this, (i, a) => {
      i != null && i !== !1 && (r[a] = n && ye.isArray(i) ? i.join(", ") : i);
    }), r;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([n, r]) => n + ": " + r).join(`
`);
  }
  getSetCookie() {
    return this.get("set-cookie") || [];
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(n) {
    return n instanceof this ? n : new this(n);
  }
  static concat(n, ...r) {
    const i = new this(n);
    return r.forEach((a) => i.set(a)), i;
  }
  static accessor(n) {
    const i = (this[hv] = this[hv] = {
      accessors: {}
    }).accessors, a = this.prototype;
    function o(s) {
      const l = qa(s);
      i[l] || (q$(a, s), i[l] = !0);
    }
    return ye.isArray(n) ? n.forEach(o) : o(n), this;
  }
};
Ut.accessor([
  "Content-Type",
  "Content-Length",
  "Accept",
  "Accept-Encoding",
  "User-Agent",
  "Authorization"
]);
ye.reduceDescriptors(Ut.prototype, ({ value: e }, n) => {
  let r = n[0].toUpperCase() + n.slice(1);
  return {
    get: () => e,
    set(i) {
      this[r] = i;
    }
  };
});
ye.freezeMethods(Ut);
const H$ = "[REDACTED ****]";
function W$(e) {
  if (ye.hasOwnProp(e, "toJSON"))
    return !0;
  let n = Object.getPrototypeOf(e);
  for (; n && n !== Object.prototype; ) {
    if (ye.hasOwnProp(n, "toJSON"))
      return !0;
    n = Object.getPrototypeOf(n);
  }
  return !1;
}
function K$(e, n) {
  const r = new Set(n.map((o) => String(o).toLowerCase())), i = [], a = (o) => {
    if (o === null || typeof o != "object" || ye.isBuffer(o)) return o;
    if (i.indexOf(o) !== -1) return;
    o instanceof Ut && (o = o.toJSON()), i.push(o);
    let s;
    if (ye.isArray(o))
      s = [], o.forEach((l, c) => {
        const m = a(l);
        ye.isUndefined(m) || (s[c] = m);
      });
    else {
      if (!ye.isPlainObject(o) && W$(o))
        return i.pop(), o;
      s = /* @__PURE__ */ Object.create(null);
      for (const [l, c] of Object.entries(o)) {
        const m = r.has(l.toLowerCase()) ? H$ : a(c);
        ye.isUndefined(m) || (s[l] = m);
      }
    }
    return i.pop(), s;
  };
  return a(e);
}
let on = class Mw extends Error {
  static from(n, r, i, a, o, s) {
    const l = new Mw(n.message, r || n.code, i, a, o);
    return l.cause = n, l.name = n.name, n.status != null && l.status == null && (l.status = n.status), s && Object.assign(l, s), l;
  }
  /**
   * Create an Error with the specified message, config, error code, request and response.
   *
   * @param {string} message The error message.
   * @param {string} [code] The error code (for example, 'ECONNABORTED').
   * @param {Object} [config] The config.
   * @param {Object} [request] The request.
   * @param {Object} [response] The response.
   *
   * @returns {Error} The created error.
   */
  constructor(n, r, i, a, o) {
    super(n), Object.defineProperty(this, "message", {
      // Null-proto descriptor so a polluted Object.prototype.get cannot turn
      // this data descriptor into an accessor descriptor on the way in.
      __proto__: null,
      value: n,
      enumerable: !0,
      writable: !0,
      configurable: !0
    }), this.name = "AxiosError", this.isAxiosError = !0, r && (this.code = r), i && (this.config = i), a && (this.request = a), o && (this.response = o, this.status = o.status);
  }
  toJSON() {
    const n = this.config, r = n && ye.hasOwnProp(n, "redact") ? n.redact : void 0, i = ye.isArray(r) && r.length > 0 ? K$(n, r) : ye.toJSONObject(n);
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: i,
      code: this.code,
      status: this.status
    };
  }
};
on.ERR_BAD_OPTION_VALUE = "ERR_BAD_OPTION_VALUE";
on.ERR_BAD_OPTION = "ERR_BAD_OPTION";
on.ECONNABORTED = "ECONNABORTED";
on.ETIMEDOUT = "ETIMEDOUT";
on.ECONNREFUSED = "ECONNREFUSED";
on.ERR_NETWORK = "ERR_NETWORK";
on.ERR_FR_TOO_MANY_REDIRECTS = "ERR_FR_TOO_MANY_REDIRECTS";
on.ERR_DEPRECATED = "ERR_DEPRECATED";
on.ERR_BAD_RESPONSE = "ERR_BAD_RESPONSE";
on.ERR_BAD_REQUEST = "ERR_BAD_REQUEST";
on.ERR_CANCELED = "ERR_CANCELED";
on.ERR_NOT_SUPPORT = "ERR_NOT_SUPPORT";
on.ERR_INVALID_URL = "ERR_INVALID_URL";
on.ERR_FORM_DATA_DEPTH_EXCEEDED = "ERR_FORM_DATA_DEPTH_EXCEEDED";
const G$ = null, Bw = 100;
function Gh(e) {
  return ye.isPlainObject(e) || ye.isArray(e);
}
function qw(e) {
  return ye.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function xd(e, n, r) {
  return e ? e.concat(n).map(function(a, o) {
    return a = qw(a), !r && o ? "[" + a + "]" : a;
  }).join(r ? "." : "") : n;
}
function Y$(e) {
  return ye.isArray(e) && !e.some(Gh);
}
const J$ = ye.toFlatObject(ye, {}, null, function(n) {
  return /^is[A-Z]/.test(n);
});
function Yl(e, n, r) {
  if (!ye.isObject(e))
    throw new TypeError("target must be an object");
  n = n || new FormData(), r = ye.toFlatObject(
    r,
    {
      metaTokens: !0,
      dots: !1,
      indexes: !1
    },
    !1,
    function(g, O) {
      return !ye.isUndefined(O[g]);
    }
  );
  const i = r.metaTokens, a = r.visitor || w, o = r.dots, s = r.indexes, l = r.Blob || typeof Blob < "u" && Blob, c = r.maxDepth === void 0 ? Bw : r.maxDepth, m = l && ye.isSpecCompliantForm(n), u = [];
  if (!ye.isFunction(a))
    throw new TypeError("visitor must be a function");
  function f(_) {
    if (_ === null) return "";
    if (ye.isDate(_))
      return _.toISOString();
    if (ye.isBoolean(_))
      return _.toString();
    if (!m && ye.isBlob(_))
      throw new on("Blob is not supported. Use a Buffer instead.");
    return ye.isArrayBuffer(_) || ye.isTypedArray(_) ? m && typeof Blob == "function" ? new Blob([_]) : Buffer.from(_) : _;
  }
  function h(_) {
    if (_ > c)
      throw new on(
        "Object is too deeply nested (" + _ + " levels). Max depth: " + c,
        on.ERR_FORM_DATA_DEPTH_EXCEEDED
      );
  }
  function k(_, g) {
    if (c === 1 / 0)
      return JSON.stringify(_);
    const O = [];
    return JSON.stringify(_, function(F, I) {
      if (!ye.isObject(I))
        return I;
      for (; O.length && O[O.length - 1] !== this; )
        O.pop();
      return O.push(I), h(g + O.length - 1), I;
    });
  }
  function w(_, g, O) {
    let R = _;
    if (ye.isReactNative(n) && ye.isReactNativeBlob(_))
      return n.append(xd(O, g, o), f(_)), !1;
    if (_ && !O && typeof _ == "object") {
      if (ye.endsWith(g, "{}"))
        g = i ? g : g.slice(0, -2), _ = k(_, 1);
      else if (ye.isArray(_) && Y$(_) || (ye.isFileList(_) || ye.endsWith(g, "[]")) && (R = ye.toArray(_)))
        return g = qw(g), R.forEach(function(I, L) {
          !(ye.isUndefined(I) || I === null) && n.append(
            // eslint-disable-next-line no-nested-ternary
            s === !0 ? xd([g], L, o) : s === null ? g : g + "[]",
            f(I)
          );
        }), !1;
    }
    return Gh(_) ? !0 : (n.append(xd(O, g, o), f(_)), !1);
  }
  const N = Object.assign(J$, {
    defaultVisitor: w,
    convertValue: f,
    isVisitable: Gh
  });
  function j(_, g, O = 0) {
    if (!ye.isUndefined(_)) {
      if (h(O), u.indexOf(_) !== -1)
        throw new Error("Circular reference detected in " + g.join("."));
      u.push(_), ye.forEach(_, function(F, I) {
        (!(ye.isUndefined(F) || F === null) && a.call(n, F, ye.isString(I) ? I.trim() : I, g, N)) === !0 && j(F, g ? g.concat(I) : [I], O + 1);
      }), u.pop();
    }
  }
  if (!ye.isObject(e))
    throw new TypeError("data must be an object");
  return j(e), n;
}
function yv(e) {
  const n = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20/g, function(i) {
    return n[i];
  });
}
function Oy(e, n) {
  this._pairs = [], e && Yl(e, this, n);
}
const Hw = Oy.prototype;
Hw.append = function(n, r) {
  this._pairs.push([n, r]);
};
Hw.toString = function(n) {
  const r = n ? function(i) {
    return n.call(this, i, yv);
  } : yv;
  return this._pairs.map(function(a) {
    return r(a[0]) + "=" + r(a[1]);
  }, "").join("&");
};
function Q$(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
}
function Ww(e, n, r) {
  if (!n)
    return e;
  const i = ye.isFunction(r) ? {
    serialize: r
  } : r, a = ye.getSafeProp(i, "encode") || Q$, o = ye.getSafeProp(i, "serialize");
  let s;
  if (o ? s = o(n, i) : s = ye.isURLSearchParams(n) ? n.toString() : new Oy(n, i).toString(a), s) {
    const l = e.indexOf("#");
    l !== -1 && (e = e.slice(0, l)), e += (e.indexOf("?") === -1 ? "?" : "&") + s;
  }
  return e;
}
class gv {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   * @param {Object} options The options for the interceptor, synchronous and runWhen
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(n, r, i) {
    return this.handlers.push({
      fulfilled: n,
      rejected: r,
      synchronous: i ? i.synchronous : !1,
      runWhen: i ? i.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */
  eject(n) {
    this.handlers[n] && (this.handlers[n] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(n) {
    ye.forEach(this.handlers, function(i) {
      i !== null && n(i);
    });
  }
}
const Py = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1,
  legacyInterceptorReqResOrdering: !0,
  advertiseZstdAcceptEncoding: !1,
  validateStatusUndefinedResolves: !0
}, X$ = typeof URLSearchParams < "u" ? URLSearchParams : Oy, Z$ = typeof FormData < "u" ? FormData : null, eE = typeof Blob < "u" ? Blob : null, nE = {
  isBrowser: !0,
  classes: {
    URLSearchParams: X$,
    FormData: Z$,
    Blob: eE
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, Ay = typeof window < "u" && typeof document < "u", Yh = typeof navigator == "object" && navigator || void 0, tE = Ay && (!Yh || ["ReactNative", "NativeScript", "NS"].indexOf(Yh.product) < 0), rE = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", iE = Ay && window.location.href || "http://localhost", aE = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: Ay,
  hasStandardBrowserEnv: tE,
  hasStandardBrowserWebWorkerEnv: rE,
  navigator: Yh,
  origin: iE
}, Symbol.toStringTag, { value: "Module" })), At = {
  ...aE,
  ...nE
};
function oE(e, n) {
  return Yl(e, new At.classes.URLSearchParams(), {
    visitor: function(r, i, a, o) {
      return At.isNode && ye.isBuffer(r) ? (this.append(i, r.toString("base64")), !1) : o.defaultVisitor.apply(this, arguments);
    },
    ...n
  });
}
const vv = Bw;
function Kw(e) {
  if (e > vv)
    throw new on(
      "FormData field is too deeply nested (" + e + " levels). Max depth: " + vv,
      on.ERR_FORM_DATA_DEPTH_EXCEEDED
    );
}
function sE(e) {
  const n = [], r = /\w+|\[(\w*)]/g;
  let i;
  for (; (i = r.exec(e)) !== null; )
    Kw(n.length), n.push(i[0] === "[]" ? "" : i[1] || i[0]);
  return n;
}
function lE(e) {
  const n = {}, r = Object.keys(e);
  let i;
  const a = r.length;
  let o;
  for (i = 0; i < a; i++)
    o = r[i], n[o] = e[o];
  return n;
}
function Gw(e) {
  function n(r, i, a, o) {
    Kw(o);
    let s = r[o++];
    if (s === "__proto__") return !0;
    const l = Number.isFinite(+s), c = o >= r.length;
    return s = !s && ye.isArray(a) ? a.length : s, c ? (ye.hasOwnProp(a, s) ? a[s] = ye.isArray(a[s]) ? a[s].concat(i) : [a[s], i] : a[s] = i, !l) : ((!ye.hasOwnProp(a, s) || !ye.isObject(a[s])) && (a[s] = []), n(r, i, a[s], o) && ye.isArray(a[s]) && (a[s] = lE(a[s])), !l);
  }
  if (ye.isFormData(e) && ye.isFunction(e.entries)) {
    const r = {};
    return ye.forEachEntry(e, (i, a) => {
      n(sE(i), a, r, 0);
    }), r;
  }
  return null;
}
const Zi = (e, n) => e != null && ye.hasOwnProp(e, n) ? e[n] : void 0;
function dE(e, n, r) {
  if (ye.isString(e))
    try {
      return (n || JSON.parse)(e), ye.trim(e);
    } catch (i) {
      if (i.name !== "SyntaxError")
        throw i;
    }
  return (r || JSON.stringify)(e);
}
const Qo = {
  transitional: Py,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [
    function(n, r) {
      const i = r.getContentType() || "", a = i.indexOf("application/json") > -1, o = ye.isObject(n);
      if (o && ye.isHTMLForm(n) && (n = new FormData(n)), ye.isFormData(n))
        return a ? JSON.stringify(Gw(n)) : n;
      if (ye.isArrayBuffer(n) || ye.isBuffer(n) || ye.isStream(n) || ye.isFile(n) || ye.isBlob(n) || ye.isReadableStream(n))
        return n;
      if (ye.isArrayBufferView(n))
        return n.buffer;
      if (ye.isURLSearchParams(n))
        return r.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), n.toString();
      let l;
      if (o) {
        const c = Zi(this, "formSerializer");
        if (i.indexOf("application/x-www-form-urlencoded") > -1)
          return oE(n, c).toString();
        if ((l = ye.isFileList(n)) || i.indexOf("multipart/form-data") > -1) {
          const m = Zi(this, "env"), u = m && m.FormData;
          return Yl(
            l ? { "files[]": n } : n,
            u && new u(),
            c
          );
        }
      }
      return o || a ? (r.setContentType("application/json", !1), dE(n)) : n;
    }
  ],
  transformResponse: [
    function(n) {
      const r = Zi(this, "transitional") || Qo.transitional, i = r && r.forcedJSONParsing, a = Zi(this, "responseType"), o = a === "json";
      if (ye.isResponse(n) || ye.isReadableStream(n))
        return n;
      if (n && ye.isString(n) && (i && !a || o)) {
        const l = !(r && r.silentJSONParsing) && o;
        try {
          return JSON.parse(n, Zi(this, "parseReviver"));
        } catch (c) {
          if (l)
            throw c.name === "SyntaxError" ? on.from(c, on.ERR_BAD_RESPONSE, this, null, Zi(this, "response")) : c;
        }
      }
      return n;
    }
  ],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: At.classes.FormData,
    Blob: At.classes.Blob
  },
  validateStatus: function(n) {
    return n >= 200 && n < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
ye.forEach(["delete", "get", "head", "post", "put", "patch", "query"], (e) => {
  Qo.headers[e] = {};
});
function Sd(e, n) {
  const r = this || Qo, i = n || r, a = Ut.from(i.headers);
  let o = i.data;
  return ye.forEach(e, function(l) {
    o = l.call(r, o, a.normalize(), n ? n.status : void 0);
  }), a.normalize(), o;
}
function Yw(e) {
  return !!(e && e.__CANCEL__);
}
let Xo = class extends on {
  /**
   * A `CanceledError` is an object that is thrown when an operation is canceled.
   *
   * @param {string=} message The message.
   * @param {Object=} config The config.
   * @param {Object=} request The request.
   *
   * @returns {CanceledError} The created error.
   */
  constructor(n, r, i) {
    super(n ?? "canceled", on.ERR_CANCELED, r, i), this.name = "CanceledError", this.__CANCEL__ = !0;
  }
};
function Jw(e, n, r) {
  const i = r.config.validateStatus;
  !r.status || !i || i(r.status) ? e(r) : n(new on(
    "Request failed with status code " + r.status,
    r.status >= 400 && r.status < 500 ? on.ERR_BAD_REQUEST : on.ERR_BAD_RESPONSE,
    r.config,
    r.request,
    r
  ));
}
function cE(e) {
  const n = /^([-+\w]{1,25}):(?:\/\/)?/.exec(e);
  return n && n[1] || "";
}
function uE(e, n) {
  e = e || 10;
  const r = new Array(e), i = new Array(e);
  let a = 0, o = 0, s;
  return n = n !== void 0 ? n : 1e3, function(c) {
    const m = Date.now(), u = i[o];
    s || (s = m), r[a] = c, i[a] = m;
    let f = o, h = 0;
    for (; f !== a; )
      h += r[f++], f = f % e;
    if (a = (a + 1) % e, a === o && (o = (o + 1) % e), m - s < n)
      return;
    const k = u && m - u;
    return k ? Math.round(h * 1e3 / k) : void 0;
  };
}
function mE(e, n) {
  let r = 0, i = 1e3 / n, a, o;
  const s = (m, u = Date.now()) => {
    r = u, a = null, o && (clearTimeout(o), o = null), e(...m);
  };
  return [(...m) => {
    const u = Date.now(), f = u - r;
    f >= i ? s(m, u) : (a = m, o || (o = setTimeout(() => {
      o = null, s(a);
    }, i - f)));
  }, () => a && s(a)];
}
const ml = (e, n, r = 3) => {
  let i = 0;
  const a = uE(50, 250);
  return mE((o) => {
    if (!o || typeof o.loaded != "number")
      return;
    const s = o.loaded, l = o.lengthComputable ? o.total : void 0, c = l != null ? Math.min(s, l) : s, m = Math.max(0, c - i), u = a(m);
    i = Math.max(i, c);
    const f = {
      loaded: c,
      total: l,
      progress: l ? c / l : void 0,
      bytes: m,
      rate: u || void 0,
      estimated: u && l ? (l - c) / u : void 0,
      event: o,
      lengthComputable: l != null,
      [n ? "download" : "upload"]: !0
    };
    e(f);
  }, r);
}, kv = (e, n) => {
  const r = e != null;
  return [
    (i) => n[0]({
      lengthComputable: r,
      total: e,
      loaded: i
    }),
    n[1]
  ];
}, bv = (e) => (...n) => ye.asap(() => e(...n)), pE = At.hasStandardBrowserEnv ? /* @__PURE__ */ ((e, n) => (r) => (r = new URL(r, At.origin), e.protocol === r.protocol && e.host === r.host && (n || e.port === r.port)))(
  new URL(At.origin),
  At.navigator && /(msie|trident)/i.test(At.navigator.userAgent)
) : () => !0, fE = At.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, n, r, i, a, o, s) {
      if (typeof document > "u") return;
      const l = [`${e}=${encodeURIComponent(n)}`];
      ye.isNumber(r) && l.push(`expires=${new Date(r).toUTCString()}`), ye.isString(i) && l.push(`path=${i}`), ye.isString(a) && l.push(`domain=${a}`), o === !0 && l.push("secure"), ye.isString(s) && l.push(`SameSite=${s}`), document.cookie = l.join("; ");
    },
    read(e) {
      if (typeof document > "u") return null;
      const n = document.cookie.split(";");
      for (let r = 0; r < n.length; r++) {
        const i = n[r].replace(/^\s+/, ""), a = i.indexOf("=");
        if (a !== -1 && i.slice(0, a) === e)
          return decodeURIComponent(i.slice(a + 1));
      }
      return null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5, "/");
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function hE(e) {
  return typeof e != "string" ? !1 : /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function yE(e, n) {
  return n ? e.replace(/\/?\/$/, "") + "/" + n.replace(/^\/+/, "") : e;
}
const gE = /^https?:(?!\/\/)/i, vE = /[\t\n\r]/g;
function kE(e) {
  let n = 0;
  for (; n < e.length && e.charCodeAt(n) <= 32; )
    n++;
  return e.slice(n);
}
function bE(e) {
  return kE(e).replace(vE, "");
}
function _v(e, n) {
  if (typeof e == "string" && gE.test(bE(e)))
    throw new on(
      'Invalid URL: missing "//" after protocol',
      on.ERR_INVALID_URL,
      n
    );
}
function Qw(e, n, r, i) {
  _v(n, i);
  let a = !hE(n);
  return e && (a || r === !1) ? (_v(e, i), yE(e, n)) : n;
}
const xv = (e) => e instanceof Ut ? { ...e } : e;
function Hi(e, n) {
  n = n || {};
  const r = /* @__PURE__ */ Object.create(null);
  Object.defineProperty(r, "hasOwnProperty", {
    // Null-proto descriptor so a polluted Object.prototype.get cannot turn
    // this data descriptor into an accessor descriptor on the way in.
    __proto__: null,
    value: Object.prototype.hasOwnProperty,
    enumerable: !1,
    writable: !0,
    configurable: !0
  });
  function i(u, f, h, k) {
    return ye.isPlainObject(u) && ye.isPlainObject(f) ? ye.merge.call({ caseless: k }, u, f) : ye.isPlainObject(f) ? ye.merge({}, f) : ye.isArray(f) ? f.slice() : f;
  }
  function a(u, f, h, k) {
    if (ye.isUndefined(f)) {
      if (!ye.isUndefined(u))
        return i(void 0, u, h, k);
    } else return i(u, f, h, k);
  }
  function o(u, f) {
    if (!ye.isUndefined(f))
      return i(void 0, f);
  }
  function s(u, f) {
    if (ye.isUndefined(f)) {
      if (!ye.isUndefined(u))
        return i(void 0, u);
    } else return i(void 0, f);
  }
  function l(u) {
    const f = ye.hasOwnProp(n, "transitional") ? n.transitional : void 0;
    if (!ye.isUndefined(f))
      if (ye.isPlainObject(f)) {
        if (ye.hasOwnProp(f, u))
          return f[u];
      } else
        return;
    const h = ye.hasOwnProp(e, "transitional") ? e.transitional : void 0;
    if (ye.isPlainObject(h) && ye.hasOwnProp(h, u))
      return h[u];
  }
  function c(u, f, h) {
    if (ye.hasOwnProp(n, h))
      return i(u, f);
    if (ye.hasOwnProp(e, h))
      return i(void 0, u);
  }
  const m = {
    url: o,
    method: o,
    data: o,
    baseURL: s,
    transformRequest: s,
    transformResponse: s,
    paramsSerializer: s,
    timeout: s,
    timeoutMessage: s,
    withCredentials: s,
    withXSRFToken: s,
    adapter: s,
    responseType: s,
    xsrfCookieName: s,
    xsrfHeaderName: s,
    onUploadProgress: s,
    onDownloadProgress: s,
    decompress: s,
    maxContentLength: s,
    maxBodyLength: s,
    beforeRedirect: s,
    transport: s,
    httpAgent: s,
    httpsAgent: s,
    cancelToken: s,
    socketPath: s,
    allowedSocketPaths: s,
    responseEncoding: s,
    validateStatus: c,
    headers: (u, f, h) => a(xv(u), xv(f), h, !0)
  };
  return ye.forEach(Object.keys({ ...e, ...n }), function(f) {
    if (f === "__proto__" || f === "constructor" || f === "prototype") return;
    const h = ye.hasOwnProp(m, f) ? m[f] : a, k = ye.hasOwnProp(e, f) ? e[f] : void 0, w = ye.hasOwnProp(n, f) ? n[f] : void 0, N = h(k, w, f);
    ye.isUndefined(N) && h !== c || (r[f] = N);
  }), ye.hasOwnProp(n, "validateStatus") && ye.isUndefined(n.validateStatus) && l("validateStatusUndefinedResolves") === !1 && (ye.hasOwnProp(e, "validateStatus") ? r.validateStatus = i(void 0, e.validateStatus) : delete r.validateStatus), r;
}
const _E = ["content-type", "content-length"];
function xE(e, n, r) {
  if (r !== "content-only") {
    e.set(n);
    return;
  }
  Object.entries(n).forEach(([i, a]) => {
    _E.includes(i.toLowerCase()) && e.set(i, a);
  });
}
const SE = (e) => encodeURIComponent(e).replace(
  /%([0-9A-F]{2})/gi,
  (n, r) => String.fromCharCode(parseInt(r, 16))
);
function Xw(e) {
  const n = Hi({}, e), r = (h) => ye.hasOwnProp(n, h) ? n[h] : void 0, i = r("data");
  let a = r("withXSRFToken");
  const o = r("xsrfHeaderName"), s = r("xsrfCookieName");
  let l = r("headers");
  const c = r("auth"), m = r("baseURL"), u = r("allowAbsoluteUrls"), f = r("url");
  if (n.headers = l = Ut.from(l), n.url = Ww(
    Qw(m, f, u, n),
    r("params"),
    r("paramsSerializer")
  ), c) {
    const h = ye.getSafeProp(c, "username") || "", k = ye.getSafeProp(c, "password") || "";
    l.set(
      "Authorization",
      "Basic " + btoa(h + ":" + (k ? SE(k) : ""))
    );
  }
  if (ye.isFormData(i) && (At.hasStandardBrowserEnv || At.hasStandardBrowserWebWorkerEnv || ye.isReactNative(i) ? l.setContentType(void 0) : ye.isFunction(i.getHeaders) && xE(l, i.getHeaders(), r("formDataHeaderPolicy"))), At.hasStandardBrowserEnv && (ye.isFunction(a) && (a = a(n)), a === !0 || a == null && pE(n.url))) {
    const k = o && s && fE.read(s);
    k && l.set(o, k);
  }
  return n;
}
const NE = typeof XMLHttpRequest < "u", jE = NE && function(e) {
  return new Promise(function(r, i) {
    const a = Xw(e);
    let o = a.data;
    const s = Ut.from(a.headers).normalize();
    let { responseType: l, onUploadProgress: c, onDownloadProgress: m } = a, u, f, h, k, w;
    function N() {
      k && k(), w && w(), a.cancelToken && a.cancelToken.unsubscribe(u), a.signal && a.signal.removeEventListener("abort", u);
    }
    let j = new XMLHttpRequest();
    j.open(a.method.toUpperCase(), a.url, !0), j.timeout = a.timeout;
    function _() {
      if (!j)
        return;
      const O = Ut.from(
        "getAllResponseHeaders" in j && j.getAllResponseHeaders()
      ), F = {
        data: !l || l === "text" || l === "json" ? j.responseText : j.response,
        status: j.status,
        statusText: j.statusText,
        headers: O,
        config: e,
        request: j
      };
      Jw(
        function(L) {
          r(L), N();
        },
        function(L) {
          i(L), N();
        },
        F
      ), j = null;
    }
    "onloadend" in j ? j.onloadend = _ : j.onreadystatechange = function() {
      !j || j.readyState !== 4 || j.status === 0 && !(j.responseURL && j.responseURL.startsWith("file:")) || setTimeout(_);
    }, j.onabort = function() {
      j && (i(new on("Request aborted", on.ECONNABORTED, e, j)), N(), j = null);
    }, j.onerror = function(R) {
      const F = R && R.message ? R.message : "Network Error", I = new on(F, on.ERR_NETWORK, e, j);
      I.event = R || null, i(I), N(), j = null;
    }, j.ontimeout = function() {
      let R = a.timeout ? "timeout of " + a.timeout + "ms exceeded" : "timeout exceeded";
      const F = a.transitional || Py;
      a.timeoutErrorMessage && (R = a.timeoutErrorMessage), i(
        new on(
          R,
          F.clarifyTimeoutError ? on.ETIMEDOUT : on.ECONNABORTED,
          e,
          j
        )
      ), N(), j = null;
    }, o === void 0 && s.setContentType(null), "setRequestHeader" in j && ye.forEach(Uw(s), function(R, F) {
      j.setRequestHeader(F, R);
    }), ye.isUndefined(a.withCredentials) || (j.withCredentials = !!a.withCredentials), l && l !== "json" && (j.responseType = a.responseType), m && ([h, w] = ml(m, !0), j.addEventListener("progress", h)), c && j.upload && ([f, k] = ml(c), j.upload.addEventListener("progress", f), j.upload.addEventListener("loadend", k)), (a.cancelToken || a.signal) && (u = (O) => {
      j && (i(!O || O.type ? new Xo(null, e, j) : O), j.abort(), N(), j = null);
    }, a.cancelToken && a.cancelToken.subscribe(u), a.signal && (a.signal.aborted ? u() : a.signal.addEventListener("abort", u)));
    const g = cE(a.url);
    if (g && !At.protocols.includes(g)) {
      i(
        new on(
          "Unsupported protocol " + g + ":",
          on.ERR_BAD_REQUEST,
          e
        )
      );
      return;
    }
    j.send(o || null);
  });
}, wE = (e, n) => {
  if (e = e ? e.filter(Boolean) : [], !n && !e.length)
    return;
  const r = new AbortController();
  let i = !1;
  const a = function(c) {
    if (!i) {
      i = !0, s();
      const m = c instanceof Error ? c : this.reason;
      r.abort(
        m instanceof on ? m : new Xo(m instanceof Error ? m.message : m)
      );
    }
  };
  let o = n && setTimeout(() => {
    o = null, a(new on(`timeout of ${n}ms exceeded`, on.ETIMEDOUT));
  }, n);
  const s = () => {
    e && (o && clearTimeout(o), o = null, e.forEach((c) => {
      c.unsubscribe ? c.unsubscribe(a) : c.removeEventListener("abort", a);
    }), e = null);
  };
  e.forEach((c) => c.addEventListener("abort", a));
  const { signal: l } = r;
  return l.unsubscribe = () => ye.asap(s), l;
}, CE = function* (e, n) {
  let r = e.byteLength;
  if (r < n) {
    yield e;
    return;
  }
  let i = 0, a;
  for (; i < r; )
    a = i + n, yield e.slice(i, a), i = a;
}, FE = async function* (e, n) {
  for await (const r of IE(e))
    yield* CE(r, n);
}, IE = async function* (e) {
  if (e[Symbol.asyncIterator]) {
    yield* e;
    return;
  }
  const n = e.getReader();
  try {
    for (; ; ) {
      const { done: r, value: i } = await n.read();
      if (r)
        break;
      yield i;
    }
  } finally {
    await n.cancel();
  }
}, Sv = (e, n, r, i) => {
  const a = FE(e, n);
  let o = 0, s, l = (c) => {
    s || (s = !0, i && i(c));
  };
  return new ReadableStream(
    {
      async pull(c) {
        try {
          const { done: m, value: u } = await a.next();
          if (m) {
            l(), c.close();
            return;
          }
          let f = u.byteLength;
          if (r) {
            let h = o += f;
            r(h);
          }
          c.enqueue(new Uint8Array(u));
        } catch (m) {
          throw l(m), m;
        }
      },
      cancel(c) {
        return l(c), a.return();
      }
    },
    {
      highWaterMark: 2
    }
  );
}, pl = (e) => e >= 48 && e <= 57 || e >= 65 && e <= 70 || e >= 97 && e <= 102, $E = (e, n, r) => n + 2 < r && pl(e.charCodeAt(n + 1)) && pl(e.charCodeAt(n + 2));
function EE(e) {
  if (!e || typeof e != "string" || !e.startsWith("data:")) return 0;
  const n = e.indexOf(",");
  if (n < 0) return 0;
  const r = e.slice(5, n), i = e.slice(n + 1);
  if (/;base64/i.test(r)) {
    let s = i.length;
    const l = i.length;
    for (let k = 0; k < l; k++)
      if (i.charCodeAt(k) === 37 && k + 2 < l) {
        const w = i.charCodeAt(k + 1), N = i.charCodeAt(k + 2);
        pl(w) && pl(N) && (s -= 2, k += 2);
      }
    let c = 0, m = l - 1;
    const u = (k) => k >= 2 && i.charCodeAt(k - 2) === 37 && // '%'
    i.charCodeAt(k - 1) === 51 && // '3'
    (i.charCodeAt(k) === 68 || i.charCodeAt(k) === 100);
    m >= 0 && (i.charCodeAt(m) === 61 ? (c++, m--) : u(m) && (c++, m -= 3)), c === 1 && m >= 0 && (i.charCodeAt(m) === 61 || u(m)) && c++;
    const h = Math.floor(s / 4) * 3 - (c || 0);
    return h > 0 ? h : 0;
  }
  let o = 0;
  for (let s = 0, l = i.length; s < l; s++) {
    const c = i.charCodeAt(s);
    if (c === 37 && $E(i, s, l))
      o += 1, s += 2;
    else if (c < 128)
      o += 1;
    else if (c < 2048)
      o += 2;
    else if (c >= 55296 && c <= 56319 && s + 1 < l) {
      const m = i.charCodeAt(s + 1);
      m >= 56320 && m <= 57343 ? (o += 4, s++) : o += 3;
    } else
      o += 3;
  }
  return o;
}
const Ly = "1.18.0", Nv = 64 * 1024, { isFunction: ms } = ye, TE = (e) => encodeURIComponent(e).replace(
  /%([0-9A-F]{2})/gi,
  (n, r) => String.fromCharCode(parseInt(r, 16))
), jv = (e) => {
  if (!ye.isString(e))
    return e;
  try {
    return decodeURIComponent(e);
  } catch {
    return e;
  }
}, wv = (e, ...n) => {
  try {
    return !!e(...n);
  } catch {
    return !1;
  }
}, RE = (e) => {
  const n = e.indexOf("://");
  let r = e;
  return n !== -1 && (r = r.slice(n + 3)), r.includes("@") || r.includes(":");
}, DE = (e) => {
  const n = ye.global !== void 0 && ye.global !== null ? ye.global : globalThis, { ReadableStream: r, TextEncoder: i } = n;
  e = ye.merge.call(
    {
      skipUndefined: !0
    },
    {
      Request: n.Request,
      Response: n.Response
    },
    e
  );
  const { fetch: a, Request: o, Response: s } = e, l = a ? ms(a) : typeof fetch == "function", c = ms(o), m = ms(s);
  if (!l)
    return !1;
  const u = l && ms(r), f = l && (typeof i == "function" ? /* @__PURE__ */ ((_) => (g) => _.encode(g))(new i()) : async (_) => new Uint8Array(await new o(_).arrayBuffer())), h = c && u && wv(() => {
    let _ = !1;
    const g = new o(At.origin, {
      body: new r(),
      method: "POST",
      get duplex() {
        return _ = !0, "half";
      }
    }), O = g.headers.has("Content-Type");
    return g.body != null && g.body.cancel(), _ && !O;
  }), k = m && u && wv(() => ye.isReadableStream(new s("").body)), w = {
    stream: k && ((_) => _.body)
  };
  l && ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((_) => {
    !w[_] && (w[_] = (g, O) => {
      let R = g && g[_];
      if (R)
        return R.call(g);
      throw new on(
        `Response type '${_}' is not supported`,
        on.ERR_NOT_SUPPORT,
        O
      );
    });
  });
  const N = async (_) => {
    if (_ == null)
      return 0;
    if (ye.isBlob(_))
      return _.size;
    if (ye.isSpecCompliantForm(_))
      return (await new o(At.origin, {
        method: "POST",
        body: _
      }).arrayBuffer()).byteLength;
    if (ye.isArrayBufferView(_) || ye.isArrayBuffer(_))
      return _.byteLength;
    if (ye.isURLSearchParams(_) && (_ = _ + ""), ye.isString(_))
      return (await f(_)).byteLength;
  }, j = async (_, g) => {
    const O = ye.toFiniteNumber(_.getContentLength());
    return O ?? N(g);
  };
  return async (_) => {
    let {
      url: g,
      method: O,
      data: R,
      signal: F,
      cancelToken: I,
      timeout: L,
      onDownloadProgress: W,
      onUploadProgress: J,
      responseType: re,
      headers: K,
      withCredentials: Y = "same-origin",
      fetchOptions: P,
      maxContentLength: B,
      maxBodyLength: ie
    } = Xw(_);
    const we = ye.isNumber(B) && B > -1, me = ye.isNumber(ie) && ie > -1, le = (Ie) => ye.hasOwnProp(_, Ie) ? _[Ie] : void 0;
    let ge = a || fetch;
    re = re ? (re + "").toLowerCase() : "text";
    let V = wE(
      [F, I && I.toAbortSignal()],
      L
    ), be = null;
    const Oe = V && V.unsubscribe && (() => {
      V.unsubscribe();
    });
    let q, Ge = null;
    const sn = () => new on(
      "Request body larger than maxBodyLength limit",
      on.ERR_BAD_REQUEST,
      _,
      be
    );
    try {
      let Ie;
      const Ue = le("auth");
      if (Ue) {
        const de = ye.getSafeProp(Ue, "username") || "", Se = ye.getSafeProp(Ue, "password") || "";
        Ie = {
          username: de,
          password: Se
        };
      }
      if (RE(g)) {
        const de = new URL(g, At.origin);
        if (!Ie && (de.username || de.password)) {
          const Se = jv(de.username), Ve = jv(de.password);
          Ie = {
            username: Se,
            password: Ve
          };
        }
        (de.username || de.password) && (de.username = "", de.password = "", g = de.href);
      }
      if (Ie && (K.delete("authorization"), K.set(
        "Authorization",
        "Basic " + btoa(TE((Ie.username || "") + ":" + (Ie.password || "")))
      )), we && typeof g == "string" && g.startsWith("data:") && EE(g) > B)
        throw new on(
          "maxContentLength size of " + B + " exceeded",
          on.ERR_BAD_RESPONSE,
          _,
          be
        );
      if (me && O !== "get" && O !== "head") {
        const de = await N(R);
        if (typeof de == "number" && isFinite(de) && (q = de, de > ie))
          throw sn();
      }
      const De = me && (ye.isReadableStream(R) || ye.isStream(R)), Be = (de, Se, Ve) => Sv(
        de,
        Nv,
        (Pe) => {
          if (me && Pe > ie)
            throw Ge = sn();
          Se && Se(Pe);
        },
        Ve
      );
      if (h && O !== "get" && O !== "head" && (J || De)) {
        if (q = q ?? await j(K, R), q !== 0 || De) {
          let de = new o(g, {
            method: "POST",
            body: R,
            duplex: "half"
          }), Se;
          if (ye.isFormData(R) && (Se = de.headers.get("content-type")) && K.setContentType(Se), de.body) {
            const [Ve, Pe] = J && kv(
              q,
              ml(bv(J))
            ) || [];
            R = Be(de.body, Ve, Pe);
          }
        }
      } else if (De && !c && u && O !== "get" && O !== "head")
        R = Be(R);
      else if (De && c && !h && O !== "get" && O !== "head")
        throw new on(
          "Stream request bodies are not supported by the current fetch implementation",
          on.ERR_NOT_SUPPORT,
          _,
          be
        );
      ye.isString(Y) || (Y = Y ? "include" : "omit");
      const Ae = c && "credentials" in o.prototype;
      if (ye.isFormData(R)) {
        const de = K.getContentType();
        de && /^multipart\/form-data/i.test(de) && !/boundary=/i.test(de) && K.delete("content-type");
      }
      K.set("User-Agent", "axios/" + Ly, !1);
      const Je = {
        ...P,
        signal: V,
        method: O.toUpperCase(),
        headers: Uw(K.normalize()),
        body: R,
        duplex: "half",
        credentials: Ae ? Y : void 0
      };
      be = c && new o(g, Je);
      let Ee = await (c ? ge(be, P) : ge(g, Je));
      const Me = Ut.from(Ee.headers);
      if (we) {
        const de = ye.toFiniteNumber(Me.getContentLength());
        if (de != null && de > B)
          throw new on(
            "maxContentLength size of " + B + " exceeded",
            on.ERR_BAD_RESPONSE,
            _,
            be
          );
      }
      const en = k && (re === "stream" || re === "response");
      if (k && Ee.body && (W || we || en && Oe)) {
        const de = {};
        ["status", "statusText", "headers"].forEach((E) => {
          de[E] = Ee[E];
        });
        const Se = ye.toFiniteNumber(Me.getContentLength()), [Ve, Pe] = W && kv(
          Se,
          ml(bv(W), !0)
        ) || [];
        let kn = 0;
        const Q = (E) => {
          if (we && (kn = E, kn > B))
            throw new on(
              "maxContentLength size of " + B + " exceeded",
              on.ERR_BAD_RESPONSE,
              _,
              be
            );
          Ve && Ve(E);
        };
        Ee = new s(
          Sv(Ee.body, Nv, Q, () => {
            Pe && Pe(), Oe && Oe();
          }),
          de
        );
      }
      re = re || "text";
      let se = await w[ye.findKey(w, re) || "text"](
        Ee,
        _
      );
      if (we && !k && !en) {
        let de;
        if (se != null && (typeof se.byteLength == "number" ? de = se.byteLength : typeof se.size == "number" ? de = se.size : typeof se == "string" && (de = typeof i == "function" ? new i().encode(se).byteLength : se.length)), typeof de == "number" && de > B)
          throw new on(
            "maxContentLength size of " + B + " exceeded",
            on.ERR_BAD_RESPONSE,
            _,
            be
          );
      }
      return !en && Oe && Oe(), await new Promise((de, Se) => {
        Jw(de, Se, {
          data: se,
          headers: Ut.from(Ee.headers),
          status: Ee.status,
          statusText: Ee.statusText,
          config: _,
          request: be
        });
      });
    } catch (Ie) {
      if (Oe && Oe(), V && V.aborted && V.reason instanceof on) {
        const Ue = V.reason;
        throw Ue.config = _, be && (Ue.request = be), Ie !== Ue && (Ue.cause = Ie), Ue;
      }
      throw Ge ? (be && !Ge.request && (Ge.request = be), Ge) : Ie instanceof on ? (be && !Ie.request && (Ie.request = be), Ie) : Ie && Ie.name === "TypeError" && /Load failed|fetch/i.test(Ie.message) ? Object.assign(
        new on(
          "Network Error",
          on.ERR_NETWORK,
          _,
          be,
          Ie && Ie.response
        ),
        {
          cause: Ie.cause || Ie
        }
      ) : on.from(Ie, Ie && Ie.code, _, be, Ie && Ie.response);
    }
  };
}, OE = /* @__PURE__ */ new Map(), Zw = (e) => {
  let n = e && e.env || {};
  const { fetch: r, Request: i, Response: a } = n, o = [i, a, r];
  let s = o.length, l = s, c, m, u = OE;
  for (; l--; )
    c = o[l], m = u.get(c), m === void 0 && u.set(c, m = l ? /* @__PURE__ */ new Map() : DE(n)), u = m;
  return m;
};
Zw();
const Vy = {
  http: G$,
  xhr: jE,
  fetch: {
    get: Zw
  }
};
ye.forEach(Vy, (e, n) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { __proto__: null, value: n });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { __proto__: null, value: n });
  }
});
const Cv = (e) => `- ${e}`, PE = (e) => ye.isFunction(e) || e === null || e === !1;
function AE(e, n) {
  e = ye.isArray(e) ? e : [e];
  const { length: r } = e;
  let i, a;
  const o = {};
  for (let s = 0; s < r; s++) {
    i = e[s];
    let l;
    if (a = i, !PE(i) && (a = Vy[(l = String(i)).toLowerCase()], a === void 0))
      throw new on(`Unknown adapter '${l}'`);
    if (a && (ye.isFunction(a) || (a = a.get(n))))
      break;
    o[l || "#" + s] = a;
  }
  if (!a) {
    const s = Object.entries(o).map(
      ([c, m]) => `adapter ${c} ` + (m === !1 ? "is not supported by the environment" : "is not available in the build")
    );
    let l = r ? s.length > 1 ? `since :
` + s.map(Cv).join(`
`) : " " + Cv(s[0]) : "as no adapter specified";
    throw new on(
      "There is no suitable adapter to dispatch the request " + l,
      "ERR_NOT_SUPPORT"
    );
  }
  return a;
}
const eC = {
  /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */
  getAdapter: AE,
  /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */
  adapters: Vy
};
function Nd(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new Xo(null, e);
}
function Fv(e) {
  return Nd(e), e.headers = Ut.from(e.headers), e.data = Sd.call(e, e.transformRequest), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), eC.getAdapter(e.adapter || Qo.adapter, e)(e).then(
    function(i) {
      Nd(e), e.response = i;
      try {
        i.data = Sd.call(e, e.transformResponse, i);
      } finally {
        delete e.response;
      }
      return i.headers = Ut.from(i.headers), i;
    },
    function(i) {
      if (!Yw(i) && (Nd(e), i && i.response)) {
        e.response = i.response;
        try {
          i.response.data = Sd.call(
            e,
            e.transformResponse,
            i.response
          );
        } finally {
          delete e.response;
        }
        i.response.headers = Ut.from(i.response.headers);
      }
      return Promise.reject(i);
    }
  );
}
const Jl = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, n) => {
  Jl[e] = function(i) {
    return typeof i === e || "a" + (n < 1 ? "n " : " ") + e;
  };
});
const Iv = {};
Jl.transitional = function(n, r, i) {
  function a(o, s) {
    return "[Axios v" + Ly + "] Transitional option '" + o + "'" + s + (i ? ". " + i : "");
  }
  return (o, s, l) => {
    if (n === !1)
      throw new on(
        a(s, " has been removed" + (r ? " in " + r : "")),
        on.ERR_DEPRECATED
      );
    return r && !Iv[s] && (Iv[s] = !0, console.warn(
      a(
        s,
        " has been deprecated since v" + r + " and will be removed in the near future"
      )
    )), n ? n(o, s, l) : !0;
  };
};
Jl.spelling = function(n) {
  return (r, i) => (console.warn(`${i} is likely a misspelling of ${n}`), !0);
};
function LE(e, n, r) {
  if (typeof e != "object")
    throw new on("options must be an object", on.ERR_BAD_OPTION_VALUE);
  const i = Object.keys(e);
  let a = i.length;
  for (; a-- > 0; ) {
    const o = i[a], s = Object.prototype.hasOwnProperty.call(n, o) ? n[o] : void 0;
    if (s) {
      const l = e[o], c = l === void 0 || s(l, o, e);
      if (c !== !0)
        throw new on(
          "option " + o + " must be " + c,
          on.ERR_BAD_OPTION_VALUE
        );
      continue;
    }
    if (r !== !0)
      throw new on("Unknown option " + o, on.ERR_BAD_OPTION);
  }
}
const Qs = {
  assertOptions: LE,
  validators: Jl
}, zt = Qs.validators;
let Vi = class {
  constructor(n) {
    this.defaults = n || {}, this.interceptors = {
      request: new gv(),
      response: new gv()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(n, r) {
    try {
      return await this._request(n, r);
    } catch (i) {
      if (i instanceof Error) {
        let a = {};
        Error.captureStackTrace ? Error.captureStackTrace(a) : a = new Error();
        const o = (() => {
          if (!a.stack)
            return "";
          const s = a.stack.indexOf(`
`);
          return s === -1 ? "" : a.stack.slice(s + 1);
        })();
        try {
          if (!i.stack)
            i.stack = o;
          else if (o) {
            const s = o.indexOf(`
`), l = s === -1 ? -1 : o.indexOf(`
`, s + 1), c = l === -1 ? "" : o.slice(l + 1);
            String(i.stack).endsWith(c) || (i.stack += `
` + o);
          }
        } catch {
        }
      }
      throw i;
    }
  }
  _request(n, r) {
    typeof n == "string" ? (r = r || {}, r.url = n) : r = n || {}, r = Hi(this.defaults, r);
    const { transitional: i, paramsSerializer: a, headers: o } = r;
    i !== void 0 && Qs.assertOptions(
      i,
      {
        silentJSONParsing: zt.transitional(zt.boolean),
        forcedJSONParsing: zt.transitional(zt.boolean),
        clarifyTimeoutError: zt.transitional(zt.boolean),
        legacyInterceptorReqResOrdering: zt.transitional(zt.boolean),
        advertiseZstdAcceptEncoding: zt.transitional(zt.boolean),
        validateStatusUndefinedResolves: zt.transitional(zt.boolean)
      },
      !1
    ), a != null && (ye.isFunction(a) ? r.paramsSerializer = {
      serialize: a
    } : Qs.assertOptions(
      a,
      {
        encode: zt.function,
        serialize: zt.function
      },
      !0
    )), r.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? r.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : r.allowAbsoluteUrls = !0), Qs.assertOptions(
      r,
      {
        baseUrl: zt.spelling("baseURL"),
        withXsrfToken: zt.spelling("withXSRFToken")
      },
      !0
    ), r.method = (r.method || this.defaults.method || "get").toLowerCase();
    let s = o && ye.merge(o.common, o[r.method]);
    o && ye.forEach(["delete", "get", "head", "post", "put", "patch", "query", "common"], (w) => {
      delete o[w];
    }), r.headers = Ut.concat(s, o);
    const l = [];
    let c = !0;
    this.interceptors.request.forEach(function(N) {
      if (typeof N.runWhen == "function" && N.runWhen(r) === !1)
        return;
      c = c && N.synchronous;
      const j = r.transitional || Py;
      j && j.legacyInterceptorReqResOrdering ? l.unshift(N.fulfilled, N.rejected) : l.push(N.fulfilled, N.rejected);
    });
    const m = [];
    this.interceptors.response.forEach(function(N) {
      m.push(N.fulfilled, N.rejected);
    });
    let u, f = 0, h;
    if (!c) {
      const w = [Fv.bind(this), void 0];
      for (w.unshift(...l), w.push(...m), h = w.length, u = Promise.resolve(r); f < h; )
        u = u.then(w[f++], w[f++]);
      return u;
    }
    h = l.length;
    let k = r;
    for (; f < h; ) {
      const w = l[f++], N = l[f++];
      try {
        k = w(k);
      } catch (j) {
        N.call(this, j);
        break;
      }
    }
    try {
      u = Fv.call(this, k);
    } catch (w) {
      return Promise.reject(w);
    }
    for (f = 0, h = m.length; f < h; )
      u = u.then(m[f++], m[f++]);
    return u;
  }
  getUri(n) {
    n = Hi(this.defaults, n);
    const r = Qw(n.baseURL, n.url, n.allowAbsoluteUrls, n);
    return Ww(r, n.params, n.paramsSerializer);
  }
};
ye.forEach(["delete", "get", "head", "options"], function(n) {
  Vi.prototype[n] = function(r, i) {
    return this.request(
      Hi(i || {}, {
        method: n,
        url: r,
        data: i && ye.hasOwnProp(i, "data") ? i.data : void 0
      })
    );
  };
});
ye.forEach(["post", "put", "patch", "query"], function(n) {
  function r(i) {
    return function(o, s, l) {
      return this.request(
        Hi(l || {}, {
          method: n,
          headers: i ? {
            "Content-Type": "multipart/form-data"
          } : {},
          url: o,
          data: s
        })
      );
    };
  }
  Vi.prototype[n] = r(), n !== "query" && (Vi.prototype[n + "Form"] = r(!0));
});
let VE = class nC {
  constructor(n) {
    if (typeof n != "function")
      throw new TypeError("executor must be a function.");
    let r;
    this.promise = new Promise(function(o) {
      r = o;
    });
    const i = this;
    this.promise.then((a) => {
      if (!i._listeners) return;
      let o = i._listeners.length;
      for (; o-- > 0; )
        i._listeners[o](a);
      i._listeners = null;
    }), this.promise.then = (a) => {
      let o;
      const s = new Promise((l) => {
        i.subscribe(l), o = l;
      }).then(a);
      return s.cancel = function() {
        i.unsubscribe(o);
      }, s;
    }, n(function(o, s, l) {
      i.reason || (i.reason = new Xo(o, s, l), r(i.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(n) {
    if (this.reason) {
      n(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(n) : this._listeners = [n];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(n) {
    if (!this._listeners)
      return;
    const r = this._listeners.indexOf(n);
    r !== -1 && this._listeners.splice(r, 1);
  }
  toAbortSignal() {
    const n = new AbortController(), r = (i) => {
      n.abort(i);
    };
    return this.subscribe(r), n.signal.unsubscribe = () => this.unsubscribe(r), n.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let n;
    return {
      token: new nC(function(a) {
        n = a;
      }),
      cancel: n
    };
  }
};
function zE(e) {
  return function(r) {
    return e.apply(null, r);
  };
}
function UE(e) {
  return ye.isObject(e) && e.isAxiosError === !0;
}
const Jh = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511,
  WebServerIsDown: 521,
  ConnectionTimedOut: 522,
  OriginIsUnreachable: 523,
  TimeoutOccurred: 524,
  SslHandshakeFailed: 525,
  InvalidSslCertificate: 526
};
Object.entries(Jh).forEach(([e, n]) => {
  Jh[n] = e;
});
function tC(e) {
  const n = new Vi(e), r = Tw(Vi.prototype.request, n);
  return ye.extend(r, Vi.prototype, n, { allOwnKeys: !0 }), ye.extend(r, n, null, { allOwnKeys: !0 }), r.create = function(a) {
    return tC(Hi(e, a));
  }, r;
}
const kt = tC(Qo);
kt.Axios = Vi;
kt.CanceledError = Xo;
kt.CancelToken = VE;
kt.isCancel = Yw;
kt.VERSION = Ly;
kt.toFormData = Yl;
kt.AxiosError = on;
kt.Cancel = kt.CanceledError;
kt.all = function(n) {
  return Promise.all(n);
};
kt.spread = zE;
kt.isAxiosError = UE;
kt.mergeConfig = Hi;
kt.AxiosHeaders = Ut;
kt.formToJSON = (e) => Gw(ye.isHTMLForm(e) ? new FormData(e) : e);
kt.getAdapter = eC.getAdapter;
kt.HttpStatusCode = Jh;
kt.default = kt;
const {
  Axios: X8,
  AxiosError: Z8,
  CanceledError: eY,
  isCancel: nY,
  CancelToken: tY,
  VERSION: rY,
  all: iY,
  Cancel: aY,
  isAxiosError: ME,
  spread: oY,
  toFormData: sY,
  AxiosHeaders: lY,
  HttpStatusCode: dY,
  formToJSON: cY,
  getAdapter: uY,
  mergeConfig: mY,
  create: pY
} = kt;
class BE {
  /** Checks whether the app is running as an electron application. */
  isElectron() {
    return window.electron ? !!window.electron : !!process?.versions?.electron || /electron/i.test(navigator.userAgent);
  }
  /**
   * Gets the electron version.
   *
   * version 0.0.0 represents a unsupported version
   */
  async getVersion() {
    return window.electron ? (await window.electron.getVersion()).split("-")[0] : "0.0.0";
  }
  /** Checks if the running Electron build is a standalone (non auto-updating windows version) */
  async isStandaloneBuild() {
    return window.electron?.isStandaloneBuild ? await window.electron.isStandaloneBuild() : null;
  }
  /** Checks if the running Electron build is installed from an windows MSI installer */
  async isMsiBuild() {
    return window.electron?.isMsiBuild ? await window.electron.isMsiBuild() : null;
  }
}
const $v = new BE();
function qE(e, n) {
  return Ev(e), Ev(n), e.localeCompare(n, void 0, {
    numeric: !0
  });
}
function Ev(e) {
  if (e.split(".").length !== 3)
    throw Error(`The version '${e}' must be in the format 'x.x.x'.`);
}
const HE = Object.prototype.toString;
function WE(e, n) {
  return HE.call(e) === `[object ${n}]`;
}
function KE(e) {
  return WE(e, "Object");
}
function GE(e) {
  return !!(e && e.then && typeof e.then == "function");
}
const $o = "8.36.0", oi = globalThis;
function zy(e, n, r) {
  const i = r || oi, a = i.__SENTRY__ = i.__SENTRY__ || {}, o = a[$o] = a[$o] || {};
  return o[e] || (o[e] = n());
}
const rC = typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__, YE = "Sentry Logger ", Tv = [
  "debug",
  "info",
  "warn",
  "error",
  "log",
  "assert",
  "trace"
], Rv = {};
function iC(e) {
  if (!("console" in oi))
    return e();
  const n = oi.console, r = {}, i = Object.keys(Rv);
  i.forEach((a) => {
    const o = Rv[a];
    r[a] = n[a], n[a] = o;
  });
  try {
    return e();
  } finally {
    i.forEach((a) => {
      n[a] = r[a];
    });
  }
}
function JE() {
  let e = !1;
  const n = {
    enable: () => {
      e = !0;
    },
    disable: () => {
      e = !1;
    },
    isEnabled: () => e
  };
  return rC ? Tv.forEach((r) => {
    n[r] = (...i) => {
      e && iC(() => {
        oi.console[r](`${YE}[${r}]:`, ...i);
      });
    };
  }) : Tv.forEach((r) => {
    n[r] = () => {
    };
  }), n;
}
const Xs = zy("logger", JE);
function QE(e, n, r) {
  try {
    Object.defineProperty(e, n, {
      // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
      value: r,
      writable: !0,
      configurable: !0
    });
  } catch {
    rC && Xs.log(`Failed to add non-enumerable property "${n}" to object`, e);
  }
}
const aC = 1e3;
function Uy() {
  return Date.now() / aC;
}
function XE() {
  const { performance: e } = oi;
  if (!e || !e.now)
    return Uy;
  const n = Date.now() - e.now(), r = e.timeOrigin == null ? n : e.timeOrigin;
  return () => (r + e.now()) / aC;
}
const ZE = XE();
(() => {
  const { performance: e } = oi;
  if (!e || !e.now)
    return;
  const n = 3600 * 1e3, r = e.now(), i = Date.now(), a = e.timeOrigin ? Math.abs(e.timeOrigin + r - i) : n, o = a < n, s = e.timing && e.timing.navigationStart, c = typeof s == "number" ? Math.abs(s + r - i) : n, m = c < n;
  return o || m ? a <= c ? e.timeOrigin : s : i;
})();
function fa() {
  const e = oi, n = e.crypto || e.msCrypto;
  let r = () => Math.random() * 16;
  try {
    if (n && n.randomUUID)
      return n.randomUUID().replace(/-/g, "");
    n && n.getRandomValues && (r = () => {
      const i = new Uint8Array(1);
      return n.getRandomValues(i), i[0];
    });
  } catch {
  }
  return ("10000000100040008000" + 1e11).replace(
    /[018]/g,
    (i) => (
      // eslint-disable-next-line no-bitwise
      (i ^ (r() & 15) >> i / 4).toString(16)
    )
  );
}
function Dv() {
  return {
    traceId: fa(),
    spanId: fa().substring(16)
  };
}
function My() {
  return By(oi), oi;
}
function By(e) {
  const n = e.__SENTRY__ = e.__SENTRY__ || {};
  return n.version = n.version || $o, n[$o] = n[$o] || {};
}
function eT(e, n = {}) {
  if (n.user && (!e.ipAddress && n.user.ip_address && (e.ipAddress = n.user.ip_address), !e.did && !n.did && (e.did = n.user.id || n.user.email || n.user.username)), e.timestamp = n.timestamp || ZE(), n.abnormal_mechanism && (e.abnormal_mechanism = n.abnormal_mechanism), n.ignoreDuration && (e.ignoreDuration = n.ignoreDuration), n.sid && (e.sid = n.sid.length === 32 ? n.sid : fa()), n.init !== void 0 && (e.init = n.init), !e.did && n.did && (e.did = `${n.did}`), typeof n.started == "number" && (e.started = n.started), e.ignoreDuration)
    e.duration = void 0;
  else if (typeof n.duration == "number")
    e.duration = n.duration;
  else {
    const r = e.timestamp - e.started;
    e.duration = r >= 0 ? r : 0;
  }
  n.release && (e.release = n.release), n.environment && (e.environment = n.environment), !e.ipAddress && n.ipAddress && (e.ipAddress = n.ipAddress), !e.userAgent && n.userAgent && (e.userAgent = n.userAgent), typeof n.errors == "number" && (e.errors = n.errors), n.status && (e.status = n.status);
}
const Qh = "_sentrySpan";
function Ov(e, n) {
  n ? QE(e, Qh, n) : delete e[Qh];
}
function Pv(e) {
  return e[Qh];
}
const nT = 100;
class qy {
  /** Flag if notifying is happening. */
  /** Callback for client to receive scope changes. */
  /** Callback list that will be called during event processing. */
  /** Array of breadcrumbs. */
  /** User */
  /** Tags */
  /** Extra */
  /** Contexts */
  /** Attachments */
  /** Propagation Context for distributed tracing */
  /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */
  /** Fingerprint */
  /** Severity */
  /**
   * Transaction Name
   *
   * IMPORTANT: The transaction name on the scope has nothing to do with root spans/transaction objects.
   * It's purpose is to assign a transaction to the scope that's added to non-transaction events.
   */
  /** Session */
  /** Request Mode Session Status */
  /** The client on this scope */
  /** Contains the last event id of a captured event.  */
  // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
  constructor() {
    this._notifyingListeners = !1, this._scopeListeners = [], this._eventProcessors = [], this._breadcrumbs = [], this._attachments = [], this._user = {}, this._tags = {}, this._extra = {}, this._contexts = {}, this._sdkProcessingMetadata = {}, this._propagationContext = Dv();
  }
  /**
   * @inheritDoc
   */
  clone() {
    const n = new qy();
    return n._breadcrumbs = [...this._breadcrumbs], n._tags = { ...this._tags }, n._extra = { ...this._extra }, n._contexts = { ...this._contexts }, n._user = this._user, n._level = this._level, n._session = this._session, n._transactionName = this._transactionName, n._fingerprint = this._fingerprint, n._eventProcessors = [...this._eventProcessors], n._requestSession = this._requestSession, n._attachments = [...this._attachments], n._sdkProcessingMetadata = { ...this._sdkProcessingMetadata }, n._propagationContext = { ...this._propagationContext }, n._client = this._client, n._lastEventId = this._lastEventId, Ov(n, Pv(this)), n;
  }
  /**
   * @inheritDoc
   */
  setClient(n) {
    this._client = n;
  }
  /**
   * @inheritDoc
   */
  setLastEventId(n) {
    this._lastEventId = n;
  }
  /**
   * @inheritDoc
   */
  getClient() {
    return this._client;
  }
  /**
   * @inheritDoc
   */
  lastEventId() {
    return this._lastEventId;
  }
  /**
   * @inheritDoc
   */
  addScopeListener(n) {
    this._scopeListeners.push(n);
  }
  /**
   * @inheritDoc
   */
  addEventProcessor(n) {
    return this._eventProcessors.push(n), this;
  }
  /**
   * @inheritDoc
   */
  setUser(n) {
    return this._user = n || {
      email: void 0,
      id: void 0,
      ip_address: void 0,
      username: void 0
    }, this._session && eT(this._session, { user: n }), this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getUser() {
    return this._user;
  }
  /**
   * @inheritDoc
   */
  getRequestSession() {
    return this._requestSession;
  }
  /**
   * @inheritDoc
   */
  setRequestSession(n) {
    return this._requestSession = n, this;
  }
  /**
   * @inheritDoc
   */
  setTags(n) {
    return this._tags = {
      ...this._tags,
      ...n
    }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setTag(n, r) {
    return this._tags = { ...this._tags, [n]: r }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setExtras(n) {
    return this._extra = {
      ...this._extra,
      ...n
    }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setExtra(n, r) {
    return this._extra = { ...this._extra, [n]: r }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setFingerprint(n) {
    return this._fingerprint = n, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setLevel(n) {
    return this._level = n, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setTransactionName(n) {
    return this._transactionName = n, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setContext(n, r) {
    return r === null ? delete this._contexts[n] : this._contexts[n] = r, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setSession(n) {
    return n ? this._session = n : delete this._session, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getSession() {
    return this._session;
  }
  /**
   * @inheritDoc
   */
  update(n) {
    if (!n)
      return this;
    const r = typeof n == "function" ? n(this) : n, [i, a] = r instanceof xa ? [r.getScopeData(), r.getRequestSession()] : KE(r) ? [n, n.requestSession] : [], { tags: o, extra: s, user: l, contexts: c, level: m, fingerprint: u = [], propagationContext: f } = i || {};
    return this._tags = { ...this._tags, ...o }, this._extra = { ...this._extra, ...s }, this._contexts = { ...this._contexts, ...c }, l && Object.keys(l).length && (this._user = l), m && (this._level = m), u.length && (this._fingerprint = u), f && (this._propagationContext = f), a && (this._requestSession = a), this;
  }
  /**
   * @inheritDoc
   */
  clear() {
    return this._breadcrumbs = [], this._tags = {}, this._extra = {}, this._user = {}, this._contexts = {}, this._level = void 0, this._transactionName = void 0, this._fingerprint = void 0, this._requestSession = void 0, this._session = void 0, Ov(this, void 0), this._attachments = [], this._propagationContext = Dv(), this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  addBreadcrumb(n, r) {
    const i = typeof r == "number" ? r : nT;
    if (i <= 0)
      return this;
    const a = {
      timestamp: Uy(),
      ...n
    }, o = this._breadcrumbs;
    return o.push(a), this._breadcrumbs = o.length > i ? o.slice(-i) : o, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getLastBreadcrumb() {
    return this._breadcrumbs[this._breadcrumbs.length - 1];
  }
  /**
   * @inheritDoc
   */
  clearBreadcrumbs() {
    return this._breadcrumbs = [], this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  addAttachment(n) {
    return this._attachments.push(n), this;
  }
  /**
   * @inheritDoc
   */
  clearAttachments() {
    return this._attachments = [], this;
  }
  /** @inheritDoc */
  getScopeData() {
    return {
      breadcrumbs: this._breadcrumbs,
      attachments: this._attachments,
      contexts: this._contexts,
      tags: this._tags,
      extra: this._extra,
      user: this._user,
      level: this._level,
      fingerprint: this._fingerprint || [],
      eventProcessors: this._eventProcessors,
      propagationContext: this._propagationContext,
      sdkProcessingMetadata: this._sdkProcessingMetadata,
      transactionName: this._transactionName,
      span: Pv(this)
    };
  }
  /**
   * @inheritDoc
   */
  setSDKProcessingMetadata(n) {
    return this._sdkProcessingMetadata = { ...this._sdkProcessingMetadata, ...n }, this;
  }
  /**
   * @inheritDoc
   */
  setPropagationContext(n) {
    return this._propagationContext = n, this;
  }
  /**
   * @inheritDoc
   */
  getPropagationContext() {
    return this._propagationContext;
  }
  /**
   * @inheritDoc
   */
  captureException(n, r) {
    const i = r && r.event_id ? r.event_id : fa();
    if (!this._client)
      return Xs.warn("No client configured on scope - will not capture exception!"), i;
    const a = new Error("Sentry syntheticException");
    return this._client.captureException(
      n,
      {
        originalException: n,
        syntheticException: a,
        ...r,
        event_id: i
      },
      this
    ), i;
  }
  /**
   * @inheritDoc
   */
  captureMessage(n, r, i) {
    const a = i && i.event_id ? i.event_id : fa();
    if (!this._client)
      return Xs.warn("No client configured on scope - will not capture message!"), a;
    const o = new Error(n);
    return this._client.captureMessage(
      n,
      r,
      {
        originalException: n,
        syntheticException: o,
        ...i,
        event_id: a
      },
      this
    ), a;
  }
  /**
   * @inheritDoc
   */
  captureEvent(n, r) {
    const i = r && r.event_id ? r.event_id : fa();
    return this._client ? (this._client.captureEvent(n, { ...r, event_id: i }, this), i) : (Xs.warn("No client configured on scope - will not capture event!"), i);
  }
  /**
   * This will be called on every set call.
   */
  _notifyScopeListeners() {
    this._notifyingListeners || (this._notifyingListeners = !0, this._scopeListeners.forEach((n) => {
      n(this);
    }), this._notifyingListeners = !1);
  }
}
const xa = qy;
function tT() {
  return zy("defaultCurrentScope", () => new xa());
}
function rT() {
  return zy("defaultIsolationScope", () => new xa());
}
class iT {
  constructor(n, r) {
    let i;
    n ? i = n : i = new xa();
    let a;
    r ? a = r : a = new xa(), this._stack = [{ scope: i }], this._isolationScope = a;
  }
  /**
   * Fork a scope for the stack.
   */
  withScope(n) {
    const r = this._pushScope();
    let i;
    try {
      i = n(r);
    } catch (a) {
      throw this._popScope(), a;
    }
    return GE(i) ? i.then(
      (a) => (this._popScope(), a),
      (a) => {
        throw this._popScope(), a;
      }
    ) : (this._popScope(), i);
  }
  /**
   * Get the client of the stack.
   */
  getClient() {
    return this.getStackTop().client;
  }
  /**
   * Returns the scope of the top stack.
   */
  getScope() {
    return this.getStackTop().scope;
  }
  /**
   * Get the isolation scope for the stack.
   */
  getIsolationScope() {
    return this._isolationScope;
  }
  /**
   * Returns the topmost scope layer in the order domain > local > process.
   */
  getStackTop() {
    return this._stack[this._stack.length - 1];
  }
  /**
   * Push a scope to the stack.
   */
  _pushScope() {
    const n = this.getScope().clone();
    return this._stack.push({
      client: this.getClient(),
      scope: n
    }), n;
  }
  /**
   * Pop a scope from the stack.
   */
  _popScope() {
    return this._stack.length <= 1 ? !1 : !!this._stack.pop();
  }
}
function Sa() {
  const e = My(), n = By(e);
  return n.stack = n.stack || new iT(tT(), rT());
}
function aT(e) {
  return Sa().withScope(e);
}
function oT(e, n) {
  const r = Sa();
  return r.withScope(() => (r.getStackTop().scope = e, n(e)));
}
function Av(e) {
  return Sa().withScope(() => e(Sa().getIsolationScope()));
}
function sT() {
  return {
    withIsolationScope: Av,
    withScope: aT,
    withSetScope: oT,
    withSetIsolationScope: (e, n) => Av(n),
    getCurrentScope: () => Sa().getScope(),
    getIsolationScope: () => Sa().getIsolationScope()
  };
}
function oC(e) {
  const n = By(e);
  return n.acs ? n.acs : sT();
}
function Hy() {
  const e = My();
  return oC(e).getCurrentScope();
}
function sC() {
  const e = My();
  return oC(e).getIsolationScope();
}
function lT() {
  return Hy().getClient();
}
function dT(e) {
  if (e)
    return cT(e) ? { captureContext: e } : mT(e) ? {
      captureContext: e
    } : e;
}
function cT(e) {
  return e instanceof xa || typeof e == "function";
}
const uT = [
  "user",
  "level",
  "extra",
  "contexts",
  "tags",
  "fingerprint",
  "requestSession",
  "propagationContext"
];
function mT(e) {
  return Object.keys(e).some((n) => uT.includes(n));
}
function Lv(e, n) {
  return Hy().captureException(e, dT(n));
}
function pT(e, n) {
  const r = typeof n == "string" ? n : void 0, i = typeof n != "string" ? { captureContext: n } : void 0;
  return Hy().captureMessage(e, r, i);
}
function fT(e, n) {
  sC().setContext(e, n);
}
const hT = 100;
function Ri(e, n) {
  const r = lT(), i = sC();
  if (!r) return;
  const { beforeBreadcrumb: a = null, maxBreadcrumbs: o = hT } = r.getOptions();
  if (o <= 0) return;
  const l = { timestamp: Uy(), ...e }, c = a ? iC(() => a(l, n)) : l;
  c !== null && (r.emit && r.emit("beforeAddBreadcrumb", c, n), i.addBreadcrumb(c, o));
}
var Bo;
(function(e) {
  e.Unknown = "unknown", e.Core = "core", e.Routing = "routing-and-presence", e.Insights = "insights", e.Ecosystem = "ecosystem", e.Partners = "partners", e.Channels = "channels", e.Messaging = "messaging", e.Platform = "platform", e.AI = "ai", e.Conversations = "conversations", e.Automation = "automation";
})(Bo || (Bo = {}));
function ha(e) {
  const n = e.split(".")[1];
  if (!n)
    throw Error("Invalid token");
  const r = n.replace(/-/g, "+").replace(/_/g, "/");
  try {
    return JSON.parse(Buffer.from(r, "base64").toString());
  } catch (i) {
    throw Error(`Failed to parse the JSON Web Token with the following error: ${i}`);
  }
}
const yT = Uo.backendDomain ? {
  "backend-domain": Uo.backendDomain
} : void 0;
function Zs() {
  const e = new URLSearchParams({
    noToken: "true",
    ...yT
  }).toString();
  document.location.href = `${Uo.url.logIn}?${e}`;
}
const jd = "authData", wd = 30, gT = 600, Cd = 5;
class vT {
  authData = null;
  /** The (server) time when the access token expires, in seconds. */
  accessTokenExpiresAt = 0;
  /**
   * The difference between client- and server-time, in seconds. Negative if
   * client is ahead of server, positive if server is ahead of client
   */
  clientServerTimeDiff = 0;
  /**
   * Returns an estimated server time (unix epoch in seconds) by adding the
   * client-server time difference to the current client time.
   *
   * The time-diff is stored whenever a new access token is saved.
   *
   * @returns {number} The estimated server time in seconds.
   */
  estimatedServerTime() {
    const n = Date.now() / 1e3;
    return this.clientServerTimeDiff >= Cd || this.clientServerTimeDiff <= -Cd ? Math.ceil(n + this.clientServerTimeDiff) : Math.ceil(n);
  }
  /**
   * Sets the auth data in localStorage.
   *
   * @param authData The auth data.
   */
  setAuthData(n) {
    this.authData = n;
    const i = Math.ceil(Date.now() / 1e3) + gT, a = ha(n.access_token).exp;
    if (this.clientServerTimeDiff = a - i, process.env.NODE_ENV !== "test" && Math.abs(this.clientServerTimeDiff) > Cd) {
      const o = this.clientServerTimeDiff > 0 ? "behind" : "ahead";
      console.info(`Client time is ${o} by significant amount. (${Math.abs(this.clientServerTimeDiff)}s)`);
    }
    this.accessTokenExpiresAt = a, localStorage.setItem(jd, JSON.stringify(n));
  }
  /** Gets the auth data from memory or localStorage. */
  getAuthData() {
    if (this.authData)
      return this.authData;
    const n = localStorage.getItem(jd), r = n ? JSON.parse(n) : null;
    return this.validateAuthDataComplete(r) && (this.authData = r), r;
  }
  /** Removes the auth data from localStorage. */
  removeAuthData() {
    this.authData = null, localStorage.removeItem(jd);
  }
  getAccessToken() {
    return this.authData?.access_token || null;
  }
  getRefreshToken() {
    return this.authData?.refresh_token || null;
  }
  /**
   * Validates that the auth data is complete - i.e not fragmented.
   *
   * @param authData The auth data.
   */
  validateAuthDataComplete(n) {
    return n ? [
      "access_token",
      "refresh_token",
      "expires_in"
    ].every((i) => typeof n[i] < "u") : !1;
  }
  isAccessTokenExpired() {
    if (!this.getAccessToken())
      return !0;
    const r = this.accessTokenExpiresAt - wd;
    return this.estimatedServerTime() >= r;
  }
  isRefreshTokenExpired(n) {
    if (!n)
      return !0;
    const r = ha(n), i = r.exp - wd;
    return !r || this.estimatedServerTime() >= i;
  }
  accessTokenExpiresInMs() {
    return (this.accessTokenExpiresAt - wd - this.estimatedServerTime()) * 1e3;
  }
}
const Tt = new vT();
async function kT(e) {
  const n = window.location.origin.replace(/^https?:\/\//, ""), r = ["localhost:8080", "uptrends-monitor"];
  if (!(!e.response || r.some((i) => n.includes(i)))) {
    try {
      const i = e.response.config.headers.Authorization ?? "", a = i ? i.toString()?.split("Basic ")[1] : "", o = a ? atob(a).split("token:")[1] : "", s = o ? ha(o).exp : "None", l = await Ql.getAuthData({ localStorageOnly: !0 }), c = Math.floor(Date.now() / 1e3), m = l?.access_token, u = l?.refresh_token, f = m ? ha(m).exp : "None", h = u ? ha(u).exp : "None", k = typeof s == "number" ? c - s : "Unknown", w = typeof f == "number" ? c - f : "Unknown", N = typeof h == "number" ? c - h : "Unknown", j = e.response.headers["x-dixa-rid"];
      fT("Expires", {
        currentTimestamp: c,
        accessTokenFromHeader: s,
        accessTokenFromHeaderDiff: k,
        accessTokenFromLocalStorage: f,
        accessTokenFromLocalStorageDiff: w,
        refreshTokenFromLocalStorage: h,
        refreshTokenFromLocalStorageDiff: N,
        xDixaRid: j,
        navigatorOnline: navigator.onLine
      });
    } catch (i) {
      console.error("Error adding Sentry error context", i);
    }
    pT("401 unauthorized interceptor", {
      level: "debug",
      tags: {
        team: Bo.Platform,
        domain: n
      }
    });
  }
}
const Fd = /* @__PURE__ */ new Map(), bT = 3;
function _T(e) {
  e.interceptors.response.use((n) => (Fd.delete(n.config.url), n), (n) => {
    if (n.response) {
      const { status: r } = n.response;
      switch (r) {
        case Xh.Unauthorized:
          if (!Ql.isRefreshTokenExpired() && n.config) {
            Ri({
              category: "errorInterceptor",
              message: "Access token expired after request",
              level: "debug"
            });
            const i = Fd.get(n.config.url) ?? 0;
            if (console.log(`Retrying request (${i + 1}): ${n.config.url}`), i <= bT)
              return Fd.set(n.config.url, i + 1), e(n.config);
          }
          kT(n), console.error("401 unauthorized interceptor"), Zs();
          break;
      }
    }
    return Promise.reject(n);
  });
}
const lC = kt.create();
_T(lC);
const Xr = console.log;
async function Vv(e) {
  return new Promise((n) => setTimeout(n, e * 1e3));
}
class xT extends Error {
  constructor(n, r) {
    super(n, r);
  }
}
function ST(e = 0) {
  return Math.min(Math.round((Math.random() + 1) * Math.pow(1.5, e)), 30);
}
const NT = 5;
class jT {
  authDataPromise = null;
  retryCount = 0;
  async init(n) {
    const r = await this.refresh(n);
    if (r)
      Tt.setAuthData(r);
    else {
      const i = Tt.isRefreshTokenExpired(n) ? "expired" : "unknown";
      throw new xT("Failed to init refresh token", {
        cause: i
      });
    }
  }
  getDebugInfo() {
    const n = Tt.getAccessToken();
    if (!n)
      return {};
    const r = ha(n), { exp: i } = r;
    return {
      expire: i ? new Date(i * 1e3).toISOString() : null,
      now: (/* @__PURE__ */ new Date()).toISOString()
    };
  }
  /**
   * Gets auth data from LocalStorage, or fetches new auth data if the current
   * token is expired or is about to expire.
   */
  async getAuthData({ localStorageOnly: n = !1 } = {}) {
    if (n)
      return Tt.getAuthData();
    if (this.authDataPromise)
      return await this.authDataPromise;
    const r = Tt.getAuthData();
    return r ? Tt.isAccessTokenExpired() ? (Ri({
      category: "refreshToken",
      // Cannot include "token" in the message, as it will be redacted
      message: "expired or about to expire",
      level: "debug",
      data: this.getDebugInfo()
    }), this.authDataPromise = this.refresh(r.refresh_token).then((i) => (i && Tt.setAuthData(i), this.authDataPromise = null, i)), await this.authDataPromise) : r : null;
  }
  removeAuthData() {
    return Tt.removeAuthData();
  }
  validateAuthDataComplete(n) {
    return Tt.validateAuthDataComplete(n);
  }
  isAccessTokenExpired() {
    return Tt.isAccessTokenExpired();
  }
  isRefreshTokenExpired() {
    const n = Tt.getAuthData();
    return n ? Tt.isRefreshTokenExpired(n.refresh_token) : !0;
  }
  /** Checks whether refresh token is supported. */
  async isSupported() {
    if (!$v.isElectron())
      return !0;
    const n = await $v.getVersion();
    return qE(n, "3.7.0") === 1;
  }
  /**
   * Gets refreshed tokens from the API
   *
   * @param refreshToken The refresh token.
   * @param retriesLeft The number of retries left.
   */
  async refresh(n, r = NT) {
    try {
      return await lC.post(`${Uo.url.rest}/v2/login/refresh`, {
        refreshToken: n
      }).then((i) => (this.retryCount = 0, i.data.data));
    } catch (i) {
      return await this.handleRefreshError(i, n, r);
    }
  }
  async waitUntilOnline() {
    const n = navigator.onLine === !1;
    for (n && (Xr("AUTH", "Network connection offline - waiting..."), Ri({
      category: "refreshToken",
      message: "Network connection offline - waiting...",
      level: "debug"
    })); navigator.onLine === !1; )
      await Vv(5);
    n && (Xr("AUTH", "Network connection restored"), Ri({
      category: "refreshToken",
      message: "Network connection restored",
      level: "debug"
    }));
  }
  async retryRefresh(n, r) {
    await this.waitUntilOnline(), this.retryCount++;
    const i = ST(this.retryCount);
    return Xr("AUTH", `Retrying in ${i} seconds`), await Vv(i), await this.refresh(n, r);
  }
  async handleRefreshError(n, r, i) {
    if (Tt.isRefreshTokenExpired(r))
      return Xr("AUTH", "Refresh token expired"), Ri({
        category: "refreshToken",
        message: "Refresh token expired",
        level: "debug"
      }), Tt.removeAuthData(), Zs(), null;
    if (ME(n)) {
      if (n.message === "timeout exceeded")
        return Xr("AUTH", "Timeout exceeded"), Ri({
          category: "refreshToken",
          message: "Timeout exceeded",
          level: "debug"
        }), await this.retryRefresh(r, i);
      if (n.message === "Network Error")
        return Xr("AUTH", "Network error"), Ri({
          category: "refreshToken",
          message: "Network error",
          level: "debug"
        }), await this.retryRefresh(r, i);
      if (n.response?.status === 401)
        return Xr("AUTH", "Refresh token invalid (401)"), Tt.removeAuthData(), Zs(), null;
      Lv(n, {
        level: "error",
        tags: {
          team: Bo.Platform,
          errorSource: "authManager.refresh"
        }
      });
    }
    return i <= 0 ? (Xr("AUTH", "Retries exhausted, logging out"), Lv(n, {
      level: "error",
      tags: {
        team: Bo.Platform,
        errorSource: "authManager.refresh"
      }
    }), Tt.removeAuthData(), Zs(), null) : (Xr("AUTH", `Retrying ${i} more times`), await this.retryRefresh(r, i - 1));
  }
  accessTokenExpiresInMs() {
    return Tt.accessTokenExpiresInMs();
  }
}
const Ql = new jT();
var Xh;
(function(e) {
  e[e.BadRequest = 400] = "BadRequest", e[e.Unauthorized = 401] = "Unauthorized", e[e.Forbidden = 403] = "Forbidden", e[e.NotFound = 404] = "NotFound", e[e.Conflict = 409] = "Conflict", e[e.InternalServerError = 500] = "InternalServerError", e[e.BadGateway = 502] = "BadGateway", e[e.ServiceUnavailable = 503] = "ServiceUnavailable";
})(Xh || (Xh = {}));
const wT = new Ey((e, n) => new Iw((r) => {
  Ql.getAuthData().then((i) => {
    const a = i?.access_token, o = e.getContext().headers;
    return e.setContext({
      ...o,
      headers: {
        Authorization: a ? `Bearer ${a}` : ""
      }
    }), n(e).subscribe(r);
  }).catch((i) => r.error(i));
})), CT = new Ey(
  (e, n) => new Iw((r) => {
    const i = e.getContext(), { headers: a, widgetId: o, widgetType: s, operationName: l } = i;
    Ql.getAuthData().then((c) => (e.setContext({
      ...i,
      headers: {
        ...a,
        ...o && { "x-integration-widget-id": o },
        ...s && { "x-integration-widget-type": s },
        ...l && {
          "x-integration-widget-operation": l
        },
        ...lI(Uo.url.partnerIntegrations) && c?.access_token && dI(c.access_token)
      }
    }), n(e).subscribe(r))).catch((c) => r.error(c));
  })
), FT = new AbortController(), dC = (e) => new RI({
  queryDeduplication: !1,
  cache: new DI(),
  link: Ey.from([
    wT,
    CT,
    OI({
      uri: `${e}/graphql`,
      fetch: VI,
      fetchOptions: {
        mode: "cors",
        // The `AbortSignal` object instance is used to communicate with a
        // fetch request and abort it if desired via an `AbortController`.
        // This prevents abandoned abort errors spiral up to Sentry.
        signal: FT.signal
      }
    })
  ]),
  defaultOptions: {
    watchQuery: {
      fetchPolicy: "no-cache",
      errorPolicy: "all"
    },
    query: {
      fetchPolicy: "no-cache",
      errorPolicy: "all"
    },
    mutate: {
      fetchPolicy: "no-cache",
      errorPolicy: "all"
    }
  }
}), IT = ({
  configuration: e,
  children: n
}) => {
  const r = Xn(
    () => dC(e.baseUrl),
    [e.baseUrl]
  );
  return /* @__PURE__ */ Qn.jsx(PI, { client: r, children: n });
};
function $T() {
  try {
    return AI(), !0;
  } catch {
    return !1;
  }
}
const ET = ({
  configuration: e,
  children: n
}) => $T() ? n : /* @__PURE__ */ Qn.jsx(IT, { configuration: e, children: n }), TT = ({
  integrationId: e,
  type: n,
  showNotification: r,
  showModal: i,
  children: a
}) => /* @__PURE__ */ Qn.jsx(LI, { children: (o) => /* @__PURE__ */ Qn.jsx(
  cI,
  {
    value: {
      useMutation: fI(e, n),
      useQuery: pI(e, n),
      useLazyQuery: mI(e, n),
      executeQuery: uI(e, n, o),
      showNotification: r,
      showModal: i ?? (() => null)
    },
    children: a
  }
) }), cC = ({
  integrationId: e,
  type: n,
  configuration: r,
  showNotification: i,
  showModal: a,
  children: o
}) => {
  const s = !!e && !!n;
  return /* @__PURE__ */ Qn.jsx(ET, { configuration: r, children: s ? /* @__PURE__ */ Qn.jsx(
    TT,
    {
      integrationId: e,
      type: n,
      showNotification: i,
      showModal: a,
      children: o
    }
  ) : o });
}, uC = Fy(
  () => {
  }
), RT = () => ql(uC), DT = ({
  children: e
}) => {
  const [n, r] = pe(!1), i = {
    headline: "",
    text: "",
    onConfirm: () => r(!1),
    confirmLabel: "Confirm",
    confirmVariant: "primary"
  }, [a, o] = pe(i), s = (c) => {
    r(!0), o(c);
  }, l = () => {
    r(!1), o(i);
  };
  return /* @__PURE__ */ Qn.jsxs(uC.Provider, { value: s, children: [
    e,
    /* @__PURE__ */ Qn.jsx(
      hI,
      {
        isOpen: n,
        setIsOpen: r,
        headline: a.headline,
        text: a.text,
        confirmLabel: a.confirmLabel,
        confirmVariant: a.confirmVariant,
        cancelLabel: a.cancelLabel,
        cancelVariant: a.cancelVariant,
        onConfirm: a.onConfirm ? () => {
          try {
            a.onConfirm && a.onConfirm();
          } finally {
            l();
          }
        } : void 0,
        onCancel: a.onCancel ? () => {
          try {
            a.onCancel && a.onCancel();
          } finally {
            l();
          }
        } : void 0,
        children: a.children
      }
    )
  ] });
}, OT = "_unmatchedHeader_qcj19_1", PT = {
  unmatchedHeader: OT
};
var Zo = (e) => e.type === "checkbox", Ai = (e) => e instanceof Date, Gt = (e) => e == null;
const mC = (e) => typeof e == "object";
var gt = (e) => !Gt(e) && !Array.isArray(e) && mC(e) && !Ai(e), pC = (e) => gt(e) && e.target ? Zo(e.target) ? e.target.checked : e.target.value : e, AT = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, fC = (e, n) => e.has(AT(n)), LT = (e) => {
  const n = e.constructor && e.constructor.prototype;
  return gt(n) && n.hasOwnProperty("isPrototypeOf");
}, Wy = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function Ot(e) {
  let n;
  const r = Array.isArray(e), i = typeof FileList < "u" ? e instanceof FileList : !1;
  if (e instanceof Date)
    n = new Date(e);
  else if (e instanceof Set)
    n = new Set(e);
  else if (!(Wy && (e instanceof Blob || i)) && (r || gt(e)))
    if (n = r ? [] : {}, !r && !LT(e))
      n = e;
    else
      for (const a in e)
        e.hasOwnProperty(a) && (n[a] = Ot(e[a]));
  else
    return e;
  return n;
}
var Xl = (e) => Array.isArray(e) ? e.filter(Boolean) : [], ht = (e) => e === void 0, nn = (e, n, r) => {
  if (!n || !gt(e))
    return r;
  const i = Xl(n.split(/[,[\].]+?/)).reduce((a, o) => Gt(a) ? a : a[o], e);
  return ht(i) || i === e ? ht(e[n]) ? r : e[n] : i;
}, sr = (e) => typeof e == "boolean", Ky = (e) => /^\w*$/.test(e), hC = (e) => Xl(e.replace(/["|']|\]/g, "").split(/\.|\[/)), it = (e, n, r) => {
  let i = -1;
  const a = Ky(n) ? [n] : hC(n), o = a.length, s = o - 1;
  for (; ++i < o; ) {
    const l = a[i];
    let c = r;
    if (i !== s) {
      const m = e[l];
      c = gt(m) || Array.isArray(m) ? m : isNaN(+a[i + 1]) ? {} : [];
    }
    if (l === "__proto__" || l === "constructor" || l === "prototype")
      return;
    e[l] = c, e = e[l];
  }
};
const fl = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, jr = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, Zr = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, yC = qe.createContext(null), Dr = () => qe.useContext(yC), Gy = (e) => {
  const { children: n, ...r } = e;
  return qe.createElement(yC.Provider, { value: r }, n);
};
var gC = (e, n, r, i = !0) => {
  const a = {
    defaultValues: n._defaultValues
  };
  for (const o in e)
    Object.defineProperty(a, o, {
      get: () => {
        const s = o;
        return n._proxyFormState[s] !== jr.all && (n._proxyFormState[s] = !i || jr.all), r && (r[s] = !0), e[s];
      }
    });
  return a;
};
function VT(e) {
  const n = Dr(), { control: r = n.control, disabled: i, name: a, exact: o } = e || {}, [s, l] = qe.useState(r._formState), c = qe.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }), m = qe.useRef(a);
  return m.current = a, qe.useEffect(() => r._subscribe({
    name: m.current,
    formState: c.current,
    exact: o,
    callback: (u) => {
      !i && l({
        ...r._formState,
        ...u
      });
    }
  }), [r, i, o]), qe.useEffect(() => {
    c.current.isValid && r._setValid(!0);
  }, [r]), qe.useMemo(() => gC(s, r, c.current, !1), [s, r]);
}
var Br = (e) => typeof e == "string", vC = (e, n, r, i, a) => Br(e) ? (i && n.watch.add(e), nn(r, e, a)) : Array.isArray(e) ? e.map((o) => (i && n.watch.add(o), nn(r, o))) : (i && (n.watchAll = !0), r);
function gi(e) {
  const n = Dr(), { control: r = n.control, name: i, defaultValue: a, disabled: o, exact: s } = e || {}, l = qe.useRef(i), c = qe.useRef(a);
  l.current = i, qe.useEffect(() => r._subscribe({
    name: l.current,
    formState: {
      values: !0
    },
    exact: s,
    callback: (f) => !o && u(vC(l.current, r._names, f.values || r._formValues, !1, c.current))
  }), [r, o, s]);
  const [m, u] = qe.useState(r._getWatch(i, a));
  return qe.useEffect(() => r._removeUnmounted()), m;
}
function Yy(e) {
  const n = Dr(), { name: r, disabled: i, control: a = n.control, shouldUnregister: o } = e, s = fC(a._names.array, r), l = gi({
    control: a,
    name: r,
    defaultValue: nn(a._formValues, r, nn(a._defaultValues, r, e.defaultValue)),
    exact: !0
  }), c = VT({
    control: a,
    name: r,
    exact: !0
  }), m = qe.useRef(e), u = qe.useRef(a.register(r, {
    ...e.rules,
    value: l,
    ...sr(e.disabled) ? { disabled: e.disabled } : {}
  })), f = qe.useMemo(() => Object.defineProperties({}, {
    invalid: {
      enumerable: !0,
      get: () => !!nn(c.errors, r)
    },
    isDirty: {
      enumerable: !0,
      get: () => !!nn(c.dirtyFields, r)
    },
    isTouched: {
      enumerable: !0,
      get: () => !!nn(c.touchedFields, r)
    },
    isValidating: {
      enumerable: !0,
      get: () => !!nn(c.validatingFields, r)
    },
    error: {
      enumerable: !0,
      get: () => nn(c.errors, r)
    }
  }), [c, r]), h = qe.useCallback((j) => u.current.onChange({
    target: {
      value: pC(j),
      name: r
    },
    type: fl.CHANGE
  }), [r]), k = qe.useCallback(() => u.current.onBlur({
    target: {
      value: nn(a._formValues, r),
      name: r
    },
    type: fl.BLUR
  }), [r, a._formValues]), w = qe.useCallback((j) => {
    const _ = nn(a._fields, r);
    _ && j && (_._f.ref = {
      focus: () => j.focus(),
      select: () => j.select(),
      setCustomValidity: (g) => j.setCustomValidity(g),
      reportValidity: () => j.reportValidity()
    });
  }, [a._fields, r]), N = qe.useMemo(() => ({
    name: r,
    value: l,
    ...sr(i) || c.disabled ? { disabled: c.disabled || i } : {},
    onChange: h,
    onBlur: k,
    ref: w
  }), [r, i, c.disabled, h, k, w, l]);
  return qe.useEffect(() => {
    const j = a._options.shouldUnregister || o;
    a.register(r, {
      ...m.current.rules,
      ...sr(m.current.disabled) ? { disabled: m.current.disabled } : {}
    });
    const _ = (g, O) => {
      const R = nn(a._fields, g);
      R && R._f && (R._f.mount = O);
    };
    if (_(r, !0), j) {
      const g = Ot(nn(a._options.defaultValues, r));
      it(a._defaultValues, r, g), ht(nn(a._formValues, r)) && it(a._formValues, r, g);
    }
    return !s && a.register(r), () => {
      (s ? j && !a._state.action : j) ? a.unregister(r) : _(r, !1);
    };
  }, [r, a, s, o]), qe.useEffect(() => {
    a._setDisabledField({
      disabled: i,
      name: r
    });
  }, [i, r, a]), qe.useMemo(() => ({
    field: N,
    formState: c,
    fieldState: f
  }), [N, c, f]);
}
const Nt = (e) => e.render(Yy(e));
var zT = (e, n, r, i, a) => n ? {
  ...r[e],
  types: {
    ...r[e] && r[e].types ? r[e].types : {},
    [i]: a || !0
  }
} : {}, Eo = (e) => Array.isArray(e) ? e : [e], zv = () => {
  let e = [];
  return {
    get observers() {
      return e;
    },
    next: (a) => {
      for (const o of e)
        o.next && o.next(a);
    },
    subscribe: (a) => (e.push(a), {
      unsubscribe: () => {
        e = e.filter((o) => o !== a);
      }
    }),
    unsubscribe: () => {
      e = [];
    }
  };
}, Zh = (e) => Gt(e) || !mC(e);
function fi(e, n) {
  if (Zh(e) || Zh(n))
    return e === n;
  if (Ai(e) && Ai(n))
    return e.getTime() === n.getTime();
  const r = Object.keys(e), i = Object.keys(n);
  if (r.length !== i.length)
    return !1;
  for (const a of r) {
    const o = e[a];
    if (!i.includes(a))
      return !1;
    if (a !== "ref") {
      const s = n[a];
      if (Ai(o) && Ai(s) || gt(o) && gt(s) || Array.isArray(o) && Array.isArray(s) ? !fi(o, s) : o !== s)
        return !1;
    }
  }
  return !0;
}
var Wt = (e) => gt(e) && !Object.keys(e).length, Jy = (e) => e.type === "file", wr = (e) => typeof e == "function", hl = (e) => {
  if (!Wy)
    return !1;
  const n = e ? e.ownerDocument : 0;
  return e instanceof (n && n.defaultView ? n.defaultView.HTMLElement : HTMLElement);
}, kC = (e) => e.type === "select-multiple", Qy = (e) => e.type === "radio", UT = (e) => Qy(e) || Zo(e), Id = (e) => hl(e) && e.isConnected;
function MT(e, n) {
  const r = n.slice(0, -1).length;
  let i = 0;
  for (; i < r; )
    e = ht(e) ? i++ : e[n[i++]];
  return e;
}
function BT(e) {
  for (const n in e)
    if (e.hasOwnProperty(n) && !ht(e[n]))
      return !1;
  return !0;
}
function Ct(e, n) {
  const r = Array.isArray(n) ? n : Ky(n) ? [n] : hC(n), i = r.length === 1 ? e : MT(e, r), a = r.length - 1, o = r[a];
  return i && delete i[o], a !== 0 && (gt(i) && Wt(i) || Array.isArray(i) && BT(i)) && Ct(e, r.slice(0, -1)), e;
}
var bC = (e) => {
  for (const n in e)
    if (wr(e[n]))
      return !0;
  return !1;
};
function yl(e, n = {}) {
  const r = Array.isArray(e);
  if (gt(e) || r)
    for (const i in e)
      Array.isArray(e[i]) || gt(e[i]) && !bC(e[i]) ? (n[i] = Array.isArray(e[i]) ? [] : {}, yl(e[i], n[i])) : Gt(e[i]) || (n[i] = !0);
  return n;
}
function _C(e, n, r) {
  const i = Array.isArray(e);
  if (gt(e) || i)
    for (const a in e)
      Array.isArray(e[a]) || gt(e[a]) && !bC(e[a]) ? ht(n) || Zh(r[a]) ? r[a] = Array.isArray(e[a]) ? yl(e[a], []) : { ...yl(e[a]) } : _C(e[a], Gt(n) ? {} : n[a], r[a]) : r[a] = !fi(e[a], n[a]);
  return r;
}
var Ha = (e, n) => _C(e, n, yl(n));
const Uv = {
  value: !1,
  isValid: !1
}, Mv = { value: !0, isValid: !0 };
var xC = (e) => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const n = e.filter((r) => r && r.checked && !r.disabled).map((r) => r.value);
      return { value: n, isValid: !!n.length };
    }
    return e[0].checked && !e[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      e[0].attributes && !ht(e[0].attributes.value) ? ht(e[0].value) || e[0].value === "" ? Mv : { value: e[0].value, isValid: !0 } : Mv
    ) : Uv;
  }
  return Uv;
}, SC = (e, { valueAsNumber: n, valueAsDate: r, setValueAs: i }) => ht(e) ? e : n ? e === "" ? NaN : e && +e : r && Br(e) ? new Date(e) : i ? i(e) : e;
const Bv = {
  isValid: !1,
  value: null
};
var NC = (e) => Array.isArray(e) ? e.reduce((n, r) => r && r.checked && !r.disabled ? {
  isValid: !0,
  value: r.value
} : n, Bv) : Bv;
function qv(e) {
  const n = e.ref;
  return Jy(n) ? n.files : Qy(n) ? NC(e.refs).value : kC(n) ? [...n.selectedOptions].map(({ value: r }) => r) : Zo(n) ? xC(e.refs).value : SC(ht(n.value) ? e.ref.value : n.value, e);
}
var qT = (e, n, r, i) => {
  const a = {};
  for (const o of e) {
    const s = nn(n, o);
    s && it(a, o, s._f);
  }
  return {
    criteriaMode: r,
    names: [...e],
    fields: a,
    shouldUseNativeValidation: i
  };
}, gl = (e) => e instanceof RegExp, Wa = (e) => ht(e) ? e : gl(e) ? e.source : gt(e) ? gl(e.value) ? e.value.source : e.value : e, Hv = (e) => ({
  isOnSubmit: !e || e === jr.onSubmit,
  isOnBlur: e === jr.onBlur,
  isOnChange: e === jr.onChange,
  isOnAll: e === jr.all,
  isOnTouch: e === jr.onTouched
});
const Wv = "AsyncFunction";
var HT = (e) => !!e && !!e.validate && !!(wr(e.validate) && e.validate.constructor.name === Wv || gt(e.validate) && Object.values(e.validate).find((n) => n.constructor.name === Wv)), WT = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate), Kv = (e, n, r) => !r && (n.watchAll || n.watch.has(e) || [...n.watch].some((i) => e.startsWith(i) && /^\.\w+/.test(e.slice(i.length))));
const To = (e, n, r, i) => {
  for (const a of r || Object.keys(e)) {
    const o = nn(e, a);
    if (o) {
      const { _f: s, ...l } = o;
      if (s) {
        if (s.refs && s.refs[0] && n(s.refs[0], a) && !i)
          return !0;
        if (s.ref && n(s.ref, s.name) && !i)
          return !0;
        if (To(l, n))
          break;
      } else if (gt(l) && To(l, n))
        break;
    }
  }
};
function Gv(e, n, r) {
  const i = nn(e, r);
  if (i || Ky(r))
    return {
      error: i,
      name: r
    };
  const a = r.split(".");
  for (; a.length; ) {
    const o = a.join("."), s = nn(n, o), l = nn(e, o);
    if (s && !Array.isArray(s) && r !== o)
      return { name: r };
    if (l && l.type)
      return {
        name: o,
        error: l
      };
    a.pop();
  }
  return {
    name: r
  };
}
var KT = (e, n, r, i) => {
  r(e);
  const { name: a, ...o } = e;
  return Wt(o) || Object.keys(o).length >= Object.keys(n).length || Object.keys(o).find((s) => n[s] === (!i || jr.all));
}, GT = (e, n, r) => !e || !n || e === n || Eo(e).some((i) => i && (r ? i === n : i.startsWith(n) || n.startsWith(i))), YT = (e, n, r, i, a) => a.isOnAll ? !1 : !r && a.isOnTouch ? !(n || e) : (r ? i.isOnBlur : a.isOnBlur) ? !e : (r ? i.isOnChange : a.isOnChange) ? e : !0, JT = (e, n) => !Xl(nn(e, n)).length && Ct(e, n), QT = (e, n, r) => {
  const i = Eo(nn(e, r));
  return it(i, "root", n[r]), it(e, r, i), e;
}, el = (e) => Br(e);
function Yv(e, n, r = "validate") {
  if (el(e) || Array.isArray(e) && e.every(el) || sr(e) && !e)
    return {
      type: r,
      message: el(e) ? e : "",
      ref: n
    };
}
var ea = (e) => gt(e) && !gl(e) ? e : {
  value: e,
  message: ""
}, Jv = async (e, n, r, i, a, o) => {
  const { ref: s, refs: l, required: c, maxLength: m, minLength: u, min: f, max: h, pattern: k, validate: w, name: N, valueAsNumber: j, mount: _ } = e._f, g = nn(r, N);
  if (!_ || n.has(N))
    return {};
  const O = l ? l[0] : s, R = (Y) => {
    a && O.reportValidity && (O.setCustomValidity(sr(Y) ? "" : Y || ""), O.reportValidity());
  }, F = {}, I = Qy(s), L = Zo(s), W = I || L, J = (j || Jy(s)) && ht(s.value) && ht(g) || hl(s) && s.value === "" || g === "" || Array.isArray(g) && !g.length, re = zT.bind(null, N, i, F), K = (Y, P, B, ie = Zr.maxLength, we = Zr.minLength) => {
    const me = Y ? P : B;
    F[N] = {
      type: Y ? ie : we,
      message: me,
      ref: s,
      ...re(Y ? ie : we, me)
    };
  };
  if (o ? !Array.isArray(g) || !g.length : c && (!W && (J || Gt(g)) || sr(g) && !g || L && !xC(l).isValid || I && !NC(l).isValid)) {
    const { value: Y, message: P } = el(c) ? { value: !!c, message: c } : ea(c);
    if (Y && (F[N] = {
      type: Zr.required,
      message: P,
      ref: O,
      ...re(Zr.required, P)
    }, !i))
      return R(P), F;
  }
  if (!J && (!Gt(f) || !Gt(h))) {
    let Y, P;
    const B = ea(h), ie = ea(f);
    if (!Gt(g) && !isNaN(g)) {
      const we = s.valueAsNumber || g && +g;
      Gt(B.value) || (Y = we > B.value), Gt(ie.value) || (P = we < ie.value);
    } else {
      const we = s.valueAsDate || new Date(g), me = (V) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + V), le = s.type == "time", ge = s.type == "week";
      Br(B.value) && g && (Y = le ? me(g) > me(B.value) : ge ? g > B.value : we > new Date(B.value)), Br(ie.value) && g && (P = le ? me(g) < me(ie.value) : ge ? g < ie.value : we < new Date(ie.value));
    }
    if ((Y || P) && (K(!!Y, B.message, ie.message, Zr.max, Zr.min), !i))
      return R(F[N].message), F;
  }
  if ((m || u) && !J && (Br(g) || o && Array.isArray(g))) {
    const Y = ea(m), P = ea(u), B = !Gt(Y.value) && g.length > +Y.value, ie = !Gt(P.value) && g.length < +P.value;
    if ((B || ie) && (K(B, Y.message, P.message), !i))
      return R(F[N].message), F;
  }
  if (k && !J && Br(g)) {
    const { value: Y, message: P } = ea(k);
    if (gl(Y) && !g.match(Y) && (F[N] = {
      type: Zr.pattern,
      message: P,
      ref: s,
      ...re(Zr.pattern, P)
    }, !i))
      return R(P), F;
  }
  if (w) {
    if (wr(w)) {
      const Y = await w(g, r), P = Yv(Y, O);
      if (P && (F[N] = {
        ...P,
        ...re(Zr.validate, P.message)
      }, !i))
        return R(P.message), F;
    } else if (gt(w)) {
      let Y = {};
      for (const P in w) {
        if (!Wt(Y) && !i)
          break;
        const B = Yv(await w[P](g, r), O, P);
        B && (Y = {
          ...B,
          ...re(P, B.message)
        }, R(B.message), i && (F[N] = Y));
      }
      if (!Wt(Y) && (F[N] = {
        ref: O,
        ...Y
      }, !i))
        return F;
    }
  }
  return R(!0), F;
};
const XT = {
  mode: jr.onSubmit,
  reValidateMode: jr.onChange,
  shouldFocusError: !0
};
function ZT(e = {}) {
  let n = {
    ...XT,
    ...e
  }, r = {
    submitCount: 0,
    isDirty: !1,
    isLoading: wr(n.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: n.errors || {},
    disabled: n.disabled || !1
  };
  const i = {};
  let a = gt(n.defaultValues) || gt(n.values) ? Ot(n.values || n.defaultValues) || {} : {}, o = n.shouldUnregister ? {} : Ot(a), s = {
    action: !1,
    mount: !1,
    watch: !1
  }, l = {
    mount: /* @__PURE__ */ new Set(),
    disabled: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, c, m = 0;
  const u = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  };
  let f = {
    ...u
  };
  const h = {
    array: zv(),
    state: zv()
  }, k = Hv(n.mode), w = Hv(n.reValidateMode), N = n.criteriaMode === jr.all, j = (E) => (z) => {
    clearTimeout(m), m = setTimeout(E, z);
  }, _ = async (E) => {
    if (!n.disabled && (u.isValid || f.isValid || E)) {
      const z = n.resolver ? Wt((await J()).errors) : await K(i, !0);
      z !== r.isValid && h.state.next({
        isValid: z
      });
    }
  }, g = (E, z) => {
    !n.disabled && (u.isValidating || u.validatingFields || f.isValidating || f.validatingFields) && ((E || Array.from(l.mount)).forEach((ae) => {
      ae && (z ? it(r.validatingFields, ae, z) : Ct(r.validatingFields, ae));
    }), h.state.next({
      validatingFields: r.validatingFields,
      isValidating: !Wt(r.validatingFields)
    }));
  }, O = (E, z = [], ae, ce, U = !0, G = !0) => {
    if (ce && ae && !n.disabled) {
      if (s.action = !0, G && Array.isArray(nn(i, E))) {
        const ve = ae(nn(i, E), ce.argA, ce.argB);
        U && it(i, E, ve);
      }
      if (G && Array.isArray(nn(r.errors, E))) {
        const ve = ae(nn(r.errors, E), ce.argA, ce.argB);
        U && it(r.errors, E, ve), JT(r.errors, E);
      }
      if ((u.touchedFields || f.touchedFields) && G && Array.isArray(nn(r.touchedFields, E))) {
        const ve = ae(nn(r.touchedFields, E), ce.argA, ce.argB);
        U && it(r.touchedFields, E, ve);
      }
      (u.dirtyFields || f.dirtyFields) && (r.dirtyFields = Ha(a, o)), h.state.next({
        name: E,
        isDirty: P(E, z),
        dirtyFields: r.dirtyFields,
        errors: r.errors,
        isValid: r.isValid
      });
    } else
      it(o, E, z);
  }, R = (E, z) => {
    it(r.errors, E, z), h.state.next({
      errors: r.errors
    });
  }, F = (E) => {
    r.errors = E, h.state.next({
      errors: r.errors,
      isValid: !1
    });
  }, I = (E, z, ae, ce) => {
    const U = nn(i, E);
    if (U) {
      const G = nn(o, E, ht(ae) ? nn(a, E) : ae);
      ht(G) || ce && ce.defaultChecked || z ? it(o, E, z ? G : qv(U._f)) : we(E, G), s.mount && _();
    }
  }, L = (E, z, ae, ce, U) => {
    let G = !1, ve = !1;
    const je = {
      name: E
    };
    if (!n.disabled) {
      if (!ae || ce) {
        (u.isDirty || f.isDirty) && (ve = r.isDirty, r.isDirty = je.isDirty = P(), G = ve !== je.isDirty);
        const Re = fi(nn(a, E), z);
        ve = !!nn(r.dirtyFields, E), Re ? Ct(r.dirtyFields, E) : it(r.dirtyFields, E, !0), je.dirtyFields = r.dirtyFields, G = G || (u.dirtyFields || f.dirtyFields) && ve !== !Re;
      }
      if (ae) {
        const Re = nn(r.touchedFields, E);
        Re || (it(r.touchedFields, E, ae), je.touchedFields = r.touchedFields, G = G || (u.touchedFields || f.touchedFields) && Re !== ae);
      }
      G && U && h.state.next(je);
    }
    return G ? je : {};
  }, W = (E, z, ae, ce) => {
    const U = nn(r.errors, E), G = (u.isValid || f.isValid) && sr(z) && r.isValid !== z;
    if (n.delayError && ae ? (c = j(() => R(E, ae)), c(n.delayError)) : (clearTimeout(m), c = null, ae ? it(r.errors, E, ae) : Ct(r.errors, E)), (ae ? !fi(U, ae) : U) || !Wt(ce) || G) {
      const ve = {
        ...ce,
        ...G && sr(z) ? { isValid: z } : {},
        errors: r.errors,
        name: E
      };
      r = {
        ...r,
        ...ve
      }, h.state.next(ve);
    }
  }, J = async (E) => {
    g(E, !0);
    const z = await n.resolver(o, n.context, qT(E || l.mount, i, n.criteriaMode, n.shouldUseNativeValidation));
    return g(E), z;
  }, re = async (E) => {
    const { errors: z } = await J(E);
    if (E)
      for (const ae of E) {
        const ce = nn(z, ae);
        ce ? it(r.errors, ae, ce) : Ct(r.errors, ae);
      }
    else
      r.errors = z;
    return z;
  }, K = async (E, z, ae = {
    valid: !0
  }) => {
    for (const ce in E) {
      const U = E[ce];
      if (U) {
        const { _f: G, ...ve } = U;
        if (G) {
          const je = l.array.has(G.name), Re = U._f && HT(U._f);
          Re && u.validatingFields && g([ce], !0);
          const rn = await Jv(U, l.disabled, o, N, n.shouldUseNativeValidation && !z, je);
          if (Re && u.validatingFields && g([ce]), rn[G.name] && (ae.valid = !1, z))
            break;
          !z && (nn(rn, G.name) ? je ? QT(r.errors, rn, G.name) : it(r.errors, G.name, rn[G.name]) : Ct(r.errors, G.name));
        }
        !Wt(ve) && await K(ve, z, ae);
      }
    }
    return ae.valid;
  }, Y = () => {
    for (const E of l.unMount) {
      const z = nn(i, E);
      z && (z._f.refs ? z._f.refs.every((ae) => !Id(ae)) : !Id(z._f.ref)) && Be(E);
    }
    l.unMount = /* @__PURE__ */ new Set();
  }, P = (E, z) => !n.disabled && (E && z && it(o, E, z), !fi(Oe(), a)), B = (E, z, ae) => vC(E, l, {
    ...s.mount ? o : ht(z) ? a : Br(E) ? { [E]: z } : z
  }, ae, z), ie = (E) => Xl(nn(s.mount ? o : a, E, n.shouldUnregister ? nn(a, E, []) : [])), we = (E, z, ae = {}) => {
    const ce = nn(i, E);
    let U = z;
    if (ce) {
      const G = ce._f;
      G && (!G.disabled && it(o, E, SC(z, G)), U = hl(G.ref) && Gt(z) ? "" : z, kC(G.ref) ? [...G.ref.options].forEach((ve) => ve.selected = U.includes(ve.value)) : G.refs ? Zo(G.ref) ? G.refs.length > 1 ? G.refs.forEach((ve) => (!ve.defaultChecked || !ve.disabled) && (ve.checked = Array.isArray(U) ? !!U.find((je) => je === ve.value) : U === ve.value)) : G.refs[0] && (G.refs[0].checked = !!U) : G.refs.forEach((ve) => ve.checked = ve.value === U) : Jy(G.ref) ? G.ref.value = "" : (G.ref.value = U, G.ref.type || h.state.next({
        name: E,
        values: Ot(o)
      })));
    }
    (ae.shouldDirty || ae.shouldTouch) && L(E, U, ae.shouldTouch, ae.shouldDirty, !0), ae.shouldValidate && be(E);
  }, me = (E, z, ae) => {
    for (const ce in z) {
      const U = z[ce], G = `${E}.${ce}`, ve = nn(i, G);
      (l.array.has(E) || gt(U) || ve && !ve._f) && !Ai(U) ? me(G, U, ae) : we(G, U, ae);
    }
  }, le = (E, z, ae = {}) => {
    const ce = nn(i, E), U = l.array.has(E), G = Ot(z);
    it(o, E, G), U ? (h.array.next({
      name: E,
      values: Ot(o)
    }), (u.isDirty || u.dirtyFields || f.isDirty || f.dirtyFields) && ae.shouldDirty && h.state.next({
      name: E,
      dirtyFields: Ha(a, o),
      isDirty: P(E, G)
    })) : ce && !ce._f && !Gt(G) ? me(E, G, ae) : we(E, G, ae), Kv(E, l) && h.state.next({ ...r }), h.state.next({
      name: s.mount ? E : void 0,
      values: Ot(o)
    });
  }, ge = async (E) => {
    s.mount = !0;
    const z = E.target;
    let ae = z.name, ce = !0;
    const U = nn(i, ae), G = (ve) => {
      ce = Number.isNaN(ve) || Ai(ve) && isNaN(ve.getTime()) || fi(ve, nn(o, ae, ve));
    };
    if (U) {
      let ve, je;
      const Re = z.type ? qv(U._f) : pC(E), rn = E.type === fl.BLUR || E.type === fl.FOCUS_OUT, bn = !WT(U._f) && !n.resolver && !nn(r.errors, ae) && !U._f.deps || YT(rn, nn(r.touchedFields, ae), r.isSubmitted, w, k), an = Kv(ae, l, rn);
      it(o, ae, Re), rn ? (U._f.onBlur && U._f.onBlur(E), c && c(0)) : U._f.onChange && U._f.onChange(E);
      const fn = L(ae, Re, rn), En = !Wt(fn) || an;
      if (!rn && h.state.next({
        name: ae,
        type: E.type,
        values: Ot(o)
      }), bn)
        return (u.isValid || f.isValid) && (n.mode === "onBlur" ? rn && _() : rn || _()), En && h.state.next({ name: ae, ...an ? {} : fn });
      if (!rn && an && h.state.next({ ...r }), n.resolver) {
        const { errors: _n } = await J([ae]);
        if (G(Re), ce) {
          const Fn = Gv(r.errors, i, ae), Ze = Gv(_n, i, Fn.name || ae);
          ve = Ze.error, ae = Ze.name, je = Wt(_n);
        }
      } else
        g([ae], !0), ve = (await Jv(U, l.disabled, o, N, n.shouldUseNativeValidation))[ae], g([ae]), G(Re), ce && (ve ? je = !1 : (u.isValid || f.isValid) && (je = await K(i, !0)));
      ce && (U._f.deps && be(U._f.deps), W(ae, je, ve, fn));
    }
  }, V = (E, z) => {
    if (nn(r.errors, z) && E.focus)
      return E.focus(), 1;
  }, be = async (E, z = {}) => {
    let ae, ce;
    const U = Eo(E);
    if (n.resolver) {
      const G = await re(ht(E) ? E : U);
      ae = Wt(G), ce = E ? !U.some((ve) => nn(G, ve)) : ae;
    } else E ? (ce = (await Promise.all(U.map(async (G) => {
      const ve = nn(i, G);
      return await K(ve && ve._f ? { [G]: ve } : ve);
    }))).every(Boolean), !(!ce && !r.isValid) && _()) : ce = ae = await K(i);
    return h.state.next({
      ...!Br(E) || (u.isValid || f.isValid) && ae !== r.isValid ? {} : { name: E },
      ...n.resolver || !E ? { isValid: ae } : {},
      errors: r.errors
    }), z.shouldFocus && !ce && To(i, V, E ? U : l.mount), ce;
  }, Oe = (E) => {
    const z = {
      ...s.mount ? o : a
    };
    return ht(E) ? z : Br(E) ? nn(z, E) : E.map((ae) => nn(z, ae));
  }, q = (E, z) => ({
    invalid: !!nn((z || r).errors, E),
    isDirty: !!nn((z || r).dirtyFields, E),
    error: nn((z || r).errors, E),
    isValidating: !!nn(r.validatingFields, E),
    isTouched: !!nn((z || r).touchedFields, E)
  }), Ge = (E) => {
    E && Eo(E).forEach((z) => Ct(r.errors, z)), h.state.next({
      errors: E ? r.errors : {}
    });
  }, sn = (E, z, ae) => {
    const ce = (nn(i, E, { _f: {} })._f || {}).ref, U = nn(r.errors, E) || {}, { ref: G, message: ve, type: je, ...Re } = U;
    it(r.errors, E, {
      ...Re,
      ...z,
      ref: ce
    }), h.state.next({
      name: E,
      errors: r.errors,
      isValid: !1
    }), ae && ae.shouldFocus && ce && ce.focus && ce.focus();
  }, Ie = (E, z) => wr(E) ? h.state.subscribe({
    next: (ae) => E(B(void 0, z), ae)
  }) : B(E, z, !0), Ue = (E) => h.state.subscribe({
    next: (z) => {
      GT(E.name, z.name, E.exact) && KT(z, E.formState || u, Pe, E.reRenderRoot) && E.callback({
        values: { ...o },
        ...r,
        ...z
      });
    }
  }).unsubscribe, De = (E) => (s.mount = !0, f = {
    ...f,
    ...E.formState
  }, Ue({
    ...E,
    formState: f
  })), Be = (E, z = {}) => {
    for (const ae of E ? Eo(E) : l.mount)
      l.mount.delete(ae), l.array.delete(ae), z.keepValue || (Ct(i, ae), Ct(o, ae)), !z.keepError && Ct(r.errors, ae), !z.keepDirty && Ct(r.dirtyFields, ae), !z.keepTouched && Ct(r.touchedFields, ae), !z.keepIsValidating && Ct(r.validatingFields, ae), !n.shouldUnregister && !z.keepDefaultValue && Ct(a, ae);
    h.state.next({
      values: Ot(o)
    }), h.state.next({
      ...r,
      ...z.keepDirty ? { isDirty: P() } : {}
    }), !z.keepIsValid && _();
  }, Ae = ({ disabled: E, name: z }) => {
    (sr(E) && s.mount || E || l.disabled.has(z)) && (E ? l.disabled.add(z) : l.disabled.delete(z));
  }, Je = (E, z = {}) => {
    let ae = nn(i, E);
    const ce = sr(z.disabled) || sr(n.disabled);
    return it(i, E, {
      ...ae || {},
      _f: {
        ...ae && ae._f ? ae._f : { ref: { name: E } },
        name: E,
        mount: !0,
        ...z
      }
    }), l.mount.add(E), ae ? Ae({
      disabled: sr(z.disabled) ? z.disabled : n.disabled,
      name: E
    }) : I(E, !0, z.value), {
      ...ce ? { disabled: z.disabled || n.disabled } : {},
      ...n.progressive ? {
        required: !!z.required,
        min: Wa(z.min),
        max: Wa(z.max),
        minLength: Wa(z.minLength),
        maxLength: Wa(z.maxLength),
        pattern: Wa(z.pattern)
      } : {},
      name: E,
      onChange: ge,
      onBlur: ge,
      ref: (U) => {
        if (U) {
          Je(E, z), ae = nn(i, E);
          const G = ht(U.value) && U.querySelectorAll && U.querySelectorAll("input,select,textarea")[0] || U, ve = UT(G), je = ae._f.refs || [];
          if (ve ? je.find((Re) => Re === G) : G === ae._f.ref)
            return;
          it(i, E, {
            _f: {
              ...ae._f,
              ...ve ? {
                refs: [
                  ...je.filter(Id),
                  G,
                  ...Array.isArray(nn(a, E)) ? [{}] : []
                ],
                ref: { type: G.type, name: E }
              } : { ref: G }
            }
          }), I(E, !1, void 0, G);
        } else
          ae = nn(i, E, {}), ae._f && (ae._f.mount = !1), (n.shouldUnregister || z.shouldUnregister) && !(fC(l.array, E) && s.action) && l.unMount.add(E);
      }
    };
  }, Ee = () => n.shouldFocusError && To(i, V, l.mount), Me = (E) => {
    sr(E) && (h.state.next({ disabled: E }), To(i, (z, ae) => {
      const ce = nn(i, ae);
      ce && (z.disabled = ce._f.disabled || E, Array.isArray(ce._f.refs) && ce._f.refs.forEach((U) => {
        U.disabled = ce._f.disabled || E;
      }));
    }, 0, !1));
  }, en = (E, z) => async (ae) => {
    let ce;
    ae && (ae.preventDefault && ae.preventDefault(), ae.persist && ae.persist());
    let U = Ot(o);
    if (h.state.next({
      isSubmitting: !0
    }), n.resolver) {
      const { errors: G, values: ve } = await J();
      r.errors = G, U = ve;
    } else
      await K(i);
    if (l.disabled.size)
      for (const G of l.disabled)
        it(U, G, void 0);
    if (Ct(r.errors, "root"), Wt(r.errors)) {
      h.state.next({
        errors: {}
      });
      try {
        await E(U, ae);
      } catch (G) {
        ce = G;
      }
    } else
      z && await z({ ...r.errors }, ae), Ee(), setTimeout(Ee);
    if (h.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: Wt(r.errors) && !ce,
      submitCount: r.submitCount + 1,
      errors: r.errors
    }), ce)
      throw ce;
  }, se = (E, z = {}) => {
    nn(i, E) && (ht(z.defaultValue) ? le(E, Ot(nn(a, E))) : (le(E, z.defaultValue), it(a, E, Ot(z.defaultValue))), z.keepTouched || Ct(r.touchedFields, E), z.keepDirty || (Ct(r.dirtyFields, E), r.isDirty = z.defaultValue ? P(E, Ot(nn(a, E))) : P()), z.keepError || (Ct(r.errors, E), u.isValid && _()), h.state.next({ ...r }));
  }, de = (E, z = {}) => {
    const ae = E ? Ot(E) : a, ce = Ot(ae), U = Wt(E), G = U ? a : ce;
    if (z.keepDefaultValues || (a = ae), !z.keepValues) {
      if (z.keepDirtyValues) {
        const ve = /* @__PURE__ */ new Set([
          ...l.mount,
          ...Object.keys(Ha(a, o))
        ]);
        for (const je of Array.from(ve))
          nn(r.dirtyFields, je) ? it(G, je, nn(o, je)) : le(je, nn(G, je));
      } else {
        if (Wy && ht(E))
          for (const ve of l.mount) {
            const je = nn(i, ve);
            if (je && je._f) {
              const Re = Array.isArray(je._f.refs) ? je._f.refs[0] : je._f.ref;
              if (hl(Re)) {
                const rn = Re.closest("form");
                if (rn) {
                  rn.reset();
                  break;
                }
              }
            }
          }
        for (const ve of l.mount)
          le(ve, nn(G, ve));
      }
      o = Ot(G), h.array.next({
        values: { ...G }
      }), h.state.next({
        values: { ...G }
      });
    }
    l = {
      mount: z.keepDirtyValues ? l.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      disabled: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, s.mount = !u.isValid || !!z.keepIsValid || !!z.keepDirtyValues, s.watch = !!n.shouldUnregister, h.state.next({
      submitCount: z.keepSubmitCount ? r.submitCount : 0,
      isDirty: U ? !1 : z.keepDirty ? r.isDirty : !!(z.keepDefaultValues && !fi(E, a)),
      isSubmitted: z.keepIsSubmitted ? r.isSubmitted : !1,
      dirtyFields: U ? {} : z.keepDirtyValues ? z.keepDefaultValues && o ? Ha(a, o) : r.dirtyFields : z.keepDefaultValues && E ? Ha(a, E) : z.keepDirty ? r.dirtyFields : {},
      touchedFields: z.keepTouched ? r.touchedFields : {},
      errors: z.keepErrors ? r.errors : {},
      isSubmitSuccessful: z.keepIsSubmitSuccessful ? r.isSubmitSuccessful : !1,
      isSubmitting: !1
    });
  }, Se = (E, z) => de(wr(E) ? E(o) : E, z), Ve = (E, z = {}) => {
    const ae = nn(i, E), ce = ae && ae._f;
    if (ce) {
      const U = ce.refs ? ce.refs[0] : ce.ref;
      U.focus && (U.focus(), z.shouldSelect && wr(U.select) && U.select());
    }
  }, Pe = (E) => {
    r = {
      ...r,
      ...E
    };
  }, Q = {
    control: {
      register: Je,
      unregister: Be,
      getFieldState: q,
      handleSubmit: en,
      setError: sn,
      _subscribe: Ue,
      _runSchema: J,
      _getWatch: B,
      _getDirty: P,
      _setValid: _,
      _setFieldArray: O,
      _setDisabledField: Ae,
      _setErrors: F,
      _getFieldArray: ie,
      _reset: de,
      _resetDefaultValues: () => wr(n.defaultValues) && n.defaultValues().then((E) => {
        Se(E, n.resetOptions), h.state.next({
          isLoading: !1
        });
      }),
      _removeUnmounted: Y,
      _disableForm: Me,
      _subjects: h,
      _proxyFormState: u,
      get _fields() {
        return i;
      },
      get _formValues() {
        return o;
      },
      get _state() {
        return s;
      },
      set _state(E) {
        s = E;
      },
      get _defaultValues() {
        return a;
      },
      get _names() {
        return l;
      },
      set _names(E) {
        l = E;
      },
      get _formState() {
        return r;
      },
      get _options() {
        return n;
      },
      set _options(E) {
        n = {
          ...n,
          ...E
        };
      }
    },
    subscribe: De,
    trigger: be,
    register: Je,
    handleSubmit: en,
    watch: Ie,
    setValue: le,
    getValues: Oe,
    reset: Se,
    resetField: se,
    clearErrors: Ge,
    unregister: Be,
    setError: sn,
    setFocus: Ve,
    getFieldState: q
  };
  return {
    ...Q,
    formControl: Q
  };
}
function ut(e = {}) {
  const n = qe.useRef(void 0), r = qe.useRef(void 0), [i, a] = qe.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: wr(e.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: e.errors || {},
    disabled: e.disabled || !1,
    defaultValues: wr(e.defaultValues) ? void 0 : e.defaultValues
  });
  n.current || (n.current = {
    ...e.formControl ? e.formControl : ZT(e),
    formState: i
  }, e.formControl && e.defaultValues && !wr(e.defaultValues) && e.formControl.reset(e.defaultValues, e.resetOptions));
  const o = n.current.control;
  return o._options = e, qe.useLayoutEffect(() => o._subscribe({
    formState: o._proxyFormState,
    callback: () => a({ ...o._formState }),
    reRenderRoot: !0
  }), [o]), qe.useEffect(() => o._disableForm(e.disabled), [o, e.disabled]), qe.useEffect(() => {
    if (o._proxyFormState.isDirty) {
      const s = o._getDirty();
      s !== i.isDirty && o._subjects.state.next({
        isDirty: s
      });
    }
  }, [o, i.isDirty]), qe.useEffect(() => {
    e.values && !fi(e.values, r.current) ? (o._reset(e.values, o._options.resetOptions), r.current = e.values, a((s) => ({ ...s }))) : o._resetDefaultValues();
  }, [e.values, o]), qe.useEffect(() => {
    e.errors && !Wt(e.errors) && o._setErrors(e.errors);
  }, [e.errors, o]), qe.useEffect(() => {
    o._state.mount || (o._setValid(), o._state.mount = !0), o._state.watch && (o._state.watch = !1, o._subjects.state.next({ ...o._formState })), o._removeUnmounted();
  }), qe.useEffect(() => {
    e.shouldUnregister && o._subjects.state.next({
      values: o._getWatch()
    });
  }, [e.shouldUnregister, o]), n.current.formState = gC(i, o), n.current;
}
var ps = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function jC(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var $d = { exports: {} }, Ka = {}, Qv;
function eR() {
  if (Qv) return Ka;
  Qv = 1;
  var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, c, m) {
    var u, f = {}, h = null, k = null;
    m !== void 0 && (h = "" + m), c.key !== void 0 && (h = "" + c.key), c.ref !== void 0 && (k = c.ref);
    for (u in c) i.call(c, u) && !o.hasOwnProperty(u) && (f[u] = c[u]);
    if (l && l.defaultProps) for (u in c = l.defaultProps, c) f[u] === void 0 && (f[u] = c[u]);
    return { $$typeof: n, type: l, key: h, ref: k, props: f, _owner: a.current };
  }
  return Ka.Fragment = r, Ka.jsx = s, Ka.jsxs = s, Ka;
}
var fs = {}, Xv;
function nR() {
  return Xv || (Xv = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), c = /* @__PURE__ */ Symbol.for("react.forward_ref"), m = /* @__PURE__ */ Symbol.for("react.suspense"), u = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), k = /* @__PURE__ */ Symbol.for("react.offscreen"), w = Symbol.iterator, N = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var d = w && t[w] || t[N];
      return typeof d == "function" ? d : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var d = arguments.length, p = new Array(d > 1 ? d - 1 : 0), y = 1; y < d; y++)
          p[y - 1] = arguments[y];
        O("error", t, p);
      }
    }
    function O(t, d, p) {
      {
        var y = _.ReactDebugCurrentFrame, C = y.getStackAddendum();
        C !== "" && (d += "%s", p = p.concat([C]));
        var T = p.map(function(S) {
          return String(S);
        });
        T.unshift("Warning: " + d), Function.prototype.apply.call(console[t], console, T);
      }
    }
    var R = !1, F = !1, I = !1, L = !1, W = !1, J;
    J = /* @__PURE__ */ Symbol.for("react.module.reference");
    function re(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || W || t === a || t === m || t === u || L || t === k || R || F || I || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === J || t.getModuleId !== void 0));
    }
    function K(t, d, p) {
      var y = t.displayName;
      if (y)
        return y;
      var C = d.displayName || d.name || "";
      return C !== "" ? p + "(" + C + ")" : p;
    }
    function Y(t) {
      return t.displayName || "Context";
    }
    function P(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var d = t;
            return Y(d) + ".Consumer";
          case s:
            var p = t;
            return Y(p._context) + ".Provider";
          case c:
            return K(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : P(t.type) || "Memo";
          case h: {
            var C = t, T = C._payload, S = C._init;
            try {
              return P(S(T));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, ie = 0, we, me, le, ge, V, be, Oe;
    function q() {
    }
    q.__reactDisabledLog = !0;
    function Ge() {
      {
        if (ie === 0) {
          we = console.log, me = console.info, le = console.warn, ge = console.error, V = console.group, be = console.groupCollapsed, Oe = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: q,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ie++;
      }
    }
    function sn() {
      {
        if (ie--, ie === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, t, {
              value: we
            }),
            info: B({}, t, {
              value: me
            }),
            warn: B({}, t, {
              value: le
            }),
            error: B({}, t, {
              value: ge
            }),
            group: B({}, t, {
              value: V
            }),
            groupCollapsed: B({}, t, {
              value: be
            }),
            groupEnd: B({}, t, {
              value: Oe
            })
          });
        }
        ie < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ie = _.ReactCurrentDispatcher, Ue;
    function De(t, d, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (C) {
            var y = C.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Ae;
    {
      var Je = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Je();
    }
    function Ee(t, d) {
      if (!t || Be)
        return "";
      {
        var p = Ae.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Be = !0;
      var C = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var T;
      T = Ie.current, Ie.current = null, Ge();
      try {
        if (d) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (ne) {
              y = ne;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (ne) {
              y = ne;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            y = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && y && typeof ne.stack == "string") {
          for (var x = ne.stack.split(`
`), Z = y.stack.split(`
`), A = x.length - 1, M = Z.length - 1; A >= 1 && M >= 0 && x[A] !== Z[M]; )
            M--;
          for (; A >= 1 && M >= 0; A--, M--)
            if (x[A] !== Z[M]) {
              if (A !== 1 || M !== 1)
                do
                  if (A--, M--, M < 0 || x[A] !== Z[M]) {
                    var ue = `
` + x[A].replace(" at new ", " at ");
                    return t.displayName && ue.includes("<anonymous>") && (ue = ue.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, ue), ue;
                  }
                while (A >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Ie.current = T, sn(), Error.prepareStackTrace = C;
      }
      var ze = t ? t.displayName || t.name : "", Te = ze ? De(ze) : "";
      return typeof t == "function" && Ae.set(t, Te), Te;
    }
    function Me(t, d, p) {
      return Ee(t, !1);
    }
    function en(t) {
      var d = t.prototype;
      return !!(d && d.isReactComponent);
    }
    function se(t, d, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ee(t, en(t));
      if (typeof t == "string")
        return De(t);
      switch (t) {
        case m:
          return De("Suspense");
        case u:
          return De("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case c:
            return Me(t.render);
          case f:
            return se(t.type, d, p);
          case h: {
            var y = t, C = y._payload, T = y._init;
            try {
              return se(T(C), d, p);
            } catch {
            }
          }
        }
      return "";
    }
    var de = Object.prototype.hasOwnProperty, Se = {}, Ve = _.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var d = t._owner, p = se(t.type, t._source, d ? d.type : null);
        Ve.setExtraStackFrame(p);
      } else
        Ve.setExtraStackFrame(null);
    }
    function kn(t, d, p, y, C) {
      {
        var T = Function.call.bind(de);
        for (var S in t)
          if (T(t, S)) {
            var x = void 0;
            try {
              if (typeof t[S] != "function") {
                var Z = Error((y || "React class") + ": " + p + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Z.name = "Invariant Violation", Z;
              }
              x = t[S](d, S, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (A) {
              x = A;
            }
            x && !(x instanceof Error) && (Pe(C), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, S, typeof x), Pe(null)), x instanceof Error && !(x.message in Se) && (Se[x.message] = !0, Pe(C), g("Failed %s type: %s", p, x.message), Pe(null));
          }
      }
    }
    var Q = Array.isArray;
    function E(t) {
      return Q(t);
    }
    function z(t) {
      {
        var d = typeof Symbol == "function" && Symbol.toStringTag, p = d && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function ae(t) {
      try {
        return ce(t), !1;
      } catch {
        return !0;
      }
    }
    function ce(t) {
      return "" + t;
    }
    function U(t) {
      if (ae(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", z(t)), ce(t);
    }
    var G = _.ReactCurrentOwner, ve = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, je, Re;
    function rn(t) {
      if (de.call(t, "ref")) {
        var d = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (d && d.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function bn(t) {
      if (de.call(t, "key")) {
        var d = Object.getOwnPropertyDescriptor(t, "key").get;
        if (d && d.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function an(t, d) {
      typeof t.ref == "string" && G.current;
    }
    function fn(t, d) {
      {
        var p = function() {
          je || (je = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", d));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function En(t, d) {
      {
        var p = function() {
          Re || (Re = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", d));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var _n = function(t, d, p, y, C, T, S) {
      var x = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: d,
        ref: p,
        props: S,
        // Record the component responsible for creating this element.
        _owner: T
      };
      return x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(x, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(x, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: C
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    };
    function Fn(t, d, p, y, C) {
      {
        var T, S = {}, x = null, Z = null;
        p !== void 0 && (U(p), x = "" + p), bn(d) && (U(d.key), x = "" + d.key), rn(d) && (Z = d.ref, an(d));
        for (T in d)
          de.call(d, T) && !ve.hasOwnProperty(T) && (S[T] = d[T]);
        if (t && t.defaultProps) {
          var A = t.defaultProps;
          for (T in A)
            S[T] === void 0 && (S[T] = A[T]);
        }
        if (x || Z) {
          var M = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          x && fn(S, M), Z && En(S, M);
        }
        return _n(t, x, Z, C, y, G.current, S);
      }
    }
    var Ze = _.ReactCurrentOwner, gn = _.ReactDebugCurrentFrame;
    function Le(t) {
      if (t) {
        var d = t._owner, p = se(t.type, t._source, d ? d.type : null);
        gn.setExtraStackFrame(p);
      } else
        gn.setExtraStackFrame(null);
    }
    var dn;
    dn = !1;
    function cn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function Nn() {
      {
        if (Ze.current) {
          var t = P(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Bn(t) {
      return "";
    }
    var Sn = {};
    function An(t) {
      {
        var d = Nn();
        if (!d) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (d = `

Check the top-level render call using <` + p + ">.");
        }
        return d;
      }
    }
    function vn(t, d) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = An(d);
        if (Sn[p])
          return;
        Sn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Ze.current && (y = " It was passed a child from " + P(t._owner.type) + "."), Le(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Le(null);
      }
    }
    function xn(t, d) {
      {
        if (typeof t != "object")
          return;
        if (E(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            cn(y) && vn(y, d);
          }
        else if (cn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var C = j(t);
          if (typeof C == "function" && C !== t.entries)
            for (var T = C.call(t), S; !(S = T.next()).done; )
              cn(S.value) && vn(S.value, d);
        }
      }
    }
    function Ln(t) {
      {
        var d = t.type;
        if (d == null || typeof d == "string")
          return;
        var p;
        if (typeof d == "function")
          p = d.propTypes;
        else if (typeof d == "object" && (d.$$typeof === c || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        d.$$typeof === f))
          p = d.propTypes;
        else
          return;
        if (p) {
          var y = P(d);
          kn(p, t.props, "prop", y, t);
        } else if (d.PropTypes !== void 0 && !dn) {
          dn = !0;
          var C = P(d);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", C || "Unknown");
        }
        typeof d.getDefaultProps == "function" && !d.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var d = Object.keys(t.props), p = 0; p < d.length; p++) {
          var y = d[p];
          if (y !== "children" && y !== "key") {
            Le(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Le(null);
            break;
          }
        }
        t.ref !== null && (Le(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Le(null));
      }
    }
    var Cn = {};
    function wn(t, d, p, y, C, T) {
      {
        var S = re(t);
        if (!S) {
          var x = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (x += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Z = Bn();
          Z ? x += Z : x += Nn();
          var A;
          t === null ? A = "null" : E(t) ? A = "array" : t !== void 0 && t.$$typeof === n ? (A = "<" + (P(t.type) || "Unknown") + " />", x = " Did you accidentally export a JSX literal instead of a component?") : A = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", A, x);
        }
        var M = Fn(t, d, p, C, T);
        if (M == null)
          return M;
        if (S) {
          var ue = d.children;
          if (ue !== void 0)
            if (y)
              if (E(ue)) {
                for (var ze = 0; ze < ue.length; ze++)
                  xn(ue[ze], t);
                Object.freeze && Object.freeze(ue);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              xn(ue, t);
        }
        if (de.call(d, "key")) {
          var Te = P(t), ne = Object.keys(d).filter(function(Kn) {
            return Kn !== "key";
          }), un = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Cn[Te + un]) {
            var Rn = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, un, Te, Rn, Te), Cn[Te + un] = !0;
          }
        }
        return t === i ? Vn(M) : Ln(M), M;
      }
    }
    function zn(t, d, p) {
      return wn(t, d, p, !0);
    }
    function qn(t, d, p) {
      return wn(t, d, p, !1);
    }
    var Un = qn, Wn = zn;
    fs.Fragment = i, fs.jsx = Un, fs.jsxs = Wn;
  })()), fs;
}
var Zv;
function tR() {
  return Zv || (Zv = 1, process.env.NODE_ENV === "production" ? $d.exports = eR() : $d.exports = nR()), $d.exports;
}
var zi = tR();
function rR(e) {
  return !e || typeof e == "boolean" || typeof e == "string" ? !!e : e.value;
}
var Ed, ek;
function ki() {
  if (ek) return Ed;
  ek = 1;
  var e = Array.isArray;
  return Ed = e, Ed;
}
var Td, nk;
function wC() {
  if (nk) return Td;
  nk = 1;
  var e = typeof ps == "object" && ps && ps.Object === Object && ps;
  return Td = e, Td;
}
var Rd, tk;
function Gr() {
  if (tk) return Rd;
  tk = 1;
  var e = wC(), n = typeof self == "object" && self && self.Object === Object && self, r = e || n || Function("return this")();
  return Rd = r, Rd;
}
var Dd, rk;
function es() {
  if (rk) return Dd;
  rk = 1;
  var e = Gr(), n = e.Symbol;
  return Dd = n, Dd;
}
var Od, ik;
function iR() {
  if (ik) return Od;
  ik = 1;
  var e = es(), n = Object.prototype, r = n.hasOwnProperty, i = n.toString, a = e ? e.toStringTag : void 0;
  function o(s) {
    var l = r.call(s, a), c = s[a];
    try {
      s[a] = void 0;
      var m = !0;
    } catch {
    }
    var u = i.call(s);
    return m && (l ? s[a] = c : delete s[a]), u;
  }
  return Od = o, Od;
}
var Pd, ak;
function aR() {
  if (ak) return Pd;
  ak = 1;
  var e = Object.prototype, n = e.toString;
  function r(i) {
    return n.call(i);
  }
  return Pd = r, Pd;
}
var Ad, ok;
function Ea() {
  if (ok) return Ad;
  ok = 1;
  var e = es(), n = iR(), r = aR(), i = "[object Null]", a = "[object Undefined]", o = e ? e.toStringTag : void 0;
  function s(l) {
    return l == null ? l === void 0 ? a : i : o && o in Object(l) ? n(l) : r(l);
  }
  return Ad = s, Ad;
}
var Ld, sk;
function Wi() {
  if (sk) return Ld;
  sk = 1;
  function e(n) {
    return n != null && typeof n == "object";
  }
  return Ld = e, Ld;
}
var Vd, lk;
function Xy() {
  if (lk) return Vd;
  lk = 1;
  var e = Ea(), n = Wi(), r = "[object Symbol]";
  function i(a) {
    return typeof a == "symbol" || n(a) && e(a) == r;
  }
  return Vd = i, Vd;
}
var zd, dk;
function oR() {
  if (dk) return zd;
  dk = 1;
  var e = ki(), n = Xy(), r = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, i = /^\w*$/;
  function a(o, s) {
    if (e(o))
      return !1;
    var l = typeof o;
    return l == "number" || l == "symbol" || l == "boolean" || o == null || n(o) ? !0 : i.test(o) || !r.test(o) || s != null && o in Object(s);
  }
  return zd = a, zd;
}
var Ud, ck;
function Ta() {
  if (ck) return Ud;
  ck = 1;
  function e(n) {
    var r = typeof n;
    return n != null && (r == "object" || r == "function");
  }
  return Ud = e, Ud;
}
var Md, uk;
function CC() {
  if (uk) return Md;
  uk = 1;
  var e = Ea(), n = Ta(), r = "[object AsyncFunction]", i = "[object Function]", a = "[object GeneratorFunction]", o = "[object Proxy]";
  function s(l) {
    if (!n(l))
      return !1;
    var c = e(l);
    return c == i || c == a || c == r || c == o;
  }
  return Md = s, Md;
}
var Bd, mk;
function sR() {
  if (mk) return Bd;
  mk = 1;
  var e = Gr(), n = e["__core-js_shared__"];
  return Bd = n, Bd;
}
var qd, pk;
function lR() {
  if (pk) return qd;
  pk = 1;
  var e = sR(), n = (function() {
    var i = /[^.]+$/.exec(e && e.keys && e.keys.IE_PROTO || "");
    return i ? "Symbol(src)_1." + i : "";
  })();
  function r(i) {
    return !!n && n in i;
  }
  return qd = r, qd;
}
var Hd, fk;
function FC() {
  if (fk) return Hd;
  fk = 1;
  var e = Function.prototype, n = e.toString;
  function r(i) {
    if (i != null) {
      try {
        return n.call(i);
      } catch {
      }
      try {
        return i + "";
      } catch {
      }
    }
    return "";
  }
  return Hd = r, Hd;
}
var Wd, hk;
function dR() {
  if (hk) return Wd;
  hk = 1;
  var e = CC(), n = lR(), r = Ta(), i = FC(), a = /[\\^$.*+?()[\]{}|]/g, o = /^\[object .+?Constructor\]$/, s = Function.prototype, l = Object.prototype, c = s.toString, m = l.hasOwnProperty, u = RegExp(
    "^" + c.call(m).replace(a, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function f(h) {
    if (!r(h) || n(h))
      return !1;
    var k = e(h) ? u : o;
    return k.test(i(h));
  }
  return Wd = f, Wd;
}
var Kd, yk;
function cR() {
  if (yk) return Kd;
  yk = 1;
  function e(n, r) {
    return n?.[r];
  }
  return Kd = e, Kd;
}
var Gd, gk;
function Ki() {
  if (gk) return Gd;
  gk = 1;
  var e = dR(), n = cR();
  function r(i, a) {
    var o = n(i, a);
    return e(o) ? o : void 0;
  }
  return Gd = r, Gd;
}
var Yd, vk;
function Zl() {
  if (vk) return Yd;
  vk = 1;
  var e = Ki(), n = e(Object, "create");
  return Yd = n, Yd;
}
var Jd, kk;
function uR() {
  if (kk) return Jd;
  kk = 1;
  var e = Zl();
  function n() {
    this.__data__ = e ? e(null) : {}, this.size = 0;
  }
  return Jd = n, Jd;
}
var Qd, bk;
function mR() {
  if (bk) return Qd;
  bk = 1;
  function e(n) {
    var r = this.has(n) && delete this.__data__[n];
    return this.size -= r ? 1 : 0, r;
  }
  return Qd = e, Qd;
}
var Xd, _k;
function pR() {
  if (_k) return Xd;
  _k = 1;
  var e = Zl(), n = "__lodash_hash_undefined__", r = Object.prototype, i = r.hasOwnProperty;
  function a(o) {
    var s = this.__data__;
    if (e) {
      var l = s[o];
      return l === n ? void 0 : l;
    }
    return i.call(s, o) ? s[o] : void 0;
  }
  return Xd = a, Xd;
}
var Zd, xk;
function fR() {
  if (xk) return Zd;
  xk = 1;
  var e = Zl(), n = Object.prototype, r = n.hasOwnProperty;
  function i(a) {
    var o = this.__data__;
    return e ? o[a] !== void 0 : r.call(o, a);
  }
  return Zd = i, Zd;
}
var ec, Sk;
function hR() {
  if (Sk) return ec;
  Sk = 1;
  var e = Zl(), n = "__lodash_hash_undefined__";
  function r(i, a) {
    var o = this.__data__;
    return this.size += this.has(i) ? 0 : 1, o[i] = e && a === void 0 ? n : a, this;
  }
  return ec = r, ec;
}
var nc, Nk;
function yR() {
  if (Nk) return nc;
  Nk = 1;
  var e = uR(), n = mR(), r = pR(), i = fR(), a = hR();
  function o(s) {
    var l = -1, c = s == null ? 0 : s.length;
    for (this.clear(); ++l < c; ) {
      var m = s[l];
      this.set(m[0], m[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = r, o.prototype.has = i, o.prototype.set = a, nc = o, nc;
}
var tc, jk;
function gR() {
  if (jk) return tc;
  jk = 1;
  function e() {
    this.__data__ = [], this.size = 0;
  }
  return tc = e, tc;
}
var rc, wk;
function IC() {
  if (wk) return rc;
  wk = 1;
  function e(n, r) {
    return n === r || n !== n && r !== r;
  }
  return rc = e, rc;
}
var ic, Ck;
function ed() {
  if (Ck) return ic;
  Ck = 1;
  var e = IC();
  function n(r, i) {
    for (var a = r.length; a--; )
      if (e(r[a][0], i))
        return a;
    return -1;
  }
  return ic = n, ic;
}
var ac, Fk;
function vR() {
  if (Fk) return ac;
  Fk = 1;
  var e = ed(), n = Array.prototype, r = n.splice;
  function i(a) {
    var o = this.__data__, s = e(o, a);
    if (s < 0)
      return !1;
    var l = o.length - 1;
    return s == l ? o.pop() : r.call(o, s, 1), --this.size, !0;
  }
  return ac = i, ac;
}
var oc, Ik;
function kR() {
  if (Ik) return oc;
  Ik = 1;
  var e = ed();
  function n(r) {
    var i = this.__data__, a = e(i, r);
    return a < 0 ? void 0 : i[a][1];
  }
  return oc = n, oc;
}
var sc, $k;
function bR() {
  if ($k) return sc;
  $k = 1;
  var e = ed();
  function n(r) {
    return e(this.__data__, r) > -1;
  }
  return sc = n, sc;
}
var lc, Ek;
function _R() {
  if (Ek) return lc;
  Ek = 1;
  var e = ed();
  function n(r, i) {
    var a = this.__data__, o = e(a, r);
    return o < 0 ? (++this.size, a.push([r, i])) : a[o][1] = i, this;
  }
  return lc = n, lc;
}
var dc, Tk;
function nd() {
  if (Tk) return dc;
  Tk = 1;
  var e = gR(), n = vR(), r = kR(), i = bR(), a = _R();
  function o(s) {
    var l = -1, c = s == null ? 0 : s.length;
    for (this.clear(); ++l < c; ) {
      var m = s[l];
      this.set(m[0], m[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = r, o.prototype.has = i, o.prototype.set = a, dc = o, dc;
}
var cc, Rk;
function Zy() {
  if (Rk) return cc;
  Rk = 1;
  var e = Ki(), n = Gr(), r = e(n, "Map");
  return cc = r, cc;
}
var uc, Dk;
function xR() {
  if (Dk) return uc;
  Dk = 1;
  var e = yR(), n = nd(), r = Zy();
  function i() {
    this.size = 0, this.__data__ = {
      hash: new e(),
      map: new (r || n)(),
      string: new e()
    };
  }
  return uc = i, uc;
}
var mc, Ok;
function SR() {
  if (Ok) return mc;
  Ok = 1;
  function e(n) {
    var r = typeof n;
    return r == "string" || r == "number" || r == "symbol" || r == "boolean" ? n !== "__proto__" : n === null;
  }
  return mc = e, mc;
}
var pc, Pk;
function td() {
  if (Pk) return pc;
  Pk = 1;
  var e = SR();
  function n(r, i) {
    var a = r.__data__;
    return e(i) ? a[typeof i == "string" ? "string" : "hash"] : a.map;
  }
  return pc = n, pc;
}
var fc, Ak;
function NR() {
  if (Ak) return fc;
  Ak = 1;
  var e = td();
  function n(r) {
    var i = e(this, r).delete(r);
    return this.size -= i ? 1 : 0, i;
  }
  return fc = n, fc;
}
var hc, Lk;
function jR() {
  if (Lk) return hc;
  Lk = 1;
  var e = td();
  function n(r) {
    return e(this, r).get(r);
  }
  return hc = n, hc;
}
var yc, Vk;
function wR() {
  if (Vk) return yc;
  Vk = 1;
  var e = td();
  function n(r) {
    return e(this, r).has(r);
  }
  return yc = n, yc;
}
var gc, zk;
function CR() {
  if (zk) return gc;
  zk = 1;
  var e = td();
  function n(r, i) {
    var a = e(this, r), o = a.size;
    return a.set(r, i), this.size += a.size == o ? 0 : 1, this;
  }
  return gc = n, gc;
}
var vc, Uk;
function $C() {
  if (Uk) return vc;
  Uk = 1;
  var e = xR(), n = NR(), r = jR(), i = wR(), a = CR();
  function o(s) {
    var l = -1, c = s == null ? 0 : s.length;
    for (this.clear(); ++l < c; ) {
      var m = s[l];
      this.set(m[0], m[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = r, o.prototype.has = i, o.prototype.set = a, vc = o, vc;
}
var kc, Mk;
function FR() {
  if (Mk) return kc;
  Mk = 1;
  var e = $C(), n = "Expected a function";
  function r(i, a) {
    if (typeof i != "function" || a != null && typeof a != "function")
      throw new TypeError(n);
    var o = function() {
      var s = arguments, l = a ? a.apply(this, s) : s[0], c = o.cache;
      if (c.has(l))
        return c.get(l);
      var m = i.apply(this, s);
      return o.cache = c.set(l, m) || c, m;
    };
    return o.cache = new (r.Cache || e)(), o;
  }
  return r.Cache = e, kc = r, kc;
}
var bc, Bk;
function IR() {
  if (Bk) return bc;
  Bk = 1;
  var e = FR(), n = 500;
  function r(i) {
    var a = e(i, function(s) {
      return o.size === n && o.clear(), s;
    }), o = a.cache;
    return a;
  }
  return bc = r, bc;
}
var _c, qk;
function $R() {
  if (qk) return _c;
  qk = 1;
  var e = IR(), n = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, r = /\\(\\)?/g, i = e(function(a) {
    var o = [];
    return a.charCodeAt(0) === 46 && o.push(""), a.replace(n, function(s, l, c, m) {
      o.push(c ? m.replace(r, "$1") : l || s);
    }), o;
  });
  return _c = i, _c;
}
var xc, Hk;
function EC() {
  if (Hk) return xc;
  Hk = 1;
  function e(n, r) {
    for (var i = -1, a = n == null ? 0 : n.length, o = Array(a); ++i < a; )
      o[i] = r(n[i], i, n);
    return o;
  }
  return xc = e, xc;
}
var Sc, Wk;
function ER() {
  if (Wk) return Sc;
  Wk = 1;
  var e = es(), n = EC(), r = ki(), i = Xy(), a = e ? e.prototype : void 0, o = a ? a.toString : void 0;
  function s(l) {
    if (typeof l == "string")
      return l;
    if (r(l))
      return n(l, s) + "";
    if (i(l))
      return o ? o.call(l) : "";
    var c = l + "";
    return c == "0" && 1 / l == -1 / 0 ? "-0" : c;
  }
  return Sc = s, Sc;
}
var Nc, Kk;
function TR() {
  if (Kk) return Nc;
  Kk = 1;
  var e = ER();
  function n(r) {
    return r == null ? "" : e(r);
  }
  return Nc = n, Nc;
}
var jc, Gk;
function Ra() {
  if (Gk) return jc;
  Gk = 1;
  var e = ki(), n = oR(), r = $R(), i = TR();
  function a(o, s) {
    return e(o) ? o : n(o, s) ? [o] : r(i(o));
  }
  return jc = a, jc;
}
var wc, Yk;
function rd() {
  if (Yk) return wc;
  Yk = 1;
  var e = Xy();
  function n(r) {
    if (typeof r == "string" || e(r))
      return r;
    var i = r + "";
    return i == "0" && 1 / r == -1 / 0 ? "-0" : i;
  }
  return wc = n, wc;
}
var Cc, Jk;
function TC() {
  if (Jk) return Cc;
  Jk = 1;
  var e = Ra(), n = rd();
  function r(i, a) {
    a = e(a, i);
    for (var o = 0, s = a.length; i != null && o < s; )
      i = i[n(a[o++])];
    return o && o == s ? i : void 0;
  }
  return Cc = r, Cc;
}
var Fc, Qk;
function RC() {
  if (Qk) return Fc;
  Qk = 1;
  var e = Ki(), n = (function() {
    try {
      var r = e(Object, "defineProperty");
      return r({}, "", {}), r;
    } catch {
    }
  })();
  return Fc = n, Fc;
}
var Ic, Xk;
function DC() {
  if (Xk) return Ic;
  Xk = 1;
  var e = RC();
  function n(r, i, a) {
    i == "__proto__" && e ? e(r, i, {
      configurable: !0,
      enumerable: !0,
      value: a,
      writable: !0
    }) : r[i] = a;
  }
  return Ic = n, Ic;
}
var $c, Zk;
function eg() {
  if (Zk) return $c;
  Zk = 1;
  var e = DC(), n = IC(), r = Object.prototype, i = r.hasOwnProperty;
  function a(o, s, l) {
    var c = o[s];
    (!(i.call(o, s) && n(c, l)) || l === void 0 && !(s in o)) && e(o, s, l);
  }
  return $c = a, $c;
}
var Ec, eb;
function ng() {
  if (eb) return Ec;
  eb = 1;
  var e = 9007199254740991, n = /^(?:0|[1-9]\d*)$/;
  function r(i, a) {
    var o = typeof i;
    return a = a ?? e, !!a && (o == "number" || o != "symbol" && n.test(i)) && i > -1 && i % 1 == 0 && i < a;
  }
  return Ec = r, Ec;
}
var Tc, nb;
function RR() {
  if (nb) return Tc;
  nb = 1;
  var e = eg(), n = Ra(), r = ng(), i = Ta(), a = rd();
  function o(s, l, c, m) {
    if (!i(s))
      return s;
    l = n(l, s);
    for (var u = -1, f = l.length, h = f - 1, k = s; k != null && ++u < f; ) {
      var w = a(l[u]), N = c;
      if (w === "__proto__" || w === "constructor" || w === "prototype")
        return s;
      if (u != h) {
        var j = k[w];
        N = m ? m(j, w, k) : void 0, N === void 0 && (N = i(j) ? j : r(l[u + 1]) ? [] : {});
      }
      e(k, w, N), k = k[w];
    }
    return s;
  }
  return Tc = o, Tc;
}
var Rc, tb;
function DR() {
  if (tb) return Rc;
  tb = 1;
  var e = TC(), n = RR(), r = Ra();
  function i(a, o, s) {
    for (var l = -1, c = o.length, m = {}; ++l < c; ) {
      var u = o[l], f = e(a, u);
      s(f, u) && n(m, r(u, a), f);
    }
    return m;
  }
  return Rc = i, Rc;
}
var Dc, rb;
function OR() {
  if (rb) return Dc;
  rb = 1;
  function e(n, r) {
    return n != null && r in Object(n);
  }
  return Dc = e, Dc;
}
var Oc, ib;
function PR() {
  if (ib) return Oc;
  ib = 1;
  var e = Ea(), n = Wi(), r = "[object Arguments]";
  function i(a) {
    return n(a) && e(a) == r;
  }
  return Oc = i, Oc;
}
var Pc, ab;
function tg() {
  if (ab) return Pc;
  ab = 1;
  var e = PR(), n = Wi(), r = Object.prototype, i = r.hasOwnProperty, a = r.propertyIsEnumerable, o = e(/* @__PURE__ */ (function() {
    return arguments;
  })()) ? e : function(s) {
    return n(s) && i.call(s, "callee") && !a.call(s, "callee");
  };
  return Pc = o, Pc;
}
var Ac, ob;
function rg() {
  if (ob) return Ac;
  ob = 1;
  var e = 9007199254740991;
  function n(r) {
    return typeof r == "number" && r > -1 && r % 1 == 0 && r <= e;
  }
  return Ac = n, Ac;
}
var Lc, sb;
function AR() {
  if (sb) return Lc;
  sb = 1;
  var e = Ra(), n = tg(), r = ki(), i = ng(), a = rg(), o = rd();
  function s(l, c, m) {
    c = e(c, l);
    for (var u = -1, f = c.length, h = !1; ++u < f; ) {
      var k = o(c[u]);
      if (!(h = l != null && m(l, k)))
        break;
      l = l[k];
    }
    return h || ++u != f ? h : (f = l == null ? 0 : l.length, !!f && a(f) && i(k, f) && (r(l) || n(l)));
  }
  return Lc = s, Lc;
}
var Vc, lb;
function LR() {
  if (lb) return Vc;
  lb = 1;
  var e = OR(), n = AR();
  function r(i, a) {
    return i != null && n(i, a, e);
  }
  return Vc = r, Vc;
}
var zc, db;
function VR() {
  if (db) return zc;
  db = 1;
  var e = DR(), n = LR();
  function r(i, a) {
    return e(i, a, function(o, s) {
      return n(i, s);
    });
  }
  return zc = r, zc;
}
var Uc, cb;
function ig() {
  if (cb) return Uc;
  cb = 1;
  function e(n, r) {
    for (var i = -1, a = r.length, o = n.length; ++i < a; )
      n[o + i] = r[i];
    return n;
  }
  return Uc = e, Uc;
}
var Mc, ub;
function zR() {
  if (ub) return Mc;
  ub = 1;
  var e = es(), n = tg(), r = ki(), i = e ? e.isConcatSpreadable : void 0;
  function a(o) {
    return r(o) || n(o) || !!(i && o && o[i]);
  }
  return Mc = a, Mc;
}
var Bc, mb;
function UR() {
  if (mb) return Bc;
  mb = 1;
  var e = ig(), n = zR();
  function r(i, a, o, s, l) {
    var c = -1, m = i.length;
    for (o || (o = n), l || (l = []); ++c < m; ) {
      var u = i[c];
      a > 0 && o(u) ? a > 1 ? r(u, a - 1, o, s, l) : e(l, u) : s || (l[l.length] = u);
    }
    return l;
  }
  return Bc = r, Bc;
}
var qc, pb;
function MR() {
  if (pb) return qc;
  pb = 1;
  var e = UR();
  function n(r) {
    var i = r == null ? 0 : r.length;
    return i ? e(r, 1) : [];
  }
  return qc = n, qc;
}
var Hc, fb;
function BR() {
  if (fb) return Hc;
  fb = 1;
  function e(n, r, i) {
    switch (i.length) {
      case 0:
        return n.call(r);
      case 1:
        return n.call(r, i[0]);
      case 2:
        return n.call(r, i[0], i[1]);
      case 3:
        return n.call(r, i[0], i[1], i[2]);
    }
    return n.apply(r, i);
  }
  return Hc = e, Hc;
}
var Wc, hb;
function qR() {
  if (hb) return Wc;
  hb = 1;
  var e = BR(), n = Math.max;
  function r(i, a, o) {
    return a = n(a === void 0 ? i.length - 1 : a, 0), function() {
      for (var s = arguments, l = -1, c = n(s.length - a, 0), m = Array(c); ++l < c; )
        m[l] = s[a + l];
      l = -1;
      for (var u = Array(a + 1); ++l < a; )
        u[l] = s[l];
      return u[a] = o(m), e(i, this, u);
    };
  }
  return Wc = r, Wc;
}
var Kc, yb;
function HR() {
  if (yb) return Kc;
  yb = 1;
  function e(n) {
    return function() {
      return n;
    };
  }
  return Kc = e, Kc;
}
var Gc, gb;
function OC() {
  if (gb) return Gc;
  gb = 1;
  function e(n) {
    return n;
  }
  return Gc = e, Gc;
}
var Yc, vb;
function WR() {
  if (vb) return Yc;
  vb = 1;
  var e = HR(), n = RC(), r = OC(), i = n ? function(a, o) {
    return n(a, "toString", {
      configurable: !0,
      enumerable: !1,
      value: e(o),
      writable: !0
    });
  } : r;
  return Yc = i, Yc;
}
var Jc, kb;
function KR() {
  if (kb) return Jc;
  kb = 1;
  var e = 800, n = 16, r = Date.now;
  function i(a) {
    var o = 0, s = 0;
    return function() {
      var l = r(), c = n - (l - s);
      if (s = l, c > 0) {
        if (++o >= e)
          return arguments[0];
      } else
        o = 0;
      return a.apply(void 0, arguments);
    };
  }
  return Jc = i, Jc;
}
var Qc, bb;
function GR() {
  if (bb) return Qc;
  bb = 1;
  var e = WR(), n = KR(), r = n(e);
  return Qc = r, Qc;
}
var Xc, _b;
function PC() {
  if (_b) return Xc;
  _b = 1;
  var e = MR(), n = qR(), r = GR();
  function i(a) {
    return r(n(a, void 0, e), a + "");
  }
  return Xc = i, Xc;
}
var Zc, xb;
function YR() {
  if (xb) return Zc;
  xb = 1;
  var e = VR(), n = PC(), r = n(function(i, a) {
    return i == null ? {} : e(i, a);
  });
  return Zc = r, Zc;
}
var JR = YR();
const AC = /* @__PURE__ */ jC(JR), QR = [
  "control",
  "defaultValue",
  "name",
  "rules",
  "shouldUnregister"
];
function LC(e) {
  const n = AC(e, QR);
  return {
    controller: Yy(n),
    controllerProps: n
  };
}
const XR = [
  "className",
  "description",
  "disabled",
  "helpIcon",
  "label",
  "noAlert",
  "noLabel",
  "style"
];
function VC(e) {
  const { controller: n, controllerProps: r } = LC(e), i = {
    ...AC(e, XR),
    required: rR(r.rules?.required),
    meta: {
      touched: n.fieldState.isTouched,
      error: n.fieldState.error?.message,
      success: e.meta?.success,
      warning: e.meta?.warning
    },
    labelFor: r.name,
    noLabel: e.noLabel,
    noAlert: e.noAlert
  };
  return {
    controller: n,
    controllerProps: r,
    fieldWrapperProps: i
  };
}
var eu, Sb;
function ZR() {
  if (Sb) return eu;
  Sb = 1;
  var e = nd();
  function n() {
    this.__data__ = new e(), this.size = 0;
  }
  return eu = n, eu;
}
var nu, Nb;
function eD() {
  if (Nb) return nu;
  Nb = 1;
  function e(n) {
    var r = this.__data__, i = r.delete(n);
    return this.size = r.size, i;
  }
  return nu = e, nu;
}
var tu, jb;
function nD() {
  if (jb) return tu;
  jb = 1;
  function e(n) {
    return this.__data__.get(n);
  }
  return tu = e, tu;
}
var ru, wb;
function tD() {
  if (wb) return ru;
  wb = 1;
  function e(n) {
    return this.__data__.has(n);
  }
  return ru = e, ru;
}
var iu, Cb;
function rD() {
  if (Cb) return iu;
  Cb = 1;
  var e = nd(), n = Zy(), r = $C(), i = 200;
  function a(o, s) {
    var l = this.__data__;
    if (l instanceof e) {
      var c = l.__data__;
      if (!n || c.length < i - 1)
        return c.push([o, s]), this.size = ++l.size, this;
      l = this.__data__ = new r(c);
    }
    return l.set(o, s), this.size = l.size, this;
  }
  return iu = a, iu;
}
var au, Fb;
function iD() {
  if (Fb) return au;
  Fb = 1;
  var e = nd(), n = ZR(), r = eD(), i = nD(), a = tD(), o = rD();
  function s(l) {
    var c = this.__data__ = new e(l);
    this.size = c.size;
  }
  return s.prototype.clear = n, s.prototype.delete = r, s.prototype.get = i, s.prototype.has = a, s.prototype.set = o, au = s, au;
}
var ou, Ib;
function aD() {
  if (Ib) return ou;
  Ib = 1;
  function e(n, r) {
    for (var i = -1, a = n == null ? 0 : n.length; ++i < a && r(n[i], i, n) !== !1; )
      ;
    return n;
  }
  return ou = e, ou;
}
var su, $b;
function ns() {
  if ($b) return su;
  $b = 1;
  var e = eg(), n = DC();
  function r(i, a, o, s) {
    var l = !o;
    o || (o = {});
    for (var c = -1, m = a.length; ++c < m; ) {
      var u = a[c], f = s ? s(o[u], i[u], u, o, i) : void 0;
      f === void 0 && (f = i[u]), l ? n(o, u, f) : e(o, u, f);
    }
    return o;
  }
  return su = r, su;
}
var lu, Eb;
function oD() {
  if (Eb) return lu;
  Eb = 1;
  function e(n, r) {
    for (var i = -1, a = Array(n); ++i < n; )
      a[i] = r(i);
    return a;
  }
  return lu = e, lu;
}
var nl = { exports: {} }, du, Tb;
function sD() {
  if (Tb) return du;
  Tb = 1;
  function e() {
    return !1;
  }
  return du = e, du;
}
nl.exports;
var Rb;
function zC() {
  return Rb || (Rb = 1, (function(e, n) {
    var r = Gr(), i = sD(), a = n && !n.nodeType && n, o = a && !0 && e && !e.nodeType && e, s = o && o.exports === a, l = s ? r.Buffer : void 0, c = l ? l.isBuffer : void 0, m = c || i;
    e.exports = m;
  })(nl, nl.exports)), nl.exports;
}
var cu, Db;
function lD() {
  if (Db) return cu;
  Db = 1;
  var e = Ea(), n = rg(), r = Wi(), i = "[object Arguments]", a = "[object Array]", o = "[object Boolean]", s = "[object Date]", l = "[object Error]", c = "[object Function]", m = "[object Map]", u = "[object Number]", f = "[object Object]", h = "[object RegExp]", k = "[object Set]", w = "[object String]", N = "[object WeakMap]", j = "[object ArrayBuffer]", _ = "[object DataView]", g = "[object Float32Array]", O = "[object Float64Array]", R = "[object Int8Array]", F = "[object Int16Array]", I = "[object Int32Array]", L = "[object Uint8Array]", W = "[object Uint8ClampedArray]", J = "[object Uint16Array]", re = "[object Uint32Array]", K = {};
  K[g] = K[O] = K[R] = K[F] = K[I] = K[L] = K[W] = K[J] = K[re] = !0, K[i] = K[a] = K[j] = K[o] = K[_] = K[s] = K[l] = K[c] = K[m] = K[u] = K[f] = K[h] = K[k] = K[w] = K[N] = !1;
  function Y(P) {
    return r(P) && n(P.length) && !!K[e(P)];
  }
  return cu = Y, cu;
}
var uu, Ob;
function ag() {
  if (Ob) return uu;
  Ob = 1;
  function e(n) {
    return function(r) {
      return n(r);
    };
  }
  return uu = e, uu;
}
var tl = { exports: {} };
tl.exports;
var Pb;
function og() {
  return Pb || (Pb = 1, (function(e, n) {
    var r = wC(), i = n && !n.nodeType && n, a = i && !0 && e && !e.nodeType && e, o = a && a.exports === i, s = o && r.process, l = (function() {
      try {
        var c = a && a.require && a.require("util").types;
        return c || s && s.binding && s.binding("util");
      } catch {
      }
    })();
    e.exports = l;
  })(tl, tl.exports)), tl.exports;
}
var mu, Ab;
function dD() {
  if (Ab) return mu;
  Ab = 1;
  var e = lD(), n = ag(), r = og(), i = r && r.isTypedArray, a = i ? n(i) : e;
  return mu = a, mu;
}
var pu, Lb;
function UC() {
  if (Lb) return pu;
  Lb = 1;
  var e = oD(), n = tg(), r = ki(), i = zC(), a = ng(), o = dD(), s = Object.prototype, l = s.hasOwnProperty;
  function c(m, u) {
    var f = r(m), h = !f && n(m), k = !f && !h && i(m), w = !f && !h && !k && o(m), N = f || h || k || w, j = N ? e(m.length, String) : [], _ = j.length;
    for (var g in m)
      (u || l.call(m, g)) && !(N && // Safari 9 has enumerable `arguments.length` in strict mode.
      (g == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      k && (g == "offset" || g == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      w && (g == "buffer" || g == "byteLength" || g == "byteOffset") || // Skip index properties.
      a(g, _))) && j.push(g);
    return j;
  }
  return pu = c, pu;
}
var fu, Vb;
function sg() {
  if (Vb) return fu;
  Vb = 1;
  var e = Object.prototype;
  function n(r) {
    var i = r && r.constructor, a = typeof i == "function" && i.prototype || e;
    return r === a;
  }
  return fu = n, fu;
}
var hu, zb;
function MC() {
  if (zb) return hu;
  zb = 1;
  function e(n, r) {
    return function(i) {
      return n(r(i));
    };
  }
  return hu = e, hu;
}
var yu, Ub;
function cD() {
  if (Ub) return yu;
  Ub = 1;
  var e = MC(), n = e(Object.keys, Object);
  return yu = n, yu;
}
var gu, Mb;
function uD() {
  if (Mb) return gu;
  Mb = 1;
  var e = sg(), n = cD(), r = Object.prototype, i = r.hasOwnProperty;
  function a(o) {
    if (!e(o))
      return n(o);
    var s = [];
    for (var l in Object(o))
      i.call(o, l) && l != "constructor" && s.push(l);
    return s;
  }
  return gu = a, gu;
}
var vu, Bb;
function BC() {
  if (Bb) return vu;
  Bb = 1;
  var e = CC(), n = rg();
  function r(i) {
    return i != null && n(i.length) && !e(i);
  }
  return vu = r, vu;
}
var ku, qb;
function lg() {
  if (qb) return ku;
  qb = 1;
  var e = UC(), n = uD(), r = BC();
  function i(a) {
    return r(a) ? e(a) : n(a);
  }
  return ku = i, ku;
}
var bu, Hb;
function mD() {
  if (Hb) return bu;
  Hb = 1;
  var e = ns(), n = lg();
  function r(i, a) {
    return i && e(a, n(a), i);
  }
  return bu = r, bu;
}
var _u, Wb;
function pD() {
  if (Wb) return _u;
  Wb = 1;
  function e(n) {
    var r = [];
    if (n != null)
      for (var i in Object(n))
        r.push(i);
    return r;
  }
  return _u = e, _u;
}
var xu, Kb;
function fD() {
  if (Kb) return xu;
  Kb = 1;
  var e = Ta(), n = sg(), r = pD(), i = Object.prototype, a = i.hasOwnProperty;
  function o(s) {
    if (!e(s))
      return r(s);
    var l = n(s), c = [];
    for (var m in s)
      m == "constructor" && (l || !a.call(s, m)) || c.push(m);
    return c;
  }
  return xu = o, xu;
}
var Su, Gb;
function dg() {
  if (Gb) return Su;
  Gb = 1;
  var e = UC(), n = fD(), r = BC();
  function i(a) {
    return r(a) ? e(a, !0) : n(a);
  }
  return Su = i, Su;
}
var Nu, Yb;
function hD() {
  if (Yb) return Nu;
  Yb = 1;
  var e = ns(), n = dg();
  function r(i, a) {
    return i && e(a, n(a), i);
  }
  return Nu = r, Nu;
}
var rl = { exports: {} };
rl.exports;
var Jb;
function yD() {
  return Jb || (Jb = 1, (function(e, n) {
    var r = Gr(), i = n && !n.nodeType && n, a = i && !0 && e && !e.nodeType && e, o = a && a.exports === i, s = o ? r.Buffer : void 0, l = s ? s.allocUnsafe : void 0;
    function c(m, u) {
      if (u)
        return m.slice();
      var f = m.length, h = l ? l(f) : new m.constructor(f);
      return m.copy(h), h;
    }
    e.exports = c;
  })(rl, rl.exports)), rl.exports;
}
var ju, Qb;
function gD() {
  if (Qb) return ju;
  Qb = 1;
  function e(n, r) {
    var i = -1, a = n.length;
    for (r || (r = Array(a)); ++i < a; )
      r[i] = n[i];
    return r;
  }
  return ju = e, ju;
}
var wu, Xb;
function vD() {
  if (Xb) return wu;
  Xb = 1;
  function e(n, r) {
    for (var i = -1, a = n == null ? 0 : n.length, o = 0, s = []; ++i < a; ) {
      var l = n[i];
      r(l, i, n) && (s[o++] = l);
    }
    return s;
  }
  return wu = e, wu;
}
var Cu, Zb;
function qC() {
  if (Zb) return Cu;
  Zb = 1;
  function e() {
    return [];
  }
  return Cu = e, Cu;
}
var Fu, e_;
function cg() {
  if (e_) return Fu;
  e_ = 1;
  var e = vD(), n = qC(), r = Object.prototype, i = r.propertyIsEnumerable, a = Object.getOwnPropertySymbols, o = a ? function(s) {
    return s == null ? [] : (s = Object(s), e(a(s), function(l) {
      return i.call(s, l);
    }));
  } : n;
  return Fu = o, Fu;
}
var Iu, n_;
function kD() {
  if (n_) return Iu;
  n_ = 1;
  var e = ns(), n = cg();
  function r(i, a) {
    return e(i, n(i), a);
  }
  return Iu = r, Iu;
}
var $u, t_;
function ug() {
  if (t_) return $u;
  t_ = 1;
  var e = MC(), n = e(Object.getPrototypeOf, Object);
  return $u = n, $u;
}
var Eu, r_;
function HC() {
  if (r_) return Eu;
  r_ = 1;
  var e = ig(), n = ug(), r = cg(), i = qC(), a = Object.getOwnPropertySymbols, o = a ? function(s) {
    for (var l = []; s; )
      e(l, r(s)), s = n(s);
    return l;
  } : i;
  return Eu = o, Eu;
}
var Tu, i_;
function bD() {
  if (i_) return Tu;
  i_ = 1;
  var e = ns(), n = HC();
  function r(i, a) {
    return e(i, n(i), a);
  }
  return Tu = r, Tu;
}
var Ru, a_;
function WC() {
  if (a_) return Ru;
  a_ = 1;
  var e = ig(), n = ki();
  function r(i, a, o) {
    var s = a(i);
    return n(i) ? s : e(s, o(i));
  }
  return Ru = r, Ru;
}
var Du, o_;
function _D() {
  if (o_) return Du;
  o_ = 1;
  var e = WC(), n = cg(), r = lg();
  function i(a) {
    return e(a, r, n);
  }
  return Du = i, Du;
}
var Ou, s_;
function KC() {
  if (s_) return Ou;
  s_ = 1;
  var e = WC(), n = HC(), r = dg();
  function i(a) {
    return e(a, r, n);
  }
  return Ou = i, Ou;
}
var Pu, l_;
function xD() {
  if (l_) return Pu;
  l_ = 1;
  var e = Ki(), n = Gr(), r = e(n, "DataView");
  return Pu = r, Pu;
}
var Au, d_;
function SD() {
  if (d_) return Au;
  d_ = 1;
  var e = Ki(), n = Gr(), r = e(n, "Promise");
  return Au = r, Au;
}
var Lu, c_;
function ND() {
  if (c_) return Lu;
  c_ = 1;
  var e = Ki(), n = Gr(), r = e(n, "Set");
  return Lu = r, Lu;
}
var Vu, u_;
function jD() {
  if (u_) return Vu;
  u_ = 1;
  var e = Ki(), n = Gr(), r = e(n, "WeakMap");
  return Vu = r, Vu;
}
var zu, m_;
function mg() {
  if (m_) return zu;
  m_ = 1;
  var e = xD(), n = Zy(), r = SD(), i = ND(), a = jD(), o = Ea(), s = FC(), l = "[object Map]", c = "[object Object]", m = "[object Promise]", u = "[object Set]", f = "[object WeakMap]", h = "[object DataView]", k = s(e), w = s(n), N = s(r), j = s(i), _ = s(a), g = o;
  return (e && g(new e(new ArrayBuffer(1))) != h || n && g(new n()) != l || r && g(r.resolve()) != m || i && g(new i()) != u || a && g(new a()) != f) && (g = function(O) {
    var R = o(O), F = R == c ? O.constructor : void 0, I = F ? s(F) : "";
    if (I)
      switch (I) {
        case k:
          return h;
        case w:
          return l;
        case N:
          return m;
        case j:
          return u;
        case _:
          return f;
      }
    return R;
  }), zu = g, zu;
}
var Uu, p_;
function wD() {
  if (p_) return Uu;
  p_ = 1;
  var e = Object.prototype, n = e.hasOwnProperty;
  function r(i) {
    var a = i.length, o = new i.constructor(a);
    return a && typeof i[0] == "string" && n.call(i, "index") && (o.index = i.index, o.input = i.input), o;
  }
  return Uu = r, Uu;
}
var Mu, f_;
function CD() {
  if (f_) return Mu;
  f_ = 1;
  var e = Gr(), n = e.Uint8Array;
  return Mu = n, Mu;
}
var Bu, h_;
function pg() {
  if (h_) return Bu;
  h_ = 1;
  var e = CD();
  function n(r) {
    var i = new r.constructor(r.byteLength);
    return new e(i).set(new e(r)), i;
  }
  return Bu = n, Bu;
}
var qu, y_;
function FD() {
  if (y_) return qu;
  y_ = 1;
  var e = pg();
  function n(r, i) {
    var a = i ? e(r.buffer) : r.buffer;
    return new r.constructor(a, r.byteOffset, r.byteLength);
  }
  return qu = n, qu;
}
var Hu, g_;
function ID() {
  if (g_) return Hu;
  g_ = 1;
  var e = /\w*$/;
  function n(r) {
    var i = new r.constructor(r.source, e.exec(r));
    return i.lastIndex = r.lastIndex, i;
  }
  return Hu = n, Hu;
}
var Wu, v_;
function $D() {
  if (v_) return Wu;
  v_ = 1;
  var e = es(), n = e ? e.prototype : void 0, r = n ? n.valueOf : void 0;
  function i(a) {
    return r ? Object(r.call(a)) : {};
  }
  return Wu = i, Wu;
}
var Ku, k_;
function ED() {
  if (k_) return Ku;
  k_ = 1;
  var e = pg();
  function n(r, i) {
    var a = i ? e(r.buffer) : r.buffer;
    return new r.constructor(a, r.byteOffset, r.length);
  }
  return Ku = n, Ku;
}
var Gu, b_;
function TD() {
  if (b_) return Gu;
  b_ = 1;
  var e = pg(), n = FD(), r = ID(), i = $D(), a = ED(), o = "[object Boolean]", s = "[object Date]", l = "[object Map]", c = "[object Number]", m = "[object RegExp]", u = "[object Set]", f = "[object String]", h = "[object Symbol]", k = "[object ArrayBuffer]", w = "[object DataView]", N = "[object Float32Array]", j = "[object Float64Array]", _ = "[object Int8Array]", g = "[object Int16Array]", O = "[object Int32Array]", R = "[object Uint8Array]", F = "[object Uint8ClampedArray]", I = "[object Uint16Array]", L = "[object Uint32Array]";
  function W(J, re, K) {
    var Y = J.constructor;
    switch (re) {
      case k:
        return e(J);
      case o:
      case s:
        return new Y(+J);
      case w:
        return n(J, K);
      case N:
      case j:
      case _:
      case g:
      case O:
      case R:
      case F:
      case I:
      case L:
        return a(J, K);
      case l:
        return new Y();
      case c:
      case f:
        return new Y(J);
      case m:
        return r(J);
      case u:
        return new Y();
      case h:
        return i(J);
    }
  }
  return Gu = W, Gu;
}
var Yu, __;
function RD() {
  if (__) return Yu;
  __ = 1;
  var e = Ta(), n = Object.create, r = /* @__PURE__ */ (function() {
    function i() {
    }
    return function(a) {
      if (!e(a))
        return {};
      if (n)
        return n(a);
      i.prototype = a;
      var o = new i();
      return i.prototype = void 0, o;
    };
  })();
  return Yu = r, Yu;
}
var Ju, x_;
function DD() {
  if (x_) return Ju;
  x_ = 1;
  var e = RD(), n = ug(), r = sg();
  function i(a) {
    return typeof a.constructor == "function" && !r(a) ? e(n(a)) : {};
  }
  return Ju = i, Ju;
}
var Qu, S_;
function OD() {
  if (S_) return Qu;
  S_ = 1;
  var e = mg(), n = Wi(), r = "[object Map]";
  function i(a) {
    return n(a) && e(a) == r;
  }
  return Qu = i, Qu;
}
var Xu, N_;
function PD() {
  if (N_) return Xu;
  N_ = 1;
  var e = OD(), n = ag(), r = og(), i = r && r.isMap, a = i ? n(i) : e;
  return Xu = a, Xu;
}
var Zu, j_;
function AD() {
  if (j_) return Zu;
  j_ = 1;
  var e = mg(), n = Wi(), r = "[object Set]";
  function i(a) {
    return n(a) && e(a) == r;
  }
  return Zu = i, Zu;
}
var em, w_;
function LD() {
  if (w_) return em;
  w_ = 1;
  var e = AD(), n = ag(), r = og(), i = r && r.isSet, a = i ? n(i) : e;
  return em = a, em;
}
var nm, C_;
function VD() {
  if (C_) return nm;
  C_ = 1;
  var e = iD(), n = aD(), r = eg(), i = mD(), a = hD(), o = yD(), s = gD(), l = kD(), c = bD(), m = _D(), u = KC(), f = mg(), h = wD(), k = TD(), w = DD(), N = ki(), j = zC(), _ = PD(), g = Ta(), O = LD(), R = lg(), F = dg(), I = 1, L = 2, W = 4, J = "[object Arguments]", re = "[object Array]", K = "[object Boolean]", Y = "[object Date]", P = "[object Error]", B = "[object Function]", ie = "[object GeneratorFunction]", we = "[object Map]", me = "[object Number]", le = "[object Object]", ge = "[object RegExp]", V = "[object Set]", be = "[object String]", Oe = "[object Symbol]", q = "[object WeakMap]", Ge = "[object ArrayBuffer]", sn = "[object DataView]", Ie = "[object Float32Array]", Ue = "[object Float64Array]", De = "[object Int8Array]", Be = "[object Int16Array]", Ae = "[object Int32Array]", Je = "[object Uint8Array]", Ee = "[object Uint8ClampedArray]", Me = "[object Uint16Array]", en = "[object Uint32Array]", se = {};
  se[J] = se[re] = se[Ge] = se[sn] = se[K] = se[Y] = se[Ie] = se[Ue] = se[De] = se[Be] = se[Ae] = se[we] = se[me] = se[le] = se[ge] = se[V] = se[be] = se[Oe] = se[Je] = se[Ee] = se[Me] = se[en] = !0, se[P] = se[B] = se[q] = !1;
  function de(Se, Ve, Pe, kn, Q, E) {
    var z, ae = Ve & I, ce = Ve & L, U = Ve & W;
    if (Pe && (z = Q ? Pe(Se, kn, Q, E) : Pe(Se)), z !== void 0)
      return z;
    if (!g(Se))
      return Se;
    var G = N(Se);
    if (G) {
      if (z = h(Se), !ae)
        return s(Se, z);
    } else {
      var ve = f(Se), je = ve == B || ve == ie;
      if (j(Se))
        return o(Se, ae);
      if (ve == le || ve == J || je && !Q) {
        if (z = ce || je ? {} : w(Se), !ae)
          return ce ? c(Se, a(z, Se)) : l(Se, i(z, Se));
      } else {
        if (!se[ve])
          return Q ? Se : {};
        z = k(Se, ve, ae);
      }
    }
    E || (E = new e());
    var Re = E.get(Se);
    if (Re)
      return Re;
    E.set(Se, z), O(Se) ? Se.forEach(function(an) {
      z.add(de(an, Ve, Pe, an, Se, E));
    }) : _(Se) && Se.forEach(function(an, fn) {
      z.set(fn, de(an, Ve, Pe, fn, Se, E));
    });
    var rn = U ? ce ? u : m : ce ? F : R, bn = G ? void 0 : rn(Se);
    return n(bn || Se, function(an, fn) {
      bn && (fn = an, an = Se[fn]), r(z, fn, de(an, Ve, Pe, fn, Se, E));
    }), z;
  }
  return nm = de, nm;
}
var tm, F_;
function zD() {
  if (F_) return tm;
  F_ = 1;
  function e(n) {
    var r = n == null ? 0 : n.length;
    return r ? n[r - 1] : void 0;
  }
  return tm = e, tm;
}
var rm, I_;
function UD() {
  if (I_) return rm;
  I_ = 1;
  function e(n, r, i) {
    var a = -1, o = n.length;
    r < 0 && (r = -r > o ? 0 : o + r), i = i > o ? o : i, i < 0 && (i += o), o = r > i ? 0 : i - r >>> 0, r >>>= 0;
    for (var s = Array(o); ++a < o; )
      s[a] = n[a + r];
    return s;
  }
  return rm = e, rm;
}
var im, $_;
function MD() {
  if ($_) return im;
  $_ = 1;
  var e = TC(), n = UD();
  function r(i, a) {
    return a.length < 2 ? i : e(i, n(a, 0, -1));
  }
  return im = r, im;
}
var am, E_;
function BD() {
  if (E_) return am;
  E_ = 1;
  var e = Ra(), n = zD(), r = MD(), i = rd(), a = Object.prototype, o = a.hasOwnProperty;
  function s(l, c) {
    c = e(c, l);
    var m = -1, u = c.length;
    if (!u)
      return !0;
    for (; ++m < u; ) {
      var f = i(c[m]);
      if (f === "__proto__" && !o.call(l, "__proto__") || (f === "constructor" || f === "prototype") && m < u - 1)
        return !1;
    }
    var h = r(l, c);
    return h == null || delete h[i(n(c))];
  }
  return am = s, am;
}
var om, T_;
function qD() {
  if (T_) return om;
  T_ = 1;
  var e = Ea(), n = ug(), r = Wi(), i = "[object Object]", a = Function.prototype, o = Object.prototype, s = a.toString, l = o.hasOwnProperty, c = s.call(Object);
  function m(u) {
    if (!r(u) || e(u) != i)
      return !1;
    var f = n(u);
    if (f === null)
      return !0;
    var h = l.call(f, "constructor") && f.constructor;
    return typeof h == "function" && h instanceof h && s.call(h) == c;
  }
  return om = m, om;
}
var sm, R_;
function HD() {
  if (R_) return sm;
  R_ = 1;
  var e = qD();
  function n(r) {
    return e(r) ? void 0 : r;
  }
  return sm = n, sm;
}
var lm, D_;
function WD() {
  if (D_) return lm;
  D_ = 1;
  var e = EC(), n = VD(), r = BD(), i = Ra(), a = ns(), o = HD(), s = PC(), l = KC(), c = 1, m = 2, u = 4, f = s(function(h, k) {
    var w = {};
    if (h == null)
      return w;
    var N = !1;
    k = e(k, function(_) {
      return _ = i(_, h), N || (N = _.length > 1), _;
    }), a(h, l(h), w), N && (w = n(w, c | m | u, o));
    for (var j = k.length; j--; )
      r(w, k[j]);
    return w;
  });
  return lm = f, lm;
}
WD();
const ur = ({
  children: e,
  ...n
}) => {
  const { controller: r, controllerProps: i, fieldWrapperProps: a } = VC(n), {
    name: o,
    onBlur: s,
    onChange: l,
    ...c
  } = r.field;
  return /* @__PURE__ */ zi.jsx(He, { ...a, children: /* @__PURE__ */ zi.jsx(
    pi,
    {
      ...n.componentProps,
      ...c,
      multiple: !1,
      value: c.value ? [c.value] : [],
      onBlur: (m) => {
        n.componentProps?.onBlur?.(m), s();
      },
      onChange: (m) => {
        n.componentProps?.onChange?.(m), l(m.selectedValues[0] ?? null);
      },
      id: i.name,
      "aria-disabled": a.disabled,
      disabled: a.disabled,
      "aria-required": a.required,
      required: a.required,
      status: He.getStatus(a.meta),
      children: e
    }
  ) });
};
var KD = OC();
const GD = /* @__PURE__ */ jC(KD), yn = ({
  transformValue: e = GD,
  label: n,
  helpIcon: r,
  className: i,
  ...a
}) => {
  const {
    controller: { field: o },
    controllerProps: { name: s }
  } = LC(a);
  return /* @__PURE__ */ zi.jsxs(b, { gap: "200", alignItems: "center", className: i, children: [
    /* @__PURE__ */ zi.jsx(
      Vo,
      {
        ...o,
        id: s,
        checked: e(o.value),
        disabled: a.componentProps?.disabled,
        onChange: (l) => {
          a.componentProps?.onChange?.(l), o.onChange(e(l.target.checked));
        }
      }
    ),
    n && /* @__PURE__ */ zi.jsx(jw, { htmlFor: s, helpIcon: r, children: n })
  ] });
}, On = (e) => {
  const { controller: n, controllerProps: r, fieldWrapperProps: i } = VC(e);
  return /* @__PURE__ */ zi.jsx(He, { ...i, children: /* @__PURE__ */ zi.jsx(
    cr,
    {
      ...e.componentProps,
      ...n.field,
      value: e.componentProps?.type === "number" && isNaN(n.field.value) ? "" : n.field.value ?? "",
      onBlur: (a) => {
        e.componentProps?.onBlur?.(a), n.field.onBlur();
      },
      onChange: (a) => {
        e.componentProps?.onChange?.(a), n.field.onChange(
          e.componentProps?.type === "number" ? a.target.valueAsNumber : a
        );
      },
      id: r.name,
      "aria-disabled": i.disabled,
      disabled: i.disabled,
      "aria-required": i.required,
      required: i.required,
      status: He.getStatus(i.meta)
    }
  ) });
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode('@charset "UTF-8";._copyIcon_10dvk_54{cursor:pointer;color:var(--dixa-typography-color-secondary)}._list_10dvk_59{padding:0;max-height:250px;overflow-y:auto;background:linear-gradient(var(--dixa-color-neutral-000) 33%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),var(--dixa-color-neutral-000) 66%) 0 100%,radial-gradient(farthest-side at 50% 0,var(--dixa-color-neutral-200),rgba(0,0,0,0)),radial-gradient(farthest-side at 50% 100%,var(--dixa-color-neutral-200),rgba(0,0,0,0)) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-200),100% var(--dixa-size-spacer-200)}._listItem_10dvk_69{background-color:transparent;padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_10dvk_69:last-child:not(:only-child){border-bottom:none}._collapsible_10dvk_78{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._collapsible_10dvk_78:hover,._collapsibleIsOpen_10dvk_86{border-color:var(--dixa-color-neutral-400)}._collapsibleHeader_10dvk_89{cursor:pointer}._collapsibleIconTrue_10dvk_92{color:var(--dixa-color-green-500)}._collapsibleIconFalse_10dvk_95{color:var(--dixa-color-red-500)}._wrapper_1xucg_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._externalLink_1xucg_7{color:var(--dixa-typography-color-primary);font-size:var(--dixa-typography-size-200)}')), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var dm = { exports: {} }, Ga = {}, O_;
function YD() {
  if (O_) return Ga;
  O_ = 1;
  var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, c, m) {
    var u, f = {}, h = null, k = null;
    m !== void 0 && (h = "" + m), c.key !== void 0 && (h = "" + c.key), c.ref !== void 0 && (k = c.ref);
    for (u in c) i.call(c, u) && !o.hasOwnProperty(u) && (f[u] = c[u]);
    if (l && l.defaultProps) for (u in c = l.defaultProps, c) f[u] === void 0 && (f[u] = c[u]);
    return { $$typeof: n, type: l, key: h, ref: k, props: f, _owner: a.current };
  }
  return Ga.Fragment = r, Ga.jsx = s, Ga.jsxs = s, Ga;
}
var hs = {}, P_;
function JD() {
  return P_ || (P_ = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), c = /* @__PURE__ */ Symbol.for("react.forward_ref"), m = /* @__PURE__ */ Symbol.for("react.suspense"), u = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), k = /* @__PURE__ */ Symbol.for("react.offscreen"), w = Symbol.iterator, N = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var d = w && t[w] || t[N];
      return typeof d == "function" ? d : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var d = arguments.length, p = new Array(d > 1 ? d - 1 : 0), y = 1; y < d; y++)
          p[y - 1] = arguments[y];
        O("error", t, p);
      }
    }
    function O(t, d, p) {
      {
        var y = _.ReactDebugCurrentFrame, C = y.getStackAddendum();
        C !== "" && (d += "%s", p = p.concat([C]));
        var T = p.map(function(S) {
          return String(S);
        });
        T.unshift("Warning: " + d), Function.prototype.apply.call(console[t], console, T);
      }
    }
    var R = !1, F = !1, I = !1, L = !1, W = !1, J;
    J = /* @__PURE__ */ Symbol.for("react.module.reference");
    function re(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || W || t === a || t === m || t === u || L || t === k || R || F || I || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === J || t.getModuleId !== void 0));
    }
    function K(t, d, p) {
      var y = t.displayName;
      if (y)
        return y;
      var C = d.displayName || d.name || "";
      return C !== "" ? p + "(" + C + ")" : p;
    }
    function Y(t) {
      return t.displayName || "Context";
    }
    function P(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var d = t;
            return Y(d) + ".Consumer";
          case s:
            var p = t;
            return Y(p._context) + ".Provider";
          case c:
            return K(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : P(t.type) || "Memo";
          case h: {
            var C = t, T = C._payload, S = C._init;
            try {
              return P(S(T));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, ie = 0, we, me, le, ge, V, be, Oe;
    function q() {
    }
    q.__reactDisabledLog = !0;
    function Ge() {
      {
        if (ie === 0) {
          we = console.log, me = console.info, le = console.warn, ge = console.error, V = console.group, be = console.groupCollapsed, Oe = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: q,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ie++;
      }
    }
    function sn() {
      {
        if (ie--, ie === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, t, {
              value: we
            }),
            info: B({}, t, {
              value: me
            }),
            warn: B({}, t, {
              value: le
            }),
            error: B({}, t, {
              value: ge
            }),
            group: B({}, t, {
              value: V
            }),
            groupCollapsed: B({}, t, {
              value: be
            }),
            groupEnd: B({}, t, {
              value: Oe
            })
          });
        }
        ie < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ie = _.ReactCurrentDispatcher, Ue;
    function De(t, d, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (C) {
            var y = C.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Ae;
    {
      var Je = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Je();
    }
    function Ee(t, d) {
      if (!t || Be)
        return "";
      {
        var p = Ae.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Be = !0;
      var C = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var T;
      T = Ie.current, Ie.current = null, Ge();
      try {
        if (d) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (ne) {
              y = ne;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (ne) {
              y = ne;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            y = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && y && typeof ne.stack == "string") {
          for (var x = ne.stack.split(`
`), Z = y.stack.split(`
`), A = x.length - 1, M = Z.length - 1; A >= 1 && M >= 0 && x[A] !== Z[M]; )
            M--;
          for (; A >= 1 && M >= 0; A--, M--)
            if (x[A] !== Z[M]) {
              if (A !== 1 || M !== 1)
                do
                  if (A--, M--, M < 0 || x[A] !== Z[M]) {
                    var ue = `
` + x[A].replace(" at new ", " at ");
                    return t.displayName && ue.includes("<anonymous>") && (ue = ue.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, ue), ue;
                  }
                while (A >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Ie.current = T, sn(), Error.prepareStackTrace = C;
      }
      var ze = t ? t.displayName || t.name : "", Te = ze ? De(ze) : "";
      return typeof t == "function" && Ae.set(t, Te), Te;
    }
    function Me(t, d, p) {
      return Ee(t, !1);
    }
    function en(t) {
      var d = t.prototype;
      return !!(d && d.isReactComponent);
    }
    function se(t, d, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ee(t, en(t));
      if (typeof t == "string")
        return De(t);
      switch (t) {
        case m:
          return De("Suspense");
        case u:
          return De("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case c:
            return Me(t.render);
          case f:
            return se(t.type, d, p);
          case h: {
            var y = t, C = y._payload, T = y._init;
            try {
              return se(T(C), d, p);
            } catch {
            }
          }
        }
      return "";
    }
    var de = Object.prototype.hasOwnProperty, Se = {}, Ve = _.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var d = t._owner, p = se(t.type, t._source, d ? d.type : null);
        Ve.setExtraStackFrame(p);
      } else
        Ve.setExtraStackFrame(null);
    }
    function kn(t, d, p, y, C) {
      {
        var T = Function.call.bind(de);
        for (var S in t)
          if (T(t, S)) {
            var x = void 0;
            try {
              if (typeof t[S] != "function") {
                var Z = Error((y || "React class") + ": " + p + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Z.name = "Invariant Violation", Z;
              }
              x = t[S](d, S, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (A) {
              x = A;
            }
            x && !(x instanceof Error) && (Pe(C), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, S, typeof x), Pe(null)), x instanceof Error && !(x.message in Se) && (Se[x.message] = !0, Pe(C), g("Failed %s type: %s", p, x.message), Pe(null));
          }
      }
    }
    var Q = Array.isArray;
    function E(t) {
      return Q(t);
    }
    function z(t) {
      {
        var d = typeof Symbol == "function" && Symbol.toStringTag, p = d && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function ae(t) {
      try {
        return ce(t), !1;
      } catch {
        return !0;
      }
    }
    function ce(t) {
      return "" + t;
    }
    function U(t) {
      if (ae(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", z(t)), ce(t);
    }
    var G = _.ReactCurrentOwner, ve = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, je, Re;
    function rn(t) {
      if (de.call(t, "ref")) {
        var d = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (d && d.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function bn(t) {
      if (de.call(t, "key")) {
        var d = Object.getOwnPropertyDescriptor(t, "key").get;
        if (d && d.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function an(t, d) {
      typeof t.ref == "string" && G.current;
    }
    function fn(t, d) {
      {
        var p = function() {
          je || (je = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", d));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function En(t, d) {
      {
        var p = function() {
          Re || (Re = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", d));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var _n = function(t, d, p, y, C, T, S) {
      var x = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: d,
        ref: p,
        props: S,
        // Record the component responsible for creating this element.
        _owner: T
      };
      return x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(x, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(x, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: C
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    };
    function Fn(t, d, p, y, C) {
      {
        var T, S = {}, x = null, Z = null;
        p !== void 0 && (U(p), x = "" + p), bn(d) && (U(d.key), x = "" + d.key), rn(d) && (Z = d.ref, an(d));
        for (T in d)
          de.call(d, T) && !ve.hasOwnProperty(T) && (S[T] = d[T]);
        if (t && t.defaultProps) {
          var A = t.defaultProps;
          for (T in A)
            S[T] === void 0 && (S[T] = A[T]);
        }
        if (x || Z) {
          var M = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          x && fn(S, M), Z && En(S, M);
        }
        return _n(t, x, Z, C, y, G.current, S);
      }
    }
    var Ze = _.ReactCurrentOwner, gn = _.ReactDebugCurrentFrame;
    function Le(t) {
      if (t) {
        var d = t._owner, p = se(t.type, t._source, d ? d.type : null);
        gn.setExtraStackFrame(p);
      } else
        gn.setExtraStackFrame(null);
    }
    var dn;
    dn = !1;
    function cn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function Nn() {
      {
        if (Ze.current) {
          var t = P(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Bn(t) {
      return "";
    }
    var Sn = {};
    function An(t) {
      {
        var d = Nn();
        if (!d) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (d = `

Check the top-level render call using <` + p + ">.");
        }
        return d;
      }
    }
    function vn(t, d) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = An(d);
        if (Sn[p])
          return;
        Sn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Ze.current && (y = " It was passed a child from " + P(t._owner.type) + "."), Le(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Le(null);
      }
    }
    function xn(t, d) {
      {
        if (typeof t != "object")
          return;
        if (E(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            cn(y) && vn(y, d);
          }
        else if (cn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var C = j(t);
          if (typeof C == "function" && C !== t.entries)
            for (var T = C.call(t), S; !(S = T.next()).done; )
              cn(S.value) && vn(S.value, d);
        }
      }
    }
    function Ln(t) {
      {
        var d = t.type;
        if (d == null || typeof d == "string")
          return;
        var p;
        if (typeof d == "function")
          p = d.propTypes;
        else if (typeof d == "object" && (d.$$typeof === c || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        d.$$typeof === f))
          p = d.propTypes;
        else
          return;
        if (p) {
          var y = P(d);
          kn(p, t.props, "prop", y, t);
        } else if (d.PropTypes !== void 0 && !dn) {
          dn = !0;
          var C = P(d);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", C || "Unknown");
        }
        typeof d.getDefaultProps == "function" && !d.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var d = Object.keys(t.props), p = 0; p < d.length; p++) {
          var y = d[p];
          if (y !== "children" && y !== "key") {
            Le(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Le(null);
            break;
          }
        }
        t.ref !== null && (Le(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Le(null));
      }
    }
    var Cn = {};
    function wn(t, d, p, y, C, T) {
      {
        var S = re(t);
        if (!S) {
          var x = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (x += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Z = Bn();
          Z ? x += Z : x += Nn();
          var A;
          t === null ? A = "null" : E(t) ? A = "array" : t !== void 0 && t.$$typeof === n ? (A = "<" + (P(t.type) || "Unknown") + " />", x = " Did you accidentally export a JSX literal instead of a component?") : A = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", A, x);
        }
        var M = Fn(t, d, p, C, T);
        if (M == null)
          return M;
        if (S) {
          var ue = d.children;
          if (ue !== void 0)
            if (y)
              if (E(ue)) {
                for (var ze = 0; ze < ue.length; ze++)
                  xn(ue[ze], t);
                Object.freeze && Object.freeze(ue);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              xn(ue, t);
        }
        if (de.call(d, "key")) {
          var Te = P(t), ne = Object.keys(d).filter(function(Kn) {
            return Kn !== "key";
          }), un = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Cn[Te + un]) {
            var Rn = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, un, Te, Rn, Te), Cn[Te + un] = !0;
          }
        }
        return t === i ? Vn(M) : Ln(M), M;
      }
    }
    function zn(t, d, p) {
      return wn(t, d, p, !0);
    }
    function qn(t, d, p) {
      return wn(t, d, p, !1);
    }
    var Un = qn, Wn = zn;
    hs.Fragment = i, hs.jsx = Un, hs.jsxs = Wn;
  })()), hs;
}
var A_;
function QD() {
  return A_ || (A_ = 1, process.env.NODE_ENV === "production" ? dm.exports = YD() : dm.exports = JD()), dm.exports;
}
var ee = QD();
const XD = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "getCustomerDetails" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Braze_exportUserDetails_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Braze" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "exportUserDetails" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Braze_exportUserDetails_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Braze_ExportedUserDetails" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }, { kind: "Field", name: { kind: "Name", value: "users" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "external_id" } }, { kind: "Field", name: { kind: "Name", value: "braze_id" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "dob" } }, { kind: "Field", name: { kind: "Name", value: "home_city" } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "language" } }, { kind: "Field", name: { kind: "Name", value: "time_zone" } }, { kind: "Field", name: { kind: "Name", value: "total_revenue" } }, { kind: "Field", name: { kind: "Name", value: "push_subscribe" } }, { kind: "Field", name: { kind: "Name", value: "email_subscribe" } }, { kind: "Field", name: { kind: "Name", value: "custom_attributes" } }, { kind: "Field", name: { kind: "Name", value: "apps" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "platform" } }, { kind: "Field", name: { kind: "Name", value: "version" } }, { kind: "Field", name: { kind: "Name", value: "sessions" } }, { kind: "Field", name: { kind: "Name", value: "first_used" } }, { kind: "Field", name: { kind: "Name", value: "last_used" } }] } }, { kind: "Field", name: { kind: "Name", value: "devices" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "model" } }, { kind: "Field", name: { kind: "Name", value: "os" } }, { kind: "Field", name: { kind: "Name", value: "carrier" } }, { kind: "Field", name: { kind: "Name", value: "idfv" } }, { kind: "Field", name: { kind: "Name", value: "idfa" } }, { kind: "Field", name: { kind: "Name", value: "google_ad_id" } }, { kind: "Field", name: { kind: "Name", value: "roku_ad_id" } }, { kind: "Field", name: { kind: "Name", value: "ad_tracking_enabled" } }] } }, { kind: "Field", name: { kind: "Name", value: "custom_events" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "first" } }, { kind: "Field", name: { kind: "Name", value: "last" } }, { kind: "Field", name: { kind: "Name", value: "count" } }] } }, { kind: "Field", name: { kind: "Name", value: "purchases" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "first" } }, { kind: "Field", name: { kind: "Name", value: "last" } }, { kind: "Field", name: { kind: "Name", value: "count" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Braze_BasicResponse" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] } }] }, ZD = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updateEmailSubscriptionStatus" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Braze_updateEmailSubscriptionStatus_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Braze" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "updateEmailSubscriptionStatus" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] }, eO = {
  "\n  mutation getCustomerDetails($input: Braze_exportUserDetails_request_Input!) {\n    Braze {\n      exportUserDetails(input: $input) {\n        ... on Braze_exportUserDetails_response {\n          ... on Braze_ExportedUserDetails {\n            message\n            users {\n              external_id\n              braze_id\n              created_at\n              email\n              first_name\n              last_name\n              dob\n              home_city\n              country\n              phone\n              language\n              time_zone\n              total_revenue\n              push_subscribe\n              email_subscribe\n              custom_attributes\n              apps {\n                name\n                platform\n                version\n                sessions\n                first_used\n                last_used\n              }\n              devices {\n                model\n                os\n                carrier\n                idfv\n                idfa\n                google_ad_id\n                roku_ad_id\n                ad_tracking_enabled\n              }\n              custom_events {\n                name\n                first\n                last\n                count\n              }\n              purchases {\n                name\n                first\n                last\n                count\n              }\n            }\n          }\n\n          ... on Braze_BasicResponse {\n            message\n          }\n        }\n      }\n    }\n  }\n": XD,
  "\n  mutation updateEmailSubscriptionStatus(\n    $input: Braze_updateEmailSubscriptionStatus_request_Input!\n  ) {\n    Braze {\n      updateEmailSubscriptionStatus(input: $input) {\n        message\n      }\n    }\n  }\n": ZD
};
function GC(e) {
  return eO[e] ?? {};
}
const nO = GC(
  /* GraphQL */
  `
  mutation getCustomerDetails($input: Braze_exportUserDetails_request_Input!) {
    Braze {
      exportUserDetails(input: $input) {
        ... on Braze_exportUserDetails_response {
          ... on Braze_ExportedUserDetails {
            message
            users {
              external_id
              braze_id
              created_at
              email
              first_name
              last_name
              dob
              home_city
              country
              phone
              language
              time_zone
              total_revenue
              push_subscribe
              email_subscribe
              custom_attributes
              apps {
                name
                platform
                version
                sessions
                first_used
                last_used
              }
              devices {
                model
                os
                carrier
                idfv
                idfa
                google_ad_id
                roku_ad_id
                ad_tracking_enabled
              }
              custom_events {
                name
                first
                last
                count
              }
              purchases {
                name
                first
                last
                count
              }
            }
          }

          ... on Braze_BasicResponse {
            message
          }
        }
      }
    }
  }
`
), tO = GC(
  /* GraphQL */
  `
  mutation updateEmailSubscriptionStatus(
    $input: Braze_updateEmailSubscriptionStatus_request_Input!
  ) {
    Braze {
      updateEmailSubscriptionStatus(input: $input) {
        message
      }
    }
  }
`
), rO = "_copyIcon_10dvk_54", iO = "_list_10dvk_59", aO = "_listItem_10dvk_69", oO = "_collapsible_10dvk_78", sO = "_collapsibleIsOpen_10dvk_86", lO = "_collapsibleHeader_10dvk_89", dO = "_collapsibleIconTrue_10dvk_92", cO = "_collapsibleIconFalse_10dvk_95", Mn = {
  copyIcon: rO,
  list: iO,
  listItem: aO,
  collapsible: oO,
  collapsibleIsOpen: sO,
  collapsibleHeader: lO,
  collapsibleIconTrue: dO,
  collapsibleIconFalse: cO
}, uO = ({
  app: e,
  openByDefault: n
}) => {
  const [r, i] = pe(n);
  if (!e)
    return null;
  const {
    name: a,
    platform: o,
    version: s,
    sessions: l,
    first_used: c,
    last_used: m
  } = e;
  return /* @__PURE__ */ ee.jsxs(
    b,
    {
      className: ct(Mn.collapsible, {
        [Mn.collapsibleIsOpen]: r
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ ee.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Mn.collapsibleHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ ee.jsx($.Paragraph, { variant: "1", children: a }),
              /* @__PURE__ */ ee.jsx(
                Qt,
                {
                  variant: "tertiary",
                  icon: r ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ ee.jsxs(Ye, { className: Mn.list, children: [
          /* @__PURE__ */ ee.jsx(Ye.Text, { variant: "dense", className: Mn.listItem, children: /* @__PURE__ */ ee.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ ee.jsx($.Paragraph, { variant: "3", children: "Platform" }),
            /* @__PURE__ */ ee.jsx($.Paragraph, { variant: "5", color: "secondary", children: o })
          ] }) }),
          /* @__PURE__ */ ee.jsx(Ye.Text, { variant: "dense", className: Mn.listItem, children: /* @__PURE__ */ ee.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ ee.jsx($.Paragraph, { variant: "3", children: "Version" }),
            /* @__PURE__ */ ee.jsx($.Paragraph, { variant: "5", color: "secondary", children: s })
          ] }) }),
          /* @__PURE__ */ ee.jsx(Ye.Text, { variant: "dense", className: Mn.listItem, children: /* @__PURE__ */ ee.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ ee.jsx($.Paragraph, { variant: "3", children: "Sessions" }),
            /* @__PURE__ */ ee.jsx($.Paragraph, { variant: "5", color: "secondary", children: l })
          ] }) }),
          /* @__PURE__ */ ee.jsx(Ye.Text, { variant: "dense", className: Mn.listItem, children: /* @__PURE__ */ ee.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ ee.jsx($.Paragraph, { variant: "3", children: "First used" }),
            /* @__PURE__ */ ee.jsx($.Paragraph, { variant: "5", color: "secondary", children: Gn(c).format($t) })
          ] }) }),
          /* @__PURE__ */ ee.jsx(Ye.Text, { variant: "dense", className: Mn.listItem, children: /* @__PURE__ */ ee.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ ee.jsx($.Paragraph, { variant: "3", children: "Last used" }),
            /* @__PURE__ */ ee.jsx($.Paragraph, { variant: "5", color: "secondary", children: Gn(m).format($t) })
          ] }) })
        ] })
      ]
    }
  );
}, mO = ({ apps: e }) => {
  const n = e && e?.length > 0;
  return /* @__PURE__ */ ee.jsxs(b, { gap: "200", flexDirection: "column", margin: "200 0 0", children: [
    /* @__PURE__ */ ee.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ ee.jsx($.Heading, { variant: "heading-3", children: "Apps" }),
      n && /* @__PURE__ */ ee.jsx(Pn, { size: "small", variant: "success", children: e.length })
    ] }),
    !n && /* @__PURE__ */ ee.jsx(
      $.Paragraph,
      {
        variant: "4",
        margin: "200 0 300 0",
        color: "secondary",
        align: "center",
        children: "There are no apps associated with this customer"
      }
    ),
    e?.map((r, i) => /* @__PURE__ */ ee.jsx(uO, { app: r, openByDefault: i === 0 }, i))
  ] });
}, pO = ({
  customerDetails: e
}) => {
  if (!e)
    return null;
  const { custom_attributes: n } = e, r = !!n && Object.keys(n).length > 0;
  return /* @__PURE__ */ ee.jsx(ee.Fragment, { children: /* @__PURE__ */ ee.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ee.jsx($.Heading, { variant: "heading-3", children: "Custom attributes" }),
    !r && /* @__PURE__ */ ee.jsx($.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No custom attributes available" }),
    r && /* @__PURE__ */ ee.jsx(Ye, { className: Mn.list, children: Object.entries(
      n
    ).map(([i, a], o) => (typeof a == "boolean" || typeof a == "string" || typeof a == "number") && /* @__PURE__ */ ee.jsx(
      Ye.Text,
      {
        variant: "dense",
        className: Mn.listItem,
        children: /* @__PURE__ */ ee.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
          /* @__PURE__ */ ee.jsx($.Paragraph, { variant: "4", children: i }),
          Bi(a)
        ] })
      },
      o
    )) })
  ] }) });
}, fO = ({
  customerDetails: e
}) => {
  if (!e)
    return null;
  const { custom_events: n } = e, r = n?.sort(
    (a, o) => o?.count - a?.count
  ), i = r && r.length > 0;
  return /* @__PURE__ */ ee.jsx(ee.Fragment, { children: /* @__PURE__ */ ee.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ee.jsx($.Heading, { variant: "heading-3", children: "Custom events" }),
    !i && /* @__PURE__ */ ee.jsx($.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No custom events available" }),
    i && /* @__PURE__ */ ee.jsx(Ye, { className: Mn.list, children: r.map((a, o) => /* @__PURE__ */ ee.jsx(
      Ye.Text,
      {
        variant: "dense",
        className: Mn.listItem,
        children: /* @__PURE__ */ ee.jsxs(b, { justifyContent: "space-between", children: [
          /* @__PURE__ */ ee.jsx(
            Xe,
            {
              content: /* @__PURE__ */ ee.jsxs(b, { flexDirection: "column", children: [
                /* @__PURE__ */ ee.jsx(b, { children: `First ${Gn(a?.first).format(
                  $t
                )}` }),
                /* @__PURE__ */ ee.jsx(b, { children: `Last ${Gn(a?.last).format(
                  $t
                )}` })
              ] }),
              children: /* @__PURE__ */ ee.jsx($.Paragraph, { variant: "4", children: a?.name })
            }
          ),
          /* @__PURE__ */ ee.jsx($.Paragraph, { variant: "5", children: a?.count })
        ] })
      },
      o
    )) })
  ] }) });
}, vl = ({
  state: e,
  noTooltip: n = !1,
  isPush: r = !1
}) => {
  if (!e) return null;
  const i = e === "subscribed", a = e === "unsubscribed", o = () => i ? "exclamation" : a ? "close-circle-filled" : "check-circle-filled", s = () => i ? "neutral.500" : a ? "red.500" : "green.500", l = () => {
    const c = r ? "push notifications" : "emails";
    return i ? `Default case "subscribed": The user has neither unsubscribed nor explicitly opted-in to receive ${c}. This is the default subscription state when a user profile is created.` : a ? `Unsubscribed: The user has explicitly unsubscribed from receiving ${c}.` : `Opted in: The user has explicitly confirmed they want to receive ${c}.`;
  };
  return /* @__PURE__ */ ee.jsx(Xe, { content: n ? null : l(), children: /* @__PURE__ */ ee.jsx(b, { alignItems: "center", children: /* @__PURE__ */ ee.jsx(he, { size: 14, name: o(), color: s() }) }) });
}, hO = "_wrapper_1xucg_1", yO = "_externalLink_1xucg_7", cm = {
  wrapper: hO,
  externalLink: yO
}, gO = ({
  customerDetails: e
}) => {
  const { isCopied: n, copy: r } = Jt(), { isCopied: i, copy: a } = Jt(), { isCopied: o, copy: s } = Jt(), { isCopied: l, copy: c } = Jt(), { isCopied: m, copy: u } = Jt();
  if (!e)
    return null;
  const {
    external_id: f,
    braze_id: h,
    first_name: k,
    last_name: w,
    home_city: N,
    country: j,
    email: _,
    phone: g,
    dob: O,
    created_at: R,
    email_subscribe: F,
    push_subscribe: I
  } = e, L = 14, W = `${k || ""} ${w || ""}`.trim() || "A customer has no name", J = `${N ? `${N} /` : ""} ${j || ""}`.trim(), re = O ? Gn(O).isSame(Date.now(), "day") : !1;
  return /* @__PURE__ */ ee.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ ee.jsxs(b, { className: cm.wrapper, gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ee.jsxs(
      b,
      {
        justifyContent: "space-between",
        className: cm.block,
        alignItems: "center",
        children: [
          /* @__PURE__ */ ee.jsx($.Heading, { variant: "heading-2", children: W }),
          re && /* @__PURE__ */ ee.jsx($.Paragraph, { variant: "4", color: "secondary", children: "... has birthday today 🥳" })
        ]
      }
    ),
    R && /* @__PURE__ */ ee.jsxs(b, { gap: "200", justifyContent: "space-between", margin: "0 0 200", children: [
      /* @__PURE__ */ ee.jsx($.Paragraph, { variant: "4", children: "Member since" }),
      /* @__PURE__ */ ee.jsx($.Paragraph, { variant: "4", children: Gn(R).format($t) })
    ] }),
    J && /* @__PURE__ */ ee.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ee.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ee.jsx(he, { size: L, name: "map-pin" }),
        /* @__PURE__ */ ee.jsx($.Paragraph, { variant: "4", children: J })
      ] }),
      /* @__PURE__ */ ee.jsx(Xe, { content: "Copy location", children: /* @__PURE__ */ ee.jsx(b, { alignItems: "center", children: /* @__PURE__ */ ee.jsx(
        he,
        {
          size: L,
          name: o ? "done" : "copy",
          onClick: () => s(J),
          className: Mn.copyIcon
        }
      ) }) })
    ] }),
    _ && /* @__PURE__ */ ee.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ee.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ee.jsx(he, { size: L, name: "mail" }),
        /* @__PURE__ */ ee.jsx("span", { className: cm.externalLink, children: _ })
      ] }),
      /* @__PURE__ */ ee.jsx(Xe, { content: "Copy email", children: /* @__PURE__ */ ee.jsx(b, { alignItems: "center", children: /* @__PURE__ */ ee.jsx(
        he,
        {
          size: L,
          name: n ? "done" : "copy",
          onClick: () => r(_),
          className: Mn.copyIcon
        }
      ) }) })
    ] }),
    g && /* @__PURE__ */ ee.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ee.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ee.jsx(he, { size: L, name: "phone" }),
        /* @__PURE__ */ ee.jsx($.Paragraph, { variant: "4", children: g })
      ] }),
      /* @__PURE__ */ ee.jsx(Xe, { content: "Copy phone number", children: /* @__PURE__ */ ee.jsx(b, { alignItems: "center", children: /* @__PURE__ */ ee.jsx(
        he,
        {
          size: L,
          name: i ? "done" : "copy",
          onClick: () => a(g),
          className: Mn.copyIcon
        }
      ) }) })
    ] }),
    h && /* @__PURE__ */ ee.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ee.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ee.jsx(he, { size: L, name: "user" }),
        /* @__PURE__ */ ee.jsx($.Paragraph, { variant: "4", children: "Braze ID" }),
        /* @__PURE__ */ ee.jsxs($.Paragraph, { variant: "5", subdued: !0, color: "tertiary", children: [
          "(",
          h,
          ")"
        ] })
      ] }),
      /* @__PURE__ */ ee.jsx(Xe, { content: "Copy Braze ID", children: /* @__PURE__ */ ee.jsx(b, { alignItems: "center", children: /* @__PURE__ */ ee.jsx(
        he,
        {
          size: L,
          name: l ? "done" : "copy",
          onClick: () => c(h),
          className: Mn.copyIcon
        }
      ) }) })
    ] }),
    f && /* @__PURE__ */ ee.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ee.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ee.jsx(he, { size: L, name: "tag" }),
        /* @__PURE__ */ ee.jsx($.Paragraph, { variant: "4", children: "External ID" }),
        /* @__PURE__ */ ee.jsxs($.Paragraph, { variant: "5", subdued: !0, color: "tertiary", children: [
          "(",
          f,
          ")"
        ] })
      ] }),
      /* @__PURE__ */ ee.jsx(Xe, { content: "Copy External ID", children: /* @__PURE__ */ ee.jsx(b, { alignItems: "center", children: /* @__PURE__ */ ee.jsx(
        he,
        {
          size: L,
          name: m ? "done" : "copy",
          onClick: () => u(f),
          className: Mn.copyIcon
        }
      ) }) })
    ] }),
    F && /* @__PURE__ */ ee.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ee.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ee.jsx(he, { size: L, name: "sync" }),
        /* @__PURE__ */ ee.jsx($.Paragraph, { variant: "4", children: "Email subscription state" })
      ] }),
      /* @__PURE__ */ ee.jsx(vl, { state: F })
    ] }),
    I && /* @__PURE__ */ ee.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ee.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ee.jsx(he, { size: L, name: "bell" }),
        /* @__PURE__ */ ee.jsx($.Paragraph, { variant: "4", children: "Push notification subscription state" })
      ] }),
      /* @__PURE__ */ ee.jsx(vl, { isPush: !0, state: I })
    ] })
  ] }) });
}, vO = ({
  device: e,
  openByDefault: n
}) => {
  const [r, i] = pe(n);
  if (!e)
    return null;
  const a = 14, {
    model: o,
    os: s,
    carrier: l,
    ad_tracking_enabled: c,
    idfa: m,
    idfv: u,
    google_ad_id: f,
    roku_ad_id: h
  } = e;
  return /* @__PURE__ */ ee.jsxs(
    b,
    {
      className: ct(Mn.collapsible, {
        [Mn.collapsibleIsOpen]: r
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ ee.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Mn.collapsibleHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ ee.jsx($.Paragraph, { variant: "1", children: o }),
              /* @__PURE__ */ ee.jsx(
                Qt,
                {
                  variant: "tertiary",
                  icon: r ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ ee.jsxs(Ye, { className: Mn.list, children: [
          /* @__PURE__ */ ee.jsx(Ye.Text, { variant: "dense", className: Mn.listItem, children: /* @__PURE__ */ ee.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ ee.jsx($.Paragraph, { variant: "3", children: "OS" }),
            /* @__PURE__ */ ee.jsx($.Paragraph, { variant: "5", color: "secondary", children: s })
          ] }) }),
          /* @__PURE__ */ ee.jsx(Ye.Text, { variant: "dense", className: Mn.listItem, children: /* @__PURE__ */ ee.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ ee.jsx($.Paragraph, { variant: "3", children: "Carrier" }),
            /* @__PURE__ */ ee.jsx($.Paragraph, { variant: "5", color: "secondary", children: l })
          ] }) }),
          /* @__PURE__ */ ee.jsx(Ye.Text, { variant: "dense", className: Mn.listItem, children: /* @__PURE__ */ ee.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ ee.jsx($.Paragraph, { variant: "3", children: "Ad tracking enabled" }),
            /* @__PURE__ */ ee.jsx(
              he,
              {
                size: a,
                className: ct({
                  [Mn.collapsibleIconTrue]: c,
                  [Mn.collapsibleIconFalse]: !c
                }),
                name: c ? "check-circle-filled" : "close-circle-filled"
              }
            )
          ] }) }),
          /* @__PURE__ */ ee.jsx(Xe, { content: "The Apple Identifier for Vendor (iOS)", children: /* @__PURE__ */ ee.jsx(Ye.Text, { variant: "dense", className: Mn.listItem, children: /* @__PURE__ */ ee.jsxs(
            b,
            {
              gap: "200",
              justifyContent: "space-between",
              width: "100%",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ ee.jsx($.Paragraph, { variant: "3", children: "Braze device identifier" }),
                /* @__PURE__ */ ee.jsx($.Paragraph, { variant: "5", color: "secondary", children: u })
              ]
            }
          ) }) }),
          /* @__PURE__ */ ee.jsx(Xe, { content: "For iOS", children: /* @__PURE__ */ ee.jsx(Ye.Text, { variant: "dense", className: Mn.listItem, children: /* @__PURE__ */ ee.jsxs(
            b,
            {
              gap: "200",
              justifyContent: "space-between",
              width: "100%",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ ee.jsx($.Paragraph, { variant: "3", children: "Identifier for Advertising" }),
                /* @__PURE__ */ ee.jsx($.Paragraph, { variant: "5", color: "secondary", children: m })
              ]
            }
          ) }) }),
          /* @__PURE__ */ ee.jsx(Ye.Text, { variant: "dense", className: Mn.listItem, children: /* @__PURE__ */ ee.jsxs(
            b,
            {
              gap: "200",
              justifyContent: "space-between",
              width: "100%",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ ee.jsx($.Paragraph, { variant: "3", children: "Roku Advertising id" }),
                /* @__PURE__ */ ee.jsx($.Paragraph, { variant: "5", color: "secondary", children: h })
              ]
            }
          ) }),
          /* @__PURE__ */ ee.jsx(Ye.Text, { variant: "dense", className: Mn.listItem, children: /* @__PURE__ */ ee.jsxs(
            b,
            {
              gap: "200",
              justifyContent: "space-between",
              width: "100%",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ ee.jsx($.Paragraph, { variant: "3", children: "Google Play Advertising id" }),
                /* @__PURE__ */ ee.jsx($.Paragraph, { variant: "5", color: "secondary", children: f })
              ]
            }
          ) })
        ] })
      ]
    }
  );
}, kO = ({ devices: e }) => {
  const n = e && e?.length > 0;
  return /* @__PURE__ */ ee.jsxs(b, { gap: "200", flexDirection: "column", margin: "200 0 0", children: [
    /* @__PURE__ */ ee.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ ee.jsx($.Heading, { variant: "heading-3", children: "Devices" }),
      n && /* @__PURE__ */ ee.jsx(Pn, { size: "small", variant: "success", children: e.length })
    ] }),
    !n && /* @__PURE__ */ ee.jsx(
      $.Paragraph,
      {
        variant: "4",
        margin: "200 0 300 0",
        color: "secondary",
        align: "center",
        children: "There are no devices associated with this customer"
      }
    ),
    e?.map((r, i) => /* @__PURE__ */ ee.jsx(vO, { device: r, openByDefault: i === 0 }, i))
  ] });
}, Ya = {
  optIn: {
    label: "Opt in",
    icon: "check-circle-filled",
    color: "var(--dixa-color-green-500)",
    tooltipContent: "Opt in to receive emails",
    parameter: "opted_in"
  },
  unsubscribe: {
    label: "Unsubscribe",
    icon: "close-circle-filled",
    color: "var(--dixa-color-red-500)",
    tooltipContent: "Unsubscribe from emails",
    parameter: "unsubscribed"
  }
}, ys = ({
  email: e,
  updateTo: n,
  refetchCustomerDetails: r
}) => {
  const { track: i } = jn(), { useMutation: a } = hn(), [o, s] = pe(!1), [l] = a(
    tO,
    {
      onCompleted: (m) => {
        m?.Braze?.updateEmailSubscriptionStatus?.message === "success" && i(n === "optIn" ? "braze:email:subscription:opt-in:succeeded" : "braze:email:subscription:unsubscribe:succeeded");
      }
    }
  ), c = async () => {
    s(!0), await l({
      variables: {
        input: {
          email: e,
          // eslint-disable-next-line camelcase
          subscription_state: Ya[n].parameter
        }
      }
    }), setTimeout(async () => {
      await r().finally(() => s(!1));
    }, 500);
  };
  return /* @__PURE__ */ ee.jsx(Xe, { content: Ya[n].tooltipContent, children: /* @__PURE__ */ ee.jsx(
    tt,
    {
      variant: "secondary",
      color: Ya[n].color,
      isLoading: o,
      onClick: () => c(),
      "data-testid": "braze-subscription-button",
      children: /* @__PURE__ */ ee.jsxs(b, { gap: "100", alignItems: "center", children: [
        /* @__PURE__ */ ee.jsx(
          vl,
          {
            noTooltip: !0,
            state: Ya[n].parameter
          }
        ),
        Ya[n].label
      ] })
    }
  ) });
}, bO = ({
  customerDetails: e,
  showCustomerDetails: n,
  refetchCustomerDetails: r
}) => {
  if (!e)
    return null;
  const { email: i, email_subscribe: a } = e;
  if (!i)
    return null;
  const o = a === "subscribed", s = a === "unsubscribed", l = a === "opted_in";
  return /* @__PURE__ */ ee.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ ee.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ee.jsx($.Heading, { variant: "heading-3", children: "Update Email subscription state" }),
    !n && /* @__PURE__ */ ee.jsx(Ye, { className: Mn.list, children: /* @__PURE__ */ ee.jsx(Ye.Text, { variant: "dense", className: Mn.listItem, children: /* @__PURE__ */ ee.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ ee.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ee.jsx(he, { size: 14, name: "sync" }),
        /* @__PURE__ */ ee.jsx($.Paragraph, { variant: "4", children: "Email subscription state" })
      ] }),
      /* @__PURE__ */ ee.jsx(vl, { state: a })
    ] }) }) }),
    /* @__PURE__ */ ee.jsxs(b, { gap: "200", alignItems: "center", children: [
      o && /* @__PURE__ */ ee.jsxs(ee.Fragment, { children: [
        /* @__PURE__ */ ee.jsx(
          ys,
          {
            email: i,
            updateTo: "optIn",
            refetchCustomerDetails: r
          }
        ),
        /* @__PURE__ */ ee.jsx(
          ys,
          {
            email: i,
            updateTo: "unsubscribe",
            refetchCustomerDetails: r
          }
        )
      ] }),
      s && /* @__PURE__ */ ee.jsx(
        ys,
        {
          email: i,
          updateTo: "optIn",
          refetchCustomerDetails: r
        }
      ),
      l && /* @__PURE__ */ ee.jsx(
        ys,
        {
          email: i,
          updateTo: "unsubscribe",
          refetchCustomerDetails: r
        }
      )
    ] })
  ] }) });
}, _O = ({
  customerDetails: e
}) => {
  if (!e)
    return null;
  const { purchases: n } = e, r = n?.sort(
    (a, o) => o?.count - a?.count
  ), i = r && r.length > 0;
  return /* @__PURE__ */ ee.jsx(ee.Fragment, { children: /* @__PURE__ */ ee.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ee.jsx($.Heading, { variant: "heading-3", children: "Purchases" }),
    !i && /* @__PURE__ */ ee.jsx($.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No purchases available" }),
    i && /* @__PURE__ */ ee.jsx(Ye, { className: Mn.list, children: r.map((a, o) => /* @__PURE__ */ ee.jsx(
      Ye.Text,
      {
        variant: "dense",
        className: Mn.listItem,
        children: /* @__PURE__ */ ee.jsxs(b, { justifyContent: "space-between", children: [
          /* @__PURE__ */ ee.jsx(
            Xe,
            {
              content: /* @__PURE__ */ ee.jsxs(b, { flexDirection: "column", children: [
                /* @__PURE__ */ ee.jsx(b, { children: `First ${Gn(a?.first).format(
                  $t
                )}` }),
                /* @__PURE__ */ ee.jsx(b, { children: `Last ${Gn(a?.last).format(
                  $t
                )}` })
              ] }),
              children: /* @__PURE__ */ ee.jsx($.Paragraph, { variant: "4", children: a?.name })
            }
          ),
          /* @__PURE__ */ ee.jsx($.Paragraph, { variant: "5", children: a?.count })
        ] })
      },
      o
    )) })
  ] }) });
}, xO = ({
  conversationContext: e,
  settings: n
}) => {
  const { track: r } = jn(), { useMutation: i } = hn(), [a, o] = pe(), [s, l] = pe(!1), [c, m] = pe(!1), u = e?.customer?.email, f = e?.customer?.phone_number, h = n.displayCustomerDetails ?? !1, k = n.updateEmailSubscriptionState ?? !1, w = n.displayCustomAttributes ?? !1, N = n.displayCustomEvents ?? !1, j = n.displayPuchases ?? !1, _ = n.displayDevices ?? !1, g = n.displayApps ?? !1, O = !h && !k && !w && !N && !j, [R, { error: F }] = i(
    nO,
    {
      onError: () => {
      },
      onCompleted: (L) => {
        const W = L?.Braze?.exportUserDetails?.users?.[0];
        W ? (o(W), l(!1), r("braze:profile:received")) : (o(void 0), l(!0));
      }
    }
  ), I = async () => {
    u || f ? await R({
      variables: {
        input: {
          // Use the email if exists. Otherwise use the phone number. We decided
          // to not search for both together, because we receive a customer
          // entity for each input parameter and we only want one.
          /* eslint-disable camelcase */
          ...u ? { email_address: u } : { phone: f },
          fields_to_export: [
            "external_id",
            "braze_id",
            "created_at",
            "email",
            "first_name",
            "last_name",
            "dob",
            "home_city",
            "country",
            "phone",
            "language",
            "time_zone",
            "total_revenue",
            "push_subscribe",
            "email_subscribe",
            "custom_attributes",
            "custom_events",
            "purchases",
            "apps",
            "devices"
          ]
          /* eslint-enable camelcase */
        }
      }
    }) : l(!0);
  };
  if (Qe(() => {
    async function L() {
      m(!0), await I();
    }
    L().finally(() => m(!1));
  }, [u, f]), F) {
    const L = F.graphQLErrors;
    return Ul({ errors: L }) ? /* @__PURE__ */ ee.jsx(
      $.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        "data-testid": "widget-downstream-api-forbidden-error",
        children: "The API key used for the integration does not have the necessary access rights. Please contact your administrator."
      }
    ) : Ml({ errors: L }) ? /* @__PURE__ */ ee.jsx(
      $.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        "data-testid": "widget-downstream-api-authorization-error",
        children: "The integration could not authorize against Braze. Please contact your administrator."
      }
    ) : /* @__PURE__ */ ee.jsx($n, { error: F });
  }
  return c ? /* @__PURE__ */ ee.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ ee.jsx(mn, {}) }) : O ? /* @__PURE__ */ ee.jsx(
    $.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      align: "center",
      "data-testid": "widget-no-features",
      children: "All features toggles in the settings are disabled."
    }
  ) : s ? /* @__PURE__ */ ee.jsx(
    $.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      align: "center",
      "data-testid": "widget-no-customer-found",
      children: "No customer found with this email or phone number."
    }
  ) : /* @__PURE__ */ ee.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "0 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        h && /* @__PURE__ */ ee.jsx(gO, { customerDetails: a }),
        k && !!a && /* @__PURE__ */ ee.jsx(
          bO,
          {
            customerDetails: a,
            showCustomerDetails: h,
            refetchCustomerDetails: async () => await I()
          }
        ),
        w && !!a && /* @__PURE__ */ ee.jsx(pO, { customerDetails: a }),
        N && !!a && /* @__PURE__ */ ee.jsx(fO, { customerDetails: a }),
        j && !!a && /* @__PURE__ */ ee.jsx(_O, { customerDetails: a }),
        _ && !!a && /* @__PURE__ */ ee.jsx(kO, { devices: a?.devices }),
        g && !!a && /* @__PURE__ */ ee.jsx(mO, { apps: a?.apps })
      ]
    }
  );
}, qo = [
  {
    key: "apiHostName",
    label: "API endpoint",
    type: "string",
    secret: !1,
    defaultValue: ""
  },
  {
    key: "brazeApiKey",
    label: "API key",
    type: "string",
    secret: !0,
    defaultValue: ""
  },
  {
    key: "displayCustomerDetails",
    label: "Display customer details",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "updateEmailSubscriptionState",
    label: "Display the button to change the email subscription state",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayCustomAttributes",
    label: "Display a list of custom attributes",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayCustomEvents",
    label: "Display a list of custom events",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    // Yeah, there is a typo 😅 We need to stick with it now, since customers
    // might have used it in the past..
    key: "displayPuchases",
    label: "Display a list of purchases",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayDevices",
    label: "Display customer devices",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayApps",
    label: "Display customer apps",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  }
], ei = ir(qo), SO = {
  enabled: !1,
  name: "",
  brazeApiKey: "",
  ...Bl([], qo)
}, NO = ({
  integrationId: e,
  handleRedirect: n,
  showNotification: r,
  automationCouplingState: i,
  renderConditionsEditor: a
}) => {
  const o = !e, s = ut({
    mode: "onChange",
    defaultValues: SO
  }), {
    create: l,
    update: c,
    remove: m,
    isLoading: u,
    error: f,
    misconfigurationCause: h,
    setMisconfigurationCause: k
  } = mr({
    integrationId: e,
    integrationType: "BRAZE",
    handleRedirect: n,
    showNotification: r
  }), {
    isLoading: w,
    error: N,
    isWidgetUnknown: j,
    refetch: _,
    widgetConfiguration: g
  } = pr({
    integrationId: e,
    fieldDefinitions: qo,
    form: s,
    onMisconfigured: k
  }), { renderConditions: O, setRenderConditions: R, renderConditionsForSubmit: F } = fr({
    integrationId: e,
    widgetConfiguration: g,
    renderConditionsEditor: a
  }), I = (W) => yr(W, {
    fieldDefinitions: qo,
    isCreationMode: o,
    create: l,
    update: c,
    renderConditions: F
  }), L = s.watch("name");
  return /* @__PURE__ */ ee.jsxs(
    hr,
    {
      form: s,
      integrationId: e,
      onValidSubmit: I,
      error: N ?? f,
      onRetry: N ? _ : void 0,
      isLoading: u || w,
      isWidgetUnknown: j,
      children: [
        h && /* @__PURE__ */ ee.jsx(gr, { cause: h }),
        /* @__PURE__ */ ee.jsxs(et, { children: [
          /* @__PURE__ */ ee.jsx(X, { children: /* @__PURE__ */ ee.jsx(He, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ ee.jsx(
            yn,
            {
              name: "enabled",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ ee.jsx(X, { span: 3, children: /* @__PURE__ */ ee.jsx(
            On,
            {
              name: "name",
              label: "Widget name",
              control: s.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ ee.jsx(X, { span: 3 }),
          /* @__PURE__ */ ee.jsx(X, { span: 3, children: /* @__PURE__ */ ee.jsx(
            On,
            {
              name: "apiHostName",
              label: ei.apiHostName,
              control: s.control,
              rules: {
                required: "API endpoint is required",
                validate: (W) => zl(W) || !0
              },
              componentProps: {
                placeholder: "REST API endpoint for your region, e.g. rest.iad-01.braze.com",
                autoComplete: "off",
                prefix: "https://"
              }
            }
          ) }),
          /* @__PURE__ */ ee.jsx(X, { span: 3 }),
          /* @__PURE__ */ ee.jsx(X, { span: 3, children: /* @__PURE__ */ ee.jsx(
            $r,
            {
              name: "brazeApiKey",
              label: ei.brazeApiKey,
              control: s.control,
              isCreationMode: o,
              rules: { required: "API key is required" },
              componentProps: {
                placeholder: "Insert your API key",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ ee.jsx(X, { span: 3 }),
          /* @__PURE__ */ ee.jsx(X, { span: 3, children: /* @__PURE__ */ ee.jsx(He, { label: ei.displayCustomerDetails, children: /* @__PURE__ */ ee.jsx(
            yn,
            {
              name: "displayCustomerDetails",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ ee.jsx(X, { span: 3 }),
          /* @__PURE__ */ ee.jsx(X, { span: 3, children: /* @__PURE__ */ ee.jsx(He, { label: ei.updateEmailSubscriptionState, children: /* @__PURE__ */ ee.jsx(
            yn,
            {
              name: "updateEmailSubscriptionState",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ ee.jsx(X, { span: 3 }),
          /* @__PURE__ */ ee.jsx(X, { span: 3, children: /* @__PURE__ */ ee.jsx(He, { label: ei.displayCustomAttributes, children: /* @__PURE__ */ ee.jsx(
            yn,
            {
              name: "displayCustomAttributes",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ ee.jsx(X, { span: 3 }),
          /* @__PURE__ */ ee.jsx(X, { span: 3, children: /* @__PURE__ */ ee.jsx(He, { label: ei.displayCustomEvents, children: /* @__PURE__ */ ee.jsx(
            yn,
            {
              name: "displayCustomEvents",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ ee.jsx(X, { span: 3 }),
          /* @__PURE__ */ ee.jsx(X, { span: 3, children: /* @__PURE__ */ ee.jsx(He, { label: ei.displayPuchases, children: /* @__PURE__ */ ee.jsx(
            yn,
            {
              name: "displayPuchases",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ ee.jsx(X, { span: 3 }),
          /* @__PURE__ */ ee.jsx(X, { span: 3, children: /* @__PURE__ */ ee.jsx(He, { label: ei.displayDevices, children: /* @__PURE__ */ ee.jsx(
            yn,
            {
              name: "displayDevices",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ ee.jsx(X, { span: 3 }),
          /* @__PURE__ */ ee.jsx(X, { span: 3, children: /* @__PURE__ */ ee.jsx(He, { label: ei.displayApps, children: /* @__PURE__ */ ee.jsx(
            yn,
            {
              name: "displayApps",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ ee.jsx(X, { span: 3 }),
          a && O !== null && /* @__PURE__ */ ee.jsx(X, { children: a({
            value: O,
            onChange: R,
            configurationKey: g?.id
          }) })
        ] }),
        /* @__PURE__ */ ee.jsx(
          vr,
          {
            integrationType: "BRAZE",
            integrationId: e,
            widgetName: L,
            isCreationMode: o,
            isSubmitting: s.formState.isSubmitting,
            automationCouplingState: i,
            onConfirmDelete: () => m()
          }
        )
      ]
    }
  );
};
function jO() {
  var e = Er(!1), n = ft(function() {
    return e.current;
  }, []);
  return Qe(function() {
    return e.current = !0, function() {
      e.current = !1;
    };
  }, []), n;
}
var wO = function(e) {
  e === void 0 && (e = {});
  var n = pe(e), r = n[0], i = n[1], a = ft(function(o) {
    i(function(s) {
      return Object.assign({}, s, o instanceof Function ? o(s) : o);
    });
  }, []);
  return [r, a];
}, CO = function(e, n) {
  return typeof n == "boolean" ? n : !e;
}, L_ = function(e) {
  return NI(CO, e);
}, um, V_;
function FO() {
  return V_ || (V_ = 1, um = function() {
    var e = document.getSelection();
    if (!e.rangeCount)
      return function() {
      };
    for (var n = document.activeElement, r = [], i = 0; i < e.rangeCount; i++)
      r.push(e.getRangeAt(i));
    switch (n.tagName.toUpperCase()) {
      // .toUpperCase handles XHTML
      case "INPUT":
      case "TEXTAREA":
        n.blur();
        break;
      default:
        n = null;
        break;
    }
    return e.removeAllRanges(), function() {
      e.type === "Caret" && e.removeAllRanges(), e.rangeCount || r.forEach(function(a) {
        e.addRange(a);
      }), n && n.focus();
    };
  }), um;
}
var mm, z_;
function IO() {
  if (z_) return mm;
  z_ = 1;
  var e = FO(), n = {
    "text/plain": "Text",
    "text/html": "Url",
    default: "Text"
  }, r = "Copy to clipboard: #{key}, Enter";
  function i(o) {
    var s = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
    return o.replace(/#{\s*key\s*}/g, s);
  }
  function a(o, s) {
    var l, c, m, u, f, h, k = !1;
    s || (s = {}), l = s.debug || !1;
    try {
      m = e(), u = document.createRange(), f = document.getSelection(), h = document.createElement("span"), h.textContent = o, h.ariaHidden = "true", h.style.all = "unset", h.style.position = "fixed", h.style.top = 0, h.style.clip = "rect(0, 0, 0, 0)", h.style.whiteSpace = "pre", h.style.webkitUserSelect = "text", h.style.MozUserSelect = "text", h.style.msUserSelect = "text", h.style.userSelect = "text", h.addEventListener("copy", function(N) {
        if (N.stopPropagation(), s.format)
          if (N.preventDefault(), typeof N.clipboardData > "u") {
            l && console.warn("unable to use e.clipboardData"), l && console.warn("trying IE specific stuff"), window.clipboardData.clearData();
            var j = n[s.format] || n.default;
            window.clipboardData.setData(j, o);
          } else
            N.clipboardData.clearData(), N.clipboardData.setData(s.format, o);
        s.onCopy && (N.preventDefault(), s.onCopy(N.clipboardData));
      }), document.body.appendChild(h), u.selectNodeContents(h), f.addRange(u);
      var w = document.execCommand("copy");
      if (!w)
        throw new Error("copy command was unsuccessful");
      k = !0;
    } catch (N) {
      l && console.error("unable to copy using execCommand: ", N), l && console.warn("trying IE specific stuff");
      try {
        window.clipboardData.setData(s.format || "text", o), s.onCopy && s.onCopy(window.clipboardData), k = !0;
      } catch (j) {
        l && console.error("unable to copy using clipboardData: ", j), l && console.error("falling back to prompt"), c = i("message" in s ? s.message : r), window.prompt(c, o);
      }
    } finally {
      f && (typeof f.removeRange == "function" ? f.removeRange(u) : f.removeAllRanges()), h && document.body.removeChild(h), m();
    }
    return k;
  }
  return mm = a, mm;
}
var $O = IO();
const EO = /* @__PURE__ */ Ty($O);
var YC = function() {
  var e = jO(), n = wO({
    value: void 0,
    error: void 0,
    noUserInteraction: !0
  }), r = n[0], i = n[1], a = ft(function(o) {
    if (e()) {
      var s, l;
      try {
        if (typeof o != "string" && typeof o != "number") {
          var c = new Error("Cannot copy typeof " + typeof o + " to clipboard, must be a string");
          process.env.NODE_ENV === "development" && console.error(c), i({
            value: o,
            error: c,
            noUserInteraction: !0
          });
          return;
        } else if (o === "") {
          var c = new Error("Cannot copy empty string to clipboard.");
          process.env.NODE_ENV === "development" && console.error(c), i({
            value: o,
            error: c,
            noUserInteraction: !0
          });
          return;
        }
        l = o.toString(), s = EO(l), i({
          value: l,
          error: void 0,
          noUserInteraction: s
        });
      } catch (m) {
        i({
          value: l,
          error: m,
          noUserInteraction: s
        });
      }
    }
  }, []);
  return [r, a];
};
function TO(e, n) {
  n === void 0 && (n = 0);
  var r = Er(!1), i = Er(), a = Er(e), o = ft(function() {
    return r.current;
  }, []), s = ft(function() {
    r.current = !1, i.current && clearTimeout(i.current), i.current = setTimeout(function() {
      r.current = !0, a.current();
    }, n);
  }, [n]), l = ft(function() {
    r.current = null, i.current && clearTimeout(i.current);
  }, []);
  return Qe(function() {
    a.current = e;
  }, [e]), Qe(function() {
    return s(), l;
  }, [n]), [o, l, s];
}
function bi(e, n, r) {
  n === void 0 && (n = 0), r === void 0 && (r = []);
  var i = TO(e, n), a = i[0], o = i[1], s = i[2];
  return Qe(s, r), [a, o];
}
var RO = function(e) {
  Qe(e, []);
}, DO = function(e, n) {
  var r = Er(function() {
  });
  Qe(function() {
    r.current = e;
  }), Qe(function() {
    if (n !== null) {
      var i = setInterval(function() {
        return r.current();
      }, n || 0);
      return function() {
        return clearInterval(i);
      };
    }
  }, [n]);
}, OO = function(e) {
  e === void 0 && (e = {});
  var n = pe(e), r = n[0], i = n[1], a = Xn(function() {
    return {
      set: function(s, l) {
        i(function(c) {
          var m;
          return bd(bd({}, c), (m = {}, m[s] = l, m));
        });
      },
      setAll: function(s) {
        i(s);
      },
      remove: function(s) {
        i(function(l) {
          var c = l, m = s;
          c[m];
          var u = zI(c, [typeof m == "symbol" ? m : m + ""]);
          return u;
        });
      },
      reset: function() {
        return i(e);
      }
    };
  }, [i]), o = bd({ get: ft(function(s) {
    return r[s];
  }, [r]) }, a);
  return [r, o];
}, PO = function(e) {
  var n = Er(e);
  n.current = e, RO(function() {
    return function() {
      return n.current();
    };
  });
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._contentWrapper_1vx3c_1{margin-bottom:var(--dixa-size-spacer-300)}._contentWrapperHeadline_1vx3c_4{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-100);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-tertiary);margin-bottom:var(--dixa-size-spacer-100)}._contentWrapperBody_1vx3c_11{max-height:75vh;overflow-y:auto}._contentWrapperAssigneeIcon_1vx3c_15{border-radius:50%;width:var(--dixa-size-spacer-300);vertical-align:middle}._contentWrapperStatusTag_1vx3c_20{margin-right:var(--dixa-size-spacer-200)}._collapse_1bdjy_1{border:1px solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);padding:0}._collapseHeader_1bdjy_10>div{padding:var(--dixa-size-spacer-300) 0!important}._collapseHeader_1bdjy_10>div>div>p{white-space:unset!important}._collapseHeader_1bdjy_10>div:first-child{width:100%}._collapseHeader_1bdjy_10>div:first-child div:first-child{width:100%}._collapseHeader_1bdjy_10>div:first-child div:first-child p{width:calc(100% - 20px)}._collapseHeader_1bdjy_10{background-color:transparent!important;padding:0 var(--dixa-size-spacer-300) 0 0;letter-spacing:-.08px;color:var(--dixa-color-neutral-500)}._collapseHeaderKey_1bdjy_31{font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-color-neutral-700)}._collapseHeaderKeyIcon_1bdjy_36{margin-top:-2px;margin-right:var(--dixa-size-spacer-100);vertical-align:middle}._collapseHeaderKeyLink_1bdjy_41{text-decoration:none}._collapseHeaderIcon_1bdjy_44{padding-top:.35em;margin-left:var(--dixa-size-spacer-100);vertical-align:text-bottom}._collapseHeaderTitle_1bdjy_49{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-300);line-height:var(--dixa-typography-line-height-300);letter-spacing:-.16px;color:var(--dixa-typography-color-primary);width:100%}._collapseContent_1bdjy_57{padding:var(--dixa-size-spacer-200) var(--dixa-size-spacer-300)!important}._collapseContentButtonSpacer_1bdjy_60{margin-top:var(--dixa-size-spacer-250)}._collapseContentButtonLink_1bdjy_63{color:var(--dixa-typography-color-link)}._result_1uaom_1{padding:0 var(--dixa-size-spacer-200);margin:0;outline:0;border:0;color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:12px;line-height:32px;height:48px;width:100%;cursor:pointer}._result_1uaom_1:hover,._result_1uaom_1:focus{background-color:var(--dixa-color-neutral-100)}._resultName_1uaom_21{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:var(--dixa-typography-weight-semibold)}._resultItemIcon_1uaom_29{margin-top:-2px;margin-right:var(--dixa-size-spacer-100);vertical-align:middle}._resultDescription_1uaom_34{width:100%;text-align:left;font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-secondary);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;margin-top:-.5em;margin-bottom:.5em}._resultLinkIcon_1uaom_46{position:absolute;right:5px;background-color:var(--dixa-color-neutral-000);border:1px solid var(--dixa-color-neutral-300);border-radius:5px;color:var(--dixa-color-neutral-500)}._tooltip_1uaom_55{width:500px;max-height:60vh;overflow:hidden;text-overflow:ellipsis}._tooltipName_1uaom_61{text-align:left;white-space:nowrap;font-weight:var(--dixa-typography-weight-semibold)}._tooltipNameIcon_1uaom_66{height:var(--dixa-typography-line-height-300);padding-right:var(--dixa-size-spacer-100);margin-top:-2px}._tooltipTag_1uaom_71{width:fit-content;max-width:15em}._itemButton_3sxfy_1{border:none;padding:0}._result_3sxfy_6{padding:0 var(--dixa-size-spacer-200);margin:0;outline:0;border:0;color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:var(--dixa-typography-size-200);line-height:32px;height:48px;width:100%;cursor:pointer}._result_3sxfy_6:hover,._result_3sxfy_6:focus{background-color:var(--dixa-color-neutral-100)}._resultIcon_3sxfy_26{height:var(--dixa-size-spacer-400);padding-right:var(--dixa-size-spacer-250)}._resultName_3sxfy_30{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:var(--dixa-typography-weight-normal)}._resultCheckIcon_3sxfy_38{height:var(--dixa-size-spacer-400)}._resultAssigneeIcon_3sxfy_41{border-radius:50%;width:var(--dixa-size-spacer-300);vertical-align:middle;margin-right:var(--dixa-size-spacer-200)}._modalBody_1hk1o_1{width:600px}._modalBodyFormFields_1hk1o_4{display:grid;gap:var(--dixa-size-spacer-300) var(--dixa-size-spacer-400)}._wrapper_19v8w_1{gap:var(--dixa-size-spacer-250);margin-bottom:var(--dixa-size-spacer-300)}._inputWrapper_19v8w_6{background-color:var(--dixa-color-neutral-100);border-radius:var(--dixa-size-border-radius-100);margin:var(--dixa-size-spacer-300) 0;gap:var(--dixa-size-spacer-250);padding:var(--dixa-size-spacer-300);text-align:center}._inputField_19v8w_15{text-align:center}._buttonLink_19v8w_19{color:var(--dixa-typography-color-link)}._noItemsFound_19v8w_23{color:var(--dixa-color-neutral-400);font-size:var(--dixa-typography-size-200)}._createIssueButton_19v8w_28{min-height:38px}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var pm = { exports: {} }, Ja = {}, U_;
function AO() {
  if (U_) return Ja;
  U_ = 1;
  var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, c, m) {
    var u, f = {}, h = null, k = null;
    m !== void 0 && (h = "" + m), c.key !== void 0 && (h = "" + c.key), c.ref !== void 0 && (k = c.ref);
    for (u in c) i.call(c, u) && !o.hasOwnProperty(u) && (f[u] = c[u]);
    if (l && l.defaultProps) for (u in c = l.defaultProps, c) f[u] === void 0 && (f[u] = c[u]);
    return { $$typeof: n, type: l, key: h, ref: k, props: f, _owner: a.current };
  }
  return Ja.Fragment = r, Ja.jsx = s, Ja.jsxs = s, Ja;
}
var gs = {}, M_;
function LO() {
  return M_ || (M_ = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), c = /* @__PURE__ */ Symbol.for("react.forward_ref"), m = /* @__PURE__ */ Symbol.for("react.suspense"), u = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), k = /* @__PURE__ */ Symbol.for("react.offscreen"), w = Symbol.iterator, N = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var d = w && t[w] || t[N];
      return typeof d == "function" ? d : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var d = arguments.length, p = new Array(d > 1 ? d - 1 : 0), y = 1; y < d; y++)
          p[y - 1] = arguments[y];
        O("error", t, p);
      }
    }
    function O(t, d, p) {
      {
        var y = _.ReactDebugCurrentFrame, C = y.getStackAddendum();
        C !== "" && (d += "%s", p = p.concat([C]));
        var T = p.map(function(S) {
          return String(S);
        });
        T.unshift("Warning: " + d), Function.prototype.apply.call(console[t], console, T);
      }
    }
    var R = !1, F = !1, I = !1, L = !1, W = !1, J;
    J = /* @__PURE__ */ Symbol.for("react.module.reference");
    function re(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || W || t === a || t === m || t === u || L || t === k || R || F || I || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === J || t.getModuleId !== void 0));
    }
    function K(t, d, p) {
      var y = t.displayName;
      if (y)
        return y;
      var C = d.displayName || d.name || "";
      return C !== "" ? p + "(" + C + ")" : p;
    }
    function Y(t) {
      return t.displayName || "Context";
    }
    function P(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var d = t;
            return Y(d) + ".Consumer";
          case s:
            var p = t;
            return Y(p._context) + ".Provider";
          case c:
            return K(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : P(t.type) || "Memo";
          case h: {
            var C = t, T = C._payload, S = C._init;
            try {
              return P(S(T));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, ie = 0, we, me, le, ge, V, be, Oe;
    function q() {
    }
    q.__reactDisabledLog = !0;
    function Ge() {
      {
        if (ie === 0) {
          we = console.log, me = console.info, le = console.warn, ge = console.error, V = console.group, be = console.groupCollapsed, Oe = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: q,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ie++;
      }
    }
    function sn() {
      {
        if (ie--, ie === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, t, {
              value: we
            }),
            info: B({}, t, {
              value: me
            }),
            warn: B({}, t, {
              value: le
            }),
            error: B({}, t, {
              value: ge
            }),
            group: B({}, t, {
              value: V
            }),
            groupCollapsed: B({}, t, {
              value: be
            }),
            groupEnd: B({}, t, {
              value: Oe
            })
          });
        }
        ie < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ie = _.ReactCurrentDispatcher, Ue;
    function De(t, d, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (C) {
            var y = C.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Ae;
    {
      var Je = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Je();
    }
    function Ee(t, d) {
      if (!t || Be)
        return "";
      {
        var p = Ae.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Be = !0;
      var C = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var T;
      T = Ie.current, Ie.current = null, Ge();
      try {
        if (d) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (ne) {
              y = ne;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (ne) {
              y = ne;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            y = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && y && typeof ne.stack == "string") {
          for (var x = ne.stack.split(`
`), Z = y.stack.split(`
`), A = x.length - 1, M = Z.length - 1; A >= 1 && M >= 0 && x[A] !== Z[M]; )
            M--;
          for (; A >= 1 && M >= 0; A--, M--)
            if (x[A] !== Z[M]) {
              if (A !== 1 || M !== 1)
                do
                  if (A--, M--, M < 0 || x[A] !== Z[M]) {
                    var ue = `
` + x[A].replace(" at new ", " at ");
                    return t.displayName && ue.includes("<anonymous>") && (ue = ue.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, ue), ue;
                  }
                while (A >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Ie.current = T, sn(), Error.prepareStackTrace = C;
      }
      var ze = t ? t.displayName || t.name : "", Te = ze ? De(ze) : "";
      return typeof t == "function" && Ae.set(t, Te), Te;
    }
    function Me(t, d, p) {
      return Ee(t, !1);
    }
    function en(t) {
      var d = t.prototype;
      return !!(d && d.isReactComponent);
    }
    function se(t, d, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ee(t, en(t));
      if (typeof t == "string")
        return De(t);
      switch (t) {
        case m:
          return De("Suspense");
        case u:
          return De("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case c:
            return Me(t.render);
          case f:
            return se(t.type, d, p);
          case h: {
            var y = t, C = y._payload, T = y._init;
            try {
              return se(T(C), d, p);
            } catch {
            }
          }
        }
      return "";
    }
    var de = Object.prototype.hasOwnProperty, Se = {}, Ve = _.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var d = t._owner, p = se(t.type, t._source, d ? d.type : null);
        Ve.setExtraStackFrame(p);
      } else
        Ve.setExtraStackFrame(null);
    }
    function kn(t, d, p, y, C) {
      {
        var T = Function.call.bind(de);
        for (var S in t)
          if (T(t, S)) {
            var x = void 0;
            try {
              if (typeof t[S] != "function") {
                var Z = Error((y || "React class") + ": " + p + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Z.name = "Invariant Violation", Z;
              }
              x = t[S](d, S, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (A) {
              x = A;
            }
            x && !(x instanceof Error) && (Pe(C), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, S, typeof x), Pe(null)), x instanceof Error && !(x.message in Se) && (Se[x.message] = !0, Pe(C), g("Failed %s type: %s", p, x.message), Pe(null));
          }
      }
    }
    var Q = Array.isArray;
    function E(t) {
      return Q(t);
    }
    function z(t) {
      {
        var d = typeof Symbol == "function" && Symbol.toStringTag, p = d && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function ae(t) {
      try {
        return ce(t), !1;
      } catch {
        return !0;
      }
    }
    function ce(t) {
      return "" + t;
    }
    function U(t) {
      if (ae(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", z(t)), ce(t);
    }
    var G = _.ReactCurrentOwner, ve = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, je, Re;
    function rn(t) {
      if (de.call(t, "ref")) {
        var d = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (d && d.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function bn(t) {
      if (de.call(t, "key")) {
        var d = Object.getOwnPropertyDescriptor(t, "key").get;
        if (d && d.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function an(t, d) {
      typeof t.ref == "string" && G.current;
    }
    function fn(t, d) {
      {
        var p = function() {
          je || (je = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", d));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function En(t, d) {
      {
        var p = function() {
          Re || (Re = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", d));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var _n = function(t, d, p, y, C, T, S) {
      var x = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: d,
        ref: p,
        props: S,
        // Record the component responsible for creating this element.
        _owner: T
      };
      return x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(x, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(x, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: C
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    };
    function Fn(t, d, p, y, C) {
      {
        var T, S = {}, x = null, Z = null;
        p !== void 0 && (U(p), x = "" + p), bn(d) && (U(d.key), x = "" + d.key), rn(d) && (Z = d.ref, an(d));
        for (T in d)
          de.call(d, T) && !ve.hasOwnProperty(T) && (S[T] = d[T]);
        if (t && t.defaultProps) {
          var A = t.defaultProps;
          for (T in A)
            S[T] === void 0 && (S[T] = A[T]);
        }
        if (x || Z) {
          var M = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          x && fn(S, M), Z && En(S, M);
        }
        return _n(t, x, Z, C, y, G.current, S);
      }
    }
    var Ze = _.ReactCurrentOwner, gn = _.ReactDebugCurrentFrame;
    function Le(t) {
      if (t) {
        var d = t._owner, p = se(t.type, t._source, d ? d.type : null);
        gn.setExtraStackFrame(p);
      } else
        gn.setExtraStackFrame(null);
    }
    var dn;
    dn = !1;
    function cn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function Nn() {
      {
        if (Ze.current) {
          var t = P(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Bn(t) {
      return "";
    }
    var Sn = {};
    function An(t) {
      {
        var d = Nn();
        if (!d) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (d = `

Check the top-level render call using <` + p + ">.");
        }
        return d;
      }
    }
    function vn(t, d) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = An(d);
        if (Sn[p])
          return;
        Sn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Ze.current && (y = " It was passed a child from " + P(t._owner.type) + "."), Le(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Le(null);
      }
    }
    function xn(t, d) {
      {
        if (typeof t != "object")
          return;
        if (E(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            cn(y) && vn(y, d);
          }
        else if (cn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var C = j(t);
          if (typeof C == "function" && C !== t.entries)
            for (var T = C.call(t), S; !(S = T.next()).done; )
              cn(S.value) && vn(S.value, d);
        }
      }
    }
    function Ln(t) {
      {
        var d = t.type;
        if (d == null || typeof d == "string")
          return;
        var p;
        if (typeof d == "function")
          p = d.propTypes;
        else if (typeof d == "object" && (d.$$typeof === c || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        d.$$typeof === f))
          p = d.propTypes;
        else
          return;
        if (p) {
          var y = P(d);
          kn(p, t.props, "prop", y, t);
        } else if (d.PropTypes !== void 0 && !dn) {
          dn = !0;
          var C = P(d);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", C || "Unknown");
        }
        typeof d.getDefaultProps == "function" && !d.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var d = Object.keys(t.props), p = 0; p < d.length; p++) {
          var y = d[p];
          if (y !== "children" && y !== "key") {
            Le(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Le(null);
            break;
          }
        }
        t.ref !== null && (Le(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Le(null));
      }
    }
    var Cn = {};
    function wn(t, d, p, y, C, T) {
      {
        var S = re(t);
        if (!S) {
          var x = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (x += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Z = Bn();
          Z ? x += Z : x += Nn();
          var A;
          t === null ? A = "null" : E(t) ? A = "array" : t !== void 0 && t.$$typeof === n ? (A = "<" + (P(t.type) || "Unknown") + " />", x = " Did you accidentally export a JSX literal instead of a component?") : A = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", A, x);
        }
        var M = Fn(t, d, p, C, T);
        if (M == null)
          return M;
        if (S) {
          var ue = d.children;
          if (ue !== void 0)
            if (y)
              if (E(ue)) {
                for (var ze = 0; ze < ue.length; ze++)
                  xn(ue[ze], t);
                Object.freeze && Object.freeze(ue);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              xn(ue, t);
        }
        if (de.call(d, "key")) {
          var Te = P(t), ne = Object.keys(d).filter(function(Kn) {
            return Kn !== "key";
          }), un = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Cn[Te + un]) {
            var Rn = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, un, Te, Rn, Te), Cn[Te + un] = !0;
          }
        }
        return t === i ? Vn(M) : Ln(M), M;
      }
    }
    function zn(t, d, p) {
      return wn(t, d, p, !0);
    }
    function qn(t, d, p) {
      return wn(t, d, p, !1);
    }
    var Un = qn, Wn = zn;
    gs.Fragment = i, gs.jsx = Un, gs.jsxs = Wn;
  })()), gs;
}
var B_;
function VO() {
  return B_ || (B_ = 1, process.env.NODE_ENV === "production" ? pm.exports = AO() : pm.exports = LO()), pm.exports;
}
var xe = VO();
const zO = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "IssueFields" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_Issue" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", alias: { kind: "Name", value: "issueState" }, name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] }, UO = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "PullRequestFields" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_PullRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", alias: { kind: "Name", value: "prState" }, name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] }, MO = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getGithubOrganizationMembersByName" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "organizationQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "usersQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxResults" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "organization" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "login" }, value: { kind: "Variable", name: { kind: "Name", value: "organizationQuery" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "teams" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "members" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }, { kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "usersQuery" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "login" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrl" } }] } }] } }] } }] } }] } }] } }] } }] } }] } }] }, BO = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createGithubIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "GitHub_CreateIssueInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "createIssue" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issue" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] }, qO = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getGithubRepositoriesByName" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxResults" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "search" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }, { kind: "Argument", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "REPOSITORY" } }, { kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "repositoryCount" } }, { kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_Repository" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] } }] }, HO = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchItems" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "prQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxIssueResults" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxPRResults" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", alias: { kind: "Name", value: "issues" }, name: { kind: "Name", value: "search" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } } }, { kind: "Argument", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "ISSUE" } }, { kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxIssueResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issueCount" } }, { kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_Issue" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "pullRequests" }, name: { kind: "Name", value: "search" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "prQuery" } } }, { kind: "Argument", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "ISSUE" } }, { kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxPRResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issueCount" } }, { kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_PullRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }] } }] } }] }, WO = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "owner" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueNumber" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "repository" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "owner" }, value: { kind: "Variable", name: { kind: "Name", value: "owner" } } }, { kind: "Argument", name: { kind: "Name", value: "name" }, value: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issue" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "number" }, value: { kind: "Variable", name: { kind: "Name", value: "issueNumber" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }] } }] }, KO = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getPullRequest" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "owner" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "prNumber" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "repository" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "owner" }, value: { kind: "Variable", name: { kind: "Name", value: "owner" } } }, { kind: "Argument", name: { kind: "Name", value: "name" }, value: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pullRequest" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "number" }, value: { kind: "Variable", name: { kind: "Name", value: "prNumber" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }] } }] }, GO = {
  "\n  query getGithubOrganizationMembersByName(\n    $organizationQuery: String!\n    $usersQuery: String!\n    $maxResults: Int!\n  ) {\n    GitHub {\n      organization(login: $organizationQuery) {\n        teams(first: $maxResults) {\n          edges {\n            node {\n              id\n              name\n              members(first: $maxResults, query: $usersQuery) {\n                edges {\n                  node {\n                    id\n                    name\n                    login\n                    avatarUrl\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": MO,
  "\n  mutation createGithubIssue($input: GitHub_CreateIssueInput!) {\n    GitHub {\n      createIssue(input: $input) {\n        issue {\n          id\n          number\n          repository {\n            name\n          }\n        }\n      }\n    }\n  }\n": BO,
  "\n  query getGithubRepositoriesByName($query: String!, $maxResults: Int!) {\n    GitHub {\n      search(query: $query, type: REPOSITORY, first: $maxResults) {\n        repositoryCount\n        edges {\n          node {\n            ... on GitHub_Repository {\n              id\n              name\n            }\n          }\n        }\n      }\n    }\n  }\n": qO,
  "\n  fragment IssueFields on GitHub_Issue {\n    id\n    number\n    title\n    body\n    bodyText\n    author {\n      avatarUrl\n      login\n    }\n    issueState: state\n    assignees(first: 10) {\n      nodes {\n        avatarUrl\n        name\n      }\n    }\n    labels(first: 10) {\n      nodes {\n        color\n        name\n      }\n    }\n    repository {\n      name\n      owner {\n        login\n      }\n    }\n  }\n": zO,
  "\n  fragment PullRequestFields on GitHub_PullRequest {\n    id\n    number\n    title\n    body\n    bodyText\n    author {\n      avatarUrl\n      login\n    }\n    prState: state\n    assignees(first: 10) {\n      nodes {\n        avatarUrl\n        name\n      }\n    }\n    labels(first: 10) {\n      nodes {\n        color\n        name\n      }\n    }\n    repository {\n      name\n      owner {\n        login\n      }\n    }\n  }\n": UO,
  "\n  query searchItems(\n    $issueQuery: String!\n    $prQuery: String!\n    $maxIssueResults: Int\n    $maxPRResults: Int\n  ) {\n    GitHub {\n      issues: search(query: $issueQuery, type: ISSUE, first: $maxIssueResults) {\n        issueCount\n        nodes {\n          ... on GitHub_Issue {\n            id\n            number\n            title\n            body\n            bodyText\n            author {\n              avatarUrl\n              login\n            }\n            state\n            assignees(first: 10) {\n              nodes {\n                avatarUrl\n                name\n              }\n            }\n            labels(first: 10) {\n              nodes {\n                color\n                name\n              }\n            }\n            repository {\n              name\n              owner {\n                login\n              }\n            }\n          }\n        }\n      }\n      pullRequests: search(query: $prQuery, type: ISSUE, first: $maxPRResults) {\n        issueCount\n        nodes {\n          ... on GitHub_PullRequest {\n            id\n            number\n            title\n            body\n            bodyText\n            author {\n              avatarUrl\n              login\n            }\n            state\n            assignees(first: 10) {\n              nodes {\n                avatarUrl\n                name\n              }\n            }\n            labels(first: 10) {\n              nodes {\n                color\n                name\n              }\n            }\n            repository {\n              name\n              owner {\n                login\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": HO,
  "\n  query getIssue(\n    $owner: String!\n    $repositoryName: String!\n    $issueNumber: Int!\n  ) {\n    GitHub {\n      repository(owner: $owner, name: $repositoryName) {\n        issue(number: $issueNumber) {\n          id\n          number\n          title\n          body\n          bodyText\n          author {\n            avatarUrl\n            login\n          }\n          state\n          assignees(first: 10) {\n            nodes {\n              avatarUrl\n              name\n            }\n          }\n          labels(first: 10) {\n            nodes {\n              color\n              name\n            }\n          }\n          repository {\n            name\n            owner {\n              login\n            }\n          }\n        }\n      }\n    }\n  }\n": WO,
  "\n  query getPullRequest(\n    $owner: String!\n    $repositoryName: String!\n    $prNumber: Int!\n  ) {\n    GitHub {\n      repository(owner: $owner, name: $repositoryName) {\n        pullRequest(number: $prNumber) {\n          id\n          number\n          title\n          body\n          bodyText\n          author {\n            avatarUrl\n            login\n          }\n          state\n          assignees(first: 10) {\n            nodes {\n              avatarUrl\n              name\n            }\n          }\n          labels(first: 10) {\n            nodes {\n              color\n              name\n            }\n          }\n          repository {\n            name\n            owner {\n              login\n            }\n          }\n        }\n      }\n    }\n  }\n": KO
};
function Da(e) {
  return GO[e] ?? {};
}
const YO = Da(
  /* GraphQL */
  `
  query searchItems(
    $issueQuery: String!
    $prQuery: String!
    $maxIssueResults: Int
    $maxPRResults: Int
  ) {
    GitHub {
      issues: search(query: $issueQuery, type: ISSUE, first: $maxIssueResults) {
        issueCount
        nodes {
          ... on GitHub_Issue {
            id
            number
            title
            body
            bodyText
            author {
              avatarUrl
              login
            }
            state
            assignees(first: 10) {
              nodes {
                avatarUrl
                name
              }
            }
            labels(first: 10) {
              nodes {
                color
                name
              }
            }
            repository {
              name
              owner {
                login
              }
            }
          }
        }
      }
      pullRequests: search(query: $prQuery, type: ISSUE, first: $maxPRResults) {
        issueCount
        nodes {
          ... on GitHub_PullRequest {
            id
            number
            title
            body
            bodyText
            author {
              avatarUrl
              login
            }
            state
            assignees(first: 10) {
              nodes {
                avatarUrl
                name
              }
            }
            labels(first: 10) {
              nodes {
                color
                name
              }
            }
            repository {
              name
              owner {
                login
              }
            }
          }
        }
      }
    }
  }
`
), JO = Da(
  /* GraphQL */
  `
  query getIssue(
    $owner: String!
    $repositoryName: String!
    $issueNumber: Int!
  ) {
    GitHub {
      repository(owner: $owner, name: $repositoryName) {
        issue(number: $issueNumber) {
          id
          number
          title
          body
          bodyText
          author {
            avatarUrl
            login
          }
          state
          assignees(first: 10) {
            nodes {
              avatarUrl
              name
            }
          }
          labels(first: 10) {
            nodes {
              color
              name
            }
          }
          repository {
            name
            owner {
              login
            }
          }
        }
      }
    }
  }
`
), QO = Da(
  /* GraphQL */
  `
  query getPullRequest(
    $owner: String!
    $repositoryName: String!
    $prNumber: Int!
  ) {
    GitHub {
      repository(owner: $owner, name: $repositoryName) {
        pullRequest(number: $prNumber) {
          id
          number
          title
          body
          bodyText
          author {
            avatarUrl
            login
          }
          state
          assignees(first: 10) {
            nodes {
              avatarUrl
              name
            }
          }
          labels(first: 10) {
            nodes {
              color
              name
            }
          }
          repository {
            name
            owner {
              login
            }
          }
        }
      }
    }
  }
`
), q_ = ({
  owner: e,
  repository: n,
  number: r
}) => `https://github.com/${e}/${n}/issues/${r}`, br = ({
  owner: e,
  repository: n,
  number: r
}) => `${e}/${n} #${r}`, XO = ({
  number: e,
  repository: n
}) => ({
  number: e,
  repository: n.name,
  owner: n.owner.login
}), H_ = (e) => {
  switch (e) {
    case "ISSUE":
      return "issue";
    case "PR":
      return "pull request";
    default:
      return e;
  }
}, ey = (e, n, r) => e === "ISSUE" ? {
  OPEN: /* @__PURE__ */ xe.jsxs(
    "svg",
    {
      className: r,
      fill: "#3fb950",
      height: "16",
      width: "16",
      "aria-hidden": "true",
      children: [
        /* @__PURE__ */ xe.jsx("path", { d: "M8 9.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3z" }),
        /* @__PURE__ */ xe.jsx("path", { d: "M8 0a8 8 0 100 16A8 8 0 008 0zM1.5 8a6.5 6.5 0 1113 0 6.5 6.5 0 01-13 0z" })
      ]
    }
  ),
  CLOSED: /* @__PURE__ */ xe.jsxs(
    "svg",
    {
      className: r,
      fill: "#a371f7",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: [
        /* @__PURE__ */ xe.jsx("path", { d: "M11.28 6.78a.75.75 0 00-1.06-1.06L7.25 8.69 5.78 7.22a.75.75 0 00-1.06 1.06l2 2a.75.75 0 001.06 0l3.5-3.5z" }),
        /* @__PURE__ */ xe.jsx(
          "path",
          {
            fillRule: "evenodd",
            d: "M16 8A8 8 0 110 8a8 8 0 0116 0zm-1.5 0a6.5 6.5 0 11-13 0 6.5 6.5 0 0113 0z"
          }
        )
      ]
    }
  )
}[n] : {
  OPEN: /* @__PURE__ */ xe.jsx(
    "svg",
    {
      className: r,
      fill: "#3fb950",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: /* @__PURE__ */ xe.jsx("path", { d: "M7.177 3.073L9.573.677A.25.25 0 0110 .854v4.792a.25.25 0 01-.427.177L7.177 3.427a.25.25 0 010-.354zM3.75 2.5a.75.75 0 100 1.5.75.75 0 000-1.5zm-2.25.75a2.25 2.25 0 113 2.122v5.256a2.251 2.251 0 11-1.5 0V5.372A2.25 2.25 0 011.5 3.25zM11 2.5h-1V4h1a1 1 0 011 1v5.628a2.251 2.251 0 101.5 0V5A2.5 2.5 0 0011 2.5zm1 10.25a.75.75 0 111.5 0 .75.75 0 01-1.5 0zM3.75 12a.75.75 0 100 1.5.75.75 0 000-1.5z" })
    }
  ),
  MERGED: /* @__PURE__ */ xe.jsx(
    "svg",
    {
      className: r,
      fill: "#a371f7",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: /* @__PURE__ */ xe.jsx("path", { d: "M5 3.254V3.25v.005a.75.75 0 110-.005v.004zm.45 1.9a2.25 2.25 0 10-1.95.218v5.256a2.25 2.25 0 101.5 0V7.123A5.735 5.735 0 009.25 9h1.378a2.251 2.251 0 100-1.5H9.25a4.25 4.25 0 01-3.8-2.346zM12.75 9a.75.75 0 100-1.5.75.75 0 000 1.5zm-8.5 4.5a.75.75 0 100-1.5.75.75 0 000 1.5z" })
    }
  ),
  CLOSED: /* @__PURE__ */ xe.jsx(
    "svg",
    {
      className: r,
      fill: "#f85149",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: /* @__PURE__ */ xe.jsx("path", { d: "M10.72 1.227a.75.75 0 011.06 0l.97.97.97-.97a.75.75 0 111.06 1.061l-.97.97.97.97a.75.75 0 01-1.06 1.06l-.97-.97-.97.97a.75.75 0 11-1.06-1.06l.97-.97-.97-.97a.75.75 0 010-1.06zM12.75 6.5a.75.75 0 00-.75.75v3.378a2.251 2.251 0 101.5 0V7.25a.75.75 0 00-.75-.75zm0 5.5a.75.75 0 100 1.5.75.75 0 000-1.5zM2.5 3.25a.75.75 0 111.5 0 .75.75 0 01-1.5 0zM3.25 1a2.25 2.25 0 00-.75 4.372v5.256a2.251 2.251 0 101.5 0V5.372A2.25 2.25 0 003.25 1zm0 11a.75.75 0 100 1.5.75.75 0 000-1.5z" })
    }
  )
}[n];
function ZO({
  conversationId: e,
  githubOrganization: n
}) {
  const r = {
    github: { issues: [], pullRequests: [] }
  }, [i, a] = pe(
    []
  ), [o, s] = pe([]), [l, c] = pe([]), [m, u] = pe([]), [f, h] = pe(), { showNotification: k, showModal: w, executeQuery: N } = hn(), { track: j } = jn(), {
    loading: _,
    data: g,
    error: O,
    store: R
  } = Cy(e ?? null), F = g?.github?.issues || [], I = g?.github?.pullRequests || [], [L, W] = pe(!1), [J, re] = pe();
  Qe(
    () => h(O || J || void 0),
    [O, J]
  ), Qe(
    () => {
      !_ && (F?.length || I?.length) ? (a(F), s(I), Y(F, I)) : (a([]), s([]), c([]), u([]));
    },
    // Only trigger when data is loaded, not when the loading status changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [g]
  );
  const K = async (ge, V) => {
    await R(ge).then(() => {
      k({
        icon: "check-circle-filled",
        severity: "success",
        title: V.success.title,
        text: V.success.text
      });
    }).catch((be) => {
      k({
        title: V.error.title,
        text: `${V.error.text} ${be.message && " (" + be.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, Y = (ge, V) => {
    if (!ge?.length && !V?.length) {
      c([]), u([]);
      return;
    }
    const be = (ge || []).map(
      (Ge) => N(JO, {
        owner: Ge.owner,
        repositoryName: Ge.repository,
        issueNumber: Ge.number
      })
    ), Oe = (V || []).map(
      (Ge) => N(QO, {
        owner: Ge.owner,
        repositoryName: Ge.repository,
        prNumber: Ge.number
      })
    ), q = [...be, ...Oe];
    W(!0), Promise.all(q).then((Ge) => {
      const sn = [], Ie = [];
      Ge.forEach((Ue) => {
        const De = Ue?.data?.GitHub;
        if (!De) {
          c([]), u([]);
          return;
        }
        Object.keys(De).forEach((Be) => {
          if (Be.startsWith("repository")) {
            const Ae = De[Be];
            Object.keys(Ae).forEach((Je) => {
              const Ee = Ae[Je], Me = {
                number: Ee?.number,
                owner: Ee?.repository?.owner?.login,
                repository: Ee?.repository?.name
              };
              Je.startsWith("issue") && sn.push({
                ...Ee,
                type: "ISSUE",
                key: Me
              }), Je.startsWith("pullRequest") && Ie.push({
                ...Ee,
                type: "PR",
                key: Me
              });
            });
          }
        });
      }), c(sn), u(Ie);
    }).catch(re).finally(() => {
      W(!1);
    });
  }, P = ({ key: ge, type: V }) => {
    j("github:link:issue:clicked", {
      githubOrganization: n
    });
    const be = g && (F.length || I.length) ? g : r, Oe = V === "ISSUE" ? "issues" : "pullRequests";
    be.github[Oe] = Array.from(
      new Set(be.github[Oe]).add(ge)
    ), K(be, {
      success: {
        title: "GitHub issue linked",
        text: `You linked the GitHub issue ${br(
          ge
        )} to this conversation.`
      },
      error: {
        title: "Linking failed",
        text: `Linking ${br(ge)} failed. Please try again.`
      }
    });
  }, B = async ({ key: ge, type: V }) => {
    j("github:link:issue:clicked", {
      githubOrganization: n
    });
    const be = g && (F.length || I.length) ? g : r, Oe = V === "ISSUE" ? "issues" : "pullRequests";
    be.github[Oe] = Array.from(
      new Set(be.github[Oe]).add(ge)
    ), await R(be).catch((q) => {
      k({
        title: "Linking failed",
        text: `Linking ${ge} failed. Please try again. ${q.message && " (" + q.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, ie = ({ key: ge, type: V }) => {
    j("github:unlink:issue:clicked", {
      githubOrganization: n
    });
    const be = V === "ISSUE" ? "issue" : "pull request";
    w({
      headline: `Unlink ${be} ${br(ge)}?`,
      text: `You are about to unlink the ${be} ${br(
        ge
      )}. Do you want to proceed?`,
      confirmLabel: `Unlink GitHub ${be}`,
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        const Oe = V === "ISSUE" ? "issues" : "pullRequests";
        if (!g)
          return;
        const q = {
          ...g,
          github: {
            ...g?.github,
            [Oe]: g?.github?.[Oe].filter(
              (Ge) => Ge.number !== ge.number || Ge.owner !== ge.owner || Ge.repository !== ge.repository
            )
          }
        };
        j("github:unlink:issue:confirmed", {
          githubOrganization: n
        }), K(q, {
          success: {
            title: `GitHub ${be} unlinked`,
            text: `You unlinked the GitHub ${be} ${br(
              ge
            )}`
          },
          error: {
            title: "Unlinking failed",
            text: `Unlinking ${br(ge)} failed.`
          }
        });
      },
      onCancel: () => {
        j("github:unlink:issue:canceled", {
          githubOrganization: n
        });
      }
    });
  }, we = () => {
    j("github:unlink:all:clicked", {
      githubOrganization: n
    }), w({
      headline: "Unlink all GitHub issues/pull requests?",
      text: "You are about to unlink the all GitHub issues/pull requests from the conversation. Do you want to proceed?",
      confirmLabel: "Unlink ALL issues/pull requests",
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        j("github:unlink:all:confirmed", {
          githubOrganization: n
        }), K(r, {
          success: {
            title: "Unlinking successful",
            text: "All GitHub issues/pull requests were unlinked"
          },
          error: {
            title: "Unlinking failed",
            text: "Unlinking all issues/pull requests failed."
          }
        });
      },
      onCancel: () => {
        j("github:unlink:all:canceled", {
          githubOrganization: n
        });
      }
    });
  }, me = F.filter(
    (ge) => !i?.includes(ge)
  ) || [], le = I.filter(
    (ge) => !o?.includes(ge)
  ) || [];
  return {
    linkGithubItem: P,
    linkGithubItemQuietly: B,
    unlinkGithubItem: ie,
    loadGithubItems: Y,
    removeDanglingGithubItemLinks: () => {
      const ge = {
        ...g,
        github: {
          ...g?.github,
          issues: F.filter(
            (V) => !me.includes(V)
          ) || [],
          pullRequests: I.filter(
            (V) => !le.includes(V)
          ) || []
        }
      };
      R(ge);
    },
    unlinkAllGithubItems: we,
    isLoadingGithubItemLinks: _,
    danglingIssueLinks: me,
    danglingPullRequestLinks: le,
    isLoadingGithubItems: L,
    issues: l,
    pullRequests: m,
    error: f
  };
}
const eP = "_contentWrapper_1vx3c_1", nP = "_contentWrapperHeadline_1vx3c_4", tP = "_contentWrapperBody_1vx3c_11", rP = "_contentWrapperAssigneeIcon_1vx3c_15", iP = "_contentWrapperStatusTag_1vx3c_20", ni = {
  contentWrapper: eP,
  contentWrapperHeadline: nP,
  contentWrapperBody: tP,
  contentWrapperAssigneeIcon: rP,
  contentWrapperStatusTag: iP
}, JC = ({
  description: e,
  assignees: n,
  labels: r
}) => /* @__PURE__ */ xe.jsxs(xe.Fragment, { children: [
  e && /* @__PURE__ */ xe.jsxs(lt, { className: ni.contentWrapper, children: [
    /* @__PURE__ */ xe.jsx(lt, { className: ni.contentWrapperHeadline, children: "Description" }),
    /* @__PURE__ */ xe.jsx(lt, { className: ni.contentWrapperBody, children: e })
  ] }),
  n?.nodes && n.nodes.length > 0 && /* @__PURE__ */ xe.jsxs(lt, { className: ni.contentWrapper, children: [
    /* @__PURE__ */ xe.jsx(lt, { className: ni.contentWrapperHeadline, children: "Assignees" }),
    /* @__PURE__ */ xe.jsx(lt, { className: ni.contentWrapperBody, children: n.nodes.map(
      (i) => i && /* @__PURE__ */ xe.jsxs(lt, { margin: "100 0", children: [
        /* @__PURE__ */ xe.jsx(
          "img",
          {
            className: ni.contentWrapperAssigneeIcon,
            src: i.avatarUrl,
            alt: i.name || ""
          }
        ),
        " ",
        i.name
      ] }, i.name)
    ) })
  ] }),
  r?.nodes && r?.nodes.length > 0 && /* @__PURE__ */ xe.jsx(lt, { className: ni.contentWrapper, children: r.nodes.map(
    (i) => i && /* @__PURE__ */ xe.jsx(
      Jn,
      {
        className: ni.contentWrapperStatusTag,
        children: i.name
      },
      i.name
    )
  ) })
] }), aP = "_collapse_1bdjy_1", oP = "_collapseHeader_1bdjy_10", sP = "_collapseHeaderKey_1bdjy_31", lP = "_collapseHeaderKeyIcon_1bdjy_36", dP = "_collapseHeaderKeyLink_1bdjy_41", cP = "_collapseHeaderIcon_1bdjy_44", uP = "_collapseHeaderTitle_1bdjy_49", mP = "_collapseContent_1bdjy_57", pP = "_collapseContentButtonSpacer_1bdjy_60", fP = "_collapseContentButtonLink_1bdjy_63", Or = {
  collapse: aP,
  collapseHeader: oP,
  collapseHeaderKey: sP,
  collapseHeaderKeyIcon: lP,
  collapseHeaderKeyLink: dP,
  collapseHeaderIcon: cP,
  collapseHeaderTitle: uP,
  collapseContent: mP,
  collapseContentButtonSpacer: pP,
  collapseContentButtonLink: fP
}, hP = ({
  items: e,
  unlinkGithubItem: n,
  githubOrganization: r
}) => {
  const i = e.reduce(
    (c, m) => ({ ...c, [m.id]: !1 }),
    {}
  ), [a, o] = pe(i), { track: s } = jn(), l = (c, m) => {
    o({ ...a, [c]: m });
  };
  return /* @__PURE__ */ xe.jsx(b, { flexDirection: "column", gap: "250", children: e?.length ? e.map((c) => {
    const {
      id: m,
      number: u,
      key: f,
      title: h,
      bodyText: k,
      repository: w,
      type: N,
      state: j,
      assignees: _,
      labels: g
    } = c, O = a[m];
    return /* @__PURE__ */ xe.jsxs(
      xr,
      {
        onToggle: () => l(m, !a[m]),
        isOpen: O,
        className: Or.collapse,
        children: [
          /* @__PURE__ */ xe.jsx(xr.Header, { className: Or.collapseHeader, children: /* @__PURE__ */ xe.jsxs(
            b,
            {
              flexDirection: "column",
              gap: "200",
              justifyContent: "space-between",
              children: [
                /* @__PURE__ */ xe.jsx(lt, { children: /* @__PURE__ */ xe.jsxs(lt, { as: "span", className: Or.collapseHeaderKey, children: [
                  ey(
                    N,
                    j,
                    Or.collapseHeaderKeyIcon
                  ),
                  /* @__PURE__ */ xe.jsxs(
                    "a",
                    {
                      href: q_(f),
                      className: Or.collapseHeaderKeyLink,
                      target: "_blank",
                      rel: "noreferrer",
                      onClick: (R) => {
                        R.stopPropagation();
                      },
                      children: [
                        br(f),
                        /* @__PURE__ */ xe.jsx(
                          he,
                          {
                            className: Or.collapseHeaderIcon,
                            name: "external-link",
                            size: 16
                          }
                        )
                      ]
                    }
                  )
                ] }) }),
                /* @__PURE__ */ xe.jsx(lt, { className: Or.collapseHeaderTitle, children: h })
              ]
            }
          ) }),
          /* @__PURE__ */ xe.jsx(xr.Content, { className: Or.collapseContent, children: /* @__PURE__ */ xe.jsxs(b, { flexDirection: "column", margin: "0 0 200 0", children: [
            /* @__PURE__ */ xe.jsx(
              JC,
              {
                description: k,
                assignees: _,
                labels: g
              }
            ),
            /* @__PURE__ */ xe.jsxs(
              tt,
              {
                icon: "link-slash",
                variant: "secondary",
                className: Or.collapseContentButtonSpacer,
                onClick: () => n({
                  key: {
                    number: u,
                    owner: w?.owner.login,
                    repository: c.repository.name
                  },
                  type: N
                }),
                children: [
                  "Unlink ",
                  H_(N)
                ]
              }
            ),
            /* @__PURE__ */ xe.jsxs(
              It,
              {
                slotEnd: /* @__PURE__ */ xe.jsx(he, { name: "external-link" }),
                variant: "tertiary",
                className: Or.collapseContentButtonLink,
                navigate: () => {
                  s("github:view:link:clicked", {
                    githubOrganization: r
                  }), window.open(q_(f), "_blank")?.focus();
                },
                children: [
                  "View ",
                  H_(N),
                  " in GitHub"
                ]
              }
            )
          ] }) })
        ]
      },
      m
    );
  }) : /* @__PURE__ */ xe.jsx(xe.Fragment, {}) });
}, yP = "_result_1uaom_1", gP = "_resultName_1uaom_21", vP = "_resultItemIcon_1uaom_29", kP = "_resultDescription_1uaom_34", bP = "_resultLinkIcon_1uaom_46", _P = "_tooltip_1uaom_55", xP = "_tooltipName_1uaom_61", SP = "_tooltipTag_1uaom_71", ti = {
  result: yP,
  resultName: gP,
  resultItemIcon: vP,
  resultDescription: kP,
  resultLinkIcon: bP,
  tooltip: _P,
  tooltipName: xP,
  tooltipTag: SP
}, NP = ({
  item: e,
  onSelect: n
}) => {
  const { key: r, title: i, type: a, state: o, labels: s, bodyText: l, assignees: c } = e, [m, u] = pe(!1);
  return /* @__PURE__ */ xe.jsx(
    Xe,
    {
      className: ti.tooltip,
      content: /* @__PURE__ */ xe.jsxs(b, { flexDirection: "column", justifyContent: "center", width: "100%", children: [
        /* @__PURE__ */ xe.jsxs(
          b,
          {
            flexDirection: "row",
            justifyContent: "space-between",
            width: "100%",
            alignItems: "center",
            margin: "0 0 300 0",
            children: [
              /* @__PURE__ */ xe.jsxs(lt, { as: "span", className: ti.tooltipName, children: [
                ey(a, o, ti.resultItemIcon),
                i
              ] }),
              /* @__PURE__ */ xe.jsx(Jn, { className: ti.tooltipTag, children: o })
            ]
          }
        ),
        /* @__PURE__ */ xe.jsx(
          JC,
          {
            description: l,
            assignees: c,
            labels: s
          }
        )
      ] }),
      side: "left",
      light: !0,
      children: /* @__PURE__ */ xe.jsxs(
        "button",
        {
          className: ti.result,
          type: "button",
          onClick: () => {
            n(e);
          },
          onMouseEnter: () => u(!0),
          onMouseLeave: () => u(!1),
          children: [
            /* @__PURE__ */ xe.jsxs(
              b,
              {
                flexDirection: "column",
                justifyContent: "center",
                width: "100%",
                style: {
                  width: m ? "calc(100% - 32px)" : "100%"
                },
                children: [
                  /* @__PURE__ */ xe.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ xe.jsxs(lt, { as: "span", className: ti.resultName, children: [
                    ey(a, o, ti.resultItemIcon),
                    br(r)
                  ] }) }),
                  /* @__PURE__ */ xe.jsx(lt, { className: ti.resultDescription, children: i })
                ]
              }
            ),
            m && /* @__PURE__ */ xe.jsx(
              he,
              {
                className: ti.resultLinkIcon,
                name: "plus",
                size: 32
              }
            )
          ]
        }
      )
    }
  );
}, jP = ({
  className: e,
  searched: n,
  githubOrganization: r
}) => /* @__PURE__ */ xe.jsx(
  It,
  {
    slotEnd: /* @__PURE__ */ xe.jsx(he, { name: "external-link" }),
    variant: "tertiary",
    style: { width: "100%" },
    className: e,
    navigate: () => {
      window.open(
        `https://github.com/search?q=is:issue+org:${r}+${n}`,
        "_blank"
      )?.focus();
    },
    children: "View matching items on GitHub"
  }
), kl = "[a-zA-z0-9_.-]+", QC = "[0-9]+", wP = new RegExp(
  `(${kl})/(${kl})/(?:issues|pull)/(${QC})`,
  "i"
), W_ = new RegExp(`^${wP.source}$`), K_ = new RegExp(
  `https://github.com/(${kl})/(${kl})/(?:issues|pull)/(${QC})`,
  "i"
), CP = ({
  onSelectItem: e,
  githubOrganization: n,
  linkedIssues: r,
  linkedPullRequests: i
}) => {
  const a = Xn(() => r?.map((I) => I.id) || [], [r]), o = Xn(() => i?.map((I) => I.id) || [], [i]), [s, l] = pe([]), { useLazyQuery: c } = hn(), [m, u] = pe(), [f, { loading: h, error: k, data: w, networkStatus: N }] = c(YO, {
    notifyOnNetworkStatusChange: !0
  });
  bi(
    () => {
      !h && m && N === rr.ready ? f({
        variables: {
          issueQuery: `${m} type:issue`,
          prQuery: `${m} type:pr`,
          maxIssueResults: 12,
          maxPRResults: 12
        }
      }) : l([]);
    },
    500,
    [m]
  ), Qe(() => {
    let I = w?.GitHub?.issues?.nodes || [], L = w?.GitHub?.pullRequests.nodes || [];
    a.length > 0 && (I = I.filter((W) => !a.includes(W.id))), o.length > 0 && (L = L.filter(
      (W) => !o.includes(W.id)
    )), l([
      ...I.map((W) => ({
        ...W,
        type: "ISSUE",
        key: {
          number: W.number,
          owner: W.repository.owner.login,
          repository: W.repository.name
        }
      })),
      ...L.map((W) => ({
        ...W,
        type: "PR",
        key: {
          number: W.number,
          owner: W.repository.owner.login,
          repository: W.repository.name
        }
      }))
    ]);
  }, [w, a, o]);
  function j(I) {
    const L = I?.trim();
    if (W_.test(L)) {
      const [W, J, re, K] = L.match(W_) || [];
      return J !== n ? void 0 : {
        owner: n,
        repository: re,
        number: parseInt(K)
      };
    }
    if (K_.test(L)) {
      const [W, J, re, K] = L.match(K_) || [];
      return J !== n ? void 0 : {
        owner: n,
        repository: re,
        number: parseInt(K)
      };
    }
  }
  const _ = (I) => {
    e({
      key: XO(I),
      type: I.type
    }), u(void 0);
  }, g = (I) => {
    const L = j(I);
    u(
      L ? `org:${L.owner} repo:${L.repository} ${L.number}` : `org:${n} ${I}`
    );
  }, O = () => {
    u(void 0);
  }, R = ({ className: I, searched: L }) => /* @__PURE__ */ xe.jsx(
    jP,
    {
      className: I,
      searched: L,
      githubOrganization: n
    }
  ), F = ({ item: I, onSelect: L }) => /* @__PURE__ */ xe.jsx(NP, { item: I, onSelect: L });
  return !h && k ? /* @__PURE__ */ xe.jsx($n, { error: k }) : /* @__PURE__ */ xe.jsx(
    Tr,
    {
      items: s?.map((I) => ({ name: I.title, ...I })),
      loading: h,
      onSearch: g,
      onSelect: _,
      onClear: O,
      emptyMessage: m ? h ? "" : "No GitHub items found" : "Enter GitHub item key, link or search terms",
      suggestionComponent: R,
      itemComponent: F,
      placeholder: "Search GitHub items",
      searchable: !0,
      clearable: !0
    }
  );
}, FP = "_itemButton_3sxfy_1", IP = "_result_3sxfy_6", $P = "_resultName_3sxfy_30", EP = "_resultCheckIcon_3sxfy_38", TP = "_resultAssigneeIcon_3sxfy_41", Qa = {
  itemButton: FP,
  result: IP,
  resultName: $P,
  resultCheckIcon: EP,
  resultAssigneeIcon: TP
}, XC = ({
  item: e,
  checked: n = !1,
  onSelectItem: r
}) => /* @__PURE__ */ xe.jsx(
  b,
  {
    flexDirection: "column",
    justifyContent: "center",
    width: "100%",
    "data-testid": "github-select-item-component",
    children: /* @__PURE__ */ xe.jsx(
      "button",
      {
        onClick: () => {
          r(e);
        },
        className: Qa.itemButton,
        children: /* @__PURE__ */ xe.jsxs(b, { className: Qa.result, flexDirection: "row", width: "100%", children: [
          e.iconUrl && /* @__PURE__ */ xe.jsx(lt, { margin: "100 0", children: /* @__PURE__ */ xe.jsx(
            "img",
            {
              className: Qa.resultAssigneeIcon,
              src: e.iconUrl,
              alt: e.name
            }
          ) }, e.name),
          /* @__PURE__ */ xe.jsx(lt, { className: Qa.resultName, children: e.name }),
          n && /* @__PURE__ */ xe.jsx(lt, { className: Qa.resultCheckIcon, children: /* @__PURE__ */ xe.jsx(he, { name: "done" }) })
        ] })
      }
    )
  }
), RP = Da(
  /* GraphQL */
  `
  query getGithubOrganizationMembersByName(
    $organizationQuery: String!
    $usersQuery: String!
    $maxResults: Int!
  ) {
    GitHub {
      organization(login: $organizationQuery) {
        teams(first: $maxResults) {
          edges {
            node {
              id
              name
              members(first: $maxResults, query: $usersQuery) {
                edges {
                  node {
                    id
                    name
                    login
                    avatarUrl
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`
), DP = ({
  githubOrganization: e,
  selectedItems: n,
  onChange: r,
  multiple: i = !1
}) => {
  const { useLazyQuery: a } = hn(), [o, s] = pe([]), [l, c] = pe(""), m = 2, [u, { loading: f, error: h, data: k, networkStatus: w }] = a(
    RP,
    {
      notifyOnNetworkStatusChange: !0
    }
  );
  return bi(
    () => {
      !f && l && l.length >= m && w === rr.ready ? u({
        variables: {
          usersQuery: l,
          organizationQuery: e,
          maxResults: 10
        }
      }) : s([]);
    },
    500,
    [l]
  ), Qe(() => {
    const N = k?.GitHub?.organization?.teams || { edges: [] }, j = [];
    N?.edges?.forEach((_) => {
      const g = _?.node?.members?.edges;
      (g?.length || 0) > 0 && g?.forEach((O) => {
        const R = O?.node;
        R && (R?.id && j.find((F) => F.id === R.id) || j.push(R));
      });
    }), s(
      j.sort((_, g) => {
        const O = _.name?.toLowerCase() || _.login?.toLowerCase(), R = g.name?.toLowerCase() || g.login?.toLowerCase();
        return O.localeCompare(R, void 0, {
          sensitivity: "base"
        });
      })
    );
  }, [k]), !f && h ? /* @__PURE__ */ xe.jsx($n, { error: h }) : /* @__PURE__ */ xe.jsx(
    Tr,
    {
      clearable: !0,
      searchable: !0,
      multiple: i,
      items: o?.map(({ id: N, name: j, login: _, avatarUrl: g }) => ({
        id: N,
        name: j || _,
        iconUrl: g
      })) || [],
      loading: f,
      onSearch: (N) => c(N),
      onChange: (N, j) => {
        const _ = N.id;
        i ? (j && !n.find(
          (g) => g.id === _
        ) && n.push(N), j || (n = n.filter(
          (g) => g.id !== _
        ))) : n = j ? [N] : [], r(n);
      },
      onClear: () => c(""),
      selectedItems: n,
      emptyMessage: l ? f ? "" : "No user found" : "Search users",
      itemComponent: ({ item: N, onSelect: j, checked: _ }) => /* @__PURE__ */ xe.jsx(
        XC,
        {
          item: N,
          checked: _,
          onSelectItem: j
        }
      ),
      placeholder: "Search GitHub users"
    }
  );
}, OP = ({
  field: e,
  value: n,
  onChange: r,
  githubOrganization: i
}) => {
  const { multiple: a, type: o } = e;
  switch (o) {
    case "any":
      return /* @__PURE__ */ xe.jsx(cr, { onChange: r, value: n });
    case "array":
      return e?.allowedValues ? /* @__PURE__ */ xe.jsx(
        Tr,
        {
          onSelect: r,
          selectedItems: Array.isArray(n) ? n : [],
          items: e?.allowedValues.map(({ id: s, name: l, value: c }) => ({
            id: s,
            name: l || c
          }))
        }
      ) : /* @__PURE__ */ xe.jsx(
        Hl,
        {
          onChange: r,
          selectedTags: Array.isArray(n) ? n : []
        }
      );
    case "number":
      return /* @__PURE__ */ xe.jsx(cr, { type: "number", onChange: r, value: n });
    case "option":
      return /* @__PURE__ */ xe.jsx(
        Tr,
        {
          onSelect: r,
          selectedItems: Array.isArray(n) ? n : [],
          items: e?.allowedValues?.map(
            ({ id: s, name: l, value: c }) => ({
              id: s,
              name: l || c
            })
          ) || []
        }
      );
    case "string":
      return /* @__PURE__ */ xe.jsx(cr, { onChange: r, value: n || "" });
    case "textarea":
      return /* @__PURE__ */ xe.jsx(Wh, { onChange: r, value: n || "" });
    case "user":
      return /* @__PURE__ */ xe.jsx(
        DP,
        {
          githubOrganization: i,
          onChange: r,
          selectedItems: Array.isArray(n) ? n : [],
          multiple: a
        }
      );
    default:
      return /* @__PURE__ */ xe.jsx(xe.Fragment, { children: "Your organizations GitHub configuration is currently not fully supported by Dixa. Please reach out so we can have a look at this field." });
  }
}, PP = ({
  issueTypeFields: e,
  control: n,
  githubOrganization: r,
  conversationContext: i,
  errors: a
}) => /* @__PURE__ */ xe.jsx(xe.Fragment, { children: e.filter(({ key: o }) => o !== "repository").map((o) => /* @__PURE__ */ xe.jsx(
  Nt,
  {
    control: n,
    render: ({ field: { onChange: s, value: l } }) => /* @__PURE__ */ xe.jsx(
      He,
      {
        meta: {
          error: a && o.key in a ? a[o.key].message : null
        },
        label: o.name,
        required: o.required,
        children: OP({
          field: o,
          value: l,
          onChange: s,
          githubOrganization: r
        })
      },
      o.key
    ),
    name: o.key,
    rules: {
      required: o.required ? "This field is required" : !1
    }
  },
  o.key
)) }), AP = ({
  createdIssue: e,
  issueBaseLink: n,
  issueLinkCopied: r,
  setIssueLinkCopied: i,
  copyToClipboard: a
}) => {
  const o = `${n}/${e.repository.name}/issues/${e.number}`;
  return /* @__PURE__ */ xe.jsxs(
    b,
    {
      flexDirection: "column",
      gap: "400",
      "data-testid": "github-create-issue-success-message",
      children: [
        /* @__PURE__ */ xe.jsxs($.Paragraph, { children: [
          "You can visit your new issue by following",
          " ",
          /* @__PURE__ */ xe.jsxs($.ExternalLink, { href: o, target: "_blank", children: [
            "this link ",
            /* @__PURE__ */ xe.jsx(he, { name: "external-link" })
          ] }),
          " ",
          "or copy it from the field below."
        ] }),
        /* @__PURE__ */ xe.jsx(He, { label: "GitHub issue link", children: /* @__PURE__ */ xe.jsx(
          cr,
          {
            readOnly: !0,
            value: o,
            suffix: {
              type: "button",
              button: {
                icon: r ? "done" : "copy",
                onClick: () => {
                  i(!0), a(o);
                }
              }
            }
          }
        ) })
      ]
    }
  );
}, LP = "_modalBody_1hk1o_1", VP = "_modalBodyFormFields_1hk1o_4", fm = {
  modalBody: LP,
  modalBodyFormFields: VP
}, zP = Da(
  /* GraphQL */
  `
  query getGithubRepositoriesByName($query: String!, $maxResults: Int!) {
    GitHub {
      search(query: $query, type: REPOSITORY, first: $maxResults) {
        repositoryCount
        edges {
          node {
            ... on GitHub_Repository {
              id
              name
            }
          }
        }
      }
    }
  }
`
), UP = Da(
  /* GraphQL */
  `
  mutation createGithubIssue($input: GitHub_CreateIssueInput!) {
    GitHub {
      createIssue(input: $input) {
        issue {
          id
          number
          repository {
            name
          }
        }
      }
    }
  }
`
), MP = [
  {
    key: "title",
    name: "Title",
    type: "string",
    required: !0
  },
  {
    key: "assignees",
    name: "Assignees",
    type: "user",
    required: !1,
    multiple: !0
  },
  {
    key: "body",
    name: "Description",
    type: "textarea",
    required: !1
  }
], BP = ({
  isOpen: e,
  onClose: n,
  linkGithubIssueQuietly: r,
  conversationContext: i,
  githubOrganization: a
}) => {
  const { showNotification: o, useLazyQuery: s, useMutation: l } = hn(), { track: c } = jn(), {
    control: m,
    handleSubmit: u,
    formState: { errors: f },
    reset: h,
    getValues: k
  } = ut(), [w, N] = pe(""), [j, _] = pe([]), [g, O] = pe(), [R, F] = pe(!1), [I, L] = pe(!1), [W, J] = YC(), [
    re,
    {
      loading: K,
      error: Y,
      networkStatus: P
    }
  ] = s(zP, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onCompleted: (Oe) => {
      _(
        Oe.GitHub.search?.edges?.map((q) => q?.node)
      );
    },
    onError: () => {
      o({
        title: "Could not get repository list",
        text: "We could not fetch the list of your repositories. Please try again later.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), _([]);
    }
  });
  bi(
    () => {
      !K && w && P === rr.ready ? re({
        variables: {
          query: w,
          maxResults: 10
        }
      }) : _([]);
    },
    500,
    [w]
  );
  const [B, { error: ie }] = l(
    UP,
    {
      onError: (Oe) => {
        F(!1), o({
          title: "Creation was not successful",
          text: "Please try again later or contact your admin.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), console.warn("Error in createMutation", Oe);
      },
      onCompleted: (Oe) => {
        F(!1);
        const q = Oe.GitHub.createIssue?.issue;
        O(q), o({
          title: "Success",
          text: `GitHub issue '${q.number}' created`,
          icon: "check-circle-filled",
          severity: "success"
        }), r({
          owner: a,
          repository: q.repository.name,
          number: q.number
        });
      }
    }
  ), we = (Oe) => {
    N(`org:${a} ${Oe}`);
  }, me = (Oe, q) => {
    q(Oe), N("");
  }, le = () => {
    N("");
  }, ge = (Oe) => {
    c("github:create:issue:confirmed", {
      githubOrganization: a
    }), F(!0), B({
      variables: {
        input: {
          repositoryId: Oe.repository.id,
          title: Oe.title,
          body: Oe.body,
          assigneeIds: Oe.assignees?.length > 0 ? Oe.assignees.map((q) => q.id) : void 0
        }
      }
    });
  };
  Qe(() => {
    const Oe = I ? window.setTimeout(() => L(!1), 2e3) : void 0;
    return () => window.clearTimeout(Oe);
  }, [I]);
  const V = () => {
    N(""), _([]), O(void 0), F(!1), L(!1);
  }, be = () => {
    c("github:create:issue:canceled", {
      githubOrganization: a
    }), V(), h(), n();
  };
  return /* @__PURE__ */ xe.jsxs(
    bt,
    {
      isOpen: e,
      "data-testid": "github-create-issue-modal",
      onClose: be,
      children: [
        /* @__PURE__ */ xe.jsx(
          _t,
          {
            title: g ? "Issue creation successful" : "Create new GitHub issue",
            onClose: be
          }
        ),
        /* @__PURE__ */ xe.jsxs(xt, { className: fm.modalBody, children: [
          !K && Y && /* @__PURE__ */ xe.jsx($n, { error: Y }),
          !R && ie && /* @__PURE__ */ xe.jsx($n, { error: ie }),
          g ? /* @__PURE__ */ xe.jsx(
            AP,
            {
              createdIssue: g,
              issueBaseLink: `https://github.com/${a}`,
              issueLinkCopied: I,
              setIssueLinkCopied: L,
              copyToClipboard: J
            }
          ) : /* @__PURE__ */ xe.jsx(
            "form",
            {
              "data-testid": "github-create-issue-form",
              onSubmit: u(ge),
              children: /* @__PURE__ */ xe.jsxs(et, { children: [
                /* @__PURE__ */ xe.jsx(X, { children: /* @__PURE__ */ xe.jsx(He, { label: "Repository", required: !0, children: /* @__PURE__ */ xe.jsx(
                  Nt,
                  {
                    control: m,
                    name: "repository",
                    rules: { required: "Please select a repository" },
                    render: ({ field: { onChange: Oe, value: q } }) => /* @__PURE__ */ xe.jsx(
                      Tr,
                      {
                        className: fm.modalBodyRepository,
                        searchable: !0,
                        clearable: !0,
                        loading: K,
                        onSearch: we,
                        onSelect: (Ge) => me(Ge, Oe),
                        onClear: le,
                        selectedItems: [q],
                        placeholder: "Search GitHub repositories",
                        emptyMessage: Y ? "No repositories found" : "No repositories available",
                        items: j || [],
                        itemComponent: ({ item: Ge, onSelect: sn, checked: Ie }) => /* @__PURE__ */ xe.jsx(
                          XC,
                          {
                            item: Ge,
                            checked: Ie,
                            onSelectItem: sn
                          }
                        )
                      }
                    )
                  }
                ) }) }),
                /* @__PURE__ */ xe.jsx(X, { className: fm.modalBodyFormFields, children: /* @__PURE__ */ xe.jsx(
                  PP,
                  {
                    control: m,
                    errors: f,
                    getValues: k,
                    githubOrganization: a,
                    conversationContext: i,
                    issueTypeFields: MP
                  }
                ) })
              ] })
            }
          )
        ] }),
        /* @__PURE__ */ xe.jsx(
          wt,
          {
            confirmOnClick: g ? be : u(ge),
            confirmProps: {
              isLoading: R,
              loadingIndicator: /* @__PURE__ */ xe.jsx(mn, { size: 16 })
            },
            confirmName: g ? "Close" : "Save",
            cancelOnClick: g ? void 0 : be
          }
        )
      ]
    }
  );
}, qP = "_wrapper_19v8w_1", HP = "_inputWrapper_19v8w_6", WP = "_buttonLink_19v8w_19", KP = "_noItemsFound_19v8w_23", GP = "_createIssueButton_19v8w_28", na = {
  wrapper: qP,
  inputWrapper: HP,
  buttonLink: WP,
  noItemsFound: KP,
  createIssueButton: GP
}, YP = ({
  conversationContext: e,
  settings: n
}) => {
  const [r, i] = pe(!1), { track: a } = jn(), o = n?.githubOrganization, s = !!n?.enableRemoveAllLinks, {
    linkGithubItem: l,
    linkGithubItemQuietly: c,
    unlinkGithubItem: m,
    loadGithubItems: u,
    removeDanglingGithubItemLinks: f,
    unlinkAllGithubItems: h,
    isLoadingGithubItemLinks: k,
    danglingIssueLinks: w,
    danglingPullRequestLinks: N,
    isLoadingGithubItems: j,
    issues: _,
    pullRequests: g,
    error: O
  } = ZO({
    conversationId: e?.conversationId || null,
    githubOrganization: o
  }), R = (J) => c({ key: J, type: "ISSUE" }), F = !(!!_?.length).valueOf() && !(!!g?.length).valueOf() && !(!!w?.length).valueOf() && !(!!N?.length).valueOf(), I = !k && !j && !!w?.length && !!N?.length && !!n?.showDanglingLinks, L = n?.enableCreateIssue, W = !!_?.length || !!g?.length;
  return !j && O ? /* @__PURE__ */ xe.jsx($n, { error: O, retry: () => u() }) : /* @__PURE__ */ xe.jsxs(xe.Fragment, { children: [
    /* @__PURE__ */ xe.jsxs(b, { className: na.wrapper, flexDirection: "column", children: [
      /* @__PURE__ */ xe.jsxs(b, { className: na.inputWrapper, flexDirection: "column", children: [
        L && /* @__PURE__ */ xe.jsxs(xe.Fragment, { children: [
          /* @__PURE__ */ xe.jsx(
            tt,
            {
              variant: "primary",
              onClick: () => {
                a("github:create:issue:clicked", {
                  githubOrganization: n?.githubOrganization
                }), i(!0);
              },
              className: na.createIssueButton,
              children: "Create new issue"
            }
          ),
          /* @__PURE__ */ xe.jsx("div", { className: na.inputSeparator, children: "or" })
        ] }),
        /* @__PURE__ */ xe.jsx(
          CP,
          {
            onSelectItem: l,
            githubOrganization: o,
            linkedIssues: _,
            linkedPullRequests: g
          }
        )
      ] }),
      j ? /* @__PURE__ */ xe.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ xe.jsx(mn, { "data-testid": "github-widget-item-spinner" }) }) : W ? /* @__PURE__ */ xe.jsx(
        hP,
        {
          items: [..._, ...g],
          unlinkGithubItem: m,
          githubOrganization: o
        }
      ) : /* @__PURE__ */ xe.jsx($.Paragraph, { align: "center", className: na.noItemsFound, children: "No linked items found." }),
      I && /* @__PURE__ */ xe.jsxs(
        b,
        {
          background: "neutral.100",
          padding: "300",
          borderRadius: "100",
          flexDirection: "column",
          gap: "200",
          children: [
            /* @__PURE__ */ xe.jsx($.Heading, { variant: "heading-3", children: "Unresolved linked issues and/or pull requests" }),
            /* @__PURE__ */ xe.jsxs(b, { flexDirection: "row", flexWrap: "wrap", gap: "100", children: [
              w.map((J) => /* @__PURE__ */ xe.jsx(
                Jn,
                {
                  onDelete: () => m({
                    key: J,
                    type: "ISSUE"
                  }),
                  children: br(J)
                },
                br(J)
              )),
              N.map((J) => /* @__PURE__ */ xe.jsx(
                Jn,
                {
                  onDelete: () => m({ key: J, type: "PR" }),
                  children: br(J)
                },
                br(J)
              ))
            ] }),
            /* @__PURE__ */ xe.jsx(
              tt,
              {
                variant: "secondary",
                onClick: () => f(),
                icon: "link-slash",
                children: "Remove all"
              }
            )
          ]
        }
      ),
      s && W && /* @__PURE__ */ xe.jsx(
        tt,
        {
          variant: "secondary",
          disabled: F,
          onClick: h,
          children: "Remove all links"
        }
      ),
      /* @__PURE__ */ xe.jsx(
        It,
        {
          slotEnd: /* @__PURE__ */ xe.jsx(he, { name: "external-link" }),
          variant: "tertiary",
          className: na.buttonLink,
          navigate: () => {
            window.open(`https://github.com/${o}`, "_blank")?.focus();
          },
          children: "Open GitHub"
        }
      )
    ] }),
    /* @__PURE__ */ xe.jsx(
      BP,
      {
        isOpen: r,
        onClose: () => i(!1),
        linkGithubIssueQuietly: R,
        conversationContext: e,
        githubOrganization: o
      }
    )
  ] });
}, bl = [
  {
    key: "githubOrganization",
    label: "GitHub organization or user",
    type: "string",
    secret: !1,
    defaultValue: ""
  },
  {
    key: "enableRemoveAllLinks",
    label: 'Enable the "Remove all links" button',
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "showDanglingLinks",
    label: "Show unresolved links to GitHub items",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "enableCreateIssue",
    label: 'Enable the "Create issue" button',
    type: "boolean",
    secret: !1,
    defaultValue: !0
  }
], vs = ir(bl), Ni = "GITHUB", JP = {
  enabled: !1,
  name: "",
  githubOrganization: "",
  enableRemoveAllLinks: !1,
  showDanglingLinks: !1,
  enableCreateIssue: !0
}, QP = ({
  integrationId: e,
  configuration: n,
  handleRedirect: r,
  showNotification: i,
  automationCouplingState: a,
  renderConditionsEditor: o
}) => {
  const s = !e, l = ut({
    mode: "onChange",
    defaultValues: JP
  }), {
    create: c,
    update: m,
    remove: u,
    isLoading: f,
    error: h,
    misconfigurationCause: k,
    setMisconfigurationCause: w
  } = mr({
    integrationId: e,
    integrationType: Ni,
    handleRedirect: r,
    showNotification: i
  }), {
    isLoading: N,
    error: j,
    isWidgetUnknown: _,
    refetch: g,
    widgetConfiguration: O
  } = pr({
    integrationId: e,
    fieldDefinitions: bl,
    form: l,
    onMisconfigured: w
  }), { renderConditions: R, setRenderConditions: F, renderConditionsForSubmit: I } = fr({
    integrationId: e,
    widgetConfiguration: O,
    renderConditionsEditor: o
  }), L = (J) => yr(J, {
    fieldDefinitions: bl,
    isCreationMode: s,
    create: c,
    update: m,
    renderConditions: I
  }), W = l.watch("name");
  return /* @__PURE__ */ xe.jsxs(
    hr,
    {
      form: l,
      integrationId: e,
      onValidSubmit: L,
      error: j ?? h,
      onRetry: j ? g : void 0,
      isLoading: f || N,
      isWidgetUnknown: _,
      children: [
        k && /* @__PURE__ */ xe.jsx(gr, { cause: k }),
        /* @__PURE__ */ xe.jsxs(et, { children: [
          /* @__PURE__ */ xe.jsx(X, { children: /* @__PURE__ */ xe.jsx(He, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ xe.jsx(
            yn,
            {
              name: "enabled",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ xe.jsx(X, { span: 3, children: /* @__PURE__ */ xe.jsx(
            On,
            {
              name: "name",
              label: "Widget name",
              control: l.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ xe.jsx(X, { span: 3 }),
          /* @__PURE__ */ xe.jsx(X, { span: 3, children: /* @__PURE__ */ xe.jsx(
            On,
            {
              name: "githubOrganization",
              label: vs.githubOrganization,
              control: l.control,
              rules: { required: "GitHub organization or user is required" },
              componentProps: {
                placeholder: "Insert your GitHub organization or user name, e.g. dixahq",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ xe.jsx(X, { span: 3 }),
          /* @__PURE__ */ xe.jsx(X, { span: 3, children: /* @__PURE__ */ xe.jsx(He, { label: vs.enableRemoveAllLinks, children: /* @__PURE__ */ xe.jsx(
            yn,
            {
              name: "enableRemoveAllLinks",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ xe.jsx(X, { span: 3 }),
          /* @__PURE__ */ xe.jsx(X, { span: 3, children: /* @__PURE__ */ xe.jsx(He, { label: vs.showDanglingLinks, children: /* @__PURE__ */ xe.jsx(
            yn,
            {
              name: "showDanglingLinks",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ xe.jsx(X, { span: 3 }),
          /* @__PURE__ */ xe.jsx(X, { span: 3, children: /* @__PURE__ */ xe.jsx(He, { label: vs.enableCreateIssue, children: /* @__PURE__ */ xe.jsx(
            yn,
            {
              name: "enableCreateIssue",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ xe.jsx(X, { span: 3 }),
          !s && e && /* @__PURE__ */ xe.jsx(
            vi,
            {
              configuration: n,
              integrationId: e,
              integrationType: Ni,
              label: "Authorize with OAuth"
            }
          ),
          o && R !== null && /* @__PURE__ */ xe.jsx(X, { children: o({
            value: R,
            onChange: F,
            configurationKey: O?.id
          }) })
        ] }),
        /* @__PURE__ */ xe.jsx(
          vr,
          {
            integrationType: Ni,
            integrationId: e,
            widgetName: W,
            isCreationMode: s,
            isSubmitting: l.formState.isSubmitting,
            automationCouplingState: a,
            onConfirmDelete: () => u(),
            confirmDeleteVariant: "danger",
            deleteConfirmationBody: /* @__PURE__ */ xe.jsxs(b, { gap: "400", children: [
              /* @__PURE__ */ xe.jsx(
                he,
                {
                  size: 24,
                  name: "exclamation-triangle-filled",
                  color: "red.500"
                }
              ),
              /* @__PURE__ */ xe.jsxs(b, { gap: "200", flexDirection: "column", children: [
                /* @__PURE__ */ xe.jsxs($.Heading, { withMarginBottom: !0, children: [
                  "By deleting the ",
                  Ni,
                  " integration, all links between Dixa and ",
                  Ni,
                  " are also deleted."
                ] }),
                /* @__PURE__ */ xe.jsxs($.Paragraph, { children: [
                  "All data in ",
                  Ni,
                  " stays untouched."
                ] }),
                /* @__PURE__ */ xe.jsxs($.Paragraph, { children: [
                  "Are you sure you want to delete the ",
                  Ni,
                  " ",
                  'integration "',
                  W,
                  '"?'
                ] })
              ] })
            ] })
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._list_16pij_1{padding:0}._listItem_16pij_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_16pij_4:last-child{border-bottom:none}._listItemEdit_16pij_11{cursor:pointer}._clickableIcon_16pij_15{cursor:pointer;color:var(--dixa-typography-color-secondary)}._boxWrapper_89s7l_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._boxWrapper_89s7l_1:hover{border-color:var(--dixa-color-neutral-300)}._trackButton_89s7l_10{color:var(--dixa-typography-color-link)}._order_135ze_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_135ze_1:hover,._orderIsOpen_135ze_9{border-color:var(--dixa-color-neutral-400)}._orderHeader_135ze_12{cursor:pointer}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var hm = { exports: {} }, Xa = {}, G_;
function XP() {
  if (G_) return Xa;
  G_ = 1;
  var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, c, m) {
    var u, f = {}, h = null, k = null;
    m !== void 0 && (h = "" + m), c.key !== void 0 && (h = "" + c.key), c.ref !== void 0 && (k = c.ref);
    for (u in c) i.call(c, u) && !o.hasOwnProperty(u) && (f[u] = c[u]);
    if (l && l.defaultProps) for (u in c = l.defaultProps, c) f[u] === void 0 && (f[u] = c[u]);
    return { $$typeof: n, type: l, key: h, ref: k, props: f, _owner: a.current };
  }
  return Xa.Fragment = r, Xa.jsx = s, Xa.jsxs = s, Xa;
}
var ks = {}, Y_;
function ZP() {
  return Y_ || (Y_ = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), c = /* @__PURE__ */ Symbol.for("react.forward_ref"), m = /* @__PURE__ */ Symbol.for("react.suspense"), u = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), k = /* @__PURE__ */ Symbol.for("react.offscreen"), w = Symbol.iterator, N = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var d = w && t[w] || t[N];
      return typeof d == "function" ? d : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var d = arguments.length, p = new Array(d > 1 ? d - 1 : 0), y = 1; y < d; y++)
          p[y - 1] = arguments[y];
        O("error", t, p);
      }
    }
    function O(t, d, p) {
      {
        var y = _.ReactDebugCurrentFrame, C = y.getStackAddendum();
        C !== "" && (d += "%s", p = p.concat([C]));
        var T = p.map(function(S) {
          return String(S);
        });
        T.unshift("Warning: " + d), Function.prototype.apply.call(console[t], console, T);
      }
    }
    var R = !1, F = !1, I = !1, L = !1, W = !1, J;
    J = /* @__PURE__ */ Symbol.for("react.module.reference");
    function re(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || W || t === a || t === m || t === u || L || t === k || R || F || I || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === J || t.getModuleId !== void 0));
    }
    function K(t, d, p) {
      var y = t.displayName;
      if (y)
        return y;
      var C = d.displayName || d.name || "";
      return C !== "" ? p + "(" + C + ")" : p;
    }
    function Y(t) {
      return t.displayName || "Context";
    }
    function P(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var d = t;
            return Y(d) + ".Consumer";
          case s:
            var p = t;
            return Y(p._context) + ".Provider";
          case c:
            return K(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : P(t.type) || "Memo";
          case h: {
            var C = t, T = C._payload, S = C._init;
            try {
              return P(S(T));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, ie = 0, we, me, le, ge, V, be, Oe;
    function q() {
    }
    q.__reactDisabledLog = !0;
    function Ge() {
      {
        if (ie === 0) {
          we = console.log, me = console.info, le = console.warn, ge = console.error, V = console.group, be = console.groupCollapsed, Oe = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: q,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ie++;
      }
    }
    function sn() {
      {
        if (ie--, ie === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, t, {
              value: we
            }),
            info: B({}, t, {
              value: me
            }),
            warn: B({}, t, {
              value: le
            }),
            error: B({}, t, {
              value: ge
            }),
            group: B({}, t, {
              value: V
            }),
            groupCollapsed: B({}, t, {
              value: be
            }),
            groupEnd: B({}, t, {
              value: Oe
            })
          });
        }
        ie < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ie = _.ReactCurrentDispatcher, Ue;
    function De(t, d, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (C) {
            var y = C.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Ae;
    {
      var Je = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Je();
    }
    function Ee(t, d) {
      if (!t || Be)
        return "";
      {
        var p = Ae.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Be = !0;
      var C = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var T;
      T = Ie.current, Ie.current = null, Ge();
      try {
        if (d) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (ne) {
              y = ne;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (ne) {
              y = ne;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            y = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && y && typeof ne.stack == "string") {
          for (var x = ne.stack.split(`
`), Z = y.stack.split(`
`), A = x.length - 1, M = Z.length - 1; A >= 1 && M >= 0 && x[A] !== Z[M]; )
            M--;
          for (; A >= 1 && M >= 0; A--, M--)
            if (x[A] !== Z[M]) {
              if (A !== 1 || M !== 1)
                do
                  if (A--, M--, M < 0 || x[A] !== Z[M]) {
                    var ue = `
` + x[A].replace(" at new ", " at ");
                    return t.displayName && ue.includes("<anonymous>") && (ue = ue.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, ue), ue;
                  }
                while (A >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Ie.current = T, sn(), Error.prepareStackTrace = C;
      }
      var ze = t ? t.displayName || t.name : "", Te = ze ? De(ze) : "";
      return typeof t == "function" && Ae.set(t, Te), Te;
    }
    function Me(t, d, p) {
      return Ee(t, !1);
    }
    function en(t) {
      var d = t.prototype;
      return !!(d && d.isReactComponent);
    }
    function se(t, d, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ee(t, en(t));
      if (typeof t == "string")
        return De(t);
      switch (t) {
        case m:
          return De("Suspense");
        case u:
          return De("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case c:
            return Me(t.render);
          case f:
            return se(t.type, d, p);
          case h: {
            var y = t, C = y._payload, T = y._init;
            try {
              return se(T(C), d, p);
            } catch {
            }
          }
        }
      return "";
    }
    var de = Object.prototype.hasOwnProperty, Se = {}, Ve = _.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var d = t._owner, p = se(t.type, t._source, d ? d.type : null);
        Ve.setExtraStackFrame(p);
      } else
        Ve.setExtraStackFrame(null);
    }
    function kn(t, d, p, y, C) {
      {
        var T = Function.call.bind(de);
        for (var S in t)
          if (T(t, S)) {
            var x = void 0;
            try {
              if (typeof t[S] != "function") {
                var Z = Error((y || "React class") + ": " + p + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Z.name = "Invariant Violation", Z;
              }
              x = t[S](d, S, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (A) {
              x = A;
            }
            x && !(x instanceof Error) && (Pe(C), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, S, typeof x), Pe(null)), x instanceof Error && !(x.message in Se) && (Se[x.message] = !0, Pe(C), g("Failed %s type: %s", p, x.message), Pe(null));
          }
      }
    }
    var Q = Array.isArray;
    function E(t) {
      return Q(t);
    }
    function z(t) {
      {
        var d = typeof Symbol == "function" && Symbol.toStringTag, p = d && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function ae(t) {
      try {
        return ce(t), !1;
      } catch {
        return !0;
      }
    }
    function ce(t) {
      return "" + t;
    }
    function U(t) {
      if (ae(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", z(t)), ce(t);
    }
    var G = _.ReactCurrentOwner, ve = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, je, Re;
    function rn(t) {
      if (de.call(t, "ref")) {
        var d = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (d && d.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function bn(t) {
      if (de.call(t, "key")) {
        var d = Object.getOwnPropertyDescriptor(t, "key").get;
        if (d && d.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function an(t, d) {
      typeof t.ref == "string" && G.current;
    }
    function fn(t, d) {
      {
        var p = function() {
          je || (je = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", d));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function En(t, d) {
      {
        var p = function() {
          Re || (Re = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", d));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var _n = function(t, d, p, y, C, T, S) {
      var x = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: d,
        ref: p,
        props: S,
        // Record the component responsible for creating this element.
        _owner: T
      };
      return x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(x, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(x, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: C
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    };
    function Fn(t, d, p, y, C) {
      {
        var T, S = {}, x = null, Z = null;
        p !== void 0 && (U(p), x = "" + p), bn(d) && (U(d.key), x = "" + d.key), rn(d) && (Z = d.ref, an(d));
        for (T in d)
          de.call(d, T) && !ve.hasOwnProperty(T) && (S[T] = d[T]);
        if (t && t.defaultProps) {
          var A = t.defaultProps;
          for (T in A)
            S[T] === void 0 && (S[T] = A[T]);
        }
        if (x || Z) {
          var M = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          x && fn(S, M), Z && En(S, M);
        }
        return _n(t, x, Z, C, y, G.current, S);
      }
    }
    var Ze = _.ReactCurrentOwner, gn = _.ReactDebugCurrentFrame;
    function Le(t) {
      if (t) {
        var d = t._owner, p = se(t.type, t._source, d ? d.type : null);
        gn.setExtraStackFrame(p);
      } else
        gn.setExtraStackFrame(null);
    }
    var dn;
    dn = !1;
    function cn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function Nn() {
      {
        if (Ze.current) {
          var t = P(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Bn(t) {
      return "";
    }
    var Sn = {};
    function An(t) {
      {
        var d = Nn();
        if (!d) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (d = `

Check the top-level render call using <` + p + ">.");
        }
        return d;
      }
    }
    function vn(t, d) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = An(d);
        if (Sn[p])
          return;
        Sn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Ze.current && (y = " It was passed a child from " + P(t._owner.type) + "."), Le(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Le(null);
      }
    }
    function xn(t, d) {
      {
        if (typeof t != "object")
          return;
        if (E(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            cn(y) && vn(y, d);
          }
        else if (cn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var C = j(t);
          if (typeof C == "function" && C !== t.entries)
            for (var T = C.call(t), S; !(S = T.next()).done; )
              cn(S.value) && vn(S.value, d);
        }
      }
    }
    function Ln(t) {
      {
        var d = t.type;
        if (d == null || typeof d == "string")
          return;
        var p;
        if (typeof d == "function")
          p = d.propTypes;
        else if (typeof d == "object" && (d.$$typeof === c || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        d.$$typeof === f))
          p = d.propTypes;
        else
          return;
        if (p) {
          var y = P(d);
          kn(p, t.props, "prop", y, t);
        } else if (d.PropTypes !== void 0 && !dn) {
          dn = !0;
          var C = P(d);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", C || "Unknown");
        }
        typeof d.getDefaultProps == "function" && !d.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var d = Object.keys(t.props), p = 0; p < d.length; p++) {
          var y = d[p];
          if (y !== "children" && y !== "key") {
            Le(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Le(null);
            break;
          }
        }
        t.ref !== null && (Le(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Le(null));
      }
    }
    var Cn = {};
    function wn(t, d, p, y, C, T) {
      {
        var S = re(t);
        if (!S) {
          var x = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (x += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Z = Bn();
          Z ? x += Z : x += Nn();
          var A;
          t === null ? A = "null" : E(t) ? A = "array" : t !== void 0 && t.$$typeof === n ? (A = "<" + (P(t.type) || "Unknown") + " />", x = " Did you accidentally export a JSX literal instead of a component?") : A = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", A, x);
        }
        var M = Fn(t, d, p, C, T);
        if (M == null)
          return M;
        if (S) {
          var ue = d.children;
          if (ue !== void 0)
            if (y)
              if (E(ue)) {
                for (var ze = 0; ze < ue.length; ze++)
                  xn(ue[ze], t);
                Object.freeze && Object.freeze(ue);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              xn(ue, t);
        }
        if (de.call(d, "key")) {
          var Te = P(t), ne = Object.keys(d).filter(function(Kn) {
            return Kn !== "key";
          }), un = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Cn[Te + un]) {
            var Rn = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, un, Te, Rn, Te), Cn[Te + un] = !0;
          }
        }
        return t === i ? Vn(M) : Ln(M), M;
      }
    }
    function zn(t, d, p) {
      return wn(t, d, p, !0);
    }
    function qn(t, d, p) {
      return wn(t, d, p, !1);
    }
    var Un = qn, Wn = zn;
    ks.Fragment = i, ks.jsx = Un, ks.jsxs = Wn;
  })()), ks;
}
var J_;
function eA() {
  return J_ || (J_ = 1, process.env.NODE_ENV === "production" ? hm.exports = XP() : hm.exports = ZP()), hm.exports;
}
var Ce = eA(), Fo = /* @__PURE__ */ ((e) => (e.Outbound = "OUTBOUND", e.Return = "RETURN", e.UnknownDirectionType = "UNKNOWN_DIRECTION_TYPE", e.Unspecified = "UNSPECIFIED", e))(Fo || {}), Di = /* @__PURE__ */ ((e) => (e.Delivery = "DELIVERY", e.Instore = "INSTORE", e.Inwarehouse = "INWAREHOUSE", e.Mailbox = "MAILBOX", e.Pickup = "PICKUP", e.Unknown = "UNKNOWN", e))(Di || {}), Zt = /* @__PURE__ */ ((e) => (e.StepAwaitingSupplier = "STEP_AWAITING_SUPPLIER", e.StepConfirmedByMerchant = "STEP_CONFIRMED_BY_MERCHANT", e.StepDeliveredToConsumer = "STEP_DELIVERED_TO_CONSUMER", e.StepDeliveredToMerchant = "STEP_DELIVERED_TO_MERCHANT", e.StepDeliveredToPickupPoint = "STEP_DELIVERED_TO_PICKUP_POINT", e.StepLinehaulToCarrier = "STEP_LINEHAUL_TO_CARRIER", e.StepOnRoute = "STEP_ON_ROUTE", e.StepPreparedByMerchant = "STEP_PREPARED_BY_MERCHANT", e.StepReturnRequested = "STEP_RETURN_REQUESTED", e.StepSentBack = "STEP_SENT_BACK", e.StepSubmittedToCarrier = "STEP_SUBMITTED_TO_CARRIER", e.StepTerminated = "STEP_TERMINATED", e.StepUnknown = "STEP_UNKNOWN", e))(Zt || {});
const nA = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getOrders" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "locale" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Ingrid" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "DeliveryTracking_GetTrackingOrders" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }, { kind: "Argument", name: { kind: "Name", value: "locale" }, value: { kind: "Variable", name: { kind: "Name", value: "locale" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Ingrid_GetTrackingOrdersResponse" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orders" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "analytics_id" } }, { kind: "Field", name: { kind: "Name", value: "external_id" } }, { kind: "Field", name: { kind: "Name", value: "preselected_parcel_index" } }, { kind: "Field", name: { kind: "Name", value: "sender_name" } }, { kind: "Field", name: { kind: "Name", value: "site_name" } }, { kind: "Field", name: { kind: "Name", value: "tos_id" } }, { kind: "Field", name: { kind: "Name", value: "tracking_links" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "links" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "image" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }] } }, { kind: "Field", name: { kind: "Name", value: "cart" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "currency" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "attributes" } }, { kind: "Field", name: { kind: "Name", value: "cancelled_quantity" } }, { kind: "Field", name: { kind: "Name", value: "cancelled_total_price" } }, { kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "image" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }, { kind: "Field", name: { kind: "Name", value: "variant" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "size" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "prices" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shipping_components" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }] } }, { kind: "Field", name: { kind: "Name", value: "total" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "items_discount" } }, { kind: "Field", name: { kind: "Name", value: "items_price" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "shipping_discount" } }, { kind: "Field", name: { kind: "Name", value: "shipping_price" } }, { kind: "Field", name: { kind: "Name", value: "tax" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "parcels" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "alerts" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "awaiting_supplier" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "estimated_time" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "earliest" } }, { kind: "Field", name: { kind: "Name", value: "latest" } }] } }, { kind: "Field", name: { kind: "Name", value: "estimated_time_range" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "end" } }, { kind: "Field", name: { kind: "Name", value: "start" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "delivery_attempt_failed" } }, { kind: "Field", name: { kind: "Name", value: "delivery_delayed" } }, { kind: "Field", name: { kind: "Name", value: "delivery_delayed_from_carrier" } }, { kind: "Field", name: { kind: "Name", value: "estimated_delivery_time_updated" } }, { kind: "Field", name: { kind: "Name", value: "linehaul" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "estimated_time" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "earliest" } }, { kind: "Field", name: { kind: "Name", value: "latest" } }] } }, { kind: "Field", name: { kind: "Name", value: "estimated_time_range" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "end" } }, { kind: "Field", name: { kind: "Name", value: "start" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "out_for_delivery" } }, { kind: "Field", name: { kind: "Name", value: "submission_delayed" } }] } }, { kind: "Field", name: { kind: "Name", value: "carrier" } }, { kind: "Field", name: { kind: "Name", value: "carrier_fallback_enabled" } }, { kind: "Field", name: { kind: "Name", value: "carrier_link" } }, { kind: "Field", name: { kind: "Name", value: "carrier_logo_pattern" } }, { kind: "Field", name: { kind: "Name", value: "carrier_product_id" } }, { kind: "Field", name: { kind: "Name", value: "carrier_product_ref" } }, { kind: "Field", name: { kind: "Name", value: "delivery_type" } }, { kind: "Field", name: { kind: "Name", value: "direction_type" } }, { kind: "Field", name: { kind: "Name", value: "display_carrier_name" } }, { kind: "Field", name: { kind: "Name", value: "estimated_delivery_time" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "end" } }, { kind: "Field", name: { kind: "Name", value: "start" } }] } }, { kind: "Field", name: { kind: "Name", value: "exceptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "status" } }] } }, { kind: "Field", name: { kind: "Name", value: "index" } }, { kind: "Field", name: { kind: "Name", value: "line_items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "currency" } }, { kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "image" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "properties" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }] } }, { kind: "Field", name: { kind: "Name", value: "location" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address_lines" } }, { kind: "Field", name: { kind: "Name", value: "apartment_number" } }, { kind: "Field", name: { kind: "Name", value: "attn" } }, { kind: "Field", name: { kind: "Name", value: "building_name" } }, { kind: "Field", name: { kind: "Name", value: "care_of" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "coordinates" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "lat" } }, { kind: "Field", name: { kind: "Name", value: "lng" } }] } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "door_code" } }, { kind: "Field", name: { kind: "Name", value: "floor_number" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "po_box_id" } }, { kind: "Field", name: { kind: "Name", value: "postal_code" } }, { kind: "Field", name: { kind: "Name", value: "region" } }, { kind: "Field", name: { kind: "Name", value: "street" } }, { kind: "Field", name: { kind: "Name", value: "street_number" } }, { kind: "Field", name: { kind: "Name", value: "subregion" } }] } }, { kind: "Field", name: { kind: "Name", value: "location_external_id" } }, { kind: "Field", name: { kind: "Name", value: "location_type" } }, { kind: "Field", name: { kind: "Name", value: "operational_hours" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "free_text" } }, { kind: "Field", name: { kind: "Name", value: "fri" } }, { kind: "Field", name: { kind: "Name", value: "mon" } }, { kind: "Field", name: { kind: "Name", value: "sat" } }, { kind: "Field", name: { kind: "Name", value: "sun" } }, { kind: "Field", name: { kind: "Name", value: "thu" } }, { kind: "Field", name: { kind: "Name", value: "tue" } }, { kind: "Field", name: { kind: "Name", value: "wed" } }] } }, { kind: "Field", name: { kind: "Name", value: "pickup_instructions" } }] } }, { kind: "Field", name: { kind: "Name", value: "progress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "estimated_time" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "end" } }, { kind: "Field", name: { kind: "Name", value: "start" } }] } }, { kind: "Field", name: { kind: "Name", value: "step" } }, { kind: "Field", name: { kind: "Name", value: "time" } }] } }, { kind: "Field", name: { kind: "Name", value: "requested_shipping_method" } }, { kind: "Field", name: { kind: "Name", value: "sender_name" } }, { kind: "Field", name: { kind: "Name", value: "tracking_link" } }, { kind: "Field", name: { kind: "Name", value: "tracking_number" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Ingrid_Error" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "details" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, tA = {
  "\n  query getOrders($email: String!, $locale: String!) {\n    Ingrid {\n      DeliveryTracking_GetTrackingOrders(\n        email: $email\n        locale: $locale\n      ) {\n        ... on Ingrid_GetTrackingOrdersResponse {\n          orders {\n            analytics_id\n            external_id\n            preselected_parcel_index\n            sender_name\n            site_name\n            tos_id\n            tracking_links {\n              links {\n                type\n                url\n              }\n            }\n            items {\n              discount\n              image\n              name\n              price\n              quantity\n              sku\n              total_price\n            }\n            cart {\n              currency\n              items {\n                attributes\n                cancelled_quantity\n                cancelled_total_price\n                discount\n                image\n                name\n                price\n                quantity\n                sku\n                total_price\n                variant {\n                  color\n                  size\n                }\n              }\n              prices {\n                shipping_components {\n                  discount\n                  name\n                  price\n                }\n                total {\n                  discount\n                  items_discount\n                  items_price\n                  price\n                  shipping_discount\n                  shipping_price\n                  tax\n                }\n              }\n            }\n            parcels {\n              alerts {\n                created_at\n                type\n                awaiting_supplier {\n                  estimated_time {\n                    earliest\n                    latest\n                  }\n                  estimated_time_range {\n                    end\n                    start\n                  }\n                }\n                delivery_attempt_failed\n                delivery_delayed\n                delivery_delayed_from_carrier\n                estimated_delivery_time_updated\n                linehaul {\n                  estimated_time {\n                    earliest\n                    latest\n                  }\n                  estimated_time_range {\n                    end\n                    start\n                  }\n                }\n                out_for_delivery\n                submission_delayed\n              }\n              carrier\n              carrier_fallback_enabled\n              carrier_link\n              carrier_logo_pattern\n              carrier_product_id\n              carrier_product_ref\n              delivery_type\n              direction_type\n              display_carrier_name\n              estimated_delivery_time {\n                end\n                start\n              }\n              exceptions {\n                created_at\n                status\n              }\n              index\n              line_items {\n                currency\n                discount\n                image\n                name\n                price\n                properties\n                quantity\n                sku\n                total_price\n              }\n              location {\n                address {\n                  address_lines\n                  apartment_number\n                  attn\n                  building_name\n                  care_of\n                  city\n                  coordinates {\n                    lat\n                    lng\n                  }\n                  country\n                  door_code\n                  floor_number\n                  name\n                  po_box_id\n                  postal_code\n                  region\n                  street\n                  street_number\n                  subregion\n                }\n                location_external_id\n                location_type\n                operational_hours {\n                  free_text\n                  fri\n                  mon\n                  sat\n                  sun\n                  thu\n                  tue\n                  wed\n                }\n                pickup_instructions\n              }\n              progress {\n                estimated_time {\n                  end\n                  start\n                }\n                step\n                time\n              }\n              requested_shipping_method\n              sender_name\n              tracking_link\n              tracking_number\n            }\n          }\n        }\n\n        ... on Ingrid_Error {\n          code\n          details\n          message\n        }\n      }\n    }\n  }\n": nA
};
function rA(e) {
  return tA[e] ?? {};
}
const iA = rA(
  /* GraphQL */
  `
  query getOrders($email: String!, $locale: String!) {
    Ingrid {
      DeliveryTracking_GetTrackingOrders(
        email: $email
        locale: $locale
      ) {
        ... on Ingrid_GetTrackingOrdersResponse {
          orders {
            analytics_id
            external_id
            preselected_parcel_index
            sender_name
            site_name
            tos_id
            tracking_links {
              links {
                type
                url
              }
            }
            items {
              discount
              image
              name
              price
              quantity
              sku
              total_price
            }
            cart {
              currency
              items {
                attributes
                cancelled_quantity
                cancelled_total_price
                discount
                image
                name
                price
                quantity
                sku
                total_price
                variant {
                  color
                  size
                }
              }
              prices {
                shipping_components {
                  discount
                  name
                  price
                }
                total {
                  discount
                  items_discount
                  items_price
                  price
                  shipping_discount
                  shipping_price
                  tax
                }
              }
            }
            parcels {
              alerts {
                created_at
                type
                awaiting_supplier {
                  estimated_time {
                    earliest
                    latest
                  }
                  estimated_time_range {
                    end
                    start
                  }
                }
                delivery_attempt_failed
                delivery_delayed
                delivery_delayed_from_carrier
                estimated_delivery_time_updated
                linehaul {
                  estimated_time {
                    earliest
                    latest
                  }
                  estimated_time_range {
                    end
                    start
                  }
                }
                out_for_delivery
                submission_delayed
              }
              carrier
              carrier_fallback_enabled
              carrier_link
              carrier_logo_pattern
              carrier_product_id
              carrier_product_ref
              delivery_type
              direction_type
              display_carrier_name
              estimated_delivery_time {
                end
                start
              }
              exceptions {
                created_at
                status
              }
              index
              line_items {
                currency
                discount
                image
                name
                price
                properties
                quantity
                sku
                total_price
              }
              location {
                address {
                  address_lines
                  apartment_number
                  attn
                  building_name
                  care_of
                  city
                  coordinates {
                    lat
                    lng
                  }
                  country
                  door_code
                  floor_number
                  name
                  po_box_id
                  postal_code
                  region
                  street
                  street_number
                  subregion
                }
                location_external_id
                location_type
                operational_hours {
                  free_text
                  fri
                  mon
                  sat
                  sun
                  thu
                  tue
                  wed
                }
                pickup_instructions
              }
              progress {
                estimated_time {
                  end
                  start
                }
                step
                time
              }
              requested_shipping_method
              sender_name
              tracking_link
              tracking_number
            }
          }
        }

        ... on Ingrid_Error {
          code
          details
          message
        }
      }
    }
  }
`
), Q_ = (e) => {
  if (!e) return "";
  try {
    return new Intl.DateTimeFormat(void 0, {
      dateStyle: "medium",
      timeStyle: "short"
    }).format(new Date(e));
  } catch {
    return e;
  }
}, ZC = (e, n) => {
  try {
    return new Intl.NumberFormat(void 0, {
      style: "currency",
      currency: n
    }).format(e);
  } catch {
    return e.toString();
  }
}, aA = "_listItem_16pij_4", oA = "_clickableIcon_16pij_15", Ho = {
  listItem: aA,
  clickableIcon: oA
}, e1 = ({
  items: e,
  title: n,
  currency: r,
  openByDefault: i = !1
}) => {
  const [a, o] = pe(i);
  return !e || e.length === 0 ? null : /* @__PURE__ */ Ce.jsx(b, { gap: "100", flexDirection: "column", children: /* @__PURE__ */ Ce.jsxs(b, { gap: "250", flexDirection: "column", children: [
    /* @__PURE__ */ Ce.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ Ce.jsx(he, { size: 14, name: "list-ul", color: "blue.900" }),
      /* @__PURE__ */ Ce.jsx(b, { gap: "200", flexDirection: "column", children: /* @__PURE__ */ Ce.jsxs(
        b,
        {
          gap: "100",
          flexDirection: "row",
          onClick: () => o(!a),
          className: Ho.clickableIcon,
          alignItems: "center",
          children: [
            /* @__PURE__ */ Ce.jsx($.Paragraph, { variant: "3", children: n }),
            /* @__PURE__ */ Ce.jsx(
              he,
              {
                size: 14,
                name: a ? "angle-down" : "angle-right"
              }
            )
          ]
        }
      ) })
    ] }),
    a && /* @__PURE__ */ Ce.jsx(Ye, { children: e.map((l, c) => {
      if (!l) return null;
      const { name: m, quantity: u, price: f, image: h, sku: k } = l, w = l.currency ?? r;
      return /* @__PURE__ */ Ce.jsx(
        Ye.Item,
        {
          contentLeft: /* @__PURE__ */ Ce.jsxs(b, { gap: "200", children: [
            /* @__PURE__ */ Ce.jsx($.Paragraph, { children: u }),
            /* @__PURE__ */ Ce.jsx($.Paragraph, { children: "×" })
          ] }),
          title: /* @__PURE__ */ Ce.jsxs(b, { flexDirection: "column", gap: "050", children: [
            /* @__PURE__ */ Ce.jsx($.Paragraph, { variant: "4", children: m }),
            f != null && /* @__PURE__ */ Ce.jsx($.Paragraph, { variant: "4", color: "tertiary", children: ZC(f / 100, w) })
          ] }),
          contentRight: h && /* @__PURE__ */ Ce.jsx(Fa, { src: h, alt: m ?? "Product image" }),
          className: Ho.listItem
        },
        `item-${c}-${k}`
      );
    }) })
  ] }) });
}, sA = "_boxWrapper_89s7l_1", lA = "_trackButton_89s7l_10", X_ = {
  boxWrapper: sA,
  trackButton: lA
}, dA = {
  [Zt.StepUnknown]: "Unknown",
  [Zt.StepConfirmedByMerchant]: "Confirmed by merchant",
  [Zt.StepPreparedByMerchant]: "Prepared by merchant",
  [Zt.StepSubmittedToCarrier]: "Submitted to carrier",
  [Zt.StepLinehaulToCarrier]: "Linehaul to carrier",
  [Zt.StepOnRoute]: "On route",
  [Zt.StepDeliveredToPickupPoint]: "At pickup point",
  [Zt.StepDeliveredToConsumer]: "Delivered to customer",
  [Zt.StepDeliveredToMerchant]: "Returned to merchant",
  [Zt.StepReturnRequested]: "Return requested",
  [Zt.StepSentBack]: "Sent back",
  [Zt.StepTerminated]: "Terminated",
  [Zt.StepAwaitingSupplier]: "Awaiting supplier"
}, cA = {
  [Di.Delivery]: "Home delivery",
  [Di.Pickup]: "Pickup point",
  [Di.Instore]: "In-store pickup",
  [Di.Mailbox]: "Mailbox",
  [Di.Inwarehouse]: "Warehouse",
  [Di.Unknown]: "Unknown"
}, uA = {
  [Fo.Outbound]: "From merchant to customer",
  [Fo.Return]: "Return from customer to merchant",
  [Fo.Unspecified]: "Unspecified",
  [Fo.UnknownDirectionType]: "Unknown"
}, mA = (e) => e ? dA[e] ?? e : "", pA = (e) => e ? cA[e] ?? e : "", fA = (e) => e ? uA[e] ?? e : "", hA = (e) => {
  if (!e) return null;
  const n = [e.street, e.street_number].filter(Boolean).join(" ");
  return [
    e.name,
    n,
    e.postal_code,
    e.city,
    e.country
  ].filter(Boolean).join(`
`);
}, yA = ({
  parcel: e
}) => {
  const { isCopied: n, copy: r } = Jt();
  if (!e)
    return null;
  const {
    carrier: i,
    progress: a,
    tracking_number: o,
    line_items: s,
    carrier_product_ref: l,
    carrier_link: c,
    display_carrier_name: m,
    delivery_type: u,
    direction_type: f,
    estimated_delivery_time: h
  } = e, k = m || l || i, w = a?.filter((R) => R?.time !== ""), N = mA(w?.[0]?.step), j = pA(u), _ = fA(f), g = hA(e.location?.address), O = 14;
  return /* @__PURE__ */ Ce.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      padding: "250",
      className: X_.boxWrapper,
      children: [
        /* @__PURE__ */ Ce.jsx($.Heading, { variant: "heading-4", children: k }),
        /* @__PURE__ */ Ce.jsxs(b, { justifyContent: "space-between", children: [
          /* @__PURE__ */ Ce.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ Ce.jsx(
              he,
              {
                size: O,
                name: "magnifying-glass-chart",
                color: "blue.900"
              }
            ),
            /* @__PURE__ */ Ce.jsxs(b, { gap: "100", flexDirection: "column", children: [
              /* @__PURE__ */ Ce.jsx($.Paragraph, { variant: "3", children: "Carrier tracking ID" }),
              /* @__PURE__ */ Ce.jsxs(b, { gap: "100", flexDirection: "row", flexWrap: "wrap", children: [
                !o && /* @__PURE__ */ Ce.jsx($.Paragraph, { variant: "4", color: "tertiary", children: "No tracking ID here yet" }),
                o && /* @__PURE__ */ Ce.jsx($.Paragraph, { variant: "4", color: "secondary", children: o })
              ] })
            ] })
          ] }),
          o && /* @__PURE__ */ Ce.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ Ce.jsx(Xe, { content: "Copy tracking ID", children: /* @__PURE__ */ Ce.jsx(
            he,
            {
              size: O,
              name: n ? "done" : "copy",
              className: Ho.clickableIcon,
              onClick: () => r(o)
            }
          ) }) })
        ] }),
        N && /* @__PURE__ */ Ce.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ Ce.jsx(he, { size: O, name: "chart-donut", color: "blue.900" }),
          /* @__PURE__ */ Ce.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ Ce.jsx($.Paragraph, { variant: "3", children: "Status" }),
            /* @__PURE__ */ Ce.jsx($.Paragraph, { variant: "4", color: "secondary", children: N })
          ] })
        ] }),
        _ && /* @__PURE__ */ Ce.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ Ce.jsx(he, { size: O, name: "arrow-right", color: "blue.900" }),
          /* @__PURE__ */ Ce.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ Ce.jsx($.Paragraph, { variant: "3", children: "Direction" }),
            /* @__PURE__ */ Ce.jsx($.Paragraph, { variant: "4", color: "secondary", children: _ })
          ] })
        ] }),
        h && /* @__PURE__ */ Ce.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ Ce.jsx(he, { size: O, name: "calendar", color: "blue.900" }),
          /* @__PURE__ */ Ce.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ Ce.jsx($.Paragraph, { variant: "3", children: "Estimated delivery" }),
            /* @__PURE__ */ Ce.jsxs($.Paragraph, { variant: "4", color: "secondary", children: [
              Q_(h.start),
              " ",
              h.end && " until"
            ] }),
            h.end && /* @__PURE__ */ Ce.jsx($.Paragraph, { variant: "4", color: "secondary", children: Q_(h.end) })
          ] })
        ] }),
        u && /* @__PURE__ */ Ce.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ Ce.jsx(he, { size: O, name: "info", color: "blue.900" }),
          /* @__PURE__ */ Ce.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ Ce.jsx($.Paragraph, { variant: "3", children: "Delivery type" }),
            /* @__PURE__ */ Ce.jsx($.Paragraph, { variant: "4", color: "secondary", children: j })
          ] })
        ] }),
        g && /* @__PURE__ */ Ce.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ Ce.jsx(he, { size: O, name: "map-pin", color: "blue.900" }),
          /* @__PURE__ */ Ce.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ Ce.jsx($.Paragraph, { variant: "3", children: "Pickup location" }),
            /* @__PURE__ */ Ce.jsx($.Paragraph, { variant: "4", color: "secondary", children: g })
          ] })
        ] }),
        /* @__PURE__ */ Ce.jsx(e1, { title: "Parcel items", items: s }),
        c && /* @__PURE__ */ Ce.jsxs(
          It,
          {
            variant: "secondary",
            className: X_.trackButton,
            navigate: () => window.open(c, "_blank")?.focus(),
            slotStart: /* @__PURE__ */ Ce.jsx(he, { name: "external-link" }),
            children: [
              "Track on ",
              k ?? "carrier",
              " website"
            ]
          }
        )
      ]
    }
  );
}, gA = "_order_135ze_1", vA = "_orderIsOpen_135ze_9", kA = "_orderHeader_135ze_12", ym = {
  order: gA,
  orderIsOpen: vA,
  orderHeader: kA
}, Z_ = "No order number found", bA = ({
  order: e,
  openByDefault: n
}) => {
  const [r, i] = pe(n), { isCopied: a, copy: o } = Jt(), { isCopied: s, copy: l } = Jt();
  if (!e)
    return null;
  const { cart: c, parcels: m, sender_name: u, tos_id: f } = e, h = e.external_id?.trim(), k = c?.currency || "", w = c?.prices?.total?.price ?? 0, N = ZC(w / 100, k), j = 14, _ = u && u.trim() !== "" ? u : "unknown sender";
  return /* @__PURE__ */ Ce.jsxs(
    b,
    {
      className: ct(ym.order, {
        [ym.orderIsOpen]: r
      }),
      gap: "300",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ Ce.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: ym.orderHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ Ce.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ Ce.jsxs($.Paragraph, { variant: "4", children: [
                  "From ",
                  _
                ] }),
                h ? /* @__PURE__ */ Ce.jsx($.Paragraph, { variant: "3", children: /* @__PURE__ */ Ce.jsxs("span", { children: [
                  "#",
                  h
                ] }) }) : /* @__PURE__ */ Ce.jsx($.Paragraph, { variant: "4", color: "tertiary", children: Z_ })
              ] }),
              /* @__PURE__ */ Ce.jsx(
                Qt,
                {
                  variant: "tertiary",
                  icon: r ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ Ce.jsxs(b, { gap: "250", flexDirection: "column", margin: "200 0 0", children: [
          /* @__PURE__ */ Ce.jsxs(b, { justifyContent: "space-between", children: [
            /* @__PURE__ */ Ce.jsxs(b, { gap: "250", flexDirection: "row", children: [
              /* @__PURE__ */ Ce.jsx(he, { size: j, name: "tag", color: "blue.900" }),
              /* @__PURE__ */ Ce.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ Ce.jsx($.Paragraph, { variant: "3", children: "Order number" }),
                /* @__PURE__ */ Ce.jsx(b, { gap: "100", flexDirection: "row", flexWrap: "wrap", children: h ? /* @__PURE__ */ Ce.jsx($.Paragraph, { variant: "4", color: "secondary", children: h }) : /* @__PURE__ */ Ce.jsx($.Paragraph, { variant: "4", color: "tertiary", children: Z_ }) })
              ] })
            ] }),
            h && /* @__PURE__ */ Ce.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ Ce.jsx(Xe, { content: "Copy order number", children: /* @__PURE__ */ Ce.jsx(
              he,
              {
                size: j,
                name: s ? "done" : "copy",
                className: Ho.clickableIcon,
                onClick: () => l(h)
              }
            ) }) })
          ] }),
          /* @__PURE__ */ Ce.jsxs(b, { justifyContent: "space-between", children: [
            /* @__PURE__ */ Ce.jsxs(b, { gap: "250", flexDirection: "row", children: [
              /* @__PURE__ */ Ce.jsx(
                he,
                {
                  size: j,
                  name: "magnifying-glass-chart",
                  color: "blue.900"
                }
              ),
              /* @__PURE__ */ Ce.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ Ce.jsx($.Paragraph, { variant: "3", children: "Ingrid tracking ID" }),
                /* @__PURE__ */ Ce.jsxs(b, { gap: "100", flexDirection: "row", flexWrap: "wrap", children: [
                  !f && /* @__PURE__ */ Ce.jsx($.Paragraph, { variant: "4", color: "tertiary", children: "No tracking ID here yet" }),
                  f && /* @__PURE__ */ Ce.jsx($.Paragraph, { variant: "4", color: "secondary", children: f })
                ] })
              ] })
            ] }),
            f && /* @__PURE__ */ Ce.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ Ce.jsx(Xe, { content: "Copy tracking ID", children: /* @__PURE__ */ Ce.jsx(
              he,
              {
                size: j,
                name: a ? "done" : "copy",
                className: Ho.clickableIcon,
                onClick: () => o(f)
              }
            ) }) })
          ] }),
          u && /* @__PURE__ */ Ce.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ Ce.jsx(he, { size: 14, name: "user", color: "blue.900" }),
            /* @__PURE__ */ Ce.jsxs(b, { gap: "100", flexDirection: "column", children: [
              /* @__PURE__ */ Ce.jsx($.Paragraph, { variant: "3", children: "Sender" }),
              /* @__PURE__ */ Ce.jsx($.Paragraph, { variant: "4", children: u })
            ] })
          ] }),
          /* @__PURE__ */ Ce.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ Ce.jsx(he, { size: 14, name: "chart-bar", color: "blue.900" }),
            /* @__PURE__ */ Ce.jsxs(b, { gap: "100", flexDirection: "column", children: [
              /* @__PURE__ */ Ce.jsx($.Paragraph, { variant: "3", children: "Order value" }),
              /* @__PURE__ */ Ce.jsx($.Paragraph, { variant: "4", children: N })
            ] })
          ] }),
          /* @__PURE__ */ Ce.jsx(
            e1,
            {
              openByDefault: !0,
              title: "Order items",
              items: c?.items?.map((g) => g),
              currency: c?.currency
            }
          ),
          m && /* @__PURE__ */ Ce.jsxs(b, { gap: "200", flexDirection: "column", margin: "0 0 100 0", children: [
            /* @__PURE__ */ Ce.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
              /* @__PURE__ */ Ce.jsx($.Heading, { variant: "heading-4", children: "Parcels" }),
              m.length > 0 && /* @__PURE__ */ Ce.jsx(Pn, { variant: "success", size: "small", children: m.length })
            ] }),
            m.length === 0 && /* @__PURE__ */ Ce.jsx($.Paragraph, { variant: "4", color: "secondary", children: "No parcels here" }),
            m.map((g, O) => /* @__PURE__ */ Ce.jsx(
              yA,
              {
                parcel: g
              },
              `parcel-${O}-${g?.tracking_number}`
            ))
          ] })
        ] })
      ]
    }
  );
}, _A = (e) => {
  const n = [], r = /* @__PURE__ */ new Map();
  for (const i of e) {
    if (!i?.external_id) {
      n.push(i);
      continue;
    }
    const a = r.get(i.external_id);
    if (a)
      a.parcels = [
        ...a.parcels ?? [],
        ...i.parcels ?? []
      ];
    else {
      const o = { ...i };
      r.set(i.external_id, o), n.push(o);
    }
  }
  return n;
}, ex = (e) => {
  let n = 1 / 0;
  for (const r of e?.parcels ?? [])
    for (const i of r?.progress ?? []) {
      if (!i?.time)
        continue;
      const a = new Date(i.time).getTime();
      !Number.isNaN(a) && a < n && (n = a);
    }
  return n === 1 / 0 ? -1 / 0 : n;
}, xA = (e) => [...e].sort(
  (n, r) => ex(r) - ex(n)
), SA = ({
  customerEmail: e
}) => {
  const { useQuery: n } = hn(), [r, i] = pe([]), a = !e, { data: o, loading: s, error: l } = n(iA, {
    skip: a,
    variables: {
      email: e,
      locale: "en-GB"
    }
  }), c = !s && r.length > 0, m = l ? yI({
    error: l.graphQLErrors?.[0]
  }) : !1, u = l ? _w({
    error: l.graphQLErrors?.[0]
  }) : !1;
  return Qe(() => {
    const f = o?.Ingrid?.DeliveryTracking_GetTrackingOrders;
    f?.orders && i(
      xA(
        _A(f.orders)
      )
    );
  }, [o?.Ingrid?.DeliveryTracking_GetTrackingOrders]), s ? /* @__PURE__ */ Ce.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ Ce.jsx(mn, {}) }) : m || !c && !l ? /* @__PURE__ */ Ce.jsx($.Paragraph, { color: "tertiary", align: "center", children: "No orders to track" }) : u ? /* @__PURE__ */ Ce.jsx($.Paragraph, { color: "tertiary", align: "center", children: "The API token used for the integration does not have the necessary access rights. Please contact your administrator." }) : l ? /* @__PURE__ */ Ce.jsx($n, { error: l }) : /* @__PURE__ */ Ce.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Ce.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ Ce.jsx($.Heading, { variant: "heading-3", children: "Orders" }),
      /* @__PURE__ */ Ce.jsx(Pn, { variant: "success", size: "small", children: r.length })
    ] }),
    /* @__PURE__ */ Ce.jsx(b, { gap: "200", flexDirection: "column", children: /* @__PURE__ */ Ce.jsx(b, { gap: "200", flexDirection: "column", children: r.map((f, h) => /* @__PURE__ */ Ce.jsx(
      bA,
      {
        order: f,
        openByDefault: h === 0
      },
      `${h}-${f?.tos_id}`
    )) }) })
  ] });
}, NA = ({ conversationContext: e }) => {
  const n = e?.customer?.email;
  return /* @__PURE__ */ Ce.jsx(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300",
      "data-testid": "widget-wrapper",
      children: /* @__PURE__ */ Ce.jsx(SA, { customerEmail: n })
    }
  );
}, _l = [
  {
    key: "ingridUseStagingEnvironment",
    label: "Use Ingrid staging environment",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "ingridSiteId",
    label: "Site ID",
    type: "string",
    secret: !1,
    defaultValue: ""
  },
  {
    key: "ingridApiToken",
    label: "API token",
    type: "string",
    secret: !0,
    defaultValue: ""
  }
], gm = ir(_l), jA = {
  enabled: !1,
  name: "",
  ingridSiteId: "",
  ingridApiToken: "",
  ingridUseStagingEnvironment: !1
}, wA = ({
  integrationId: e,
  handleRedirect: n,
  showNotification: r,
  automationCouplingState: i,
  renderConditionsEditor: a
}) => {
  const o = !e, s = ut({
    mode: "onChange",
    defaultValues: jA
  }), {
    create: l,
    update: c,
    remove: m,
    isLoading: u,
    error: f,
    misconfigurationCause: h,
    setMisconfigurationCause: k
  } = mr({
    integrationId: e,
    integrationType: "INGRID",
    handleRedirect: n,
    showNotification: r
  }), {
    isLoading: w,
    error: N,
    isWidgetUnknown: j,
    refetch: _,
    widgetConfiguration: g
  } = pr({
    integrationId: e,
    fieldDefinitions: _l,
    form: s,
    onMisconfigured: k
  }), { renderConditions: O, setRenderConditions: R, renderConditionsForSubmit: F } = fr({
    integrationId: e,
    widgetConfiguration: g,
    renderConditionsEditor: a
  }), I = (W) => yr(W, {
    fieldDefinitions: _l,
    isCreationMode: o,
    create: l,
    update: c,
    renderConditions: F
  }), L = s.watch("name");
  return /* @__PURE__ */ Ce.jsxs(
    hr,
    {
      form: s,
      integrationId: e,
      onValidSubmit: I,
      error: N ?? f,
      onRetry: N ? _ : void 0,
      isLoading: u || w,
      isWidgetUnknown: j,
      children: [
        h && /* @__PURE__ */ Ce.jsx(gr, { cause: h }),
        /* @__PURE__ */ Ce.jsxs(et, { children: [
          /* @__PURE__ */ Ce.jsx(X, { children: /* @__PURE__ */ Ce.jsx(He, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ Ce.jsx(
            yn,
            {
              name: "enabled",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ Ce.jsx(X, { span: 3, children: /* @__PURE__ */ Ce.jsx(
            On,
            {
              name: "name",
              label: "Widget name",
              control: s.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ Ce.jsx(X, { span: 3 }),
          /* @__PURE__ */ Ce.jsx(X, { span: 3, children: /* @__PURE__ */ Ce.jsx(He, { label: gm.ingridUseStagingEnvironment, children: /* @__PURE__ */ Ce.jsx(
            yn,
            {
              name: "ingridUseStagingEnvironment",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ Ce.jsx(X, { span: 3 }),
          /* @__PURE__ */ Ce.jsx(X, { span: 3, children: /* @__PURE__ */ Ce.jsx(
            On,
            {
              name: "ingridSiteId",
              label: gm.ingridSiteId,
              control: s.control,
              rules: { required: "Site ID is required" },
              componentProps: {
                placeholder: "Site ID from Ingrid",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ Ce.jsx(X, { span: 3 }),
          /* @__PURE__ */ Ce.jsx(X, { span: 3, children: /* @__PURE__ */ Ce.jsx(
            $r,
            {
              name: "ingridApiToken",
              label: gm.ingridApiToken,
              control: s.control,
              isCreationMode: o,
              rules: { required: "API token is required" },
              componentProps: {
                placeholder: "API token from Ingrid",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ Ce.jsx(X, { span: 3 }),
          a && O !== null && /* @__PURE__ */ Ce.jsx(X, { children: a({
            value: O,
            onChange: R,
            configurationKey: g?.id
          }) })
        ] }),
        /* @__PURE__ */ Ce.jsx(
          vr,
          {
            integrationType: "INGRID",
            integrationId: e,
            widgetName: L,
            isCreationMode: o,
            isSubmitting: s.formState.isSubmitting,
            automationCouplingState: i,
            onConfirmDelete: () => m()
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode('@charset "UTF-8";._jiraCode_h30p6_1{padding:2px 4px;font-size:100%;font-family:var(--dixa-typography-family-code);color:var(--dixa-typography-color-primary);border-radius:4px}._jiraCodeInline_h30p6_8{background-color:var(--dixa-color-neutral-200)}._collapse_m2gjh_1{border:1px solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);padding:0}._collapseHeader_m2gjh_10>div{padding:var(--dixa-size-spacer-300) 0!important}._collapseHeader_m2gjh_10>div>div>p{white-space:unset!important}._collapseHeader_m2gjh_10>div:first-child{width:100%}._collapseHeader_m2gjh_10>div:first-child div:first-child{width:100%}._collapseHeader_m2gjh_10>div:first-child div:first-child p{width:calc(100% - 20px)}._collapseHeader_m2gjh_10{background-color:transparent!important;padding:0 var(--dixa-size-spacer-300) 0 0;letter-spacing:-.08px;color:var(--dixa-color-neutral-500)}._collapseHeaderLink_m2gjh_31{font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-link);text-decoration:none}._collapseHeaderLink_m2gjh_31:hover{text-decoration:underline}._collapseHeaderStatus_m2gjh_40{font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-color-neutral-500);float:right}._collapseHeaderIcon_m2gjh_46{padding-top:.35em;transform:scale(1.4);margin-left:var(--dixa-size-spacer-100)}._collapseHeaderTitle_m2gjh_51{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-300);line-height:var(--dixa-typography-line-height-300);letter-spacing:-.16px;color:var(--dixa-typography-color-primary);width:100%}._collapseContent_m2gjh_59{padding:var(--dixa-size-spacer-200) var(--dixa-size-spacer-300)!important}._collapseContentHeadline_m2gjh_62{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-100);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-tertiary)}._collapseContentButtonSpacer_m2gjh_68{margin-top:var(--dixa-size-spacer-250)}._collapseContentButtonLink_m2gjh_71{color:var(--dixa-typography-color-link)}._collapseContentStatusTag_m2gjh_74{max-width:10em}._collapseContentDescription_m2gjh_77{max-height:75vh;overflow-y:auto}._result_1wiub_54{padding:0 var(--dixa-size-spacer-200);margin:0;outline:0;border:0;color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:12px;line-height:32px;height:48px;width:100%;cursor:pointer}._result_1wiub_54:hover,._result_1wiub_54:focus{background-color:var(--dixa-color-neutral-100)}._resultName_1wiub_74{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:var(--dixa-typography-weight-semibold)}._resultNameIcon_1wiub_82{height:var(--dixa-typography-line-height-200);padding-right:var(--dixa-size-spacer-100);margin-top:-2px}._resultDescription_1wiub_87{width:100%;text-align:left;font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-secondary);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;margin-top:-.5em;margin-bottom:.5em}._resultLinkIcon_1wiub_99{position:absolute;right:5px;background-color:var(--dixa-color-neutral-000);border:1px solid var(--dixa-color-neutral-300);border-radius:5px;color:var(--dixa-color-neutral-500)}._tooltip_1wiub_108{width:500px;max-height:60vh;overflow:hidden;text-overflow:ellipsis}._tooltipContent_1wiub_114{display:flex;flex-direction:column;width:100%;max-height:60vh;max-height:60dvh}._tooltipName_1wiub_121{text-align:left;white-space:nowrap;font-weight:var(--dixa-typography-weight-semibold)}._tooltipNameIcon_1wiub_126{height:var(--dixa-typography-line-height-300);padding-right:var(--dixa-size-spacer-100);margin-top:-2px}._tooltipDescription_1wiub_131{padding-top:.5em;width:100%;text-align:left;color:var(--dixa-typography-color-secondary);flex-grow:1;overflow-y:auto}._tooltipSummary_1wiub_139{padding-top:.5em;font-weight:var(--dixa-typography-weight-semibold)}._tooltipTag_1wiub_143{width:fit-content;max-width:15em}._itemButton_1hl53_1{border:none;padding:0}._result_1hl53_6{padding:0 var(--dixa-size-spacer-200);margin:0;outline:0;border:0;color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:var(--dixa-typography-size-200);line-height:32px;height:48px;width:100%;cursor:pointer}._result_1hl53_6:hover,._result_1hl53_6:focus{background-color:var(--dixa-color-neutral-100)}._resultIcon_1hl53_26{height:var(--dixa-size-spacer-400);padding-right:var(--dixa-size-spacer-250)}._resultName_1hl53_30{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:var(--dixa-typography-weight-semibold)}._resultCheckIcon_1hl53_38{height:var(--dixa-size-spacer-400)}._modalBody_1hk1o_1{width:600px}._modalBodyFormFields_1hk1o_4{display:grid;gap:var(--dixa-size-spacer-300) var(--dixa-size-spacer-400)}._wrapper_1bylq_1{gap:var(--dixa-size-spacer-250);margin-bottom:var(--dixa-size-spacer-300)}._inputWrapper_1bylq_6{background-color:var(--dixa-color-neutral-100);border-radius:var(--dixa-size-border-radius-100);margin:var(--dixa-size-spacer-300) 0;gap:var(--dixa-size-spacer-250);padding:var(--dixa-size-spacer-300)}._inputField_1bylq_14{text-align:center}._inputSeparator_1bylq_18{color:var(--dixa-color-neutral-600);text-align:center}._buttonLink_1bylq_23{color:var(--dixa-typography-color-link)}._noIssuesFound_1bylq_27{color:var(--dixa-color-neutral-400);font-size:var(--dixa-typography-size-200)}')), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var vm = { exports: {} }, Za = {}, nx;
function CA() {
  if (nx) return Za;
  nx = 1;
  var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, c, m) {
    var u, f = {}, h = null, k = null;
    m !== void 0 && (h = "" + m), c.key !== void 0 && (h = "" + c.key), c.ref !== void 0 && (k = c.ref);
    for (u in c) i.call(c, u) && !o.hasOwnProperty(u) && (f[u] = c[u]);
    if (l && l.defaultProps) for (u in c = l.defaultProps, c) f[u] === void 0 && (f[u] = c[u]);
    return { $$typeof: n, type: l, key: h, ref: k, props: f, _owner: a.current };
  }
  return Za.Fragment = r, Za.jsx = s, Za.jsxs = s, Za;
}
var bs = {}, tx;
function FA() {
  return tx || (tx = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), c = /* @__PURE__ */ Symbol.for("react.forward_ref"), m = /* @__PURE__ */ Symbol.for("react.suspense"), u = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), k = /* @__PURE__ */ Symbol.for("react.offscreen"), w = Symbol.iterator, N = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var d = w && t[w] || t[N];
      return typeof d == "function" ? d : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var d = arguments.length, p = new Array(d > 1 ? d - 1 : 0), y = 1; y < d; y++)
          p[y - 1] = arguments[y];
        O("error", t, p);
      }
    }
    function O(t, d, p) {
      {
        var y = _.ReactDebugCurrentFrame, C = y.getStackAddendum();
        C !== "" && (d += "%s", p = p.concat([C]));
        var T = p.map(function(S) {
          return String(S);
        });
        T.unshift("Warning: " + d), Function.prototype.apply.call(console[t], console, T);
      }
    }
    var R = !1, F = !1, I = !1, L = !1, W = !1, J;
    J = /* @__PURE__ */ Symbol.for("react.module.reference");
    function re(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || W || t === a || t === m || t === u || L || t === k || R || F || I || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === J || t.getModuleId !== void 0));
    }
    function K(t, d, p) {
      var y = t.displayName;
      if (y)
        return y;
      var C = d.displayName || d.name || "";
      return C !== "" ? p + "(" + C + ")" : p;
    }
    function Y(t) {
      return t.displayName || "Context";
    }
    function P(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var d = t;
            return Y(d) + ".Consumer";
          case s:
            var p = t;
            return Y(p._context) + ".Provider";
          case c:
            return K(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : P(t.type) || "Memo";
          case h: {
            var C = t, T = C._payload, S = C._init;
            try {
              return P(S(T));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, ie = 0, we, me, le, ge, V, be, Oe;
    function q() {
    }
    q.__reactDisabledLog = !0;
    function Ge() {
      {
        if (ie === 0) {
          we = console.log, me = console.info, le = console.warn, ge = console.error, V = console.group, be = console.groupCollapsed, Oe = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: q,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ie++;
      }
    }
    function sn() {
      {
        if (ie--, ie === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, t, {
              value: we
            }),
            info: B({}, t, {
              value: me
            }),
            warn: B({}, t, {
              value: le
            }),
            error: B({}, t, {
              value: ge
            }),
            group: B({}, t, {
              value: V
            }),
            groupCollapsed: B({}, t, {
              value: be
            }),
            groupEnd: B({}, t, {
              value: Oe
            })
          });
        }
        ie < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ie = _.ReactCurrentDispatcher, Ue;
    function De(t, d, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (C) {
            var y = C.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Ae;
    {
      var Je = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Je();
    }
    function Ee(t, d) {
      if (!t || Be)
        return "";
      {
        var p = Ae.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Be = !0;
      var C = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var T;
      T = Ie.current, Ie.current = null, Ge();
      try {
        if (d) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (ne) {
              y = ne;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (ne) {
              y = ne;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            y = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && y && typeof ne.stack == "string") {
          for (var x = ne.stack.split(`
`), Z = y.stack.split(`
`), A = x.length - 1, M = Z.length - 1; A >= 1 && M >= 0 && x[A] !== Z[M]; )
            M--;
          for (; A >= 1 && M >= 0; A--, M--)
            if (x[A] !== Z[M]) {
              if (A !== 1 || M !== 1)
                do
                  if (A--, M--, M < 0 || x[A] !== Z[M]) {
                    var ue = `
` + x[A].replace(" at new ", " at ");
                    return t.displayName && ue.includes("<anonymous>") && (ue = ue.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, ue), ue;
                  }
                while (A >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Ie.current = T, sn(), Error.prepareStackTrace = C;
      }
      var ze = t ? t.displayName || t.name : "", Te = ze ? De(ze) : "";
      return typeof t == "function" && Ae.set(t, Te), Te;
    }
    function Me(t, d, p) {
      return Ee(t, !1);
    }
    function en(t) {
      var d = t.prototype;
      return !!(d && d.isReactComponent);
    }
    function se(t, d, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ee(t, en(t));
      if (typeof t == "string")
        return De(t);
      switch (t) {
        case m:
          return De("Suspense");
        case u:
          return De("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case c:
            return Me(t.render);
          case f:
            return se(t.type, d, p);
          case h: {
            var y = t, C = y._payload, T = y._init;
            try {
              return se(T(C), d, p);
            } catch {
            }
          }
        }
      return "";
    }
    var de = Object.prototype.hasOwnProperty, Se = {}, Ve = _.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var d = t._owner, p = se(t.type, t._source, d ? d.type : null);
        Ve.setExtraStackFrame(p);
      } else
        Ve.setExtraStackFrame(null);
    }
    function kn(t, d, p, y, C) {
      {
        var T = Function.call.bind(de);
        for (var S in t)
          if (T(t, S)) {
            var x = void 0;
            try {
              if (typeof t[S] != "function") {
                var Z = Error((y || "React class") + ": " + p + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Z.name = "Invariant Violation", Z;
              }
              x = t[S](d, S, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (A) {
              x = A;
            }
            x && !(x instanceof Error) && (Pe(C), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, S, typeof x), Pe(null)), x instanceof Error && !(x.message in Se) && (Se[x.message] = !0, Pe(C), g("Failed %s type: %s", p, x.message), Pe(null));
          }
      }
    }
    var Q = Array.isArray;
    function E(t) {
      return Q(t);
    }
    function z(t) {
      {
        var d = typeof Symbol == "function" && Symbol.toStringTag, p = d && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function ae(t) {
      try {
        return ce(t), !1;
      } catch {
        return !0;
      }
    }
    function ce(t) {
      return "" + t;
    }
    function U(t) {
      if (ae(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", z(t)), ce(t);
    }
    var G = _.ReactCurrentOwner, ve = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, je, Re;
    function rn(t) {
      if (de.call(t, "ref")) {
        var d = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (d && d.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function bn(t) {
      if (de.call(t, "key")) {
        var d = Object.getOwnPropertyDescriptor(t, "key").get;
        if (d && d.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function an(t, d) {
      typeof t.ref == "string" && G.current;
    }
    function fn(t, d) {
      {
        var p = function() {
          je || (je = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", d));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function En(t, d) {
      {
        var p = function() {
          Re || (Re = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", d));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var _n = function(t, d, p, y, C, T, S) {
      var x = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: d,
        ref: p,
        props: S,
        // Record the component responsible for creating this element.
        _owner: T
      };
      return x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(x, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(x, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: C
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    };
    function Fn(t, d, p, y, C) {
      {
        var T, S = {}, x = null, Z = null;
        p !== void 0 && (U(p), x = "" + p), bn(d) && (U(d.key), x = "" + d.key), rn(d) && (Z = d.ref, an(d));
        for (T in d)
          de.call(d, T) && !ve.hasOwnProperty(T) && (S[T] = d[T]);
        if (t && t.defaultProps) {
          var A = t.defaultProps;
          for (T in A)
            S[T] === void 0 && (S[T] = A[T]);
        }
        if (x || Z) {
          var M = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          x && fn(S, M), Z && En(S, M);
        }
        return _n(t, x, Z, C, y, G.current, S);
      }
    }
    var Ze = _.ReactCurrentOwner, gn = _.ReactDebugCurrentFrame;
    function Le(t) {
      if (t) {
        var d = t._owner, p = se(t.type, t._source, d ? d.type : null);
        gn.setExtraStackFrame(p);
      } else
        gn.setExtraStackFrame(null);
    }
    var dn;
    dn = !1;
    function cn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function Nn() {
      {
        if (Ze.current) {
          var t = P(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Bn(t) {
      return "";
    }
    var Sn = {};
    function An(t) {
      {
        var d = Nn();
        if (!d) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (d = `

Check the top-level render call using <` + p + ">.");
        }
        return d;
      }
    }
    function vn(t, d) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = An(d);
        if (Sn[p])
          return;
        Sn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Ze.current && (y = " It was passed a child from " + P(t._owner.type) + "."), Le(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Le(null);
      }
    }
    function xn(t, d) {
      {
        if (typeof t != "object")
          return;
        if (E(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            cn(y) && vn(y, d);
          }
        else if (cn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var C = j(t);
          if (typeof C == "function" && C !== t.entries)
            for (var T = C.call(t), S; !(S = T.next()).done; )
              cn(S.value) && vn(S.value, d);
        }
      }
    }
    function Ln(t) {
      {
        var d = t.type;
        if (d == null || typeof d == "string")
          return;
        var p;
        if (typeof d == "function")
          p = d.propTypes;
        else if (typeof d == "object" && (d.$$typeof === c || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        d.$$typeof === f))
          p = d.propTypes;
        else
          return;
        if (p) {
          var y = P(d);
          kn(p, t.props, "prop", y, t);
        } else if (d.PropTypes !== void 0 && !dn) {
          dn = !0;
          var C = P(d);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", C || "Unknown");
        }
        typeof d.getDefaultProps == "function" && !d.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var d = Object.keys(t.props), p = 0; p < d.length; p++) {
          var y = d[p];
          if (y !== "children" && y !== "key") {
            Le(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Le(null);
            break;
          }
        }
        t.ref !== null && (Le(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Le(null));
      }
    }
    var Cn = {};
    function wn(t, d, p, y, C, T) {
      {
        var S = re(t);
        if (!S) {
          var x = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (x += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Z = Bn();
          Z ? x += Z : x += Nn();
          var A;
          t === null ? A = "null" : E(t) ? A = "array" : t !== void 0 && t.$$typeof === n ? (A = "<" + (P(t.type) || "Unknown") + " />", x = " Did you accidentally export a JSX literal instead of a component?") : A = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", A, x);
        }
        var M = Fn(t, d, p, C, T);
        if (M == null)
          return M;
        if (S) {
          var ue = d.children;
          if (ue !== void 0)
            if (y)
              if (E(ue)) {
                for (var ze = 0; ze < ue.length; ze++)
                  xn(ue[ze], t);
                Object.freeze && Object.freeze(ue);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              xn(ue, t);
        }
        if (de.call(d, "key")) {
          var Te = P(t), ne = Object.keys(d).filter(function(Kn) {
            return Kn !== "key";
          }), un = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Cn[Te + un]) {
            var Rn = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, un, Te, Rn, Te), Cn[Te + un] = !0;
          }
        }
        return t === i ? Vn(M) : Ln(M), M;
      }
    }
    function zn(t, d, p) {
      return wn(t, d, p, !0);
    }
    function qn(t, d, p) {
      return wn(t, d, p, !1);
    }
    var Un = qn, Wn = zn;
    bs.Fragment = i, bs.jsx = Un, bs.jsxs = Wn;
  })()), bs;
}
var rx;
function IA() {
  return rx || (rx = 1, process.env.NODE_ENV === "production" ? vm.exports = CA() : vm.exports = FA()), vm.exports;
}
var fe = IA();
const fg = (e, n) => {
  const r = (o) => (e.marks || []).map((s) => ({
    formatterFunction: n.marks[e.type]?.[s.type],
    mark: s
  })).reduce(
    (s, l) => () => l.formatterFunction?.(l.mark, s) || o,
    () => o
  )(), i = (o, s) => () => o.content ? o.content.map((l) => fg(l, s)) : [], a = n.nodes[e.type] || n.default;
  return r(
    a(e, i(e, n))
  );
}, $A = "_jiraCode_h30p6_1", EA = "_jiraCodeInline_h30p6_8", km = {
  jiraCode: $A,
  jiraCodeInline: EA
}, n1 = {
  default: (e, n) => n().every((r) => typeof r == "string") ? n().join(" ") : /* @__PURE__ */ fe.jsx(fe.Fragment, { children: n() }),
  nodes: {
    doc: (e, n) => /* @__PURE__ */ fe.jsx("div", { children: n() }),
    paragraph: (e, n) => /* @__PURE__ */ fe.jsx("p", { children: n() }),
    text: (e) => e.text || "",
    hardBreak: () => /* @__PURE__ */ fe.jsx("br", {}),
    bulletList: (e, n) => /* @__PURE__ */ fe.jsx("ul", { children: n() }),
    orderedList: (e, n) => /* @__PURE__ */ fe.jsx("ol", { children: n() }),
    listItem: (e, n) => /* @__PURE__ */ fe.jsx("li", { children: n() }),
    codeBlock: (e, n) => /* @__PURE__ */ fe.jsx("pre", { children: /* @__PURE__ */ fe.jsx("code", { className: km.jiraCode, children: n() }) }),
    heading: (e, n) => {
      switch (e.attrs?.level) {
        // Not using headlines above level 3
        case 1:
          return /* @__PURE__ */ fe.jsx("h3", { children: n() });
        case 2:
          return /* @__PURE__ */ fe.jsx("h4", { children: n() });
        case 3:
          return /* @__PURE__ */ fe.jsx("h5", { children: n() });
        case 4:
          return /* @__PURE__ */ fe.jsx("h6", { children: n() });
        case 5:
          return /* @__PURE__ */ fe.jsx("b", { children: n() });
        case 6:
          return /* @__PURE__ */ fe.jsx("b", { children: n() });
        default:
          return /* @__PURE__ */ fe.jsx("h4", { children: n() });
      }
    }
  },
  marks: {
    text: {
      em: (e, n) => /* @__PURE__ */ fe.jsx("em", { children: n() }),
      strong: (e, n) => /* @__PURE__ */ fe.jsx("b", { children: n() }),
      underline: (e, n) => /* @__PURE__ */ fe.jsx("u", { children: n() }),
      link: (e, n) => /* @__PURE__ */ fe.jsx("a", { href: e.attrs?.href || "", target: "_blank", rel: "noreferrer", children: n() }),
      code: (e, n) => /* @__PURE__ */ fe.jsx("code", { className: ct(km.jiraCode, km.jiraCodeInline), children: n() })
      // Removing color support for now.
      // textColor: (mark, next) => (
      // 	<span style={{ color: mark.attrs?.['color'] }}>{next()}</span>
      // ),
    }
  }
}, xl = ({
  iconUrl: e,
  className: n,
  width: r
}) => {
  const [i, a] = pe(!1);
  return !e || i ? /* @__PURE__ */ fe.jsx(he, { size: r, name: "question", className: n }) : /* @__PURE__ */ fe.jsx(
    "img",
    {
      src: e,
      width: r,
      className: n,
      onError: ({ currentTarget: o }) => {
        o.onerror = null, a(!0);
      }
    }
  );
}, TA = "_collapse_m2gjh_1", RA = "_collapseHeader_m2gjh_10", DA = "_collapseHeaderLink_m2gjh_31", OA = "_collapseHeaderStatus_m2gjh_40", PA = "_collapseHeaderTitle_m2gjh_51", AA = "_collapseContent_m2gjh_59", LA = "_collapseContentHeadline_m2gjh_62", VA = "_collapseContentButtonSpacer_m2gjh_68", zA = "_collapseContentButtonLink_m2gjh_71", UA = "_collapseContentStatusTag_m2gjh_74", MA = "_collapseContentDescription_m2gjh_77", Nr = {
  collapse: TA,
  collapseHeader: RA,
  collapseHeaderLink: DA,
  collapseHeaderStatus: OA,
  collapseHeaderTitle: PA,
  collapseContent: AA,
  collapseContentHeadline: LA,
  collapseContentButtonSpacer: VA,
  collapseContentButtonLink: zA,
  collapseContentStatusTag: UA,
  collapseContentDescription: MA
}, t1 = ({
  jiraInstanceUrl: e,
  avatarId: n,
  iconUrl: r
}) => n ? `${e}/rest/api/3/universal_avatar/view/type/issuetype/avatar/${n}?size=medium` : r, BA = ({
  issues: e,
  jiraInstanceUrl: n,
  unlinkIssue: r
}) => {
  const i = e.reduce(
    (c, m) => m?.id ? { ...c, [m.id]: !1 } : c,
    {}
  ), [a, o] = pe(i), { track: s } = jn(), l = (c, m) => {
    o({ ...a, [c]: m });
  };
  return /* @__PURE__ */ fe.jsx(b, { flexDirection: "column", gap: "250", children: e?.length ? e.map((c) => {
    const { summary: m, description: u, status: f, issuetype: h } = c?.fields || {}, k = t1({
      avatarId: h?.avatarId,
      iconUrl: h?.iconUrl,
      jiraInstanceUrl: n
    }), w = !!(c?.id && a[c.id]);
    return /* @__PURE__ */ fe.jsxs(
      xr,
      {
        onToggle: () => c?.id && l(c.id, !a[c.id]),
        isOpen: w,
        className: Nr.collapse,
        children: [
          /* @__PURE__ */ fe.jsx(xr.Header, { className: Nr.collapseHeader, children: /* @__PURE__ */ fe.jsxs(
            b,
            {
              flexDirection: "column",
              gap: "200",
              justifyContent: "space-between",
              children: [
                /* @__PURE__ */ fe.jsxs(b, { flexDirection: "row", justifyContent: "space-between", children: [
                  /* @__PURE__ */ fe.jsxs(b, { alignItems: "center", gap: "200", children: [
                    /* @__PURE__ */ fe.jsx(xl, { width: 16, iconUrl: k }),
                    /* @__PURE__ */ fe.jsx(
                      "a",
                      {
                        className: Nr.collapseHeaderLink,
                        href: `${n}/browse/${c?.key}`,
                        target: "_blank",
                        rel: "noreferrer",
                        onClick: (N) => {
                          N.stopPropagation(), c?.key && s("jira:view:issue:clicked", {
                            jiraIssueKey: c.key,
                            jiraInstanceUrl: n
                          });
                        },
                        children: /* @__PURE__ */ fe.jsxs(b, { alignItems: "center", gap: "200", children: [
                          c?.key,
                          /* @__PURE__ */ fe.jsx(he, { name: "external-link", size: 16 })
                        ] })
                      },
                      c?.key
                    )
                  ] }),
                  /* @__PURE__ */ fe.jsx("span", { className: Nr.collapseHeaderStatus, children: f?.name && /* @__PURE__ */ fe.jsx(Jn, { className: Nr.collapseContentStatusTag, children: f.name }) })
                ] }),
                /* @__PURE__ */ fe.jsx("div", { className: Nr.collapseHeaderTitle, children: m })
              ]
            }
          ) }),
          /* @__PURE__ */ fe.jsx(xr.Content, { className: Nr.collapseContent, children: /* @__PURE__ */ fe.jsxs(b, { flexDirection: "column", gap: "250", margin: "0 0 200 0", children: [
            /* @__PURE__ */ fe.jsx("div", { className: Nr.collapseContentHeadline, children: "Description" }),
            /* @__PURE__ */ fe.jsx(lt, { className: Nr.collapseContentDescription, children: u ? fg(u, n1) : "" }),
            /* @__PURE__ */ fe.jsx(
              tt,
              {
                icon: "link-slash",
                variant: "secondary",
                className: Nr.collapseContentButtonSpacer,
                onClick: () => c?.key && r(c.key),
                children: "Unlink issue from Jira"
              }
            ),
            /* @__PURE__ */ fe.jsx(
              It,
              {
                slotEnd: /* @__PURE__ */ fe.jsx(he, { name: "external-link" }),
                variant: "tertiary",
                className: Nr.collapseContentButtonLink,
                navigate: () => {
                  c?.key && (s("jira:view:issue:clicked", {
                    jiraIssueKey: c.key,
                    jiraInstanceUrl: n
                  }), window.open(
                    `${n}/browse/${c.key}`,
                    "_blank"
                  )?.focus());
                },
                children: "View issue in Jira"
              }
            )
          ] }) })
        ]
      },
      c?.id
    );
  }) : /* @__PURE__ */ fe.jsx(fe.Fragment, {}) });
}, qA = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createBacklink" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueKey" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "title" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "url" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "globalId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "createOrUpdateRemoteIssueLink" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "issueIdOrKey" }, value: { kind: "Variable", name: { kind: "Name", value: "issueKey" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "globalId" }, value: { kind: "Variable", name: { kind: "Name", value: "globalId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "application" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "name" }, value: { kind: "StringValue", value: "Dixa Conversations", block: !1 } }, { kind: "ObjectField", name: { kind: "Name", value: "type" }, value: { kind: "StringValue", value: "com.dixa.conversations", block: !1 } }] } }, { kind: "ObjectField", name: { kind: "Name", value: "relationship" }, value: { kind: "StringValue", value: "dixa-backlink", block: !1 } }, { kind: "ObjectField", name: { kind: "Name", value: "object" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "title" }, value: { kind: "Variable", name: { kind: "Name", value: "title" } } }, { kind: "ObjectField", name: { kind: "Name", value: "url" }, value: { kind: "Variable", name: { kind: "Name", value: "url" } } }, { kind: "ObjectField", name: { kind: "Name", value: "icon" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "url16x16" }, value: { kind: "StringValue", value: "https://www.dixa.com/app/themes/dixa/app/frontend/src/images/favicons/favicon-32x32.png?v=2", block: !1 } }, { kind: "ObjectField", name: { kind: "Name", value: "title" }, value: { kind: "StringValue", value: "Dixa", block: !1 } }] } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "__typename" } }] } }] } }] } }] }, HA = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "removeBacklink" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueKey" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "globalId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "deleteRemoteIssueLinkByGlobalId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "issueIdOrKey" }, value: { kind: "Variable", name: { kind: "Name", value: "issueKey" } } }, { kind: "Argument", name: { kind: "Name", value: "globalId" }, value: { kind: "Variable", name: { kind: "Name", value: "globalId" } } }] }] } }] } }] }, WA = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Jira_IssueUpdateDetails_Input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "createIssue" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Jira_CreatedIssue" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Jira_ErrorCollection" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errorMessages" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "errors" } }] } }] } }] } }] } }] }, KA = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getAllProjects" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrls" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "_24x24" } }] } }] } }] } }] } }] }, GA = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCreateIssueMeta" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "projectKey" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getCreateIssueMeta" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "projectKeys" }, value: { kind: "ListValue", values: [{ kind: "Variable", name: { kind: "Name", value: "projectKey" } }] } }, { kind: "Argument", name: { kind: "Name", value: "expand" }, value: { kind: "StringValue", value: "projects.issuetypes.fields", block: !1 } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "projects" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "issuetypes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "iconUrl" } }, { kind: "Field", name: { kind: "Name", value: "entityId" } }, { kind: "Field", name: { kind: "Name", value: "hierarchyLevel" } }, { kind: "Field", name: { kind: "Name", value: "subtask" } }, { kind: "Field", name: { kind: "Name", value: "scope" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "project" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "additionalProperties" } }] } }, { kind: "Field", name: { kind: "Name", value: "expand" } }, { kind: "Field", name: { kind: "Name", value: "subtask" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "fields" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "additionalProperties" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "value" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "required" } }, { kind: "Field", name: { kind: "Name", value: "hasDefaultValue" } }, { kind: "Field", name: { kind: "Name", value: "schema" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "system" } }, { kind: "Field", name: { kind: "Name", value: "items" } }, { kind: "Field", name: { kind: "Name", value: "custom" } }, { kind: "Field", name: { kind: "Name", value: "customId" } }] } }, { kind: "Field", name: { kind: "Name", value: "allowedValues" } }, { kind: "Field", name: { kind: "Name", value: "defaultValue" } }, { kind: "Field", name: { kind: "Name", value: "operations" } }, { kind: "Field", name: { kind: "Name", value: "autoCompleteUrl" } }] } }] } }] } }] } }] } }] } }] } }] } }] }, YA = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchAndReconsileIssuesUsingJql" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "jql" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxResults" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "searchAndReconsileIssuesUsingJql" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "jql" }, value: { kind: "Variable", name: { kind: "Name", value: "jql" } } }, { kind: "Argument", name: { kind: "Name", value: "maxResults" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }, { kind: "Argument", name: { kind: "Name", value: "fields" }, value: { kind: "ListValue", values: [{ kind: "StringValue", value: "summary", block: !1 }, { kind: "StringValue", value: "description", block: !1 }, { kind: "StringValue", value: "status", block: !1 }, { kind: "StringValue", value: "updated", block: !1 }, { kind: "StringValue", value: "issuetype", block: !1 }, { kind: "StringValue", value: "project", block: !1 }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issues" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "fields" } }] } }] } }] } }] } }] }, JA = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "findUsers" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "findUsers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "accountId" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "self" } }, { kind: "Field", name: { kind: "Name", value: "active" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrls" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "_24x24" } }] } }] } }] } }] } }] }, QA = {
  '\n  mutation createBacklink(\n    $issueKey: String!\n    $title: String!\n    $url: String!\n    $globalId: String!\n  ) {\n    Jira {\n      createOrUpdateRemoteIssueLink(\n        issueIdOrKey: $issueKey\n        input: {\n          globalId: $globalId\n          application: {\n            name: "Dixa Conversations"\n            type: "com.dixa.conversations"\n          }\n          relationship: "dixa-backlink"\n          object: {\n            title: $title\n            url: $url\n            icon: {\n              url16x16: "https://www.dixa.com/app/themes/dixa/app/frontend/src/images/favicons/favicon-32x32.png?v=2"\n              title: "Dixa"\n            }\n          }\n        }\n      ) {\n        __typename\n      }\n    }\n  }\n': qA,
  "\n  mutation removeBacklink($issueKey: String!, $globalId: String!) {\n    Jira {\n      deleteRemoteIssueLinkByGlobalId(\n        issueIdOrKey: $issueKey\n        globalId: $globalId\n      )\n    }\n  }\n": HA,
  "\n  mutation createIssue($input: Jira_IssueUpdateDetails_Input) {\n    Jira {\n      createIssue(input: $input) {\n        ... on Jira_CreatedIssue {\n          id\n          key\n        }\n        ... on Jira_ErrorCollection {\n          errorMessages\n          status\n          errors\n        }\n      }\n    }\n  }\n": WA,
  "\n  query jira {\n    Jira {\n      getAllProjects {\n        id\n        key\n        name\n        avatarUrls {\n          _24x24\n        }\n      }\n    }\n  }\n": KA,
  '\n  query getCreateIssueMeta($projectKey: String) {\n    Jira {\n      getCreateIssueMeta(\n        projectKeys: [$projectKey]\n        expand: "projects.issuetypes.fields"\n      ) {\n        projects {\n          id\n          key\n          name\n          issuetypes {\n            id\n            name\n            iconUrl\n            entityId\n            hierarchyLevel\n            subtask\n            scope {\n              type\n              project {\n                id\n                key\n                name\n              }\n              additionalProperties\n            }\n            expand\n            subtask\n            description\n            fields {\n              additionalProperties {\n                key\n                value {\n                  key\n                  name\n                  required\n                  hasDefaultValue\n                  schema {\n                    type\n                    system\n                    items\n                    custom\n                    customId\n                  }\n                  allowedValues\n                  defaultValue\n                  operations\n                  autoCompleteUrl\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n': GA,
  '\n  query searchAndReconsileIssuesUsingJql($jql: String!, $maxResults: Int) {\n    Jira {\n      searchAndReconsileIssuesUsingJql(\n        jql: $jql\n        maxResults: $maxResults\n        fields: [\n          "summary"\n          "description"\n          "status"\n          "updated"\n          "issuetype"\n          "project"\n        ]\n      ) {\n        issues {\n          id\n          key\n          fields\n        }\n      }\n    }\n  }\n': YA,
  "\n  query findUsers($query: String) {\n    Jira {\n      findUsers(query: $query) {\n        accountId\n        displayName\n        self\n        active\n        avatarUrls {\n          _24x24\n        }\n      }\n    }\n  }\n": JA
};
function Gi(e) {
  return QA[e] ?? {};
}
const r1 = Gi(
  /* GraphQL */
  `
  query searchAndReconsileIssuesUsingJql($jql: String!, $maxResults: Int) {
    Jira {
      searchAndReconsileIssuesUsingJql(
        jql: $jql
        maxResults: $maxResults
        fields: [
          "summary"
          "description"
          "status"
          "updated"
          "issuetype"
          "project"
        ]
      ) {
        issues {
          id
          key
          fields
        }
      }
    }
  }
`
), XA = Gi(
  /* GraphQL */
  `
  mutation createBacklink(
    $issueKey: String!
    $title: String!
    $url: String!
    $globalId: String!
  ) {
    Jira {
      createOrUpdateRemoteIssueLink(
        issueIdOrKey: $issueKey
        input: {
          globalId: $globalId
          application: {
            name: "Dixa Conversations"
            type: "com.dixa.conversations"
          }
          relationship: "dixa-backlink"
          object: {
            title: $title
            url: $url
            icon: {
              url16x16: "https://www.dixa.com/app/themes/dixa/app/frontend/src/images/favicons/favicon-32x32.png?v=2"
              title: "Dixa"
            }
          }
        }
      ) {
        __typename
      }
    }
  }
`
), ZA = Gi(
  /* GraphQL */
  `
  mutation removeBacklink($issueKey: String!, $globalId: String!) {
    Jira {
      deleteRemoteIssueLinkByGlobalId(
        issueIdOrKey: $issueKey
        globalId: $globalId
      )
    }
  }
`
), e2 = Gi(
  /* GraphQL */
  `
  query jira {
    Jira {
      getAllProjects {
        id
        key
        name
        avatarUrls {
          _24x24
        }
      }
    }
  }
`
), n2 = Gi(
  /* GraphQL */
  `
  query getCreateIssueMeta($projectKey: String) {
    Jira {
      getCreateIssueMeta(
        projectKeys: [$projectKey]
        expand: "projects.issuetypes.fields"
      ) {
        projects {
          id
          key
          name
          issuetypes {
            id
            name
            iconUrl
            entityId
            hierarchyLevel
            subtask
            scope {
              type
              project {
                id
                key
                name
              }
              additionalProperties
            }
            expand
            subtask
            description
            fields {
              additionalProperties {
                key
                value {
                  key
                  name
                  required
                  hasDefaultValue
                  schema {
                    type
                    system
                    items
                    custom
                    customId
                  }
                  allowedValues
                  defaultValue
                  operations
                  autoCompleteUrl
                }
              }
            }
          }
        }
      }
    }
  }
`
), t2 = Gi(
  /* GraphQL */
  `
  mutation createIssue($input: Jira_IssueUpdateDetails_Input) {
    Jira {
      createIssue(input: $input) {
        ... on Jira_CreatedIssue {
          id
          key
        }
        ... on Jira_ErrorCollection {
          errorMessages
          status
          errors
        }
      }
    }
  }
`
), r2 = Gi(
  /* GraphQL */
  `
  query findUsers($query: String) {
    Jira {
      findUsers(query: $query) {
        accountId
        displayName
        self
        active
        avatarUrls {
          _24x24
        }
      }
    }
  }
`
), hg = new RegExp("[a-zA-Z0-9_]{2,}-[0-9]+"), i2 = new RegExp(`^${hg.source}$`), a2 = new RegExp(`/${hg.source}$`), ix = new RegExp(
  `.+?[&?]selectedIssue=(${hg.source})[&?]?.*`
);
function i1(e, n) {
  const r = { jira: { issues: [] } }, [i, a] = pe([]), [o, s] = pe([]), [l, c] = pe(), { track: m } = jn(), { showNotification: u, showModal: f, useLazyQuery: h, useMutation: k } = hn(), {
    loading: w,
    data: N,
    error: j,
    store: _
  } = Cy(e ?? null), [
    g,
    { loading: O, error: R, data: F }
  ] = h(r1, {
    notifyOnNetworkStatusChange: !0
  });
  Qe(() => {
    const le = F?.Jira?.searchAndReconsileIssuesUsingJql?.issues || [];
    le?.length && (s(le), a(le.map((ge) => ge?.key).filter(Boolean)));
  }, [F]), Qe(
    () => c(j || R || void 0),
    [j, R]
  ), Qe(
    () => {
      w || Y();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [N?.jira?.issues, w]
  );
  const I = async (le, ge) => {
    await _(le).then(() => {
      u({
        icon: "check-circle-filled",
        severity: "success",
        title: ge.success.title,
        text: ge.success.text
      });
    }).catch((V) => {
      u({
        title: ge.error.title,
        text: `${ge.error.text} ${V.message && " (" + V.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, [L] = k(XA, {
    onError: (le) => {
      u({
        title: "Something went wrong",
        text: `It looks like something went wrong when trying to create a link back from the issue to the conversation. Please create it manually in Jira.
				${le.message && " (" + le.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    }
  }), W = (le, ge) => {
    const V = window.location.href, be = ge ? V.replace(
      e?.toString() ?? "",
      ge?.toString()
    ) : V, Oe = ge ? `# ${ge}` : `# ${e}`;
    L({
      variables: {
        issueKey: le,
        title: Oe,
        url: be,
        globalId: `system=${be}`
      }
    });
  }, [J] = k(ZA, {
    onError: (le) => {
      u({
        title: "Something went wrong",
        text: `It looks like something went wrong when trying to remove a link back from the issue to the conversation. Please remove it manually from Jira.
					${le.message && " (" + le.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    }
  }), re = (le) => {
    const ge = window.location.href;
    J({
      variables: {
        issueKey: le,
        globalId: `system=${ge}`
      }
    });
  }, K = (le) => ({
    jiraInstanceUrl: n,
    jiraIssueKey: le
  }), Y = () => {
    N && N.jira?.issues?.length > 0 ? g({
      variables: {
        jql: `key in (${N?.jira?.issues.join(",")})`,
        maxResults: 15
      }
    }) : s([]);
  }, P = async (le, ge) => {
    m("jira:issue:link:clicked", K(le));
    const V = N?.jira?.issues ? N : r;
    V.jira.issues = Array.from(
      new Set(V.jira.issues).add(le)
    ), await _(V, ge?.toString()).then(() => W(le, ge)).catch((be) => {
      u({
        title: "Linking failed",
        text: `Linking ${le} failed. Please try again. ${be.message && " (" + be.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, B = (le) => {
    m("jira:issue:link:clicked", K(le));
    const ge = N?.jira?.issues ? N : r;
    ge.jira.issues = Array.from(
      new Set(ge.jira.issues).add(le)
    ), I(ge, {
      success: {
        title: "Jira issue linked",
        text: `You linked the Jira issue ${le} to this conversation.`
      },
      error: {
        title: "Linking failed",
        text: `Linking ${le} failed. Please try again.`
      }
    }).then(() => W(le));
  }, ie = (le) => {
    m("jira:issue:unlink:clicked", K(le)), f({
      headline: `Unlink issue ${le}?`,
      text: `You are about to unlink the issue ${le}. Do you want to proceed?`,
      confirmLabel: "Unlink Jira issue",
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        m("jira:issue:unlink:confirmed", K(le));
        const ge = {
          ...N,
          jira: {
            ...N?.jira,
            issues: N?.jira?.issues.filter((V) => V !== le) || []
          }
        };
        I(ge, {
          success: {
            title: "Jira issue unlinked",
            text: `You unlinked the Jira issue ${le}`
          },
          error: {
            title: "Unlinking failed",
            text: `Unlinking ${le} failed.`
          }
        }).then(() => re(le));
      },
      onCancel: () => m("jira:issue:unlink:cancelled", K(le))
    });
  }, we = () => {
    m("jira:issue:unlink-all:clicked", { jiraInstanceUrl: n }), f({
      headline: "Unlink all Jira issues?",
      text: "You are about to unlink the all Jira issues from the conversation. Do you want to proceed?",
      confirmLabel: "Unlink ALL issues",
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        m("jira:issue:unlink-all:confirmed", { jiraInstanceUrl: n }), o?.forEach((le) => le?.key && re(le.key)), I(r, {
          success: {
            title: "Unlinking successful",
            text: "All Jira issues were unlinked"
          },
          error: {
            title: "Unlinking failed",
            text: "Unlinking all issues failed."
          }
        });
      },
      onCancel: () => m("jira:issue:unlink-all:cancelled", { jiraInstanceUrl: n })
    });
  }, me = N?.jira?.issues?.filter(
    (le) => !i?.includes(le)
  ) || [];
  return {
    linkIssue: B,
    linkIssueQuietly: P,
    unlinkIssue: ie,
    loadIssues: Y,
    removeDanglingIssueLinks: () => {
      m("jira:issue:unlink-all-dangling:clicked", {
        jiraInstanceUrl: n
      });
      const le = {
        ...N,
        jira: {
          ...N?.jira,
          issues: N?.jira?.issues.filter(
            (ge) => !me.includes(ge)
          ) || []
        }
      };
      _(le);
    },
    unlinkAllIssues: we,
    maybeExtractIssueKey: (le) => {
      const ge = le.replace(/\s/g, "");
      if (i2.test(ge))
        return ge;
      if (ix.test(le))
        return le.match(ix)?.[1];
      if (le.startsWith(n) && a2.test(le))
        return le.substring(le.lastIndexOf("/") + 1);
    },
    isLoadingIssueLinks: w,
    danglingIssueLinks: me,
    isLoadingIssues: O,
    issues: o,
    error: l
  };
}
function o2(e = !1, n) {
  const [r, i] = pe(e);
  return Qe(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copyToClipboard: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const s2 = "_result_1wiub_54", l2 = "_resultName_1wiub_74", d2 = "_resultNameIcon_1wiub_82", c2 = "_resultDescription_1wiub_87", u2 = "_resultLinkIcon_1wiub_99", m2 = "_tooltip_1wiub_108", p2 = "_tooltipContent_1wiub_114", f2 = "_tooltipName_1wiub_121", h2 = "_tooltipNameIcon_1wiub_126", y2 = "_tooltipDescription_1wiub_131", g2 = "_tooltipSummary_1wiub_139", v2 = "_tooltipTag_1wiub_143", kr = {
  result: s2,
  resultName: l2,
  resultNameIcon: d2,
  resultDescription: c2,
  resultLinkIcon: u2,
  tooltip: m2,
  tooltipContent: p2,
  tooltipName: f2,
  tooltipNameIcon: h2,
  tooltipDescription: y2,
  tooltipSummary: g2,
  tooltipTag: v2
}, k2 = ({
  item: e,
  jiraInstanceUrl: n,
  onSelect: r,
  disableTooltip: i = !1,
  ...a
}) => {
  const { issuetype: o, name: s, status: l, text: c, description: m } = e, [u, f] = pe(!1), h = t1({
    avatarId: o?.avatarId,
    iconUrl: o?.iconUrl,
    jiraInstanceUrl: n
  });
  return /* @__PURE__ */ fe.jsx(
    Xe,
    {
      disabled: i,
      className: kr.tooltip,
      content: /* @__PURE__ */ fe.jsxs("div", { className: kr.tooltipContent, children: [
        /* @__PURE__ */ fe.jsxs(
          b,
          {
            flexDirection: "row",
            justifyContent: "space-between",
            width: "100%",
            children: [
              /* @__PURE__ */ fe.jsxs("span", { className: kr.tooltipName, children: [
                /* @__PURE__ */ fe.jsx(
                  xl,
                  {
                    width: 16,
                    iconUrl: h,
                    className: kr.tooltipNameIcon
                  }
                ),
                " ",
                s
              ] }),
              /* @__PURE__ */ fe.jsx(Jn, { className: kr.tooltipTag, children: l.name })
            ]
          }
        ),
        m && /* @__PURE__ */ fe.jsx("div", { className: kr.tooltipSummary, children: m }),
        c && /* @__PURE__ */ fe.jsx("div", { className: kr.tooltipDescription, children: c })
      ] }),
      side: "left",
      light: !0,
      children: /* @__PURE__ */ fe.jsxs(
        "button",
        {
          ...a,
          className: kr.result,
          type: "button",
          onClick: () => {
            r(e);
          },
          onMouseEnter: () => f(!0),
          onMouseLeave: () => f(!1),
          children: [
            /* @__PURE__ */ fe.jsxs(
              b,
              {
                flexDirection: "column",
                justifyContent: "center",
                style: {
                  width: u ? "calc(100% - 32px)" : "100%"
                },
                children: [
                  /* @__PURE__ */ fe.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ fe.jsxs("span", { className: kr.resultName, children: [
                    /* @__PURE__ */ fe.jsx(
                      xl,
                      {
                        width: 16,
                        iconUrl: h,
                        className: kr.resultNameIcon
                      }
                    ),
                    " ",
                    s
                  ] }) }),
                  m && /* @__PURE__ */ fe.jsx("div", { className: kr.resultDescription, children: m })
                ]
              }
            ),
            u && /* @__PURE__ */ fe.jsx(
              he,
              {
                className: kr.resultLinkIcon,
                name: "plus",
                size: 32
              }
            )
          ]
        }
      )
    }
  );
}, b2 = ({
  className: e,
  searched: n,
  jiraInstanceUrl: r
}) => /* @__PURE__ */ fe.jsx(
  It,
  {
    slotEnd: /* @__PURE__ */ fe.jsx(he, { name: "external-link" }),
    variant: "tertiary",
    style: { width: "100%" },
    className: e,
    navigate: () => {
      window.open(
        `${r}/secure/QuickSearch.jspa?searchString=${n}`,
        "_blank"
      )?.focus();
    },
    children: "View matching issues in Jira"
  }
), _2 = ({
  onSelectIssue: e,
  jiraInstanceUrl: n,
  filterByProjectKey: r,
  disableTooltip: i
}) => {
  const { useLazyQuery: a } = hn(), [o, s] = pe([]), [l, c] = pe(""), [m, { loading: u, error: f, data: h, networkStatus: k }] = a(r1, {
    notifyOnNetworkStatusChange: !0
  }), { maybeExtractIssueKey: w } = i1(null, n);
  bi(
    () => {
      !u && l && k === rr.ready ? m({
        variables: {
          jql: l,
          maxResults: 25
        }
      }) : s([]);
    },
    500,
    [l]
  ), Qe(() => {
    const R = h?.Jira?.searchAndReconsileIssuesUsingJql?.issues || [];
    s(
      R.map((F) => ({
        id: F?.key ?? "",
        name: F?.key ?? "",
        description: F?.fields.summary,
        status: F?.fields.status,
        issuetype: F?.fields.issuetype,
        text: F?.fields.description ? fg(F?.fields.description, n1) : /* @__PURE__ */ fe.jsx(fe.Fragment, {})
      }))
    );
  }, [h]);
  const N = (R) => {
    e(R.id), c("");
  }, j = (R) => {
    const F = R.trim(), I = w(F);
    if (I) {
      const L = I.replaceAll("[-_|]", "\\\\$0");
      c(`key = '${L}'`);
    } else F !== "" && c(
      `text ~ '${F}'${r ? " and project = " + r : ""}`
    );
  }, _ = () => {
    c("");
  }, g = (R) => /* @__PURE__ */ fe.jsx(b2, { ...R, jiraInstanceUrl: n }), O = (R) => /* @__PURE__ */ fe.jsx(
    k2,
    {
      ...R,
      jiraInstanceUrl: n,
      disableTooltip: i
    }
  );
  return !u && f ? /* @__PURE__ */ fe.jsx($n, { error: f }) : /* @__PURE__ */ fe.jsx(
    Tr,
    {
      items: o,
      loading: u,
      onSearch: j,
      onSelect: N,
      onClear: _,
      emptyMessage: l ? u ? "" : "No Jira Issues found" : "Enter Jira issue key, link or search terms",
      suggestionComponent: g,
      itemComponent: O,
      placeholder: "Search and link existing issue",
      searchable: !0,
      clearable: !0
    }
  );
}, x2 = ({
  field: e,
  value: n,
  onChange: r
}) => {
  const [i, a] = pe(n ? [n] : []), o = (s, l) => {
    a(
      l ? [...i, s] : i.filter(({ id: c }) => c !== s.id)
    );
  };
  return Qe(() => {
    r(i);
  }, [i]), /* @__PURE__ */ fe.jsx(
    Tr,
    {
      multiple: !0,
      onChange: o,
      selectedItems: i,
      items: e?.allowedValues?.map(
        ({ id: s, name: l, value: c }) => ({
          id: s,
          name: l || c
        })
      )
    }
  );
}, S2 = "_itemButton_1hl53_1", N2 = "_result_1hl53_6", j2 = "_resultIcon_1hl53_26", w2 = "_resultName_1hl53_30", C2 = "_resultCheckIcon_1hl53_38", eo = {
  itemButton: S2,
  result: N2,
  resultIcon: j2,
  resultName: w2,
  resultCheckIcon: C2
}, ny = ({
  item: e,
  checked: n = !1,
  onSelectItem: r,
  jiraInstanceUrl: i
}) => {
  const a = (s) => {
    const l = s.indexOf("/rest/api/");
    return l >= 0 ? `${i}${s?.substring(l)}` : s;
  };
  let o = e?.iconUrl || e?.avatarUrls?._24x24 || null;
  return o && (o = o?.startsWith("https://api.atlassian.com/ex/") ? a(o) : o), /* @__PURE__ */ fe.jsx(
    b,
    {
      flexDirection: "column",
      justifyContent: "center",
      width: "100%",
      "data-testid": "jira-select-item-component",
      children: /* @__PURE__ */ fe.jsx(
        "button",
        {
          onClick: () => {
            r(e);
          },
          className: eo.itemButton,
          children: /* @__PURE__ */ fe.jsxs(b, { className: eo.result, flexDirection: "row", width: "100%", children: [
            /* @__PURE__ */ fe.jsx(
              xl,
              {
                width: 36,
                iconUrl: o || "",
                className: eo.resultIcon
              }
            ),
            /* @__PURE__ */ fe.jsx(lt, { className: eo.resultName, children: e.name }),
            n && /* @__PURE__ */ fe.jsx(lt, { className: eo.resultCheckIcon, children: /* @__PURE__ */ fe.jsx(he, { name: "done" }) })
          ] })
        }
      )
    }
  );
}, F2 = ({
  selectedItems: e,
  agentEmail: n,
  onSelect: r,
  jiraInstanceUrl: i
}) => {
  const { useLazyQuery: a } = hn(), [o, s] = pe([]), [l, c] = pe(), m = 2, [u, { loading: f, error: h, data: k, networkStatus: w }] = a(r2, {
    notifyOnNetworkStatusChange: !0
  });
  return bi(
    () => {
      !f && l && l.length >= m && w === rr.ready ? u({
        variables: {
          query: l,
          maxResults: 10
        }
      }) : s([]);
    },
    500,
    [l]
  ), Qe(() => {
    n && u({
      variables: {
        query: n,
        maxResults: 1
      }
    }).then((N) => {
      if (N?.data?.Jira.findUsers?.length === 1) {
        const j = N?.data?.Jira?.findUsers[0];
        r(j.accountId), s([
          {
            id: j.accountId,
            name: j.displayName
          }
        ]);
      }
    });
  }, []), Qe(() => {
    const N = k?.Jira?.findUsers || [];
    s(
      N.filter(({ active: j }) => j).map(({ accountId: j, displayName: _, avatarUrls: g, active: O }) => ({
        id: j,
        name: _,
        avatarUrls: g,
        active: O
      }))
    );
  }, [k]), !f && h ? /* @__PURE__ */ fe.jsx($n, { error: h }) : /* @__PURE__ */ fe.jsx(
    Tr,
    {
      clearable: !0,
      searchable: !0,
      items: o,
      loading: f,
      onSearch: (N) => c(N),
      onSelect: r,
      onClear: () => c(void 0),
      selectedItems: e,
      emptyMessage: l ? f ? "" : "No user found" : "Enter keyword to search for user",
      itemComponent: ({ item: N, onSelect: j, checked: _ }) => /* @__PURE__ */ fe.jsx(
        ny,
        {
          item: N,
          checked: _,
          onSelectItem: j,
          jiraInstanceUrl: i
        }
      ),
      placeholder: "Search Jira users"
    }
  );
}, ax = ({
  field: e
}) => {
  const [n, r] = pe(!1), [i, a] = YC();
  return Qe(() => {
    const o = n ? window.setTimeout(() => r(!1), 2e3) : void 0;
    return () => window.clearTimeout(o);
  }, [n]), /* @__PURE__ */ fe.jsxs(b, { alignItems: "center", gap: "400", justifyContent: "space-between", children: [
    /* @__PURE__ */ fe.jsx(b, { children: /* @__PURE__ */ fe.jsx(he, { size: 24, name: "exclamation-triangle-filled", color: "red.500" }) }),
    /* @__PURE__ */ fe.jsx($.Paragraph, { children: "Your organizations Jira configuration is currently not fully supported by Dixa. Please reach out so we can have a look at this field. Please, attach a copy of the field details when contacting us. You can use the copy button to do so." }),
    /* @__PURE__ */ fe.jsx(Xe, { content: n ? "Copied" : "Copy field details", children: /* @__PURE__ */ fe.jsx(
      Qt,
      {
        variant: "secondary",
        icon: n ? "done" : "copy",
        onClick: () => {
          a(JSON.stringify(e, null, 2)), r(!0);
        }
      }
    ) })
  ] });
}, I2 = ({
  field: e,
  onChange: n,
  value: r,
  conversationContext: i,
  jiraInstanceUrl: a
}) => {
  const { type: o, system: s } = e.schema;
  if (["array", "option", "priority"].includes(o) && (!e?.allowedValues || e.allowedValues.length === 0))
    return /* @__PURE__ */ fe.jsx(ax, { field: e });
  switch (o) {
    case "issuelink":
    case "environment":
    case "any":
      return /* @__PURE__ */ fe.jsx(cr, { onChange: n, value: r });
    case "string":
      return s === "description" ? /* @__PURE__ */ fe.jsx(Wh, { onChange: n, value: r }) : /* @__PURE__ */ fe.jsx(cr, { onChange: n, value: r });
    case "textarea":
      return /* @__PURE__ */ fe.jsx(Wh, { onChange: n, value: r });
    case "number":
      return /* @__PURE__ */ fe.jsx(cr, { type: "number", onChange: n, value: r });
    case "user":
      return /* @__PURE__ */ fe.jsx(
        F2,
        {
          onSelect: n,
          selectedItems: r ? [r] : [],
          agentEmail: e.key === "reporter" && i?.agent?.email || void 0,
          jiraInstanceUrl: a
        }
      );
    case "option":
    case "priority":
      return /* @__PURE__ */ fe.jsx(
        Tr,
        {
          onSelect: n,
          selectedItems: r ? [r] : [],
          items: e?.allowedValues?.map(
            ({ id: l, name: c, value: m }) => ({
              id: l,
              name: c || m
            })
          ) || []
        }
      );
    case "array":
      return /* @__PURE__ */ fe.jsx(x2, { field: e, value: r, onChange: n });
    default:
      return /* @__PURE__ */ fe.jsx(ax, { field: e });
  }
}, $2 = ["description", "reporter", "summary"], E2 = ({
  issueTypeFields: e,
  control: n,
  jiraInstanceUrl: r,
  conversationContext: i,
  errors: a
}) => /* @__PURE__ */ fe.jsx(fe.Fragment, { children: e.filter(({ key: o }) => o !== "project" && o !== "issuetype").filter(
  ({ key: o, required: s }) => s || $2.includes(o)
).map((o) => /* @__PURE__ */ fe.jsx(
  Nt,
  {
    control: n,
    render: ({ field: { onChange: s, value: l } }) => /* @__PURE__ */ fe.jsx(
      He,
      {
        meta: {
          error: a && o.key in a ? a[o.key].message : null
        },
        label: o.name,
        required: o.required,
        children: I2({
          field: o,
          onChange: s,
          value: l,
          conversationContext: i,
          jiraInstanceUrl: r
        })
      },
      o.key
    ),
    name: o.key,
    rules: {
      required: o.required ? "This field is required" : !1
    }
  },
  o.key
)) }), T2 = ({
  createdIssue: e,
  issueBaseLink: n,
  issueLinkCopied: r,
  setIssueLinkCopied: i,
  copyToClipboard: a
}) => /* @__PURE__ */ fe.jsxs(
  b,
  {
    flexDirection: "column",
    gap: "400",
    "data-testid": "jira-create-issue-success-message",
    children: [
      /* @__PURE__ */ fe.jsxs($.Paragraph, { children: [
        "You can visit your new issue by following",
        " ",
        /* @__PURE__ */ fe.jsxs(
          $.ExternalLink,
          {
            href: `${n}/${e.key}`,
            target: "_blank",
            children: [
              "this link ",
              /* @__PURE__ */ fe.jsx(he, { name: "external-link" })
            ]
          }
        ),
        " ",
        "or copy it from the field below."
      ] }),
      /* @__PURE__ */ fe.jsx(He, { label: "Jira issue link", children: /* @__PURE__ */ fe.jsx(
        cr,
        {
          readOnly: !0,
          value: `${n}/${e.key}`,
          suffix: {
            type: "button",
            button: {
              icon: r ? "done" : "copy",
              onClick: () => {
                i(!0), a(`${n}/${e.key}`);
              }
            }
          }
        }
      ) })
    ]
  }
), R2 = "_modalBody_1hk1o_1", D2 = "_modalBodyFormFields_1hk1o_4", ox = {
  modalBody: R2,
  modalBodyFormFields: D2
}, O2 = (e) => ({
  version: 1,
  type: "doc",
  content: e?.trim()?.split(`
`).filter((n) => n !== "").map((n) => ({
    type: "paragraph",
    content: [
      {
        type: "text",
        text: n
      }
    ]
  }))
}), P2 = (e) => e?.custom?.split(":")?.[1] || null, A2 = (e, n) => {
  if (e.startsWith("customfield_")) {
    const r = n.find((i) => i.key === e)?.schema;
    if (r)
      return r;
  }
  return null;
}, L2 = (e, n) => {
  const r = ["environment", "textarea", "description"];
  return {
    fields: {
      ...Object.entries(e).reduce((i, [a, o]) => {
        if (!o || o === "")
          return delete e[a], i;
        const s = A2(a, n), l = P2(s) ?? a;
        return r.includes(l) ? i[a] = O2(o) : s?.type === "number" ? i[a] = parseInt(o) : i[a] = o, i;
      }, {}),
      summary: e.summary,
      project: { id: e.project.id },
      issuetype: { id: e.issuetype.id },
      ...e?.parent && { parent: { key: e.parent } },
      ...e?.reporter && {
        reporter: { id: e.reporter?.id ?? e.reporter }
      },
      ...e?.assignee && {
        assignee: { id: e.assignee?.id ?? e.assignee }
      }
    }
  };
}, V2 = ({
  isOpen: e,
  onClose: n,
  linkIssueQuietly: r,
  conversationContext: i,
  jiraInstanceUrl: a,
  hasSortIssueTypeByLabelEnabled: o
}) => {
  const s = { project: void 0, issuetype: void 0 }, [l, c] = pe([]), [m, u] = pe(), [f, h] = pe(0), [k, w] = pe([]), [N, j] = pe([]), [_, g] = pe(!1), [O, R] = pe(!1), [F, I] = pe({}), { track: L } = jn(), { isCopied: W, copyToClipboard: J } = o2(), re = Xn(() => i?.conversationId, [e]), { useMutation: K, useLazyQuery: Y, showNotification: P } = hn(), {
    control: B,
    handleSubmit: ie,
    formState: { errors: we },
    reset: me,
    setValue: le,
    getValues: ge
  } = ut({
    defaultValues: s
  }), V = N.length > 0, be = `${a}/browse`, Oe = Object.keys(F).length > 0, [q, { loading: Ge, error: sn }] = Y(e2, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onCompleted: (de) => {
      c(de.Jira.getAllProjects);
    },
    onError: (de) => {
      P({
        title: "Could not get project list",
        text: "We could not fetch the list of your projects. Please try again later.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), console.warn("Error response when fetching projects", de), c([]);
    }
  }), [
    Ie,
    { loading: Ue, error: De }
  ] = Y(n2, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onCompleted: (de) => {
      h(0);
      const Se = de?.Jira?.getCreateIssueMeta?.projects[0];
      if (Se) {
        const Ve = Se?.issuetypes.filter(
          ({ subtask: Pe }) => !Pe
        );
        w(Ve || []), le(
          "issuetype",
          Ve.length > 0 ? Ve[0] : void 0
        );
      } else
        P({
          title: "Could not get issue-type list",
          text: "It seems that there are no issue-types for this project or you might not have the necessary access rights to view them.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), w([]), j([]);
    },
    onError: (de) => {
      P({
        title: "Could not get issue list",
        text: "We could not fetch the list of issue-types for this project. Please try again later.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), console.warn("Error in getCreateIssueMeta", de), w([]), j([]), h(0);
    }
  }), [Be, { error: Ae }] = K(
    t2,
    {
      onError: () => {
        g(!1), P({
          title: "Creation was not successful",
          text: "Please try again later or contact your admin.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), L("jira:issue:create:failed", { jiraInstanceUrl: a });
      },
      onCompleted: (de) => {
        if (g(!1), de?.Jira && "key" in de.Jira.createIssue)
          u(de?.Jira?.createIssue), P({
            title: "Success",
            text: `Jira issue '${de.Jira.createIssue.key}' created`,
            icon: "check-circle-filled",
            severity: "success"
          }), L("jira:issue:create:succeeded", {
            jiraInstanceUrl: a,
            jiraIssueKey: de.Jira.createIssue.key
          }), re && r(
            de.Jira.createIssue.key,
            re
          );
        else if ("errorMessages" in de.Jira.createIssue || "errors" in de.Jira.createIssue) {
          const Se = de?.Jira?.createIssue?.errors;
          console.warn("There was a problem creating a Jira issue.", Se), P({
            title: "Creation was not successful",
            text: "Something went wrong. Please get in contact with Dixa.",
            icon: "exclamation-triangle-filled",
            severity: "warning"
          });
        }
      }
    }
  ), Je = (de) => {
    g(!0), I({}), Be({
      variables: {
        input: L2(de, N)
      }
    });
  };
  Qe(() => {
    if (e)
      try {
        q();
      } catch (de) {
        console.warn("Error when fetching initial projects", de);
      }
  }, [e]), Qe(() => {
    const de = O ? window.setTimeout(() => R(!1), 2e3) : void 0;
    return () => window.clearTimeout(de);
  }, [O]), Qe(() => {
    if (k?.length > 0) {
      le("issuetype", k[f]);
      const de = k[f]?.fields?.additionalProperties;
      if (de?.length > 0) {
        const Se = de.map(
          ({ value: Q }) => Q
        ), Ve = (o ? Se.sort(({ name: Q }, { name: E }) => Q.localeCompare(E)) : Se).sort(
          ({ required: Q }, { required: E }) => Number(E) - Number(Q)
        ), { project: Pe, issuetype: kn } = ge();
        me({ project: Pe, issuetype: kn }), j(Ve);
      }
    } else
      j([]), le("issuetype", void 0);
  }, [k, le, f]), Qe(() => {
    if (Ae && $w(Ae)) {
      if (Ae?.graphQLErrors?.length > 0) {
        const { graphQLErrors: de } = Ae, Se = de[0].extensions?.integration?.responseBody;
        try {
          const Ve = JSON.parse(Se);
          if (Ve?.errors) {
            const Pe = Object.keys(Ve.errors).reduce(
              (kn, Q) => ({
                ...kn,
                [Q]: {
                  type: "required",
                  message: Ve.errors[Q],
                  ref: {
                    name: Q
                  }
                }
              }),
              {}
            );
            I(Pe);
          }
        } catch {
        }
      }
    } else
      I({});
  }, [Ae]);
  const Ee = () => {
    c([]), j([]), w([]), u(void 0), h(0), g(!1), I({});
  }, Me = () => {
    Ee(), me(s), n();
  }, en = (de) => {
    de && Ie({
      variables: {
        projectKey: de
      }
    });
  }, se = (de) => {
    const Se = k.map((Ve) => Ve.id).indexOf(de);
    h(Se ?? 0);
  };
  return /* @__PURE__ */ fe.jsxs(
    bt,
    {
      isOpen: e,
      "data-testid": "jira-create-issue-modal",
      onClose: Me,
      children: [
        /* @__PURE__ */ fe.jsx(
          _t,
          {
            title: m ? "Issue creation successful" : "Create new Jira issue",
            onClose: Me
          }
        ),
        /* @__PURE__ */ fe.jsxs(xt, { className: ox.modalBody, children: [
          !Ge && sn && /* @__PURE__ */ fe.jsx($n, { error: sn, retry: q }),
          !Ue && De && /* @__PURE__ */ fe.jsx(
            $n,
            {
              error: De,
              retry: Ie
            }
          ),
          !_ && Oe && /* @__PURE__ */ fe.jsx(b, { margin: "0 0 400", children: /* @__PURE__ */ fe.jsx(
            Iy,
            {
              variant: "warning",
              description: /* @__PURE__ */ fe.jsxs(
                b,
                {
                  gap: "300",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  children: [
                    /* @__PURE__ */ fe.jsx($.Paragraph, { variant: "4", children: "The form contains input validation errors. Please correct them and try again to save. If your inputs seem fine, please contact our support team and provide the form schema to debug further." }),
                    /* @__PURE__ */ fe.jsx(
                      tt,
                      {
                        icon: W ? "done" : "copy",
                        variant: "secondary",
                        onClick: () => J(JSON.stringify(N, null, 2)),
                        children: "Copy form schema"
                      }
                    )
                  ]
                }
              )
            }
          ) }),
          m ? /* @__PURE__ */ fe.jsx(
            T2,
            {
              createdIssue: m,
              issueBaseLink: be,
              issueLinkCopied: O,
              setIssueLinkCopied: R,
              copyToClipboard: J
            }
          ) : /* @__PURE__ */ fe.jsx(
            "form",
            {
              "data-testid": "jira-create-issue-form",
              onSubmit: ie(Je),
              children: /* @__PURE__ */ fe.jsxs(et, { children: [
                /* @__PURE__ */ fe.jsx(X, { span: 3, children: /* @__PURE__ */ fe.jsx(He, { label: "Project", required: !0, children: /* @__PURE__ */ fe.jsx(
                  Nt,
                  {
                    control: B,
                    name: "project",
                    rules: { required: "Please select a project" },
                    render: ({ field: { onChange: de, value: Se } }) => /* @__PURE__ */ fe.jsx(
                      Tr,
                      {
                        searchable: !0,
                        loading: Ge,
                        onSelect: (Ve) => {
                          en(Ve.key), de(Ve);
                        },
                        selectedItems: [Se],
                        placeholder: "Select Jira project",
                        emptyMessage: sn ? "No projects found" : "No projects available",
                        items: l || [],
                        itemComponent: ({ item: Ve, onSelect: Pe, checked: kn }) => /* @__PURE__ */ fe.jsx(
                          ny,
                          {
                            item: Ve,
                            checked: kn,
                            onSelectItem: Pe,
                            jiraInstanceUrl: a
                          }
                        )
                      }
                    )
                  }
                ) }) }),
                /* @__PURE__ */ fe.jsx(X, { span: 3, children: /* @__PURE__ */ fe.jsx(He, { label: "Issue type", required: !0, children: /* @__PURE__ */ fe.jsx(
                  Nt,
                  {
                    control: B,
                    name: "issuetype",
                    rules: { required: "Please select an issue type" },
                    render: ({ field: { onChange: de, value: Se } }) => /* @__PURE__ */ fe.jsx(
                      Tr,
                      {
                        disabled: k.length === 0,
                        loading: Ue,
                        onSelect: (Ve) => {
                          se(Ve.id), de(Ve);
                        },
                        selectedItems: [Se],
                        placeholder: k.length > 0 ? "Select Jira issue type" : "",
                        emptyMessage: De ? "No issues found" : "No issues available",
                        items: k,
                        itemComponent: ({ item: Ve, onSelect: Pe, checked: kn }) => /* @__PURE__ */ fe.jsx(
                          ny,
                          {
                            item: Ve,
                            checked: kn,
                            onSelectItem: Pe,
                            jiraInstanceUrl: a
                          }
                        )
                      }
                    )
                  }
                ) }) }),
                V && // Wrapping all dynamic input fields inside one `FormField`
                // which can handle the overflow scrolling in case we get many
                // input fields in the form
                /* @__PURE__ */ fe.jsx(X, { className: ox.modalBodyFormFields, children: /* @__PURE__ */ fe.jsx(
                  E2,
                  {
                    control: B,
                    errors: { ...we, ...F },
                    getValues: ge,
                    conversationContext: i,
                    jiraInstanceUrl: a,
                    issueTypeFields: N
                  }
                ) })
              ] })
            }
          )
        ] }),
        /* @__PURE__ */ fe.jsx(
          wt,
          {
            confirmOnClick: m ? Me : ie(Je),
            confirmProps: {
              disabled: !V,
              isLoading: _,
              loadingIndicator: /* @__PURE__ */ fe.jsx(mn, { size: 16 })
            },
            confirmName: m ? "Close" : "Save",
            cancelOnClick: m ? void 0 : Me
          }
        )
      ]
    }
  );
}, z2 = (e) => {
  if (!e) return "";
  const n = "https://", r = (e.startsWith(n) ? e.slice(n.length) : e).split("/")[0];
  return `${n}${r}`;
}, U2 = (e) => {
  if (!e?.trim())
    return "Please add a value";
  const n = "https://";
  if (e.startsWith(" ") || e.endsWith(" "))
    return "Please remove any empty spaces before or after the URL";
  const r = e.startsWith(n);
  if (r) {
    const i = e.slice(n.length).split("/");
    if (i.length > 1) {
      const a = r ? n.length + i[0].length : i[0].length;
      return i.length === 2 && i[1] === "" ? "Please remove the trailing slash `/`" : `Please remove the trailing path \`${e.slice(a)}\``;
    }
  } else
    return e.includes("://") ? `The protocol \`${e.substring(
      0,
      e.indexOf("://") + 3
    )}\` is not supported` : `Please add \`${n}\` as protocol`;
}, M2 = "_wrapper_1bylq_1", B2 = "_inputWrapper_1bylq_6", q2 = "_inputSeparator_1bylq_18", H2 = "_buttonLink_1bylq_23", W2 = "_noIssuesFound_1bylq_27", no = {
  wrapper: M2,
  inputWrapper: B2,
  inputSeparator: q2,
  buttonLink: H2,
  noIssuesFound: W2
}, K2 = ({
  conversationContext: e,
  settings: n
}) => {
  const { track: r } = jn(), i = z2(n?.jiraSiteUrl), [a, o] = pe(!1), s = !!e?.conversationId, {
    linkIssue: l,
    linkIssueQuietly: c,
    unlinkIssue: m,
    unlinkAllIssues: u,
    loadIssues: f,
    removeDanglingIssueLinks: h,
    danglingIssueLinks: k,
    isLoadingIssueLinks: w,
    isLoadingIssues: N,
    issues: j,
    error: _
  } = i1(
    s ? e.conversationId : null,
    i
  ), g = !!n?.enableCreateIssue, O = !!n?.enableSortIssueTypeByLabel, R = !!(j?.length || k?.length), F = !!n?.enableRemoveAllLinks && R, I = !w && !N && k?.length > 0 && !!n?.showDanglingLinks;
  return !N && _ ? /* @__PURE__ */ fe.jsx($n, { error: _, retry: () => f() }) : /* @__PURE__ */ fe.jsxs(fe.Fragment, { children: [
    /* @__PURE__ */ fe.jsxs(b, { className: no.wrapper, flexDirection: "column", children: [
      /* @__PURE__ */ fe.jsxs(b, { className: no.inputWrapper, flexDirection: "column", children: [
        g && /* @__PURE__ */ fe.jsxs(fe.Fragment, { children: [
          /* @__PURE__ */ fe.jsx(
            tt,
            {
              variant: "primary",
              onClick: () => o(!0),
              style: {
                minHeight: "38px"
              },
              children: "Create new issue"
            }
          ),
          /* @__PURE__ */ fe.jsx("div", { className: no.inputSeparator, children: "or" })
        ] }),
        /* @__PURE__ */ fe.jsx(
          _2,
          {
            onSelectIssue: l,
            jiraInstanceUrl: i
          }
        )
      ] }),
      N ? /* @__PURE__ */ fe.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ fe.jsx(mn, { "data-testid": "jira-widget-issue-spinner" }) }) : j?.length ? /* @__PURE__ */ fe.jsx(
        BA,
        {
          issues: j,
          jiraInstanceUrl: i,
          unlinkIssue: m
        }
      ) : /* @__PURE__ */ fe.jsx($.Paragraph, { align: "center", className: no.noIssuesFound, children: "No linked issues found" }),
      F && j?.length > 0 && /* @__PURE__ */ fe.jsx(
        tt,
        {
          variant: "secondary",
          disabled: !j?.length && !k?.length,
          onClick: u,
          children: "Unlink all issues"
        }
      ),
      I && /* @__PURE__ */ fe.jsxs(
        b,
        {
          background: "neutral.100",
          padding: "300",
          borderRadius: "100",
          flexDirection: "column",
          gap: "200",
          children: [
            /* @__PURE__ */ fe.jsx($.Heading, { variant: "heading-3", children: "Unresolved linked issues" }),
            /* @__PURE__ */ fe.jsx(b, { flexDirection: "row", flexWrap: "wrap", gap: "100", children: k.map((L) => /* @__PURE__ */ fe.jsx(Jn, { onDelete: () => m(L), children: L }, L)) }),
            /* @__PURE__ */ fe.jsx(
              tt,
              {
                variant: "secondary",
                onClick: () => h(),
                icon: "link-slash",
                children: "Remove all unresolved issues"
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ fe.jsx(
        It,
        {
          slotEnd: /* @__PURE__ */ fe.jsx(he, { name: "external-link" }),
          variant: "tertiary",
          className: no.buttonLink,
          navigate: () => {
            r("jira:view:jira:clicked", { jiraInstanceUrl: i }), window.open(i, "_blank")?.focus();
          },
          children: "Open Jira"
        }
      )
    ] }),
    a && /* @__PURE__ */ fe.jsx(
      V2,
      {
        isOpen: a,
        onClose: () => o(!1),
        linkIssueQuietly: c,
        conversationContext: e,
        jiraInstanceUrl: i,
        hasSortIssueTypeByLabelEnabled: O
      }
    )
  ] });
}, Sl = [
  {
    key: "jiraSiteUrl",
    label: "Jira site URL",
    type: "string",
    secret: !1,
    defaultValue: ""
  },
  {
    key: "enableRemoveAllLinks",
    label: 'Enable the "Remove all links" button',
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "showDanglingLinks",
    label: "Show unresolved links to Jira issues",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "enableCreateIssue",
    label: 'Enable the "Create issue" button',
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "enableSortIssueTypeByLabel",
    label: "Enable to sort the issue types by label",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  }
], G2 = (e) => {
  const n = U2(e);
  return typeof n == "string" ? n : !0;
}, to = ir(Sl), ji = "JIRA", Y2 = {
  enabled: !1,
  name: "",
  jiraSiteUrl: "",
  enableRemoveAllLinks: !1,
  showDanglingLinks: !1,
  enableCreateIssue: !0,
  enableSortIssueTypeByLabel: !1
}, J2 = ({
  integrationId: e,
  configuration: n,
  handleRedirect: r,
  showNotification: i,
  automationCouplingState: a,
  renderConditionsEditor: o
}) => {
  const s = !e, l = ut({
    mode: "onChange",
    defaultValues: Y2
  }), {
    create: c,
    update: m,
    remove: u,
    isLoading: f,
    error: h,
    misconfigurationCause: k,
    setMisconfigurationCause: w
  } = mr({
    integrationId: e,
    integrationType: ji,
    handleRedirect: r,
    showNotification: i
  }), {
    isLoading: N,
    error: j,
    isWidgetUnknown: _,
    refetch: g,
    widgetConfiguration: O
  } = pr({
    integrationId: e,
    fieldDefinitions: Sl,
    form: l,
    onMisconfigured: w
  }), { renderConditions: R, setRenderConditions: F, renderConditionsForSubmit: I } = fr({
    integrationId: e,
    widgetConfiguration: O,
    renderConditionsEditor: o
  }), L = (J) => yr(J, {
    fieldDefinitions: Sl,
    isCreationMode: s,
    create: c,
    update: m,
    renderConditions: I
  }), W = l.watch("name");
  return /* @__PURE__ */ fe.jsxs(
    hr,
    {
      form: l,
      integrationId: e,
      onValidSubmit: L,
      error: j ?? h,
      onRetry: j ? g : void 0,
      isLoading: f || N,
      isWidgetUnknown: _,
      children: [
        k && /* @__PURE__ */ fe.jsx(gr, { cause: k }),
        /* @__PURE__ */ fe.jsxs(et, { children: [
          /* @__PURE__ */ fe.jsx(X, { children: /* @__PURE__ */ fe.jsx(He, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ fe.jsx(
            yn,
            {
              name: "enabled",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ fe.jsx(X, { span: 3, children: /* @__PURE__ */ fe.jsx(
            On,
            {
              name: "name",
              label: "Widget name",
              control: l.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ fe.jsx(X, { span: 3 }),
          /* @__PURE__ */ fe.jsx(X, { span: 3, children: /* @__PURE__ */ fe.jsx(
            On,
            {
              name: "jiraSiteUrl",
              label: to.jiraSiteUrl,
              control: l.control,
              rules: {
                validate: (J) => G2(J)
              },
              componentProps: {
                placeholder: 'Insert your Jira site URL, e.g. "https://your-site.atlassian.net/"',
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ fe.jsx(X, { span: 3 }),
          /* @__PURE__ */ fe.jsx(X, { span: 3, children: /* @__PURE__ */ fe.jsx(He, { label: to.enableRemoveAllLinks, children: /* @__PURE__ */ fe.jsx(
            yn,
            {
              name: "enableRemoveAllLinks",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ fe.jsx(X, { span: 3 }),
          /* @__PURE__ */ fe.jsx(X, { span: 3, children: /* @__PURE__ */ fe.jsx(He, { label: to.showDanglingLinks, children: /* @__PURE__ */ fe.jsx(
            yn,
            {
              name: "showDanglingLinks",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ fe.jsx(X, { span: 3 }),
          /* @__PURE__ */ fe.jsx(X, { span: 3, children: /* @__PURE__ */ fe.jsx(He, { label: to.enableCreateIssue, children: /* @__PURE__ */ fe.jsx(
            yn,
            {
              name: "enableCreateIssue",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ fe.jsx(X, { span: 3 }),
          /* @__PURE__ */ fe.jsx(X, { span: 3, children: /* @__PURE__ */ fe.jsx(He, { label: to.enableSortIssueTypeByLabel, children: /* @__PURE__ */ fe.jsx(
            yn,
            {
              name: "enableSortIssueTypeByLabel",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ fe.jsx(X, { span: 3 }),
          !s && e && /* @__PURE__ */ fe.jsx(
            vi,
            {
              configuration: n,
              integrationId: e,
              integrationType: ji,
              label: "Authorize with OAuth"
            }
          ),
          o && R !== null && /* @__PURE__ */ fe.jsx(X, { children: o({
            value: R,
            onChange: F,
            configurationKey: O?.id
          }) })
        ] }),
        /* @__PURE__ */ fe.jsx(
          vr,
          {
            integrationType: ji,
            integrationId: e,
            widgetName: W,
            isCreationMode: s,
            isSubmitting: l.formState.isSubmitting,
            automationCouplingState: a,
            onConfirmDelete: () => u(),
            confirmDeleteVariant: "danger",
            deleteConfirmationBody: /* @__PURE__ */ fe.jsxs(b, { gap: "400", children: [
              /* @__PURE__ */ fe.jsx(
                he,
                {
                  size: 24,
                  name: "exclamation-triangle-filled",
                  color: "red.500"
                }
              ),
              /* @__PURE__ */ fe.jsxs(b, { gap: "200", flexDirection: "column", children: [
                /* @__PURE__ */ fe.jsxs($.Heading, { withMarginBottom: !0, children: [
                  "By deleting the ",
                  ji,
                  " integration, all links between Dixa and ",
                  ji,
                  " are also deleted."
                ] }),
                /* @__PURE__ */ fe.jsxs($.Paragraph, { children: [
                  "All data in ",
                  ji,
                  " stays untouched."
                ] }),
                /* @__PURE__ */ fe.jsxs($.Paragraph, { children: [
                  "Are you sure you want to delete the ",
                  ji,
                  " ",
                  'integration "',
                  W,
                  '"?'
                ] })
              ] })
            ] })
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode('@charset "UTF-8";._notificationText_1polx_1{color:var(--dixa-color-neutral-500)}._message_zrl8q_54{padding:var(--dixa-size-spacer-250);border-radius:var(--dixa-size-border-radius-100);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300)}._message_zrl8q_54:hover,._messageIsOpen_zrl8q_62{border-color:var(--dixa-color-neutral-400)}._messageHeader_zrl8q_65{cursor:pointer}._messageUnattended_zrl8q_68{text-decoration:line-through}._messageLabel_zrl8q_71{color:var(--dixa-typography-color-secondary)}._messageText_zrl8q_74{max-height:150px;overflow:scroll;padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-200);border:1px solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);overflow:auto}._messageText_zrl8q_74::-webkit-scrollbar{width:7px;height:7px}._messageText_zrl8q_74::-webkit-scrollbar-track{background-color:var(--dixa-color-neutral-000)}._messageText_zrl8q_74::-webkit-scrollbar-thumb{background-color:var(--dixa-color-neutral-400);border-radius:4px}._messageText_zrl8q_74::-webkit-scrollbar-thumb:hover{background-color:var(--dixa-color-neutral-500)}._list_ld0hf_1{padding:0}._listItem_ld0hf_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_ld0hf_4:last-child{border-bottom:none}._tagHover_kzbzk_1:hover{cursor:pointer;border-color:var(--dixa-color-neutral-400)}._channelUnsubscribed_kzbzk_6{color:var(--dixa-color-neutral-500)}._subscriptionError_1qhhx_1{color:var(--dixa-typography-color-error);font-size:var(--dixa-typography-size-200)}._settingsWrapper_eleyu_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);margin-bottom:var(--dixa-size-spacer-300)}')), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var bm = { exports: {} }, ro = {}, sx;
function Q2() {
  if (sx) return ro;
  sx = 1;
  var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, c, m) {
    var u, f = {}, h = null, k = null;
    m !== void 0 && (h = "" + m), c.key !== void 0 && (h = "" + c.key), c.ref !== void 0 && (k = c.ref);
    for (u in c) i.call(c, u) && !o.hasOwnProperty(u) && (f[u] = c[u]);
    if (l && l.defaultProps) for (u in c = l.defaultProps, c) f[u] === void 0 && (f[u] = c[u]);
    return { $$typeof: n, type: l, key: h, ref: k, props: f, _owner: a.current };
  }
  return ro.Fragment = r, ro.jsx = s, ro.jsxs = s, ro;
}
var _s = {}, lx;
function X2() {
  return lx || (lx = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), c = /* @__PURE__ */ Symbol.for("react.forward_ref"), m = /* @__PURE__ */ Symbol.for("react.suspense"), u = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), k = /* @__PURE__ */ Symbol.for("react.offscreen"), w = Symbol.iterator, N = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var d = w && t[w] || t[N];
      return typeof d == "function" ? d : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var d = arguments.length, p = new Array(d > 1 ? d - 1 : 0), y = 1; y < d; y++)
          p[y - 1] = arguments[y];
        O("error", t, p);
      }
    }
    function O(t, d, p) {
      {
        var y = _.ReactDebugCurrentFrame, C = y.getStackAddendum();
        C !== "" && (d += "%s", p = p.concat([C]));
        var T = p.map(function(S) {
          return String(S);
        });
        T.unshift("Warning: " + d), Function.prototype.apply.call(console[t], console, T);
      }
    }
    var R = !1, F = !1, I = !1, L = !1, W = !1, J;
    J = /* @__PURE__ */ Symbol.for("react.module.reference");
    function re(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || W || t === a || t === m || t === u || L || t === k || R || F || I || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === J || t.getModuleId !== void 0));
    }
    function K(t, d, p) {
      var y = t.displayName;
      if (y)
        return y;
      var C = d.displayName || d.name || "";
      return C !== "" ? p + "(" + C + ")" : p;
    }
    function Y(t) {
      return t.displayName || "Context";
    }
    function P(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var d = t;
            return Y(d) + ".Consumer";
          case s:
            var p = t;
            return Y(p._context) + ".Provider";
          case c:
            return K(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : P(t.type) || "Memo";
          case h: {
            var C = t, T = C._payload, S = C._init;
            try {
              return P(S(T));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, ie = 0, we, me, le, ge, V, be, Oe;
    function q() {
    }
    q.__reactDisabledLog = !0;
    function Ge() {
      {
        if (ie === 0) {
          we = console.log, me = console.info, le = console.warn, ge = console.error, V = console.group, be = console.groupCollapsed, Oe = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: q,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ie++;
      }
    }
    function sn() {
      {
        if (ie--, ie === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, t, {
              value: we
            }),
            info: B({}, t, {
              value: me
            }),
            warn: B({}, t, {
              value: le
            }),
            error: B({}, t, {
              value: ge
            }),
            group: B({}, t, {
              value: V
            }),
            groupCollapsed: B({}, t, {
              value: be
            }),
            groupEnd: B({}, t, {
              value: Oe
            })
          });
        }
        ie < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ie = _.ReactCurrentDispatcher, Ue;
    function De(t, d, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (C) {
            var y = C.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Ae;
    {
      var Je = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Je();
    }
    function Ee(t, d) {
      if (!t || Be)
        return "";
      {
        var p = Ae.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Be = !0;
      var C = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var T;
      T = Ie.current, Ie.current = null, Ge();
      try {
        if (d) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (ne) {
              y = ne;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (ne) {
              y = ne;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            y = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && y && typeof ne.stack == "string") {
          for (var x = ne.stack.split(`
`), Z = y.stack.split(`
`), A = x.length - 1, M = Z.length - 1; A >= 1 && M >= 0 && x[A] !== Z[M]; )
            M--;
          for (; A >= 1 && M >= 0; A--, M--)
            if (x[A] !== Z[M]) {
              if (A !== 1 || M !== 1)
                do
                  if (A--, M--, M < 0 || x[A] !== Z[M]) {
                    var ue = `
` + x[A].replace(" at new ", " at ");
                    return t.displayName && ue.includes("<anonymous>") && (ue = ue.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, ue), ue;
                  }
                while (A >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Ie.current = T, sn(), Error.prepareStackTrace = C;
      }
      var ze = t ? t.displayName || t.name : "", Te = ze ? De(ze) : "";
      return typeof t == "function" && Ae.set(t, Te), Te;
    }
    function Me(t, d, p) {
      return Ee(t, !1);
    }
    function en(t) {
      var d = t.prototype;
      return !!(d && d.isReactComponent);
    }
    function se(t, d, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ee(t, en(t));
      if (typeof t == "string")
        return De(t);
      switch (t) {
        case m:
          return De("Suspense");
        case u:
          return De("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case c:
            return Me(t.render);
          case f:
            return se(t.type, d, p);
          case h: {
            var y = t, C = y._payload, T = y._init;
            try {
              return se(T(C), d, p);
            } catch {
            }
          }
        }
      return "";
    }
    var de = Object.prototype.hasOwnProperty, Se = {}, Ve = _.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var d = t._owner, p = se(t.type, t._source, d ? d.type : null);
        Ve.setExtraStackFrame(p);
      } else
        Ve.setExtraStackFrame(null);
    }
    function kn(t, d, p, y, C) {
      {
        var T = Function.call.bind(de);
        for (var S in t)
          if (T(t, S)) {
            var x = void 0;
            try {
              if (typeof t[S] != "function") {
                var Z = Error((y || "React class") + ": " + p + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Z.name = "Invariant Violation", Z;
              }
              x = t[S](d, S, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (A) {
              x = A;
            }
            x && !(x instanceof Error) && (Pe(C), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, S, typeof x), Pe(null)), x instanceof Error && !(x.message in Se) && (Se[x.message] = !0, Pe(C), g("Failed %s type: %s", p, x.message), Pe(null));
          }
      }
    }
    var Q = Array.isArray;
    function E(t) {
      return Q(t);
    }
    function z(t) {
      {
        var d = typeof Symbol == "function" && Symbol.toStringTag, p = d && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function ae(t) {
      try {
        return ce(t), !1;
      } catch {
        return !0;
      }
    }
    function ce(t) {
      return "" + t;
    }
    function U(t) {
      if (ae(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", z(t)), ce(t);
    }
    var G = _.ReactCurrentOwner, ve = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, je, Re;
    function rn(t) {
      if (de.call(t, "ref")) {
        var d = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (d && d.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function bn(t) {
      if (de.call(t, "key")) {
        var d = Object.getOwnPropertyDescriptor(t, "key").get;
        if (d && d.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function an(t, d) {
      typeof t.ref == "string" && G.current;
    }
    function fn(t, d) {
      {
        var p = function() {
          je || (je = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", d));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function En(t, d) {
      {
        var p = function() {
          Re || (Re = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", d));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var _n = function(t, d, p, y, C, T, S) {
      var x = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: d,
        ref: p,
        props: S,
        // Record the component responsible for creating this element.
        _owner: T
      };
      return x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(x, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(x, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: C
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    };
    function Fn(t, d, p, y, C) {
      {
        var T, S = {}, x = null, Z = null;
        p !== void 0 && (U(p), x = "" + p), bn(d) && (U(d.key), x = "" + d.key), rn(d) && (Z = d.ref, an(d));
        for (T in d)
          de.call(d, T) && !ve.hasOwnProperty(T) && (S[T] = d[T]);
        if (t && t.defaultProps) {
          var A = t.defaultProps;
          for (T in A)
            S[T] === void 0 && (S[T] = A[T]);
        }
        if (x || Z) {
          var M = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          x && fn(S, M), Z && En(S, M);
        }
        return _n(t, x, Z, C, y, G.current, S);
      }
    }
    var Ze = _.ReactCurrentOwner, gn = _.ReactDebugCurrentFrame;
    function Le(t) {
      if (t) {
        var d = t._owner, p = se(t.type, t._source, d ? d.type : null);
        gn.setExtraStackFrame(p);
      } else
        gn.setExtraStackFrame(null);
    }
    var dn;
    dn = !1;
    function cn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function Nn() {
      {
        if (Ze.current) {
          var t = P(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Bn(t) {
      return "";
    }
    var Sn = {};
    function An(t) {
      {
        var d = Nn();
        if (!d) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (d = `

Check the top-level render call using <` + p + ">.");
        }
        return d;
      }
    }
    function vn(t, d) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = An(d);
        if (Sn[p])
          return;
        Sn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Ze.current && (y = " It was passed a child from " + P(t._owner.type) + "."), Le(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Le(null);
      }
    }
    function xn(t, d) {
      {
        if (typeof t != "object")
          return;
        if (E(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            cn(y) && vn(y, d);
          }
        else if (cn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var C = j(t);
          if (typeof C == "function" && C !== t.entries)
            for (var T = C.call(t), S; !(S = T.next()).done; )
              cn(S.value) && vn(S.value, d);
        }
      }
    }
    function Ln(t) {
      {
        var d = t.type;
        if (d == null || typeof d == "string")
          return;
        var p;
        if (typeof d == "function")
          p = d.propTypes;
        else if (typeof d == "object" && (d.$$typeof === c || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        d.$$typeof === f))
          p = d.propTypes;
        else
          return;
        if (p) {
          var y = P(d);
          kn(p, t.props, "prop", y, t);
        } else if (d.PropTypes !== void 0 && !dn) {
          dn = !0;
          var C = P(d);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", C || "Unknown");
        }
        typeof d.getDefaultProps == "function" && !d.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var d = Object.keys(t.props), p = 0; p < d.length; p++) {
          var y = d[p];
          if (y !== "children" && y !== "key") {
            Le(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Le(null);
            break;
          }
        }
        t.ref !== null && (Le(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Le(null));
      }
    }
    var Cn = {};
    function wn(t, d, p, y, C, T) {
      {
        var S = re(t);
        if (!S) {
          var x = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (x += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Z = Bn();
          Z ? x += Z : x += Nn();
          var A;
          t === null ? A = "null" : E(t) ? A = "array" : t !== void 0 && t.$$typeof === n ? (A = "<" + (P(t.type) || "Unknown") + " />", x = " Did you accidentally export a JSX literal instead of a component?") : A = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", A, x);
        }
        var M = Fn(t, d, p, C, T);
        if (M == null)
          return M;
        if (S) {
          var ue = d.children;
          if (ue !== void 0)
            if (y)
              if (E(ue)) {
                for (var ze = 0; ze < ue.length; ze++)
                  xn(ue[ze], t);
                Object.freeze && Object.freeze(ue);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              xn(ue, t);
        }
        if (de.call(d, "key")) {
          var Te = P(t), ne = Object.keys(d).filter(function(Kn) {
            return Kn !== "key";
          }), un = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Cn[Te + un]) {
            var Rn = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, un, Te, Rn, Te), Cn[Te + un] = !0;
          }
        }
        return t === i ? Vn(M) : Ln(M), M;
      }
    }
    function zn(t, d, p) {
      return wn(t, d, p, !0);
    }
    function qn(t, d, p) {
      return wn(t, d, p, !1);
    }
    var Un = qn, Wn = zn;
    _s.Fragment = i, _s.jsx = Un, _s.jsxs = Wn;
  })()), _s;
}
var dx;
function Z2() {
  return dx || (dx = 1, process.env.NODE_ENV === "production" ? bm.exports = Q2() : bm.exports = X2()), bm.exports;
}
var ke = Z2();
function eL({
  query: e,
  options: n,
  delayMs: r
}) {
  const { useLazyQuery: i } = hn(), [a, o] = pe([]), [s] = i(e, n), [l, c] = pe(
    []
  );
  return Qe(() => () => {
    l.forEach((m) => window.clearTimeout(m));
  }, []), [async (m) => {
    const u = [];
    for (const [f, h] of m.entries()) {
      f !== 0 && await new Promise((w) => {
        const N = setTimeout(w, r);
        c([...l, N]);
      });
      const k = await s({
        variables: h
      });
      u.push(k);
    }
    o(u);
  }, a];
}
var a1 = /* @__PURE__ */ ((e) => (e.List = "list", e))(a1 || {}), ty = /* @__PURE__ */ ((e) => (e.Profile = "profile", e))(ty || {}), ry = /* @__PURE__ */ ((e) => (e.Subscribed = "SUBSCRIBED", e))(ry || {}), iy = /* @__PURE__ */ ((e) => (e.Unsubscribed = "UNSUBSCRIBED", e))(iy || {});
const nL = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, tL = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, rL = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "GetEventResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "timestamp" } }, { kind: "Field", name: { kind: "Name", value: "event_properties" } }] } }] } }] } }] }, iL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getLists" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_lists" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetListListResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "created" } }, { kind: "Field", name: { kind: "Name", value: "updated" } }] } }, { kind: "Field", name: { kind: "Name", value: "links" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "self" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "links" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "self" } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, aL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "subscribeProfileToChannel" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "attributes" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_attributes_Input" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "relationships" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_relationships_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "bulk_subscribe_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "data" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "profile_subscription_bulk_create_job" } }, { kind: "ObjectField", name: { kind: "Name", value: "attributes" }, value: { kind: "Variable", name: { kind: "Name", value: "attributes" } } }, { kind: "ObjectField", name: { kind: "Name", value: "relationships" }, value: { kind: "Variable", name: { kind: "Name", value: "relationships" } } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, oL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "unsubscribeProfileByContact" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "attributes" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_mutationInput_bulk_unsubscribe_profiles_input_data_attributes_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "bulk_unsubscribe_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "data" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "profile_subscription_bulk_delete_job" } }, { kind: "ObjectField", name: { kind: "Name", value: "attributes" }, value: { kind: "Variable", name: { kind: "Name", value: "attributes" } } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, sL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getEvents" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "receivedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "openedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "clickedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "bouncedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "receivedSmsEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "pageSize" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_PositiveInt" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", alias: { kind: "Name", value: "receivedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "receivedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "openedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "openedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "clickedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "clickedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "bouncedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "bouncedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "receivedSms" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "receivedSmsEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "GetEventResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "timestamp" } }, { kind: "Field", name: { kind: "Name", value: "event_properties" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, lL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getFlowMessage" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "messageId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_flow_message" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "messageId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetFlowMessageEncodedResponseCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "definition" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_FlowEmail" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "preview_text" } }] } }] } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, dL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getMetrics" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_metrics" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetMetricResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, cL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getProfileByFilter" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "emailFilter" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "phoneNumberFilter" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "hasEmail" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "hasPhoneNumber" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", alias: { kind: "Name", value: "profileByEmail" }, name: { kind: "Name", value: "get_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "emailFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "IntValue", value: "1" } }], directives: [{ kind: "Directive", name: { kind: "Name", value: "include" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "if" }, value: { kind: "Variable", name: { kind: "Name", value: "hasEmail" } } }] }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetProfileResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "profileByPhoneNumber" }, name: { kind: "Name", value: "get_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "phoneNumberFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "IntValue", value: "1" } }], directives: [{ kind: "Directive", name: { kind: "Name", value: "include" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "if" }, value: { kind: "Variable", name: { kind: "Name", value: "hasPhoneNumber" } } }] }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetProfileResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, uL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getProfileById" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "profileId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_profile" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "profileId" } } }, { kind: "Argument", name: { kind: "Name", value: "fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_" }, value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "subscriptions" }, { kind: "EnumValue", value: "properties" }, { kind: "EnumValue", value: "predictive_analytics" }] } }, { kind: "Argument", name: { kind: "Name", value: "additional_fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_" }, value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "subscriptions" }, { kind: "EnumValue", value: "predictive_analytics" }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetProfileResponseCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "email" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "marketing" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "consent" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "sms" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "marketing" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "consent" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "properties" } }, { kind: "Field", name: { kind: "Name", value: "predictive_analytics" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "average_order_value" } }, { kind: "Field", name: { kind: "Name", value: "churn_probability" } }, { kind: "Field", name: { kind: "Name", value: "predicted_clv" } }, { kind: "Field", name: { kind: "Name", value: "historic_clv" } }, { kind: "Field", name: { kind: "Name", value: "total_clv" } }, { kind: "Field", name: { kind: "Name", value: "historic_number_of_orders" } }, { kind: "Field", name: { kind: "Name", value: "predicted_number_of_orders" } }, { kind: "Field", name: { kind: "Name", value: "average_days_between_orders" } }, { kind: "Field", name: { kind: "Name", value: "expected_date_of_next_order" } }, { kind: "Field", name: { kind: "Name", value: "ranked_channel_affinity" } }] } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, mL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getListsByProfileId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "profileId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_lists_for_profile" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "profileId" } } }, { kind: "Argument", name: { kind: "Name", value: "fields_LEFT_SQUARE_BRACE_list_RIGHT_SQUARE_BRACE_" }, value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "name" }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetListResponseCollection" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, pL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getSegmentsByProfileId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "profileId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_segments_for_profile" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "profileId" } } }, { kind: "Argument", name: { kind: "Name", value: "fields_LEFT_SQUARE_BRACE_segment_RIGHT_SQUARE_BRACE_" }, value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "name" }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetSegmentResponseCollection" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, fL = {
  "\n  query getLists {\n    Klaviyo {\n      get_lists {\n        ... on Klaviyo_GetListListResponseCollectionCompoundDocument {\n          data {\n            type\n            id\n            attributes {\n              name\n              created\n              updated\n            }\n            links {\n              self\n            }\n          }\n          links {\n            self\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": iL,
  "\n  fragment ClientErrorResponseFragment on Klaviyo_ClientError_response {\n    errors {\n      id\n      code\n      title\n      detail\n      source {\n        pointer\n        parameter\n      }\n    }\n  }\n": nL,
  "\n  fragment ServerErrorResponseFragment on Klaviyo_ServerError_response {\n    errors {\n      id\n      code\n      title\n      detail\n      source {\n        pointer\n        parameter\n      }\n    }\n  }\n": tL,
  "\n  mutation subscribeProfileToChannel(\n    $attributes: Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_attributes_Input!\n    $relationships: Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_relationships_Input!\n  ) {\n    Klaviyo {\n      bulk_subscribe_profiles(\n        input: {\n          data: {\n            type: profile_subscription_bulk_create_job\n            attributes: $attributes\n            relationships: $relationships\n          }\n        }\n      ) {\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": aL,
  "\n  mutation unsubscribeProfileByContact(\n    $attributes: Klaviyo_mutationInput_bulk_unsubscribe_profiles_input_data_attributes_Input!\n  ) {\n    Klaviyo {\n      bulk_unsubscribe_profiles(\n        input: {\n          data: {\n            type: profile_subscription_bulk_delete_job\n            attributes: $attributes\n          }\n        }\n      ) {\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": oL,
  "\n  fragment GetEventResponseFragment on Klaviyo_GetEventResponseCollectionCompoundDocument {\n    data {\n      id\n      type\n      attributes {\n        timestamp\n        event_properties\n      }\n    }\n  }\n": rL,
  "\n  query getEvents(\n    $receivedEmailEventsFilter: String!\n    $openedEmailEventsFilter: String!\n    $clickedEmailEventsFilter: String!\n    $bouncedEmailEventsFilter: String!\n    $receivedSmsEventsFilter: String!\n    $pageSize: Klaviyo_PositiveInt!\n  ) {\n    Klaviyo {\n      receivedEmail: get_events(\n        filter: $receivedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      openedEmail: get_events(\n        filter: $openedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      clickedEmail: get_events(\n        filter: $clickedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      bouncedEmail: get_events(\n        filter: $bouncedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      receivedSms: get_events(\n        filter: $receivedSmsEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": sL,
  "\n  query getFlowMessage($messageId: String!) {\n    Klaviyo {\n      get_flow_message(id: $messageId) {\n        ... on Klaviyo_GetFlowMessageEncodedResponseCompoundDocument {\n          data {\n            id\n            type\n            attributes {\n              definition {\n                ... on Klaviyo_FlowEmail {\n                  preview_text\n                }\n              }\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": lL,
  "\n  query getMetrics {\n    Klaviyo {\n      get_metrics {\n        ... on Klaviyo_GetMetricResponseCollectionCompoundDocument {\n          data {\n            id\n            attributes {\n              name\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": dL,
  "\n  query getProfileByFilter(\n    $emailFilter: String\n    $phoneNumberFilter: String\n    $hasEmail: Boolean!\n    $hasPhoneNumber: Boolean!\n  ) {\n    Klaviyo {\n      profileByEmail: get_profiles(\n        filter: $emailFilter\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1\n      ) @include(if: $hasEmail) {\n        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {\n          data {\n            id\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      profileByPhoneNumber: get_profiles(\n        filter: $phoneNumberFilter\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1\n      ) @include(if: $hasPhoneNumber) {\n        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {\n          data {\n            id\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": cL,
  "\n  query getProfileById($profileId: String!) {\n    Klaviyo {\n      get_profile(\n        id: $profileId\n        fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: [\n          subscriptions\n          properties\n          predictive_analytics\n        ]\n        additional_fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: [\n          subscriptions\n          predictive_analytics\n        ]\n      ) {\n        ... on Klaviyo_GetProfileResponseCompoundDocument {\n          data {\n            attributes {\n              subscriptions {\n                email {\n                  marketing {\n                    consent\n                  }\n                }\n                sms {\n                  marketing {\n                    consent\n                  }\n                }\n              }\n              properties\n              predictive_analytics {\n                average_order_value\n                churn_probability\n                predicted_clv\n                historic_clv\n                total_clv\n                historic_number_of_orders\n                predicted_number_of_orders\n                average_days_between_orders\n                expected_date_of_next_order\n                ranked_channel_affinity\n              }\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": uL,
  "\n  query getListsByProfileId($profileId: String!) {\n    Klaviyo {\n      get_lists_for_profile(\n        id: $profileId\n        fields_LEFT_SQUARE_BRACE_list_RIGHT_SQUARE_BRACE_: [name]\n      ) {\n        ... on Klaviyo_GetListResponseCollection {\n          data {\n            id\n            attributes {\n              name\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": mL,
  "\n  query getSegmentsByProfileId($profileId: String!) {\n    Klaviyo {\n      get_segments_for_profile(\n        id: $profileId\n        fields_LEFT_SQUARE_BRACE_segment_RIGHT_SQUARE_BRACE_: [name]\n      ) {\n        ... on Klaviyo_GetSegmentResponseCollection {\n          data {\n            id\n            attributes {\n              name\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": pL
};
function Yr(e) {
  return fL[e] ?? {};
}
const hL = Yr(
  /* GraphQL */
  `
  query getEvents(
    $receivedEmailEventsFilter: String!
    $openedEmailEventsFilter: String!
    $clickedEmailEventsFilter: String!
    $bouncedEmailEventsFilter: String!
    $receivedSmsEventsFilter: String!
    $pageSize: Klaviyo_PositiveInt!
  ) {
    Klaviyo {
      receivedEmail: get_events(
        filter: $receivedEmailEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      openedEmail: get_events(
        filter: $openedEmailEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      clickedEmail: get_events(
        filter: $clickedEmailEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      bouncedEmail: get_events(
        filter: $bouncedEmailEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      receivedSms: get_events(
        filter: $receivedSmsEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), yL = Yr(
  /* GraphQL */
  `
  query getFlowMessage($messageId: String!) {
    Klaviyo {
      get_flow_message(id: $messageId) {
        ... on Klaviyo_GetFlowMessageEncodedResponseCompoundDocument {
          data {
            id
            type
            attributes {
              definition {
                ... on Klaviyo_FlowEmail {
                  preview_text
                }
              }
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), gL = Yr(
  /* GraphQL */
  `
  query getMetrics {
    Klaviyo {
      get_metrics {
        ... on Klaviyo_GetMetricResponseCollectionCompoundDocument {
          data {
            id
            attributes {
              name
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), vL = Yr(
  /* GraphQL */
  `
  query getProfileByFilter(
    $emailFilter: String
    $phoneNumberFilter: String
    $hasEmail: Boolean!
    $hasPhoneNumber: Boolean!
  ) {
    Klaviyo {
      profileByEmail: get_profiles(
        filter: $emailFilter
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1
      ) @include(if: $hasEmail) {
        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {
          data {
            id
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      profileByPhoneNumber: get_profiles(
        filter: $phoneNumberFilter
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1
      ) @include(if: $hasPhoneNumber) {
        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {
          data {
            id
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), kL = Yr(
  /* GraphQL */
  `
  query getProfileById($profileId: String!) {
    Klaviyo {
      get_profile(
        id: $profileId
        fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: [
          subscriptions
          properties
          predictive_analytics
        ]
        additional_fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: [
          subscriptions
          predictive_analytics
        ]
      ) {
        ... on Klaviyo_GetProfileResponseCompoundDocument {
          data {
            attributes {
              subscriptions {
                email {
                  marketing {
                    consent
                  }
                }
                sms {
                  marketing {
                    consent
                  }
                }
              }
              properties
              predictive_analytics {
                average_order_value
                churn_probability
                predicted_clv
                historic_clv
                total_clv
                historic_number_of_orders
                predicted_number_of_orders
                average_days_between_orders
                expected_date_of_next_order
                ranked_channel_affinity
              }
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), bL = Yr(
  /* GraphQL */
  `
  query getListsByProfileId($profileId: String!) {
    Klaviyo {
      get_lists_for_profile(
        id: $profileId
        fields_LEFT_SQUARE_BRACE_list_RIGHT_SQUARE_BRACE_: [name]
      ) {
        ... on Klaviyo_GetListResponseCollection {
          data {
            id
            attributes {
              name
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), _L = Yr(
  /* GraphQL */
  `
  query getSegmentsByProfileId($profileId: String!) {
    Klaviyo {
      get_segments_for_profile(
        id: $profileId
        fields_LEFT_SQUARE_BRACE_segment_RIGHT_SQUARE_BRACE_: [name]
      ) {
        ... on Klaviyo_GetSegmentResponseCollection {
          data {
            id
            attributes {
              name
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), xL = Yr(
  /* GraphQL */
  `
  mutation subscribeProfileToChannel(
    $attributes: Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_attributes_Input!
    $relationships: Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_relationships_Input!
  ) {
    Klaviyo {
      bulk_subscribe_profiles(
        input: {
          data: {
            type: profile_subscription_bulk_create_job
            attributes: $attributes
            relationships: $relationships
          }
        }
      ) {
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), SL = Yr(
  /* GraphQL */
  `
  mutation unsubscribeProfileByContact(
    $attributes: Klaviyo_mutationInput_bulk_unsubscribe_profiles_input_data_attributes_Input!
  ) {
    Klaviyo {
      bulk_unsubscribe_profiles(
        input: {
          data: {
            type: profile_subscription_bulk_delete_job
            attributes: $attributes
          }
        }
      ) {
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
);
function ay(e) {
  return e?.attributes?.event_properties?.$flow !== void 0;
}
function cx(e) {
  return ay(e) && e?.attributes?.event_properties?.$message;
}
function NL(e) {
  return e?.attributes?.event_properties?.["Bounce Type"] !== void 0;
}
function ux(e) {
  const n = e?.attributes?.timestamp;
  if (n)
    return n;
}
function jL(e) {
  return e.Klaviyo?.get_metrics?.__typename === "Klaviyo_GetMetricResponseCollectionCompoundDocument" && e.Klaviyo.get_metrics.data || [];
}
function wL(e) {
  return (e?.Klaviyo?.receivedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.receivedEmail.data || [])?.map((n) => ({
    ...n,
    eventType: "EMAIL"
  }));
}
function CL(e) {
  return (e?.Klaviyo?.receivedSms?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.receivedSms.data || [])?.map((n) => ({
    ...n,
    eventType: "SMS"
  }));
}
function FL(e) {
  return (e?.Klaviyo?.openedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.openedEmail.data || [])?.map((n) => ({
    ...n,
    eventType: "EMAIL"
  }));
}
function IL(e) {
  return (e?.Klaviyo?.clickedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.clickedEmail.data || [])?.map((n) => ({
    ...n,
    eventType: "EMAIL"
  }));
}
function $L(e) {
  return (e?.Klaviyo?.bouncedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.bouncedEmail.data || [])?.map((n) => ({
    ...n,
    eventType: "EMAIL"
  }));
}
function mx(e) {
  return e?.Klaviyo?.get_flow_message?.__typename === "Klaviyo_GetFlowMessageEncodedResponseCompoundDocument" && e.Klaviyo.get_flow_message.data || void 0;
}
function EL(e) {
  return e?.attributes?.definition?.__typename === "Klaviyo_FlowEmail" && e.attributes.definition.preview_text || void 0;
}
function TL(e) {
  try {
    return JSON.parse(JSON.stringify(e));
  } catch {
    return console.error(`Could not make a copy of ${JSON.stringify(e)}`), {};
  }
}
const RL = (e) => e.charAt(0).toUpperCase() + e.slice(1).toLowerCase();
function DL(e) {
  return e?.data?.attributes?.subscriptions?.email?.marketing?.consent === "SUBSCRIBED";
}
function OL(e) {
  return e?.data?.attributes?.subscriptions?.sms?.marketing?.consent === "SUBSCRIBED";
}
function PL({
  profileId: e,
  noOfMessagesToShow: n
}) {
  const { useLazyQuery: r, useQuery: i } = hn(), { track: a } = jn(), [o, s] = pe(null), [l, c] = pe(
    null
  ), [m, u] = pe(null), [f, h] = pe(null), [k, w] = pe(
    null
  ), [N, j] = pe([]), {
    data: _,
    error: g,
    loading: O,
    networkStatus: R
  } = i(gL, {
    /*
    	Since metrics should rarely be changed, query once when the client initializes
    	and then read from the cache for the subsequent queries.
    */
    fetchPolicy: "network-only",
    // Used for first execution
    nextFetchPolicy: "cache-first",
    // Used for subsequent executions
    notifyOnNetworkStatusChange: !0
  }), [
    F,
    {
      data: I,
      error: L,
      loading: W,
      networkStatus: J
    }
  ] = r(hL, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0
  });
  return Qe(() => {
    if (_ && !O && R === rr.ready) {
      const re = jL(_);
      s(
        re.find((K) => K?.attributes?.name === "Received Email")?.id || null
      ), c(
        re.find((K) => K?.attributes?.name === "Opened Email")?.id || null
      ), u(
        re.find((K) => K?.attributes?.name === "Clicked Email")?.id || null
      ), h(
        re.find((K) => K?.attributes?.name === "Bounced Email")?.id || null
      ), w(
        re.find((K) => K?.attributes?.name === "Received SMS")?.id || null
      );
    } else
      s(null), c(null), u(null), h(null), w(null);
  }, [_]), Qe(() => {
    o && l && m && f && k && !W && J === rr.ready ? F({
      variables: {
        receivedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${o}")`,
        openedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${l}")`,
        clickedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${m}")`,
        bouncedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${f}")`,
        receivedSmsEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${k}")`,
        pageSize: n
      }
    }) : j([]);
  }, [
    o,
    l,
    m,
    f,
    k
  ]), Qe(() => {
    if (!W && I) {
      const re = wL(I), K = FL(
        I
      ).map(
        (me) => me?.attributes?.event_properties.$message
      ), Y = IL(
        I
      ).map(
        (me) => me?.attributes?.event_properties.$message
      );
      re.forEach((me) => {
        const le = me.attributes?.event_properties.$message;
        me.opened = K.includes(le), me.clicked = Y.includes(le);
      });
      const P = CL(I), B = $L(I), ie = [
        ...re,
        ...B,
        ...P
      ].sort((me, le) => {
        const ge = ux(me), V = ux(le);
        return ge == null && V == null ? 0 : ge == null ? 1 : V == null ? -1 : V - ge;
      }).slice(0, n);
      j(ie);
      const we = ie.map((me) => me.id);
      a("klaviyo:messages:received", {
        emailsReceived: re.filter(
          (me) => we.includes(me.id)
        ).length,
        emailsBounced: B.filter(
          (me) => we.includes(me.id)
        ).length,
        smsReceived: P.filter(
          (me) => we.includes(me.id)
        ).length,
        total: we.length
      });
    } else
      j([]);
  }, [W, I]), Xn(
    () => ({
      receivedMessages: N,
      isLoading: O || W,
      error: g || L
    }),
    [
      N,
      O,
      W,
      g,
      L
    ]
  );
}
function AL({ profileId: e }) {
  const { useQuery: n } = hn(), [r, i] = pe(), [a, o] = pe(), {
    data: s,
    error: l,
    loading: c,
    refetch: m
  } = n(kL, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    variables: {
      profileId: e
    }
  });
  Qe(() => {
    l && o(l);
  }, [l]), Qe(() => {
    !c && s && i(s.Klaviyo.get_profile);
  }, [c, s]);
  const u = async () => {
    const f = await m();
    f.error ? o(f.error) : f.data && i(
      f.data.Klaviyo.get_profile
    );
  };
  return Xn(
    () => ({
      profile: r,
      refetchProfile: u,
      isLoading: c,
      error: a
    }),
    // No need to add `refetchProfile` as a dependency here
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [r, c, a]
  );
}
function LL({
  email: e,
  phoneNumber: n
}) {
  const { track: r } = jn(), { useLazyQuery: i } = hn(), [a, o] = pe(), [s, l] = pe(), [
    c,
    { data: m, error: u, loading: f }
  ] = i(vL, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0
  });
  Qe(() => {
    if (!f && m) {
      const k = m.Klaviyo?.profileByEmail?.__typename === "Klaviyo_GetProfileResponseCollectionCompoundDocument" && m.Klaviyo.profileByEmail || void 0, w = m.Klaviyo?.profileByPhoneNumber?.__typename === "Klaviyo_GetProfileResponseCollectionCompoundDocument" && m.Klaviyo.profileByPhoneNumber || void 0;
      h(k, w);
    }
  }, [f, m]);
  const h = (k, w) => {
    const N = k?.data?.length === 1 && k.data[0]?.id || void 0, j = w?.data?.length === 1 && w.data[0]?.id || void 0, _ = N || j, g = !N || !j || N === j;
    if (_ && g) {
      o(N || j), r("klaviyo:profile:received", { hasProfile: !0 });
      return;
    }
    o(void 0), r("klaviyo:profile:received", { hasProfile: !1 }), g || l(
      new Error(
        `Two different profiles were retrieved from Klaviyo for the email ${e} (profile ID ${N}) and phone number ${n} (profile ID ${j}).`
      )
    );
  };
  return Xn(
    () => ({
      profileId: a,
      getProfileId: c,
      isLoading: f,
      error: u || s
    }),
    [a, c, f, u, s]
  );
}
const px = 800, VL = {
  min: 800,
  // 0.8 seconds
  max: 1200
  // 1.2 seconds
}, zL = 3, UL = 1.5, ML = ({
  query: e,
  delay: n,
  delayRange: r,
  maxCount: i = zL,
  useDelayRange: a = !1
}) => {
  const o = (L) => Math.floor(Math.random() * (L.max - L.min) + L.min), [s, l] = pe(0), [c, m] = pe(n || px), [u, f] = pe(r || VL), [h, k] = pe(!1), [w, N] = pe(!1), j = a || !!r, _ = j ? o(u) : n || px, [g, O] = pe(_);
  DO(
    async () => {
      const L = s + 1, W = UL ** L;
      l(L), O(
        (j ? o(u) : c) * W
      ), await e().then(() => {
        N(!0), I();
      });
    },
    h ? g : null
  ), PO(() => I());
  const R = ft(() => {
    l(0), O(_);
  }, [_]), F = ft(
    (L = {}) => {
      const { delay: W, delayRange: J } = L;
      N(!1), R(), J && (f(J), O(o(J))), W && (m(W), O(W)), k(!0);
    },
    [R]
  ), I = ft(() => {
    k(!1), R();
  }, [R]);
  return Qe(() => {
    s >= i && I();
  }, [s, i, I]), Xn(
    () => ({ isRunning: h, isSuccessful: w, start: F, stop: I }),
    [h, w, F, I]
  );
}, BL = (e) => {
  const n = e.graphQLErrors[0]?.extensions.integration?.responseHeaders?.["retry-after"];
  return n ? parseInt(n, 10) : void 0;
}, qL = (e) => ({
  min: e * 1e3,
  max: e * 1e3 + 500
});
function HL({
  profileId: e,
  query: n
}) {
  const { useQuery: r } = hn(), [i, a] = pe(), [o, s] = pe(), {
    data: l,
    error: c,
    loading: m,
    refetch: u,
    networkStatus: f
  } = r(
    n === "lists" ? bL : _L,
    {
      fetchPolicy: "no-cache",
      notifyOnNetworkStatusChange: !0,
      variables: {
        profileId: e
      }
    }
  ), {
    isRunning: h,
    start: k,
    stop: w
  } = ML({
    query: u,
    useDelayRange: !0
  }), N = m || h;
  return Qe(() => {
    if (c)
      if (kI({
        errors: c.graphQLErrors
      })) {
        if (!h) {
          const j = BL(c);
          k({
            ...j && {
              delayRange: qL(j)
            }
          });
        }
      } else
        s(c);
  }, [c]), Qe(() => {
    if (!m && l?.Klaviyo) {
      let j = {}, _ = {};
      n === "lists" && (j = l?.Klaviyo?.get_lists_for_profile), n === "segments" && (_ = l?.Klaviyo?.get_segments_for_profile), (j?.data || _?.data) && (w(), a(
        (n === "lists" ? j?.data : _?.data)?.map((g) => ({
          ...g,
          type: n === "lists" ? "list" : "segment"
        }))
      ));
    }
  }, [m, l]), Xn(
    () => ({
      listsOrSegments: i,
      refetchListOrSegments: k,
      isLoading: N,
      error: o,
      networkStatus: f
    }),
    [i, N, o, f, k]
  );
}
const WL = "_notificationText_1polx_1", yg = {
  notificationText: WL
}, id = ({ error: e }) => {
  const { track: n } = jn();
  let r = e;
  if ($w(e)) {
    const i = e.graphQLErrors, a = i.length === 1 && _w({ error: i[0] }), o = i.length === 1 && gI({ error: i[0] });
    if (a)
      n("klaviyo:profile:failed", { reason: "Invalid access token" }), r = new Error(
        "It was not possible to retrieve data from Klaviyo due to an access issue. Please contact your administrator."
      );
    else if (o)
      n("klaviyo:profile:failed", { reason: "Insufficient permissions" }), r = new Error(
        "You don't have enough permissions to see Klaviyo profile data for this conversation. This is typically due to a misconfiguration of the Klaviyo integration."
      );
    else
      return n("klaviyo:profile:failed", { reason: "Unexpected error" }), /* @__PURE__ */ ke.jsx($n, { error: e });
  }
  return /* @__PURE__ */ ke.jsx(b, { margin: "0 0 300", children: /* @__PURE__ */ ke.jsx(
    Ye.Item,
    {
      contentLeft: /* @__PURE__ */ ke.jsx(he, { color: "red.500", size: 20, name: "exclamation-triangle-filled" }),
      titleSecondary: r.message,
      title: "Unable to show Klaviyo profile data",
      variant: "dense"
    }
  ) });
}, KL = "_message_zrl8q_54", GL = "_messageIsOpen_zrl8q_62", YL = "_messageHeader_zrl8q_65", JL = "_messageLabel_zrl8q_71", QL = "_messageText_zrl8q_74", ya = {
  message: KL,
  messageIsOpen: GL,
  messageHeader: YL,
  messageLabel: JL,
  messageText: QL
}, XL = ({ event: e, isLoadingPreview: n }) => {
  const r = e?.attributes?.event_properties, i = e.flowMessage && EL(e.flowMessage);
  return /* @__PURE__ */ ke.jsxs(ke.Fragment, { children: [
    /* @__PURE__ */ ke.jsxs(b, { flexDirection: "column", justifyContent: "space-between", gap: "100", children: [
      /* @__PURE__ */ ke.jsx($.Paragraph, { variant: "4", className: ya.messageLabel, children: "Campaign name" }),
      /* @__PURE__ */ ke.jsx($.Paragraph, { children: r["Campaign Name"] })
    ] }),
    n ? /* @__PURE__ */ ke.jsx(b, { justifyContent: "center", margin: "100", children: /* @__PURE__ */ ke.jsx(mn, { size: 22 }) }) : i && i.length > 0 && /* @__PURE__ */ ke.jsxs(
      b,
      {
        flexDirection: "column",
        justifyContent: "space-between",
        gap: "100",
        children: [
          /* @__PURE__ */ ke.jsx(b, { children: /* @__PURE__ */ ke.jsx(
            $.Paragraph,
            {
              variant: "4",
              className: ya.messageLabel,
              children: "Preview text"
            }
          ) }),
          /* @__PURE__ */ ke.jsx($.Paragraph, { variant: "4", className: ya.messageText, children: i })
        ]
      }
    )
  ] });
}, ZL = ({ event: e }) => {
  const n = e?.attributes?.event_properties;
  return /* @__PURE__ */ ke.jsx(ke.Fragment, { children: /* @__PURE__ */ ke.jsxs(b, { flexDirection: "column", justifyContent: "space-between", gap: "100", children: [
    /* @__PURE__ */ ke.jsx(b, { children: /* @__PURE__ */ ke.jsx($.Heading, { variant: "heading-4", children: "Message" }) }),
    /* @__PURE__ */ ke.jsx(b, { children: n?.extra?.["Message Body"] })
  ] }) });
}, eV = ({
  event: e,
  isLoadingPreview: n,
  openByDefault: r
}) => {
  const [i, a] = pe(r), { attributes: o, eventType: s } = e, l = o?.datetime, c = o?.timestamp, m = "DD MMM YYYY @ HH:mm", u = Xn(
    () => () => l ? Gn(l).format(m) : c ? Gn.unix(c).format(m) : null,
    [c, l]
  )(), f = s === "EMAIL", h = s === "SMS", k = f && e.opened, w = f && e.clicked, N = f && o?.event_properties.Subject, j = h && o?.event_properties["Message Name"], _ = f ? "mail" : "sms";
  return /* @__PURE__ */ ke.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      className: ct(ya.message, {
        [ya.messageIsOpen]: i
      }),
      children: [
        /* @__PURE__ */ ke.jsxs(
          b,
          {
            alignItems: "center",
            justifyContent: "space-between",
            className: ya.messageHeader,
            onClick: () => a(!i),
            children: [
              /* @__PURE__ */ ke.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ ke.jsxs(b, { gap: "200", alignItems: "center", children: [
                  /* @__PURE__ */ ke.jsx(he, { size: 16, name: _ }),
                  " ",
                  RL(s),
                  u && /* @__PURE__ */ ke.jsx(Pn, { size: "small", variant: "info", children: u })
                ] }),
                N && N,
                j && j
              ] }),
              /* @__PURE__ */ ke.jsx(
                Qt,
                {
                  variant: "tertiary",
                  icon: i ? "angle-up" : "angle-down"
                }
              )
            ]
          }
        ),
        i && /* @__PURE__ */ ke.jsxs(b, { flexDirection: "column", gap: "300", children: [
          /* @__PURE__ */ ke.jsx(Wl, {}),
          NL(e) && /* @__PURE__ */ ke.jsx(b, { children: /* @__PURE__ */ ke.jsx(Pn, { size: "medium", variant: "error", children: "Bounced" }) }),
          f && /* @__PURE__ */ ke.jsxs(ke.Fragment, { children: [
            /* @__PURE__ */ ke.jsxs(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [
              /* @__PURE__ */ ke.jsx(Jn, { children: /* @__PURE__ */ ke.jsxs(b, { alignItems: "center", gap: "200", children: [
                /* @__PURE__ */ ke.jsx(
                  he,
                  {
                    size: 16,
                    color: k ? "green.400" : "red.400",
                    name: k ? "check-circle-filled" : "close-circle-filled"
                  }
                ),
                " ",
                "Opened"
              ] }) }),
              /* @__PURE__ */ ke.jsx(Jn, { children: /* @__PURE__ */ ke.jsxs(b, { alignItems: "center", gap: "200", children: [
                /* @__PURE__ */ ke.jsx(
                  he,
                  {
                    size: 16,
                    color: w ? "green.400" : "red.400",
                    name: w ? "check-circle-filled" : "close-circle-filled"
                  }
                ),
                " ",
                "Clicked"
              ] }) })
            ] }),
            /* @__PURE__ */ ke.jsx(XL, { event: e, isLoadingPreview: n })
          ] }),
          h && /* @__PURE__ */ ke.jsx(ZL, { event: e })
        ] })
      ]
    }
  );
}, nV = {
  /*
  	Compiler needs this casting so as not to complain that the string literal 'no-cache'
  	is actually of type "FetchPolicy", which type is defined as one of many string values,
  	including 'no-cache'.
  */
  fetchPolicy: "no-cache",
  notifyOnNetworkStatusChange: !0
}, tV = ({
  profileId: e,
  noOfMessagesToShow: n
}) => {
  const [r, i] = pe(!1), {
    receivedMessages: a,
    isLoading: o,
    error: s
  } = PL({
    profileId: e,
    noOfMessagesToShow: n
  }), [l, c] = eL({
    query: yL,
    options: nV,
    delayMs: 1e3
  }), [m, u] = pe([]);
  Qe(() => {
    if (a.length > 0) {
      u(a);
      const h = a.filter((k) => ay(k)).map((k) => cx(k));
      h.length > 0 && (i(!0), l(
        h.map((k) => ({
          messageId: k
        }))
      ).finally(() => i(!1)));
    }
  }, [a]), Qe(() => {
    c.length > 0 && u(
      a?.map((h) => {
        if (h.eventType === "EMAIL" && ay(h) && !h.flowMessage) {
          const k = cx(h), w = c.find((j) => (j.data && mx(j.data))?.id === k), N = w?.data && mx(w.data);
          if (N)
            return {
              ...TL(h),
              flowMessage: N
            };
        }
        return h;
      })
    );
  }, [c]);
  const f = [];
  return s && f.push(s), c.length > 0 && f.push(
    ...c.map((h) => h.error).filter((h) => h)
  ), f && f.length > 0 ? /* @__PURE__ */ ke.jsx(ke.Fragment, { children: f.map((h, k) => h.graphQLErrors ? /* @__PURE__ */ ke.jsx(
    $n,
    {
      error: h
    },
    `lastMessagesError${k}`
  ) : /* @__PURE__ */ ke.jsx(
    id,
    {
      error: h
    },
    `lastMessagesError${k}`
  )) }) : /* @__PURE__ */ ke.jsxs(ke.Fragment, { children: [
    /* @__PURE__ */ ke.jsx($.Heading, { variant: "heading-3", children: "Messages" }),
    o ? /* @__PURE__ */ ke.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ ke.jsx(mn, {}) }) : /* @__PURE__ */ ke.jsx(ke.Fragment, { children: m?.length > 0 ? /* @__PURE__ */ ke.jsx(b, { gap: "200", flexDirection: "column", children: m.map((h, k) => /* @__PURE__ */ ke.jsx(
      eV,
      {
        event: h,
        isLoadingPreview: r,
        openByDefault: k === 0
      },
      h.id
    )) }) : /* @__PURE__ */ ke.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200",
        className: yg.notificationText,
        children: "No messages found for the profile"
      }
    ) })
  ] });
}, rV = "_list_ld0hf_1", iV = "_listItem_ld0hf_4", ii = {
  list: rV,
  listItem: iV
}, aV = ({
  profile: e
}) => {
  const n = e?.data?.attributes?.properties, r = Object.entries(
    n ?? {}
  ).filter(([a, o]) => a !== "__typename" && o != null), i = r.length > 0;
  return /* @__PURE__ */ ke.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ke.jsx($.Heading, { variant: "heading-3", children: "Custom properties" }),
    !i && /* @__PURE__ */ ke.jsx($.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No custom properties available" }),
    i && /* @__PURE__ */ ke.jsx(Ye, { className: ii.list, children: r.map(([a, o]) => typeof o == "boolean" || typeof o == "string" || typeof o == "number" || Array.isArray(o) && o.every((s) => typeof s == "string") ? /* @__PURE__ */ ke.jsx(Ye.Text, { variant: "dense", className: ii.listItem, children: /* @__PURE__ */ ke.jsxs(
      b,
      {
        justifyContent: "space-between",
        alignItems: "flex-start",
        gap: "200",
        children: [
          /* @__PURE__ */ ke.jsx($.Paragraph, { variant: "4", children: vI(a) }),
          /* @__PURE__ */ ke.jsx(
            b,
            {
              style: { flex: 1, minWidth: 0 },
              justifyContent: "flex-end",
              children: Bi(o)
            }
          )
        ]
      }
    ) }, a) : null) })
  ] });
}, fx = ({
  profileId: e,
  type: n
}) => {
  const [r, i] = pe(!1), {
    listsOrSegments: a,
    error: o,
    isLoading: s,
    networkStatus: l,
    refetchListOrSegments: c
  } = HL({ profileId: e, query: n });
  Qe(() => {
    l === 4 && i(!0);
  }, [l]);
  const m = () => {
    a || c();
  }, u = a || [];
  return o ? /* @__PURE__ */ ke.jsx(id, { error: o }) : s ? /* @__PURE__ */ ke.jsx(Ye.Text, { variant: "dense", className: ii.listItem, children: /* @__PURE__ */ ke.jsx(mn, { size: 14 }) }, "loading") : u.length > 0 ? /* @__PURE__ */ ke.jsx(ke.Fragment, { children: u.map(
    ({ attributes: f, type: h }, k) => /* @__PURE__ */ ke.jsx(Ye.Text, { variant: "dense", className: ii.listItem, children: /* @__PURE__ */ ke.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
      /* @__PURE__ */ ke.jsx($.Paragraph, { variant: "4", children: f?.name }),
      !!h && /* @__PURE__ */ ke.jsx(Jn, { children: xw(h) })
    ] }) }, k)
  ) }) : r && !a ? /* @__PURE__ */ ke.jsx(Ye.Text, { variant: "dense", className: ii.listItem, children: /* @__PURE__ */ ke.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
    /* @__PURE__ */ ke.jsxs(b, { gap: "200", children: [
      /* @__PURE__ */ ke.jsx(he, { name: "exclamation-triangle-filled", color: "red" }),
      /* @__PURE__ */ ke.jsxs($.Paragraph, { variant: "4", color: "red.500", children: [
        n === "lists" ? "Lists" : "Segments",
        " could not be loaded"
      ] })
    ] }),
    /* @__PURE__ */ ke.jsx(Xe, { content: "Refresh lists and segments", children: /* @__PURE__ */ ke.jsx(tt, { icon: "sync", variant: "secondary", onClick: () => m(), children: "Retry" }) })
  ] }) }, "refetch") : /* @__PURE__ */ ke.jsx(Ye.Text, { variant: "dense", className: ii.listItem, children: /* @__PURE__ */ ke.jsx(b, { justifyContent: "space-between", alignItems: "center", children: /* @__PURE__ */ ke.jsx($.Paragraph, { variant: "4", subdued: !0, children: /* @__PURE__ */ ke.jsx("i", { children: `No ${n === "lists" ? "lists" : "segments"} available` }) }) }) }, "refetch");
}, oV = 0.7, sV = 0.3, lV = (e) => e >= oV ? { variant: "error", label: "High risk" } : e >= sV ? { variant: "warning", label: "Medium risk" } : { variant: "success", label: "Low risk" }, dV = (e) => /* @__PURE__ */ ke.jsx($.Paragraph, { as: "span", variant: "4", children: e.toFixed(2) }), cV = (e) => {
  const n = lV(e);
  return /* @__PURE__ */ ke.jsxs(b, { alignItems: "center", gap: "100", children: [
    /* @__PURE__ */ ke.jsx(Pn, { size: "small", variant: n.variant, children: n.label }),
    /* @__PURE__ */ ke.jsx($.Paragraph, { as: "span", variant: "4", children: `${(e * 100).toFixed(1)}%` })
  ] });
}, uV = (e) => {
  const n = e?.data?.attributes?.predictive_analytics ?? null;
  if (!n)
    return [];
  const r = [
    ["Average order value", n.average_order_value],
    ["Historic lifetime value", n.historic_clv],
    ["Predicted lifetime value", n.predicted_clv],
    ["Total lifetime value", n.total_clv]
  ], i = [
    ["Historic orders", n.historic_number_of_orders],
    ["Predicted orders", n.predicted_number_of_orders],
    [
      "Average days between orders",
      n.average_days_between_orders
    ],
    ["Expected next order", n.expected_date_of_next_order]
  ], a = n.churn_probability, o = n.ranked_channel_affinity?.filter(Boolean) ?? null;
  return [
    ...r.flatMap(
      ([s, l]) => l ? [{ label: s, content: dV(l) }] : []
    ),
    ...i.flatMap(
      ([s, l]) => l ? [{ label: s, content: Bi(l) }] : []
    ),
    ...a ? [
      {
        label: "Churn probability",
        content: cV(a)
      }
    ] : [],
    ...o?.length ? [
      {
        label: "Channel affinity",
        content: Bi(o)
      }
    ] : []
  ];
}, mV = ({
  profile: e
}) => {
  const n = uV(e);
  return /* @__PURE__ */ ke.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ke.jsx($.Heading, { variant: "heading-3", children: "Predictive analytics" }),
    n.length === 0 && /* @__PURE__ */ ke.jsx($.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No predictive analytics available" }),
    n.length > 0 && /* @__PURE__ */ ke.jsx(Ye, { className: ii.list, children: n.map(({ label: r, content: i }) => /* @__PURE__ */ ke.jsx(Ye.Text, { variant: "dense", className: ii.listItem, children: /* @__PURE__ */ ke.jsxs(
      b,
      {
        justifyContent: "space-between",
        alignItems: "center",
        gap: "200",
        children: [
          /* @__PURE__ */ ke.jsx($.Paragraph, { as: "span", variant: "4", children: r }),
          i
        ]
      }
    ) }, r)) })
  ] });
}, pV = "_tagHover_kzbzk_1", fV = "_channelUnsubscribed_kzbzk_6", hx = {
  tagHover: pV,
  channelUnsubscribed: fV
}, yx = ({
  isSubscribed: e,
  isLoading: n,
  channelName: r,
  channelIcon: i,
  hasReSubscriptionFeature: a,
  handleAction: o
}) => {
  const s = e ? "Unsubscribe" : "Subscribe", l = !e && !a;
  return /* @__PURE__ */ ke.jsx(
    Xe,
    {
      content: l ? "You have to select a resubscription list in the settings." : s,
      children: /* @__PURE__ */ ke.jsx(
        Jn,
        {
          className: hx.tagHover,
          color: e ? "green.500" : "neutral.200",
          children: /* @__PURE__ */ ke.jsxs(
            b,
            {
              "data-testid": `widget-preference-${e ? "subscribed" : "unsubscribed"}`,
              gap: "200",
              alignItems: "center",
              className: ct({
                [hx.channelUnsubscribed]: !e || l
              }),
              onClick: () => {
                l || o();
              },
              children: [
                n ? /* @__PURE__ */ ke.jsx(mn, { size: 16 }) : /* @__PURE__ */ ke.jsx(he, { size: 16, name: i }),
                r
              ]
            }
          )
        }
      )
    }
  );
}, hV = "_subscriptionError_1qhhx_1", yV = {
  subscriptionError: hV
}, gV = ({
  subscriptionListId: e,
  profile: n,
  email: r,
  phoneNumber: i,
  profileId: a,
  refetchProfile: o
}) => {
  const [s, l] = pe(!1), [c, m] = pe(!1), [u, f] = pe(), { track: h } = jn(), [k, w] = OO({
    channel: null,
    request: null
  }), N = DL(n), j = OL(n), _ = !!e, { useMutation: g } = hn(), [O] = g(
    xL
  ), [R] = g(
    SL
  ), F = (W) => {
    h("klaviyo:profile:subscribe:clicked", { channel: W }), w.setAll({
      channel: W,
      request: "subscribed"
    }), ((J) => O({
      variables: {
        attributes: {
          // eslint-disable-next-line camelcase
          custom_source: "Dixa integration",
          profiles: {
            data: [
              {
                type: ty.Profile,
                id: a,
                attributes: {
                  email: r,
                  // eslint-disable-next-line camelcase
                  ...i ? { phone_number: i } : {},
                  subscriptions: {
                    ...J === "EMAIL" && {
                      email: {
                        marketing: {
                          consent: ry.Subscribed
                        }
                      }
                    },
                    ...J === "SMS" && {
                      sms: {
                        marketing: {
                          consent: ry.Subscribed
                        }
                      }
                    }
                  }
                }
              }
            ]
          }
        },
        relationships: {
          list: {
            data: {
              type: a1.List,
              id: e
            }
          }
        }
      }
    }))(W).then(
      (J) => L({
        channel: W,
        mutationResponse: J,
        isSubscriptionRequest: !0
      })
    ).catch(
      (J) => L({
        channel: W,
        mutationErrorResponse: J,
        isSubscriptionRequest: !0
      })
    );
  }, I = (W) => {
    h("klaviyo:profile:unsubscribe:clicked", { channel: W }), w.setAll({
      channel: W,
      request: "unsubscribed"
    }), R({
      variables: {
        attributes: {
          profiles: {
            data: [
              {
                type: ty.Profile,
                attributes: {
                  ...W === "EMAIL" ? { email: r } : {},
                  // eslint-disable-next-line camelcase
                  ...W === "SMS" ? { phone_number: i } : {},
                  subscriptions: {
                    ...W === "EMAIL" && {
                      email: {
                        marketing: {
                          consent: iy.Unsubscribed
                        }
                      }
                    },
                    ...W === "SMS" && {
                      sms: {
                        marketing: {
                          consent: iy.Unsubscribed
                        }
                      }
                    }
                  }
                }
              }
            ]
          }
        }
      }
    }).then(
      (J) => L({
        channel: W,
        mutationResponse: J,
        isSubscriptionRequest: !1
      })
    ).catch(
      (J) => L({
        channel: W,
        mutationErrorResponse: J,
        isSubscriptionRequest: !1
      })
    );
  }, L = async ({
    channel: W,
    mutationResponse: J,
    mutationErrorResponse: re,
    isSubscriptionRequest: K
  }) => {
    const Y = re?.networkError, P = Y ? Y?.statusCode : NaN, B = J?.errors, ie = !!B && Sw({
      errors: B
    });
    P === 202 ? (h(
      K ? "klaviyo:profile:subscribe:succeeded" : "klaviyo:profile:unsubscribe:succeeded",
      { channel: W }
    ), await o()) : ie ? (h(
      K ? "klaviyo:profile:subscribe:failed" : "klaviyo:profile:unsubscribe:failed",
      {
        channel: W,
        reason: "Insufficient permissions"
      }
    ), f(
      `Request failed with a permission error. Could not ${K ? "opt-in" : "opt-out"}.`
    )) : (h(
      K ? "klaviyo:profile:subscribe:failed" : "klaviyo:profile:unsubscribe:failed",
      {
        channel: W,
        reason: Y?.message || "Unexpected error"
      }
    ), f(
      `Request failed. Could not ${K ? "opt-in" : "opt-out"}.`
    )), m(!1), l(!1);
  };
  return Qe(() => {
    if (k.request === "subscribed") {
      const W = `This subscription might be a double opt-in. The customer needs to check if they received a confirmation ${k.channel === "EMAIL" ? "email" : "sms"} to give consent.`;
      k.channel === "EMAIL" && !s && n?.data?.attributes?.subscriptions?.email?.marketing?.consent !== "SUBSCRIBED" && (f(W), w.reset()), k.channel === "SMS" && !c && n?.data?.attributes?.subscriptions?.sms?.marketing?.consent !== "SUBSCRIBED" && (f(W), w.reset());
    }
  }, [
    n?.data?.attributes?.subscriptions?.email?.marketing?.consent,
    n?.data?.attributes?.subscriptions?.sms?.marketing?.consent,
    s,
    c
  ]), /* @__PURE__ */ ke.jsx(
    b,
    {
      "data-testid": "subscription-channels",
      gap: "200",
      flexDirection: "column",
      children: /* @__PURE__ */ ke.jsxs(b, { gap: "200", flexDirection: "column", children: [
        /* @__PURE__ */ ke.jsx($.Heading, { variant: "heading-3", children: "Subscription channels" }),
        /* @__PURE__ */ ke.jsxs(b, { gap: "100", flexDirection: "row", children: [
          /* @__PURE__ */ ke.jsx(
            yx,
            {
              "data-testid": "subscription-channels-email-button",
              isLoading: s,
              isSubscribed: N,
              channelName: "Email",
              channelIcon: "mail",
              hasReSubscriptionFeature: _,
              handleAction: () => {
                l(!0), f(void 0), N ? I("EMAIL") : F("EMAIL");
              }
            }
          ),
          /* @__PURE__ */ ke.jsx(
            yx,
            {
              "data-testid": "subscription-channels-sms-button",
              isLoading: c,
              isSubscribed: j,
              channelName: "Sms",
              channelIcon: "sms",
              hasReSubscriptionFeature: _,
              handleAction: () => {
                m(!0), f(void 0), j ? I("SMS") : F("SMS");
              }
            }
          )
        ] }),
        u && /* @__PURE__ */ ke.jsx(b, { className: yV.subscriptionError, children: u })
      ] })
    }
  );
}, vV = ({
  profileId: e,
  email: n,
  phoneNumber: r,
  showProfileLists: i,
  showProfileSegments: a,
  showSubscriptions: o,
  showCustomProperties: s,
  showPredictiveAnalytics: l,
  noOfMessagesToShow: c,
  subscriptionListId: m
}) => {
  const {
    profile: u,
    error: f,
    isLoading: h,
    refetchProfile: k
  } = AL({ profileId: e });
  return f ? /* @__PURE__ */ ke.jsx(id, { error: f }) : h ? /* @__PURE__ */ ke.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ ke.jsx(mn, {}) }) : !u && !h ? /* @__PURE__ */ ke.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200",
      className: yg.notificationText,
      children: "No Klaviyo profile data found"
    }
  ) : /* @__PURE__ */ ke.jsxs(b, { flexDirection: "column", gap: "300", margin: "200 0 300", children: [
    (i || a) && /* @__PURE__ */ ke.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ ke.jsx($.Heading, { variant: "heading-3", children: "Lists & Segments" }),
      /* @__PURE__ */ ke.jsxs(Ye, { className: ii.list, children: [
        i && /* @__PURE__ */ ke.jsx(fx, { profileId: e, type: "lists" }),
        a && /* @__PURE__ */ ke.jsx(
          fx,
          {
            profileId: e,
            type: "segments"
          }
        )
      ] })
    ] }),
    u && e && o && /* @__PURE__ */ ke.jsx(
      gV,
      {
        profile: u,
        profileId: e,
        subscriptionListId: m,
        refetchProfile: k,
        email: n,
        phoneNumber: r
      }
    ),
    u && l && /* @__PURE__ */ ke.jsx(mV, { profile: u }),
    u && s && /* @__PURE__ */ ke.jsx(aV, { profile: u }),
    /* @__PURE__ */ ke.jsx(
      tV,
      {
        profileId: e,
        noOfMessagesToShow: c
      }
    )
  ] });
}, kV = ({
  conversationContext: e,
  settings: n
}) => {
  const r = e.customer?.email || void 0, i = e.customer?.phone_number || void 0, a = n?.showProfileLists, o = n?.showProfileSegments, s = n?.showSubscriptions, l = n?.showCustomProperties, c = n?.showPredictiveAnalytics, m = Number(n?.noOfMessagesToShow), u = n?.subscriptionListId, {
    profileId: f,
    getProfileId: h,
    isLoading: k,
    error: w
  } = LL({ email: r, phoneNumber: i });
  return jI(() => {
    (r || i) && h({
      variables: {
        emailFilter: r ? `equals(email,"${r}")` : void 0,
        phoneNumberFilter: i ? `equals(phone_number,"${i}")` : void 0,
        hasEmail: !!r,
        hasPhoneNumber: !!i
      }
    });
  }, [r, i]), !r && !i ? /* @__PURE__ */ ke.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: "The customer does not have an email nor a phone number" }) : k ? /* @__PURE__ */ ke.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ ke.jsx(mn, {}) }) : w ? /* @__PURE__ */ ke.jsx(id, { error: w }) : f ? /* @__PURE__ */ ke.jsx(
    vV,
    {
      profileId: f,
      email: r,
      phoneNumber: i,
      showProfileLists: a,
      showProfileSegments: o,
      showSubscriptions: s,
      showCustomProperties: l,
      showPredictiveAnalytics: c,
      noOfMessagesToShow: m,
      subscriptionListId: u
    }
  ) : /* @__PURE__ */ ke.jsx(
    b,
    {
      justifyContent: "center",
      margin: "0 0 300 0",
      className: yg.notificationText,
      children: "No profile ID found"
    }
  );
}, Na = [
  {
    key: "klaviyoApiKey",
    label: "API key",
    type: "string",
    secret: !0,
    defaultValue: ""
  },
  {
    key: "showProfileLists",
    label: "Show Klaviyo lists for a profile",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "showProfileSegments",
    label: "Show Klaviyo segments for a profile",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "showSubscriptions",
    label: "Show subscription channels for Klaviyo messages",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "showCustomProperties",
    label: "Show custom properties for a profile",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showPredictiveAnalytics",
    label: "Show predictive analytics for a profile",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  // Populated by the subscribe-list selector; empty means the feature is off.
  {
    key: "subscriptionListId",
    label: "Re-/subscription list",
    type: "string",
    secret: !1,
    defaultValue: ""
  },
  {
    key: "noOfMessagesToShow",
    label: "Choose how many messages to show",
    type: "string",
    secret: !1,
    defaultValue: "5"
  }
], bV = [
  {
    key: "authorizeWithOauth",
    label: "Authorize with OAuth",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: vi
  }
], _V = [
  {
    key: "klaviyoApiKey",
    label: "API key",
    placeholder: "API key from Klaviyo",
    required: !0,
    secret: !0,
    type: "input"
  }
], xV = ir(Na), gx = [
  { value: "3", label: "The three latest messages" },
  { value: "4", label: "The four latest messages" },
  { value: "5", label: "The five latest messages" }
], SV = ({
  control: e,
  name: n
}) => /* @__PURE__ */ ke.jsx(
  ur,
  {
    name: n,
    control: e,
    label: xV.noOfMessagesToShow,
    rules: { required: "Please choose how many messages to show" },
    componentProps: {
      placeholder: "Select an option",
      equalityFn: (r, i) => r === i,
      getItemTitleByValue: (r) => {
        const i = gx.find(
          (a) => a.value === r
        )?.label;
        return i ? /* @__PURE__ */ ke.jsx($.Paragraph, { children: i }) : null;
      }
    },
    children: gx.map((r) => /* @__PURE__ */ ke.jsx(mt.Item, { value: r.value, children: r.label }, r.value))
  }
), NV = "_settingsWrapper_eleyu_1", jV = {
  settingsWrapper: NV
}, wV = Yr(
  /* GraphQL */
  `
  query getLists {
    Klaviyo {
      get_lists {
        ... on Klaviyo_GetListListResponseCollectionCompoundDocument {
          data {
            type
            id
            attributes {
              name
              created
              updated
            }
            links {
              self
            }
          }
          links {
            self
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), vx = [], CV = ({
  value: e,
  onChange: n
}) => {
  const { useQuery: r } = hn(), [i, a] = pe(vx), [o, s] = pe(!!e), {
    data: l,
    error: c,
    loading: m
  } = r(wV, {
    skip: !o,
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0
  });
  return Qe(() => {
    e && s(!0);
  }, [e]), Qe(() => {
    const u = l?.Klaviyo?.get_lists;
    if (o && u && !m && !c) {
      const f = u?.data?.map(
        (h) => ({
          value: h?.id,
          label: h?.attributes?.name
        })
      ) || vx;
      a(f);
    }
  }, [o, l, m, c]), /* @__PURE__ */ ke.jsxs(ke.Fragment, { children: [
    /* @__PURE__ */ ke.jsx(X, { span: 3, children: /* @__PURE__ */ ke.jsxs(
      b,
      {
        gap: "300",
        flexDirection: "column",
        className: jV.settingsWrapper,
        children: [
          /* @__PURE__ */ ke.jsx(He, { label: "Activate re-/subscription list selection", children: /* @__PURE__ */ ke.jsx(
            ww,
            {
              input: {
                name: "subscriptionListId-switch",
                value: "switchValueFromComponent",
                checked: o,
                onChange: () => {
                  const u = !o;
                  u || n(""), s(u);
                }
              }
            }
          ) }),
          o && c && !m && /* @__PURE__ */ ke.jsx(He, { children: /* @__PURE__ */ ke.jsx($n, { error: c }) }),
          o && !c && m && /* @__PURE__ */ ke.jsx(He, { children: /* @__PURE__ */ ke.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ ke.jsx(mn, {}) }) }),
          o && !c && !m && i && /* @__PURE__ */ ke.jsx(He, { label: "Available lists to subscribe to", children: /* @__PURE__ */ ke.jsx(
            pi,
            {
              required: !0,
              placeholder: "Select a list",
              onChange: (u) => n(u?.selectedValues?.[0]?.value ?? ""),
              getItemTitleByValue: (u) => u ? /* @__PURE__ */ ke.jsx($.Paragraph, { children: u.label }) : null,
              value: e ? [
                {
                  label: (i || []).find(
                    (u) => u.value === e
                  )?.label,
                  value: e
                }
              ] : [],
              equalityFn: (u, f) => u.value === f.value,
              children: i.map((u) => /* @__PURE__ */ ke.jsx(mt.Item, { value: u, children: u.label }, u.value))
            }
          ) })
        ]
      }
    ) }),
    /* @__PURE__ */ ke.jsx(X, { span: 3 })
  ] });
}, ta = ir(Na), _m = "KLAVIYO", FV = {
  enabled: !1,
  name: "",
  ...Bl(
    [],
    Na
  )
}, IV = ({
  integrationId: e,
  configuration: n,
  handleRedirect: r,
  showNotification: i,
  automationCouplingState: a,
  renderConditionsEditor: o
}) => {
  const s = !e, l = ut({
    mode: "onChange",
    defaultValues: FV
  }), {
    create: c,
    update: m,
    remove: u,
    isLoading: f,
    error: h,
    misconfigurationCause: k,
    setMisconfigurationCause: w
  } = mr({
    integrationId: e,
    integrationType: _m,
    handleRedirect: r,
    showNotification: i
  }), {
    isLoading: N,
    error: j,
    isWidgetUnknown: _,
    refetch: g,
    widgetConfiguration: O
  } = pr({
    integrationId: e,
    fieldDefinitions: Na,
    form: l,
    onMisconfigured: w
  }), { renderConditions: R, setRenderConditions: F, renderConditionsForSubmit: I } = fr({
    integrationId: e,
    widgetConfiguration: O,
    renderConditionsEditor: o
  }), L = s || !!O?.additionalProperties?.isUsingOAuth, W = (re) => yr(re, {
    fieldDefinitions: Na,
    isCreationMode: s,
    create: c,
    update: m,
    renderConditions: I
  }), J = l.watch("name");
  return /* @__PURE__ */ ke.jsxs(
    hr,
    {
      form: l,
      integrationId: e,
      onValidSubmit: W,
      error: j ?? h,
      onRetry: j ? g : void 0,
      isLoading: f || N,
      isWidgetUnknown: _,
      children: [
        k && /* @__PURE__ */ ke.jsx(gr, { cause: k }),
        /* @__PURE__ */ ke.jsxs(et, { children: [
          /* @__PURE__ */ ke.jsx(X, { children: /* @__PURE__ */ ke.jsx(He, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ ke.jsx(
            yn,
            {
              name: "enabled",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ ke.jsx(X, { span: 3, children: /* @__PURE__ */ ke.jsx(
            On,
            {
              name: "name",
              label: "Widget name",
              control: l.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ ke.jsx(X, { span: 3 }),
          !L && /* @__PURE__ */ ke.jsxs(ke.Fragment, { children: [
            /* @__PURE__ */ ke.jsx(X, { span: 3, children: /* @__PURE__ */ ke.jsx(
              $r,
              {
                name: "klaviyoApiKey",
                label: ta.klaviyoApiKey,
                control: l.control,
                isCreationMode: s,
                rules: { required: "API key is required" },
                componentProps: {
                  placeholder: "API key from Klaviyo",
                  autoComplete: "off"
                }
              }
            ) }),
            /* @__PURE__ */ ke.jsx(X, { span: 3 })
          ] }),
          /* @__PURE__ */ ke.jsx(X, { span: 3, children: /* @__PURE__ */ ke.jsx(He, { label: ta.showProfileLists, children: /* @__PURE__ */ ke.jsx(
            yn,
            {
              name: "showProfileLists",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ ke.jsx(X, { span: 3 }),
          /* @__PURE__ */ ke.jsx(X, { span: 3, children: /* @__PURE__ */ ke.jsx(He, { label: ta.showProfileSegments, children: /* @__PURE__ */ ke.jsx(
            yn,
            {
              name: "showProfileSegments",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ ke.jsx(X, { span: 3 }),
          /* @__PURE__ */ ke.jsx(X, { span: 3, children: /* @__PURE__ */ ke.jsx(He, { label: ta.showSubscriptions, children: /* @__PURE__ */ ke.jsx(
            yn,
            {
              name: "showSubscriptions",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ ke.jsx(X, { span: 3 }),
          /* @__PURE__ */ ke.jsx(X, { span: 3, children: /* @__PURE__ */ ke.jsx(He, { label: ta.showCustomProperties, children: /* @__PURE__ */ ke.jsx(
            yn,
            {
              name: "showCustomProperties",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ ke.jsx(X, { span: 3 }),
          /* @__PURE__ */ ke.jsx(X, { span: 3, children: /* @__PURE__ */ ke.jsx(He, { label: ta.showPredictiveAnalytics, children: /* @__PURE__ */ ke.jsx(
            yn,
            {
              name: "showPredictiveAnalytics",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ ke.jsx(X, { span: 3 }),
          !s && /* @__PURE__ */ ke.jsx(
            Nt,
            {
              name: "subscriptionListId",
              control: l.control,
              render: ({ field: re }) => /* @__PURE__ */ ke.jsx(
                CV,
                {
                  value: re.value,
                  onChange: re.onChange
                }
              )
            }
          ),
          /* @__PURE__ */ ke.jsx(X, { span: 3, children: /* @__PURE__ */ ke.jsx(
            SV,
            {
              name: "noOfMessagesToShow",
              control: l.control
            }
          ) }),
          /* @__PURE__ */ ke.jsx(X, { span: 3 }),
          L && !s && e && /* @__PURE__ */ ke.jsx(
            vi,
            {
              configuration: n,
              integrationId: e,
              integrationType: _m,
              label: "Authorize with OAuth"
            }
          ),
          o && R !== null && /* @__PURE__ */ ke.jsx(X, { children: o({
            value: R,
            onChange: F,
            configurationKey: O?.id
          }) })
        ] }),
        /* @__PURE__ */ ke.jsx(
          vr,
          {
            integrationType: _m,
            integrationId: e,
            widgetName: J,
            isCreationMode: s,
            isSubmitting: l.formState.isSubmitting,
            automationCouplingState: a,
            onConfirmDelete: () => u()
          }
        )
      ]
    }
  );
};
function $V(e, n) {
  const r = {};
  return (e[e.length - 1] === "" ? [...e, ""] : e).join(
    (r.padRight ? " " : "") + "," + (r.padLeft === !1 ? "" : " ")
  ).trim();
}
const EV = /^[$_\p{ID_Start}][$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, TV = /^[$_\p{ID_Start}][-$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, RV = {};
function kx(e, n) {
  return (RV.jsx ? TV : EV).test(e);
}
const DV = /[ \t\n\f\r]/g;
function OV(e) {
  return typeof e == "object" ? e.type === "text" ? bx(e.value) : !1 : bx(e);
}
function bx(e) {
  return e.replace(DV, "") === "";
}
class ts {
  /**
   * @constructor
   * @param {Properties} property
   * @param {Normal} normal
   * @param {string} [space]
   */
  constructor(n, r, i) {
    this.property = n, this.normal = r, i && (this.space = i);
  }
}
ts.prototype.property = {};
ts.prototype.normal = {};
ts.prototype.space = null;
function o1(e, n) {
  const r = {}, i = {};
  let a = -1;
  for (; ++a < e.length; )
    Object.assign(r, e[a].property), Object.assign(i, e[a].normal);
  return new ts(r, i, n);
}
function oy(e) {
  return e.toLowerCase();
}
class Sr {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   */
  constructor(n, r) {
    this.property = n, this.attribute = r;
  }
}
Sr.prototype.space = null;
Sr.prototype.boolean = !1;
Sr.prototype.booleanish = !1;
Sr.prototype.overloadedBoolean = !1;
Sr.prototype.number = !1;
Sr.prototype.commaSeparated = !1;
Sr.prototype.spaceSeparated = !1;
Sr.prototype.commaOrSpaceSeparated = !1;
Sr.prototype.mustUseProperty = !1;
Sr.prototype.defined = !1;
let PV = 0;
const Tn = Yi(), St = Yi(), s1 = Yi(), Ke = Yi(), st = Yi(), ga = Yi(), or = Yi();
function Yi() {
  return 2 ** ++PV;
}
const sy = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  boolean: Tn,
  booleanish: St,
  commaOrSpaceSeparated: or,
  commaSeparated: ga,
  number: Ke,
  overloadedBoolean: s1,
  spaceSeparated: st
}, Symbol.toStringTag, { value: "Module" })), xm = Object.keys(sy);
class gg extends Sr {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   * @param {number|null} [mask]
   * @param {string} [space]
   */
  constructor(n, r, i, a) {
    let o = -1;
    if (super(n, r), _x(this, "space", a), typeof i == "number")
      for (; ++o < xm.length; ) {
        const s = xm[o];
        _x(this, xm[o], (i & sy[s]) === sy[s]);
      }
  }
}
gg.prototype.defined = !0;
function _x(e, n, r) {
  r && (e[n] = r);
}
const AV = {}.hasOwnProperty;
function Oa(e) {
  const n = {}, r = {};
  let i;
  for (i in e.properties)
    if (AV.call(e.properties, i)) {
      const a = e.properties[i], o = new gg(
        i,
        e.transform(e.attributes || {}, i),
        a,
        e.space
      );
      e.mustUseProperty && e.mustUseProperty.includes(i) && (o.mustUseProperty = !0), n[i] = o, r[oy(i)] = i, r[oy(o.attribute)] = i;
    }
  return new ts(n, r, e.space);
}
const l1 = Oa({
  space: "xlink",
  transform(e, n) {
    return "xlink:" + n.slice(5).toLowerCase();
  },
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  }
}), d1 = Oa({
  space: "xml",
  transform(e, n) {
    return "xml:" + n.slice(3).toLowerCase();
  },
  properties: { xmlLang: null, xmlBase: null, xmlSpace: null }
});
function c1(e, n) {
  return n in e ? e[n] : n;
}
function u1(e, n) {
  return c1(e, n.toLowerCase());
}
const m1 = Oa({
  space: "xmlns",
  attributes: { xmlnsxlink: "xmlns:xlink" },
  transform: u1,
  properties: { xmlns: null, xmlnsXLink: null }
}), p1 = Oa({
  transform(e, n) {
    return n === "role" ? n : "aria-" + n.slice(4).toLowerCase();
  },
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: St,
    ariaAutoComplete: null,
    ariaBusy: St,
    ariaChecked: St,
    ariaColCount: Ke,
    ariaColIndex: Ke,
    ariaColSpan: Ke,
    ariaControls: st,
    ariaCurrent: null,
    ariaDescribedBy: st,
    ariaDetails: null,
    ariaDisabled: St,
    ariaDropEffect: st,
    ariaErrorMessage: null,
    ariaExpanded: St,
    ariaFlowTo: st,
    ariaGrabbed: St,
    ariaHasPopup: null,
    ariaHidden: St,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: st,
    ariaLevel: Ke,
    ariaLive: null,
    ariaModal: St,
    ariaMultiLine: St,
    ariaMultiSelectable: St,
    ariaOrientation: null,
    ariaOwns: st,
    ariaPlaceholder: null,
    ariaPosInSet: Ke,
    ariaPressed: St,
    ariaReadOnly: St,
    ariaRelevant: null,
    ariaRequired: St,
    ariaRoleDescription: st,
    ariaRowCount: Ke,
    ariaRowIndex: Ke,
    ariaRowSpan: Ke,
    ariaSelected: St,
    ariaSetSize: Ke,
    ariaSort: null,
    ariaValueMax: Ke,
    ariaValueMin: Ke,
    ariaValueNow: Ke,
    ariaValueText: null,
    role: null
  }
}), LV = Oa({
  space: "html",
  attributes: {
    acceptcharset: "accept-charset",
    classname: "class",
    htmlfor: "for",
    httpequiv: "http-equiv"
  },
  transform: u1,
  mustUseProperty: ["checked", "multiple", "muted", "selected"],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: ga,
    acceptCharset: st,
    accessKey: st,
    action: null,
    allow: null,
    allowFullScreen: Tn,
    allowPaymentRequest: Tn,
    allowUserMedia: Tn,
    alt: null,
    as: null,
    async: Tn,
    autoCapitalize: null,
    autoComplete: st,
    autoFocus: Tn,
    autoPlay: Tn,
    blocking: st,
    capture: null,
    charSet: null,
    checked: Tn,
    cite: null,
    className: st,
    cols: Ke,
    colSpan: null,
    content: null,
    contentEditable: St,
    controls: Tn,
    controlsList: st,
    coords: Ke | ga,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: Tn,
    defer: Tn,
    dir: null,
    dirName: null,
    disabled: Tn,
    download: s1,
    draggable: St,
    encType: null,
    enterKeyHint: null,
    fetchPriority: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: Tn,
    formTarget: null,
    headers: st,
    height: Ke,
    hidden: Tn,
    high: Ke,
    href: null,
    hrefLang: null,
    htmlFor: st,
    httpEquiv: st,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inert: Tn,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: Tn,
    itemId: null,
    itemProp: st,
    itemRef: st,
    itemScope: Tn,
    itemType: st,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: Tn,
    low: Ke,
    manifest: null,
    max: null,
    maxLength: Ke,
    media: null,
    method: null,
    min: null,
    minLength: Ke,
    multiple: Tn,
    muted: Tn,
    name: null,
    nonce: null,
    noModule: Tn,
    noValidate: Tn,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeToggle: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: Tn,
    optimum: Ke,
    pattern: null,
    ping: st,
    placeholder: null,
    playsInline: Tn,
    popover: null,
    popoverTarget: null,
    popoverTargetAction: null,
    poster: null,
    preload: null,
    readOnly: Tn,
    referrerPolicy: null,
    rel: st,
    required: Tn,
    reversed: Tn,
    rows: Ke,
    rowSpan: Ke,
    sandbox: st,
    scope: null,
    scoped: Tn,
    seamless: Tn,
    selected: Tn,
    shadowRootClonable: Tn,
    shadowRootDelegatesFocus: Tn,
    shadowRootMode: null,
    shape: null,
    size: Ke,
    sizes: null,
    slot: null,
    span: Ke,
    spellCheck: St,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: Ke,
    step: null,
    style: null,
    tabIndex: Ke,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: Tn,
    useMap: null,
    value: St,
    width: Ke,
    wrap: null,
    writingSuggestions: null,
    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null,
    // Several. Use CSS `text-align` instead,
    aLink: null,
    // `<body>`. Use CSS `a:active {color}` instead
    archive: st,
    // `<object>`. List of URIs to archives
    axis: null,
    // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null,
    // `<body>`. Use CSS `background-image` instead
    bgColor: null,
    // `<body>` and table elements. Use CSS `background-color` instead
    border: Ke,
    // `<table>`. Use CSS `border-width` instead,
    borderColor: null,
    // `<table>`. Use CSS `border-color` instead,
    bottomMargin: Ke,
    // `<body>`
    cellPadding: null,
    // `<table>`
    cellSpacing: null,
    // `<table>`
    char: null,
    // Several table elements. When `align=char`, sets the character to align on
    charOff: null,
    // Several table elements. When `char`, offsets the alignment
    classId: null,
    // `<object>`
    clear: null,
    // `<br>`. Use CSS `clear` instead
    code: null,
    // `<object>`
    codeBase: null,
    // `<object>`
    codeType: null,
    // `<object>`
    color: null,
    // `<font>` and `<hr>`. Use CSS instead
    compact: Tn,
    // Lists. Use CSS to reduce space between items instead
    declare: Tn,
    // `<object>`
    event: null,
    // `<script>`
    face: null,
    // `<font>`. Use CSS instead
    frame: null,
    // `<table>`
    frameBorder: null,
    // `<iframe>`. Use CSS `border` instead
    hSpace: Ke,
    // `<img>` and `<object>`
    leftMargin: Ke,
    // `<body>`
    link: null,
    // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null,
    // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null,
    // `<img>`. Use a `<picture>`
    marginHeight: Ke,
    // `<body>`
    marginWidth: Ke,
    // `<body>`
    noResize: Tn,
    // `<frame>`
    noHref: Tn,
    // `<area>`. Use no href instead of an explicit `nohref`
    noShade: Tn,
    // `<hr>`. Use background-color and height instead of borders
    noWrap: Tn,
    // `<td>` and `<th>`
    object: null,
    // `<applet>`
    profile: null,
    // `<head>`
    prompt: null,
    // `<isindex>`
    rev: null,
    // `<link>`
    rightMargin: Ke,
    // `<body>`
    rules: null,
    // `<table>`
    scheme: null,
    // `<meta>`
    scrolling: St,
    // `<frame>`. Use overflow in the child context
    standby: null,
    // `<object>`
    summary: null,
    // `<table>`
    text: null,
    // `<body>`. Use CSS `color` instead
    topMargin: Ke,
    // `<body>`
    valueType: null,
    // `<param>`
    version: null,
    // `<html>`. Use a doctype.
    vAlign: null,
    // Several. Use CSS `vertical-align` instead
    vLink: null,
    // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: Ke,
    // `<img>` and `<object>`
    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: Tn,
    disableRemotePlayback: Tn,
    prefix: null,
    property: null,
    results: Ke,
    security: null,
    unselectable: null
  }
}), VV = Oa({
  space: "svg",
  attributes: {
    accentHeight: "accent-height",
    alignmentBaseline: "alignment-baseline",
    arabicForm: "arabic-form",
    baselineShift: "baseline-shift",
    capHeight: "cap-height",
    className: "class",
    clipPath: "clip-path",
    clipRule: "clip-rule",
    colorInterpolation: "color-interpolation",
    colorInterpolationFilters: "color-interpolation-filters",
    colorProfile: "color-profile",
    colorRendering: "color-rendering",
    crossOrigin: "crossorigin",
    dataType: "datatype",
    dominantBaseline: "dominant-baseline",
    enableBackground: "enable-background",
    fillOpacity: "fill-opacity",
    fillRule: "fill-rule",
    floodColor: "flood-color",
    floodOpacity: "flood-opacity",
    fontFamily: "font-family",
    fontSize: "font-size",
    fontSizeAdjust: "font-size-adjust",
    fontStretch: "font-stretch",
    fontStyle: "font-style",
    fontVariant: "font-variant",
    fontWeight: "font-weight",
    glyphName: "glyph-name",
    glyphOrientationHorizontal: "glyph-orientation-horizontal",
    glyphOrientationVertical: "glyph-orientation-vertical",
    hrefLang: "hreflang",
    horizAdvX: "horiz-adv-x",
    horizOriginX: "horiz-origin-x",
    horizOriginY: "horiz-origin-y",
    imageRendering: "image-rendering",
    letterSpacing: "letter-spacing",
    lightingColor: "lighting-color",
    markerEnd: "marker-end",
    markerMid: "marker-mid",
    markerStart: "marker-start",
    navDown: "nav-down",
    navDownLeft: "nav-down-left",
    navDownRight: "nav-down-right",
    navLeft: "nav-left",
    navNext: "nav-next",
    navPrev: "nav-prev",
    navRight: "nav-right",
    navUp: "nav-up",
    navUpLeft: "nav-up-left",
    navUpRight: "nav-up-right",
    onAbort: "onabort",
    onActivate: "onactivate",
    onAfterPrint: "onafterprint",
    onBeforePrint: "onbeforeprint",
    onBegin: "onbegin",
    onCancel: "oncancel",
    onCanPlay: "oncanplay",
    onCanPlayThrough: "oncanplaythrough",
    onChange: "onchange",
    onClick: "onclick",
    onClose: "onclose",
    onCopy: "oncopy",
    onCueChange: "oncuechange",
    onCut: "oncut",
    onDblClick: "ondblclick",
    onDrag: "ondrag",
    onDragEnd: "ondragend",
    onDragEnter: "ondragenter",
    onDragExit: "ondragexit",
    onDragLeave: "ondragleave",
    onDragOver: "ondragover",
    onDragStart: "ondragstart",
    onDrop: "ondrop",
    onDurationChange: "ondurationchange",
    onEmptied: "onemptied",
    onEnd: "onend",
    onEnded: "onended",
    onError: "onerror",
    onFocus: "onfocus",
    onFocusIn: "onfocusin",
    onFocusOut: "onfocusout",
    onHashChange: "onhashchange",
    onInput: "oninput",
    onInvalid: "oninvalid",
    onKeyDown: "onkeydown",
    onKeyPress: "onkeypress",
    onKeyUp: "onkeyup",
    onLoad: "onload",
    onLoadedData: "onloadeddata",
    onLoadedMetadata: "onloadedmetadata",
    onLoadStart: "onloadstart",
    onMessage: "onmessage",
    onMouseDown: "onmousedown",
    onMouseEnter: "onmouseenter",
    onMouseLeave: "onmouseleave",
    onMouseMove: "onmousemove",
    onMouseOut: "onmouseout",
    onMouseOver: "onmouseover",
    onMouseUp: "onmouseup",
    onMouseWheel: "onmousewheel",
    onOffline: "onoffline",
    onOnline: "ononline",
    onPageHide: "onpagehide",
    onPageShow: "onpageshow",
    onPaste: "onpaste",
    onPause: "onpause",
    onPlay: "onplay",
    onPlaying: "onplaying",
    onPopState: "onpopstate",
    onProgress: "onprogress",
    onRateChange: "onratechange",
    onRepeat: "onrepeat",
    onReset: "onreset",
    onResize: "onresize",
    onScroll: "onscroll",
    onSeeked: "onseeked",
    onSeeking: "onseeking",
    onSelect: "onselect",
    onShow: "onshow",
    onStalled: "onstalled",
    onStorage: "onstorage",
    onSubmit: "onsubmit",
    onSuspend: "onsuspend",
    onTimeUpdate: "ontimeupdate",
    onToggle: "ontoggle",
    onUnload: "onunload",
    onVolumeChange: "onvolumechange",
    onWaiting: "onwaiting",
    onZoom: "onzoom",
    overlinePosition: "overline-position",
    overlineThickness: "overline-thickness",
    paintOrder: "paint-order",
    panose1: "panose-1",
    pointerEvents: "pointer-events",
    referrerPolicy: "referrerpolicy",
    renderingIntent: "rendering-intent",
    shapeRendering: "shape-rendering",
    stopColor: "stop-color",
    stopOpacity: "stop-opacity",
    strikethroughPosition: "strikethrough-position",
    strikethroughThickness: "strikethrough-thickness",
    strokeDashArray: "stroke-dasharray",
    strokeDashOffset: "stroke-dashoffset",
    strokeLineCap: "stroke-linecap",
    strokeLineJoin: "stroke-linejoin",
    strokeMiterLimit: "stroke-miterlimit",
    strokeOpacity: "stroke-opacity",
    strokeWidth: "stroke-width",
    tabIndex: "tabindex",
    textAnchor: "text-anchor",
    textDecoration: "text-decoration",
    textRendering: "text-rendering",
    transformOrigin: "transform-origin",
    typeOf: "typeof",
    underlinePosition: "underline-position",
    underlineThickness: "underline-thickness",
    unicodeBidi: "unicode-bidi",
    unicodeRange: "unicode-range",
    unitsPerEm: "units-per-em",
    vAlphabetic: "v-alphabetic",
    vHanging: "v-hanging",
    vIdeographic: "v-ideographic",
    vMathematical: "v-mathematical",
    vectorEffect: "vector-effect",
    vertAdvY: "vert-adv-y",
    vertOriginX: "vert-origin-x",
    vertOriginY: "vert-origin-y",
    wordSpacing: "word-spacing",
    writingMode: "writing-mode",
    xHeight: "x-height",
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: "playbackorder",
    timelineBegin: "timelinebegin"
  },
  transform: c1,
  properties: {
    about: or,
    accentHeight: Ke,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: Ke,
    amplitude: Ke,
    arabicForm: null,
    ascent: Ke,
    attributeName: null,
    attributeType: null,
    azimuth: Ke,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: Ke,
    by: null,
    calcMode: null,
    capHeight: Ke,
    className: st,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: Ke,
    diffuseConstant: Ke,
    direction: null,
    display: null,
    dur: null,
    divisor: Ke,
    dominantBaseline: null,
    download: Tn,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: Ke,
    enableBackground: null,
    end: null,
    event: null,
    exponent: Ke,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: Ke,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: ga,
    g2: ga,
    glyphName: ga,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: Ke,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: Ke,
    horizOriginX: Ke,
    horizOriginY: Ke,
    id: null,
    ideographic: Ke,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: Ke,
    k: Ke,
    k1: Ke,
    k2: Ke,
    k3: Ke,
    k4: Ke,
    kernelMatrix: or,
    kernelUnitLength: null,
    keyPoints: null,
    // SEMI_COLON_SEPARATED
    keySplines: null,
    // SEMI_COLON_SEPARATED
    keyTimes: null,
    // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: Ke,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: Ke,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: Ke,
    overlineThickness: Ke,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: Ke,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: st,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: Ke,
    pointsAtY: Ke,
    pointsAtZ: Ke,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: or,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: or,
    rev: or,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: or,
    requiredFeatures: or,
    requiredFonts: or,
    requiredFormats: or,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: Ke,
    specularExponent: Ke,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: Ke,
    strikethroughThickness: Ke,
    string: null,
    stroke: null,
    strokeDashArray: or,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: Ke,
    strokeOpacity: Ke,
    strokeWidth: null,
    style: null,
    surfaceScale: Ke,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: or,
    tabIndex: Ke,
    tableValues: null,
    target: null,
    targetX: Ke,
    targetY: Ke,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: or,
    to: null,
    transform: null,
    transformOrigin: null,
    u1: null,
    u2: null,
    underlinePosition: Ke,
    underlineThickness: Ke,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: Ke,
    values: null,
    vAlphabetic: Ke,
    vMathematical: Ke,
    vectorEffect: null,
    vHanging: Ke,
    vIdeographic: Ke,
    version: null,
    vertAdvY: Ke,
    vertOriginX: Ke,
    vertOriginY: Ke,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: Ke,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  }
}), zV = /^data[-\w.:]+$/i, xx = /-[a-z]/g, UV = /[A-Z]/g;
function MV(e, n) {
  const r = oy(n);
  let i = n, a = Sr;
  if (r in e.normal)
    return e.property[e.normal[r]];
  if (r.length > 4 && r.slice(0, 4) === "data" && zV.test(n)) {
    if (n.charAt(4) === "-") {
      const o = n.slice(5).replace(xx, qV);
      i = "data" + o.charAt(0).toUpperCase() + o.slice(1);
    } else {
      const o = n.slice(4);
      if (!xx.test(o)) {
        let s = o.replace(UV, BV);
        s.charAt(0) !== "-" && (s = "-" + s), n = "data" + s;
      }
    }
    a = gg;
  }
  return new a(i, n);
}
function BV(e) {
  return "-" + e.toLowerCase();
}
function qV(e) {
  return e.charAt(1).toUpperCase();
}
const HV = {
  classId: "classID",
  dataType: "datatype",
  itemId: "itemID",
  strokeDashArray: "strokeDasharray",
  strokeDashOffset: "strokeDashoffset",
  strokeLineCap: "strokeLinecap",
  strokeLineJoin: "strokeLinejoin",
  strokeMiterLimit: "strokeMiterlimit",
  typeOf: "typeof",
  xLinkActuate: "xlinkActuate",
  xLinkArcRole: "xlinkArcrole",
  xLinkHref: "xlinkHref",
  xLinkRole: "xlinkRole",
  xLinkShow: "xlinkShow",
  xLinkTitle: "xlinkTitle",
  xLinkType: "xlinkType",
  xmlnsXLink: "xmlnsXlink"
}, WV = o1([d1, l1, m1, p1, LV], "html"), vg = o1([d1, l1, m1, p1, VV], "svg");
function KV(e) {
  return e.join(" ").trim();
}
var ra = {}, Sm, Sx;
function GV() {
  if (Sx) return Sm;
  Sx = 1;
  var e = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g, n = /\n/g, r = /^\s*/, i = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/, a = /^:\s*/, o = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/, s = /^[;\s]*/, l = /^\s+|\s+$/g, c = `
`, m = "/", u = "*", f = "", h = "comment", k = "declaration";
  Sm = function(N, j) {
    if (typeof N != "string")
      throw new TypeError("First argument must be a string");
    if (!N) return [];
    j = j || {};
    var _ = 1, g = 1;
    function O(P) {
      var B = P.match(n);
      B && (_ += B.length);
      var ie = P.lastIndexOf(c);
      g = ~ie ? P.length - ie : g + P.length;
    }
    function R() {
      var P = { line: _, column: g };
      return function(B) {
        return B.position = new F(P), W(), B;
      };
    }
    function F(P) {
      this.start = P, this.end = { line: _, column: g }, this.source = j.source;
    }
    F.prototype.content = N;
    function I(P) {
      var B = new Error(
        j.source + ":" + _ + ":" + g + ": " + P
      );
      if (B.reason = P, B.filename = j.source, B.line = _, B.column = g, B.source = N, !j.silent) throw B;
    }
    function L(P) {
      var B = P.exec(N);
      if (B) {
        var ie = B[0];
        return O(ie), N = N.slice(ie.length), B;
      }
    }
    function W() {
      L(r);
    }
    function J(P) {
      var B;
      for (P = P || []; B = re(); )
        B !== !1 && P.push(B);
      return P;
    }
    function re() {
      var P = R();
      if (!(m != N.charAt(0) || u != N.charAt(1))) {
        for (var B = 2; f != N.charAt(B) && (u != N.charAt(B) || m != N.charAt(B + 1)); )
          ++B;
        if (B += 2, f === N.charAt(B - 1))
          return I("End of comment missing");
        var ie = N.slice(2, B - 2);
        return g += 2, O(ie), N = N.slice(B), g += 2, P({
          type: h,
          comment: ie
        });
      }
    }
    function K() {
      var P = R(), B = L(i);
      if (B) {
        if (re(), !L(a)) return I("property missing ':'");
        var ie = L(o), we = P({
          type: k,
          property: w(B[0].replace(e, f)),
          value: ie ? w(ie[0].replace(e, f)) : f
        });
        return L(s), we;
      }
    }
    function Y() {
      var P = [];
      J(P);
      for (var B; B = K(); )
        B !== !1 && (P.push(B), J(P));
      return P;
    }
    return W(), Y();
  };
  function w(N) {
    return N ? N.replace(l, f) : f;
  }
  return Sm;
}
var Nx;
function YV() {
  if (Nx) return ra;
  Nx = 1;
  var e = ra && ra.__importDefault || function(i) {
    return i && i.__esModule ? i : { default: i };
  };
  Object.defineProperty(ra, "__esModule", { value: !0 }), ra.default = r;
  var n = e(GV());
  function r(i, a) {
    var o = null;
    if (!i || typeof i != "string")
      return o;
    var s = (0, n.default)(i), l = typeof a == "function";
    return s.forEach(function(c) {
      if (c.type === "declaration") {
        var m = c.property, u = c.value;
        l ? a(m, u, c) : u && (o = o || {}, o[m] = u);
      }
    }), o;
  }
  return ra;
}
var JV = YV();
const jx = /* @__PURE__ */ Ty(JV), QV = jx.default || jx, f1 = h1("end"), kg = h1("start");
function h1(e) {
  return n;
  function n(r) {
    const i = r && r.position && r.position[e] || {};
    if (typeof i.line == "number" && i.line > 0 && typeof i.column == "number" && i.column > 0)
      return {
        line: i.line,
        column: i.column,
        offset: typeof i.offset == "number" && i.offset > -1 ? i.offset : void 0
      };
  }
}
function XV(e) {
  const n = kg(e), r = f1(e);
  if (n && r)
    return { start: n, end: r };
}
function Ro(e) {
  return !e || typeof e != "object" ? "" : "position" in e || "type" in e ? wx(e.position) : "start" in e || "end" in e ? wx(e) : "line" in e || "column" in e ? ly(e) : "";
}
function ly(e) {
  return Cx(e && e.line) + ":" + Cx(e && e.column);
}
function wx(e) {
  return ly(e && e.start) + "-" + ly(e && e.end);
}
function Cx(e) {
  return e && typeof e == "number" ? e : 1;
}
class Bt extends Error {
  /**
   * Create a message for `reason`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {Options | null | undefined} [options]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | Options | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */
  // eslint-disable-next-line complexity
  constructor(n, r, i) {
    super(), typeof r == "string" && (i = r, r = void 0);
    let a = "", o = {}, s = !1;
    if (r && ("line" in r && "column" in r ? o = { place: r } : "start" in r && "end" in r ? o = { place: r } : "type" in r ? o = {
      ancestors: [r],
      place: r.position
    } : o = { ...r }), typeof n == "string" ? a = n : !o.cause && n && (s = !0, a = n.message, o.cause = n), !o.ruleId && !o.source && typeof i == "string") {
      const c = i.indexOf(":");
      c === -1 ? o.ruleId = i : (o.source = i.slice(0, c), o.ruleId = i.slice(c + 1));
    }
    if (!o.place && o.ancestors && o.ancestors) {
      const c = o.ancestors[o.ancestors.length - 1];
      c && (o.place = c.position);
    }
    const l = o.place && "start" in o.place ? o.place.start : o.place;
    this.ancestors = o.ancestors || void 0, this.cause = o.cause || void 0, this.column = l ? l.column : void 0, this.fatal = void 0, this.file, this.message = a, this.line = l ? l.line : void 0, this.name = Ro(o.place) || "1:1", this.place = o.place || void 0, this.reason = this.message, this.ruleId = o.ruleId || void 0, this.source = o.source || void 0, this.stack = s && o.cause && typeof o.cause.stack == "string" ? o.cause.stack : "", this.actual, this.expected, this.note, this.url;
  }
}
Bt.prototype.file = "";
Bt.prototype.name = "";
Bt.prototype.reason = "";
Bt.prototype.message = "";
Bt.prototype.stack = "";
Bt.prototype.column = void 0;
Bt.prototype.line = void 0;
Bt.prototype.ancestors = void 0;
Bt.prototype.cause = void 0;
Bt.prototype.fatal = void 0;
Bt.prototype.place = void 0;
Bt.prototype.ruleId = void 0;
Bt.prototype.source = void 0;
const bg = {}.hasOwnProperty, ZV = /* @__PURE__ */ new Map(), e3 = /[A-Z]/g, n3 = /-([a-z])/g, t3 = /* @__PURE__ */ new Set(["table", "tbody", "thead", "tfoot", "tr"]), r3 = /* @__PURE__ */ new Set(["td", "th"]), y1 = "https://github.com/syntax-tree/hast-util-to-jsx-runtime";
function i3(e, n) {
  if (!n || n.Fragment === void 0)
    throw new TypeError("Expected `Fragment` in options");
  const r = n.filePath || void 0;
  let i;
  if (n.development) {
    if (typeof n.jsxDEV != "function")
      throw new TypeError(
        "Expected `jsxDEV` in options when `development: true`"
      );
    i = m3(r, n.jsxDEV);
  } else {
    if (typeof n.jsx != "function")
      throw new TypeError("Expected `jsx` in production options");
    if (typeof n.jsxs != "function")
      throw new TypeError("Expected `jsxs` in production options");
    i = u3(r, n.jsx, n.jsxs);
  }
  const a = {
    Fragment: n.Fragment,
    ancestors: [],
    components: n.components || {},
    create: i,
    elementAttributeNameCase: n.elementAttributeNameCase || "react",
    evaluater: n.createEvaluater ? n.createEvaluater() : void 0,
    filePath: r,
    ignoreInvalidStyle: n.ignoreInvalidStyle || !1,
    passKeys: n.passKeys !== !1,
    passNode: n.passNode || !1,
    schema: n.space === "svg" ? vg : WV,
    stylePropertyNameCase: n.stylePropertyNameCase || "dom",
    tableCellAlignToStyle: n.tableCellAlignToStyle !== !1
  }, o = g1(a, e, void 0);
  return o && typeof o != "string" ? o : a.create(
    e,
    a.Fragment,
    { children: o || void 0 },
    void 0
  );
}
function g1(e, n, r) {
  if (n.type === "element")
    return a3(e, n, r);
  if (n.type === "mdxFlowExpression" || n.type === "mdxTextExpression")
    return o3(e, n);
  if (n.type === "mdxJsxFlowElement" || n.type === "mdxJsxTextElement")
    return l3(e, n, r);
  if (n.type === "mdxjsEsm")
    return s3(e, n);
  if (n.type === "root")
    return d3(e, n, r);
  if (n.type === "text")
    return c3(e, n);
}
function a3(e, n, r) {
  const i = e.schema;
  let a = i;
  n.tagName.toLowerCase() === "svg" && i.space === "html" && (a = vg, e.schema = a), e.ancestors.push(n);
  const o = k1(e, n.tagName, !1), s = p3(e, n);
  let l = xg(e, n);
  return t3.has(n.tagName) && (l = l.filter(function(c) {
    return typeof c == "string" ? !OV(c) : !0;
  })), v1(e, s, o, n), _g(s, l), e.ancestors.pop(), e.schema = i, e.create(n, o, s, r);
}
function o3(e, n) {
  if (n.data && n.data.estree && e.evaluater) {
    const i = n.data.estree.body[0];
    return i.type, /** @type {Child | undefined} */
    e.evaluater.evaluateExpression(i.expression);
  }
  Wo(e, n.position);
}
function s3(e, n) {
  if (n.data && n.data.estree && e.evaluater)
    return (
      /** @type {Child | undefined} */
      e.evaluater.evaluateProgram(n.data.estree)
    );
  Wo(e, n.position);
}
function l3(e, n, r) {
  const i = e.schema;
  let a = i;
  n.name === "svg" && i.space === "html" && (a = vg, e.schema = a), e.ancestors.push(n);
  const o = n.name === null ? e.Fragment : k1(e, n.name, !0), s = f3(e, n), l = xg(e, n);
  return v1(e, s, o, n), _g(s, l), e.ancestors.pop(), e.schema = i, e.create(n, o, s, r);
}
function d3(e, n, r) {
  const i = {};
  return _g(i, xg(e, n)), e.create(n, e.Fragment, i, r);
}
function c3(e, n) {
  return n.value;
}
function v1(e, n, r, i) {
  typeof r != "string" && r !== e.Fragment && e.passNode && (n.node = i);
}
function _g(e, n) {
  if (n.length > 0) {
    const r = n.length > 1 ? n : n[0];
    r && (e.children = r);
  }
}
function u3(e, n, r) {
  return i;
  function i(a, o, s, l) {
    const m = Array.isArray(s.children) ? r : n;
    return l ? m(o, s, l) : m(o, s);
  }
}
function m3(e, n) {
  return r;
  function r(i, a, o, s) {
    const l = Array.isArray(o.children), c = kg(i);
    return n(
      a,
      o,
      s,
      l,
      {
        columnNumber: c ? c.column - 1 : void 0,
        fileName: e,
        lineNumber: c ? c.line : void 0
      },
      void 0
    );
  }
}
function p3(e, n) {
  const r = {};
  let i, a;
  for (a in n.properties)
    if (a !== "children" && bg.call(n.properties, a)) {
      const o = h3(e, a, n.properties[a]);
      if (o) {
        const [s, l] = o;
        e.tableCellAlignToStyle && s === "align" && typeof l == "string" && r3.has(n.tagName) ? i = l : r[s] = l;
      }
    }
  if (i) {
    const o = (
      /** @type {Style} */
      r.style || (r.style = {})
    );
    o[e.stylePropertyNameCase === "css" ? "text-align" : "textAlign"] = i;
  }
  return r;
}
function f3(e, n) {
  const r = {};
  for (const i of n.attributes)
    if (i.type === "mdxJsxExpressionAttribute")
      if (i.data && i.data.estree && e.evaluater) {
        const o = i.data.estree.body[0];
        o.type;
        const s = o.expression;
        s.type;
        const l = s.properties[0];
        l.type, Object.assign(
          r,
          e.evaluater.evaluateExpression(l.argument)
        );
      } else
        Wo(e, n.position);
    else {
      const a = i.name;
      let o;
      if (i.value && typeof i.value == "object")
        if (i.value.data && i.value.data.estree && e.evaluater) {
          const l = i.value.data.estree.body[0];
          l.type, o = e.evaluater.evaluateExpression(l.expression);
        } else
          Wo(e, n.position);
      else
        o = i.value === null ? !0 : i.value;
      r[a] = /** @type {Props[keyof Props]} */
      o;
    }
  return r;
}
function xg(e, n) {
  const r = [];
  let i = -1;
  const a = e.passKeys ? /* @__PURE__ */ new Map() : ZV;
  for (; ++i < n.children.length; ) {
    const o = n.children[i];
    let s;
    if (e.passKeys) {
      const c = o.type === "element" ? o.tagName : o.type === "mdxJsxFlowElement" || o.type === "mdxJsxTextElement" ? o.name : void 0;
      if (c) {
        const m = a.get(c) || 0;
        s = c + "-" + m, a.set(c, m + 1);
      }
    }
    const l = g1(e, o, s);
    l !== void 0 && r.push(l);
  }
  return r;
}
function h3(e, n, r) {
  const i = MV(e.schema, n);
  if (!(r == null || typeof r == "number" && Number.isNaN(r))) {
    if (Array.isArray(r) && (r = i.commaSeparated ? $V(r) : KV(r)), i.property === "style") {
      let a = typeof r == "object" ? r : y3(e, String(r));
      return e.stylePropertyNameCase === "css" && (a = g3(a)), ["style", a];
    }
    return [
      e.elementAttributeNameCase === "react" && i.space ? HV[i.property] || i.property : i.attribute,
      r
    ];
  }
}
function y3(e, n) {
  const r = {};
  try {
    QV(n, i);
  } catch (a) {
    if (!e.ignoreInvalidStyle) {
      const o = (
        /** @type {Error} */
        a
      ), s = new Bt("Cannot parse `style` attribute", {
        ancestors: e.ancestors,
        cause: o,
        ruleId: "style",
        source: "hast-util-to-jsx-runtime"
      });
      throw s.file = e.filePath || void 0, s.url = y1 + "#cannot-parse-style-attribute", s;
    }
  }
  return r;
  function i(a, o) {
    let s = a;
    s.slice(0, 2) !== "--" && (s.slice(0, 4) === "-ms-" && (s = "ms-" + s.slice(4)), s = s.replace(n3, k3)), r[s] = o;
  }
}
function k1(e, n, r) {
  let i;
  if (!r)
    i = { type: "Literal", value: n };
  else if (n.includes(".")) {
    const a = n.split(".");
    let o = -1, s;
    for (; ++o < a.length; ) {
      const l = kx(a[o]) ? { type: "Identifier", name: a[o] } : { type: "Literal", value: a[o] };
      s = s ? {
        type: "MemberExpression",
        object: s,
        property: l,
        computed: !!(o && l.type === "Literal"),
        optional: !1
      } : l;
    }
    i = s;
  } else
    i = kx(n) && !/^[a-z]/.test(n) ? { type: "Identifier", name: n } : { type: "Literal", value: n };
  if (i.type === "Literal") {
    const a = (
      /** @type {keyof JSX.IntrinsicElements} */
      i.value
    );
    return bg.call(e.components, a) ? e.components[a] : a;
  }
  if (e.evaluater)
    return e.evaluater.evaluateExpression(i);
  Wo(e);
}
function Wo(e, n) {
  const r = new Bt(
    "Cannot handle MDX estrees without `createEvaluater`",
    {
      ancestors: e.ancestors,
      place: n,
      ruleId: "mdx-estree",
      source: "hast-util-to-jsx-runtime"
    }
  );
  throw r.file = e.filePath || void 0, r.url = y1 + "#cannot-handle-mdx-estrees-without-createevaluater", r;
}
function g3(e) {
  const n = {};
  let r;
  for (r in e)
    bg.call(e, r) && (n[v3(r)] = e[r]);
  return n;
}
function v3(e) {
  let n = e.replace(e3, b3);
  return n.slice(0, 3) === "ms-" && (n = "-" + n), n;
}
function k3(e, n) {
  return n.toUpperCase();
}
function b3(e) {
  return "-" + e.toLowerCase();
}
const Nm = {
  action: ["form"],
  cite: ["blockquote", "del", "ins", "q"],
  data: ["object"],
  formAction: ["button", "input"],
  href: ["a", "area", "base", "link"],
  icon: ["menuitem"],
  itemId: null,
  manifest: ["html"],
  ping: ["a", "area"],
  poster: ["video"],
  src: [
    "audio",
    "embed",
    "iframe",
    "img",
    "input",
    "script",
    "source",
    "track",
    "video"
  ]
}, _3 = {};
function x3(e, n) {
  const r = _3, i = typeof r.includeImageAlt == "boolean" ? r.includeImageAlt : !0, a = typeof r.includeHtml == "boolean" ? r.includeHtml : !0;
  return b1(e, i, a);
}
function b1(e, n, r) {
  if (S3(e)) {
    if ("value" in e)
      return e.type === "html" && !r ? "" : e.value;
    if (n && "alt" in e && e.alt)
      return e.alt;
    if ("children" in e)
      return Fx(e.children, n, r);
  }
  return Array.isArray(e) ? Fx(e, n, r) : "";
}
function Fx(e, n, r) {
  const i = [];
  let a = -1;
  for (; ++a < e.length; )
    i[a] = b1(e[a], n, r);
  return i.join("");
}
function S3(e) {
  return !!(e && typeof e == "object");
}
const Ix = document.createElement("i");
function Sg(e) {
  const n = "&" + e + ";";
  Ix.innerHTML = n;
  const r = Ix.textContent;
  return r.charCodeAt(r.length - 1) === 59 && e !== "semi" || r === n ? !1 : r;
}
function Kr(e, n, r, i) {
  const a = e.length;
  let o = 0, s;
  if (n < 0 ? n = -n > a ? 0 : a + n : n = n > a ? a : n, r = r > 0 ? r : 0, i.length < 1e4)
    s = Array.from(i), s.unshift(n, r), e.splice(...s);
  else
    for (r && e.splice(n, r); o < i.length; )
      s = i.slice(o, o + 1e4), s.unshift(n, 0), e.splice(...s), o += 1e4, n += 1e4;
}
function _r(e, n) {
  return e.length > 0 ? (Kr(e, e.length, 0, n), e) : n;
}
const $x = {}.hasOwnProperty;
function N3(e) {
  const n = {};
  let r = -1;
  for (; ++r < e.length; )
    j3(n, e[r]);
  return n;
}
function j3(e, n) {
  let r;
  for (r in n) {
    const a = ($x.call(e, r) ? e[r] : void 0) || (e[r] = {}), o = n[r];
    let s;
    if (o)
      for (s in o) {
        $x.call(a, s) || (a[s] = []);
        const l = o[s];
        w3(
          // @ts-expect-error Looks like a list.
          a[s],
          Array.isArray(l) ? l : l ? [l] : []
        );
      }
  }
}
function w3(e, n) {
  let r = -1;
  const i = [];
  for (; ++r < n.length; )
    (n[r].add === "after" ? e : i).push(n[r]);
  Kr(e, 0, 0, i);
}
function _1(e, n) {
  const r = Number.parseInt(e, n);
  return (
    // C0 except for HT, LF, FF, CR, space.
    r < 9 || r === 11 || r > 13 && r < 32 || // Control character (DEL) of C0, and C1 controls.
    r > 126 && r < 160 || // Lone high surrogates and low surrogates.
    r > 55295 && r < 57344 || // Noncharacters.
    r > 64975 && r < 65008 || /* eslint-disable no-bitwise */
    (r & 65535) === 65535 || (r & 65535) === 65534 || /* eslint-enable no-bitwise */
    // Out of range
    r > 1114111 ? "�" : String.fromCodePoint(r)
  );
}
function va(e) {
  return e.replace(/[\t\n\r ]+/g, " ").replace(/^ | $/g, "").toLowerCase().toUpperCase();
}
const Ur = _i(/[A-Za-z]/), dr = _i(/[\dA-Za-z]/), C3 = _i(/[#-'*+\--9=?A-Z^-~]/);
function dy(e) {
  return (
    // Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    e !== null && (e < 32 || e === 127)
  );
}
const cy = _i(/\d/), F3 = _i(/[\dA-Fa-f]/), I3 = _i(/[!-/:-@[-`{-~]/);
function In(e) {
  return e !== null && e < -2;
}
function tr(e) {
  return e !== null && (e < 0 || e === 32);
}
function Yn(e) {
  return e === -2 || e === -1 || e === 32;
}
const $3 = _i(new RegExp("\\p{P}|\\p{S}", "u")), E3 = _i(/\s/);
function _i(e) {
  return n;
  function n(r) {
    return r !== null && r > -1 && e.test(String.fromCharCode(r));
  }
}
function Pa(e) {
  const n = [];
  let r = -1, i = 0, a = 0;
  for (; ++r < e.length; ) {
    const o = e.charCodeAt(r);
    let s = "";
    if (o === 37 && dr(e.charCodeAt(r + 1)) && dr(e.charCodeAt(r + 2)))
      a = 2;
    else if (o < 128)
      /[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(o)) || (s = String.fromCharCode(o));
    else if (o > 55295 && o < 57344) {
      const l = e.charCodeAt(r + 1);
      o < 56320 && l > 56319 && l < 57344 ? (s = String.fromCharCode(o, l), a = 1) : s = "�";
    } else
      s = String.fromCharCode(o);
    s && (n.push(e.slice(i, r), encodeURIComponent(s)), i = r + a + 1, s = ""), a && (r += a, a = 0);
  }
  return n.join("") + e.slice(i);
}
function dt(e, n, r, i) {
  const a = i ? i - 1 : Number.POSITIVE_INFINITY;
  let o = 0;
  return s;
  function s(c) {
    return Yn(c) ? (e.enter(r), l(c)) : n(c);
  }
  function l(c) {
    return Yn(c) && o++ < a ? (e.consume(c), l) : (e.exit(r), n(c));
  }
}
const T3 = {
  tokenize: R3
};
function R3(e) {
  const n = e.attempt(this.parser.constructs.contentInitial, i, a);
  let r;
  return n;
  function i(l) {
    if (l === null) {
      e.consume(l);
      return;
    }
    return e.enter("lineEnding"), e.consume(l), e.exit("lineEnding"), dt(e, n, "linePrefix");
  }
  function a(l) {
    return e.enter("paragraph"), o(l);
  }
  function o(l) {
    const c = e.enter("chunkText", {
      contentType: "text",
      previous: r
    });
    return r && (r.next = c), r = c, s(l);
  }
  function s(l) {
    if (l === null) {
      e.exit("chunkText"), e.exit("paragraph"), e.consume(l);
      return;
    }
    return In(l) ? (e.consume(l), e.exit("chunkText"), o) : (e.consume(l), s);
  }
}
const D3 = {
  tokenize: O3
}, Ex = {
  tokenize: P3
};
function O3(e) {
  const n = this, r = [];
  let i = 0, a, o, s;
  return l;
  function l(O) {
    if (i < r.length) {
      const R = r[i];
      return n.containerState = R[1], e.attempt(R[0].continuation, c, m)(O);
    }
    return m(O);
  }
  function c(O) {
    if (i++, n.containerState._closeFlow) {
      n.containerState._closeFlow = void 0, a && g();
      const R = n.events.length;
      let F = R, I;
      for (; F--; )
        if (n.events[F][0] === "exit" && n.events[F][1].type === "chunkFlow") {
          I = n.events[F][1].end;
          break;
        }
      _(i);
      let L = R;
      for (; L < n.events.length; )
        n.events[L][1].end = {
          ...I
        }, L++;
      return Kr(n.events, F + 1, 0, n.events.slice(R)), n.events.length = L, m(O);
    }
    return l(O);
  }
  function m(O) {
    if (i === r.length) {
      if (!a)
        return h(O);
      if (a.currentConstruct && a.currentConstruct.concrete)
        return w(O);
      n.interrupt = !!(a.currentConstruct && !a._gfmTableDynamicInterruptHack);
    }
    return n.containerState = {}, e.check(Ex, u, f)(O);
  }
  function u(O) {
    return a && g(), _(i), h(O);
  }
  function f(O) {
    return n.parser.lazy[n.now().line] = i !== r.length, s = n.now().offset, w(O);
  }
  function h(O) {
    return n.containerState = {}, e.attempt(Ex, k, w)(O);
  }
  function k(O) {
    return i++, r.push([n.currentConstruct, n.containerState]), h(O);
  }
  function w(O) {
    if (O === null) {
      a && g(), _(0), e.consume(O);
      return;
    }
    return a = a || n.parser.flow(n.now()), e.enter("chunkFlow", {
      _tokenizer: a,
      contentType: "flow",
      previous: o
    }), N(O);
  }
  function N(O) {
    if (O === null) {
      j(e.exit("chunkFlow"), !0), _(0), e.consume(O);
      return;
    }
    return In(O) ? (e.consume(O), j(e.exit("chunkFlow")), i = 0, n.interrupt = void 0, l) : (e.consume(O), N);
  }
  function j(O, R) {
    const F = n.sliceStream(O);
    if (R && F.push(null), O.previous = o, o && (o.next = O), o = O, a.defineSkip(O.start), a.write(F), n.parser.lazy[O.start.line]) {
      let I = a.events.length;
      for (; I--; )
        if (
          // The token starts before the line ending…
          a.events[I][1].start.offset < s && // …and either is not ended yet…
          (!a.events[I][1].end || // …or ends after it.
          a.events[I][1].end.offset > s)
        )
          return;
      const L = n.events.length;
      let W = L, J, re;
      for (; W--; )
        if (n.events[W][0] === "exit" && n.events[W][1].type === "chunkFlow") {
          if (J) {
            re = n.events[W][1].end;
            break;
          }
          J = !0;
        }
      for (_(i), I = L; I < n.events.length; )
        n.events[I][1].end = {
          ...re
        }, I++;
      Kr(n.events, W + 1, 0, n.events.slice(L)), n.events.length = I;
    }
  }
  function _(O) {
    let R = r.length;
    for (; R-- > O; ) {
      const F = r[R];
      n.containerState = F[1], F[0].exit.call(n, e);
    }
    r.length = O;
  }
  function g() {
    a.write([null]), o = void 0, a = void 0, n.containerState._closeFlow = void 0;
  }
}
function P3(e, n, r) {
  return dt(e, e.attempt(this.parser.constructs.document, n, r), "linePrefix", this.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4);
}
function Tx(e) {
  if (e === null || tr(e) || E3(e))
    return 1;
  if ($3(e))
    return 2;
}
function Ng(e, n, r) {
  const i = [];
  let a = -1;
  for (; ++a < e.length; ) {
    const o = e[a].resolveAll;
    o && !i.includes(o) && (n = o(n, r), i.push(o));
  }
  return n;
}
const uy = {
  name: "attention",
  resolveAll: A3,
  tokenize: L3
};
function A3(e, n) {
  let r = -1, i, a, o, s, l, c, m, u;
  for (; ++r < e.length; )
    if (e[r][0] === "enter" && e[r][1].type === "attentionSequence" && e[r][1]._close) {
      for (i = r; i--; )
        if (e[i][0] === "exit" && e[i][1].type === "attentionSequence" && e[i][1]._open && // If the markers are the same:
        n.sliceSerialize(e[i][1]).charCodeAt(0) === n.sliceSerialize(e[r][1]).charCodeAt(0)) {
          if ((e[i][1]._close || e[r][1]._open) && (e[r][1].end.offset - e[r][1].start.offset) % 3 && !((e[i][1].end.offset - e[i][1].start.offset + e[r][1].end.offset - e[r][1].start.offset) % 3))
            continue;
          c = e[i][1].end.offset - e[i][1].start.offset > 1 && e[r][1].end.offset - e[r][1].start.offset > 1 ? 2 : 1;
          const f = {
            ...e[i][1].end
          }, h = {
            ...e[r][1].start
          };
          Rx(f, -c), Rx(h, c), s = {
            type: c > 1 ? "strongSequence" : "emphasisSequence",
            start: f,
            end: {
              ...e[i][1].end
            }
          }, l = {
            type: c > 1 ? "strongSequence" : "emphasisSequence",
            start: {
              ...e[r][1].start
            },
            end: h
          }, o = {
            type: c > 1 ? "strongText" : "emphasisText",
            start: {
              ...e[i][1].end
            },
            end: {
              ...e[r][1].start
            }
          }, a = {
            type: c > 1 ? "strong" : "emphasis",
            start: {
              ...s.start
            },
            end: {
              ...l.end
            }
          }, e[i][1].end = {
            ...s.start
          }, e[r][1].start = {
            ...l.end
          }, m = [], e[i][1].end.offset - e[i][1].start.offset && (m = _r(m, [["enter", e[i][1], n], ["exit", e[i][1], n]])), m = _r(m, [["enter", a, n], ["enter", s, n], ["exit", s, n], ["enter", o, n]]), m = _r(m, Ng(n.parser.constructs.insideSpan.null, e.slice(i + 1, r), n)), m = _r(m, [["exit", o, n], ["enter", l, n], ["exit", l, n], ["exit", a, n]]), e[r][1].end.offset - e[r][1].start.offset ? (u = 2, m = _r(m, [["enter", e[r][1], n], ["exit", e[r][1], n]])) : u = 0, Kr(e, i - 1, r - i + 3, m), r = i + m.length - u - 2;
          break;
        }
    }
  for (r = -1; ++r < e.length; )
    e[r][1].type === "attentionSequence" && (e[r][1].type = "data");
  return e;
}
function L3(e, n) {
  const r = this.parser.constructs.attentionMarkers.null, i = this.previous, a = Tx(i);
  let o;
  return s;
  function s(c) {
    return o = c, e.enter("attentionSequence"), l(c);
  }
  function l(c) {
    if (c === o)
      return e.consume(c), l;
    const m = e.exit("attentionSequence"), u = Tx(c), f = !u || u === 2 && a || r.includes(c), h = !a || a === 2 && u || r.includes(i);
    return m._open = !!(o === 42 ? f : f && (a || !h)), m._close = !!(o === 42 ? h : h && (u || !f)), n(c);
  }
}
function Rx(e, n) {
  e.column += n, e.offset += n, e._bufferIndex += n;
}
const V3 = {
  name: "autolink",
  tokenize: z3
};
function z3(e, n, r) {
  let i = 0;
  return a;
  function a(k) {
    return e.enter("autolink"), e.enter("autolinkMarker"), e.consume(k), e.exit("autolinkMarker"), e.enter("autolinkProtocol"), o;
  }
  function o(k) {
    return Ur(k) ? (e.consume(k), s) : k === 64 ? r(k) : m(k);
  }
  function s(k) {
    return k === 43 || k === 45 || k === 46 || dr(k) ? (i = 1, l(k)) : m(k);
  }
  function l(k) {
    return k === 58 ? (e.consume(k), i = 0, c) : (k === 43 || k === 45 || k === 46 || dr(k)) && i++ < 32 ? (e.consume(k), l) : (i = 0, m(k));
  }
  function c(k) {
    return k === 62 ? (e.exit("autolinkProtocol"), e.enter("autolinkMarker"), e.consume(k), e.exit("autolinkMarker"), e.exit("autolink"), n) : k === null || k === 32 || k === 60 || dy(k) ? r(k) : (e.consume(k), c);
  }
  function m(k) {
    return k === 64 ? (e.consume(k), u) : C3(k) ? (e.consume(k), m) : r(k);
  }
  function u(k) {
    return dr(k) ? f(k) : r(k);
  }
  function f(k) {
    return k === 46 ? (e.consume(k), i = 0, u) : k === 62 ? (e.exit("autolinkProtocol").type = "autolinkEmail", e.enter("autolinkMarker"), e.consume(k), e.exit("autolinkMarker"), e.exit("autolink"), n) : h(k);
  }
  function h(k) {
    if ((k === 45 || dr(k)) && i++ < 63) {
      const w = k === 45 ? h : f;
      return e.consume(k), w;
    }
    return r(k);
  }
}
const ad = {
  partial: !0,
  tokenize: U3
};
function U3(e, n, r) {
  return i;
  function i(o) {
    return Yn(o) ? dt(e, a, "linePrefix")(o) : a(o);
  }
  function a(o) {
    return o === null || In(o) ? n(o) : r(o);
  }
}
const x1 = {
  continuation: {
    tokenize: B3
  },
  exit: q3,
  name: "blockQuote",
  tokenize: M3
};
function M3(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    if (s === 62) {
      const l = i.containerState;
      return l.open || (e.enter("blockQuote", {
        _container: !0
      }), l.open = !0), e.enter("blockQuotePrefix"), e.enter("blockQuoteMarker"), e.consume(s), e.exit("blockQuoteMarker"), o;
    }
    return r(s);
  }
  function o(s) {
    return Yn(s) ? (e.enter("blockQuotePrefixWhitespace"), e.consume(s), e.exit("blockQuotePrefixWhitespace"), e.exit("blockQuotePrefix"), n) : (e.exit("blockQuotePrefix"), n(s));
  }
}
function B3(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return Yn(s) ? dt(e, o, "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(s) : o(s);
  }
  function o(s) {
    return e.attempt(x1, n, r)(s);
  }
}
function q3(e) {
  e.exit("blockQuote");
}
const S1 = {
  name: "characterEscape",
  tokenize: H3
};
function H3(e, n, r) {
  return i;
  function i(o) {
    return e.enter("characterEscape"), e.enter("escapeMarker"), e.consume(o), e.exit("escapeMarker"), a;
  }
  function a(o) {
    return I3(o) ? (e.enter("characterEscapeValue"), e.consume(o), e.exit("characterEscapeValue"), e.exit("characterEscape"), n) : r(o);
  }
}
const N1 = {
  name: "characterReference",
  tokenize: W3
};
function W3(e, n, r) {
  const i = this;
  let a = 0, o, s;
  return l;
  function l(f) {
    return e.enter("characterReference"), e.enter("characterReferenceMarker"), e.consume(f), e.exit("characterReferenceMarker"), c;
  }
  function c(f) {
    return f === 35 ? (e.enter("characterReferenceMarkerNumeric"), e.consume(f), e.exit("characterReferenceMarkerNumeric"), m) : (e.enter("characterReferenceValue"), o = 31, s = dr, u(f));
  }
  function m(f) {
    return f === 88 || f === 120 ? (e.enter("characterReferenceMarkerHexadecimal"), e.consume(f), e.exit("characterReferenceMarkerHexadecimal"), e.enter("characterReferenceValue"), o = 6, s = F3, u) : (e.enter("characterReferenceValue"), o = 7, s = cy, u(f));
  }
  function u(f) {
    if (f === 59 && a) {
      const h = e.exit("characterReferenceValue");
      return s === dr && !Sg(i.sliceSerialize(h)) ? r(f) : (e.enter("characterReferenceMarker"), e.consume(f), e.exit("characterReferenceMarker"), e.exit("characterReference"), n);
    }
    return s(f) && a++ < o ? (e.consume(f), u) : r(f);
  }
}
const Dx = {
  partial: !0,
  tokenize: G3
}, Ox = {
  concrete: !0,
  name: "codeFenced",
  tokenize: K3
};
function K3(e, n, r) {
  const i = this, a = {
    partial: !0,
    tokenize: F
  };
  let o = 0, s = 0, l;
  return c;
  function c(I) {
    return m(I);
  }
  function m(I) {
    const L = i.events[i.events.length - 1];
    return o = L && L[1].type === "linePrefix" ? L[2].sliceSerialize(L[1], !0).length : 0, l = I, e.enter("codeFenced"), e.enter("codeFencedFence"), e.enter("codeFencedFenceSequence"), u(I);
  }
  function u(I) {
    return I === l ? (s++, e.consume(I), u) : s < 3 ? r(I) : (e.exit("codeFencedFenceSequence"), Yn(I) ? dt(e, f, "whitespace")(I) : f(I));
  }
  function f(I) {
    return I === null || In(I) ? (e.exit("codeFencedFence"), i.interrupt ? n(I) : e.check(Dx, N, R)(I)) : (e.enter("codeFencedFenceInfo"), e.enter("chunkString", {
      contentType: "string"
    }), h(I));
  }
  function h(I) {
    return I === null || In(I) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), f(I)) : Yn(I) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), dt(e, k, "whitespace")(I)) : I === 96 && I === l ? r(I) : (e.consume(I), h);
  }
  function k(I) {
    return I === null || In(I) ? f(I) : (e.enter("codeFencedFenceMeta"), e.enter("chunkString", {
      contentType: "string"
    }), w(I));
  }
  function w(I) {
    return I === null || In(I) ? (e.exit("chunkString"), e.exit("codeFencedFenceMeta"), f(I)) : I === 96 && I === l ? r(I) : (e.consume(I), w);
  }
  function N(I) {
    return e.attempt(a, R, j)(I);
  }
  function j(I) {
    return e.enter("lineEnding"), e.consume(I), e.exit("lineEnding"), _;
  }
  function _(I) {
    return o > 0 && Yn(I) ? dt(e, g, "linePrefix", o + 1)(I) : g(I);
  }
  function g(I) {
    return I === null || In(I) ? e.check(Dx, N, R)(I) : (e.enter("codeFlowValue"), O(I));
  }
  function O(I) {
    return I === null || In(I) ? (e.exit("codeFlowValue"), g(I)) : (e.consume(I), O);
  }
  function R(I) {
    return e.exit("codeFenced"), n(I);
  }
  function F(I, L, W) {
    let J = 0;
    return re;
    function re(ie) {
      return I.enter("lineEnding"), I.consume(ie), I.exit("lineEnding"), K;
    }
    function K(ie) {
      return I.enter("codeFencedFence"), Yn(ie) ? dt(I, Y, "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(ie) : Y(ie);
    }
    function Y(ie) {
      return ie === l ? (I.enter("codeFencedFenceSequence"), P(ie)) : W(ie);
    }
    function P(ie) {
      return ie === l ? (J++, I.consume(ie), P) : J >= s ? (I.exit("codeFencedFenceSequence"), Yn(ie) ? dt(I, B, "whitespace")(ie) : B(ie)) : W(ie);
    }
    function B(ie) {
      return ie === null || In(ie) ? (I.exit("codeFencedFence"), L(ie)) : W(ie);
    }
  }
}
function G3(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return s === null ? r(s) : (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), o);
  }
  function o(s) {
    return i.parser.lazy[i.now().line] ? r(s) : n(s);
  }
}
const jm = {
  name: "codeIndented",
  tokenize: J3
}, Y3 = {
  partial: !0,
  tokenize: Q3
};
function J3(e, n, r) {
  const i = this;
  return a;
  function a(m) {
    return e.enter("codeIndented"), dt(e, o, "linePrefix", 5)(m);
  }
  function o(m) {
    const u = i.events[i.events.length - 1];
    return u && u[1].type === "linePrefix" && u[2].sliceSerialize(u[1], !0).length >= 4 ? s(m) : r(m);
  }
  function s(m) {
    return m === null ? c(m) : In(m) ? e.attempt(Y3, s, c)(m) : (e.enter("codeFlowValue"), l(m));
  }
  function l(m) {
    return m === null || In(m) ? (e.exit("codeFlowValue"), s(m)) : (e.consume(m), l);
  }
  function c(m) {
    return e.exit("codeIndented"), n(m);
  }
}
function Q3(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return i.parser.lazy[i.now().line] ? r(s) : In(s) ? (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), a) : dt(e, o, "linePrefix", 5)(s);
  }
  function o(s) {
    const l = i.events[i.events.length - 1];
    return l && l[1].type === "linePrefix" && l[2].sliceSerialize(l[1], !0).length >= 4 ? n(s) : In(s) ? a(s) : r(s);
  }
}
const X3 = {
  name: "codeText",
  previous: ez,
  resolve: Z3,
  tokenize: nz
};
function Z3(e) {
  let n = e.length - 4, r = 3, i, a;
  if ((e[r][1].type === "lineEnding" || e[r][1].type === "space") && (e[n][1].type === "lineEnding" || e[n][1].type === "space")) {
    for (i = r; ++i < n; )
      if (e[i][1].type === "codeTextData") {
        e[r][1].type = "codeTextPadding", e[n][1].type = "codeTextPadding", r += 2, n -= 2;
        break;
      }
  }
  for (i = r - 1, n++; ++i <= n; )
    a === void 0 ? i !== n && e[i][1].type !== "lineEnding" && (a = i) : (i === n || e[i][1].type === "lineEnding") && (e[a][1].type = "codeTextData", i !== a + 2 && (e[a][1].end = e[i - 1][1].end, e.splice(a + 2, i - a - 2), n -= i - a - 2, i = a + 2), a = void 0);
  return e;
}
function ez(e) {
  return e !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function nz(e, n, r) {
  let i = 0, a, o;
  return s;
  function s(f) {
    return e.enter("codeText"), e.enter("codeTextSequence"), l(f);
  }
  function l(f) {
    return f === 96 ? (e.consume(f), i++, l) : (e.exit("codeTextSequence"), c(f));
  }
  function c(f) {
    return f === null ? r(f) : f === 32 ? (e.enter("space"), e.consume(f), e.exit("space"), c) : f === 96 ? (o = e.enter("codeTextSequence"), a = 0, u(f)) : In(f) ? (e.enter("lineEnding"), e.consume(f), e.exit("lineEnding"), c) : (e.enter("codeTextData"), m(f));
  }
  function m(f) {
    return f === null || f === 32 || f === 96 || In(f) ? (e.exit("codeTextData"), c(f)) : (e.consume(f), m);
  }
  function u(f) {
    return f === 96 ? (e.consume(f), a++, u) : a === i ? (e.exit("codeTextSequence"), e.exit("codeText"), n(f)) : (o.type = "codeTextData", m(f));
  }
}
class tz {
  /**
   * @param {ReadonlyArray<T> | null | undefined} [initial]
   *   Initial items (optional).
   * @returns
   *   Splice buffer.
   */
  constructor(n) {
    this.left = n ? [...n] : [], this.right = [];
  }
  /**
   * Array access;
   * does not move the cursor.
   *
   * @param {number} index
   *   Index.
   * @return {T}
   *   Item.
   */
  get(n) {
    if (n < 0 || n >= this.left.length + this.right.length)
      throw new RangeError("Cannot access index `" + n + "` in a splice buffer of size `" + (this.left.length + this.right.length) + "`");
    return n < this.left.length ? this.left[n] : this.right[this.right.length - n + this.left.length - 1];
  }
  /**
   * The length of the splice buffer, one greater than the largest index in the
   * array.
   */
  get length() {
    return this.left.length + this.right.length;
  }
  /**
   * Remove and return `list[0]`;
   * moves the cursor to `0`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  shift() {
    return this.setCursor(0), this.right.pop();
  }
  /**
   * Slice the buffer to get an array;
   * does not move the cursor.
   *
   * @param {number} start
   *   Start.
   * @param {number | null | undefined} [end]
   *   End (optional).
   * @returns {Array<T>}
   *   Array of items.
   */
  slice(n, r) {
    const i = r ?? Number.POSITIVE_INFINITY;
    return i < this.left.length ? this.left.slice(n, i) : n > this.left.length ? this.right.slice(this.right.length - i + this.left.length, this.right.length - n + this.left.length).reverse() : this.left.slice(n).concat(this.right.slice(this.right.length - i + this.left.length).reverse());
  }
  /**
   * Mimics the behavior of Array.prototype.splice() except for the change of
   * interface necessary to avoid segfaults when patching in very large arrays.
   *
   * This operation moves cursor is moved to `start` and results in the cursor
   * placed after any inserted items.
   *
   * @param {number} start
   *   Start;
   *   zero-based index at which to start changing the array;
   *   negative numbers count backwards from the end of the array and values
   *   that are out-of bounds are clamped to the appropriate end of the array.
   * @param {number | null | undefined} [deleteCount=0]
   *   Delete count (default: `0`);
   *   maximum number of elements to delete, starting from start.
   * @param {Array<T> | null | undefined} [items=[]]
   *   Items to include in place of the deleted items (default: `[]`).
   * @return {Array<T>}
   *   Any removed items.
   */
  splice(n, r, i) {
    const a = r || 0;
    this.setCursor(Math.trunc(n));
    const o = this.right.splice(this.right.length - a, Number.POSITIVE_INFINITY);
    return i && io(this.left, i), o.reverse();
  }
  /**
   * Remove and return the highest-numbered item in the array, so
   * `list[list.length - 1]`;
   * Moves the cursor to `length`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  pop() {
    return this.setCursor(Number.POSITIVE_INFINITY), this.left.pop();
  }
  /**
   * Inserts a single item to the high-numbered side of the array;
   * moves the cursor to `length`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  push(n) {
    this.setCursor(Number.POSITIVE_INFINITY), this.left.push(n);
  }
  /**
   * Inserts many items to the high-numbered side of the array.
   * Moves the cursor to `length`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  pushMany(n) {
    this.setCursor(Number.POSITIVE_INFINITY), io(this.left, n);
  }
  /**
   * Inserts a single item to the low-numbered side of the array;
   * Moves the cursor to `0`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  unshift(n) {
    this.setCursor(0), this.right.push(n);
  }
  /**
   * Inserts many items to the low-numbered side of the array;
   * moves the cursor to `0`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  unshiftMany(n) {
    this.setCursor(0), io(this.right, n.reverse());
  }
  /**
   * Move the cursor to a specific position in the array. Requires
   * time proportional to the distance moved.
   *
   * If `n < 0`, the cursor will end up at the beginning.
   * If `n > length`, the cursor will end up at the end.
   *
   * @param {number} n
   *   Position.
   * @return {undefined}
   *   Nothing.
   */
  setCursor(n) {
    if (!(n === this.left.length || n > this.left.length && this.right.length === 0 || n < 0 && this.left.length === 0))
      if (n < this.left.length) {
        const r = this.left.splice(n, Number.POSITIVE_INFINITY);
        io(this.right, r.reverse());
      } else {
        const r = this.right.splice(this.left.length + this.right.length - n, Number.POSITIVE_INFINITY);
        io(this.left, r.reverse());
      }
  }
}
function io(e, n) {
  let r = 0;
  if (n.length < 1e4)
    e.push(...n);
  else
    for (; r < n.length; )
      e.push(...n.slice(r, r + 1e4)), r += 1e4;
}
function j1(e) {
  const n = {};
  let r = -1, i, a, o, s, l, c, m;
  const u = new tz(e);
  for (; ++r < u.length; ) {
    for (; r in n; )
      r = n[r];
    if (i = u.get(r), r && i[1].type === "chunkFlow" && u.get(r - 1)[1].type === "listItemPrefix" && (c = i[1]._tokenizer.events, o = 0, o < c.length && c[o][1].type === "lineEndingBlank" && (o += 2), o < c.length && c[o][1].type === "content"))
      for (; ++o < c.length && c[o][1].type !== "content"; )
        c[o][1].type === "chunkText" && (c[o][1]._isInFirstContentOfListItem = !0, o++);
    if (i[0] === "enter")
      i[1].contentType && (Object.assign(n, rz(u, r)), r = n[r], m = !0);
    else if (i[1]._container) {
      for (o = r, a = void 0; o-- && (s = u.get(o), s[1].type === "lineEnding" || s[1].type === "lineEndingBlank"); )
        s[0] === "enter" && (a && (u.get(a)[1].type = "lineEndingBlank"), s[1].type = "lineEnding", a = o);
      a && (i[1].end = {
        ...u.get(a)[1].start
      }, l = u.slice(a, r), l.unshift(i), u.splice(a, r - a + 1, l));
    }
  }
  return Kr(e, 0, Number.POSITIVE_INFINITY, u.slice(0)), !m;
}
function rz(e, n) {
  const r = e.get(n)[1], i = e.get(n)[2];
  let a = n - 1;
  const o = [], s = r._tokenizer || i.parser[r.contentType](r.start), l = s.events, c = [], m = {};
  let u, f, h = -1, k = r, w = 0, N = 0;
  const j = [N];
  for (; k; ) {
    for (; e.get(++a)[1] !== k; )
      ;
    o.push(a), k._tokenizer || (u = i.sliceStream(k), k.next || u.push(null), f && s.defineSkip(k.start), k._isInFirstContentOfListItem && (s._gfmTasklistFirstContentOfListItem = !0), s.write(u), k._isInFirstContentOfListItem && (s._gfmTasklistFirstContentOfListItem = void 0)), f = k, k = k.next;
  }
  for (k = r; ++h < l.length; )
    // Find a void token that includes a break.
    l[h][0] === "exit" && l[h - 1][0] === "enter" && l[h][1].type === l[h - 1][1].type && l[h][1].start.line !== l[h][1].end.line && (N = h + 1, j.push(N), k._tokenizer = void 0, k.previous = void 0, k = k.next);
  for (s.events = [], k ? (k._tokenizer = void 0, k.previous = void 0) : j.pop(), h = j.length; h--; ) {
    const _ = l.slice(j[h], j[h + 1]), g = o.pop();
    c.push([g, g + _.length - 1]), e.splice(g, 2, _);
  }
  for (c.reverse(), h = -1; ++h < c.length; )
    m[w + c[h][0]] = w + c[h][1], w += c[h][1] - c[h][0] - 1;
  return m;
}
const iz = {
  resolve: oz,
  tokenize: sz
}, az = {
  partial: !0,
  tokenize: lz
};
function oz(e) {
  return j1(e), e;
}
function sz(e, n) {
  let r;
  return i;
  function i(l) {
    return e.enter("content"), r = e.enter("chunkContent", {
      contentType: "content"
    }), a(l);
  }
  function a(l) {
    return l === null ? o(l) : In(l) ? e.check(az, s, o)(l) : (e.consume(l), a);
  }
  function o(l) {
    return e.exit("chunkContent"), e.exit("content"), n(l);
  }
  function s(l) {
    return e.consume(l), e.exit("chunkContent"), r.next = e.enter("chunkContent", {
      contentType: "content",
      previous: r
    }), r = r.next, a;
  }
}
function lz(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return e.exit("chunkContent"), e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), dt(e, o, "linePrefix");
  }
  function o(s) {
    if (s === null || In(s))
      return r(s);
    const l = i.events[i.events.length - 1];
    return !i.parser.constructs.disable.null.includes("codeIndented") && l && l[1].type === "linePrefix" && l[2].sliceSerialize(l[1], !0).length >= 4 ? n(s) : e.interrupt(i.parser.constructs.flow, r, n)(s);
  }
}
function w1(e, n, r, i, a, o, s, l, c) {
  const m = c || Number.POSITIVE_INFINITY;
  let u = 0;
  return f;
  function f(_) {
    return _ === 60 ? (e.enter(i), e.enter(a), e.enter(o), e.consume(_), e.exit(o), h) : _ === null || _ === 32 || _ === 41 || dy(_) ? r(_) : (e.enter(i), e.enter(s), e.enter(l), e.enter("chunkString", {
      contentType: "string"
    }), N(_));
  }
  function h(_) {
    return _ === 62 ? (e.enter(o), e.consume(_), e.exit(o), e.exit(a), e.exit(i), n) : (e.enter(l), e.enter("chunkString", {
      contentType: "string"
    }), k(_));
  }
  function k(_) {
    return _ === 62 ? (e.exit("chunkString"), e.exit(l), h(_)) : _ === null || _ === 60 || In(_) ? r(_) : (e.consume(_), _ === 92 ? w : k);
  }
  function w(_) {
    return _ === 60 || _ === 62 || _ === 92 ? (e.consume(_), k) : k(_);
  }
  function N(_) {
    return !u && (_ === null || _ === 41 || tr(_)) ? (e.exit("chunkString"), e.exit(l), e.exit(s), e.exit(i), n(_)) : u < m && _ === 40 ? (e.consume(_), u++, N) : _ === 41 ? (e.consume(_), u--, N) : _ === null || _ === 32 || _ === 40 || dy(_) ? r(_) : (e.consume(_), _ === 92 ? j : N);
  }
  function j(_) {
    return _ === 40 || _ === 41 || _ === 92 ? (e.consume(_), N) : N(_);
  }
}
function C1(e, n, r, i, a, o) {
  const s = this;
  let l = 0, c;
  return m;
  function m(k) {
    return e.enter(i), e.enter(a), e.consume(k), e.exit(a), e.enter(o), u;
  }
  function u(k) {
    return l > 999 || k === null || k === 91 || k === 93 && !c || // To do: remove in the future once we’ve switched from
    // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
    // which doesn’t need this.
    // Hidden footnotes hook.
    /* c8 ignore next 3 */
    k === 94 && !l && "_hiddenFootnoteSupport" in s.parser.constructs ? r(k) : k === 93 ? (e.exit(o), e.enter(a), e.consume(k), e.exit(a), e.exit(i), n) : In(k) ? (e.enter("lineEnding"), e.consume(k), e.exit("lineEnding"), u) : (e.enter("chunkString", {
      contentType: "string"
    }), f(k));
  }
  function f(k) {
    return k === null || k === 91 || k === 93 || In(k) || l++ > 999 ? (e.exit("chunkString"), u(k)) : (e.consume(k), c || (c = !Yn(k)), k === 92 ? h : f);
  }
  function h(k) {
    return k === 91 || k === 92 || k === 93 ? (e.consume(k), l++, f) : f(k);
  }
}
function F1(e, n, r, i, a, o) {
  let s;
  return l;
  function l(h) {
    return h === 34 || h === 39 || h === 40 ? (e.enter(i), e.enter(a), e.consume(h), e.exit(a), s = h === 40 ? 41 : h, c) : r(h);
  }
  function c(h) {
    return h === s ? (e.enter(a), e.consume(h), e.exit(a), e.exit(i), n) : (e.enter(o), m(h));
  }
  function m(h) {
    return h === s ? (e.exit(o), c(s)) : h === null ? r(h) : In(h) ? (e.enter("lineEnding"), e.consume(h), e.exit("lineEnding"), dt(e, m, "linePrefix")) : (e.enter("chunkString", {
      contentType: "string"
    }), u(h));
  }
  function u(h) {
    return h === s || h === null || In(h) ? (e.exit("chunkString"), m(h)) : (e.consume(h), h === 92 ? f : u);
  }
  function f(h) {
    return h === s || h === 92 ? (e.consume(h), u) : u(h);
  }
}
function Do(e, n) {
  let r;
  return i;
  function i(a) {
    return In(a) ? (e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), r = !0, i) : Yn(a) ? dt(e, i, r ? "linePrefix" : "lineSuffix")(a) : n(a);
  }
}
const dz = {
  name: "definition",
  tokenize: uz
}, cz = {
  partial: !0,
  tokenize: mz
};
function uz(e, n, r) {
  const i = this;
  let a;
  return o;
  function o(k) {
    return e.enter("definition"), s(k);
  }
  function s(k) {
    return C1.call(
      i,
      e,
      l,
      // Note: we don’t need to reset the way `markdown-rs` does.
      r,
      "definitionLabel",
      "definitionLabelMarker",
      "definitionLabelString"
    )(k);
  }
  function l(k) {
    return a = va(i.sliceSerialize(i.events[i.events.length - 1][1]).slice(1, -1)), k === 58 ? (e.enter("definitionMarker"), e.consume(k), e.exit("definitionMarker"), c) : r(k);
  }
  function c(k) {
    return tr(k) ? Do(e, m)(k) : m(k);
  }
  function m(k) {
    return w1(
      e,
      u,
      // Note: we don’t need to reset the way `markdown-rs` does.
      r,
      "definitionDestination",
      "definitionDestinationLiteral",
      "definitionDestinationLiteralMarker",
      "definitionDestinationRaw",
      "definitionDestinationString"
    )(k);
  }
  function u(k) {
    return e.attempt(cz, f, f)(k);
  }
  function f(k) {
    return Yn(k) ? dt(e, h, "whitespace")(k) : h(k);
  }
  function h(k) {
    return k === null || In(k) ? (e.exit("definition"), i.parser.defined.push(a), n(k)) : r(k);
  }
}
function mz(e, n, r) {
  return i;
  function i(l) {
    return tr(l) ? Do(e, a)(l) : r(l);
  }
  function a(l) {
    return F1(e, o, r, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(l);
  }
  function o(l) {
    return Yn(l) ? dt(e, s, "whitespace")(l) : s(l);
  }
  function s(l) {
    return l === null || In(l) ? n(l) : r(l);
  }
}
const pz = {
  name: "hardBreakEscape",
  tokenize: fz
};
function fz(e, n, r) {
  return i;
  function i(o) {
    return e.enter("hardBreakEscape"), e.consume(o), a;
  }
  function a(o) {
    return In(o) ? (e.exit("hardBreakEscape"), n(o)) : r(o);
  }
}
const hz = {
  name: "headingAtx",
  resolve: yz,
  tokenize: gz
};
function yz(e, n) {
  let r = e.length - 2, i = 3, a, o;
  return e[i][1].type === "whitespace" && (i += 2), r - 2 > i && e[r][1].type === "whitespace" && (r -= 2), e[r][1].type === "atxHeadingSequence" && (i === r - 1 || r - 4 > i && e[r - 2][1].type === "whitespace") && (r -= i + 1 === r ? 2 : 4), r > i && (a = {
    type: "atxHeadingText",
    start: e[i][1].start,
    end: e[r][1].end
  }, o = {
    type: "chunkText",
    start: e[i][1].start,
    end: e[r][1].end,
    contentType: "text"
  }, Kr(e, i, r - i + 1, [["enter", a, n], ["enter", o, n], ["exit", o, n], ["exit", a, n]])), e;
}
function gz(e, n, r) {
  let i = 0;
  return a;
  function a(u) {
    return e.enter("atxHeading"), o(u);
  }
  function o(u) {
    return e.enter("atxHeadingSequence"), s(u);
  }
  function s(u) {
    return u === 35 && i++ < 6 ? (e.consume(u), s) : u === null || tr(u) ? (e.exit("atxHeadingSequence"), l(u)) : r(u);
  }
  function l(u) {
    return u === 35 ? (e.enter("atxHeadingSequence"), c(u)) : u === null || In(u) ? (e.exit("atxHeading"), n(u)) : Yn(u) ? dt(e, l, "whitespace")(u) : (e.enter("atxHeadingText"), m(u));
  }
  function c(u) {
    return u === 35 ? (e.consume(u), c) : (e.exit("atxHeadingSequence"), l(u));
  }
  function m(u) {
    return u === null || u === 35 || tr(u) ? (e.exit("atxHeadingText"), l(u)) : (e.consume(u), m);
  }
}
const vz = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "search",
  "section",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
], Px = ["pre", "script", "style", "textarea"], kz = {
  concrete: !0,
  name: "htmlFlow",
  resolveTo: xz,
  tokenize: Sz
}, bz = {
  partial: !0,
  tokenize: jz
}, _z = {
  partial: !0,
  tokenize: Nz
};
function xz(e) {
  let n = e.length;
  for (; n-- && !(e[n][0] === "enter" && e[n][1].type === "htmlFlow"); )
    ;
  return n > 1 && e[n - 2][1].type === "linePrefix" && (e[n][1].start = e[n - 2][1].start, e[n + 1][1].start = e[n - 2][1].start, e.splice(n - 2, 2)), e;
}
function Sz(e, n, r) {
  const i = this;
  let a, o, s, l, c;
  return m;
  function m(q) {
    return u(q);
  }
  function u(q) {
    return e.enter("htmlFlow"), e.enter("htmlFlowData"), e.consume(q), f;
  }
  function f(q) {
    return q === 33 ? (e.consume(q), h) : q === 47 ? (e.consume(q), o = !0, N) : q === 63 ? (e.consume(q), a = 3, i.interrupt ? n : V) : Ur(q) ? (e.consume(q), s = String.fromCharCode(q), j) : r(q);
  }
  function h(q) {
    return q === 45 ? (e.consume(q), a = 2, k) : q === 91 ? (e.consume(q), a = 5, l = 0, w) : Ur(q) ? (e.consume(q), a = 4, i.interrupt ? n : V) : r(q);
  }
  function k(q) {
    return q === 45 ? (e.consume(q), i.interrupt ? n : V) : r(q);
  }
  function w(q) {
    const Ge = "CDATA[";
    return q === Ge.charCodeAt(l++) ? (e.consume(q), l === Ge.length ? i.interrupt ? n : Y : w) : r(q);
  }
  function N(q) {
    return Ur(q) ? (e.consume(q), s = String.fromCharCode(q), j) : r(q);
  }
  function j(q) {
    if (q === null || q === 47 || q === 62 || tr(q)) {
      const Ge = q === 47, sn = s.toLowerCase();
      return !Ge && !o && Px.includes(sn) ? (a = 1, i.interrupt ? n(q) : Y(q)) : vz.includes(s.toLowerCase()) ? (a = 6, Ge ? (e.consume(q), _) : i.interrupt ? n(q) : Y(q)) : (a = 7, i.interrupt && !i.parser.lazy[i.now().line] ? r(q) : o ? g(q) : O(q));
    }
    return q === 45 || dr(q) ? (e.consume(q), s += String.fromCharCode(q), j) : r(q);
  }
  function _(q) {
    return q === 62 ? (e.consume(q), i.interrupt ? n : Y) : r(q);
  }
  function g(q) {
    return Yn(q) ? (e.consume(q), g) : re(q);
  }
  function O(q) {
    return q === 47 ? (e.consume(q), re) : q === 58 || q === 95 || Ur(q) ? (e.consume(q), R) : Yn(q) ? (e.consume(q), O) : re(q);
  }
  function R(q) {
    return q === 45 || q === 46 || q === 58 || q === 95 || dr(q) ? (e.consume(q), R) : F(q);
  }
  function F(q) {
    return q === 61 ? (e.consume(q), I) : Yn(q) ? (e.consume(q), F) : O(q);
  }
  function I(q) {
    return q === null || q === 60 || q === 61 || q === 62 || q === 96 ? r(q) : q === 34 || q === 39 ? (e.consume(q), c = q, L) : Yn(q) ? (e.consume(q), I) : W(q);
  }
  function L(q) {
    return q === c ? (e.consume(q), c = null, J) : q === null || In(q) ? r(q) : (e.consume(q), L);
  }
  function W(q) {
    return q === null || q === 34 || q === 39 || q === 47 || q === 60 || q === 61 || q === 62 || q === 96 || tr(q) ? F(q) : (e.consume(q), W);
  }
  function J(q) {
    return q === 47 || q === 62 || Yn(q) ? O(q) : r(q);
  }
  function re(q) {
    return q === 62 ? (e.consume(q), K) : r(q);
  }
  function K(q) {
    return q === null || In(q) ? Y(q) : Yn(q) ? (e.consume(q), K) : r(q);
  }
  function Y(q) {
    return q === 45 && a === 2 ? (e.consume(q), we) : q === 60 && a === 1 ? (e.consume(q), me) : q === 62 && a === 4 ? (e.consume(q), be) : q === 63 && a === 3 ? (e.consume(q), V) : q === 93 && a === 5 ? (e.consume(q), ge) : In(q) && (a === 6 || a === 7) ? (e.exit("htmlFlowData"), e.check(bz, Oe, P)(q)) : q === null || In(q) ? (e.exit("htmlFlowData"), P(q)) : (e.consume(q), Y);
  }
  function P(q) {
    return e.check(_z, B, Oe)(q);
  }
  function B(q) {
    return e.enter("lineEnding"), e.consume(q), e.exit("lineEnding"), ie;
  }
  function ie(q) {
    return q === null || In(q) ? P(q) : (e.enter("htmlFlowData"), Y(q));
  }
  function we(q) {
    return q === 45 ? (e.consume(q), V) : Y(q);
  }
  function me(q) {
    return q === 47 ? (e.consume(q), s = "", le) : Y(q);
  }
  function le(q) {
    if (q === 62) {
      const Ge = s.toLowerCase();
      return Px.includes(Ge) ? (e.consume(q), be) : Y(q);
    }
    return Ur(q) && s.length < 8 ? (e.consume(q), s += String.fromCharCode(q), le) : Y(q);
  }
  function ge(q) {
    return q === 93 ? (e.consume(q), V) : Y(q);
  }
  function V(q) {
    return q === 62 ? (e.consume(q), be) : q === 45 && a === 2 ? (e.consume(q), V) : Y(q);
  }
  function be(q) {
    return q === null || In(q) ? (e.exit("htmlFlowData"), Oe(q)) : (e.consume(q), be);
  }
  function Oe(q) {
    return e.exit("htmlFlow"), n(q);
  }
}
function Nz(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return In(s) ? (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), o) : r(s);
  }
  function o(s) {
    return i.parser.lazy[i.now().line] ? r(s) : n(s);
  }
}
function jz(e, n, r) {
  return i;
  function i(a) {
    return e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), e.attempt(ad, n, r);
  }
}
const wz = {
  name: "htmlText",
  tokenize: Cz
};
function Cz(e, n, r) {
  const i = this;
  let a, o, s;
  return l;
  function l(V) {
    return e.enter("htmlText"), e.enter("htmlTextData"), e.consume(V), c;
  }
  function c(V) {
    return V === 33 ? (e.consume(V), m) : V === 47 ? (e.consume(V), F) : V === 63 ? (e.consume(V), O) : Ur(V) ? (e.consume(V), W) : r(V);
  }
  function m(V) {
    return V === 45 ? (e.consume(V), u) : V === 91 ? (e.consume(V), o = 0, w) : Ur(V) ? (e.consume(V), g) : r(V);
  }
  function u(V) {
    return V === 45 ? (e.consume(V), k) : r(V);
  }
  function f(V) {
    return V === null ? r(V) : V === 45 ? (e.consume(V), h) : In(V) ? (s = f, me(V)) : (e.consume(V), f);
  }
  function h(V) {
    return V === 45 ? (e.consume(V), k) : f(V);
  }
  function k(V) {
    return V === 62 ? we(V) : V === 45 ? h(V) : f(V);
  }
  function w(V) {
    const be = "CDATA[";
    return V === be.charCodeAt(o++) ? (e.consume(V), o === be.length ? N : w) : r(V);
  }
  function N(V) {
    return V === null ? r(V) : V === 93 ? (e.consume(V), j) : In(V) ? (s = N, me(V)) : (e.consume(V), N);
  }
  function j(V) {
    return V === 93 ? (e.consume(V), _) : N(V);
  }
  function _(V) {
    return V === 62 ? we(V) : V === 93 ? (e.consume(V), _) : N(V);
  }
  function g(V) {
    return V === null || V === 62 ? we(V) : In(V) ? (s = g, me(V)) : (e.consume(V), g);
  }
  function O(V) {
    return V === null ? r(V) : V === 63 ? (e.consume(V), R) : In(V) ? (s = O, me(V)) : (e.consume(V), O);
  }
  function R(V) {
    return V === 62 ? we(V) : O(V);
  }
  function F(V) {
    return Ur(V) ? (e.consume(V), I) : r(V);
  }
  function I(V) {
    return V === 45 || dr(V) ? (e.consume(V), I) : L(V);
  }
  function L(V) {
    return In(V) ? (s = L, me(V)) : Yn(V) ? (e.consume(V), L) : we(V);
  }
  function W(V) {
    return V === 45 || dr(V) ? (e.consume(V), W) : V === 47 || V === 62 || tr(V) ? J(V) : r(V);
  }
  function J(V) {
    return V === 47 ? (e.consume(V), we) : V === 58 || V === 95 || Ur(V) ? (e.consume(V), re) : In(V) ? (s = J, me(V)) : Yn(V) ? (e.consume(V), J) : we(V);
  }
  function re(V) {
    return V === 45 || V === 46 || V === 58 || V === 95 || dr(V) ? (e.consume(V), re) : K(V);
  }
  function K(V) {
    return V === 61 ? (e.consume(V), Y) : In(V) ? (s = K, me(V)) : Yn(V) ? (e.consume(V), K) : J(V);
  }
  function Y(V) {
    return V === null || V === 60 || V === 61 || V === 62 || V === 96 ? r(V) : V === 34 || V === 39 ? (e.consume(V), a = V, P) : In(V) ? (s = Y, me(V)) : Yn(V) ? (e.consume(V), Y) : (e.consume(V), B);
  }
  function P(V) {
    return V === a ? (e.consume(V), a = void 0, ie) : V === null ? r(V) : In(V) ? (s = P, me(V)) : (e.consume(V), P);
  }
  function B(V) {
    return V === null || V === 34 || V === 39 || V === 60 || V === 61 || V === 96 ? r(V) : V === 47 || V === 62 || tr(V) ? J(V) : (e.consume(V), B);
  }
  function ie(V) {
    return V === 47 || V === 62 || tr(V) ? J(V) : r(V);
  }
  function we(V) {
    return V === 62 ? (e.consume(V), e.exit("htmlTextData"), e.exit("htmlText"), n) : r(V);
  }
  function me(V) {
    return e.exit("htmlTextData"), e.enter("lineEnding"), e.consume(V), e.exit("lineEnding"), le;
  }
  function le(V) {
    return Yn(V) ? dt(e, ge, "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(V) : ge(V);
  }
  function ge(V) {
    return e.enter("htmlTextData"), s(V);
  }
}
const jg = {
  name: "labelEnd",
  resolveAll: Ez,
  resolveTo: Tz,
  tokenize: Rz
}, Fz = {
  tokenize: Dz
}, Iz = {
  tokenize: Oz
}, $z = {
  tokenize: Pz
};
function Ez(e) {
  let n = -1;
  const r = [];
  for (; ++n < e.length; ) {
    const i = e[n][1];
    if (r.push(e[n]), i.type === "labelImage" || i.type === "labelLink" || i.type === "labelEnd") {
      const a = i.type === "labelImage" ? 4 : 2;
      i.type = "data", n += a;
    }
  }
  return e.length !== r.length && Kr(e, 0, e.length, r), e;
}
function Tz(e, n) {
  let r = e.length, i = 0, a, o, s, l;
  for (; r--; )
    if (a = e[r][1], o) {
      if (a.type === "link" || a.type === "labelLink" && a._inactive)
        break;
      e[r][0] === "enter" && a.type === "labelLink" && (a._inactive = !0);
    } else if (s) {
      if (e[r][0] === "enter" && (a.type === "labelImage" || a.type === "labelLink") && !a._balanced && (o = r, a.type !== "labelLink")) {
        i = 2;
        break;
      }
    } else a.type === "labelEnd" && (s = r);
  const c = {
    type: e[o][1].type === "labelLink" ? "link" : "image",
    start: {
      ...e[o][1].start
    },
    end: {
      ...e[e.length - 1][1].end
    }
  }, m = {
    type: "label",
    start: {
      ...e[o][1].start
    },
    end: {
      ...e[s][1].end
    }
  }, u = {
    type: "labelText",
    start: {
      ...e[o + i + 2][1].end
    },
    end: {
      ...e[s - 2][1].start
    }
  };
  return l = [["enter", c, n], ["enter", m, n]], l = _r(l, e.slice(o + 1, o + i + 3)), l = _r(l, [["enter", u, n]]), l = _r(l, Ng(n.parser.constructs.insideSpan.null, e.slice(o + i + 4, s - 3), n)), l = _r(l, [["exit", u, n], e[s - 2], e[s - 1], ["exit", m, n]]), l = _r(l, e.slice(s + 1)), l = _r(l, [["exit", c, n]]), Kr(e, o, e.length, l), e;
}
function Rz(e, n, r) {
  const i = this;
  let a = i.events.length, o, s;
  for (; a--; )
    if ((i.events[a][1].type === "labelImage" || i.events[a][1].type === "labelLink") && !i.events[a][1]._balanced) {
      o = i.events[a][1];
      break;
    }
  return l;
  function l(h) {
    return o ? o._inactive ? f(h) : (s = i.parser.defined.includes(va(i.sliceSerialize({
      start: o.end,
      end: i.now()
    }))), e.enter("labelEnd"), e.enter("labelMarker"), e.consume(h), e.exit("labelMarker"), e.exit("labelEnd"), c) : r(h);
  }
  function c(h) {
    return h === 40 ? e.attempt(Fz, u, s ? u : f)(h) : h === 91 ? e.attempt(Iz, u, s ? m : f)(h) : s ? u(h) : f(h);
  }
  function m(h) {
    return e.attempt($z, u, f)(h);
  }
  function u(h) {
    return n(h);
  }
  function f(h) {
    return o._balanced = !0, r(h);
  }
}
function Dz(e, n, r) {
  return i;
  function i(f) {
    return e.enter("resource"), e.enter("resourceMarker"), e.consume(f), e.exit("resourceMarker"), a;
  }
  function a(f) {
    return tr(f) ? Do(e, o)(f) : o(f);
  }
  function o(f) {
    return f === 41 ? u(f) : w1(e, s, l, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(f);
  }
  function s(f) {
    return tr(f) ? Do(e, c)(f) : u(f);
  }
  function l(f) {
    return r(f);
  }
  function c(f) {
    return f === 34 || f === 39 || f === 40 ? F1(e, m, r, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(f) : u(f);
  }
  function m(f) {
    return tr(f) ? Do(e, u)(f) : u(f);
  }
  function u(f) {
    return f === 41 ? (e.enter("resourceMarker"), e.consume(f), e.exit("resourceMarker"), e.exit("resource"), n) : r(f);
  }
}
function Oz(e, n, r) {
  const i = this;
  return a;
  function a(l) {
    return C1.call(i, e, o, s, "reference", "referenceMarker", "referenceString")(l);
  }
  function o(l) {
    return i.parser.defined.includes(va(i.sliceSerialize(i.events[i.events.length - 1][1]).slice(1, -1))) ? n(l) : r(l);
  }
  function s(l) {
    return r(l);
  }
}
function Pz(e, n, r) {
  return i;
  function i(o) {
    return e.enter("reference"), e.enter("referenceMarker"), e.consume(o), e.exit("referenceMarker"), a;
  }
  function a(o) {
    return o === 93 ? (e.enter("referenceMarker"), e.consume(o), e.exit("referenceMarker"), e.exit("reference"), n) : r(o);
  }
}
const Az = {
  name: "labelStartImage",
  resolveAll: jg.resolveAll,
  tokenize: Lz
};
function Lz(e, n, r) {
  const i = this;
  return a;
  function a(l) {
    return e.enter("labelImage"), e.enter("labelImageMarker"), e.consume(l), e.exit("labelImageMarker"), o;
  }
  function o(l) {
    return l === 91 ? (e.enter("labelMarker"), e.consume(l), e.exit("labelMarker"), e.exit("labelImage"), s) : r(l);
  }
  function s(l) {
    return l === 94 && "_hiddenFootnoteSupport" in i.parser.constructs ? r(l) : n(l);
  }
}
const Vz = {
  name: "labelStartLink",
  resolveAll: jg.resolveAll,
  tokenize: zz
};
function zz(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return e.enter("labelLink"), e.enter("labelMarker"), e.consume(s), e.exit("labelMarker"), e.exit("labelLink"), o;
  }
  function o(s) {
    return s === 94 && "_hiddenFootnoteSupport" in i.parser.constructs ? r(s) : n(s);
  }
}
const wm = {
  name: "lineEnding",
  tokenize: Uz
};
function Uz(e, n) {
  return r;
  function r(i) {
    return e.enter("lineEnding"), e.consume(i), e.exit("lineEnding"), dt(e, n, "linePrefix");
  }
}
const il = {
  name: "thematicBreak",
  tokenize: Mz
};
function Mz(e, n, r) {
  let i = 0, a;
  return o;
  function o(m) {
    return e.enter("thematicBreak"), s(m);
  }
  function s(m) {
    return a = m, l(m);
  }
  function l(m) {
    return m === a ? (e.enter("thematicBreakSequence"), c(m)) : i >= 3 && (m === null || In(m)) ? (e.exit("thematicBreak"), n(m)) : r(m);
  }
  function c(m) {
    return m === a ? (e.consume(m), i++, c) : (e.exit("thematicBreakSequence"), Yn(m) ? dt(e, l, "whitespace")(m) : l(m));
  }
}
const er = {
  continuation: {
    tokenize: Wz
  },
  exit: Gz,
  name: "list",
  tokenize: Hz
}, Bz = {
  partial: !0,
  tokenize: Yz
}, qz = {
  partial: !0,
  tokenize: Kz
};
function Hz(e, n, r) {
  const i = this, a = i.events[i.events.length - 1];
  let o = a && a[1].type === "linePrefix" ? a[2].sliceSerialize(a[1], !0).length : 0, s = 0;
  return l;
  function l(k) {
    const w = i.containerState.type || (k === 42 || k === 43 || k === 45 ? "listUnordered" : "listOrdered");
    if (w === "listUnordered" ? !i.containerState.marker || k === i.containerState.marker : cy(k)) {
      if (i.containerState.type || (i.containerState.type = w, e.enter(w, {
        _container: !0
      })), w === "listUnordered")
        return e.enter("listItemPrefix"), k === 42 || k === 45 ? e.check(il, r, m)(k) : m(k);
      if (!i.interrupt || k === 49)
        return e.enter("listItemPrefix"), e.enter("listItemValue"), c(k);
    }
    return r(k);
  }
  function c(k) {
    return cy(k) && ++s < 10 ? (e.consume(k), c) : (!i.interrupt || s < 2) && (i.containerState.marker ? k === i.containerState.marker : k === 41 || k === 46) ? (e.exit("listItemValue"), m(k)) : r(k);
  }
  function m(k) {
    return e.enter("listItemMarker"), e.consume(k), e.exit("listItemMarker"), i.containerState.marker = i.containerState.marker || k, e.check(
      ad,
      // Can’t be empty when interrupting.
      i.interrupt ? r : u,
      e.attempt(Bz, h, f)
    );
  }
  function u(k) {
    return i.containerState.initialBlankLine = !0, o++, h(k);
  }
  function f(k) {
    return Yn(k) ? (e.enter("listItemPrefixWhitespace"), e.consume(k), e.exit("listItemPrefixWhitespace"), h) : r(k);
  }
  function h(k) {
    return i.containerState.size = o + i.sliceSerialize(e.exit("listItemPrefix"), !0).length, n(k);
  }
}
function Wz(e, n, r) {
  const i = this;
  return i.containerState._closeFlow = void 0, e.check(ad, a, o);
  function a(l) {
    return i.containerState.furtherBlankLines = i.containerState.furtherBlankLines || i.containerState.initialBlankLine, dt(e, n, "listItemIndent", i.containerState.size + 1)(l);
  }
  function o(l) {
    return i.containerState.furtherBlankLines || !Yn(l) ? (i.containerState.furtherBlankLines = void 0, i.containerState.initialBlankLine = void 0, s(l)) : (i.containerState.furtherBlankLines = void 0, i.containerState.initialBlankLine = void 0, e.attempt(qz, n, s)(l));
  }
  function s(l) {
    return i.containerState._closeFlow = !0, i.interrupt = void 0, dt(e, e.attempt(er, n, r), "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(l);
  }
}
function Kz(e, n, r) {
  const i = this;
  return dt(e, a, "listItemIndent", i.containerState.size + 1);
  function a(o) {
    const s = i.events[i.events.length - 1];
    return s && s[1].type === "listItemIndent" && s[2].sliceSerialize(s[1], !0).length === i.containerState.size ? n(o) : r(o);
  }
}
function Gz(e) {
  e.exit(this.containerState.type);
}
function Yz(e, n, r) {
  const i = this;
  return dt(e, a, "listItemPrefixWhitespace", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 5);
  function a(o) {
    const s = i.events[i.events.length - 1];
    return !Yn(o) && s && s[1].type === "listItemPrefixWhitespace" ? n(o) : r(o);
  }
}
const Ax = {
  name: "setextUnderline",
  resolveTo: Jz,
  tokenize: Qz
};
function Jz(e, n) {
  let r = e.length, i, a, o;
  for (; r--; )
    if (e[r][0] === "enter") {
      if (e[r][1].type === "content") {
        i = r;
        break;
      }
      e[r][1].type === "paragraph" && (a = r);
    } else
      e[r][1].type === "content" && e.splice(r, 1), !o && e[r][1].type === "definition" && (o = r);
  const s = {
    type: "setextHeading",
    start: {
      ...e[a][1].start
    },
    end: {
      ...e[e.length - 1][1].end
    }
  };
  return e[a][1].type = "setextHeadingText", o ? (e.splice(a, 0, ["enter", s, n]), e.splice(o + 1, 0, ["exit", e[i][1], n]), e[i][1].end = {
    ...e[o][1].end
  }) : e[i][1] = s, e.push(["exit", s, n]), e;
}
function Qz(e, n, r) {
  const i = this;
  let a;
  return o;
  function o(m) {
    let u = i.events.length, f;
    for (; u--; )
      if (i.events[u][1].type !== "lineEnding" && i.events[u][1].type !== "linePrefix" && i.events[u][1].type !== "content") {
        f = i.events[u][1].type === "paragraph";
        break;
      }
    return !i.parser.lazy[i.now().line] && (i.interrupt || f) ? (e.enter("setextHeadingLine"), a = m, s(m)) : r(m);
  }
  function s(m) {
    return e.enter("setextHeadingLineSequence"), l(m);
  }
  function l(m) {
    return m === a ? (e.consume(m), l) : (e.exit("setextHeadingLineSequence"), Yn(m) ? dt(e, c, "lineSuffix")(m) : c(m));
  }
  function c(m) {
    return m === null || In(m) ? (e.exit("setextHeadingLine"), n(m)) : r(m);
  }
}
const Xz = {
  tokenize: Zz
};
function Zz(e) {
  const n = this, r = e.attempt(
    // Try to parse a blank line.
    ad,
    i,
    // Try to parse initial flow (essentially, only code).
    e.attempt(this.parser.constructs.flowInitial, a, dt(e, e.attempt(this.parser.constructs.flow, a, e.attempt(iz, a)), "linePrefix"))
  );
  return r;
  function i(o) {
    if (o === null) {
      e.consume(o);
      return;
    }
    return e.enter("lineEndingBlank"), e.consume(o), e.exit("lineEndingBlank"), n.currentConstruct = void 0, r;
  }
  function a(o) {
    if (o === null) {
      e.consume(o);
      return;
    }
    return e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), n.currentConstruct = void 0, r;
  }
}
const eU = {
  resolveAll: $1()
}, nU = I1("string"), tU = I1("text");
function I1(e) {
  return {
    resolveAll: $1(e === "text" ? rU : void 0),
    tokenize: n
  };
  function n(r) {
    const i = this, a = this.parser.constructs[e], o = r.attempt(a, s, l);
    return s;
    function s(u) {
      return m(u) ? o(u) : l(u);
    }
    function l(u) {
      if (u === null) {
        r.consume(u);
        return;
      }
      return r.enter("data"), r.consume(u), c;
    }
    function c(u) {
      return m(u) ? (r.exit("data"), o(u)) : (r.consume(u), c);
    }
    function m(u) {
      if (u === null)
        return !0;
      const f = a[u];
      let h = -1;
      if (f)
        for (; ++h < f.length; ) {
          const k = f[h];
          if (!k.previous || k.previous.call(i, i.previous))
            return !0;
        }
      return !1;
    }
  }
}
function $1(e) {
  return n;
  function n(r, i) {
    let a = -1, o;
    for (; ++a <= r.length; )
      o === void 0 ? r[a] && r[a][1].type === "data" && (o = a, a++) : (!r[a] || r[a][1].type !== "data") && (a !== o + 2 && (r[o][1].end = r[a - 1][1].end, r.splice(o + 2, a - o - 2), a = o + 2), o = void 0);
    return e ? e(r, i) : r;
  }
}
function rU(e, n) {
  let r = 0;
  for (; ++r <= e.length; )
    if ((r === e.length || e[r][1].type === "lineEnding") && e[r - 1][1].type === "data") {
      const i = e[r - 1][1], a = n.sliceStream(i);
      let o = a.length, s = -1, l = 0, c;
      for (; o--; ) {
        const m = a[o];
        if (typeof m == "string") {
          for (s = m.length; m.charCodeAt(s - 1) === 32; )
            l++, s--;
          if (s) break;
          s = -1;
        } else if (m === -2)
          c = !0, l++;
        else if (m !== -1) {
          o++;
          break;
        }
      }
      if (l) {
        const m = {
          type: r === e.length || c || l < 2 ? "lineSuffix" : "hardBreakTrailing",
          start: {
            _bufferIndex: o ? s : i.start._bufferIndex + s,
            _index: i.start._index + o,
            line: i.end.line,
            column: i.end.column - l,
            offset: i.end.offset - l
          },
          end: {
            ...i.end
          }
        };
        i.end = {
          ...m.start
        }, i.start.offset === i.end.offset ? Object.assign(i, m) : (e.splice(r, 0, ["enter", m, n], ["exit", m, n]), r += 2);
      }
      r++;
    }
  return e;
}
const iU = {
  42: er,
  43: er,
  45: er,
  48: er,
  49: er,
  50: er,
  51: er,
  52: er,
  53: er,
  54: er,
  55: er,
  56: er,
  57: er,
  62: x1
}, aU = {
  91: dz
}, oU = {
  [-2]: jm,
  [-1]: jm,
  32: jm
}, sU = {
  35: hz,
  42: il,
  45: [Ax, il],
  60: kz,
  61: Ax,
  95: il,
  96: Ox,
  126: Ox
}, lU = {
  38: N1,
  92: S1
}, dU = {
  [-5]: wm,
  [-4]: wm,
  [-3]: wm,
  33: Az,
  38: N1,
  42: uy,
  60: [V3, wz],
  91: Vz,
  92: [pz, S1],
  93: jg,
  95: uy,
  96: X3
}, cU = {
  null: [uy, eU]
}, uU = {
  null: [42, 95]
}, mU = {
  null: []
}, pU = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  attentionMarkers: uU,
  contentInitial: aU,
  disable: mU,
  document: iU,
  flow: sU,
  flowInitial: oU,
  insideSpan: cU,
  string: lU,
  text: dU
}, Symbol.toStringTag, { value: "Module" }));
function fU(e, n, r) {
  let i = {
    _bufferIndex: -1,
    _index: 0,
    line: r && r.line || 1,
    column: r && r.column || 1,
    offset: r && r.offset || 0
  };
  const a = {}, o = [];
  let s = [], l = [];
  const c = {
    attempt: L(F),
    check: L(I),
    consume: g,
    enter: O,
    exit: R,
    interrupt: L(I, {
      interrupt: !0
    })
  }, m = {
    code: null,
    containerState: {},
    defineSkip: N,
    events: [],
    now: w,
    parser: e,
    previous: null,
    sliceSerialize: h,
    sliceStream: k,
    write: f
  };
  let u = n.tokenize.call(m, c);
  return n.resolveAll && o.push(n), m;
  function f(K) {
    return s = _r(s, K), j(), s[s.length - 1] !== null ? [] : (W(n, 0), m.events = Ng(o, m.events, m), m.events);
  }
  function h(K, Y) {
    return yU(k(K), Y);
  }
  function k(K) {
    return hU(s, K);
  }
  function w() {
    const {
      _bufferIndex: K,
      _index: Y,
      line: P,
      column: B,
      offset: ie
    } = i;
    return {
      _bufferIndex: K,
      _index: Y,
      line: P,
      column: B,
      offset: ie
    };
  }
  function N(K) {
    a[K.line] = K.column, re();
  }
  function j() {
    let K;
    for (; i._index < s.length; ) {
      const Y = s[i._index];
      if (typeof Y == "string")
        for (K = i._index, i._bufferIndex < 0 && (i._bufferIndex = 0); i._index === K && i._bufferIndex < Y.length; )
          _(Y.charCodeAt(i._bufferIndex));
      else
        _(Y);
    }
  }
  function _(K) {
    u = u(K);
  }
  function g(K) {
    In(K) ? (i.line++, i.column = 1, i.offset += K === -3 ? 2 : 1, re()) : K !== -1 && (i.column++, i.offset++), i._bufferIndex < 0 ? i._index++ : (i._bufferIndex++, i._bufferIndex === // Points w/ non-negative `_bufferIndex` reference
    // strings.
    /** @type {string} */
    s[i._index].length && (i._bufferIndex = -1, i._index++)), m.previous = K;
  }
  function O(K, Y) {
    const P = Y || {};
    return P.type = K, P.start = w(), m.events.push(["enter", P, m]), l.push(P), P;
  }
  function R(K) {
    const Y = l.pop();
    return Y.end = w(), m.events.push(["exit", Y, m]), Y;
  }
  function F(K, Y) {
    W(K, Y.from);
  }
  function I(K, Y) {
    Y.restore();
  }
  function L(K, Y) {
    return P;
    function P(B, ie, we) {
      let me, le, ge, V;
      return Array.isArray(B) ? (
        /* c8 ignore next 1 */
        Oe(B)
      ) : "tokenize" in B ? (
        // Looks like a construct.
        Oe([
          /** @type {Construct} */
          B
        ])
      ) : be(B);
      function be(Ie) {
        return Ue;
        function Ue(De) {
          const Be = De !== null && Ie[De], Ae = De !== null && Ie.null, Je = [
            // To do: add more extension tests.
            /* c8 ignore next 2 */
            ...Array.isArray(Be) ? Be : Be ? [Be] : [],
            ...Array.isArray(Ae) ? Ae : Ae ? [Ae] : []
          ];
          return Oe(Je)(De);
        }
      }
      function Oe(Ie) {
        return me = Ie, le = 0, Ie.length === 0 ? we : q(Ie[le]);
      }
      function q(Ie) {
        return Ue;
        function Ue(De) {
          return V = J(), ge = Ie, Ie.partial || (m.currentConstruct = Ie), Ie.name && m.parser.constructs.disable.null.includes(Ie.name) ? sn() : Ie.tokenize.call(
            // If we do have fields, create an object w/ `context` as its
            // prototype.
            // This allows a “live binding”, which is needed for `interrupt`.
            Y ? Object.assign(Object.create(m), Y) : m,
            c,
            Ge,
            sn
          )(De);
        }
      }
      function Ge(Ie) {
        return K(ge, V), ie;
      }
      function sn(Ie) {
        return V.restore(), ++le < me.length ? q(me[le]) : we;
      }
    }
  }
  function W(K, Y) {
    K.resolveAll && !o.includes(K) && o.push(K), K.resolve && Kr(m.events, Y, m.events.length - Y, K.resolve(m.events.slice(Y), m)), K.resolveTo && (m.events = K.resolveTo(m.events, m));
  }
  function J() {
    const K = w(), Y = m.previous, P = m.currentConstruct, B = m.events.length, ie = Array.from(l);
    return {
      from: B,
      restore: we
    };
    function we() {
      i = K, m.previous = Y, m.currentConstruct = P, m.events.length = B, l = ie, re();
    }
  }
  function re() {
    i.line in a && i.column < 2 && (i.column = a[i.line], i.offset += a[i.line] - 1);
  }
}
function hU(e, n) {
  const r = n.start._index, i = n.start._bufferIndex, a = n.end._index, o = n.end._bufferIndex;
  let s;
  if (r === a)
    s = [e[r].slice(i, o)];
  else {
    if (s = e.slice(r, a), i > -1) {
      const l = s[0];
      typeof l == "string" ? s[0] = l.slice(i) : s.shift();
    }
    o > 0 && s.push(e[a].slice(0, o));
  }
  return s;
}
function yU(e, n) {
  let r = -1;
  const i = [];
  let a;
  for (; ++r < e.length; ) {
    const o = e[r];
    let s;
    if (typeof o == "string")
      s = o;
    else switch (o) {
      case -5: {
        s = "\r";
        break;
      }
      case -4: {
        s = `
`;
        break;
      }
      case -3: {
        s = `\r
`;
        break;
      }
      case -2: {
        s = n ? " " : "	";
        break;
      }
      case -1: {
        if (!n && a) continue;
        s = " ";
        break;
      }
      default:
        s = String.fromCharCode(o);
    }
    a = o === -2, i.push(s);
  }
  return i.join("");
}
function gU(e) {
  const i = {
    constructs: (
      /** @type {FullNormalizedExtension} */
      N3([pU, ...(e || {}).extensions || []])
    ),
    content: a(T3),
    defined: [],
    document: a(D3),
    flow: a(Xz),
    lazy: {},
    string: a(nU),
    text: a(tU)
  };
  return i;
  function a(o) {
    return s;
    function s(l) {
      return fU(i, o, l);
    }
  }
}
function vU(e) {
  for (; !j1(e); )
    ;
  return e;
}
const Lx = /[\0\t\n\r]/g;
function kU() {
  let e = 1, n = "", r = !0, i;
  return a;
  function a(o, s, l) {
    const c = [];
    let m, u, f, h, k;
    for (o = n + (typeof o == "string" ? o.toString() : new TextDecoder(s || void 0).decode(o)), f = 0, n = "", r && (o.charCodeAt(0) === 65279 && f++, r = void 0); f < o.length; ) {
      if (Lx.lastIndex = f, m = Lx.exec(o), h = m && m.index !== void 0 ? m.index : o.length, k = o.charCodeAt(h), !m) {
        n = o.slice(f);
        break;
      }
      if (k === 10 && f === h && i)
        c.push(-3), i = void 0;
      else
        switch (i && (c.push(-5), i = void 0), f < h && (c.push(o.slice(f, h)), e += h - f), k) {
          case 0: {
            c.push(65533), e++;
            break;
          }
          case 9: {
            for (u = Math.ceil(e / 4) * 4, c.push(-2); e++ < u; ) c.push(-1);
            break;
          }
          case 10: {
            c.push(-4), e = 1;
            break;
          }
          default:
            i = !0, e = 1;
        }
      f = h + 1;
    }
    return l && (i && c.push(-5), n && c.push(n), c.push(null)), c;
  }
}
const bU = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function _U(e) {
  return e.replace(bU, xU);
}
function xU(e, n, r) {
  if (n)
    return n;
  if (r.charCodeAt(0) === 35) {
    const a = r.charCodeAt(1), o = a === 120 || a === 88;
    return _1(r.slice(o ? 2 : 1), o ? 16 : 10);
  }
  return Sg(r) || e;
}
const E1 = {}.hasOwnProperty;
function SU(e, n, r) {
  return typeof n != "string" && (r = n, n = void 0), NU(r)(vU(gU(r).document().write(kU()(e, n, !0))));
}
function NU(e) {
  const n = {
    transforms: [],
    canContainEols: ["emphasis", "fragment", "heading", "paragraph", "strong"],
    enter: {
      autolink: o(Pe),
      autolinkProtocol: J,
      autolinkEmail: J,
      atxHeading: o(se),
      blockQuote: o(Ae),
      characterEscape: J,
      characterReference: J,
      codeFenced: o(Je),
      codeFencedFenceInfo: s,
      codeFencedFenceMeta: s,
      codeIndented: o(Je, s),
      codeText: o(Ee, s),
      codeTextData: J,
      data: J,
      codeFlowValue: J,
      definition: o(Me),
      definitionDestinationString: s,
      definitionLabelString: s,
      definitionTitleString: s,
      emphasis: o(en),
      hardBreakEscape: o(de),
      hardBreakTrailing: o(de),
      htmlFlow: o(Se, s),
      htmlFlowData: J,
      htmlText: o(Se, s),
      htmlTextData: J,
      image: o(Ve),
      label: s,
      link: o(Pe),
      listItem: o(Q),
      listItemValue: h,
      listOrdered: o(kn, f),
      listUnordered: o(kn),
      paragraph: o(E),
      reference: q,
      referenceString: s,
      resourceDestinationString: s,
      resourceTitleString: s,
      setextHeading: o(se),
      strong: o(z),
      thematicBreak: o(ce)
    },
    exit: {
      atxHeading: c(),
      atxHeadingSequence: F,
      autolink: c(),
      autolinkEmail: Be,
      autolinkProtocol: De,
      blockQuote: c(),
      characterEscapeValue: re,
      characterReferenceMarkerHexadecimal: sn,
      characterReferenceMarkerNumeric: sn,
      characterReferenceValue: Ie,
      characterReference: Ue,
      codeFenced: c(j),
      codeFencedFence: N,
      codeFencedFenceInfo: k,
      codeFencedFenceMeta: w,
      codeFlowValue: re,
      codeIndented: c(_),
      codeText: c(ie),
      codeTextData: re,
      data: re,
      definition: c(),
      definitionDestinationString: R,
      definitionLabelString: g,
      definitionTitleString: O,
      emphasis: c(),
      hardBreakEscape: c(Y),
      hardBreakTrailing: c(Y),
      htmlFlow: c(P),
      htmlFlowData: re,
      htmlText: c(B),
      htmlTextData: re,
      image: c(me),
      label: ge,
      labelText: le,
      lineEnding: K,
      link: c(we),
      listItem: c(),
      listOrdered: c(),
      listUnordered: c(),
      paragraph: c(),
      referenceString: Ge,
      resourceDestinationString: V,
      resourceTitleString: be,
      resource: Oe,
      setextHeading: c(W),
      setextHeadingLineSequence: L,
      setextHeadingText: I,
      strong: c(),
      thematicBreak: c()
    }
  };
  T1(n, (e || {}).mdastExtensions || []);
  const r = {};
  return i;
  function i(U) {
    let G = {
      type: "root",
      children: []
    };
    const ve = {
      stack: [G],
      tokenStack: [],
      config: n,
      enter: l,
      exit: m,
      buffer: s,
      resume: u,
      data: r
    }, je = [];
    let Re = -1;
    for (; ++Re < U.length; )
      if (U[Re][1].type === "listOrdered" || U[Re][1].type === "listUnordered")
        if (U[Re][0] === "enter")
          je.push(Re);
        else {
          const rn = je.pop();
          Re = a(U, rn, Re);
        }
    for (Re = -1; ++Re < U.length; ) {
      const rn = n[U[Re][0]];
      E1.call(rn, U[Re][1].type) && rn[U[Re][1].type].call(Object.assign({
        sliceSerialize: U[Re][2].sliceSerialize
      }, ve), U[Re][1]);
    }
    if (ve.tokenStack.length > 0) {
      const rn = ve.tokenStack[ve.tokenStack.length - 1];
      (rn[1] || Vx).call(ve, void 0, rn[0]);
    }
    for (G.position = {
      start: ci(U.length > 0 ? U[0][1].start : {
        line: 1,
        column: 1,
        offset: 0
      }),
      end: ci(U.length > 0 ? U[U.length - 2][1].end : {
        line: 1,
        column: 1,
        offset: 0
      })
    }, Re = -1; ++Re < n.transforms.length; )
      G = n.transforms[Re](G) || G;
    return G;
  }
  function a(U, G, ve) {
    let je = G - 1, Re = -1, rn = !1, bn, an, fn, En;
    for (; ++je <= ve; ) {
      const _n = U[je];
      switch (_n[1].type) {
        case "listUnordered":
        case "listOrdered":
        case "blockQuote": {
          _n[0] === "enter" ? Re++ : Re--, En = void 0;
          break;
        }
        case "lineEndingBlank": {
          _n[0] === "enter" && (bn && !En && !Re && !fn && (fn = je), En = void 0);
          break;
        }
        case "linePrefix":
        case "listItemValue":
        case "listItemMarker":
        case "listItemPrefix":
        case "listItemPrefixWhitespace":
          break;
        default:
          En = void 0;
      }
      if (!Re && _n[0] === "enter" && _n[1].type === "listItemPrefix" || Re === -1 && _n[0] === "exit" && (_n[1].type === "listUnordered" || _n[1].type === "listOrdered")) {
        if (bn) {
          let Fn = je;
          for (an = void 0; Fn--; ) {
            const Ze = U[Fn];
            if (Ze[1].type === "lineEnding" || Ze[1].type === "lineEndingBlank") {
              if (Ze[0] === "exit") continue;
              an && (U[an][1].type = "lineEndingBlank", rn = !0), Ze[1].type = "lineEnding", an = Fn;
            } else if (!(Ze[1].type === "linePrefix" || Ze[1].type === "blockQuotePrefix" || Ze[1].type === "blockQuotePrefixWhitespace" || Ze[1].type === "blockQuoteMarker" || Ze[1].type === "listItemIndent")) break;
          }
          fn && (!an || fn < an) && (bn._spread = !0), bn.end = Object.assign({}, an ? U[an][1].start : _n[1].end), U.splice(an || je, 0, ["exit", bn, _n[2]]), je++, ve++;
        }
        if (_n[1].type === "listItemPrefix") {
          const Fn = {
            type: "listItem",
            _spread: !1,
            start: Object.assign({}, _n[1].start),
            // @ts-expect-error: we’ll add `end` in a second.
            end: void 0
          };
          bn = Fn, U.splice(je, 0, ["enter", Fn, _n[2]]), je++, ve++, fn = void 0, En = !0;
        }
      }
    }
    return U[G][1]._spread = rn, ve;
  }
  function o(U, G) {
    return ve;
    function ve(je) {
      l.call(this, U(je), je), G && G.call(this, je);
    }
  }
  function s() {
    this.stack.push({
      type: "fragment",
      children: []
    });
  }
  function l(U, G, ve) {
    this.stack[this.stack.length - 1].children.push(U), this.stack.push(U), this.tokenStack.push([G, ve || void 0]), U.position = {
      start: ci(G.start),
      // @ts-expect-error: `end` will be patched later.
      end: void 0
    };
  }
  function c(U) {
    return G;
    function G(ve) {
      U && U.call(this, ve), m.call(this, ve);
    }
  }
  function m(U, G) {
    const ve = this.stack.pop(), je = this.tokenStack.pop();
    if (je)
      je[0].type !== U.type && (G ? G.call(this, U, je[0]) : (je[1] || Vx).call(this, U, je[0]));
    else throw new Error("Cannot close `" + U.type + "` (" + Ro({
      start: U.start,
      end: U.end
    }) + "): it’s not open");
    ve.position.end = ci(U.end);
  }
  function u() {
    return x3(this.stack.pop());
  }
  function f() {
    this.data.expectingFirstListItemValue = !0;
  }
  function h(U) {
    if (this.data.expectingFirstListItemValue) {
      const G = this.stack[this.stack.length - 2];
      G.start = Number.parseInt(this.sliceSerialize(U), 10), this.data.expectingFirstListItemValue = void 0;
    }
  }
  function k() {
    const U = this.resume(), G = this.stack[this.stack.length - 1];
    G.lang = U;
  }
  function w() {
    const U = this.resume(), G = this.stack[this.stack.length - 1];
    G.meta = U;
  }
  function N() {
    this.data.flowCodeInside || (this.buffer(), this.data.flowCodeInside = !0);
  }
  function j() {
    const U = this.resume(), G = this.stack[this.stack.length - 1];
    G.value = U.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, ""), this.data.flowCodeInside = void 0;
  }
  function _() {
    const U = this.resume(), G = this.stack[this.stack.length - 1];
    G.value = U.replace(/(\r?\n|\r)$/g, "");
  }
  function g(U) {
    const G = this.resume(), ve = this.stack[this.stack.length - 1];
    ve.label = G, ve.identifier = va(this.sliceSerialize(U)).toLowerCase();
  }
  function O() {
    const U = this.resume(), G = this.stack[this.stack.length - 1];
    G.title = U;
  }
  function R() {
    const U = this.resume(), G = this.stack[this.stack.length - 1];
    G.url = U;
  }
  function F(U) {
    const G = this.stack[this.stack.length - 1];
    if (!G.depth) {
      const ve = this.sliceSerialize(U).length;
      G.depth = ve;
    }
  }
  function I() {
    this.data.setextHeadingSlurpLineEnding = !0;
  }
  function L(U) {
    const G = this.stack[this.stack.length - 1];
    G.depth = this.sliceSerialize(U).codePointAt(0) === 61 ? 1 : 2;
  }
  function W() {
    this.data.setextHeadingSlurpLineEnding = void 0;
  }
  function J(U) {
    const ve = this.stack[this.stack.length - 1].children;
    let je = ve[ve.length - 1];
    (!je || je.type !== "text") && (je = ae(), je.position = {
      start: ci(U.start),
      // @ts-expect-error: we’ll add `end` later.
      end: void 0
    }, ve.push(je)), this.stack.push(je);
  }
  function re(U) {
    const G = this.stack.pop();
    G.value += this.sliceSerialize(U), G.position.end = ci(U.end);
  }
  function K(U) {
    const G = this.stack[this.stack.length - 1];
    if (this.data.atHardBreak) {
      const ve = G.children[G.children.length - 1];
      ve.position.end = ci(U.end), this.data.atHardBreak = void 0;
      return;
    }
    !this.data.setextHeadingSlurpLineEnding && n.canContainEols.includes(G.type) && (J.call(this, U), re.call(this, U));
  }
  function Y() {
    this.data.atHardBreak = !0;
  }
  function P() {
    const U = this.resume(), G = this.stack[this.stack.length - 1];
    G.value = U;
  }
  function B() {
    const U = this.resume(), G = this.stack[this.stack.length - 1];
    G.value = U;
  }
  function ie() {
    const U = this.resume(), G = this.stack[this.stack.length - 1];
    G.value = U;
  }
  function we() {
    const U = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const G = this.data.referenceType || "shortcut";
      U.type += "Reference", U.referenceType = G, delete U.url, delete U.title;
    } else
      delete U.identifier, delete U.label;
    this.data.referenceType = void 0;
  }
  function me() {
    const U = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const G = this.data.referenceType || "shortcut";
      U.type += "Reference", U.referenceType = G, delete U.url, delete U.title;
    } else
      delete U.identifier, delete U.label;
    this.data.referenceType = void 0;
  }
  function le(U) {
    const G = this.sliceSerialize(U), ve = this.stack[this.stack.length - 2];
    ve.label = _U(G), ve.identifier = va(G).toLowerCase();
  }
  function ge() {
    const U = this.stack[this.stack.length - 1], G = this.resume(), ve = this.stack[this.stack.length - 1];
    if (this.data.inReference = !0, ve.type === "link") {
      const je = U.children;
      ve.children = je;
    } else
      ve.alt = G;
  }
  function V() {
    const U = this.resume(), G = this.stack[this.stack.length - 1];
    G.url = U;
  }
  function be() {
    const U = this.resume(), G = this.stack[this.stack.length - 1];
    G.title = U;
  }
  function Oe() {
    this.data.inReference = void 0;
  }
  function q() {
    this.data.referenceType = "collapsed";
  }
  function Ge(U) {
    const G = this.resume(), ve = this.stack[this.stack.length - 1];
    ve.label = G, ve.identifier = va(this.sliceSerialize(U)).toLowerCase(), this.data.referenceType = "full";
  }
  function sn(U) {
    this.data.characterReferenceType = U.type;
  }
  function Ie(U) {
    const G = this.sliceSerialize(U), ve = this.data.characterReferenceType;
    let je;
    ve ? (je = _1(G, ve === "characterReferenceMarkerNumeric" ? 10 : 16), this.data.characterReferenceType = void 0) : je = Sg(G);
    const Re = this.stack[this.stack.length - 1];
    Re.value += je;
  }
  function Ue(U) {
    const G = this.stack.pop();
    G.position.end = ci(U.end);
  }
  function De(U) {
    re.call(this, U);
    const G = this.stack[this.stack.length - 1];
    G.url = this.sliceSerialize(U);
  }
  function Be(U) {
    re.call(this, U);
    const G = this.stack[this.stack.length - 1];
    G.url = "mailto:" + this.sliceSerialize(U);
  }
  function Ae() {
    return {
      type: "blockquote",
      children: []
    };
  }
  function Je() {
    return {
      type: "code",
      lang: null,
      meta: null,
      value: ""
    };
  }
  function Ee() {
    return {
      type: "inlineCode",
      value: ""
    };
  }
  function Me() {
    return {
      type: "definition",
      identifier: "",
      label: null,
      title: null,
      url: ""
    };
  }
  function en() {
    return {
      type: "emphasis",
      children: []
    };
  }
  function se() {
    return {
      type: "heading",
      // @ts-expect-error `depth` will be set later.
      depth: 0,
      children: []
    };
  }
  function de() {
    return {
      type: "break"
    };
  }
  function Se() {
    return {
      type: "html",
      value: ""
    };
  }
  function Ve() {
    return {
      type: "image",
      title: null,
      url: "",
      alt: null
    };
  }
  function Pe() {
    return {
      type: "link",
      title: null,
      url: "",
      children: []
    };
  }
  function kn(U) {
    return {
      type: "list",
      ordered: U.type === "listOrdered",
      start: null,
      spread: U._spread,
      children: []
    };
  }
  function Q(U) {
    return {
      type: "listItem",
      spread: U._spread,
      checked: null,
      children: []
    };
  }
  function E() {
    return {
      type: "paragraph",
      children: []
    };
  }
  function z() {
    return {
      type: "strong",
      children: []
    };
  }
  function ae() {
    return {
      type: "text",
      value: ""
    };
  }
  function ce() {
    return {
      type: "thematicBreak"
    };
  }
}
function ci(e) {
  return {
    line: e.line,
    column: e.column,
    offset: e.offset
  };
}
function T1(e, n) {
  let r = -1;
  for (; ++r < n.length; ) {
    const i = n[r];
    Array.isArray(i) ? T1(e, i) : jU(e, i);
  }
}
function jU(e, n) {
  let r;
  for (r in n)
    if (E1.call(n, r))
      switch (r) {
        case "canContainEols": {
          const i = n[r];
          i && e[r].push(...i);
          break;
        }
        case "transforms": {
          const i = n[r];
          i && e[r].push(...i);
          break;
        }
        case "enter":
        case "exit": {
          const i = n[r];
          i && Object.assign(e[r], i);
          break;
        }
      }
}
function Vx(e, n) {
  throw e ? new Error("Cannot close `" + e.type + "` (" + Ro({
    start: e.start,
    end: e.end
  }) + "): a different token (`" + n.type + "`, " + Ro({
    start: n.start,
    end: n.end
  }) + ") is open") : new Error("Cannot close document, a token (`" + n.type + "`, " + Ro({
    start: n.start,
    end: n.end
  }) + ") is still open");
}
function wU(e) {
  const n = this;
  n.parser = r;
  function r(i) {
    return SU(i, {
      ...n.data("settings"),
      ...e,
      // Note: these options are not in the readme.
      // The goal is for them to be set by plugins on `data` instead of being
      // passed by users.
      extensions: n.data("micromarkExtensions") || [],
      mdastExtensions: n.data("fromMarkdownExtensions") || []
    });
  }
}
function CU(e, n) {
  const r = {
    type: "element",
    tagName: "blockquote",
    properties: {},
    children: e.wrap(e.all(n), !0)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function FU(e, n) {
  const r = { type: "element", tagName: "br", properties: {}, children: [] };
  return e.patch(n, r), [e.applyData(n, r), { type: "text", value: `
` }];
}
function IU(e, n) {
  const r = n.value ? n.value + `
` : "", i = {}, a = n.lang ? n.lang.split(/\s+/) : [];
  a.length > 0 && (i.className = ["language-" + a[0]]);
  let o = {
    type: "element",
    tagName: "code",
    properties: i,
    children: [{ type: "text", value: r }]
  };
  return n.meta && (o.data = { meta: n.meta }), e.patch(n, o), o = e.applyData(n, o), o = { type: "element", tagName: "pre", properties: {}, children: [o] }, e.patch(n, o), o;
}
function $U(e, n) {
  const r = {
    type: "element",
    tagName: "del",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function EU(e, n) {
  const r = {
    type: "element",
    tagName: "em",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function TU(e, n) {
  const r = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", i = String(n.identifier).toUpperCase(), a = Pa(i.toLowerCase()), o = e.footnoteOrder.indexOf(i);
  let s, l = e.footnoteCounts.get(i);
  l === void 0 ? (l = 0, e.footnoteOrder.push(i), s = e.footnoteOrder.length) : s = o + 1, l += 1, e.footnoteCounts.set(i, l);
  const c = {
    type: "element",
    tagName: "a",
    properties: {
      href: "#" + r + "fn-" + a,
      id: r + "fnref-" + a + (l > 1 ? "-" + l : ""),
      dataFootnoteRef: !0,
      ariaDescribedBy: ["footnote-label"]
    },
    children: [{ type: "text", value: String(s) }]
  };
  e.patch(n, c);
  const m = {
    type: "element",
    tagName: "sup",
    properties: {},
    children: [c]
  };
  return e.patch(n, m), e.applyData(n, m);
}
function RU(e, n) {
  const r = {
    type: "element",
    tagName: "h" + n.depth,
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function DU(e, n) {
  if (e.options.allowDangerousHtml) {
    const r = { type: "raw", value: n.value };
    return e.patch(n, r), e.applyData(n, r);
  }
}
function R1(e, n) {
  const r = n.referenceType;
  let i = "]";
  if (r === "collapsed" ? i += "[]" : r === "full" && (i += "[" + (n.label || n.identifier) + "]"), n.type === "imageReference")
    return [{ type: "text", value: "![" + n.alt + i }];
  const a = e.all(n), o = a[0];
  o && o.type === "text" ? o.value = "[" + o.value : a.unshift({ type: "text", value: "[" });
  const s = a[a.length - 1];
  return s && s.type === "text" ? s.value += i : a.push({ type: "text", value: i }), a;
}
function OU(e, n) {
  const r = String(n.identifier).toUpperCase(), i = e.definitionById.get(r);
  if (!i)
    return R1(e, n);
  const a = { src: Pa(i.url || ""), alt: n.alt };
  i.title !== null && i.title !== void 0 && (a.title = i.title);
  const o = { type: "element", tagName: "img", properties: a, children: [] };
  return e.patch(n, o), e.applyData(n, o);
}
function PU(e, n) {
  const r = { src: Pa(n.url) };
  n.alt !== null && n.alt !== void 0 && (r.alt = n.alt), n.title !== null && n.title !== void 0 && (r.title = n.title);
  const i = { type: "element", tagName: "img", properties: r, children: [] };
  return e.patch(n, i), e.applyData(n, i);
}
function AU(e, n) {
  const r = { type: "text", value: n.value.replace(/\r?\n|\r/g, " ") };
  e.patch(n, r);
  const i = {
    type: "element",
    tagName: "code",
    properties: {},
    children: [r]
  };
  return e.patch(n, i), e.applyData(n, i);
}
function LU(e, n) {
  const r = String(n.identifier).toUpperCase(), i = e.definitionById.get(r);
  if (!i)
    return R1(e, n);
  const a = { href: Pa(i.url || "") };
  i.title !== null && i.title !== void 0 && (a.title = i.title);
  const o = {
    type: "element",
    tagName: "a",
    properties: a,
    children: e.all(n)
  };
  return e.patch(n, o), e.applyData(n, o);
}
function VU(e, n) {
  const r = { href: Pa(n.url) };
  n.title !== null && n.title !== void 0 && (r.title = n.title);
  const i = {
    type: "element",
    tagName: "a",
    properties: r,
    children: e.all(n)
  };
  return e.patch(n, i), e.applyData(n, i);
}
function zU(e, n, r) {
  const i = e.all(n), a = r ? UU(r) : D1(n), o = {}, s = [];
  if (typeof n.checked == "boolean") {
    const u = i[0];
    let f;
    u && u.type === "element" && u.tagName === "p" ? f = u : (f = { type: "element", tagName: "p", properties: {}, children: [] }, i.unshift(f)), f.children.length > 0 && f.children.unshift({ type: "text", value: " " }), f.children.unshift({
      type: "element",
      tagName: "input",
      properties: { type: "checkbox", checked: n.checked, disabled: !0 },
      children: []
    }), o.className = ["task-list-item"];
  }
  let l = -1;
  for (; ++l < i.length; ) {
    const u = i[l];
    (a || l !== 0 || u.type !== "element" || u.tagName !== "p") && s.push({ type: "text", value: `
` }), u.type === "element" && u.tagName === "p" && !a ? s.push(...u.children) : s.push(u);
  }
  const c = i[i.length - 1];
  c && (a || c.type !== "element" || c.tagName !== "p") && s.push({ type: "text", value: `
` });
  const m = { type: "element", tagName: "li", properties: o, children: s };
  return e.patch(n, m), e.applyData(n, m);
}
function UU(e) {
  let n = !1;
  if (e.type === "list") {
    n = e.spread || !1;
    const r = e.children;
    let i = -1;
    for (; !n && ++i < r.length; )
      n = D1(r[i]);
  }
  return n;
}
function D1(e) {
  const n = e.spread;
  return n ?? e.children.length > 1;
}
function MU(e, n) {
  const r = {}, i = e.all(n);
  let a = -1;
  for (typeof n.start == "number" && n.start !== 1 && (r.start = n.start); ++a < i.length; ) {
    const s = i[a];
    if (s.type === "element" && s.tagName === "li" && s.properties && Array.isArray(s.properties.className) && s.properties.className.includes("task-list-item")) {
      r.className = ["contains-task-list"];
      break;
    }
  }
  const o = {
    type: "element",
    tagName: n.ordered ? "ol" : "ul",
    properties: r,
    children: e.wrap(i, !0)
  };
  return e.patch(n, o), e.applyData(n, o);
}
function BU(e, n) {
  const r = {
    type: "element",
    tagName: "p",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function qU(e, n) {
  const r = { type: "root", children: e.wrap(e.all(n)) };
  return e.patch(n, r), e.applyData(n, r);
}
function HU(e, n) {
  const r = {
    type: "element",
    tagName: "strong",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function WU(e, n) {
  const r = e.all(n), i = r.shift(), a = [];
  if (i) {
    const s = {
      type: "element",
      tagName: "thead",
      properties: {},
      children: e.wrap([i], !0)
    };
    e.patch(n.children[0], s), a.push(s);
  }
  if (r.length > 0) {
    const s = {
      type: "element",
      tagName: "tbody",
      properties: {},
      children: e.wrap(r, !0)
    }, l = kg(n.children[1]), c = f1(n.children[n.children.length - 1]);
    l && c && (s.position = { start: l, end: c }), a.push(s);
  }
  const o = {
    type: "element",
    tagName: "table",
    properties: {},
    children: e.wrap(a, !0)
  };
  return e.patch(n, o), e.applyData(n, o);
}
function KU(e, n, r) {
  const i = r ? r.children : void 0, o = (i ? i.indexOf(n) : 1) === 0 ? "th" : "td", s = r && r.type === "table" ? r.align : void 0, l = s ? s.length : n.children.length;
  let c = -1;
  const m = [];
  for (; ++c < l; ) {
    const f = n.children[c], h = {}, k = s ? s[c] : void 0;
    k && (h.align = k);
    let w = { type: "element", tagName: o, properties: h, children: [] };
    f && (w.children = e.all(f), e.patch(f, w), w = e.applyData(f, w)), m.push(w);
  }
  const u = {
    type: "element",
    tagName: "tr",
    properties: {},
    children: e.wrap(m, !0)
  };
  return e.patch(n, u), e.applyData(n, u);
}
function GU(e, n) {
  const r = {
    type: "element",
    tagName: "td",
    // Assume body cell.
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
const zx = 9, Ux = 32;
function YU(e) {
  const n = String(e), r = /\r?\n|\r/g;
  let i = r.exec(n), a = 0;
  const o = [];
  for (; i; )
    o.push(
      Mx(n.slice(a, i.index), a > 0, !0),
      i[0]
    ), a = i.index + i[0].length, i = r.exec(n);
  return o.push(Mx(n.slice(a), a > 0, !1)), o.join("");
}
function Mx(e, n, r) {
  let i = 0, a = e.length;
  if (n) {
    let o = e.codePointAt(i);
    for (; o === zx || o === Ux; )
      i++, o = e.codePointAt(i);
  }
  if (r) {
    let o = e.codePointAt(a - 1);
    for (; o === zx || o === Ux; )
      a--, o = e.codePointAt(a - 1);
  }
  return a > i ? e.slice(i, a) : "";
}
function JU(e, n) {
  const r = { type: "text", value: YU(String(n.value)) };
  return e.patch(n, r), e.applyData(n, r);
}
function QU(e, n) {
  const r = {
    type: "element",
    tagName: "hr",
    properties: {},
    children: []
  };
  return e.patch(n, r), e.applyData(n, r);
}
const XU = {
  blockquote: CU,
  break: FU,
  code: IU,
  delete: $U,
  emphasis: EU,
  footnoteReference: TU,
  heading: RU,
  html: DU,
  imageReference: OU,
  image: PU,
  inlineCode: AU,
  linkReference: LU,
  link: VU,
  listItem: zU,
  list: MU,
  paragraph: BU,
  // @ts-expect-error: root is different, but hard to type.
  root: qU,
  strong: HU,
  table: WU,
  tableCell: GU,
  tableRow: KU,
  text: JU,
  thematicBreak: QU,
  toml: xs,
  yaml: xs,
  definition: xs,
  footnoteDefinition: xs
};
function xs() {
}
const O1 = -1, od = 0, Nl = 1, jl = 2, wg = 3, Cg = 4, Fg = 5, Ig = 6, P1 = 7, A1 = 8, Bx = typeof self == "object" ? self : globalThis, ZU = (e, n) => {
  const r = (a, o) => (e.set(o, a), a), i = (a) => {
    if (e.has(a))
      return e.get(a);
    const [o, s] = n[a];
    switch (o) {
      case od:
      case O1:
        return r(s, a);
      case Nl: {
        const l = r([], a);
        for (const c of s)
          l.push(i(c));
        return l;
      }
      case jl: {
        const l = r({}, a);
        for (const [c, m] of s)
          l[i(c)] = i(m);
        return l;
      }
      case wg:
        return r(new Date(s), a);
      case Cg: {
        const { source: l, flags: c } = s;
        return r(new RegExp(l, c), a);
      }
      case Fg: {
        const l = r(/* @__PURE__ */ new Map(), a);
        for (const [c, m] of s)
          l.set(i(c), i(m));
        return l;
      }
      case Ig: {
        const l = r(/* @__PURE__ */ new Set(), a);
        for (const c of s)
          l.add(i(c));
        return l;
      }
      case P1: {
        const { name: l, message: c } = s;
        return r(new Bx[l](c), a);
      }
      case A1:
        return r(BigInt(s), a);
      case "BigInt":
        return r(Object(BigInt(s)), a);
    }
    return r(new Bx[o](s), a);
  };
  return i;
}, qx = (e) => ZU(/* @__PURE__ */ new Map(), e)(0), ia = "", { toString: eM } = {}, { keys: nM } = Object, ao = (e) => {
  const n = typeof e;
  if (n !== "object" || !e)
    return [od, n];
  const r = eM.call(e).slice(8, -1);
  switch (r) {
    case "Array":
      return [Nl, ia];
    case "Object":
      return [jl, ia];
    case "Date":
      return [wg, ia];
    case "RegExp":
      return [Cg, ia];
    case "Map":
      return [Fg, ia];
    case "Set":
      return [Ig, ia];
  }
  return r.includes("Array") ? [Nl, r] : r.includes("Error") ? [P1, r] : [jl, r];
}, Ss = ([e, n]) => e === od && (n === "function" || n === "symbol"), tM = (e, n, r, i) => {
  const a = (s, l) => {
    const c = i.push(s) - 1;
    return r.set(l, c), c;
  }, o = (s) => {
    if (r.has(s))
      return r.get(s);
    let [l, c] = ao(s);
    switch (l) {
      case od: {
        let u = s;
        switch (c) {
          case "bigint":
            l = A1, u = s.toString();
            break;
          case "function":
          case "symbol":
            if (e)
              throw new TypeError("unable to serialize " + c);
            u = null;
            break;
          case "undefined":
            return a([O1], s);
        }
        return a([l, u], s);
      }
      case Nl: {
        if (c)
          return a([c, [...s]], s);
        const u = [], f = a([l, u], s);
        for (const h of s)
          u.push(o(h));
        return f;
      }
      case jl: {
        if (c)
          switch (c) {
            case "BigInt":
              return a([c, s.toString()], s);
            case "Boolean":
            case "Number":
            case "String":
              return a([c, s.valueOf()], s);
          }
        if (n && "toJSON" in s)
          return o(s.toJSON());
        const u = [], f = a([l, u], s);
        for (const h of nM(s))
          (e || !Ss(ao(s[h]))) && u.push([o(h), o(s[h])]);
        return f;
      }
      case wg:
        return a([l, s.toISOString()], s);
      case Cg: {
        const { source: u, flags: f } = s;
        return a([l, { source: u, flags: f }], s);
      }
      case Fg: {
        const u = [], f = a([l, u], s);
        for (const [h, k] of s)
          (e || !(Ss(ao(h)) || Ss(ao(k)))) && u.push([o(h), o(k)]);
        return f;
      }
      case Ig: {
        const u = [], f = a([l, u], s);
        for (const h of s)
          (e || !Ss(ao(h))) && u.push(o(h));
        return f;
      }
    }
    const { message: m } = s;
    return a([l, { name: c, message: m }], s);
  };
  return o;
}, Hx = (e, { json: n, lossy: r } = {}) => {
  const i = [];
  return tM(!(n || r), !!n, /* @__PURE__ */ new Map(), i)(e), i;
}, wl = typeof structuredClone == "function" ? (
  /* c8 ignore start */
  (e, n) => n && ("json" in n || "lossy" in n) ? qx(Hx(e, n)) : structuredClone(e)
) : (e, n) => qx(Hx(e, n));
function rM(e, n) {
  const r = [{ type: "text", value: "↩" }];
  return n > 1 && r.push({
    type: "element",
    tagName: "sup",
    properties: {},
    children: [{ type: "text", value: String(n) }]
  }), r;
}
function iM(e, n) {
  return "Back to reference " + (e + 1) + (n > 1 ? "-" + n : "");
}
function aM(e) {
  const n = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", r = e.options.footnoteBackContent || rM, i = e.options.footnoteBackLabel || iM, a = e.options.footnoteLabel || "Footnotes", o = e.options.footnoteLabelTagName || "h2", s = e.options.footnoteLabelProperties || {
    className: ["sr-only"]
  }, l = [];
  let c = -1;
  for (; ++c < e.footnoteOrder.length; ) {
    const m = e.footnoteById.get(
      e.footnoteOrder[c]
    );
    if (!m)
      continue;
    const u = e.all(m), f = String(m.identifier).toUpperCase(), h = Pa(f.toLowerCase());
    let k = 0;
    const w = [], N = e.footnoteCounts.get(f);
    for (; N !== void 0 && ++k <= N; ) {
      w.length > 0 && w.push({ type: "text", value: " " });
      let g = typeof r == "string" ? r : r(c, k);
      typeof g == "string" && (g = { type: "text", value: g }), w.push({
        type: "element",
        tagName: "a",
        properties: {
          href: "#" + n + "fnref-" + h + (k > 1 ? "-" + k : ""),
          dataFootnoteBackref: "",
          ariaLabel: typeof i == "string" ? i : i(c, k),
          className: ["data-footnote-backref"]
        },
        children: Array.isArray(g) ? g : [g]
      });
    }
    const j = u[u.length - 1];
    if (j && j.type === "element" && j.tagName === "p") {
      const g = j.children[j.children.length - 1];
      g && g.type === "text" ? g.value += " " : j.children.push({ type: "text", value: " " }), j.children.push(...w);
    } else
      u.push(...w);
    const _ = {
      type: "element",
      tagName: "li",
      properties: { id: n + "fn-" + h },
      children: e.wrap(u, !0)
    };
    e.patch(m, _), l.push(_);
  }
  if (l.length !== 0)
    return {
      type: "element",
      tagName: "section",
      properties: { dataFootnotes: !0, className: ["footnotes"] },
      children: [
        {
          type: "element",
          tagName: o,
          properties: {
            ...wl(s),
            id: "footnote-label"
          },
          children: [{ type: "text", value: a }]
        },
        { type: "text", value: `
` },
        {
          type: "element",
          tagName: "ol",
          properties: {},
          children: e.wrap(l, !0)
        },
        { type: "text", value: `
` }
      ]
    };
}
const L1 = (
  // Note: overloads in JSDoc can’t yet use different `@template`s.
  /**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {Check}
   */
  (function(e) {
    if (e == null)
      return dM;
    if (typeof e == "function")
      return sd(e);
    if (typeof e == "object")
      return Array.isArray(e) ? oM(e) : sM(e);
    if (typeof e == "string")
      return lM(e);
    throw new Error("Expected function, string, or object as test");
  })
);
function oM(e) {
  const n = [];
  let r = -1;
  for (; ++r < e.length; )
    n[r] = L1(e[r]);
  return sd(i);
  function i(...a) {
    let o = -1;
    for (; ++o < n.length; )
      if (n[o].apply(this, a)) return !0;
    return !1;
  }
}
function sM(e) {
  const n = (
    /** @type {Record<string, unknown>} */
    e
  );
  return sd(r);
  function r(i) {
    const a = (
      /** @type {Record<string, unknown>} */
      /** @type {unknown} */
      i
    );
    let o;
    for (o in e)
      if (a[o] !== n[o]) return !1;
    return !0;
  }
}
function lM(e) {
  return sd(n);
  function n(r) {
    return r && r.type === e;
  }
}
function sd(e) {
  return n;
  function n(r, i, a) {
    return !!(cM(r) && e.call(
      this,
      r,
      typeof i == "number" ? i : void 0,
      a || void 0
    ));
  }
}
function dM() {
  return !0;
}
function cM(e) {
  return e !== null && typeof e == "object" && "type" in e;
}
const V1 = [], uM = !0, Wx = !1, mM = "skip";
function pM(e, n, r, i) {
  let a;
  typeof n == "function" && typeof r != "function" ? (i = r, r = n) : a = n;
  const o = L1(a), s = i ? -1 : 1;
  l(e, void 0, [])();
  function l(c, m, u) {
    const f = (
      /** @type {Record<string, unknown>} */
      c && typeof c == "object" ? c : {}
    );
    if (typeof f.type == "string") {
      const k = (
        // `hast`
        typeof f.tagName == "string" ? f.tagName : (
          // `xast`
          typeof f.name == "string" ? f.name : void 0
        )
      );
      Object.defineProperty(h, "name", {
        value: "node (" + (c.type + (k ? "<" + k + ">" : "")) + ")"
      });
    }
    return h;
    function h() {
      let k = V1, w, N, j;
      if ((!n || o(c, m, u[u.length - 1] || void 0)) && (k = fM(r(c, u)), k[0] === Wx))
        return k;
      if ("children" in c && c.children) {
        const _ = (
          /** @type {UnistParent} */
          c
        );
        if (_.children && k[0] !== mM)
          for (N = (i ? _.children.length : -1) + s, j = u.concat(_); N > -1 && N < _.children.length; ) {
            const g = _.children[N];
            if (w = l(g, N, j)(), w[0] === Wx)
              return w;
            N = typeof w[1] == "number" ? w[1] : N + s;
          }
      }
      return k;
    }
  }
}
function fM(e) {
  return Array.isArray(e) ? e : typeof e == "number" ? [uM, e] : e == null ? V1 : [e];
}
function z1(e, n, r, i) {
  let a, o, s;
  typeof n == "function" && typeof r != "function" ? (o = void 0, s = n, a = r) : (o = n, s = r, a = i), pM(e, o, l, a);
  function l(c, m) {
    const u = m[m.length - 1], f = u ? u.children.indexOf(c) : void 0;
    return s(c, f, u);
  }
}
const my = {}.hasOwnProperty, hM = {};
function yM(e, n) {
  const r = n || hM, i = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Map(), s = { ...XU, ...r.handlers }, l = {
    all: m,
    applyData: vM,
    definitionById: i,
    footnoteById: a,
    footnoteCounts: o,
    footnoteOrder: [],
    handlers: s,
    one: c,
    options: r,
    patch: gM,
    wrap: bM
  };
  return z1(e, function(u) {
    if (u.type === "definition" || u.type === "footnoteDefinition") {
      const f = u.type === "definition" ? i : a, h = String(u.identifier).toUpperCase();
      f.has(h) || f.set(h, u);
    }
  }), l;
  function c(u, f) {
    const h = u.type, k = l.handlers[h];
    if (my.call(l.handlers, h) && k)
      return k(l, u, f);
    if (l.options.passThrough && l.options.passThrough.includes(h)) {
      if ("children" in u) {
        const { children: N, ...j } = u, _ = wl(j);
        return _.children = l.all(u), _;
      }
      return wl(u);
    }
    return (l.options.unknownHandler || kM)(l, u, f);
  }
  function m(u) {
    const f = [];
    if ("children" in u) {
      const h = u.children;
      let k = -1;
      for (; ++k < h.length; ) {
        const w = l.one(h[k], u);
        if (w) {
          if (k && h[k - 1].type === "break" && (!Array.isArray(w) && w.type === "text" && (w.value = Kx(w.value)), !Array.isArray(w) && w.type === "element")) {
            const N = w.children[0];
            N && N.type === "text" && (N.value = Kx(N.value));
          }
          Array.isArray(w) ? f.push(...w) : f.push(w);
        }
      }
    }
    return f;
  }
}
function gM(e, n) {
  e.position && (n.position = XV(e));
}
function vM(e, n) {
  let r = n;
  if (e && e.data) {
    const i = e.data.hName, a = e.data.hChildren, o = e.data.hProperties;
    if (typeof i == "string")
      if (r.type === "element")
        r.tagName = i;
      else {
        const s = "children" in r ? r.children : [r];
        r = { type: "element", tagName: i, properties: {}, children: s };
      }
    r.type === "element" && o && Object.assign(r.properties, wl(o)), "children" in r && r.children && a !== null && a !== void 0 && (r.children = a);
  }
  return r;
}
function kM(e, n) {
  const r = n.data || {}, i = "value" in n && !(my.call(r, "hProperties") || my.call(r, "hChildren")) ? { type: "text", value: n.value } : {
    type: "element",
    tagName: "div",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, i), e.applyData(n, i);
}
function bM(e, n) {
  const r = [];
  let i = -1;
  for (n && r.push({ type: "text", value: `
` }); ++i < e.length; )
    i && r.push({ type: "text", value: `
` }), r.push(e[i]);
  return n && e.length > 0 && r.push({ type: "text", value: `
` }), r;
}
function Kx(e) {
  let n = 0, r = e.charCodeAt(n);
  for (; r === 9 || r === 32; )
    n++, r = e.charCodeAt(n);
  return e.slice(n);
}
function Gx(e, n) {
  const r = yM(e, n), i = r.one(e, void 0), a = aM(r), o = Array.isArray(i) ? { type: "root", children: i } : i || { type: "root", children: [] };
  return a && o.children.push({ type: "text", value: `
` }, a), o;
}
function _M(e, n) {
  return e && "run" in e ? async function(r, i) {
    const a = (
      /** @type {HastRoot} */
      Gx(r, { file: i, ...n })
    );
    await e.run(a, i);
  } : function(r, i) {
    return (
      /** @type {HastRoot} */
      Gx(r, { file: i, ...e || n })
    );
  };
}
function Yx(e) {
  if (e)
    throw e;
}
var Cm, Jx;
function xM() {
  if (Jx) return Cm;
  Jx = 1;
  var e = Object.prototype.hasOwnProperty, n = Object.prototype.toString, r = Object.defineProperty, i = Object.getOwnPropertyDescriptor, a = function(m) {
    return typeof Array.isArray == "function" ? Array.isArray(m) : n.call(m) === "[object Array]";
  }, o = function(m) {
    if (!m || n.call(m) !== "[object Object]")
      return !1;
    var u = e.call(m, "constructor"), f = m.constructor && m.constructor.prototype && e.call(m.constructor.prototype, "isPrototypeOf");
    if (m.constructor && !u && !f)
      return !1;
    var h;
    for (h in m)
      ;
    return typeof h > "u" || e.call(m, h);
  }, s = function(m, u) {
    r && u.name === "__proto__" ? r(m, u.name, {
      enumerable: !0,
      configurable: !0,
      value: u.newValue,
      writable: !0
    }) : m[u.name] = u.newValue;
  }, l = function(m, u) {
    if (u === "__proto__")
      if (e.call(m, u)) {
        if (i)
          return i(m, u).value;
      } else return;
    return m[u];
  };
  return Cm = function c() {
    var m, u, f, h, k, w, N = arguments[0], j = 1, _ = arguments.length, g = !1;
    for (typeof N == "boolean" && (g = N, N = arguments[1] || {}, j = 2), (N == null || typeof N != "object" && typeof N != "function") && (N = {}); j < _; ++j)
      if (m = arguments[j], m != null)
        for (u in m)
          f = l(N, u), h = l(m, u), N !== h && (g && h && (o(h) || (k = a(h))) ? (k ? (k = !1, w = f && a(f) ? f : []) : w = f && o(f) ? f : {}, s(N, { name: u, newValue: c(g, w, h) })) : typeof h < "u" && s(N, { name: u, newValue: h }));
    return N;
  }, Cm;
}
var SM = xM();
const Fm = /* @__PURE__ */ Ty(SM);
function py(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const n = Object.getPrototypeOf(e);
  return (n === null || n === Object.prototype || Object.getPrototypeOf(n) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function NM() {
  const e = [], n = { run: r, use: i };
  return n;
  function r(...a) {
    let o = -1;
    const s = a.pop();
    if (typeof s != "function")
      throw new TypeError("Expected function as last argument, not " + s);
    l(null, ...a);
    function l(c, ...m) {
      const u = e[++o];
      let f = -1;
      if (c) {
        s(c);
        return;
      }
      for (; ++f < a.length; )
        (m[f] === null || m[f] === void 0) && (m[f] = a[f]);
      a = m, u ? jM(u, l)(...m) : s(null, ...m);
    }
  }
  function i(a) {
    if (typeof a != "function")
      throw new TypeError(
        "Expected `middelware` to be a function, not " + a
      );
    return e.push(a), n;
  }
}
function jM(e, n) {
  let r;
  return i;
  function i(...s) {
    const l = e.length > s.length;
    let c;
    l && s.push(a);
    try {
      c = e.apply(this, s);
    } catch (m) {
      const u = (
        /** @type {Error} */
        m
      );
      if (l && r)
        throw u;
      return a(u);
    }
    l || (c instanceof Promise ? c.then(o, a) : c instanceof Error ? a(c) : o(c));
  }
  function a(s, ...l) {
    r || (r = !0, n(s, ...l));
  }
  function o(s) {
    a(null, s);
  }
}
const Vr = { basename: wM, dirname: CM, extname: FM, join: IM, sep: "/" };
function wM(e, n) {
  if (n !== void 0 && typeof n != "string")
    throw new TypeError('"ext" argument must be a string');
  rs(e);
  let r = 0, i = -1, a = e.length, o;
  if (n === void 0 || n.length === 0 || n.length > e.length) {
    for (; a--; )
      if (e.codePointAt(a) === 47) {
        if (o) {
          r = a + 1;
          break;
        }
      } else i < 0 && (o = !0, i = a + 1);
    return i < 0 ? "" : e.slice(r, i);
  }
  if (n === e)
    return "";
  let s = -1, l = n.length - 1;
  for (; a--; )
    if (e.codePointAt(a) === 47) {
      if (o) {
        r = a + 1;
        break;
      }
    } else
      s < 0 && (o = !0, s = a + 1), l > -1 && (e.codePointAt(a) === n.codePointAt(l--) ? l < 0 && (i = a) : (l = -1, i = s));
  return r === i ? i = s : i < 0 && (i = e.length), e.slice(r, i);
}
function CM(e) {
  if (rs(e), e.length === 0)
    return ".";
  let n = -1, r = e.length, i;
  for (; --r; )
    if (e.codePointAt(r) === 47) {
      if (i) {
        n = r;
        break;
      }
    } else i || (i = !0);
  return n < 0 ? e.codePointAt(0) === 47 ? "/" : "." : n === 1 && e.codePointAt(0) === 47 ? "//" : e.slice(0, n);
}
function FM(e) {
  rs(e);
  let n = e.length, r = -1, i = 0, a = -1, o = 0, s;
  for (; n--; ) {
    const l = e.codePointAt(n);
    if (l === 47) {
      if (s) {
        i = n + 1;
        break;
      }
      continue;
    }
    r < 0 && (s = !0, r = n + 1), l === 46 ? a < 0 ? a = n : o !== 1 && (o = 1) : a > -1 && (o = -1);
  }
  return a < 0 || r < 0 || // We saw a non-dot character immediately before the dot.
  o === 0 || // The (right-most) trimmed path component is exactly `..`.
  o === 1 && a === r - 1 && a === i + 1 ? "" : e.slice(a, r);
}
function IM(...e) {
  let n = -1, r;
  for (; ++n < e.length; )
    rs(e[n]), e[n] && (r = r === void 0 ? e[n] : r + "/" + e[n]);
  return r === void 0 ? "." : $M(r);
}
function $M(e) {
  rs(e);
  const n = e.codePointAt(0) === 47;
  let r = EM(e, !n);
  return r.length === 0 && !n && (r = "."), r.length > 0 && e.codePointAt(e.length - 1) === 47 && (r += "/"), n ? "/" + r : r;
}
function EM(e, n) {
  let r = "", i = 0, a = -1, o = 0, s = -1, l, c;
  for (; ++s <= e.length; ) {
    if (s < e.length)
      l = e.codePointAt(s);
    else {
      if (l === 47)
        break;
      l = 47;
    }
    if (l === 47) {
      if (!(a === s - 1 || o === 1)) if (a !== s - 1 && o === 2) {
        if (r.length < 2 || i !== 2 || r.codePointAt(r.length - 1) !== 46 || r.codePointAt(r.length - 2) !== 46) {
          if (r.length > 2) {
            if (c = r.lastIndexOf("/"), c !== r.length - 1) {
              c < 0 ? (r = "", i = 0) : (r = r.slice(0, c), i = r.length - 1 - r.lastIndexOf("/")), a = s, o = 0;
              continue;
            }
          } else if (r.length > 0) {
            r = "", i = 0, a = s, o = 0;
            continue;
          }
        }
        n && (r = r.length > 0 ? r + "/.." : "..", i = 2);
      } else
        r.length > 0 ? r += "/" + e.slice(a + 1, s) : r = e.slice(a + 1, s), i = s - a - 1;
      a = s, o = 0;
    } else l === 46 && o > -1 ? o++ : o = -1;
  }
  return r;
}
function rs(e) {
  if (typeof e != "string")
    throw new TypeError(
      "Path must be a string. Received " + JSON.stringify(e)
    );
}
const TM = { cwd: RM };
function RM() {
  return "/";
}
function fy(e) {
  return !!(e !== null && typeof e == "object" && "href" in e && e.href && "protocol" in e && e.protocol && // @ts-expect-error: indexing is fine.
  e.auth === void 0);
}
function DM(e) {
  if (typeof e == "string")
    e = new URL(e);
  else if (!fy(e)) {
    const n = new TypeError(
      'The "path" argument must be of type string or an instance of URL. Received `' + e + "`"
    );
    throw n.code = "ERR_INVALID_ARG_TYPE", n;
  }
  if (e.protocol !== "file:") {
    const n = new TypeError("The URL must be of scheme file");
    throw n.code = "ERR_INVALID_URL_SCHEME", n;
  }
  return OM(e);
}
function OM(e) {
  if (e.hostname !== "") {
    const i = new TypeError(
      'File URL host must be "localhost" or empty on darwin'
    );
    throw i.code = "ERR_INVALID_FILE_URL_HOST", i;
  }
  const n = e.pathname;
  let r = -1;
  for (; ++r < n.length; )
    if (n.codePointAt(r) === 37 && n.codePointAt(r + 1) === 50) {
      const i = n.codePointAt(r + 2);
      if (i === 70 || i === 102) {
        const a = new TypeError(
          "File URL path must not include encoded / characters"
        );
        throw a.code = "ERR_INVALID_FILE_URL_PATH", a;
      }
    }
  return decodeURIComponent(n);
}
const Im = (
  /** @type {const} */
  [
    "history",
    "path",
    "basename",
    "stem",
    "extname",
    "dirname"
  ]
);
class U1 {
  /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Uint8Array` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */
  constructor(n) {
    let r;
    n ? fy(n) ? r = { path: n } : typeof n == "string" || PM(n) ? r = { value: n } : r = n : r = {}, this.cwd = "cwd" in r ? "" : TM.cwd(), this.data = {}, this.history = [], this.messages = [], this.value, this.map, this.result, this.stored;
    let i = -1;
    for (; ++i < Im.length; ) {
      const o = Im[i];
      o in r && r[o] !== void 0 && r[o] !== null && (this[o] = o === "history" ? [...r[o]] : r[o]);
    }
    let a;
    for (a in r)
      Im.includes(a) || (this[a] = r[a]);
  }
  /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   *
   * @returns {string | undefined}
   *   Basename.
   */
  get basename() {
    return typeof this.path == "string" ? Vr.basename(this.path) : void 0;
  }
  /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} basename
   *   Basename.
   * @returns {undefined}
   *   Nothing.
   */
  set basename(n) {
    Em(n, "basename"), $m(n, "basename"), this.path = Vr.join(this.dirname || "", n);
  }
  /**
   * Get the parent path (example: `'~'`).
   *
   * @returns {string | undefined}
   *   Dirname.
   */
  get dirname() {
    return typeof this.path == "string" ? Vr.dirname(this.path) : void 0;
  }
  /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} dirname
   *   Dirname.
   * @returns {undefined}
   *   Nothing.
   */
  set dirname(n) {
    Qx(this.basename, "dirname"), this.path = Vr.join(n || "", this.basename);
  }
  /**
   * Get the extname (including dot) (example: `'.js'`).
   *
   * @returns {string | undefined}
   *   Extname.
   */
  get extname() {
    return typeof this.path == "string" ? Vr.extname(this.path) : void 0;
  }
  /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} extname
   *   Extname.
   * @returns {undefined}
   *   Nothing.
   */
  set extname(n) {
    if ($m(n, "extname"), Qx(this.dirname, "extname"), n) {
      if (n.codePointAt(0) !== 46)
        throw new Error("`extname` must start with `.`");
      if (n.includes(".", 1))
        throw new Error("`extname` cannot contain multiple dots");
    }
    this.path = Vr.join(this.dirname, this.stem + (n || ""));
  }
  /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   *   Path.
   */
  get path() {
    return this.history[this.history.length - 1];
  }
  /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {URL | string} path
   *   Path.
   * @returns {undefined}
   *   Nothing.
   */
  set path(n) {
    fy(n) && (n = DM(n)), Em(n, "path"), this.path !== n && this.history.push(n);
  }
  /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   *
   * @returns {string | undefined}
   *   Stem.
   */
  get stem() {
    return typeof this.path == "string" ? Vr.basename(this.path, this.extname) : void 0;
  }
  /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} stem
   *   Stem.
   * @returns {undefined}
   *   Nothing.
   */
  set stem(n) {
    Em(n, "stem"), $m(n, "stem"), this.path = Vr.join(this.dirname || "", n + (this.extname || ""));
  }
  // Normal prototypal methods.
  /**
   * Create a fatal message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `true` (error; file not usable)
   * and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Never.
   * @throws {VFileMessage}
   *   Message.
   */
  fail(n, r, i) {
    const a = this.message(n, r, i);
    throw a.fatal = !0, a;
  }
  /**
   * Create an info message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `undefined` (info; change
   * likely not needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  info(n, r, i) {
    const a = this.message(n, r, i);
    return a.fatal = void 0, a;
  }
  /**
   * Create a message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `false` (warning; change may be
   * needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  message(n, r, i) {
    const a = new Bt(
      // @ts-expect-error: the overloads are fine.
      n,
      r,
      i
    );
    return this.path && (a.name = this.path + ":" + a.name, a.file = this.path), a.fatal = !1, this.messages.push(a), a;
  }
  /**
   * Serialize the file.
   *
   * > **Note**: which encodings are supported depends on the engine.
   * > For info on Node.js, see:
   * > <https://nodejs.org/api/util.html#whatwg-supported-encodings>.
   *
   * @param {string | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Uint8Array`
   *   (default: `'utf-8'`).
   * @returns {string}
   *   Serialized file.
   */
  toString(n) {
    return this.value === void 0 ? "" : typeof this.value == "string" ? this.value : new TextDecoder(n || void 0).decode(this.value);
  }
}
function $m(e, n) {
  if (e && e.includes(Vr.sep))
    throw new Error(
      "`" + n + "` cannot be a path: did not expect `" + Vr.sep + "`"
    );
}
function Em(e, n) {
  if (!e)
    throw new Error("`" + n + "` cannot be empty");
}
function Qx(e, n) {
  if (!e)
    throw new Error("Setting `" + n + "` requires `path` to be set too");
}
function PM(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const AM = (
  /**
   * @type {new <Parameters extends Array<unknown>, Result>(property: string | symbol) => (...parameters: Parameters) => Result}
   */
  /** @type {unknown} */
  /**
   * @this {Function}
   * @param {string | symbol} property
   * @returns {(...parameters: Array<unknown>) => unknown}
   */
  (function(e) {
    const i = (
      /** @type {Record<string | symbol, Function>} */
      // Prototypes do exist.
      // type-coverage:ignore-next-line
      this.constructor.prototype
    ), a = i[e], o = function() {
      return a.apply(o, arguments);
    };
    return Object.setPrototypeOf(o, i), o;
  })
), LM = {}.hasOwnProperty;
class $g extends AM {
  /**
   * Create a processor.
   */
  constructor() {
    super("copy"), this.Compiler = void 0, this.Parser = void 0, this.attachers = [], this.compiler = void 0, this.freezeIndex = -1, this.frozen = void 0, this.namespace = {}, this.parser = void 0, this.transformers = NM();
  }
  /**
   * Copy a processor.
   *
   * @deprecated
   *   This is a private internal method and should not be used.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   New *unfrozen* processor ({@linkcode Processor}) that is
   *   configured to work the same as its ancestor.
   *   When the descendant processor is configured in the future it does not
   *   affect the ancestral processor.
   */
  copy() {
    const n = (
      /** @type {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>} */
      new $g()
    );
    let r = -1;
    for (; ++r < this.attachers.length; ) {
      const i = this.attachers[r];
      n.use(...i);
    }
    return n.data(Fm(!0, {}, this.namespace)), n;
  }
  /**
   * Configure the processor with info available to all plugins.
   * Information is stored in an object.
   *
   * Typically, options can be given to a specific plugin, but sometimes it
   * makes sense to have information shared with several plugins.
   * For example, a list of HTML elements that are self-closing, which is
   * needed during all phases.
   *
   * > **Note**: setting information cannot occur on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * > **Note**: to register custom data in TypeScript, augment the
   * > {@linkcode Data} interface.
   *
   * @example
   *   This example show how to get and set info:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   const processor = unified().data('alpha', 'bravo')
   *
   *   processor.data('alpha') // => 'bravo'
   *
   *   processor.data() // => {alpha: 'bravo'}
   *
   *   processor.data({charlie: 'delta'})
   *
   *   processor.data() // => {charlie: 'delta'}
   *   ```
   *
   * @template {keyof Data} Key
   *
   * @overload
   * @returns {Data}
   *
   * @overload
   * @param {Data} dataset
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Key} key
   * @returns {Data[Key]}
   *
   * @overload
   * @param {Key} key
   * @param {Data[Key]} value
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @param {Data | Key} [key]
   *   Key to get or set, or entire dataset to set, or nothing to get the
   *   entire dataset (optional).
   * @param {Data[Key]} [value]
   *   Value to set (optional).
   * @returns {unknown}
   *   The current processor when setting, the value at `key` when getting, or
   *   the entire dataset when getting without key.
   */
  data(n, r) {
    return typeof n == "string" ? arguments.length === 2 ? (Dm("data", this.frozen), this.namespace[n] = r, this) : LM.call(this.namespace, n) && this.namespace[n] || void 0 : n ? (Dm("data", this.frozen), this.namespace = n, this) : this.namespace;
  }
  /**
   * Freeze a processor.
   *
   * Frozen processors are meant to be extended and not to be configured
   * directly.
   *
   * When a processor is frozen it cannot be unfrozen.
   * New processors working the same way can be created by calling the
   * processor.
   *
   * It’s possible to freeze processors explicitly by calling `.freeze()`.
   * Processors freeze automatically when `.parse()`, `.run()`, `.runSync()`,
   * `.stringify()`, `.process()`, or `.processSync()` are called.
   *
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   The current processor.
   */
  freeze() {
    if (this.frozen)
      return this;
    const n = (
      /** @type {Processor} */
      /** @type {unknown} */
      this
    );
    for (; ++this.freezeIndex < this.attachers.length; ) {
      const [r, ...i] = this.attachers[this.freezeIndex];
      if (i[0] === !1)
        continue;
      i[0] === !0 && (i[0] = void 0);
      const a = r.call(n, ...i);
      typeof a == "function" && this.transformers.use(a);
    }
    return this.frozen = !0, this.freezeIndex = Number.POSITIVE_INFINITY, this;
  }
  /**
   * Parse text to a syntax tree.
   *
   * > **Note**: `parse` freezes the processor if not already *frozen*.
   *
   * > **Note**: `parse` performs the parse phase, not the run phase or other
   * > phases.
   *
   * @param {Compatible | undefined} [file]
   *   file to parse (optional); typically `string` or `VFile`; any value
   *   accepted as `x` in `new VFile(x)`.
   * @returns {ParseTree extends undefined ? Node : ParseTree}
   *   Syntax tree representing `file`.
   */
  parse(n) {
    this.freeze();
    const r = Ns(n), i = this.parser || this.Parser;
    return Tm("parse", i), i(String(r), r);
  }
  /**
   * Process the given file as configured on the processor.
   *
   * > **Note**: `process` freezes the processor if not already *frozen*.
   *
   * > **Note**: `process` performs the parse, run, and stringify phases.
   *
   * @overload
   * @param {Compatible | undefined} file
   * @param {ProcessCallback<VFileWithOutput<CompileResult>>} done
   * @returns {undefined}
   *
   * @overload
   * @param {Compatible | undefined} [file]
   * @returns {Promise<VFileWithOutput<CompileResult>>}
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`]; any value accepted as
   *   `x` in `new VFile(x)`.
   * @param {ProcessCallback<VFileWithOutput<CompileResult>> | undefined} [done]
   *   Callback (optional).
   * @returns {Promise<VFile> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise a promise, rejected with a fatal error or resolved with the
   *   processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  process(n, r) {
    const i = this;
    return this.freeze(), Tm("process", this.parser || this.Parser), Rm("process", this.compiler || this.Compiler), r ? a(void 0, r) : new Promise(a);
    function a(o, s) {
      const l = Ns(n), c = (
        /** @type {HeadTree extends undefined ? Node : HeadTree} */
        /** @type {unknown} */
        i.parse(l)
      );
      i.run(c, l, function(u, f, h) {
        if (u || !f || !h)
          return m(u);
        const k = (
          /** @type {CompileTree extends undefined ? Node : CompileTree} */
          /** @type {unknown} */
          f
        ), w = i.stringify(k, h);
        UM(w) ? h.value = w : h.result = w, m(
          u,
          /** @type {VFileWithOutput<CompileResult>} */
          h
        );
      });
      function m(u, f) {
        u || !f ? s(u) : o ? o(f) : r(void 0, f);
      }
    }
  }
  /**
   * Process the given file as configured on the processor.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `processSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `processSync` performs the parse, run, and stringify phases.
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`; any value accepted as
   *   `x` in `new VFile(x)`.
   * @returns {VFileWithOutput<CompileResult>}
   *   The processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  processSync(n) {
    let r = !1, i;
    return this.freeze(), Tm("processSync", this.parser || this.Parser), Rm("processSync", this.compiler || this.Compiler), this.process(n, a), Zx("processSync", "process", r), i;
    function a(o, s) {
      r = !0, Yx(o), i = s;
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * > **Note**: `run` freezes the processor if not already *frozen*.
   *
   * > **Note**: `run` performs the run phase, not other phases.
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} file
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} [file]
   * @returns {Promise<TailTree extends undefined ? Node : TailTree>}
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {(
   *   RunCallback<TailTree extends undefined ? Node : TailTree> |
   *   Compatible
   * )} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} [done]
   *   Callback (optional).
   * @returns {Promise<TailTree extends undefined ? Node : TailTree> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise, a promise rejected with a fatal error or resolved with the
   *   transformed tree.
   */
  run(n, r, i) {
    Xx(n), this.freeze();
    const a = this.transformers;
    return !i && typeof r == "function" && (i = r, r = void 0), i ? o(void 0, i) : new Promise(o);
    function o(s, l) {
      const c = Ns(r);
      a.run(n, c, m);
      function m(u, f, h) {
        const k = (
          /** @type {TailTree extends undefined ? Node : TailTree} */
          f || n
        );
        u ? l(u) : s ? s(k) : i(void 0, k, h);
      }
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `runSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `runSync` performs the run phase, not other phases.
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {TailTree extends undefined ? Node : TailTree}
   *   Transformed tree.
   */
  runSync(n, r) {
    let i = !1, a;
    return this.run(n, r, o), Zx("runSync", "run", i), a;
    function o(s, l) {
      Yx(s), a = l, i = !0;
    }
  }
  /**
   * Compile a syntax tree.
   *
   * > **Note**: `stringify` freezes the processor if not already *frozen*.
   *
   * > **Note**: `stringify` performs the stringify phase, not the run phase
   * > or other phases.
   *
   * @param {CompileTree extends undefined ? Node : CompileTree} tree
   *   Tree to compile.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {CompileResult extends undefined ? Value : CompileResult}
   *   Textual representation of the tree (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most compilers
   *   > return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  stringify(n, r) {
    this.freeze();
    const i = Ns(r), a = this.compiler || this.Compiler;
    return Rm("stringify", a), Xx(n), a(n, i);
  }
  /**
   * Configure the processor to use a plugin, a list of usable values, or a
   * preset.
   *
   * If the processor is already using a plugin, the previous plugin
   * configuration is changed based on the options that are passed in.
   * In other words, the plugin is not added a second time.
   *
   * > **Note**: `use` cannot be called on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * @example
   *   There are many ways to pass plugins to `.use()`.
   *   This example gives an overview:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   unified()
   *     // Plugin with options:
   *     .use(pluginA, {x: true, y: true})
   *     // Passing the same plugin again merges configuration (to `{x: true, y: false, z: true}`):
   *     .use(pluginA, {y: false, z: true})
   *     // Plugins:
   *     .use([pluginB, pluginC])
   *     // Two plugins, the second with options:
   *     .use([pluginD, [pluginE, {}]])
   *     // Preset with plugins and settings:
   *     .use({plugins: [pluginF, [pluginG, {}]], settings: {position: false}})
   *     // Settings only:
   *     .use({settings: {position: false}})
   *   ```
   *
   * @template {Array<unknown>} [Parameters=[]]
   * @template {Node | string | undefined} [Input=undefined]
   * @template [Output=Input]
   *
   * @overload
   * @param {Preset | null | undefined} [preset]
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {PluggableList} list
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Plugin<Parameters, Input, Output>} plugin
   * @param {...(Parameters | [boolean])} parameters
   * @returns {UsePlugin<ParseTree, HeadTree, TailTree, CompileTree, CompileResult, Input, Output>}
   *
   * @param {PluggableList | Plugin | Preset | null | undefined} value
   *   Usable value.
   * @param {...unknown} parameters
   *   Parameters, when a plugin is given as a usable value.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   Current processor.
   */
  use(n, ...r) {
    const i = this.attachers, a = this.namespace;
    if (Dm("use", this.frozen), n != null) if (typeof n == "function")
      c(n, r);
    else if (typeof n == "object")
      Array.isArray(n) ? l(n) : s(n);
    else
      throw new TypeError("Expected usable value, not `" + n + "`");
    return this;
    function o(m) {
      if (typeof m == "function")
        c(m, []);
      else if (typeof m == "object")
        if (Array.isArray(m)) {
          const [u, ...f] = (
            /** @type {PluginTuple<Array<unknown>>} */
            m
          );
          c(u, f);
        } else
          s(m);
      else
        throw new TypeError("Expected usable value, not `" + m + "`");
    }
    function s(m) {
      if (!("plugins" in m) && !("settings" in m))
        throw new Error(
          "Expected usable value but received an empty preset, which is probably a mistake: presets typically come with `plugins` and sometimes with `settings`, but this has neither"
        );
      l(m.plugins), m.settings && (a.settings = Fm(!0, a.settings, m.settings));
    }
    function l(m) {
      let u = -1;
      if (m != null) if (Array.isArray(m))
        for (; ++u < m.length; ) {
          const f = m[u];
          o(f);
        }
      else
        throw new TypeError("Expected a list of plugins, not `" + m + "`");
    }
    function c(m, u) {
      let f = -1, h = -1;
      for (; ++f < i.length; )
        if (i[f][0] === m) {
          h = f;
          break;
        }
      if (h === -1)
        i.push([m, ...u]);
      else if (u.length > 0) {
        let [k, ...w] = u;
        const N = i[h][1];
        py(N) && py(k) && (k = Fm(!0, N, k)), i[h] = [m, k, ...w];
      }
    }
  }
}
const VM = new $g().freeze();
function Tm(e, n) {
  if (typeof n != "function")
    throw new TypeError("Cannot `" + e + "` without `parser`");
}
function Rm(e, n) {
  if (typeof n != "function")
    throw new TypeError("Cannot `" + e + "` without `compiler`");
}
function Dm(e, n) {
  if (n)
    throw new Error(
      "Cannot call `" + e + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`."
    );
}
function Xx(e) {
  if (!py(e) || typeof e.type != "string")
    throw new TypeError("Expected node, got `" + e + "`");
}
function Zx(e, n, r) {
  if (!r)
    throw new Error(
      "`" + e + "` finished async. Use `" + n + "` instead"
    );
}
function Ns(e) {
  return zM(e) ? e : new U1(e);
}
function zM(e) {
  return !!(e && typeof e == "object" && "message" in e && "messages" in e);
}
function UM(e) {
  return typeof e == "string" || MM(e);
}
function MM(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const BM = "https://github.com/remarkjs/react-markdown/blob/main/changelog.md", eS = [], nS = { allowDangerousHtml: !0 }, qM = /^(https?|ircs?|mailto|xmpp)$/i, HM = [
  { from: "astPlugins", id: "remove-buggy-html-in-markdown-parser" },
  { from: "allowDangerousHtml", id: "remove-buggy-html-in-markdown-parser" },
  {
    from: "allowNode",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowElement"
  },
  {
    from: "allowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowedElements"
  },
  {
    from: "disallowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "disallowedElements"
  },
  { from: "escapeHtml", id: "remove-buggy-html-in-markdown-parser" },
  { from: "includeElementIndex", id: "#remove-includeelementindex" },
  {
    from: "includeNodeIndex",
    id: "change-includenodeindex-to-includeelementindex"
  },
  { from: "linkTarget", id: "remove-linktarget" },
  { from: "plugins", id: "change-plugins-to-remarkplugins", to: "remarkPlugins" },
  { from: "rawSourcePos", id: "#remove-rawsourcepos" },
  { from: "renderers", id: "change-renderers-to-components", to: "components" },
  { from: "source", id: "change-source-to-children", to: "children" },
  { from: "sourcePos", id: "#remove-sourcepos" },
  { from: "transformImageUri", id: "#add-urltransform", to: "urlTransform" },
  { from: "transformLinkUri", id: "#add-urltransform", to: "urlTransform" }
];
function WM(e) {
  const n = e.allowedElements, r = e.allowElement, i = e.children || "", a = e.className, o = e.components, s = e.disallowedElements, l = e.rehypePlugins || eS, c = e.remarkPlugins || eS, m = e.remarkRehypeOptions ? { ...e.remarkRehypeOptions, ...nS } : nS, u = e.skipHtml, f = e.unwrapDisallowed, h = e.urlTransform || KM, k = VM().use(wU).use(c).use(_M, m).use(l), w = new U1();
  typeof i == "string" && (w.value = i);
  for (const g of HM)
    Object.hasOwn(e, g.from) && ("" + g.from + (g.to ? "use `" + g.to + "` instead" : "remove it") + BM + g.id, void 0);
  const N = k.parse(w);
  let j = k.runSync(N, w);
  return a && (j = {
    type: "element",
    tagName: "div",
    properties: { className: a },
    // Assume no doctypes.
    children: (
      /** @type {Array<ElementContent>} */
      j.type === "root" ? j.children : [j]
    )
  }), z1(j, _), i3(j, {
    Fragment: Qn.Fragment,
    components: o,
    ignoreInvalidStyle: !0,
    jsx: Qn.jsx,
    jsxs: Qn.jsxs,
    passKeys: !0,
    passNode: !0
  });
  function _(g, O, R) {
    if (g.type === "raw" && R && typeof O == "number")
      return u ? R.children.splice(O, 1) : R.children[O] = { type: "text", value: g.value }, O;
    if (g.type === "element") {
      let F;
      for (F in Nm)
        if (Object.hasOwn(Nm, F) && Object.hasOwn(g.properties, F)) {
          const I = g.properties[F], L = Nm[F];
          (L === null || L.includes(g.tagName)) && (g.properties[F] = h(String(I || ""), F, g));
        }
    }
    if (g.type === "element") {
      let F = n ? !n.includes(g.tagName) : s ? s.includes(g.tagName) : !1;
      if (!F && r && typeof O == "number" && (F = !r(g, O, R)), F && R && typeof O == "number")
        return f && g.children ? R.children.splice(O, 1, ...g.children) : R.children.splice(O, 1), O;
    }
  }
}
function KM(e) {
  const n = e.indexOf(":"), r = e.indexOf("?"), i = e.indexOf("#"), a = e.indexOf("/");
  return (
    // If there is no protocol, it’s relative.
    n < 0 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    a > -1 && n > a || r > -1 && n > r || i > -1 && n > i || // It is a protocol, it should be allowed.
    qM.test(e.slice(0, n)) ? e : ""
  );
}
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode('._issueAvatar_kc0sw_1{margin:var(--dixa-size-spacer-100) 0}._issueAvatar_kc0sw_1 h2{font-weight:var(--dixa-typography-weight-normal);align-items:center;display:flex}._issueField_kc0sw_9{font-weight:var(--dixa-typography-weight-normal)}._issueDescription_kc0sw_12{font-weight:var(--dixa-typography-weight-normal);color:var(--dixa-color-neutral-800);padding:var(--dixa-size-spacer-200);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100)}._issueDescription_kc0sw_12 p{margin:unset}._wrapper_e0qj3_1{width:400px;padding:0 0 var(--dixa-size-spacer-200) 0;max-height:400px;overflow:hidden;position:relative}._wrapper_e0qj3_1 ._description_e0qj3_8{color:var(--dixa-color-neutral-600)}._wrapper_e0qj3_1:after{width:100%;height:var(--dixa-size-spacer-400);content:"";position:absolute;bottom:0;left:0;background:linear-gradient(0deg,#fff,#ffffffbc 19%,#ffffff8a 34%,#ffffff61 47%,#ffffff47 56.5%,#ffffff31 65%,#ffffff20 73%,#ffffff13 80.2%,#ffffff0b 86.1%,#ffffff05 91%,#ffffff02 95.2%,#ffffff01 98.2%,#fff0)}._resultTitle_e0qj3_21{text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;color:var(--dixa-color-neutral-600)}._resultTooltipTitle_e0qj3_28{margin-bottom:var(--dixa-size-spacer-200)}._resultLinkIcon_e0qj3_31{position:absolute;right:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-000);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);color:var(--dixa-color-neutral-500)}._loader_13xpk_1{width:100%;display:flex;padding:var(--dixa-size-spacer-200);justify-content:center}._dropdown_13xpk_8{max-height:300px;overflow-y:scroll}._loadMore_13xpk_13{cursor:pointer}._loadMore_13xpk_13:hover{background-color:var(--dixa-color-neutral-100)}._loadMore_13xpk_13:hover p{color:var(--dixa-color-purple-600)}._loadMore_13xpk_13 p{color:var(--dixa-color-purple-500)}._collapse_su0f9_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);padding:var(--dixa-size-spacer-100)}._collapseHeader_su0f9_8{padding:var(--dixa-size-spacer-250);width:100%;box-sizing:border-box;background-color:transparent;gap:var(--dixa-size-spacer-100)}._collapseHeader_su0f9_8>div:first-of-type{padding:0!important;padding-right:var(--dixa-size-spacer-300);width:100%}._collapseHeader_su0f9_8>div>div:first-of-type{padding:0!important;width:100%}._collapseHeader_su0f9_8 p>div:first-of-type{justify-content:space-between}._collapseHeader_su0f9_8>div>div>p{white-space:unset!important;margin:0}._collapseContent_su0f9_31{padding:0 var(--dixa-size-spacer-250) var(--dixa-size-spacer-250) var(--dixa-size-spacer-250)}._url_su0f9_35{align-items:center;display:flex;flex-direction:row;gap:var(--dixa-size-spacer-100);color:var(--dixa-color-purple-500);font-weight:var(--dixa-typography-weight-semibold);cursor:pointer;font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200)}._empty_su0f9_47 p{color:var(--dixa-color-neutral-400)}._externalLink_su0f9_51{color:var(--dixa-typography-color-link)}._emptyState_su0f9_55{font-weight:var(--dixa-typography-weight-normal)}._modalBody_iv3ua_1{width:600px}._error_iv3ua_5{border:var(--dixa-size-border-100) solid var(--dixa-typography-color-error)}._emptyState_iv3ua_9{padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-200) var(--dixa-size-spacer-200)}._emptyState_iv3ua_9 p{color:var(--dixa-color-neutral-400)}._dropdown_iv3ua_16{max-height:300px;overflow-y:scroll}._modalWrapper_4kh9u_1{min-width:600px;position:relative}._copyButton_4kh9u_6{height:var(--dixa-size-spacer-500);width:var(--dixa-size-spacer-500)}._copyButton_4kh9u_6 button{background-color:var(--dixa-color-neutral-100);border-radius:0 var(--dixa-size-border-radius-100) var(--dixa-size-border-radius-100) 0}._copyWrapper_4kh9u_15{box-sizing:border-box}._copyWrapper_4kh9u_15:focus-within{border-radius:var(--dixa-size-border-radius-100);outline:solid var(--dixa-size-border-100) var(--dixa-color-purple-500);box-shadow:0 0 0 3px var(--dixa-color-purple-300)}._copyField_4kh9u_24{cursor:pointer;min-width:62ch;height:var(--dixa-size-spacer-500);border-radius:var(--dixa-size-border-radius-100) 0 0 var(--dixa-size-border-radius-100);border:none}._copyField_4kh9u_24:hover{border:none}._copyField_4kh9u_24:focus-within{box-shadow:none;border:none;outline:none}._copyField_4kh9u_24 input{color:var(--dixa-color-neutral-800);background-color:var(--dixa-color-neutral-100);cursor:pointer;border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);border-right:none}._externalLink_4kh9u_47{display:flex;align-items:center}._externalLinkIcon_4kh9u_52{align-self:center}._textWrapper_4kh9u_56{display:flex;gap:var(--dixa-size-spacer-100)}')), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Om = { exports: {} }, oo = {}, tS;
function GM() {
  if (tS) return oo;
  tS = 1;
  var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, c, m) {
    var u, f = {}, h = null, k = null;
    m !== void 0 && (h = "" + m), c.key !== void 0 && (h = "" + c.key), c.ref !== void 0 && (k = c.ref);
    for (u in c) i.call(c, u) && !o.hasOwnProperty(u) && (f[u] = c[u]);
    if (l && l.defaultProps) for (u in c = l.defaultProps, c) f[u] === void 0 && (f[u] = c[u]);
    return { $$typeof: n, type: l, key: h, ref: k, props: f, _owner: a.current };
  }
  return oo.Fragment = r, oo.jsx = s, oo.jsxs = s, oo;
}
var js = {}, rS;
function YM() {
  return rS || (rS = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), c = /* @__PURE__ */ Symbol.for("react.forward_ref"), m = /* @__PURE__ */ Symbol.for("react.suspense"), u = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), k = /* @__PURE__ */ Symbol.for("react.offscreen"), w = Symbol.iterator, N = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var d = w && t[w] || t[N];
      return typeof d == "function" ? d : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var d = arguments.length, p = new Array(d > 1 ? d - 1 : 0), y = 1; y < d; y++)
          p[y - 1] = arguments[y];
        O("error", t, p);
      }
    }
    function O(t, d, p) {
      {
        var y = _.ReactDebugCurrentFrame, C = y.getStackAddendum();
        C !== "" && (d += "%s", p = p.concat([C]));
        var T = p.map(function(S) {
          return String(S);
        });
        T.unshift("Warning: " + d), Function.prototype.apply.call(console[t], console, T);
      }
    }
    var R = !1, F = !1, I = !1, L = !1, W = !1, J;
    J = /* @__PURE__ */ Symbol.for("react.module.reference");
    function re(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || W || t === a || t === m || t === u || L || t === k || R || F || I || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === J || t.getModuleId !== void 0));
    }
    function K(t, d, p) {
      var y = t.displayName;
      if (y)
        return y;
      var C = d.displayName || d.name || "";
      return C !== "" ? p + "(" + C + ")" : p;
    }
    function Y(t) {
      return t.displayName || "Context";
    }
    function P(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var d = t;
            return Y(d) + ".Consumer";
          case s:
            var p = t;
            return Y(p._context) + ".Provider";
          case c:
            return K(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : P(t.type) || "Memo";
          case h: {
            var C = t, T = C._payload, S = C._init;
            try {
              return P(S(T));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, ie = 0, we, me, le, ge, V, be, Oe;
    function q() {
    }
    q.__reactDisabledLog = !0;
    function Ge() {
      {
        if (ie === 0) {
          we = console.log, me = console.info, le = console.warn, ge = console.error, V = console.group, be = console.groupCollapsed, Oe = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: q,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ie++;
      }
    }
    function sn() {
      {
        if (ie--, ie === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, t, {
              value: we
            }),
            info: B({}, t, {
              value: me
            }),
            warn: B({}, t, {
              value: le
            }),
            error: B({}, t, {
              value: ge
            }),
            group: B({}, t, {
              value: V
            }),
            groupCollapsed: B({}, t, {
              value: be
            }),
            groupEnd: B({}, t, {
              value: Oe
            })
          });
        }
        ie < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ie = _.ReactCurrentDispatcher, Ue;
    function De(t, d, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (C) {
            var y = C.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Ae;
    {
      var Je = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Je();
    }
    function Ee(t, d) {
      if (!t || Be)
        return "";
      {
        var p = Ae.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Be = !0;
      var C = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var T;
      T = Ie.current, Ie.current = null, Ge();
      try {
        if (d) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (ne) {
              y = ne;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (ne) {
              y = ne;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            y = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && y && typeof ne.stack == "string") {
          for (var x = ne.stack.split(`
`), Z = y.stack.split(`
`), A = x.length - 1, M = Z.length - 1; A >= 1 && M >= 0 && x[A] !== Z[M]; )
            M--;
          for (; A >= 1 && M >= 0; A--, M--)
            if (x[A] !== Z[M]) {
              if (A !== 1 || M !== 1)
                do
                  if (A--, M--, M < 0 || x[A] !== Z[M]) {
                    var ue = `
` + x[A].replace(" at new ", " at ");
                    return t.displayName && ue.includes("<anonymous>") && (ue = ue.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, ue), ue;
                  }
                while (A >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Ie.current = T, sn(), Error.prepareStackTrace = C;
      }
      var ze = t ? t.displayName || t.name : "", Te = ze ? De(ze) : "";
      return typeof t == "function" && Ae.set(t, Te), Te;
    }
    function Me(t, d, p) {
      return Ee(t, !1);
    }
    function en(t) {
      var d = t.prototype;
      return !!(d && d.isReactComponent);
    }
    function se(t, d, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ee(t, en(t));
      if (typeof t == "string")
        return De(t);
      switch (t) {
        case m:
          return De("Suspense");
        case u:
          return De("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case c:
            return Me(t.render);
          case f:
            return se(t.type, d, p);
          case h: {
            var y = t, C = y._payload, T = y._init;
            try {
              return se(T(C), d, p);
            } catch {
            }
          }
        }
      return "";
    }
    var de = Object.prototype.hasOwnProperty, Se = {}, Ve = _.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var d = t._owner, p = se(t.type, t._source, d ? d.type : null);
        Ve.setExtraStackFrame(p);
      } else
        Ve.setExtraStackFrame(null);
    }
    function kn(t, d, p, y, C) {
      {
        var T = Function.call.bind(de);
        for (var S in t)
          if (T(t, S)) {
            var x = void 0;
            try {
              if (typeof t[S] != "function") {
                var Z = Error((y || "React class") + ": " + p + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Z.name = "Invariant Violation", Z;
              }
              x = t[S](d, S, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (A) {
              x = A;
            }
            x && !(x instanceof Error) && (Pe(C), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, S, typeof x), Pe(null)), x instanceof Error && !(x.message in Se) && (Se[x.message] = !0, Pe(C), g("Failed %s type: %s", p, x.message), Pe(null));
          }
      }
    }
    var Q = Array.isArray;
    function E(t) {
      return Q(t);
    }
    function z(t) {
      {
        var d = typeof Symbol == "function" && Symbol.toStringTag, p = d && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function ae(t) {
      try {
        return ce(t), !1;
      } catch {
        return !0;
      }
    }
    function ce(t) {
      return "" + t;
    }
    function U(t) {
      if (ae(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", z(t)), ce(t);
    }
    var G = _.ReactCurrentOwner, ve = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, je, Re;
    function rn(t) {
      if (de.call(t, "ref")) {
        var d = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (d && d.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function bn(t) {
      if (de.call(t, "key")) {
        var d = Object.getOwnPropertyDescriptor(t, "key").get;
        if (d && d.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function an(t, d) {
      typeof t.ref == "string" && G.current;
    }
    function fn(t, d) {
      {
        var p = function() {
          je || (je = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", d));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function En(t, d) {
      {
        var p = function() {
          Re || (Re = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", d));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var _n = function(t, d, p, y, C, T, S) {
      var x = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: d,
        ref: p,
        props: S,
        // Record the component responsible for creating this element.
        _owner: T
      };
      return x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(x, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(x, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: C
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    };
    function Fn(t, d, p, y, C) {
      {
        var T, S = {}, x = null, Z = null;
        p !== void 0 && (U(p), x = "" + p), bn(d) && (U(d.key), x = "" + d.key), rn(d) && (Z = d.ref, an(d));
        for (T in d)
          de.call(d, T) && !ve.hasOwnProperty(T) && (S[T] = d[T]);
        if (t && t.defaultProps) {
          var A = t.defaultProps;
          for (T in A)
            S[T] === void 0 && (S[T] = A[T]);
        }
        if (x || Z) {
          var M = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          x && fn(S, M), Z && En(S, M);
        }
        return _n(t, x, Z, C, y, G.current, S);
      }
    }
    var Ze = _.ReactCurrentOwner, gn = _.ReactDebugCurrentFrame;
    function Le(t) {
      if (t) {
        var d = t._owner, p = se(t.type, t._source, d ? d.type : null);
        gn.setExtraStackFrame(p);
      } else
        gn.setExtraStackFrame(null);
    }
    var dn;
    dn = !1;
    function cn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function Nn() {
      {
        if (Ze.current) {
          var t = P(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Bn(t) {
      return "";
    }
    var Sn = {};
    function An(t) {
      {
        var d = Nn();
        if (!d) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (d = `

Check the top-level render call using <` + p + ">.");
        }
        return d;
      }
    }
    function vn(t, d) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = An(d);
        if (Sn[p])
          return;
        Sn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Ze.current && (y = " It was passed a child from " + P(t._owner.type) + "."), Le(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Le(null);
      }
    }
    function xn(t, d) {
      {
        if (typeof t != "object")
          return;
        if (E(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            cn(y) && vn(y, d);
          }
        else if (cn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var C = j(t);
          if (typeof C == "function" && C !== t.entries)
            for (var T = C.call(t), S; !(S = T.next()).done; )
              cn(S.value) && vn(S.value, d);
        }
      }
    }
    function Ln(t) {
      {
        var d = t.type;
        if (d == null || typeof d == "string")
          return;
        var p;
        if (typeof d == "function")
          p = d.propTypes;
        else if (typeof d == "object" && (d.$$typeof === c || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        d.$$typeof === f))
          p = d.propTypes;
        else
          return;
        if (p) {
          var y = P(d);
          kn(p, t.props, "prop", y, t);
        } else if (d.PropTypes !== void 0 && !dn) {
          dn = !0;
          var C = P(d);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", C || "Unknown");
        }
        typeof d.getDefaultProps == "function" && !d.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var d = Object.keys(t.props), p = 0; p < d.length; p++) {
          var y = d[p];
          if (y !== "children" && y !== "key") {
            Le(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Le(null);
            break;
          }
        }
        t.ref !== null && (Le(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Le(null));
      }
    }
    var Cn = {};
    function wn(t, d, p, y, C, T) {
      {
        var S = re(t);
        if (!S) {
          var x = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (x += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Z = Bn();
          Z ? x += Z : x += Nn();
          var A;
          t === null ? A = "null" : E(t) ? A = "array" : t !== void 0 && t.$$typeof === n ? (A = "<" + (P(t.type) || "Unknown") + " />", x = " Did you accidentally export a JSX literal instead of a component?") : A = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", A, x);
        }
        var M = Fn(t, d, p, C, T);
        if (M == null)
          return M;
        if (S) {
          var ue = d.children;
          if (ue !== void 0)
            if (y)
              if (E(ue)) {
                for (var ze = 0; ze < ue.length; ze++)
                  xn(ue[ze], t);
                Object.freeze && Object.freeze(ue);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              xn(ue, t);
        }
        if (de.call(d, "key")) {
          var Te = P(t), ne = Object.keys(d).filter(function(Kn) {
            return Kn !== "key";
          }), un = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Cn[Te + un]) {
            var Rn = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, un, Te, Rn, Te), Cn[Te + un] = !0;
          }
        }
        return t === i ? Vn(M) : Ln(M), M;
      }
    }
    function zn(t, d, p) {
      return wn(t, d, p, !0);
    }
    function qn(t, d, p) {
      return wn(t, d, p, !1);
    }
    var Un = qn, Wn = zn;
    js.Fragment = i, js.jsx = Un, js.jsxs = Wn;
  })()), js;
}
var iS;
function JM() {
  return iS || (iS = 1, process.env.NODE_ENV === "production" ? Om.exports = GM() : Om.exports = YM()), Om.exports;
}
var oe = JM();
const QM = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueTitle" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueDescription" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "teamId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "projectId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "statusId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "priority" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issueCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "title" }, value: { kind: "Variable", name: { kind: "Name", value: "issueTitle" } } }, { kind: "ObjectField", name: { kind: "Name", value: "description" }, value: { kind: "Variable", name: { kind: "Name", value: "issueDescription" } } }, { kind: "ObjectField", name: { kind: "Name", value: "teamId" }, value: { kind: "Variable", name: { kind: "Name", value: "teamId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "projectId" }, value: { kind: "Variable", name: { kind: "Name", value: "projectId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "stateId" }, value: { kind: "Variable", name: { kind: "Name", value: "statusId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "priority" }, value: { kind: "Variable", name: { kind: "Name", value: "priority" } } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "success" } }, { kind: "Field", name: { kind: "Name", value: "issue" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }] } }] } }] }, XM = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "staticData" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "teams" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "issuePriorityValues" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "priority" } }, { kind: "Field", name: { kind: "Name", value: "label" } }] } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }] } }] }, ZM = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "teamData" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "teamId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "team" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "teamId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "projects" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "states" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "templates" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "templateData" } }] } }] } }] } }] } }] } }] } }] }, e4 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchIssues" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "after" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "first" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "searchIssues" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }, { kind: "Argument", name: { kind: "Name", value: "after" }, value: { kind: "Variable", name: { kind: "Name", value: "after" } } }, { kind: "Argument", name: { kind: "Name", value: "term" }, value: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "priority" } }, { kind: "Field", name: { kind: "Name", value: "priorityLabel" } }, { kind: "Field", name: { kind: "Name", value: "url" } }, { kind: "Field", name: { kind: "Name", value: "state" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }, { kind: "Field", name: { kind: "Name", value: "assignee" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "email" } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "team" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "project" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "pageInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "hasNextPage" } }, { kind: "Field", name: { kind: "Name", value: "endCursor" } }] } }] } }] } }] } }] }, n4 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchLinkedIssues" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "linkedIssues" } }, type: { kind: "ListType", type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issues" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "id" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "in" }, value: { kind: "Variable", name: { kind: "Name", value: "linkedIssues" } } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "priority" } }, { kind: "Field", name: { kind: "Name", value: "priorityLabel" } }, { kind: "Field", name: { kind: "Name", value: "url" } }, { kind: "Field", name: { kind: "Name", value: "state" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }, { kind: "Field", name: { kind: "Name", value: "assignee" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "email" } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "team" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "project" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] } }] }, t4 = {
  "\n  mutation createIssue(\n    $issueTitle: String!\n    $issueDescription: String\n    $teamId: String!\n    $projectId: String\n    $statusId: String\n    $priority: Int\n  ) {\n    Linear {\n      issueCreate(\n        input: {\n          title: $issueTitle\n          description: $issueDescription\n          teamId: $teamId\n          projectId: $projectId\n          stateId: $statusId\n          priority: $priority\n        }\n      ) {\n        success\n        issue {\n          id\n          title\n          identifier\n          url\n        }\n      }\n    }\n  }\n": QM,
  "\n  query staticData {\n    Linear {\n      teams {\n        edges {\n          node {\n            id\n            name\n            organization {\n              urlKey\n            }\n          }\n        }\n      }\n      issuePriorityValues {\n        priority\n        label\n      }\n      organization {\n        urlKey\n      }\n    }\n  }\n": XM,
  "\n  query teamData($teamId: String!) {\n    Linear {\n      team(id: $teamId) {\n        projects {\n          edges {\n            node {\n              id\n              name\n            }\n          }\n        }\n        states {\n          edges {\n            node {\n              id\n              name\n              type\n              color\n            }\n          }\n        }\n        templates {\n          edges {\n            node {\n              id\n              name\n              type\n              templateData\n            }\n          }\n        }\n      }\n    }\n  }\n": ZM,
  "\n  query searchIssues($issueQuery: String! $after: String, $first: Int ) {\n    Linear {\n      searchIssues(\n        first:$first\n        after:$after\n        term: $issueQuery\n      ) {\n        edges {\n          node {\n            id\n            title\n            description\n            identifier\n            priority\n            priorityLabel\n            url\n            state {\n              id\n              type\n              name\n              color\n            }\n            assignee {\n              name\n              displayName\n              avatarUrl\n              email\n            }\n            labels {\n              edges {\n                node {\n                  id\n                  name\n                  color\n                }\n              }\n            }\n            team {\n              name\n              organization {\n                urlKey\n              }\n            }\n            project {\n              id\n              name\n            }\n          }\n        }\n        pageInfo {\n          hasNextPage\n          endCursor\n        }\n      }\n    }\n  }\n": e4,
  "\n  query searchLinkedIssues($linkedIssues: [ID!]) {\n    Linear {\n      issues(filter: { id: { in: $linkedIssues } }) {\n        edges {\n          node {\n            id\n            title\n            description\n            identifier\n            priority\n            priorityLabel\n            url\n            state {\n              id\n              type\n              name\n              color\n            }\n            assignee {\n              name\n              displayName\n              avatarUrl\n              email\n            }\n            labels {\n              edges {\n                node {\n                  id\n                  name\n                  color\n                }\n              }\n            }\n            team {\n              name\n              organization {\n                urlKey\n              }\n            }\n            project {\n              id\n              name\n            }\n          }\n        }\n      }\n    }\n  }\n": n4
};
function is(e) {
  return t4[e] ?? {};
}
const r4 = is(
  /* GraphQL */
  `
  query searchIssues($issueQuery: String! $after: String, $first: Int ) {
    Linear {
      searchIssues(
        first:$first
        after:$after
        term: $issueQuery
      ) {
        edges {
          node {
            id
            title
            description
            identifier
            priority
            priorityLabel
            url
            state {
              id
              type
              name
              color
            }
            assignee {
              name
              displayName
              avatarUrl
              email
            }
            labels {
              edges {
                node {
                  id
                  name
                  color
                }
              }
            }
            team {
              name
              organization {
                urlKey
              }
            }
            project {
              id
              name
            }
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
`
), i4 = is(
  /* GraphQL */
  `
  query searchLinkedIssues($linkedIssues: [ID!]) {
    Linear {
      issues(filter: { id: { in: $linkedIssues } }) {
        edges {
          node {
            id
            title
            description
            identifier
            priority
            priorityLabel
            url
            state {
              id
              type
              name
              color
            }
            assignee {
              name
              displayName
              avatarUrl
              email
            }
            labels {
              edges {
                node {
                  id
                  name
                  color
                }
              }
            }
            team {
              name
              organization {
                urlKey
              }
            }
            project {
              id
              name
            }
          }
        }
      }
    }
  }
`
), ws = ({
  title: e,
  children: n
}) => /* @__PURE__ */ oe.jsxs(b, { flexDirection: "column", gap: "100", children: [
  /* @__PURE__ */ oe.jsx($.Paragraph, { variant: "5", color: "neutral.500", children: e }),
  n
] }), a4 = "_issueAvatar_kc0sw_1", o4 = "_issueField_kc0sw_9", s4 = "_issueDescription_kc0sw_12", Cs = {
  issueAvatar: a4,
  issueField: o4,
  issueDescription: s4
}, M1 = ({ issue: e }) => /* @__PURE__ */ oe.jsxs(oe.Fragment, { children: [
  /* @__PURE__ */ oe.jsx(ws, { title: "Assignee", children: /* @__PURE__ */ oe.jsxs(
    b,
    {
      gap: "200",
      flexDirection: "row",
      alignContent: "center",
      className: Cs.issueAvatar,
      children: [
        /* @__PURE__ */ oe.jsx(
          $y,
          {
            size: "24",
            user: e.assignee ? {
              name: e.assignee.name || null,
              // eslint-disable-next-line camelcase
              avatar_url: e.assignee.avatarUrl || null,
              email: e.assignee.email
            } : void 0
          }
        ),
        /* @__PURE__ */ oe.jsx($.Heading, { variant: "heading-4", children: e.assignee ? e.assignee.name : "Unassigned" })
      ]
    }
  ) }),
  e.team?.name && /* @__PURE__ */ oe.jsx(ws, { title: "Team", children: /* @__PURE__ */ oe.jsx(
    $.Paragraph,
    {
      variant: "3",
      color: "neutral.800",
      className: Cs.issueField,
      children: e.team.name
    }
  ) }),
  e.project?.name && /* @__PURE__ */ oe.jsx(ws, { title: "Project", children: /* @__PURE__ */ oe.jsx(
    $.Paragraph,
    {
      variant: "3",
      color: "neutral.800",
      className: Cs.issueField,
      children: e.project.name
    }
  ) }),
  /* @__PURE__ */ oe.jsx(ws, { title: "Description", children: /* @__PURE__ */ oe.jsx(WM, { className: Cs.issueDescription, children: e.description }) })
] }), l4 = /* @__PURE__ */ oe.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--dixa-color-neutral-500)",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "No Priority",
    "data-testid": "noPriorityIcon",
    children: [
      /* @__PURE__ */ oe.jsx("rect", { width: "2", height: "2", rx: "1", transform: "matrix(-1 0 0 1 5 7)" }),
      /* @__PURE__ */ oe.jsx("rect", { width: "2", height: "2", rx: "1", transform: "matrix(-1 0 0 1 8 7)" }),
      /* @__PURE__ */ oe.jsx("rect", { width: "2", height: "2", rx: "1", transform: "matrix(-1 0 0 1 11 7)" })
    ]
  }
), d4 = /* @__PURE__ */ oe.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--dixa-color-neutral-500)",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "Low Priority",
    children: [
      /* @__PURE__ */ oe.jsx("rect", { x: "1", y: "8", width: "3", height: "6", rx: "1" }),
      /* @__PURE__ */ oe.jsx("rect", { x: "6", y: "5", width: "3", height: "9", rx: "1", fillOpacity: "0.4" }),
      /* @__PURE__ */ oe.jsx("rect", { x: "11", y: "2", width: "3", height: "12", rx: "1", fillOpacity: "0.4" })
    ]
  }
), c4 = /* @__PURE__ */ oe.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--dixa-color-neutral-500)",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "Medium Priority",
    children: [
      /* @__PURE__ */ oe.jsx("rect", { x: "1", y: "8", width: "3", height: "6", rx: "1" }),
      /* @__PURE__ */ oe.jsx("rect", { x: "6", y: "5", width: "3", height: "9", rx: "1" }),
      /* @__PURE__ */ oe.jsx("rect", { x: "11", y: "2", width: "3", height: "12", rx: "1", fillOpacity: "0.4" })
    ]
  }
), u4 = /* @__PURE__ */ oe.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--dixa-color-neutral-500)",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "High Priority",
    children: [
      /* @__PURE__ */ oe.jsx("rect", { x: "1", y: "8", width: "3", height: "6", rx: "1" }),
      /* @__PURE__ */ oe.jsx("rect", { x: "6", y: "5", width: "3", height: "9", rx: "1" }),
      /* @__PURE__ */ oe.jsx("rect", { x: "11", y: "2", width: "3", height: "12", rx: "1" })
    ]
  }
), m4 = /* @__PURE__ */ oe.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "-1 -1 15 15",
    "aria-label": "Urgent Priority",
    fill: "var(--dixa-color-orange-400)",
    children: /* @__PURE__ */ oe.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2 0a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2V2a2 2 0 00-2-2H2zm3.914 3h1.738L7.5 8.602H6.07L5.914 3zm1.809 7.164a.95.95 0 01-.938.938.934.934 0 110-1.867c.5 0 .934.417.938.93z"
      }
    )
  }
), B1 = {
  0: l4,
  1: m4,
  2: u4,
  3: c4,
  4: d4
}, p4 = (e) => e in B1, Cl = ({ priority: e }) => p4(e) ? B1[e] : /* @__PURE__ */ oe.jsx(Jn, { "data-testid": "defaultPriorityTag", children: e }), f4 = (e, n) => /* @__PURE__ */ oe.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    "data-testid": "defaultStatusIcon",
    children: /* @__PURE__ */ oe.jsx(
      "path",
      {
        d: "M13.9408 7.91426L11.9576 7.65557C11.9855 7.4419 12 7.22314 12 7C12 6.77686 11.9855 6.5581 11.9576 6.34443L13.9408 6.08573C13.9799 6.38496 14 6.69013 14 7C14 7.30987 13.9799 7.61504 13.9408 7.91426ZM13.4688 4.32049C13.2328 3.7514 12.9239 3.22019 12.5538 2.73851L10.968 3.95716C11.2328 4.30185 11.4533 4.68119 11.6214 5.08659L13.4688 4.32049ZM11.2615 1.4462L10.0428 3.03204C9.69815 2.76716 9.31881 2.54673 8.91341 2.37862L9.67951 0.531163C10.2486 0.767153 10.7798 1.07605 11.2615 1.4462ZM7.91426 0.0591659L7.65557 2.04237C7.4419 2.01449 7.22314 2 7 2C6.77686 2 6.5581 2.01449 6.34443 2.04237L6.08574 0.059166C6.38496 0.0201343 6.69013 0 7 0C7.30987 0 7.61504 0.0201343 7.91426 0.0591659ZM4.32049 0.531164L5.08659 2.37862C4.68119 2.54673 4.30185 2.76716 3.95716 3.03204L2.73851 1.4462C3.22019 1.07605 3.7514 0.767153 4.32049 0.531164ZM1.4462 2.73851L3.03204 3.95716C2.76716 4.30185 2.54673 4.68119 2.37862 5.08659L0.531164 4.32049C0.767153 3.7514 1.07605 3.22019 1.4462 2.73851ZM0.0591659 6.08574C0.0201343 6.38496 0 6.69013 0 7C0 7.30987 0.0201343 7.61504 0.059166 7.91426L2.04237 7.65557C2.01449 7.4419 2 7.22314 2 7C2 6.77686 2.01449 6.5581 2.04237 6.34443L0.0591659 6.08574ZM0.531164 9.67951L2.37862 8.91341C2.54673 9.31881 2.76716 9.69815 3.03204 10.0428L1.4462 11.2615C1.07605 10.7798 0.767153 10.2486 0.531164 9.67951ZM2.73851 12.5538L3.95716 10.968C4.30185 11.2328 4.68119 11.4533 5.08659 11.6214L4.32049 13.4688C3.7514 13.2328 3.22019 12.9239 2.73851 12.5538ZM6.08574 13.9408L6.34443 11.9576C6.5581 11.9855 6.77686 12 7 12C7.22314 12 7.4419 11.9855 7.65557 11.9576L7.91427 13.9408C7.61504 13.9799 7.30987 14 7 14C6.69013 14 6.38496 13.9799 6.08574 13.9408ZM9.67951 13.4688L8.91341 11.6214C9.31881 11.4533 9.69815 11.2328 10.0428 10.968L11.2615 12.5538C10.7798 12.9239 10.2486 13.2328 9.67951 13.4688ZM12.5538 11.2615L10.968 10.0428C11.2328 9.69815 11.4533 9.31881 11.6214 8.91341L13.4688 9.67951C13.2328 10.2486 12.924 10.7798 12.5538 11.2615Z",
        stroke: "none"
      }
    )
  }
), h4 = (e, n) => /* @__PURE__ */ oe.jsxs(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    "aria-label": n,
    "data-testid": "unstartedStatusIcon",
    children: [
      /* @__PURE__ */ oe.jsx(
        "rect",
        {
          x: "1",
          y: "1",
          width: "12",
          height: "12",
          rx: "6",
          stroke: e,
          strokeWidth: "2",
          fill: "none"
        }
      ),
      /* @__PURE__ */ oe.jsx(
        "path",
        {
          fill: e,
          stroke: "none",
          d: "M 3.5,3.5 L3.5,0 A3.5,3.5 0 0,1 3.5, 0 z",
          transform: "translate(3.5,3.5)"
        }
      )
    ]
  }
), y4 = (e, n) => /* @__PURE__ */ oe.jsxs("svg", { width: "14", height: "14", viewBox: "0 0 14 14", fill: "none", "aria-label": n, children: [
  /* @__PURE__ */ oe.jsx(
    "rect",
    {
      x: "1",
      y: "1",
      width: "12",
      height: "12",
      rx: "6",
      stroke: e,
      strokeWidth: "2",
      fill: "none"
    }
  ),
  /* @__PURE__ */ oe.jsx(
    "path",
    {
      fill: e,
      stroke: "none",
      d: "M 3.5,3.5 L3.5,0 A3.5,3.5 0 0,1 3.5, 7 z",
      transform: "translate(3.5,3.5)"
    }
  )
] }), g4 = (e, n) => /* @__PURE__ */ oe.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    children: /* @__PURE__ */ oe.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0ZM11.101 5.10104C11.433 4.76909 11.433 4.23091 11.101 3.89896C10.7691 3.56701 10.2309 3.56701 9.89896 3.89896L5.5 8.29792L4.10104 6.89896C3.7691 6.56701 3.2309 6.56701 2.89896 6.89896C2.56701 7.2309 2.56701 7.7691 2.89896 8.10104L4.89896 10.101C5.2309 10.433 5.7691 10.433 6.10104 10.101L11.101 5.10104Z"
      }
    )
  }
), v4 = (e, n) => /* @__PURE__ */ oe.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    children: /* @__PURE__ */ oe.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14ZM5.03033 3.96967C4.73744 3.67678 4.26256 3.67678 3.96967 3.96967C3.67678 4.26256 3.67678 4.73744 3.96967 5.03033L5.93934 7L3.96967 8.96967C3.67678 9.26256 3.67678 9.73744 3.96967 10.0303C4.26256 10.3232 4.73744 10.3232 5.03033 10.0303L7 8.06066L8.96967 10.0303C9.26256 10.3232 9.73744 10.3232 10.0303 10.0303C10.3232 9.73744 10.3232 9.26256 10.0303 8.96967L8.06066 7L10.0303 5.03033C10.3232 4.73744 10.3232 4.26256 10.0303 3.96967C9.73744 3.67678 9.26256 3.67678 8.96967 3.96967L7 5.93934L5.03033 3.96967Z",
        stroke: "none"
      }
    )
  }
), k4 = (e, n) => /* @__PURE__ */ oe.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    children: /* @__PURE__ */ oe.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0ZM11.101 5.10104C11.433 4.76909 11.433 4.23091 11.101 3.89896C10.7691 3.56701 10.2309 3.56701 9.89896 3.89896L5.5 8.29792L4.10104 6.89896C3.7691 6.56701 3.2309 6.56701 2.89896 6.89896C2.56701 7.2309 2.56701 7.7691 2.89896 8.10104L4.89896 10.101C5.2309 10.433 5.7691 10.433 6.10104 10.101L11.101 5.10104Z"
      }
    )
  }
), hy = {
  backlog: (e, n) => f4(e, n),
  unstarted: (e, n) => h4(e, n),
  started: (e, n) => y4(e, n),
  done: (e, n) => g4(e, n),
  canceled: (e, n) => v4(e, n),
  completed: (e, n) => k4(e, n)
}, b4 = (e) => e in hy, Fl = ({
  type: e = "backlog",
  color: n = "var(--dixa-color-neutral-400)",
  name: r = "linear-backlog-icon"
}) => b4(e) ? hy[e](n, r) : hy.backlog(
  "var(--dixa-color-neutral-400)",
  "linear-backlog-icon"
), _4 = "_wrapper_e0qj3_1", x4 = "_resultTitle_e0qj3_21", S4 = "_resultTooltipTitle_e0qj3_28", N4 = "_resultLinkIcon_e0qj3_31", so = {
  wrapper: _4,
  resultTitle: x4,
  resultTooltipTitle: S4,
  resultLinkIcon: N4
}, j4 = ({
  issue: e
}) => {
  const [n, r] = pe(!1), {
    list: { isDisabled: i },
    item: { onSelect: a }
  } = ql($I()), o = ft(
    (s) => {
      i || a({
        value: e,
        meta: {
          target: s?.target,
          event: s || void 0
        }
      });
    },
    [i, a, e]
  );
  return /* @__PURE__ */ oe.jsx(
    Xe,
    {
      wrap: "none",
      side: "left",
      content: /* @__PURE__ */ oe.jsxs(b, { flexDirection: "column", gap: "300", className: so.wrapper, children: [
        /* @__PURE__ */ oe.jsxs(b, { flexDirection: "row", justifyContent: "space-between", gap: "300", children: [
          /* @__PURE__ */ oe.jsxs(b, { flexDirection: "row", gap: "200", alignItems: "center", children: [
            /* @__PURE__ */ oe.jsx(
              Fl,
              {
                type: e.state.type,
                name: e.state.name,
                color: e.state.color
              }
            ),
            /* @__PURE__ */ oe.jsx($.Heading, { variant: "heading-3", children: e.identifier }),
            /* @__PURE__ */ oe.jsx(Cl, { priority: e.priority })
          ] }),
          /* @__PURE__ */ oe.jsx(Jn, { children: e.state.name })
        ] }),
        /* @__PURE__ */ oe.jsxs(b, { gap: "200", flexDirection: "column", children: [
          /* @__PURE__ */ oe.jsx(
            $.Heading,
            {
              variant: "heading-3",
              className: so.resultTooltipTitle,
              children: e.title
            }
          ),
          /* @__PURE__ */ oe.jsx(M1, { issue: e })
        ] })
      ] }),
      light: !0,
      children: /* @__PURE__ */ oe.jsx(
        mt.Item,
        {
          value: e,
          noFixedSelectionStateSpace: !0,
          className: so.result,
          onMouseEnter: () => r(!0),
          onMouseLeave: () => r(!1),
          "data-testid": "selectionListItemWrapper",
          onClick: o,
          children: /* @__PURE__ */ oe.jsxs(
            b,
            {
              flexDirection: "column",
              style: {
                width: n ? "calc(100% - 32px)" : "100%"
              },
              children: [
                /* @__PURE__ */ oe.jsxs(b, { flexDirection: "row", gap: "200", alignItems: "center", children: [
                  /* @__PURE__ */ oe.jsx(
                    Fl,
                    {
                      type: e.state.type,
                      color: e.state.color,
                      name: e.state.name
                    }
                  ),
                  /* @__PURE__ */ oe.jsx($.Heading, { variant: "heading-3", children: e.identifier }),
                  /* @__PURE__ */ oe.jsx(Cl, { priority: e.priority })
                ] }),
                /* @__PURE__ */ oe.jsx($.Paragraph, { variant: "4", className: so.resultTitle, children: e.title }),
                n && /* @__PURE__ */ oe.jsx(
                  he,
                  {
                    className: so.resultLinkIcon,
                    name: "plus",
                    size: 32
                  }
                )
              ]
            }
          )
        },
        e.id
      )
    }
  );
}, w4 = "_loader_13xpk_1", C4 = "_dropdown_13xpk_8", F4 = "_loadMore_13xpk_13", Pm = {
  loader: w4,
  dropdown: C4,
  loadMore: F4
}, I4 = ({
  handleSelect: e,
  linkedIssues: n
}) => {
  const [r, i] = pe(), [a, o] = pe([]), [s, l] = pe(""), [c, m] = pe(!1), { useLazyQuery: u } = hn(), [f, { data: h, loading: k, networkStatus: w }] = u(
    r4,
    {
      fetchPolicy: "no-cache",
      notifyOnNetworkStatusChange: !0
    }
  );
  bi(
    () => {
      !k && s !== "" && w === rr.ready ? f({
        variables: {
          issueQuery: s,
          first: 8
        }
      }) : o([]);
    },
    500,
    [s]
  ), Qe(() => {
    k || o([]);
  }, [s]), Qe(() => {
    if (h && Object.keys(h).length > 0) {
      const j = h.Linear.searchIssues.edges.map(
        ({ node: R }) => R
      ), _ = a.filter(
        (R) => !n.find((F) => F.id === R.id)
      ), g = _.filter(
        (R) => !j.find(
          (F) => F.id === R.id
        )
      ), O = j.filter(
        (R) => !n.find((F) => F.id === R.id)
      );
      n.length > 0 ? o(
        c ? [...g, ...O] : O
      ) : h?.Linear?.searchIssues?.edges && o(
        c ? [..._, ...j] : j
      ), h.Linear.searchIssues.pageInfo.hasNextPage && m(!1), i(h.Linear.searchIssues?.pageInfo);
    }
  }, [h, n]);
  const N = () => {
    !k && s !== "" && w === rr.ready ? (m(!0), f({
      variables: {
        issueQuery: s,
        first: 8,
        after: r?.endCursor
      }
    })) : o([]);
  };
  return /* @__PURE__ */ oe.jsx(b, { flexDirection: "column", gap: "200", "data-testid": "searchBarWrapper", children: /* @__PURE__ */ oe.jsxs(
    pi,
    {
      "data-testid": "searchBarComponent",
      clearable: !0,
      getItemTitleByValue: (j) => j?.title,
      onChange: (j) => e(j.selectedValues[0]),
      dropdownProps: { className: Pm.dropdown },
      filter: {
        value: s,
        onChange: (j) => {
          const _ = j.target.value;
          l(_);
        }
      },
      placeholder: "Search Linear issues",
      children: [
        a?.map((j) => /* @__PURE__ */ oe.jsx(j4, { issue: j }, j.id)),
        r?.hasNextPage && !k && s !== "" && a.length && /* @__PURE__ */ oe.jsx(
          b,
          {
            gap: "100",
            justifyContent: "center",
            padding: "200",
            alignItems: "center",
            onClick: () => N(),
            className: Pm.loadMore,
            children: /* @__PURE__ */ oe.jsx($.Paragraph, { variant: "3", children: "Load more ..." })
          }
        ),
        k && s !== "" && /* @__PURE__ */ oe.jsx(b, { justifyContent: "center", className: Pm.loader, children: /* @__PURE__ */ oe.jsx(mn, { size: 24 }) }),
        s === "" && a.length === 0 && /* @__PURE__ */ oe.jsx(
          b,
          {
            justifyContent: "center",
            style: { margin: "var(--dixa-size-spacer-250)" },
            children: /* @__PURE__ */ oe.jsx($.Paragraph, { variant: "3", color: "neutral.400", children: "Enter issue title or description" })
          }
        ),
        a.length === 0 && s !== "" && !k && /* @__PURE__ */ oe.jsx(
          b,
          {
            justifyContent: "center",
            style: { margin: "var(--dixa-size-spacer-250)" },
            children: /* @__PURE__ */ oe.jsx($.Paragraph, { variant: "3", color: "neutral.400", children: "No Linear issues found" })
          }
        )
      ]
    }
  ) });
}, $4 = "_collapse_su0f9_1", E4 = "_collapseHeader_su0f9_8", T4 = "_collapseContent_su0f9_31", R4 = "_url_su0f9_35", D4 = "_externalLink_su0f9_51", O4 = "_emptyState_su0f9_55", ui = {
  collapse: $4,
  collapseHeader: E4,
  collapseContent: T4,
  url: R4,
  externalLink: D4,
  emptyState: O4
}, P4 = ({
  linkedIssues: e,
  isLoading: n,
  handleUnlinkIssue: r,
  showUnlinkAllModal: i,
  showUnlinkAllButton: a,
  organizationUrl: o
}) => {
  const s = e.reduce(
    (u, f) => ({ ...u, [f.id]: !1 }),
    {}
  ), [l, c] = pe(s), { track: m } = jn();
  return n ? /* @__PURE__ */ oe.jsx(
    b,
    {
      flexDirection: "column",
      margin: "0 0 400 0",
      justifyContent: "center",
      alignItems: "center",
      children: /* @__PURE__ */ oe.jsx(mn, { size: 24 })
    }
  ) : e.length === 0 ? /* @__PURE__ */ oe.jsxs(
    b,
    {
      flexDirection: "column",
      justifyContent: "center",
      margin: "0 0 300 0",
      gap: "300",
      children: [
        /* @__PURE__ */ oe.jsx(
          $.Paragraph,
          {
            align: "center",
            variant: "3",
            color: "neutral.400",
            className: ui.emptyState,
            children: "No linked issues found"
          }
        ),
        /* @__PURE__ */ oe.jsx(
          It,
          {
            slotEnd: /* @__PURE__ */ oe.jsx(he, { name: "external-link" }),
            variant: "tertiary",
            className: ui.externalLink,
            navigate: () => window.open(
              `https://linear.app/${e[0]?.team?.organization.urlKey ?? ""}`,
              "_blank"
            )?.focus(),
            children: "Open Linear"
          }
        )
      ]
    }
  ) : /* @__PURE__ */ oe.jsxs(
    b,
    {
      flexDirection: "column",
      gap: "250",
      margin: "0 0 400 0",
      "data-testid": "linkedIssueWrapper",
      children: [
        e.map((u) => {
          const f = l[u.id];
          return /* @__PURE__ */ oe.jsxs(
            xr,
            {
              "data-testid": "collapseCard",
              onToggle: () => c({ ...l, [u.id]: !l[u.id] }),
              isOpen: f,
              className: ui.collapse,
              children: [
                /* @__PURE__ */ oe.jsx(xr.Header, { className: ui.collapseHeader, children: /* @__PURE__ */ oe.jsxs(b, { flexDirection: "column", gap: "100", children: [
                  /* @__PURE__ */ oe.jsxs(b, { flexDirection: "row", justifyContent: "space-between", children: [
                    /* @__PURE__ */ oe.jsxs(b, { gap: "100", alignItems: "center", children: [
                      /* @__PURE__ */ oe.jsx(Xe, { content: /* @__PURE__ */ oe.jsx(b, { children: u.state.name }), children: /* @__PURE__ */ oe.jsx(b, { alignSelf: "center", children: /* @__PURE__ */ oe.jsx(
                        Fl,
                        {
                          type: u.state.type,
                          color: u.state.color,
                          name: u.state.name
                        }
                      ) }) }),
                      /* @__PURE__ */ oe.jsxs(
                        $.ExternalLink,
                        {
                          className: ui.url,
                          href: u.url,
                          target: "_blank",
                          rel: "noreferrer",
                          children: [
                            u.identifier,
                            /* @__PURE__ */ oe.jsx(he, { name: "external-link" })
                          ]
                        }
                      ),
                      /* @__PURE__ */ oe.jsx(Xe, { content: /* @__PURE__ */ oe.jsx(b, { children: u.priorityLabel }), children: /* @__PURE__ */ oe.jsx(b, { alignSelf: "center", children: /* @__PURE__ */ oe.jsx(Cl, { priority: u.priority }) }) })
                    ] }),
                    /* @__PURE__ */ oe.jsx(Jn, { children: u.state.name })
                  ] }),
                  u.title
                ] }) }),
                /* @__PURE__ */ oe.jsx(xr.Content, { className: ui.collapseContent, children: /* @__PURE__ */ oe.jsxs(b, { flexDirection: "column", gap: "300", children: [
                  u?.labels && u?.labels?.edges?.length > 0 && /* @__PURE__ */ oe.jsx(
                    b,
                    {
                      flexDirection: "row",
                      gap: "200",
                      alignItems: "center",
                      flexWrap: "wrap",
                      children: u.labels?.edges.map((h) => /* @__PURE__ */ oe.jsx(Jn, { color: h.node.color, children: h.node.name }, h.node.id))
                    }
                  ),
                  /* @__PURE__ */ oe.jsx(M1, { issue: u }),
                  /* @__PURE__ */ oe.jsx(
                    tt,
                    {
                      slotStart: /* @__PURE__ */ oe.jsx(he, { name: "link-slash" }),
                      variant: "secondary",
                      onClick: () => r(u.id),
                      style: { marginTop: "var(--dixa-size-spacer-200)" },
                      children: "Unlink issue from Linear"
                    }
                  ),
                  /* @__PURE__ */ oe.jsxs(
                    It,
                    {
                      slotEnd: /* @__PURE__ */ oe.jsx(he, { name: "external-link" }),
                      variant: "tertiary",
                      className: ui.externalLink,
                      onClick: () => {
                        m("linear:open:issue:clicked", {
                          linearInstanceUrl: o,
                          linearIssueKey: u.id
                        });
                      },
                      navigate: () => window.open(u.url, "_blank")?.focus(),
                      children: [
                        "View ",
                        u.identifier,
                        " in Linear"
                      ]
                    }
                  )
                ] }) })
              ]
            },
            u.id
          );
        }),
        e.length > 1 && a && /* @__PURE__ */ oe.jsx(
          tt,
          {
            slotStart: /* @__PURE__ */ oe.jsx(he, { name: "link-slash" }),
            variant: "secondary",
            onClick: () => i(!0),
            children: "Unlink all issues"
          }
        ),
        /* @__PURE__ */ oe.jsx(
          It,
          {
            slotEnd: /* @__PURE__ */ oe.jsx(he, { name: "external-link" }),
            variant: "tertiary",
            className: ui.externalLink,
            onClick: () => {
              m("linear:open:linear:clicked", {
                // we check against empty linkedIssues earlier in the code.
                // function is using item at index 0 since all teams belong in the same organization/workspace,
                linearInstanceUrl: o,
                linearIssueKey: e[0].id
              });
            },
            disabled: !o,
            navigate: () => window.open(o, "_blank")?.focus(),
            children: "Open Linear"
          }
        )
      ]
    }
  );
}, A4 = {
  default: (e, n) => (n() ?? []).join(""),
  nodes: {
    doc: (e, n) => (n() ?? []).join(""),
    heading: (e, n) => `
${"#".repeat(
      parseInt(e.attrs?.level) || 1
    )} ${n()}

`,
    bullet_list: (e, n) => `
` + n().map((r) => `- ${r}`).join(""),
    ordered_list: (e, n) => `
` + n().map((r) => `1. ${r}`).join(""),
    // We're not emitting list items from the listItem formatter but from the
    // ordered/bullet list nodes above, as markdown does not encapsulate list items
    //listItem: (_node, children) => '- ' + children(),
    paragraph: (e, n) => n().join("") + `
`,
    text: (e) => e.text ?? "",
    hard_break: () => `
`,
    blockquote: (e, n) => `> ${n().join("")}
`,
    code_block: (e, n) => "\n```" + (e.attrs?.language || "") + `
` + n() + "\n```\n"
  },
  marks: {
    text: {
      strong: (e, n) => `**${n()}**`,
      strike: (e, n) => `~~${n()}~~`,
      subsup: (e, n) => {
        switch (e.attrs?.type) {
          case "sub":
            return `<sub>${n()}</sub>`;
          case "sup":
            return `<sup>${n()}</sup>`;
          default:
            return n();
        }
      },
      underline: (e, n) => `<u>${n()}</u>`,
      em: (e, n) => `*${n()}*`,
      link: (e, n) => `[${n()}](${e.attrs?.href})`,
      code: (e, n) => `\`${n()}\``
    }
  }
}, q1 = (e, n) => {
  const r = (o) => (e.marks || []).map((s) => ({
    formatterFunction: n.marks[e.type]?.[s.type],
    mark: s
  })).reduce(
    (s, l) => () => l.formatterFunction?.(l.mark, s) || o,
    () => o
  )(), i = (o, s) => () => o.content ? o.content.map((l) => q1(l, s)) : [], a = n.nodes[e.type] || n.default;
  return r(
    a(e, i(e, n))
  );
}, L4 = "_modalBody_iv3ua_1", V4 = "_error_iv3ua_5", z4 = "_dropdown_iv3ua_16", aa = {
  modalBody: L4,
  error: V4,
  dropdown: z4
}, U4 = is(
  /* GraphQL */
  `
  mutation createIssue(
    $issueTitle: String!
    $issueDescription: String
    $teamId: String!
    $projectId: String
    $statusId: String
    $priority: Int
  ) {
    Linear {
      issueCreate(
        input: {
          title: $issueTitle
          description: $issueDescription
          teamId: $teamId
          projectId: $projectId
          stateId: $statusId
          priority: $priority
        }
      ) {
        success
        issue {
          id
          title
          identifier
          url
        }
      }
    }
  }
`
), M4 = is(
  /* GraphQL */
  `
  query staticData {
    Linear {
      teams {
        edges {
          node {
            id
            name
            organization {
              urlKey
            }
          }
        }
      }
      issuePriorityValues {
        priority
        label
      }
      organization {
        urlKey
      }
    }
  }
`
), B4 = is(
  /* GraphQL */
  `
  query teamData($teamId: String!) {
    Linear {
      team(id: $teamId) {
        projects {
          edges {
            node {
              id
              name
            }
          }
        }
        states {
          edges {
            node {
              id
              name
              type
              color
            }
          }
        }
        templates {
          edges {
            node {
              id
              name
              type
              templateData
            }
          }
        }
      }
    }
  }
`
), q4 = ({
  setCreatedIssue: e,
  isCreateIssueModalOpen: n,
  setIsCreateIssueModalOpen: r,
  setIsCreationSuccessfulModalOpen: i,
  addToLinkedIssueIds: a,
  organizationUrl: o,
  setOrganizationUrl: s
}) => {
  const { useLazyQuery: l, showNotification: c } = hn(), { control: m, handleSubmit: u, reset: f } = ut(), [h, k] = pe([]), [w, N] = pe(), [j, _] = pe([]), [g, O] = pe(), [R, F] = pe([]), [I, L] = pe(), [W, J] = pe([]), [re, K] = pe(), [Y, P] = pe([]), [B, ie] = pe(), [we, me] = pe(!1), { useMutation: le } = hn(), { track: ge } = jn(), [V, { loading: be }] = le(
    U4,
    {
      onError: () => {
        me(!1), c({
          title: "Creation was not successful",
          text: "Please try again later or contact your admin.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        });
      },
      onCompleted: (Ee) => {
        const Me = {
          identifier: Ee.Linear?.issueCreate?.issue?.identifier,
          url: Ee.Linear?.issueCreate?.issue?.url
        };
        Ee.Linear && Ee.Linear?.issueCreate?.issue?.id && (a(Ee.Linear?.issueCreate?.issue?.id), Be(Me), me(!1), c({
          title: "Issue was created and linked to the conversation",
          text: `Issue ${Ee.Linear.issueCreate.issue.identifier} was created and added to the active conversation`,
          icon: "exclamation-triangle-filled",
          severity: "success"
        }), ge("linear:create:new:issue:confirmed", {
          linearInstanceUrl: o
        }));
      }
    }
  ), [
    Oe,
    { data: q, loading: Ge, error: sn }
  ] = l(M4, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onError: () => c({
      title: "Error while fetching team ID",
      text: "Please try again later or contact your admin.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    }),
    onCompleted: (Ee) => {
      const Me = Ee.Linear.teams.edges.map(
        ({ node: en }) => en
      );
      k(Me), J(Ee.Linear.issuePriorityValues), s(`${Z4}${Ee.Linear.organization.urlKey}`);
    }
  }), [Ie, { data: Ue, loading: De }] = l(B4, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onError: () => c({
      title: "Error while fetching team projects",
      text: "Please try again later or contact your admin.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    }),
    onCompleted: (Ee) => {
      const Me = Ee?.Linear?.team?.projects?.edges?.map(
        ({ node: de }) => de
      );
      _(Me);
      const en = Ee?.Linear?.team?.states?.edges?.map(
        ({ node: de }) => de
      );
      F(en);
      const se = Ee?.Linear?.team?.templates?.edges?.map(
        ({ node: de }) => de
      );
      P(
        se.filter(
          (de) => de.type === "issue"
        )
      );
    }
  }), Be = (Ee) => {
    r(!1), O(void 0), N(void 0), L(void 0), K(void 0), ie(void 0), Ee && (e(Ee), i(!0)), f({
      title: "",
      description: "",
      projectId: "",
      teamId: "",
      statusId: "",
      priority: void 0
    });
  }, Ae = (Ee) => {
    q && !Ge && (V({
      variables: {
        issueTitle: Ee.title,
        issueDescription: Ee?.description,
        teamId: Ee.team.id,
        projectId: Ee?.project?.id,
        statusId: Ee?.status?.id,
        priority: Ee?.priority?.priority
      }
    }), me(!0));
  };
  Qe(() => {
    n && Oe();
  }, [n]);
  const Je = () => {
    ge("linear:create:new:issue:cancelled", {
      linearInstanceUrl: o
    });
  };
  return /* @__PURE__ */ oe.jsxs(
    bt,
    {
      isOpen: n,
      onClose: () => {
        Je(), Be();
      },
      children: [
        /* @__PURE__ */ oe.jsx(
          _t,
          {
            title: "Create new Linear issue",
            onClose: () => {
              Je(), Be();
            }
          }
        ),
        /* @__PURE__ */ oe.jsx(
          xt,
          {
            className: aa.modalBody,
            "data-testid": "createIssueModalBody",
            children: sn ? /* @__PURE__ */ oe.jsx($n, { error: sn }) : /* @__PURE__ */ oe.jsx("form", { onSubmit: u(Ae), id: "issueCreationForm", children: /* @__PURE__ */ oe.jsxs(et, { children: [
              /* @__PURE__ */ oe.jsx(X, { span: 3, children: /* @__PURE__ */ oe.jsx(
                Nt,
                {
                  control: m,
                  name: "team",
                  rules: {
                    required: "Team is required"
                  },
                  render: ({
                    field: { value: Ee, onChange: Me },
                    fieldState: { error: en }
                  }) => /* @__PURE__ */ oe.jsx(
                    He,
                    {
                      required: !0,
                      label: "Team",
                      meta: {
                        error: en?.message ?? null
                      },
                      children: /* @__PURE__ */ oe.jsx(
                        pi,
                        {
                          dropdownProps: { className: aa.dropdown },
                          placeholder: "Select Linear team",
                          className: ct({ [aa.error]: en }),
                          getItemTitleByValue: (se) => se?.name,
                          onChange: (se) => {
                            O(void 0), L(void 0), K(void 0), ie(void 0), N(se.selectedValues[0]), Ie({
                              variables: { teamId: se.selectedValues[0].id }
                            }), Me(se.selectedValues[0]);
                          },
                          value: w ? [Ee] : void 0,
                          children: h?.map((se) => /* @__PURE__ */ oe.jsx(
                            mt.Item,
                            {
                              value: se,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ oe.jsx($.Paragraph, { children: se.name })
                            },
                            se.id
                          ))
                        }
                      )
                    }
                  )
                }
              ) }),
              /* @__PURE__ */ oe.jsx(X, { span: 3, children: /* @__PURE__ */ oe.jsx(
                Nt,
                {
                  control: m,
                  name: "project",
                  render: ({ field: { value: Ee, onChange: Me } }) => {
                    const en = De ? [{ name: "Loading projects...", id: "" }] : void 0;
                    return /* @__PURE__ */ oe.jsx(He, { label: "Project", children: /* @__PURE__ */ oe.jsx(
                      pi,
                      {
                        dropdownProps: { className: aa.dropdown },
                        clearable: !0,
                        getItemTitleByValue: (se) => se?.name,
                        disabled: w === void 0,
                        placeholder: w ? "Select Linear project" : "Select a Team first",
                        onChange: (se) => {
                          O(se.selectedValues[0]), Me(se.selectedValues[0]);
                        },
                        value: g ? [Ee] : en,
                        children: /* @__PURE__ */ oe.jsxs(oe.Fragment, { children: [
                          De && /* @__PURE__ */ oe.jsx(
                            b,
                            {
                              justifyContent: "center",
                              style: {
                                padding: "var(--dixa-size-spacer-200)"
                              },
                              children: /* @__PURE__ */ oe.jsx(mn, { size: 24 })
                            }
                          ),
                          Ue && !De && j.map((se) => /* @__PURE__ */ oe.jsx(
                            mt.Item,
                            {
                              value: se,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ oe.jsx($.Paragraph, { children: se.name })
                            },
                            se.id
                          ))
                        ] })
                      }
                    ) });
                  }
                }
              ) }),
              /* @__PURE__ */ oe.jsx(X, { span: 6, children: /* @__PURE__ */ oe.jsx(He, { label: "Template", children: /* @__PURE__ */ oe.jsx(
                pi,
                {
                  clearable: !0,
                  dropdownProps: { className: aa.dropdown },
                  disabled: !w || De,
                  placeholder: w ? "Select template" : "Select a Team first",
                  getItemTitleByValue: (Ee) => Ee?.name,
                  onChange: (Ee) => {
                    if (Ee.selectedValues.length > 0) {
                      ie(Ee.selectedValues[0]);
                      const Me = JSON.parse(
                        Ee.selectedValues[0].templateData
                      ), en = W.filter(
                        (Ve) => Ve.priority === Me.priority
                      );
                      K(
                        en ? en[0] : void 0
                      );
                      const se = R.filter(
                        (Ve) => Ve.id === Me.stateId
                      );
                      L(
                        se ? se[0] : void 0
                      );
                      const de = j.filter(
                        (Ve) => Ve.id === Me.projectId
                      );
                      O(
                        de ? de[0] : void 0
                      );
                      const Se = Me.description;
                      f({
                        title: Me?.title,
                        priority: en[0],
                        status: se[0],
                        project: de[0],
                        description: Se ? q1(Se, A4) : "",
                        team: w
                      });
                    } else
                      f({
                        title: "",
                        description: "",
                        team: w
                      }), O(void 0), K(void 0), L(void 0), ie(void 0);
                  },
                  value: B ? [B] : void 0,
                  children: Y?.map((Ee) => /* @__PURE__ */ oe.jsx(
                    mt.Item,
                    {
                      value: Ee,
                      noFixedSelectionStateSpace: !0,
                      children: /* @__PURE__ */ oe.jsx($.Paragraph, { children: Ee.name })
                    },
                    Ee.id
                  ))
                }
              ) }) }),
              /* @__PURE__ */ oe.jsx(X, { span: 6, children: /* @__PURE__ */ oe.jsx(
                Nt,
                {
                  control: m,
                  name: "title",
                  rules: {
                    required: "Title field is required",
                    minLength: 2
                  },
                  render: ({
                    field: { onChange: Ee, value: Me },
                    fieldState: { error: en }
                  }) => /* @__PURE__ */ oe.jsx(
                    Wr,
                    {
                      required: !0,
                      label: "Title",
                      placeholder: "Insert issue title here",
                      input: {
                        name: "issueTitle",
                        value: Me || "",
                        onChange: Ee
                      },
                      meta: {
                        error: en?.message ?? null
                      }
                    }
                  )
                }
              ) }),
              /* @__PURE__ */ oe.jsx(X, { span: 3, children: /* @__PURE__ */ oe.jsx(
                Nt,
                {
                  control: m,
                  name: "status",
                  render: ({ field: { value: Ee, onChange: Me } }) => {
                    const en = De ? [
                      {
                        name: "Loading statuses...",
                        id: "",
                        type: "",
                        color: ""
                      }
                    ] : void 0;
                    return /* @__PURE__ */ oe.jsx(He, { label: "Status", children: /* @__PURE__ */ oe.jsx(
                      pi,
                      {
                        dropdownProps: { className: aa.dropdown },
                        clearable: !0,
                        getItemTitleByValue: (se) => se?.name,
                        disabled: w === void 0,
                        placeholder: w ? "Select Issue status" : "Select a Team first",
                        onChange: (se) => {
                          L(se.selectedValues[0]), Me(se.selectedValues[0]);
                        },
                        value: I ? [Ee] : en,
                        children: /* @__PURE__ */ oe.jsxs(oe.Fragment, { children: [
                          De && /* @__PURE__ */ oe.jsx(
                            b,
                            {
                              justifyContent: "center",
                              style: {
                                padding: "var(--dixa-size-spacer-200)"
                              },
                              children: /* @__PURE__ */ oe.jsx(mn, { size: 24 })
                            }
                          ),
                          Ue && !De && R.map((se) => /* @__PURE__ */ oe.jsx(
                            mt.Item,
                            {
                              value: se,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ oe.jsxs(
                                b,
                                {
                                  flexDirection: "row",
                                  gap: "300",
                                  alignItems: "center",
                                  children: [
                                    /* @__PURE__ */ oe.jsx(
                                      Fl,
                                      {
                                        type: se.type,
                                        color: se.color,
                                        name: se.name
                                      }
                                    ),
                                    /* @__PURE__ */ oe.jsx($.Paragraph, { children: se.name })
                                  ]
                                }
                              )
                            },
                            se.id
                          ))
                        ] })
                      }
                    ) });
                  }
                }
              ) }),
              /* @__PURE__ */ oe.jsx(X, { span: 3, children: /* @__PURE__ */ oe.jsx(
                Nt,
                {
                  control: m,
                  name: "priority",
                  render: ({ field: { value: Ee, onChange: Me } }) => {
                    const en = Ge ? [
                      {
                        label: "Loading Priorities...",
                        priority: 0
                      }
                    ] : void 0;
                    return /* @__PURE__ */ oe.jsx(He, { label: "Priority", children: /* @__PURE__ */ oe.jsx(
                      pi,
                      {
                        clearable: !0,
                        getItemTitleByValue: (se) => se?.label,
                        disabled: w === void 0,
                        placeholder: w ? "Select Issue priority" : "Select a Team first",
                        onChange: (se) => {
                          K(se.selectedValues[0]), Me(se.selectedValues[0]);
                        },
                        value: re ? [Ee] : en,
                        children: /* @__PURE__ */ oe.jsxs(oe.Fragment, { children: [
                          De && /* @__PURE__ */ oe.jsx(
                            b,
                            {
                              justifyContent: "center",
                              style: {
                                padding: "var(--dixa-size-spacer-200)"
                              },
                              children: /* @__PURE__ */ oe.jsx(mn, { size: 24 })
                            }
                          ),
                          q && !Ge && W.map((se) => /* @__PURE__ */ oe.jsx(
                            mt.Item,
                            {
                              value: se,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ oe.jsxs(
                                b,
                                {
                                  flexDirection: "row",
                                  gap: "300",
                                  alignItems: "center",
                                  children: [
                                    /* @__PURE__ */ oe.jsx(
                                      Cl,
                                      {
                                        priority: se.priority
                                      }
                                    ),
                                    /* @__PURE__ */ oe.jsx($.Paragraph, { children: se.label })
                                  ]
                                }
                              )
                            },
                            se.priority
                          ))
                        ] })
                      }
                    ) });
                  }
                }
              ) }),
              /* @__PURE__ */ oe.jsx(X, { children: /* @__PURE__ */ oe.jsx(
                Nt,
                {
                  control: m,
                  name: "description",
                  render: ({
                    field: { onChange: Ee, value: Me },
                    fieldState: { error: en }
                  }) => /* @__PURE__ */ oe.jsx(
                    FI,
                    {
                      label: "Description",
                      placeholder: "Insert Issue description here",
                      input: {
                        name: "description",
                        value: Me || "",
                        onChange: Ee
                      },
                      meta: {
                        error: en?.message ?? null
                      }
                    }
                  )
                }
              ) })
            ] }) })
          }
        ),
        /* @__PURE__ */ oe.jsx(
          wt,
          {
            confirmOnClick: u(Ae),
            confirmProps: {
              disabled: be || !q,
              isLoading: we || Ge || De,
              loadingIndicator: /* @__PURE__ */ oe.jsx(mn, { size: 16 })
            },
            confirmName: "Save",
            cancelOnClick: () => {
              Je(), Be();
            }
          }
        )
      ]
    }
  );
}, H4 = "_modalWrapper_4kh9u_1", W4 = "_copyButton_4kh9u_6", K4 = "_copyWrapper_4kh9u_15", G4 = "_copyField_4kh9u_24", Y4 = "_externalLink_4kh9u_47", J4 = "_externalLinkIcon_4kh9u_52", Q4 = "_textWrapper_4kh9u_56", wi = {
  modalWrapper: H4,
  copyButton: W4,
  copyWrapper: K4,
  copyField: G4,
  externalLink: Y4,
  externalLinkIcon: J4,
  textWrapper: Q4
}, X4 = ({
  isCreationSuccessfulModalOpen: e,
  createdIssueData: n,
  setIsCreationSuccessfulModalOpen: r
}) => /* @__PURE__ */ oe.jsxs(
  bt,
  {
    isOpen: !!n && e,
    className: wi.modalWrapper,
    onClose: () => r(!1),
    children: [
      /* @__PURE__ */ oe.jsx(
        _t,
        {
          title: "Issue creation successful",
          onClose: () => r(!1)
        }
      ),
      /* @__PURE__ */ oe.jsx(xt, { children: /* @__PURE__ */ oe.jsxs(
        b,
        {
          gap: "300",
          flexDirection: "column",
          "data-testid": "creationSuccessfulModal",
          children: [
            /* @__PURE__ */ oe.jsxs($.Paragraph, { className: wi.textWrapper, children: [
              `You can visit issue ${n?.identifier} by following `,
              " ",
              /* @__PURE__ */ oe.jsxs(
                $.ExternalLink,
                {
                  href: n?.url,
                  target: "_blank",
                  className: wi.externalLink,
                  children: [
                    "this link",
                    " ",
                    /* @__PURE__ */ oe.jsx(he, { name: "external-link", className: wi.externalLinkIcon })
                  ]
                }
              ),
              "or copy it from the field below."
            ] }),
            /* @__PURE__ */ oe.jsx(He, { label: "Linear issue link", children: /* @__PURE__ */ oe.jsxs(
              b,
              {
                flexDirection: "row",
                alignItems: "center",
                "data-testid": "copyInputField",
                className: wi.copyWrapper,
                children: [
                  /* @__PURE__ */ oe.jsx(
                    cr,
                    {
                      readOnly: !0,
                      value: n?.url,
                      className: wi.copyField
                    }
                  ),
                  /* @__PURE__ */ oe.jsx(
                    II,
                    {
                      className: wi.copyButton,
                      textToCopy: n?.url || "",
                      clickedProps: {
                        icon: "check-circle-filled"
                      }
                    }
                  )
                ]
              }
            ) })
          ]
        }
      ) }),
      /* @__PURE__ */ oe.jsx(
        wt,
        {
          cancelOnClick: () => r(!1),
          cancelProps: { variant: "primary" },
          cancelName: "Close"
        }
      )
    ]
  }
), Z4 = "https://linear.app/", e5 = ({
  conversationContext: e,
  settings: n
}) => {
  const [r, i] = pe([]), [a, o] = pe([]), [s, l] = pe(!1), [c, m] = pe(!1), [u, f] = pe(!1), [h, k] = pe(), { useLazyQuery: w } = hn(), [N, j] = pe(""), _ = n?.enableCreateIssue, g = !!n?.enableUnlinkAll, { track: O } = jn(), {
    loading: R,
    data: F,
    error: I,
    store: L
  } = Cy(e?.conversationId ?? null), [
    W,
    {
      data: J,
      loading: re,
      networkStatus: K,
      error: Y
    }
  ] = w(i4, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0
  });
  Qe(() => {
    !R && !I && F && F?.linear?.issues?.length > 0 ? (o(F.linear.issues), W({
      variables: {
        linkedIssues: F.linear.issues
      }
    })) : !R && !I && (i([]), o([]));
  }, [F, R, I]), Qe(() => {
    J && J?.Linear && !re && K === rr.ready && Object.keys(J).length > 0 && i(J.Linear.issues?.edges?.map(({ node: me }) => me));
  }, [J, re, K]);
  const P = (me) => {
    me && me?.team?.organization?.urlKey && O("linear:link:issue:clicked", {
      linearInstanceUrl: N,
      linearIssueKey: me.id
    });
    const le = (ge) => ge.id === me?.id;
    r.some((ge) => ge && le(ge)) || (F && a.length === 0 && o([]), L({
      linear: {
        issues: [...a, me.id]
      }
    }));
  }, B = (me) => {
    const le = F?.linear.issues.filter((ge) => ge !== me) || [];
    O("linear:unlink:issue:clicked", {
      linearInstanceUrl: N,
      linearIssueKey: me
    }), i(r.filter(({ id: ge }) => ge !== me)), o(le), L({
      linear: {
        issues: le
      }
    });
  }, ie = () => {
    l(!1), i([]), o([]), L({
      linear: {
        issues: []
      }
    });
  }, we = R || re || !F && !I || (F?.linear?.issues?.length ?? 0) > 0 && r.length === 0;
  return !R && !re && (Y || I) ? /* @__PURE__ */ oe.jsx($n, { error: Y || I }) : /* @__PURE__ */ oe.jsxs(b, { flexDirection: "column", gap: "300", children: [
    /* @__PURE__ */ oe.jsxs(
      bt,
      {
        isOpen: s,
        onClose: () => l(!1),
        children: [
          /* @__PURE__ */ oe.jsx(
            _t,
            {
              title: "Unlink all Linear issues?",
              onClose: () => l(!1)
            }
          ),
          /* @__PURE__ */ oe.jsx(xt, { "data-testid": "unlinkAllIssuesModalBody", children: "You are about to unlink all Linear issues from the conversation. Do you want to proceed?" }),
          /* @__PURE__ */ oe.jsx(
            wt,
            {
              confirmOnClick: () => ie(),
              confirmName: "Unlink all",
              cancelOnClick: () => l(!1)
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ oe.jsx(
      q4,
      {
        isCreateIssueModalOpen: c,
        setIsCreateIssueModalOpen: (me) => m(me),
        setIsCreationSuccessfulModalOpen: (me) => f(me),
        addToLinkedIssueIds: (me) => {
          L({
            linear: {
              issues: [...a, me]
            }
          });
        },
        setCreatedIssue: (me) => k(me),
        organizationUrl: N,
        setOrganizationUrl: (me) => j(me)
      }
    ),
    /* @__PURE__ */ oe.jsx(
      X4,
      {
        isCreationSuccessfulModalOpen: u,
        setIsCreationSuccessfulModalOpen: (me) => f(me),
        createdIssueData: h
      }
    ),
    /* @__PURE__ */ oe.jsxs(
      b,
      {
        flexDirection: "column",
        background: "neutral.100",
        padding: "300",
        borderRadius: "100",
        gap: "250",
        children: [
          _ && /* @__PURE__ */ oe.jsxs(oe.Fragment, { children: [
            /* @__PURE__ */ oe.jsx(
              tt,
              {
                variant: "primary",
                onClick: () => {
                  O("linear:create:new:issue:clicked", {
                    linearInstanceUrl: N
                  }), m(!0);
                },
                style: { minHeight: "38px" },
                children: "Create new issue"
              }
            ),
            /* @__PURE__ */ oe.jsx($.Paragraph, { color: "neutral.600", align: "center", children: "or" })
          ] }),
          /* @__PURE__ */ oe.jsx(I4, { handleSelect: P, linkedIssues: r })
        ]
      }
    ),
    /* @__PURE__ */ oe.jsx(
      P4,
      {
        linkedIssues: r,
        isLoading: we,
        handleUnlinkIssue: B,
        showUnlinkAllModal: (me) => l(me),
        showUnlinkAllButton: g,
        organizationUrl: N
      }
    )
  ] });
}, Il = [
  {
    key: "enableCreateIssue",
    label: 'Enable the "Create issue" button',
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "enableUnlinkAll",
    label: 'Enable the "Unlink all" button',
    type: "boolean",
    secret: !1,
    defaultValue: !0
  }
], aS = ir(Il), Ci = "LINEAR", n5 = {
  enabled: !1,
  name: "",
  enableCreateIssue: !0,
  enableUnlinkAll: !0
}, t5 = ({
  integrationId: e,
  configuration: n,
  handleRedirect: r,
  showNotification: i,
  automationCouplingState: a,
  renderConditionsEditor: o
}) => {
  const s = !e, l = ut({
    mode: "onChange",
    defaultValues: n5
  }), {
    create: c,
    update: m,
    remove: u,
    isLoading: f,
    error: h,
    misconfigurationCause: k,
    setMisconfigurationCause: w
  } = mr({
    integrationId: e,
    integrationType: Ci,
    handleRedirect: r,
    showNotification: i
  }), {
    isLoading: N,
    error: j,
    isWidgetUnknown: _,
    refetch: g,
    widgetConfiguration: O
  } = pr({
    integrationId: e,
    fieldDefinitions: Il,
    form: l,
    onMisconfigured: w
  }), { renderConditions: R, setRenderConditions: F, renderConditionsForSubmit: I } = fr({
    integrationId: e,
    widgetConfiguration: O,
    renderConditionsEditor: o
  }), L = (J) => yr(J, {
    fieldDefinitions: Il,
    isCreationMode: s,
    create: c,
    update: m,
    renderConditions: I
  }), W = l.watch("name");
  return /* @__PURE__ */ oe.jsxs(
    hr,
    {
      form: l,
      integrationId: e,
      onValidSubmit: L,
      error: j ?? h,
      onRetry: j ? g : void 0,
      isLoading: f || N,
      isWidgetUnknown: _,
      children: [
        k && /* @__PURE__ */ oe.jsx(gr, { cause: k }),
        /* @__PURE__ */ oe.jsxs(et, { children: [
          /* @__PURE__ */ oe.jsx(X, { children: /* @__PURE__ */ oe.jsx(He, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ oe.jsx(
            yn,
            {
              name: "enabled",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ oe.jsx(X, { span: 3, children: /* @__PURE__ */ oe.jsx(
            On,
            {
              name: "name",
              label: "Widget name",
              control: l.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ oe.jsx(X, { span: 3 }),
          /* @__PURE__ */ oe.jsx(X, { span: 3, children: /* @__PURE__ */ oe.jsx(He, { label: aS.enableCreateIssue, children: /* @__PURE__ */ oe.jsx(
            yn,
            {
              name: "enableCreateIssue",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ oe.jsx(X, { span: 3 }),
          /* @__PURE__ */ oe.jsx(X, { span: 3, children: /* @__PURE__ */ oe.jsx(He, { label: aS.enableUnlinkAll, children: /* @__PURE__ */ oe.jsx(
            yn,
            {
              name: "enableUnlinkAll",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ oe.jsx(X, { span: 3 }),
          !s && e && /* @__PURE__ */ oe.jsx(
            vi,
            {
              configuration: n,
              integrationId: e,
              integrationType: Ci,
              label: "Authorize with OAuth"
            }
          ),
          o && R !== null && /* @__PURE__ */ oe.jsx(X, { children: o({
            value: R,
            onChange: F,
            configurationKey: O?.id
          }) })
        ] }),
        /* @__PURE__ */ oe.jsx(
          vr,
          {
            integrationType: Ci,
            integrationId: e,
            widgetName: W,
            isCreationMode: s,
            isSubmitting: l.formState.isSubmitting,
            automationCouplingState: a,
            onConfirmDelete: () => u(),
            confirmDeleteVariant: "danger",
            deleteConfirmationBody: /* @__PURE__ */ oe.jsxs(b, { gap: "400", children: [
              /* @__PURE__ */ oe.jsx(
                he,
                {
                  size: 24,
                  name: "exclamation-triangle-filled",
                  color: "red.500"
                }
              ),
              /* @__PURE__ */ oe.jsxs(b, { gap: "200", flexDirection: "column", children: [
                /* @__PURE__ */ oe.jsxs($.Heading, { withMarginBottom: !0, children: [
                  "By deleting the ",
                  Ci,
                  " integration, all links between Dixa and ",
                  Ci,
                  " are also deleted."
                ] }),
                /* @__PURE__ */ oe.jsxs($.Paragraph, { children: [
                  "All data in ",
                  Ci,
                  " stays untouched."
                ] }),
                /* @__PURE__ */ oe.jsxs($.Paragraph, { children: [
                  "Are you sure you want to delete the ",
                  Ci,
                  " ",
                  'integration "',
                  W,
                  '"?'
                ] })
              ] })
            ] })
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._wrapper_27vny_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._textVariant_27vny_7{color:var(--dixa-typography-color-secondary);font-size:var(--dixa-typography-size-300)}._copyIcon_27vny_12{cursor:pointer;color:var(--dixa-typography-color-secondary)}._labelText_1q5b5_1{color:var(--dixa-typography-color-secondary)}._list_1q5b5_5{padding:0}._listItem_1q5b5_8{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_1q5b5_8:last-child{border-bottom:none}._listItemEdit_1q5b5_15{cursor:pointer}._notificationText_1q5b5_19{color:var(--dixa-color-neutral-500)}._modalBody_1clhs_1{width:400px}._reward_1wxia_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._reward_1wxia_1:hover{border-color:var(--dixa-color-neutral-400)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Am = { exports: {} }, lo = {}, oS;
function r5() {
  if (oS) return lo;
  oS = 1;
  var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, c, m) {
    var u, f = {}, h = null, k = null;
    m !== void 0 && (h = "" + m), c.key !== void 0 && (h = "" + c.key), c.ref !== void 0 && (k = c.ref);
    for (u in c) i.call(c, u) && !o.hasOwnProperty(u) && (f[u] = c[u]);
    if (l && l.defaultProps) for (u in c = l.defaultProps, c) f[u] === void 0 && (f[u] = c[u]);
    return { $$typeof: n, type: l, key: h, ref: k, props: f, _owner: a.current };
  }
  return lo.Fragment = r, lo.jsx = s, lo.jsxs = s, lo;
}
var Fs = {}, sS;
function i5() {
  return sS || (sS = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), c = /* @__PURE__ */ Symbol.for("react.forward_ref"), m = /* @__PURE__ */ Symbol.for("react.suspense"), u = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), k = /* @__PURE__ */ Symbol.for("react.offscreen"), w = Symbol.iterator, N = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var d = w && t[w] || t[N];
      return typeof d == "function" ? d : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var d = arguments.length, p = new Array(d > 1 ? d - 1 : 0), y = 1; y < d; y++)
          p[y - 1] = arguments[y];
        O("error", t, p);
      }
    }
    function O(t, d, p) {
      {
        var y = _.ReactDebugCurrentFrame, C = y.getStackAddendum();
        C !== "" && (d += "%s", p = p.concat([C]));
        var T = p.map(function(S) {
          return String(S);
        });
        T.unshift("Warning: " + d), Function.prototype.apply.call(console[t], console, T);
      }
    }
    var R = !1, F = !1, I = !1, L = !1, W = !1, J;
    J = /* @__PURE__ */ Symbol.for("react.module.reference");
    function re(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || W || t === a || t === m || t === u || L || t === k || R || F || I || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === J || t.getModuleId !== void 0));
    }
    function K(t, d, p) {
      var y = t.displayName;
      if (y)
        return y;
      var C = d.displayName || d.name || "";
      return C !== "" ? p + "(" + C + ")" : p;
    }
    function Y(t) {
      return t.displayName || "Context";
    }
    function P(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var d = t;
            return Y(d) + ".Consumer";
          case s:
            var p = t;
            return Y(p._context) + ".Provider";
          case c:
            return K(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : P(t.type) || "Memo";
          case h: {
            var C = t, T = C._payload, S = C._init;
            try {
              return P(S(T));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, ie = 0, we, me, le, ge, V, be, Oe;
    function q() {
    }
    q.__reactDisabledLog = !0;
    function Ge() {
      {
        if (ie === 0) {
          we = console.log, me = console.info, le = console.warn, ge = console.error, V = console.group, be = console.groupCollapsed, Oe = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: q,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ie++;
      }
    }
    function sn() {
      {
        if (ie--, ie === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, t, {
              value: we
            }),
            info: B({}, t, {
              value: me
            }),
            warn: B({}, t, {
              value: le
            }),
            error: B({}, t, {
              value: ge
            }),
            group: B({}, t, {
              value: V
            }),
            groupCollapsed: B({}, t, {
              value: be
            }),
            groupEnd: B({}, t, {
              value: Oe
            })
          });
        }
        ie < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ie = _.ReactCurrentDispatcher, Ue;
    function De(t, d, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (C) {
            var y = C.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Ae;
    {
      var Je = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Je();
    }
    function Ee(t, d) {
      if (!t || Be)
        return "";
      {
        var p = Ae.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Be = !0;
      var C = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var T;
      T = Ie.current, Ie.current = null, Ge();
      try {
        if (d) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (ne) {
              y = ne;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (ne) {
              y = ne;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            y = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && y && typeof ne.stack == "string") {
          for (var x = ne.stack.split(`
`), Z = y.stack.split(`
`), A = x.length - 1, M = Z.length - 1; A >= 1 && M >= 0 && x[A] !== Z[M]; )
            M--;
          for (; A >= 1 && M >= 0; A--, M--)
            if (x[A] !== Z[M]) {
              if (A !== 1 || M !== 1)
                do
                  if (A--, M--, M < 0 || x[A] !== Z[M]) {
                    var ue = `
` + x[A].replace(" at new ", " at ");
                    return t.displayName && ue.includes("<anonymous>") && (ue = ue.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, ue), ue;
                  }
                while (A >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Ie.current = T, sn(), Error.prepareStackTrace = C;
      }
      var ze = t ? t.displayName || t.name : "", Te = ze ? De(ze) : "";
      return typeof t == "function" && Ae.set(t, Te), Te;
    }
    function Me(t, d, p) {
      return Ee(t, !1);
    }
    function en(t) {
      var d = t.prototype;
      return !!(d && d.isReactComponent);
    }
    function se(t, d, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ee(t, en(t));
      if (typeof t == "string")
        return De(t);
      switch (t) {
        case m:
          return De("Suspense");
        case u:
          return De("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case c:
            return Me(t.render);
          case f:
            return se(t.type, d, p);
          case h: {
            var y = t, C = y._payload, T = y._init;
            try {
              return se(T(C), d, p);
            } catch {
            }
          }
        }
      return "";
    }
    var de = Object.prototype.hasOwnProperty, Se = {}, Ve = _.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var d = t._owner, p = se(t.type, t._source, d ? d.type : null);
        Ve.setExtraStackFrame(p);
      } else
        Ve.setExtraStackFrame(null);
    }
    function kn(t, d, p, y, C) {
      {
        var T = Function.call.bind(de);
        for (var S in t)
          if (T(t, S)) {
            var x = void 0;
            try {
              if (typeof t[S] != "function") {
                var Z = Error((y || "React class") + ": " + p + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Z.name = "Invariant Violation", Z;
              }
              x = t[S](d, S, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (A) {
              x = A;
            }
            x && !(x instanceof Error) && (Pe(C), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, S, typeof x), Pe(null)), x instanceof Error && !(x.message in Se) && (Se[x.message] = !0, Pe(C), g("Failed %s type: %s", p, x.message), Pe(null));
          }
      }
    }
    var Q = Array.isArray;
    function E(t) {
      return Q(t);
    }
    function z(t) {
      {
        var d = typeof Symbol == "function" && Symbol.toStringTag, p = d && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function ae(t) {
      try {
        return ce(t), !1;
      } catch {
        return !0;
      }
    }
    function ce(t) {
      return "" + t;
    }
    function U(t) {
      if (ae(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", z(t)), ce(t);
    }
    var G = _.ReactCurrentOwner, ve = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, je, Re;
    function rn(t) {
      if (de.call(t, "ref")) {
        var d = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (d && d.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function bn(t) {
      if (de.call(t, "key")) {
        var d = Object.getOwnPropertyDescriptor(t, "key").get;
        if (d && d.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function an(t, d) {
      typeof t.ref == "string" && G.current;
    }
    function fn(t, d) {
      {
        var p = function() {
          je || (je = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", d));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function En(t, d) {
      {
        var p = function() {
          Re || (Re = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", d));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var _n = function(t, d, p, y, C, T, S) {
      var x = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: d,
        ref: p,
        props: S,
        // Record the component responsible for creating this element.
        _owner: T
      };
      return x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(x, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(x, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: C
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    };
    function Fn(t, d, p, y, C) {
      {
        var T, S = {}, x = null, Z = null;
        p !== void 0 && (U(p), x = "" + p), bn(d) && (U(d.key), x = "" + d.key), rn(d) && (Z = d.ref, an(d));
        for (T in d)
          de.call(d, T) && !ve.hasOwnProperty(T) && (S[T] = d[T]);
        if (t && t.defaultProps) {
          var A = t.defaultProps;
          for (T in A)
            S[T] === void 0 && (S[T] = A[T]);
        }
        if (x || Z) {
          var M = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          x && fn(S, M), Z && En(S, M);
        }
        return _n(t, x, Z, C, y, G.current, S);
      }
    }
    var Ze = _.ReactCurrentOwner, gn = _.ReactDebugCurrentFrame;
    function Le(t) {
      if (t) {
        var d = t._owner, p = se(t.type, t._source, d ? d.type : null);
        gn.setExtraStackFrame(p);
      } else
        gn.setExtraStackFrame(null);
    }
    var dn;
    dn = !1;
    function cn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function Nn() {
      {
        if (Ze.current) {
          var t = P(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Bn(t) {
      return "";
    }
    var Sn = {};
    function An(t) {
      {
        var d = Nn();
        if (!d) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (d = `

Check the top-level render call using <` + p + ">.");
        }
        return d;
      }
    }
    function vn(t, d) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = An(d);
        if (Sn[p])
          return;
        Sn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Ze.current && (y = " It was passed a child from " + P(t._owner.type) + "."), Le(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Le(null);
      }
    }
    function xn(t, d) {
      {
        if (typeof t != "object")
          return;
        if (E(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            cn(y) && vn(y, d);
          }
        else if (cn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var C = j(t);
          if (typeof C == "function" && C !== t.entries)
            for (var T = C.call(t), S; !(S = T.next()).done; )
              cn(S.value) && vn(S.value, d);
        }
      }
    }
    function Ln(t) {
      {
        var d = t.type;
        if (d == null || typeof d == "string")
          return;
        var p;
        if (typeof d == "function")
          p = d.propTypes;
        else if (typeof d == "object" && (d.$$typeof === c || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        d.$$typeof === f))
          p = d.propTypes;
        else
          return;
        if (p) {
          var y = P(d);
          kn(p, t.props, "prop", y, t);
        } else if (d.PropTypes !== void 0 && !dn) {
          dn = !0;
          var C = P(d);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", C || "Unknown");
        }
        typeof d.getDefaultProps == "function" && !d.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var d = Object.keys(t.props), p = 0; p < d.length; p++) {
          var y = d[p];
          if (y !== "children" && y !== "key") {
            Le(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Le(null);
            break;
          }
        }
        t.ref !== null && (Le(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Le(null));
      }
    }
    var Cn = {};
    function wn(t, d, p, y, C, T) {
      {
        var S = re(t);
        if (!S) {
          var x = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (x += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Z = Bn();
          Z ? x += Z : x += Nn();
          var A;
          t === null ? A = "null" : E(t) ? A = "array" : t !== void 0 && t.$$typeof === n ? (A = "<" + (P(t.type) || "Unknown") + " />", x = " Did you accidentally export a JSX literal instead of a component?") : A = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", A, x);
        }
        var M = Fn(t, d, p, C, T);
        if (M == null)
          return M;
        if (S) {
          var ue = d.children;
          if (ue !== void 0)
            if (y)
              if (E(ue)) {
                for (var ze = 0; ze < ue.length; ze++)
                  xn(ue[ze], t);
                Object.freeze && Object.freeze(ue);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              xn(ue, t);
        }
        if (de.call(d, "key")) {
          var Te = P(t), ne = Object.keys(d).filter(function(Kn) {
            return Kn !== "key";
          }), un = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Cn[Te + un]) {
            var Rn = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, un, Te, Rn, Te), Cn[Te + un] = !0;
          }
        }
        return t === i ? Vn(M) : Ln(M), M;
      }
    }
    function zn(t, d, p) {
      return wn(t, d, p, !0);
    }
    function qn(t, d, p) {
      return wn(t, d, p, !1);
    }
    var Un = qn, Wn = zn;
    Fs.Fragment = i, Fs.jsx = Un, Fs.jsxs = Wn;
  })()), Fs;
}
var lS;
function a5() {
  return lS || (lS = 1, process.env.NODE_ENV === "production" ? Am.exports = r5() : Am.exports = i5()), Am.exports;
}
var Fe = a5();
const o5 = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] }, s5 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "addPoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "merchantId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_updateCustomersPoints_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "updateCustomersPoints" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "merchant_id" }, value: { kind: "Variable", name: { kind: "Name", value: "merchantId" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_updateCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UpdateCustomersPointsResponse" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Unauthorized" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Unauthorized" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Forbidden" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Forbidden" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "NotFound" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_NotFound" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "UnprocessableEntity" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_UnprocessableEntity" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerError" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_ServerError" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "UpdateCustomersPointsResponse" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_updateCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "BadRequest" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Unauthorized" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Forbidden" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "NotFound" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "UnprocessableEntity" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "ServerError" } }] } }] }, l5 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "removePoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "merchantId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_removeCustomersPoints_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "removeCustomersPoints" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "merchant_id" }, value: { kind: "Variable", name: { kind: "Name", value: "merchantId" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_removeCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "RemoveCustomersPointsResponse" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Unauthorized" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Unauthorized" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Forbidden" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Forbidden" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "NotFound" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_NotFound" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "UnprocessableEntity" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_UnprocessableEntity" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerError" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_ServerError" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "RemoveCustomersPointsResponse" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_removeCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "BadRequest" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Unauthorized" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Forbidden" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "NotFound" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "UnprocessableEntity" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "ServerError" } }] } }] }, d5 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomers" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getCustomers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_getCustomers_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Customers" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customers" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "merchant_id" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "points_approved" } }, { kind: "Field", name: { kind: "Name", value: "points_pending" } }, { kind: "Field", name: { kind: "Name", value: "points_spent" } }, { kind: "Field", name: { kind: "Name", value: "rewards_claimed" } }, { kind: "Field", name: { kind: "Name", value: "birthday" } }, { kind: "Field", name: { kind: "Name", value: "guest" } }, { kind: "Field", name: { kind: "Name", value: "blocked" } }, { kind: "Field", name: { kind: "Name", value: "enrolled" } }, { kind: "Field", name: { kind: "Name", value: "enrolled_at" } }, { kind: "Field", name: { kind: "Name", value: "referral_id" } }, { kind: "Field", name: { kind: "Name", value: "referred_by" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "merchant_id" } }] } }, { kind: "Field", name: { kind: "Name", value: "loyalty_tier_membership" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "started_at" } }, { kind: "Field", name: { kind: "Name", value: "expires_at" } }, { kind: "Field", name: { kind: "Name", value: "manual" } }, { kind: "Field", name: { kind: "Name", value: "loyalty_tier" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "position" } }, { kind: "Field", name: { kind: "Name", value: "default" } }, { kind: "Field", name: { kind: "Name", value: "hidden" } }, { kind: "Field", name: { kind: "Name", value: "lower_bound" } }, { kind: "Field", name: { kind: "Name", value: "upper_bound" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "insights_segment" } }, { kind: "Field", name: { kind: "Name", value: "referral_url" } }, { kind: "Field", name: { kind: "Name", value: "metadata" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shopify_source_url" } }] } }, { kind: "Field", name: { kind: "Name", value: "properties" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }] } }] } }] } }] } }] } }] } }] } }] }, c5 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getRewards" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "merchantId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getAvailableRewards" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "merchant_id" }, value: { kind: "Variable", name: { kind: "Name", value: "merchantId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_getAvailableRewards_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Rewards" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "rewards" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "site_id" } }, { kind: "Field", name: { kind: "Name", value: "target_site" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }, { kind: "Field", name: { kind: "Name", value: "content" } }, { kind: "Field", name: { kind: "Name", value: "kind" } }, { kind: "Field", name: { kind: "Name", value: "point_cost" } }] } }] } }, { kind: "FragmentSpread", name: { kind: "Name", value: "BadRequest" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Unauthorized" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Forbidden" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "NotFound" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "ServerError" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Unauthorized" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Unauthorized" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Forbidden" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Forbidden" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "NotFound" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_NotFound" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerError" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_ServerError" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] }, u5 = {
  "\n  fragment BadRequest on LoyaltyLion_BadRequest {\n    message\n  }\n  fragment Unauthorized on LoyaltyLion_Unauthorized {\n    message\n  }\n  fragment Forbidden on LoyaltyLion_Forbidden {\n    message\n  }\n  fragment NotFound on LoyaltyLion_NotFound {\n    message\n  }\n  fragment UnprocessableEntity on LoyaltyLion_UnprocessableEntity {\n    message\n  }\n  fragment ServerError on LoyaltyLion_ServerError {\n    message\n  }\n\n  fragment UpdateCustomersPointsResponse on LoyaltyLion_updateCustomersPoints_response {\n    ...BadRequest\n    ...Unauthorized\n    ...Forbidden\n    ...NotFound\n    ...UnprocessableEntity\n    ...ServerError\n  }\n\n  fragment RemoveCustomersPointsResponse on LoyaltyLion_removeCustomersPoints_response {\n    ...BadRequest\n    ...Unauthorized\n    ...Forbidden\n    ...NotFound\n    ...UnprocessableEntity\n    ...ServerError\n  }\n": o5,
  "\n  mutation addPoints(\n    $merchantId: String!\n    $input: LoyaltyLion_updateCustomersPoints_request_Input!\n  ) {\n    LoyaltyLion {\n      updateCustomersPoints(merchant_id: $merchantId, input: $input) {\n        ... on LoyaltyLion_updateCustomersPoints_response {\n          ...UpdateCustomersPointsResponse\n        }\n      }\n    }\n  }\n": s5,
  "\n  mutation removePoints(\n    $merchantId: String!\n    $input: LoyaltyLion_removeCustomersPoints_request_Input!\n  ) {\n    LoyaltyLion {\n      removeCustomersPoints(merchant_id: $merchantId, input: $input) {\n        ... on LoyaltyLion_removeCustomersPoints_response {\n          ...RemoveCustomersPointsResponse\n        }\n      }\n    }\n  }\n": l5,
  "\n  query getCustomers($email: String!) {\n    LoyaltyLion {\n      getCustomers(email: $email) {\n        ... on LoyaltyLion_getCustomers_response {\n          ... on LoyaltyLion_Customers {\n            customers {\n              id\n              merchant_id\n              email\n              points_approved\n              points_pending\n              points_spent\n              rewards_claimed\n              birthday\n              guest\n              blocked\n              enrolled\n              enrolled_at\n              referral_id\n              referred_by {\n                id\n                merchant_id\n              }\n              loyalty_tier_membership {\n                started_at\n                expires_at\n                manual\n                loyalty_tier {\n                  id\n                  name\n                  position\n                  default\n                  hidden\n                  lower_bound\n                  upper_bound\n                }\n              }\n              insights_segment\n              referral_url\n              metadata {\n                shopify_source_url\n              }\n              properties {\n                name\n                first_name\n                last_name\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": d5,
  "\n  query getRewards($merchantId: String!) {\n    LoyaltyLion {\n      getAvailableRewards(merchant_id: $merchantId) {\n        ... on LoyaltyLion_getAvailableRewards_response {\n          ... on LoyaltyLion_Rewards {\n            rewards {\n              id\n              title\n              description\n              site_id\n              target_site {\n                id\n                name\n                url\n              }\n              content\n              kind\n              point_cost\n            }\n          }\n          ...BadRequest\n          ...Unauthorized\n          ...Forbidden\n          ...NotFound\n          ...ServerError\n        }\n      }\n    }\n  }\n": c5
};
function ld(e) {
  return u5[e] ?? {};
}
const m5 = ld(
  /* GraphQL */
  `
  query getCustomers($email: String!) {
    LoyaltyLion {
      getCustomers(email: $email) {
        ... on LoyaltyLion_getCustomers_response {
          ... on LoyaltyLion_Customers {
            customers {
              id
              merchant_id
              email
              points_approved
              points_pending
              points_spent
              rewards_claimed
              birthday
              guest
              blocked
              enrolled
              enrolled_at
              referral_id
              referred_by {
                id
                merchant_id
              }
              loyalty_tier_membership {
                started_at
                expires_at
                manual
                loyalty_tier {
                  id
                  name
                  position
                  default
                  hidden
                  lower_bound
                  upper_bound
                }
              }
              insights_segment
              referral_url
              metadata {
                shopify_source_url
              }
              properties {
                name
                first_name
                last_name
              }
            }
          }
        }
      }
    }
  }
`
), p5 = ld(
  /* GraphQL */
  `
  query getRewards($merchantId: String!) {
    LoyaltyLion {
      getAvailableRewards(merchant_id: $merchantId) {
        ... on LoyaltyLion_getAvailableRewards_response {
          ... on LoyaltyLion_Rewards {
            rewards {
              id
              title
              description
              site_id
              target_site {
                id
                name
                url
              }
              content
              kind
              point_cost
            }
          }
          ...BadRequest
          ...Unauthorized
          ...Forbidden
          ...NotFound
          ...ServerError
        }
      }
    }
  }
`
), f5 = ld(
  /* GraphQL */
  `
  mutation addPoints(
    $merchantId: String!
    $input: LoyaltyLion_updateCustomersPoints_request_Input!
  ) {
    LoyaltyLion {
      updateCustomersPoints(merchant_id: $merchantId, input: $input) {
        ... on LoyaltyLion_updateCustomersPoints_response {
          ...UpdateCustomersPointsResponse
        }
      }
    }
  }
`
), h5 = ld(
  /* GraphQL */
  `
  mutation removePoints(
    $merchantId: String!
    $input: LoyaltyLion_removeCustomersPoints_request_Input!
  ) {
    LoyaltyLion {
      removeCustomersPoints(merchant_id: $merchantId, input: $input) {
        ... on LoyaltyLion_removeCustomersPoints_response {
          ...RemoveCustomersPointsResponse
        }
      }
    }
  }
`
);
function Lm(e = !1, n) {
  const [r, i] = pe(e);
  return Qe(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copy: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const y5 = "_wrapper_27vny_1", g5 = "_copyIcon_27vny_12", co = {
  wrapper: y5,
  copyIcon: g5
}, v5 = ({
  customer: e
}) => {
  const { isCopied: n, copy: r } = Lm(), { isCopied: i, copy: a } = Lm(), { isCopied: o, copy: s } = Lm();
  if (!e)
    return null;
  const l = 14, {
    email: c,
    properties: m,
    metadata: u,
    birthday: f,
    created_at: h,
    enrolled: k,
    enrolled_at: w,
    referral_url: N
  } = e, j = f ? Gn(f).isSame(Date.now(), "day") : !1, { name: _, first_name: g, last_name: O } = m ?? {}, R = _ ?? (`${g} ${O}`.trim() || "A customer has no name"), F = u?.shopify_source_url ? u.shopify_source_url.startsWith("https://") ? u.shopify_source_url : `https://${u.shopify_source_url}` : "";
  return /* @__PURE__ */ Fe.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ Fe.jsxs(b, { className: co.wrapper, gap: "250", flexDirection: "column", children: [
    /* @__PURE__ */ Fe.jsxs(
      b,
      {
        justifyContent: "space-between",
        className: co.block,
        alignItems: "center",
        children: [
          /* @__PURE__ */ Fe.jsx($.Heading, { variant: "heading-2", children: R }),
          j && /* @__PURE__ */ Fe.jsx($.Paragraph, { variant: "4", color: "primary", children: "... has birthday today 🥳" })
        ]
      }
    ),
    h && /* @__PURE__ */ Fe.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Fe.jsx($.Paragraph, { variant: "4", color: "secondary", children: "Member since" }),
      /* @__PURE__ */ Fe.jsx($.Paragraph, { variant: "4", color: "secondary", children: Gn(h).format("DD MMM YYYY @ HH:mm") })
    ] }),
    k && /* @__PURE__ */ Fe.jsx(b, { gap: "200", children: /* @__PURE__ */ Fe.jsxs($.Paragraph, { variant: "4", color: "secondary", children: [
      "Enrolled since ",
      Gn(w).format("DD MMM YYYY @ HH:mm")
    ] }) }),
    /* @__PURE__ */ Fe.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Fe.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ Fe.jsx(he, { size: l, name: "mail" }),
        /* @__PURE__ */ Fe.jsx($.ExternalLink, { href: `mailto:${c}`, children: c })
      ] }),
      /* @__PURE__ */ Fe.jsx(Xe, { content: n ? "Copied" : "Copy", children: /* @__PURE__ */ Fe.jsx(
        he,
        {
          size: l,
          name: n ? "done" : "copy",
          onClick: () => r(c),
          className: co.copyIcon
        }
      ) })
    ] }),
    F && /* @__PURE__ */ Fe.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Fe.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ Fe.jsx(he, { size: l, name: "link" }),
        /* @__PURE__ */ Fe.jsx(Xe, { content: "Shopify shop", children: /* @__PURE__ */ Fe.jsx(
          $.ExternalLink,
          {
            href: F,
            target: "_blank",
            rel: "noreferrer",
            children: F.replace("https://", "")
          }
        ) })
      ] }),
      /* @__PURE__ */ Fe.jsx(Xe, { content: i ? "Copied" : "Copy", children: /* @__PURE__ */ Fe.jsx(
        he,
        {
          size: l,
          name: i ? "done" : "copy",
          onClick: () => a(F),
          className: co.copyIcon
        }
      ) })
    ] }),
    N && /* @__PURE__ */ Fe.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Fe.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ Fe.jsx(he, { size: l, name: "external-link" }),
        /* @__PURE__ */ Fe.jsx(Xe, { content: "Referral link", children: /* @__PURE__ */ Fe.jsx(
          $.ExternalLink,
          {
            href: N,
            target: "_blank",
            rel: "noreferrer",
            children: N.replace("https://", "")
          }
        ) })
      ] }),
      /* @__PURE__ */ Fe.jsx(Xe, { content: o ? "Copied" : "Copy", children: /* @__PURE__ */ Fe.jsx(
        he,
        {
          size: l,
          name: o ? "done" : "copy",
          onClick: () => s(N),
          className: co.copyIcon
        }
      ) })
    ] })
  ] }) });
}, k5 = "_list_1q5b5_5", b5 = "_listItem_1q5b5_8", _5 = "_listItemEdit_1q5b5_15", x5 = "_notificationText_1q5b5_19", ja = {
  list: k5,
  listItem: b5,
  listItemEdit: _5,
  notificationText: x5
}, S5 = "_modalBody_1clhs_1", N5 = {
  modalBody: S5
}, j5 = ({
  isOpen: e,
  points: n,
  merchantId: r,
  onClose: i,
  refetchCustomerData: a
}) => {
  const { useMutation: o, showNotification: s } = hn(), { track: l } = jn(), [c, m] = pe(n), [u, f] = pe(""), [h, k] = pe(), [w, { loading: N }] = o(
    f5,
    {
      onCompleted: () => {
        s({
          title: "Success",
          text: "Added points successfully",
          icon: "check-circle-filled",
          severity: "success"
        }), l("loyaltylion:add:points:succeeded"), K();
      }
    }
  ), [j, { loading: _ }] = o(h5), g = N || _, O = !!h, R = n === c ? "Change the value to update the points" : "", F = isNaN(c), I = F ? "Points can not be empty" : "", L = c > n && c - n > 1e6, W = L ? "Points can not exceed 1,000,000" : "", J = () => {
    if (!r) {
      k(["Merchant information is missing."]), c > n ? l("loyaltylion:add:points:failed") : c < n && l("loyaltylion:remove:points:failed");
      return;
    }
    c > n && w({
      variables: {
        input: {
          points: c - n,
          reason: u
        },
        merchantId: r
      }
    }).catch((Y) => {
      const P = Y?.networkError;
      (P ? P?.statusCode : NaN) === 201 ? (l("loyaltylion:add:points:succeeded"), s({
        title: "Success",
        text: "Added points successfully",
        icon: "check-circle-filled",
        severity: "success"
      }), K()) : (l("loyaltylion:add:points:failed"), k(["Failed to add points, try again later."]));
    }), c < n && j({
      variables: {
        input: {
          points: n - c,
          reason: u
        },
        merchantId: r
      }
    }).then((Y) => {
      Y.data?.LoyaltyLion?.removeCustomersPoints?.__typename === "LoyaltyLion_Void_container" ? (l("loyaltylion:remove:points:succeeded"), s({
        title: "Success",
        text: "Removed points successfully",
        icon: "check-circle-filled",
        severity: "success"
      }), K()) : "errors" in Y && (l("loyaltylion:remove:points:failed"), k(
        Y.errors?.map((P) => P.message) ?? [
          "Failed to remove points, try again later."
        ]
      ));
    }).catch(() => {
      l("loyaltylion:remove:points:failed"), k(["Failed to remove points, try again later."]);
    });
  }, re = () => {
    F && m(n), f(""), i();
  }, K = () => {
    a(), re();
  };
  return /* @__PURE__ */ Fe.jsxs(
    bt,
    {
      isOpen: e,
      onClose: re,
      "data-testid": "change-points-modal",
      children: [
        /* @__PURE__ */ Fe.jsx(_t, { title: "Change points", onClose: re }),
        /* @__PURE__ */ Fe.jsxs(xt, { className: N5.modalBody, children: [
          /* @__PURE__ */ Fe.jsxs(et, { children: [
            /* @__PURE__ */ Fe.jsx(X, { span: 6, children: /* @__PURE__ */ Fe.jsx(
              Wr,
              {
                required: !0,
                label: "New points",
                type: "number",
                placeholder: "Insert new points",
                min: 0,
                max: 1e5,
                meta: {
                  error: W || I,
                  warning: R
                },
                input: {
                  name: "points",
                  value: c.toString(),
                  onChange: (Y) => m(Y?.target.valueAsNumber ?? 0)
                },
                "data-testid": "points-input"
              }
            ) }),
            /* @__PURE__ */ Fe.jsx(X, { span: 6, children: /* @__PURE__ */ Fe.jsx(
              Wr,
              {
                label: "Reason",
                placeholder: "Insert an optional reason",
                input: {
                  name: "reason",
                  value: u,
                  onChange: (Y) => f(Y?.target.value ?? "")
                }
              }
            ) })
          ] }),
          !g && O && /* @__PURE__ */ Fe.jsx(b, { margin: "200 0", flexDirection: "column", children: /* @__PURE__ */ Fe.jsx(Ye, { children: h?.map((Y, P) => /* @__PURE__ */ Fe.jsx(
            Ye.Item,
            {
              variant: "dense",
              title: Y,
              contentLeft: /* @__PURE__ */ Fe.jsx(
                he,
                {
                  color: "red.500",
                  size: 16,
                  name: "exclamation-triangle-filled"
                }
              )
            },
            P
          )) }) })
        ] }),
        /* @__PURE__ */ Fe.jsx(
          wt,
          {
            confirmName: "Save",
            confirmOnClick: () => J(),
            confirmProps: {
              isLoading: g,
              disabled: F || L || n === c,
              loadingIndicator: /* @__PURE__ */ Fe.jsx(mn, { size: 16 })
            },
            cancelOnClick: re
          }
        )
      ]
    }
  );
}, w5 = ({
  label: e,
  points: n,
  setIsModalOpen: r
}) => {
  const i = n > 0 ? "green.500" : "neutral.400", a = n > 0 ? "warning" : "secondary", o = 10;
  return /* @__PURE__ */ Fe.jsx(Ye.Text, { variant: "dense", className: ja.listItem, children: /* @__PURE__ */ Fe.jsxs(b, { justifyContent: "space-between", children: [
    /* @__PURE__ */ Fe.jsxs(b, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ Fe.jsx(he, { color: i, size: o, name: "star-full" }),
      /* @__PURE__ */ Fe.jsx($.Paragraph, { variant: "4", children: e })
    ] }),
    /* @__PURE__ */ Fe.jsxs(b, { gap: "200", alignItems: "center", children: [
      r && /* @__PURE__ */ Fe.jsx(Xe, { content: "Edit points", children: /* @__PURE__ */ Fe.jsx(
        he,
        {
          name: "pen",
          size: o,
          "aria-label": "Edit points",
          className: ja.listItemEdit,
          onClick: () => r(!0)
        }
      ) }),
      /* @__PURE__ */ Fe.jsx(Pn, { size: "small", variant: a, children: n })
    ] })
  ] }) });
}, C5 = ({
  customer: e,
  refetchCustomerData: n
}) => {
  const [r, i] = pe(!1);
  if (!e)
    return null;
  const {
    merchant_id: a,
    points_approved: o,
    points_pending: s,
    points_spent: l,
    rewards_claimed: c
  } = e, m = [
    {
      id: "pointsApproved",
      label: "Points approved",
      points: o ?? 0,
      setIsModalOpen: i
    },
    {
      id: "pointsPending",
      label: "Points pending",
      points: s ?? 0
    },
    {
      id: "pointsSpent",
      label: "Points spent",
      points: l ?? 0
    },
    {
      id: "rewardClaimed",
      label: "Rewards claimed",
      points: c ?? 0
    }
  ];
  return /* @__PURE__ */ Fe.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Fe.jsx($.Heading, { variant: "heading-3", children: "Points balance" }),
    /* @__PURE__ */ Fe.jsx(Ye, { className: ja.list, children: m.map(({ id: u, points: f, label: h, setIsModalOpen: k }) => /* @__PURE__ */ Fe.jsx(
      w5,
      {
        points: f,
        label: h,
        setIsModalOpen: k
      },
      u
    )) }),
    /* @__PURE__ */ Fe.jsx(
      j5,
      {
        isOpen: r,
        points: o,
        merchantId: a,
        onClose: () => i(!1),
        refetchCustomerData: n
      }
    )
  ] });
}, F5 = "_reward_1wxia_1", I5 = {
  reward: F5
}, $5 = ({ reward: e }) => {
  const {
    title: n,
    point_cost: r,
    target_site: i,
    description: a
  } = e, o = i?.name, s = i?.url;
  return /* @__PURE__ */ Fe.jsx(b, { gap: "100", flexDirection: "column", className: I5.reward, children: /* @__PURE__ */ Fe.jsx(Xe, { content: a ?? "No description", children: /* @__PURE__ */ Fe.jsxs(b, { gap: "100", flexDirection: "column", children: [
    /* @__PURE__ */ Fe.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ Fe.jsxs(b, { gap: "100", alignItems: "center", children: [
        /* @__PURE__ */ Fe.jsx(he, { name: "star", size: 12, color: "neutral.500" }),
        n
      ] }),
      /* @__PURE__ */ Fe.jsxs(Pn, { size: "small", variant: "info", children: [
        r ?? 0,
        " points"
      ] })
    ] }),
    o && s && /* @__PURE__ */ Fe.jsxs(b, { gap: "100", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ Fe.jsx(he, { size: 14, name: "external-link" }),
      /* @__PURE__ */ Fe.jsx(
        $.ExternalLink,
        {
          href: s,
          target: "_blank",
          rel: "noreferrer",
          children: o
        }
      )
    ] })
  ] }) }) });
}, E5 = ({ customer: e }) => {
  const { useQuery: n } = hn(), [r, i] = pe(), { merchant_id: a } = e, {
    loading: o,
    error: s,
    data: l
  } = n(p5, {
    skip: !a,
    variables: {
      merchantId: a
    }
  });
  if (Qe(() => {
    if (l?.LoyaltyLion) {
      const c = l.LoyaltyLion?.getAvailableRewards?.rewards;
      c && i(c);
    }
  }, [l]), s) {
    const c = s.graphQLErrors;
    return Ca({ errors: c }) ? /* @__PURE__ */ Fe.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200 0 300 0",
        className: ja.notificationText,
        children: "No rewards found"
      }
    ) : Sw({ errors: c }) ? /* @__PURE__ */ Fe.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200 0 300 0",
        className: ja.notificationText,
        children: "You don't have permissions to view rewards"
      }
    ) : /* @__PURE__ */ Fe.jsx($n, { error: s });
  }
  return /* @__PURE__ */ Fe.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Fe.jsx($.Heading, { variant: "heading-3", children: "Available rewards" }),
    o ? /* @__PURE__ */ Fe.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ Fe.jsx(mn, {}) }) : /* @__PURE__ */ Fe.jsx(b, { gap: "200", flexDirection: "column", children: r?.map((c) => /* @__PURE__ */ Fe.jsx($5, { reward: c }, c.id)) })
  ] });
}, T5 = ({ customer: e }) => {
  const { blocked: n, guest: r, insights_segment: i } = e ?? {}, a = n || r || i, o = 14;
  return a ? /* @__PURE__ */ Fe.jsxs(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [
    n && /* @__PURE__ */ Fe.jsx(b, { alignItems: "start", children: /* @__PURE__ */ Fe.jsx(Jn, { children: /* @__PURE__ */ Fe.jsxs(b, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ Fe.jsx(
        he,
        {
          size: o,
          color: "red.500",
          name: "exclamation-triangle-filled"
        }
      ),
      "Blocked"
    ] }) }) }),
    r && /* @__PURE__ */ Fe.jsx(b, { alignItems: "start", children: /* @__PURE__ */ Fe.jsx(Jn, { children: /* @__PURE__ */ Fe.jsxs(b, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ Fe.jsx(he, { size: o, color: "green.500", name: "user" }),
      "Guest"
    ] }) }) }),
    i && /* @__PURE__ */ Fe.jsx(b, { alignItems: "start", children: /* @__PURE__ */ Fe.jsx(Xe, { content: "Insights segment", children: /* @__PURE__ */ Fe.jsx(Jn, { children: /* @__PURE__ */ Fe.jsxs(b, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ Fe.jsx(he, { size: o, color: "green.500", name: "team" }),
      i
    ] }) }) }) })
  ] }) : null;
}, R5 = ({
  conversationContext: e,
  settings: n
}) => {
  const { useQuery: r } = hn(), { track: i } = jn(), [a, o] = pe(null), { customer: s } = e, {
    showCustomerSummary: l,
    showTags: c,
    showPointsBalance: m,
    showAvailableRewards: u
  } = n, f = !l && !c && !m && !u, {
    loading: h,
    error: k,
    data: w,
    refetch: N
  } = r(m5, {
    skip: !s?.email,
    variables: {
      email: s?.email ?? ""
    }
  });
  return Qe(() => {
    if (w && !h) {
      const j = (w?.LoyaltyLion?.getCustomers).customers;
      j && j.length > 0 && (o(j[0]), i("loyaltylion:customer:received"));
    }
  }, [w, h]), s?.email ? k ? Ca({
    errors: k.graphQLErrors
  }) ? /* @__PURE__ */ Fe.jsxs(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      className: ja.notificationText,
      children: [
        "No user found for email: ",
        s?.email
      ]
    }
  ) : /* @__PURE__ */ Fe.jsx($n, { error: k }) : h ? /* @__PURE__ */ Fe.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ Fe.jsx(mn, {}) }) : f ? /* @__PURE__ */ Fe.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "no-feature-enabled-message",
      children: "All features toggles in the integration settings are disabled"
    }
  ) : /* @__PURE__ */ Fe.jsx(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "0 0 300 0",
      "data-testid": "widget-wrapper",
      children: a ? /* @__PURE__ */ Fe.jsxs(Fe.Fragment, { children: [
        l && /* @__PURE__ */ Fe.jsx(v5, { customer: a }),
        c && /* @__PURE__ */ Fe.jsx(T5, { customer: a }),
        m && /* @__PURE__ */ Fe.jsx(
          C5,
          {
            customer: a,
            refetchCustomerData: N
          }
        ),
        u && /* @__PURE__ */ Fe.jsx(E5, { customer: a })
      ] }) : /* @__PURE__ */ Fe.jsx(b, { justifyContent: "center", padding: "200", children: "Nothing found" })
    }
  ) : /* @__PURE__ */ Fe.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "no-email-message",
      children: "We can only search LoyaltyLion with an email and there seems to be no email in this conversation"
    }
  );
}, $l = [
  {
    key: "basicAuthorization",
    label: "LoyaltyLion authorization",
    type: "string",
    secret: !0,
    defaultValue: ""
  },
  {
    key: "showCustomerSummary",
    label: "Show customer summary",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showTags",
    label: "Show tags",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showPointsBalance",
    label: "Show points balance",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showAvailableRewards",
    label: "Show available rewards",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  }
], uo = ir($l), dS = "LOYALTYLION", D5 = {
  enabled: !1,
  name: "",
  basicAuthorization: "",
  showCustomerSummary: !0,
  showTags: !0,
  showPointsBalance: !0,
  showAvailableRewards: !0
}, O5 = ({
  integrationId: e,
  handleRedirect: n,
  showNotification: r,
  automationCouplingState: i,
  renderConditionsEditor: a
}) => {
  const o = !e, s = ut({
    mode: "onChange",
    defaultValues: D5
  }), {
    create: l,
    update: c,
    remove: m,
    isLoading: u,
    error: f,
    misconfigurationCause: h,
    setMisconfigurationCause: k
  } = mr({
    integrationId: e,
    integrationType: dS,
    handleRedirect: n,
    showNotification: r
  }), {
    isLoading: w,
    error: N,
    isWidgetUnknown: j,
    refetch: _,
    widgetConfiguration: g
  } = pr({
    integrationId: e,
    fieldDefinitions: $l,
    form: s,
    onMisconfigured: k
  }), { renderConditions: O, setRenderConditions: R, renderConditionsForSubmit: F } = fr({
    integrationId: e,
    widgetConfiguration: g,
    renderConditionsEditor: a
  }), I = (W) => yr(W, {
    fieldDefinitions: $l,
    isCreationMode: o,
    create: l,
    update: c,
    renderConditions: F
  }), L = s.watch("name");
  return /* @__PURE__ */ Fe.jsxs(
    hr,
    {
      form: s,
      integrationId: e,
      onValidSubmit: I,
      error: N ?? f,
      onRetry: N ? _ : void 0,
      isLoading: u || w,
      isWidgetUnknown: j,
      children: [
        h && /* @__PURE__ */ Fe.jsx(gr, { cause: h }),
        /* @__PURE__ */ Fe.jsxs(et, { children: [
          /* @__PURE__ */ Fe.jsx(X, { children: /* @__PURE__ */ Fe.jsx(He, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ Fe.jsx(
            yn,
            {
              name: "enabled",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ Fe.jsx(X, { span: 3, children: /* @__PURE__ */ Fe.jsx(
            On,
            {
              name: "name",
              label: "Widget name",
              control: s.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ Fe.jsx(X, { span: 3 }),
          /* @__PURE__ */ Fe.jsx(X, { span: 3, children: /* @__PURE__ */ Fe.jsx(
            bI,
            {
              name: "basicAuthorization",
              label: uo.basicAuthorization,
              control: s.control,
              isCreationMode: o,
              rules: { required: "Please insert a value for both fields" },
              usernameLabel: "Token",
              passwordLabel: "Secret",
              usernamePlaceholder: "Insert your token",
              passwordPlaceholder: "Insert your secret"
            }
          ) }),
          /* @__PURE__ */ Fe.jsx(X, { span: 3 }),
          /* @__PURE__ */ Fe.jsx(X, { span: 3, children: /* @__PURE__ */ Fe.jsx(He, { label: uo.showCustomerSummary, children: /* @__PURE__ */ Fe.jsx(
            yn,
            {
              name: "showCustomerSummary",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ Fe.jsx(X, { span: 3 }),
          /* @__PURE__ */ Fe.jsx(X, { span: 3, children: /* @__PURE__ */ Fe.jsx(He, { label: uo.showTags, children: /* @__PURE__ */ Fe.jsx(
            yn,
            {
              name: "showTags",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ Fe.jsx(X, { span: 3 }),
          /* @__PURE__ */ Fe.jsx(X, { span: 3, children: /* @__PURE__ */ Fe.jsx(He, { label: uo.showPointsBalance, children: /* @__PURE__ */ Fe.jsx(
            yn,
            {
              name: "showPointsBalance",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ Fe.jsx(X, { span: 3 }),
          /* @__PURE__ */ Fe.jsx(X, { span: 3, children: /* @__PURE__ */ Fe.jsx(He, { label: uo.showAvailableRewards, children: /* @__PURE__ */ Fe.jsx(
            yn,
            {
              name: "showAvailableRewards",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ Fe.jsx(X, { span: 3 }),
          a && O !== null && /* @__PURE__ */ Fe.jsx(X, { children: a({
            value: O,
            onChange: R,
            configurationKey: g?.id
          }) })
        ] }),
        /* @__PURE__ */ Fe.jsx(
          vr,
          {
            integrationType: dS,
            integrationId: e,
            widgetName: L,
            isCreationMode: o,
            isSubmitting: s.formState.isSubmitting,
            automationCouplingState: i,
            onConfirmDelete: () => m()
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._messageContainer_1rxr4_1{padding:var(--dixa-size-spacer-250);border-radius:var(--dixa-size-border-radius-100);border:var(--dixa-size-border-100) solid}._chip_1rxr4_7{color:var(--dixa-typography-color-secondary)}._chipLabel_1rxr4_10{font-weight:var(--dixa-typography-weight-semibold)}._chipValue_1rxr4_13{font-weight:var(--dixa-typography-weight-normal)}._conversation_1draa_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._conversation_1draa_1:hover{border-color:var(--dixa-color-neutral-400)}._conversationSubLine_1draa_9{font-size:var(--dixa-typography-size-200);color:var(--dixa-typography-color-tertiary)}._modal_1draa_14{width:800px}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Vm = { exports: {} }, mo = {}, cS;
function P5() {
  if (cS) return mo;
  cS = 1;
  var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, c, m) {
    var u, f = {}, h = null, k = null;
    m !== void 0 && (h = "" + m), c.key !== void 0 && (h = "" + c.key), c.ref !== void 0 && (k = c.ref);
    for (u in c) i.call(c, u) && !o.hasOwnProperty(u) && (f[u] = c[u]);
    if (l && l.defaultProps) for (u in c = l.defaultProps, c) f[u] === void 0 && (f[u] = c[u]);
    return { $$typeof: n, type: l, key: h, ref: k, props: f, _owner: a.current };
  }
  return mo.Fragment = r, mo.jsx = s, mo.jsxs = s, mo;
}
var Is = {}, uS;
function A5() {
  return uS || (uS = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), c = /* @__PURE__ */ Symbol.for("react.forward_ref"), m = /* @__PURE__ */ Symbol.for("react.suspense"), u = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), k = /* @__PURE__ */ Symbol.for("react.offscreen"), w = Symbol.iterator, N = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var d = w && t[w] || t[N];
      return typeof d == "function" ? d : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var d = arguments.length, p = new Array(d > 1 ? d - 1 : 0), y = 1; y < d; y++)
          p[y - 1] = arguments[y];
        O("error", t, p);
      }
    }
    function O(t, d, p) {
      {
        var y = _.ReactDebugCurrentFrame, C = y.getStackAddendum();
        C !== "" && (d += "%s", p = p.concat([C]));
        var T = p.map(function(S) {
          return String(S);
        });
        T.unshift("Warning: " + d), Function.prototype.apply.call(console[t], console, T);
      }
    }
    var R = !1, F = !1, I = !1, L = !1, W = !1, J;
    J = /* @__PURE__ */ Symbol.for("react.module.reference");
    function re(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || W || t === a || t === m || t === u || L || t === k || R || F || I || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === J || t.getModuleId !== void 0));
    }
    function K(t, d, p) {
      var y = t.displayName;
      if (y)
        return y;
      var C = d.displayName || d.name || "";
      return C !== "" ? p + "(" + C + ")" : p;
    }
    function Y(t) {
      return t.displayName || "Context";
    }
    function P(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var d = t;
            return Y(d) + ".Consumer";
          case s:
            var p = t;
            return Y(p._context) + ".Provider";
          case c:
            return K(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : P(t.type) || "Memo";
          case h: {
            var C = t, T = C._payload, S = C._init;
            try {
              return P(S(T));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, ie = 0, we, me, le, ge, V, be, Oe;
    function q() {
    }
    q.__reactDisabledLog = !0;
    function Ge() {
      {
        if (ie === 0) {
          we = console.log, me = console.info, le = console.warn, ge = console.error, V = console.group, be = console.groupCollapsed, Oe = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: q,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ie++;
      }
    }
    function sn() {
      {
        if (ie--, ie === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, t, {
              value: we
            }),
            info: B({}, t, {
              value: me
            }),
            warn: B({}, t, {
              value: le
            }),
            error: B({}, t, {
              value: ge
            }),
            group: B({}, t, {
              value: V
            }),
            groupCollapsed: B({}, t, {
              value: be
            }),
            groupEnd: B({}, t, {
              value: Oe
            })
          });
        }
        ie < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ie = _.ReactCurrentDispatcher, Ue;
    function De(t, d, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (C) {
            var y = C.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Ae;
    {
      var Je = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Je();
    }
    function Ee(t, d) {
      if (!t || Be)
        return "";
      {
        var p = Ae.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Be = !0;
      var C = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var T;
      T = Ie.current, Ie.current = null, Ge();
      try {
        if (d) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (ne) {
              y = ne;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (ne) {
              y = ne;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            y = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && y && typeof ne.stack == "string") {
          for (var x = ne.stack.split(`
`), Z = y.stack.split(`
`), A = x.length - 1, M = Z.length - 1; A >= 1 && M >= 0 && x[A] !== Z[M]; )
            M--;
          for (; A >= 1 && M >= 0; A--, M--)
            if (x[A] !== Z[M]) {
              if (A !== 1 || M !== 1)
                do
                  if (A--, M--, M < 0 || x[A] !== Z[M]) {
                    var ue = `
` + x[A].replace(" at new ", " at ");
                    return t.displayName && ue.includes("<anonymous>") && (ue = ue.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, ue), ue;
                  }
                while (A >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Ie.current = T, sn(), Error.prepareStackTrace = C;
      }
      var ze = t ? t.displayName || t.name : "", Te = ze ? De(ze) : "";
      return typeof t == "function" && Ae.set(t, Te), Te;
    }
    function Me(t, d, p) {
      return Ee(t, !1);
    }
    function en(t) {
      var d = t.prototype;
      return !!(d && d.isReactComponent);
    }
    function se(t, d, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ee(t, en(t));
      if (typeof t == "string")
        return De(t);
      switch (t) {
        case m:
          return De("Suspense");
        case u:
          return De("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case c:
            return Me(t.render);
          case f:
            return se(t.type, d, p);
          case h: {
            var y = t, C = y._payload, T = y._init;
            try {
              return se(T(C), d, p);
            } catch {
            }
          }
        }
      return "";
    }
    var de = Object.prototype.hasOwnProperty, Se = {}, Ve = _.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var d = t._owner, p = se(t.type, t._source, d ? d.type : null);
        Ve.setExtraStackFrame(p);
      } else
        Ve.setExtraStackFrame(null);
    }
    function kn(t, d, p, y, C) {
      {
        var T = Function.call.bind(de);
        for (var S in t)
          if (T(t, S)) {
            var x = void 0;
            try {
              if (typeof t[S] != "function") {
                var Z = Error((y || "React class") + ": " + p + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Z.name = "Invariant Violation", Z;
              }
              x = t[S](d, S, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (A) {
              x = A;
            }
            x && !(x instanceof Error) && (Pe(C), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, S, typeof x), Pe(null)), x instanceof Error && !(x.message in Se) && (Se[x.message] = !0, Pe(C), g("Failed %s type: %s", p, x.message), Pe(null));
          }
      }
    }
    var Q = Array.isArray;
    function E(t) {
      return Q(t);
    }
    function z(t) {
      {
        var d = typeof Symbol == "function" && Symbol.toStringTag, p = d && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function ae(t) {
      try {
        return ce(t), !1;
      } catch {
        return !0;
      }
    }
    function ce(t) {
      return "" + t;
    }
    function U(t) {
      if (ae(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", z(t)), ce(t);
    }
    var G = _.ReactCurrentOwner, ve = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, je, Re;
    function rn(t) {
      if (de.call(t, "ref")) {
        var d = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (d && d.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function bn(t) {
      if (de.call(t, "key")) {
        var d = Object.getOwnPropertyDescriptor(t, "key").get;
        if (d && d.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function an(t, d) {
      typeof t.ref == "string" && G.current;
    }
    function fn(t, d) {
      {
        var p = function() {
          je || (je = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", d));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function En(t, d) {
      {
        var p = function() {
          Re || (Re = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", d));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var _n = function(t, d, p, y, C, T, S) {
      var x = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: d,
        ref: p,
        props: S,
        // Record the component responsible for creating this element.
        _owner: T
      };
      return x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(x, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(x, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: C
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    };
    function Fn(t, d, p, y, C) {
      {
        var T, S = {}, x = null, Z = null;
        p !== void 0 && (U(p), x = "" + p), bn(d) && (U(d.key), x = "" + d.key), rn(d) && (Z = d.ref, an(d));
        for (T in d)
          de.call(d, T) && !ve.hasOwnProperty(T) && (S[T] = d[T]);
        if (t && t.defaultProps) {
          var A = t.defaultProps;
          for (T in A)
            S[T] === void 0 && (S[T] = A[T]);
        }
        if (x || Z) {
          var M = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          x && fn(S, M), Z && En(S, M);
        }
        return _n(t, x, Z, C, y, G.current, S);
      }
    }
    var Ze = _.ReactCurrentOwner, gn = _.ReactDebugCurrentFrame;
    function Le(t) {
      if (t) {
        var d = t._owner, p = se(t.type, t._source, d ? d.type : null);
        gn.setExtraStackFrame(p);
      } else
        gn.setExtraStackFrame(null);
    }
    var dn;
    dn = !1;
    function cn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function Nn() {
      {
        if (Ze.current) {
          var t = P(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Bn(t) {
      return "";
    }
    var Sn = {};
    function An(t) {
      {
        var d = Nn();
        if (!d) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (d = `

Check the top-level render call using <` + p + ">.");
        }
        return d;
      }
    }
    function vn(t, d) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = An(d);
        if (Sn[p])
          return;
        Sn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Ze.current && (y = " It was passed a child from " + P(t._owner.type) + "."), Le(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Le(null);
      }
    }
    function xn(t, d) {
      {
        if (typeof t != "object")
          return;
        if (E(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            cn(y) && vn(y, d);
          }
        else if (cn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var C = j(t);
          if (typeof C == "function" && C !== t.entries)
            for (var T = C.call(t), S; !(S = T.next()).done; )
              cn(S.value) && vn(S.value, d);
        }
      }
    }
    function Ln(t) {
      {
        var d = t.type;
        if (d == null || typeof d == "string")
          return;
        var p;
        if (typeof d == "function")
          p = d.propTypes;
        else if (typeof d == "object" && (d.$$typeof === c || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        d.$$typeof === f))
          p = d.propTypes;
        else
          return;
        if (p) {
          var y = P(d);
          kn(p, t.props, "prop", y, t);
        } else if (d.PropTypes !== void 0 && !dn) {
          dn = !0;
          var C = P(d);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", C || "Unknown");
        }
        typeof d.getDefaultProps == "function" && !d.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var d = Object.keys(t.props), p = 0; p < d.length; p++) {
          var y = d[p];
          if (y !== "children" && y !== "key") {
            Le(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Le(null);
            break;
          }
        }
        t.ref !== null && (Le(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Le(null));
      }
    }
    var Cn = {};
    function wn(t, d, p, y, C, T) {
      {
        var S = re(t);
        if (!S) {
          var x = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (x += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Z = Bn();
          Z ? x += Z : x += Nn();
          var A;
          t === null ? A = "null" : E(t) ? A = "array" : t !== void 0 && t.$$typeof === n ? (A = "<" + (P(t.type) || "Unknown") + " />", x = " Did you accidentally export a JSX literal instead of a component?") : A = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", A, x);
        }
        var M = Fn(t, d, p, C, T);
        if (M == null)
          return M;
        if (S) {
          var ue = d.children;
          if (ue !== void 0)
            if (y)
              if (E(ue)) {
                for (var ze = 0; ze < ue.length; ze++)
                  xn(ue[ze], t);
                Object.freeze && Object.freeze(ue);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              xn(ue, t);
        }
        if (de.call(d, "key")) {
          var Te = P(t), ne = Object.keys(d).filter(function(Kn) {
            return Kn !== "key";
          }), un = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Cn[Te + un]) {
            var Rn = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, un, Te, Rn, Te), Cn[Te + un] = !0;
          }
        }
        return t === i ? Vn(M) : Ln(M), M;
      }
    }
    function zn(t, d, p) {
      return wn(t, d, p, !0);
    }
    function qn(t, d, p) {
      return wn(t, d, p, !1);
    }
    var Un = qn, Wn = zn;
    Is.Fragment = i, Is.jsx = Un, Is.jsxs = Wn;
  })()), Is;
}
var mS;
function L5() {
  return mS || (mS = 1, process.env.NODE_ENV === "production" ? Vm.exports = P5() : Vm.exports = A5()), Vm.exports;
}
var pn = L5();
const V5 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "conversationsQuery" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Miuros" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "findTickets" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }, { kind: "Argument", name: { kind: "Name", value: "page_size" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "labels" } }, { kind: "Field", name: { kind: "Name", value: "subject" } }, { kind: "Field", name: { kind: "Name", value: "messages" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "direction" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "agent" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }] } }, { kind: "Field", name: { kind: "Name", value: "custom_fields" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "additionalProperties" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "value" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "value" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }] } }] } }] } }] } }] }, z5 = {
  "\n  query conversationsQuery($query: String) {\n    Miuros {\n      findTickets(query: $query, page_size: 10) {\n        data {\n          id\n          labels\n          subject\n          messages {\n            direction\n            body\n            agent {\n              email\n              name\n            }\n            created_at\n          }\n          custom_fields {\n            additionalProperties {\n              key\n              value {\n                value\n              }\n            }\n          }\n          created_at\n        }\n      }\n    }\n  }\n": V5
};
function U5(e) {
  return z5[e] ?? {};
}
function pS(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var r = 0, i = Array(n); r < n; r++) i[r] = e[r];
  return i;
}
function M5(e) {
  if (Array.isArray(e)) return e;
}
function B5(e, n) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var i, a, o, s, l = [], c = !0, m = !1;
    try {
      if (o = (r = r.call(e)).next, n !== 0) for (; !(c = (i = o.call(r)).done) && (l.push(i.value), l.length !== n); c = !0) ;
    } catch (u) {
      m = !0, a = u;
    } finally {
      try {
        if (!c && r.return != null && (s = r.return(), Object(s) !== s)) return;
      } finally {
        if (m) throw a;
      }
    }
    return l;
  }
}
function q5() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function H5(e, n) {
  return M5(e) || B5(e, n) || W5(e, n) || q5();
}
function W5(e, n) {
  if (e) {
    if (typeof e == "string") return pS(e, n);
    var r = {}.toString.call(e).slice(8, -1);
    return r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set" ? Array.from(e) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? pS(e, n) : void 0;
  }
}
const H1 = Object.entries, fS = Object.setPrototypeOf, K5 = Object.isFrozen, G5 = Object.getPrototypeOf, Y5 = Object.getOwnPropertyDescriptor;
let Lt = Object.freeze, Vt = Object.seal, ua = Object.create, W1 = typeof Reflect < "u" && Reflect, yy = W1.apply, gy = W1.construct;
Lt || (Lt = function(e) {
  return e;
});
Vt || (Vt = function(e) {
  return e;
});
yy || (yy = function(e, n) {
  for (var r = arguments.length, i = new Array(r > 2 ? r - 2 : 0), a = 2; a < r; a++)
    i[a - 2] = arguments[a];
  return e.apply(n, i);
});
gy || (gy = function(e) {
  for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)
    r[i - 1] = arguments[i];
  return new e(...r);
});
const po = jt(Array.prototype.forEach), J5 = jt(Array.prototype.lastIndexOf), hS = jt(Array.prototype.pop), oa = jt(Array.prototype.push), Q5 = jt(Array.prototype.splice), hi = Array.isArray, Io = jt(String.prototype.toLowerCase), zm = jt(String.prototype.toString), yS = jt(String.prototype.match), fo = jt(String.prototype.replace), gS = jt(String.prototype.indexOf), X5 = jt(String.prototype.trim), Z5 = jt(Number.prototype.toString), eB = jt(Boolean.prototype.toString), vS = typeof BigInt > "u" ? null : jt(BigInt.prototype.toString), kS = typeof Symbol > "u" ? null : jt(Symbol.prototype.toString), Et = jt(Object.prototype.hasOwnProperty), ho = jt(Object.prototype.toString), Rt = jt(RegExp.prototype.test), Fi = nB(TypeError);
function jt(e) {
  return function(n) {
    n instanceof RegExp && (n.lastIndex = 0);
    for (var r = arguments.length, i = new Array(r > 1 ? r - 1 : 0), a = 1; a < r; a++)
      i[a - 1] = arguments[a];
    return yy(e, n, i);
  };
}
function nB(e) {
  return function() {
    for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
      r[i] = arguments[i];
    return gy(e, r);
  };
}
function Hn(e, n) {
  let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Io;
  if (fS && fS(e, null), !hi(n))
    return e;
  let i = n.length;
  for (; i--; ) {
    let a = n[i];
    if (typeof a == "string") {
      const o = r(a);
      o !== a && (K5(n) || (n[i] = o), a = o);
    }
    e[a] = !0;
  }
  return e;
}
function tB(e) {
  for (let n = 0; n < e.length; n++)
    Et(e, n) || (e[n] = null);
  return e;
}
function Ht(e) {
  const n = ua(null);
  for (const i of H1(e)) {
    var r = H5(i, 2);
    const a = r[0], o = r[1];
    Et(e, a) && (hi(o) ? n[a] = tB(o) : o && typeof o == "object" && o.constructor === Object ? n[a] = Ht(o) : n[a] = o);
  }
  return n;
}
function rB(e) {
  switch (typeof e) {
    case "string":
      return e;
    case "number":
      return Z5(e);
    case "boolean":
      return eB(e);
    case "bigint":
      return vS ? vS(e) : "0";
    case "symbol":
      return kS ? kS(e) : "Symbol()";
    case "undefined":
      return ho(e);
    case "function":
    case "object": {
      if (e === null)
        return ho(e);
      const n = e, r = Lr(n, "toString");
      if (typeof r == "function") {
        const i = r(n);
        return typeof i == "string" ? i : ho(i);
      }
      return ho(e);
    }
    default:
      return ho(e);
  }
}
function Lr(e, n) {
  for (; e !== null; ) {
    const i = Y5(e, n);
    if (i) {
      if (i.get)
        return jt(i.get);
      if (typeof i.value == "function")
        return jt(i.value);
    }
    e = G5(e);
  }
  function r() {
    return null;
  }
  return r;
}
function iB(e) {
  try {
    return Rt(e, ""), !0;
  } catch {
    return !1;
  }
}
const bS = Lt(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "search", "section", "select", "shadow", "slot", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]), Um = Lt(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "enterkeyhint", "exportparts", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "inputmode", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "part", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]), Mm = Lt(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]), aB = Lt(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]), Bm = Lt(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]), oB = Lt(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]), _S = Lt(["#text"]), xS = Lt(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "command", "commandfor", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "exportparts", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inert", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "part", "pattern", "placeholder", "playsinline", "popover", "popovertarget", "popovertargetaction", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "slot", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "wrap", "xmlns"]), qm = Lt(["accent-height", "accumulate", "additive", "alignment-baseline", "amplitude", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "exponent", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "intercept", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "mask-type", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "slope", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "tablevalues", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]), SS = Lt(["accent", "accentunder", "align", "bevelled", "close", "columnalign", "columnlines", "columnspacing", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lquote", "lspace", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]), $s = Lt(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]), sB = Vt(/{{[\w\W]*|^[\w\W]*}}/g), lB = Vt(/<%[\w\W]*|^[\w\W]*%>/g), dB = Vt(/\${[\w\W]*/g), cB = Vt(/^data-[\-\w.\u00B7-\uFFFF]+$/), uB = Vt(/^aria-[\-\w]+$/), NS = Vt(
  /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
  // eslint-disable-line no-useless-escape
), mB = Vt(/^(?:\w+script|data):/i), pB = Vt(
  /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g
  // eslint-disable-line no-control-regex
), fB = Vt(/^html$/i), hB = Vt(/^[a-z][.\w]*(-[.\w]+)+$/i), jS = Vt(/<[/\w!]/g), yB = Vt(/<[/\w]/g), gB = Vt(/<\/no(script|embed|frames)/i), vB = Vt(/\/>/i), Pr = {
  element: 1,
  attribute: 2,
  text: 3,
  cdataSection: 4,
  entityReference: 5,
  // Deprecated
  entityNode: 6,
  // Deprecated
  processingInstruction: 7,
  comment: 8,
  document: 9,
  documentType: 10,
  documentFragment: 11,
  notation: 12
  // Deprecated
}, kB = function() {
  return typeof window > "u" ? null : window;
}, bB = function(e, n) {
  if (typeof e != "object" || typeof e.createPolicy != "function")
    return null;
  let r = null;
  const i = "data-tt-policy-suffix";
  n && n.hasAttribute(i) && (r = n.getAttribute(i));
  const a = "dompurify" + (r ? "#" + r : "");
  try {
    return e.createPolicy(a, {
      createHTML(o) {
        return o;
      },
      createScriptURL(o) {
        return o;
      }
    });
  } catch {
    return console.warn("TrustedTypes policy " + a + " could not be created."), null;
  }
}, wS = function() {
  return {
    afterSanitizeAttributes: [],
    afterSanitizeElements: [],
    afterSanitizeShadowDOM: [],
    beforeSanitizeAttributes: [],
    beforeSanitizeElements: [],
    beforeSanitizeShadowDOM: [],
    uponSanitizeAttribute: [],
    uponSanitizeElement: [],
    uponSanitizeShadowNode: []
  };
}, mi = function(e, n, r, i) {
  return Et(e, n) && hi(e[n]) ? Hn(i.base ? Ht(i.base) : {}, e[n], i.transform) : r;
};
function K1() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : kB();
  const n = (H) => K1(H);
  if (n.version = "3.4.11", n.removed = [], !e || !e.document || e.document.nodeType !== Pr.document || !e.Element)
    return n.isSupported = !1, n;
  let r = e.document;
  const i = r, a = i.currentScript;
  e.DocumentFragment;
  const o = e.HTMLTemplateElement, s = e.Node, l = e.Element, c = e.NodeFilter;
  e.NamedNodeMap === void 0 && (e.NamedNodeMap || e.MozNamedAttrMap), e.HTMLFormElement;
  const u = e.DOMParser, f = e.trustedTypes, h = l.prototype, k = Lr(h, "cloneNode"), w = Lr(h, "remove"), N = Lr(h, "nextSibling"), j = Lr(h, "childNodes"), _ = Lr(h, "parentNode"), g = Lr(h, "shadowRoot"), O = Lr(h, "attributes"), R = s && s.prototype ? Lr(s.prototype, "nodeType") : null, F = s && s.prototype ? Lr(s.prototype, "nodeName") : null;
  if (typeof o == "function") {
    const H = r.createElement("template");
    H.content && H.content.ownerDocument && (r = H.content.ownerDocument);
  }
  let I, L = "", W, J = !1, re = 0;
  const K = function() {
    if (re > 0)
      throw Fi('A configured TRUSTED_TYPES_POLICY callback (createHTML or createScriptURL) must not call DOMPurify.sanitize, as that causes infinite recursion. Do not pass a policy whose callbacks wrap DOMPurify as TRUSTED_TYPES_POLICY; see the "DOMPurify and Trusted Types" section of the README.');
  }, Y = function(H) {
    K(), re++;
    try {
      return I.createHTML(H);
    } finally {
      re--;
    }
  }, P = function(H) {
    K(), re++;
    try {
      return I.createScriptURL(H);
    } finally {
      re--;
    }
  }, B = function() {
    return J || (W = bB(f, a), J = !0), W;
  }, ie = r, we = ie.implementation, me = ie.createNodeIterator, le = ie.createDocumentFragment, ge = ie.getElementsByTagName, V = i.importNode;
  let be = wS();
  n.isSupported = typeof H1 == "function" && typeof _ == "function" && we && we.createHTMLDocument !== void 0;
  const Oe = sB, q = lB, Ge = dB, sn = cB, Ie = uB, Ue = mB, De = pB, Be = hB;
  let Ae = NS, Je = null;
  const Ee = Hn({}, [...bS, ...Um, ...Mm, ...Bm, ..._S]);
  let Me = null;
  const en = Hn({}, [...xS, ...qm, ...SS, ...$s]);
  let se = Object.seal(ua(null, {
    tagNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    allowCustomizedBuiltInElements: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: !1
    }
  })), de = null, Se = null;
  const Ve = Object.seal(ua(null, {
    tagCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    }
  }));
  let Pe = !0, kn = !0, Q = !1, E = !0, z = !1, ae = !0, ce = !1, U = !1, G = null, ve = null, je = !1, Re = !1, rn = !1, bn = !1, an = !0, fn = !1;
  const En = "user-content-";
  let _n = !0, Fn = !1, Ze = {}, gn = null;
  const Le = Hn({}, [
    "annotation-xml",
    "audio",
    "colgroup",
    "desc",
    "foreignobject",
    "head",
    "iframe",
    "math",
    "mi",
    "mn",
    "mo",
    "ms",
    "mtext",
    "noembed",
    "noframes",
    "noscript",
    "plaintext",
    "script",
    // <selectedcontent> mirrors the selected <option>'s subtree, cloned by
    // the UA (customizable <select>) — including any on* handlers — and the
    // engine re-mirrors synchronously whenever a removal changes which
    // option/selectedcontent is current, even inside DOMPurify's inert
    // DOMParser document. Hoisting its children on removal re-inserts a fresh
    // mirror target ahead of the walk, which the engine refills, looping
    // forever (DoS) and amplifying output. Dropping its content on removal
    // (rather than hoisting) breaks that cascade; the content is a duplicate
    // of the option, which is sanitized on its own. See campaign-3 F1/F6.
    "selectedcontent",
    "style",
    "svg",
    "template",
    "thead",
    "title",
    "video",
    "xmp"
  ]);
  let dn = null;
  const cn = Hn({}, ["audio", "video", "img", "source", "image", "track"]);
  let Nn = null;
  const Bn = Hn({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]), Sn = "http://www.w3.org/1998/Math/MathML", An = "http://www.w3.org/2000/svg", vn = "http://www.w3.org/1999/xhtml";
  let xn = vn, Ln = !1, Vn = null;
  const Cn = Hn({}, [Sn, An, vn], zm), wn = Lt(["mi", "mo", "mn", "ms", "mtext"]);
  let zn = Hn({}, wn);
  const qn = Lt(["annotation-xml"]);
  let Un = Hn({}, qn);
  const Wn = Hn({}, ["title", "style", "font", "a", "script"]);
  let t = null;
  const d = ["application/xhtml+xml", "text/html"], p = "text/html";
  let y = null, C = null;
  const T = r.createElement("form"), S = function(H) {
    return H instanceof RegExp || H instanceof Function;
  }, x = function() {
    let H = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (C && C === H)
      return;
    (!H || typeof H != "object") && (H = {}), H = Ht(H), t = // eslint-disable-next-line unicorn/prefer-includes
    d.indexOf(H.PARSER_MEDIA_TYPE) === -1 ? p : H.PARSER_MEDIA_TYPE, y = t === "application/xhtml+xml" ? zm : Io, Je = mi(H, "ALLOWED_TAGS", Ee, {
      transform: y
    }), Me = mi(H, "ALLOWED_ATTR", en, {
      transform: y
    }), Vn = mi(H, "ALLOWED_NAMESPACES", Cn, {
      transform: zm
    }), Nn = mi(H, "ADD_URI_SAFE_ATTR", Bn, {
      transform: y,
      base: Bn
    }), dn = mi(H, "ADD_DATA_URI_TAGS", cn, {
      transform: y,
      base: cn
    }), gn = mi(H, "FORBID_CONTENTS", Le, {
      transform: y
    }), de = mi(H, "FORBID_TAGS", Ht({}), {
      transform: y
    }), Se = mi(H, "FORBID_ATTR", Ht({}), {
      transform: y
    }), Ze = Et(H, "USE_PROFILES") ? H.USE_PROFILES && typeof H.USE_PROFILES == "object" ? Ht(H.USE_PROFILES) : H.USE_PROFILES : !1, Pe = H.ALLOW_ARIA_ATTR !== !1, kn = H.ALLOW_DATA_ATTR !== !1, Q = H.ALLOW_UNKNOWN_PROTOCOLS || !1, E = H.ALLOW_SELF_CLOSE_IN_ATTR !== !1, z = H.SAFE_FOR_TEMPLATES || !1, ae = H.SAFE_FOR_XML !== !1, ce = H.WHOLE_DOCUMENT || !1, Re = H.RETURN_DOM || !1, rn = H.RETURN_DOM_FRAGMENT || !1, bn = H.RETURN_TRUSTED_TYPE || !1, je = H.FORCE_BODY || !1, an = H.SANITIZE_DOM !== !1, fn = H.SANITIZE_NAMED_PROPS || !1, _n = H.KEEP_CONTENT !== !1, Fn = H.IN_PLACE || !1, Ae = iB(H.ALLOWED_URI_REGEXP) ? H.ALLOWED_URI_REGEXP : NS, xn = typeof H.NAMESPACE == "string" ? H.NAMESPACE : vn, zn = Et(H, "MATHML_TEXT_INTEGRATION_POINTS") && H.MATHML_TEXT_INTEGRATION_POINTS && typeof H.MATHML_TEXT_INTEGRATION_POINTS == "object" ? Ht(H.MATHML_TEXT_INTEGRATION_POINTS) : Hn({}, wn), Un = Et(H, "HTML_INTEGRATION_POINTS") && H.HTML_INTEGRATION_POINTS && typeof H.HTML_INTEGRATION_POINTS == "object" ? Ht(H.HTML_INTEGRATION_POINTS) : Hn({}, qn);
    const $e = Et(H, "CUSTOM_ELEMENT_HANDLING") && H.CUSTOM_ELEMENT_HANDLING && typeof H.CUSTOM_ELEMENT_HANDLING == "object" ? Ht(H.CUSTOM_ELEMENT_HANDLING) : ua(null);
    if (se = ua(null), Et($e, "tagNameCheck") && S($e.tagNameCheck) && (se.tagNameCheck = $e.tagNameCheck), Et($e, "attributeNameCheck") && S($e.attributeNameCheck) && (se.attributeNameCheck = $e.attributeNameCheck), Et($e, "allowCustomizedBuiltInElements") && typeof $e.allowCustomizedBuiltInElements == "boolean" && (se.allowCustomizedBuiltInElements = $e.allowCustomizedBuiltInElements), Vt(se), z && (kn = !1), rn && (Re = !0), Ze && (Je = Hn({}, _S), Me = ua(null), Ze.html === !0 && (Hn(Je, bS), Hn(Me, xS)), Ze.svg === !0 && (Hn(Je, Um), Hn(Me, qm), Hn(Me, $s)), Ze.svgFilters === !0 && (Hn(Je, Mm), Hn(Me, qm), Hn(Me, $s)), Ze.mathMl === !0 && (Hn(Je, Bm), Hn(Me, SS), Hn(Me, $s))), Ve.tagCheck = null, Ve.attributeCheck = null, Et(H, "ADD_TAGS") && (typeof H.ADD_TAGS == "function" ? Ve.tagCheck = H.ADD_TAGS : hi(H.ADD_TAGS) && (Je === Ee && (Je = Ht(Je)), Hn(Je, H.ADD_TAGS, y))), Et(H, "ADD_ATTR") && (typeof H.ADD_ATTR == "function" ? Ve.attributeCheck = H.ADD_ATTR : hi(H.ADD_ATTR) && (Me === en && (Me = Ht(Me)), Hn(Me, H.ADD_ATTR, y))), Et(H, "ADD_URI_SAFE_ATTR") && hi(H.ADD_URI_SAFE_ATTR) && Hn(Nn, H.ADD_URI_SAFE_ATTR, y), Et(H, "FORBID_CONTENTS") && hi(H.FORBID_CONTENTS) && (gn === Le && (gn = Ht(gn)), Hn(gn, H.FORBID_CONTENTS, y)), Et(H, "ADD_FORBID_CONTENTS") && hi(H.ADD_FORBID_CONTENTS) && (gn === Le && (gn = Ht(gn)), Hn(gn, H.ADD_FORBID_CONTENTS, y)), _n && (Je["#text"] = !0), ce && Hn(Je, ["html", "head", "body"]), Je.table && (Hn(Je, ["tbody"]), delete de.tbody), H.TRUSTED_TYPES_POLICY) {
      if (typeof H.TRUSTED_TYPES_POLICY.createHTML != "function")
        throw Fi('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
      if (typeof H.TRUSTED_TYPES_POLICY.createScriptURL != "function")
        throw Fi('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
      const We = I;
      I = H.TRUSTED_TYPES_POLICY;
      try {
        L = Y("");
      } catch (ln) {
        throw I = We, ln;
      }
    } else H.TRUSTED_TYPES_POLICY === null ? (I = void 0, L = "") : (I === void 0 && (I = B()), I && typeof L == "string" && (L = Y("")));
    Lt && Lt(H), C = H;
  }, Z = Hn({}, [...Um, ...Mm, ...aB]), A = Hn({}, [...Bm, ...oB]), M = function(H, $e, We) {
    return $e.namespaceURI === vn ? H === "svg" : $e.namespaceURI === Sn ? H === "svg" && (We === "annotation-xml" || zn[We]) : !!Z[H];
  }, ue = function(H, $e, We) {
    return $e.namespaceURI === vn ? H === "math" : $e.namespaceURI === An ? H === "math" && Un[We] : !!A[H];
  }, ze = function(H, $e, We) {
    return $e.namespaceURI === An && !Un[We] || $e.namespaceURI === Sn && !zn[We] ? !1 : !A[H] && (Wn[H] || !Z[H]);
  }, Te = function(H) {
    let $e = _(H);
    (!$e || !$e.tagName) && ($e = {
      namespaceURI: xn,
      tagName: "template"
    });
    const We = Io(H.tagName), ln = Io($e.tagName);
    return Vn[H.namespaceURI] ? H.namespaceURI === An ? M(We, $e, ln) : H.namespaceURI === Sn ? ue(We, $e, ln) : H.namespaceURI === vn ? ze(We, $e, ln) : !!(t === "application/xhtml+xml" && Vn[H.namespaceURI]) : !1;
  }, ne = function(H) {
    oa(n.removed, {
      element: H
    });
    try {
      _(H).removeChild(H);
    } catch {
      if (w(H), !_(H))
        throw Fi("a node selected for removal could not be detached from its tree and cannot be safely returned; refusing to sanitize in place");
    }
  }, un = function(H) {
    const $e = j(H);
    if ($e) {
      const ln = [];
      po($e, (Dn) => {
        oa(ln, Dn);
      }), po(ln, (Dn) => {
        try {
          w(Dn);
        } catch {
        }
      });
    }
    const We = O(H);
    if (We)
      for (let ln = We.length - 1; ln >= 0; --ln) {
        const Dn = We[ln], nt = Dn && Dn.name;
        if (typeof nt == "string")
          try {
            H.removeAttribute(nt);
          } catch {
          }
      }
  }, Rn = function(H, $e) {
    try {
      oa(n.removed, {
        attribute: $e.getAttributeNode(H),
        from: $e
      });
    } catch {
      oa(n.removed, {
        attribute: null,
        from: $e
      });
    }
    if ($e.removeAttribute(H), H === "is")
      if (Re || rn)
        try {
          ne($e);
        } catch {
        }
      else
        try {
          $e.setAttribute(H, "");
        } catch {
        }
  }, Kn = function(H) {
    const $e = O(H);
    if ($e)
      for (let We = $e.length - 1; We >= 0; --We) {
        const ln = $e[We], Dn = ln && ln.name;
        if (!(typeof Dn != "string" || Me[y(Dn)]))
          try {
            H.removeAttribute(Dn);
          } catch {
          }
      }
  }, tI = function(H) {
    const $e = [H];
    for (; $e.length > 0; ) {
      const We = $e.pop();
      (R ? R(We) : We.nodeType) === Pr.element && Kn(We);
      const ln = j(We);
      if (ln)
        for (let Dn = ln.length - 1; Dn >= 0; --Dn)
          $e.push(ln[Dn]);
    }
  }, rv = function(H) {
    let $e = null, We = null;
    if (je)
      H = "<remove></remove>" + H;
    else {
      const nt = yS(H, /^[\r\n\t ]+/);
      We = nt && nt[0];
    }
    t === "application/xhtml+xml" && xn === vn && (H = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + H + "</body></html>");
    const ln = I ? Y(H) : H;
    if (xn === vn)
      try {
        $e = new u().parseFromString(ln, t);
      } catch {
      }
    if (!$e || !$e.documentElement) {
      $e = we.createDocument(xn, "template", null);
      try {
        $e.documentElement.innerHTML = Ln ? L : ln;
      } catch {
      }
    }
    const Dn = $e.body || $e.documentElement;
    return H && We && Dn.insertBefore(r.createTextNode(We), Dn.childNodes[0] || null), xn === vn ? ge.call($e, ce ? "html" : "body")[0] : ce ? $e.documentElement : Dn;
  }, iv = function(H) {
    return me.call(
      H.ownerDocument || H,
      H,
      // eslint-disable-next-line no-bitwise
      c.SHOW_ELEMENT | c.SHOW_COMMENT | c.SHOW_TEXT | c.SHOW_PROCESSING_INSTRUCTION | c.SHOW_CDATA_SECTION,
      null
    );
  }, ls = function(H) {
    return H = fo(H, Oe, " "), H = fo(H, q, " "), H = fo(H, Ge, " "), H;
  }, vd = function(H) {
    var $e;
    H.normalize();
    const We = me.call(
      H.ownerDocument || H,
      H,
      // eslint-disable-next-line no-bitwise
      c.SHOW_TEXT | c.SHOW_COMMENT | c.SHOW_CDATA_SECTION | c.SHOW_PROCESSING_INSTRUCTION,
      null
    );
    let ln = We.nextNode();
    for (; ln; )
      ln.data = ls(ln.data), ln = We.nextNode();
    const Dn = ($e = H.querySelectorAll) === null || $e === void 0 ? void 0 : $e.call(H, "template");
    Dn && po(Dn, (nt) => {
      Xi(nt.content) && vd(nt.content);
    });
  }, ds = function(H) {
    const $e = F ? F(H) : null;
    return typeof $e != "string" || y($e) !== "form" ? !1 : typeof H.nodeName != "string" || typeof H.textContent != "string" || typeof H.removeChild != "function" || // Realm-safe NamedNodeMap detection: equality against the cached
    // prototype getter. Clobbered .attributes (e.g. <input name="attributes">)
    // makes the direct read diverge from the cached read; a clean form
    // (same-realm OR foreign-realm) has both reads pointing at the same
    // canonical NamedNodeMap.
    H.attributes !== O(H) || typeof H.removeAttribute != "function" || typeof H.setAttribute != "function" || typeof H.namespaceURI != "string" || typeof H.insertBefore != "function" || typeof H.hasChildNodes != "function" || // NodeType clobbering probe. Cached Node.prototype.nodeType getter
    // returns the integer 1 for any Element regardless of realm; direct
    // read on a clobbered form (e.g. <input name="nodeType">) returns
    // the named child element. Cheap addition — nodeType is read from
    // an internal slot, no serialization cost — and removes a residual
    // clobbering surface used by several mXSS / PI / comment branches
    // in _sanitizeElements that compare currentNode.nodeType directly.
    H.nodeType !== R(H) || // HTMLFormElement has [LegacyOverrideBuiltIns]: a descendant named
    // "childNodes" shadows the prototype getter. Direct reads of
    // form.childNodes from a clobbered form return the named child
    // instead of the real NodeList, so any walk that reads it directly
    // skips the form's real children. Compare the direct read to the
    // cached Node.prototype getter — when the form's named-property
    // getter intercepts the read, the two values differ and we flag
    // the form. This catches every clobbering child type (input,
    // select, etc.) regardless of whether the named child happens to
    // carry a numeric .length, which a typeof-based probe would miss
    // (e.g. HTMLSelectElement.length is a defined unsigned-long).
    H.childNodes !== j(H);
  }, Xi = function(H) {
    if (!R || typeof H != "object" || H === null)
      return !1;
    try {
      return R(H) === Pr.documentFragment;
    } catch {
      return !1;
    }
  }, Ua = function(H) {
    if (!R || typeof H != "object" || H === null)
      return !1;
    try {
      return typeof R(H) == "number";
    } catch {
      return !1;
    }
  };
  function Qr(H, $e, We) {
    H.length !== 0 && po(H, (ln) => {
      ln.call(n, $e, We, C);
    });
  }
  const rI = function(H, $e) {
    return !!(ae && H.hasChildNodes() && !Ua(H.firstElementChild) && Rt(jS, H.textContent) && Rt(jS, H.innerHTML) || ae && H.namespaceURI === vn && $e === "style" && Ua(H.firstElementChild) || H.nodeType === Pr.processingInstruction || ae && H.nodeType === Pr.comment && Rt(yB, H.data));
  }, iI = function(H, $e) {
    if (!de[$e] && sv($e) && (se.tagNameCheck instanceof RegExp && Rt(se.tagNameCheck, $e) || se.tagNameCheck instanceof Function && se.tagNameCheck($e)))
      return !1;
    if (_n && !gn[$e]) {
      const We = _(H), ln = j(H);
      if (ln && We) {
        const Dn = ln.length;
        for (let nt = Dn - 1; nt >= 0; --nt) {
          const rt = Fn ? ln[nt] : k(ln[nt], !0);
          We.insertBefore(rt, N(H));
        }
      }
    }
    return ne(H), !0;
  }, av = function(H) {
    if (Qr(be.beforeSanitizeElements, H, null), ds(H))
      return ne(H), !0;
    const $e = y(F ? F(H) : H.nodeName);
    if (Qr(be.uponSanitizeElement, H, {
      tagName: $e,
      allowedTags: Je
    }), rI(H, $e))
      return ne(H), !0;
    if (de[$e] || !(Ve.tagCheck instanceof Function && Ve.tagCheck($e)) && !Je[$e])
      return iI(H, $e);
    if ((R ? R(H) : H.nodeType) === Pr.element && !Te(H) || ($e === "noscript" || $e === "noembed" || $e === "noframes") && Rt(gB, H.innerHTML))
      return ne(H), !0;
    if (z && H.nodeType === Pr.text) {
      const We = ls(H.textContent);
      H.textContent !== We && (oa(n.removed, {
        element: H.cloneNode()
      }), H.textContent = We);
    }
    return Qr(be.afterSanitizeElements, H, null), !1;
  }, ov = function(H, $e, We) {
    if (Se[$e] || an && ($e === "id" || $e === "name") && (We in r || We in T))
      return !1;
    const ln = Me[$e] || Ve.attributeCheck instanceof Function && Ve.attributeCheck($e, H);
    if (!(kn && Rt(sn, $e)) && !(Pe && Rt(Ie, $e))) {
      if (ln) {
        if (!Nn[$e] && !Rt(Ae, fo(We, De, "")) && !(($e === "src" || $e === "xlink:href" || $e === "href") && H !== "script" && gS(We, "data:") === 0 && dn[H]) && !(Q && !Rt(Ue, fo(We, De, ""))) && We)
          return !1;
      } else if (
        // First condition does a very basic check if a) it's basically a valid custom element tagname AND
        // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
        // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
        !(sv(H) && (se.tagNameCheck instanceof RegExp && Rt(se.tagNameCheck, H) || se.tagNameCheck instanceof Function && se.tagNameCheck(H)) && (se.attributeNameCheck instanceof RegExp && Rt(se.attributeNameCheck, $e) || se.attributeNameCheck instanceof Function && se.attributeNameCheck($e, H)) || // Alternative, second condition checks if it's an `is`-attribute, AND
        // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
        $e === "is" && se.allowCustomizedBuiltInElements && (se.tagNameCheck instanceof RegExp && Rt(se.tagNameCheck, We) || se.tagNameCheck instanceof Function && se.tagNameCheck(We)))
      ) return !1;
    }
    return !0;
  }, aI = Hn({}, ["annotation-xml", "color-profile", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "missing-glyph"]), sv = function(H) {
    return !aI[Io(H)] && Rt(Be, H);
  }, oI = function(H, $e, We, ln) {
    if (I && typeof f == "object" && typeof f.getAttributeType == "function" && !We)
      switch (f.getAttributeType(H, $e)) {
        case "TrustedHTML":
          return Y(ln);
        case "TrustedScriptURL":
          return P(ln);
      }
    return ln;
  }, sI = function(H, $e, We, ln) {
    try {
      We ? H.setAttributeNS(We, $e, ln) : H.setAttribute($e, ln), ds(H) ? ne(H) : hS(n.removed);
    } catch {
      Rn($e, H);
    }
  }, lv = function(H) {
    Qr(be.beforeSanitizeAttributes, H, null);
    const $e = H.attributes;
    if (!$e || ds(H))
      return;
    const We = {
      attrName: "",
      attrValue: "",
      keepAttr: !0,
      allowedAttributes: Me,
      forceKeepAttr: void 0
    };
    let ln = $e.length;
    const Dn = y(H.nodeName);
    for (; ln--; ) {
      const nt = $e[ln], rt = nt.name, Si = nt.namespaceURI, li = nt.value, Xt = y(rt), di = li;
      let qt = rt === "value" ? di : X5(di);
      if (We.attrName = Xt, We.attrValue = qt, We.keepAttr = !0, We.forceKeepAttr = void 0, Qr(be.uponSanitizeAttribute, H, We), qt = We.attrValue, fn && (Xt === "id" || Xt === "name") && gS(qt, En) !== 0 && (Rn(rt, H), qt = En + qt), ae && Rt(/((--!?|])>)|<\/(style|script|title|xmp|textarea|noscript|iframe|noembed|noframes)/i, qt)) {
        Rn(rt, H);
        continue;
      }
      if (Xt === "attributename" && yS(qt, "href")) {
        Rn(rt, H);
        continue;
      }
      if (!We.forceKeepAttr) {
        if (!We.keepAttr) {
          Rn(rt, H);
          continue;
        }
        if (!E && Rt(vB, qt)) {
          Rn(rt, H);
          continue;
        }
        if (z && (qt = ls(qt)), !ov(Dn, Xt, qt)) {
          Rn(rt, H);
          continue;
        }
        qt = oI(Dn, Xt, Si, qt), qt !== di && sI(H, rt, Si, qt);
      }
    }
    Qr(be.afterSanitizeAttributes, H, null);
  }, cs = function(H) {
    let $e = null;
    const We = iv(H);
    for (Qr(be.beforeSanitizeShadowDOM, H, null); $e = We.nextNode(); )
      if (Qr(be.uponSanitizeShadowNode, $e, null), av($e), lv($e), Xi($e.content) && cs($e.content), (R ? R($e) : $e.nodeType) === Pr.element) {
        const ln = g($e);
        Xi(ln) && (kd(ln), cs(ln));
      }
    Qr(be.afterSanitizeShadowDOM, H, null);
  }, kd = function(H) {
    const $e = [{
      node: H,
      shadow: null
    }];
    for (; $e.length > 0; ) {
      const We = $e.pop();
      if (We.shadow) {
        cs(We.shadow);
        continue;
      }
      const ln = We.node, Dn = (R ? R(ln) : ln.nodeType) === Pr.element, nt = j(ln);
      if (nt)
        for (let rt = nt.length - 1; rt >= 0; --rt)
          $e.push({
            node: nt[rt],
            shadow: null
          });
      if (Dn) {
        const rt = F ? F(ln) : null;
        if (typeof rt == "string" && y(rt) === "template") {
          const Si = ln.content;
          Xi(Si) && $e.push({
            node: Si,
            shadow: null
          });
        }
      }
      if (Dn) {
        const rt = g(ln);
        Xi(rt) && $e.push({
          node: null,
          shadow: rt
        }, {
          node: rt,
          shadow: null
        });
      }
    }
  };
  return n.sanitize = function(H) {
    let $e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, We = null, ln = null, Dn = null, nt = null;
    if (Ln = !H, Ln && (H = "<!-->"), typeof H != "string" && !Ua(H) && (H = rB(H), typeof H != "string"))
      throw Fi("dirty is not a string, aborting");
    if (!n.isSupported)
      return H;
    U ? (Je = G, Me = ve) : x($e), (be.uponSanitizeElement.length > 0 || be.uponSanitizeAttribute.length > 0) && (Je = Ht(Je)), be.uponSanitizeAttribute.length > 0 && (Me = Ht(Me)), n.removed = [];
    const rt = Fn && typeof H != "string" && Ua(H);
    if (rt) {
      const Xt = F ? F(H) : H.nodeName;
      if (typeof Xt == "string") {
        const di = y(Xt);
        if (!Je[di] || de[di])
          throw Fi("root node is forbidden and cannot be sanitized in-place");
      }
      if (ds(H))
        throw Fi("root node is clobbered and cannot be sanitized in-place");
      try {
        kd(H);
      } catch (di) {
        throw un(H), di;
      }
    } else if (Ua(H))
      We = rv("<!---->"), ln = We.ownerDocument.importNode(H, !0), ln.nodeType === Pr.element && ln.nodeName === "BODY" || ln.nodeName === "HTML" ? We = ln : We.appendChild(ln), kd(ln);
    else {
      if (!Re && !z && !ce && // eslint-disable-next-line unicorn/prefer-includes
      H.indexOf("<") === -1)
        return I && bn ? Y(H) : H;
      if (We = rv(H), !We)
        return Re ? null : bn ? L : "";
    }
    We && je && ne(We.firstChild);
    const Si = iv(rt ? H : We);
    try {
      for (; Dn = Si.nextNode(); )
        av(Dn), lv(Dn), Xi(Dn.content) && cs(Dn.content);
    } catch (Xt) {
      throw rt && un(H), Xt;
    }
    if (rt)
      return po(n.removed, (Xt) => {
        Xt.element && tI(Xt.element);
      }), z && vd(H), H;
    if (Re) {
      if (z && vd(We), rn)
        for (nt = le.call(We.ownerDocument); We.firstChild; )
          nt.appendChild(We.firstChild);
      else
        nt = We;
      return (Me.shadowroot || Me.shadowrootmode) && (nt = V.call(i, nt, !0)), nt;
    }
    let li = ce ? We.outerHTML : We.innerHTML;
    return ce && Je["!doctype"] && We.ownerDocument && We.ownerDocument.doctype && We.ownerDocument.doctype.name && Rt(fB, We.ownerDocument.doctype.name) && (li = "<!DOCTYPE " + We.ownerDocument.doctype.name + `>
` + li), z && (li = ls(li)), I && bn ? Y(li) : li;
  }, n.setConfig = function() {
    let H = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    x(H), U = !0, G = Je, ve = Me;
  }, n.clearConfig = function() {
    C = null, U = !1, G = null, ve = null, I = W, L = "";
  }, n.isValidAttribute = function(H, $e, We) {
    C || x({});
    const ln = y(H), Dn = y($e);
    return ov(ln, Dn, We);
  }, n.addHook = function(H, $e) {
    typeof $e == "function" && Et(be, H) && oa(be[H], $e);
  }, n.removeHook = function(H, $e) {
    if (Et(be, H)) {
      if ($e !== void 0) {
        const We = J5(be[H], $e);
        return We === -1 ? void 0 : Q5(be[H], We, 1)[0];
      }
      return hS(be[H]);
    }
  }, n.removeHooks = function(H) {
    Et(be, H) && (be[H] = []);
  }, n.removeAllHooks = function() {
    be = wS();
  }, n;
}
var _B = K1();
const xB = "_messageContainer_1rxr4_1", SB = "_chip_1rxr4_7", NB = "_chipLabel_1rxr4_10", jB = "_chipValue_1rxr4_13", Es = {
  messageContainer: xB,
  chip: SB,
  chipLabel: NB,
  chipValue: jB
}, CS = {
  INBOUND: {
    background: "var(--dixa-color-neutral-000)",
    borderColor: "var(--dixa-color-neutral-100)"
  },
  OUTBOUND: {
    background: "var(--dixa-color-neutral-100)",
    borderColor: "var(--dixa-color-neutral-200)"
  },
  INTERNAL: {
    background: "var(--dixa-color-orange-100)",
    borderColor: "var(--dixa-color-orange-200)"
  }
}, wB = ({
  messages: e,
  customFields: n,
  attachments: r,
  conversationContext: i
}) => {
  Qe(() => {
    document.getElementById("endOfConversationAnchor") && document.getElementById("endOfConversationAnchor")?.scrollIntoView({ behavior: "smooth" });
  }, [e]);
  const a = () => {
    const o = "Contact";
    if (!i?.customer)
      return o;
    const {
      name: s,
      given_name: l,
      family_name: c,
      email: m,
      phone_number: u
    } = i.customer;
    return s ?? l ?? c ?? m ?? u ?? o;
  };
  return /* @__PURE__ */ pn.jsxs(b, { flexDirection: "column", gap: "200", children: [
    /* @__PURE__ */ pn.jsx(b, { flexDirection: "row", flexWrap: "wrap", margin: "0 0 300", children: !!n?.length && /* @__PURE__ */ pn.jsxs(b, { gap: "100", children: [
      /* @__PURE__ */ pn.jsx(Xe, { content: "Conversation Attributes", children: /* @__PURE__ */ pn.jsx(
        $y,
        {
          icon: "input",
          color: {
            contentColor: "var(--dixa-color-neutral-700)",
            backgroundColor: "var(--dixa-color-neutral-200)"
          }
        }
      ) }),
      n.map((o, s) => /* @__PURE__ */ pn.jsx(b, { alignItems: "center", children: /* @__PURE__ */ pn.jsx(Jn, { className: Es.chip, children: /* @__PURE__ */ pn.jsxs(b, { gap: "100", children: [
        /* @__PURE__ */ pn.jsxs(lt, { className: Es.chipLabel, children: [
          o.name,
          ":"
        ] }),
        /* @__PURE__ */ pn.jsx(lt, { className: Es.chipValue, children: o.value })
      ] }) }) }, `${s}-${o.name}`))
    ] }) }),
    e?.map((o) => /* @__PURE__ */ pn.jsx(
      b,
      {
        className: Es.messageContainer,
        gap: "200",
        style: {
          backgroundColor: o?.direction ? CS[o.direction].background : "var(--dixa-color-neutral-000)",
          borderColor: o?.direction ? CS[o.direction].borderColor : "var(--dixa-color-neutral-100)"
        },
        children: /* @__PURE__ */ pn.jsxs(b, { flexDirection: "column", gap: "200", width: "100%", children: [
          /* @__PURE__ */ pn.jsxs(b, { flexDirection: "row", justifyContent: "space-between", children: [
            /* @__PURE__ */ pn.jsx($.Heading, { variant: "heading-3", children: o?.direction == "INBOUND" ? a() : o?.agent?.name }),
            /* @__PURE__ */ pn.jsx($.Paragraph, { variant: "4", children: /* @__PURE__ */ pn.jsx(EI, { relative: !0, time: o?.created_at }) })
          ] }),
          /* @__PURE__ */ pn.jsx(
            "div",
            {
              dangerouslySetInnerHTML: {
                __html: _B.sanitize(
                  o?.body?.replaceAll(/\r\n?|\n/g, "<br />") || ""
                )
              }
            }
          )
        ] })
      },
      o?.created_at
    )),
    r && /* @__PURE__ */ pn.jsx(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", margin: "300 0 0", children: r.map((o, s) => /* @__PURE__ */ pn.jsx(
      TI,
      {
        fileName: o.url,
        label: o.label,
        onDownload: () => {
          window.open(o.url, "_blank")?.focus();
        }
      },
      `${s}-${o.url}`
    )) }),
    /* @__PURE__ */ pn.jsx("div", { id: "endOfConversationAnchor", children: " " })
  ] });
}, CB = "_conversation_1draa_1", FB = "_conversationSubLine_1draa_9", IB = "_modal_1draa_14", Hm = {
  conversation: CB,
  conversationSubLine: FB,
  modal: IB
}, $B = (e) => (e && JSON.parse(e) || []).map((n) => ({
  url: n.URL__c,
  label: n.Name,
  type: n.File_Type__c
})), EB = (e) => Object.entries(e || {}).filter(([n]) => n.endsWith("__c")).map(([n, r]) => ({
  name: n.replace("__c", "").replaceAll("_", " "),
  // transform key into readable name
  value: r?.value ? r.value.toString() : ""
})), TB = ({
  conversation: e,
  conversationContext: n
}) => {
  const [r, i] = pe(!1), a = e?.created_at, o = e?.custom_fields, s = o && "attachments" in o;
  return /* @__PURE__ */ pn.jsxs(b, { className: Hm.conversation, gap: "300", flexDirection: "column", children: [
    /* @__PURE__ */ pn.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
      /* @__PURE__ */ pn.jsxs(b, { flexDirection: "column", gap: "100", children: [
        /* @__PURE__ */ pn.jsxs(b, { flexDirection: "row", gap: "100", children: [
          /* @__PURE__ */ pn.jsx($.Heading, { variant: "heading-4", children: e?.id }),
          a && /* @__PURE__ */ pn.jsx(Pn, { size: "small", variant: "info", children: Gn(e?.created_at).format("DD MMM YYYY @ HH:mm") })
        ] }),
        /* @__PURE__ */ pn.jsx(
          $.Heading,
          {
            variant: "heading-4",
            className: Hm.conversationSubLine,
            children: e?.subject
          }
        ),
        !!e?.labels?.length && /* @__PURE__ */ pn.jsx(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [...new Set(e.labels)].map((l) => /* @__PURE__ */ pn.jsx(Jn, { children: l }, `${e.id}-${l}`)) })
      ] }),
      /* @__PURE__ */ pn.jsx(Xe, { content: "Show conversation preview", children: /* @__PURE__ */ pn.jsx(
        Qt,
        {
          variant: "secondary",
          icon: "eye",
          onClick: () => i(!0),
          "data-testid": "open-messages-preview"
        }
      ) })
    ] }),
    /* @__PURE__ */ pn.jsxs(
      bt,
      {
        isOpen: r,
        allowEscClose: !0,
        onClose: () => i(!1),
        className: Hm.modal,
        children: [
          /* @__PURE__ */ pn.jsx(
            _t,
            {
              title: "Conversation preview",
              onClose: () => i(!1)
            }
          ),
          /* @__PURE__ */ pn.jsx(xt, { children: /* @__PURE__ */ pn.jsx(
            wB,
            {
              messages: e?.messages || [],
              ...s && {
                attachments: $B(
                  o?.attachments?.value
                )
              },
              conversationContext: n,
              customFields: EB(
                e?.custom_fields
              )
            }
          ) })
        ]
      }
    )
  ] });
}, RB = ({
  conversations: e,
  conversationContext: n,
  conversationsToShow: r
}) => {
  const [i, a] = pe(!1), o = r > 0 ? r : 1, s = e?.length > o, l = Xn(
    () => e?.sort((c, m) => m?.created_at.localeCompare(c?.created_at)).slice(
      0,
      i ? e.length : o
    ),
    [e, i, o]
  );
  return /* @__PURE__ */ pn.jsxs(b, { flexDirection: "column", gap: "200", margin: "200 0 300 0", children: [
    l.map((c, m) => /* @__PURE__ */ pn.jsx(
      TB,
      {
        conversation: c,
        conversationContext: n
      },
      `${m}-${c?.id}`
    )),
    s && /* @__PURE__ */ pn.jsxs(
      tt,
      {
        variant: "secondary",
        onClick: () => a(!i),
        children: [
          "Show ",
          i ? "less" : "all"
        ]
      }
    )
  ] });
}, DB = U5(
  /* GraphQL*/
  `
  query conversationsQuery($query: String) {
    Miuros {
      findTickets(query: $query, page_size: 10) {
        data {
          id
          labels
          subject
          messages {
            direction
            body
            agent {
              email
              name
            }
            created_at
          }
          custom_fields {
            additionalProperties {
              key
              value {
                value
              }
            }
          }
          created_at
        }
      }
    }
  }
`
), OB = ({
  conversationContext: e,
  settings: n
}) => {
  const [r, i] = pe([]), a = Number.parseInt(n?.amountOfConversationsToShow) || 1, o = [
    e.customer?.email,
    e.customer?.phone_number
  ].filter((u) => !!u).map((u) => `'${u}'`).join(","), { useQuery: s } = hn(), { data: l, loading: c, error: m } = s(DB, {
    skip: o.length === 0,
    variables: {
      query: `requester_id=in=(${o})`
    }
  });
  return Qe(() => {
    if (l?.Miuros) {
      const u = l?.Miuros?.findTickets?.data;
      u && i(u);
    }
  }, [l]), m ? /* @__PURE__ */ pn.jsx($n, { error: m }) : c ? /* @__PURE__ */ pn.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ pn.jsx(mn, {}) }) : r?.length === 0 ? /* @__PURE__ */ pn.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: "No conversations found for this customer" }) : /* @__PURE__ */ pn.jsx(
    RB,
    {
      "data-testid": "conversation-list",
      conversationsToShow: a,
      conversations: r,
      conversationContext: e
    }
  );
}, El = [
  {
    key: "miurosClientId",
    label: "Authorization: Client ID",
    type: "string",
    secret: !1,
    defaultValue: ""
  },
  {
    key: "miurosClientSecret",
    label: "Authorization: Client secret",
    type: "string",
    secret: !0,
    defaultValue: ""
  },
  {
    key: "amountOfConversationsToShow",
    label: "Number of conversation to show before the fold",
    type: "string",
    secret: !1,
    defaultValue: "1"
  }
], Wm = ir(El), Km = "MIUROS", PB = {
  enabled: !1,
  name: "",
  miurosClientId: "",
  miurosClientSecret: "",
  amountOfConversationsToShow: "1"
}, AB = ({
  integrationId: e,
  configuration: n,
  handleRedirect: r,
  showNotification: i,
  automationCouplingState: a,
  renderConditionsEditor: o
}) => {
  const s = !e, l = ut({
    mode: "onChange",
    defaultValues: PB
  }), {
    create: c,
    update: m,
    remove: u,
    isLoading: f,
    error: h,
    misconfigurationCause: k,
    setMisconfigurationCause: w
  } = mr({
    integrationId: e,
    integrationType: Km,
    handleRedirect: r,
    showNotification: i
  }), {
    isLoading: N,
    error: j,
    isWidgetUnknown: _,
    refetch: g,
    widgetConfiguration: O
  } = pr({
    integrationId: e,
    fieldDefinitions: El,
    form: l,
    onMisconfigured: w
  }), { renderConditions: R, setRenderConditions: F, renderConditionsForSubmit: I } = fr({
    integrationId: e,
    widgetConfiguration: O,
    renderConditionsEditor: o
  }), L = (J) => yr(J, {
    fieldDefinitions: El,
    isCreationMode: s,
    create: c,
    update: m,
    renderConditions: I
  }), W = l.watch("name");
  return /* @__PURE__ */ pn.jsxs(
    hr,
    {
      form: l,
      integrationId: e,
      onValidSubmit: L,
      error: j ?? h,
      onRetry: j ? g : void 0,
      isLoading: f || N,
      isWidgetUnknown: _,
      children: [
        k && /* @__PURE__ */ pn.jsx(gr, { cause: k }),
        /* @__PURE__ */ pn.jsxs(et, { children: [
          /* @__PURE__ */ pn.jsx(X, { children: /* @__PURE__ */ pn.jsx(He, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ pn.jsx(
            yn,
            {
              name: "enabled",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ pn.jsx(X, { span: 3, children: /* @__PURE__ */ pn.jsx(
            On,
            {
              name: "name",
              label: "Widget name",
              control: l.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ pn.jsx(X, { span: 3 }),
          /* @__PURE__ */ pn.jsx(X, { span: 3, children: /* @__PURE__ */ pn.jsx(
            On,
            {
              name: "miurosClientId",
              label: Wm.miurosClientId,
              control: l.control,
              rules: { required: "Client ID is required" },
              componentProps: {
                placeholder: "Insert client ID",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ pn.jsx(X, { span: 3 }),
          /* @__PURE__ */ pn.jsx(X, { span: 3, children: /* @__PURE__ */ pn.jsx(
            $r,
            {
              name: "miurosClientSecret",
              label: Wm.miurosClientSecret,
              control: l.control,
              isCreationMode: s,
              rules: { required: "Client secret is required" },
              componentProps: {
                placeholder: "Insert client secret",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ pn.jsx(X, { span: 3 }),
          /* @__PURE__ */ pn.jsx(X, { span: 3, children: /* @__PURE__ */ pn.jsx(
            On,
            {
              name: "amountOfConversationsToShow",
              label: Wm.amountOfConversationsToShow,
              control: l.control,
              rules: {
                required: "Please enter a number",
                validate: (J) => !Number.isNaN(Number.parseInt(J, 10)) || "Please enter a number"
              },
              componentProps: {
                placeholder: "Enter number",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ pn.jsx(X, { span: 3 }),
          !s && e && /* @__PURE__ */ pn.jsx(
            vi,
            {
              configuration: n,
              integrationId: e,
              integrationType: Km,
              label: "Authorize"
            }
          ),
          o && R !== null && /* @__PURE__ */ pn.jsx(X, { children: o({
            value: R,
            onChange: F,
            configurationKey: O?.id
          }) })
        ] }),
        /* @__PURE__ */ pn.jsx(
          vr,
          {
            integrationType: Km,
            integrationId: e,
            widgetName: W,
            isCreationMode: s,
            isSubmitting: l.formState.isSubmitting,
            automationCouplingState: a,
            onConfirmDelete: () => u()
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._list_18ybb_1{padding:0}._listItem_18ybb_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_18ybb_4:last-child{border-bottom:none}._copyIcon_18ybb_12{cursor:pointer;color:var(--dixa-typography-color-secondary)}._fullWidth_18ybb_17{width:100%}._wrapper_1nher_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._order_1dlaa_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_1dlaa_1:hover,._orderIsOpen_1dlaa_9{border-color:var(--dixa-color-neutral-400)}._orderHeader_1dlaa_12{cursor:pointer}._note_1dlaa_16{border:var(--dixa-size-border-100) dashed var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-200);max-height:100px;overflow-y:auto}._subscription_1xxl7_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._subscription_1xxl7_1:hover,._subscriptionIsOpen_1xxl7_9{border-color:var(--dixa-color-neutral-400)}._subscriptionHeader_1xxl7_12{cursor:pointer}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Gm = { exports: {} }, yo = {}, FS;
function LB() {
  if (FS) return yo;
  FS = 1;
  var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, c, m) {
    var u, f = {}, h = null, k = null;
    m !== void 0 && (h = "" + m), c.key !== void 0 && (h = "" + c.key), c.ref !== void 0 && (k = c.ref);
    for (u in c) i.call(c, u) && !o.hasOwnProperty(u) && (f[u] = c[u]);
    if (l && l.defaultProps) for (u in c = l.defaultProps, c) f[u] === void 0 && (f[u] = c[u]);
    return { $$typeof: n, type: l, key: h, ref: k, props: f, _owner: a.current };
  }
  return yo.Fragment = r, yo.jsx = s, yo.jsxs = s, yo;
}
var Ts = {}, IS;
function VB() {
  return IS || (IS = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), c = /* @__PURE__ */ Symbol.for("react.forward_ref"), m = /* @__PURE__ */ Symbol.for("react.suspense"), u = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), k = /* @__PURE__ */ Symbol.for("react.offscreen"), w = Symbol.iterator, N = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var d = w && t[w] || t[N];
      return typeof d == "function" ? d : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var d = arguments.length, p = new Array(d > 1 ? d - 1 : 0), y = 1; y < d; y++)
          p[y - 1] = arguments[y];
        O("error", t, p);
      }
    }
    function O(t, d, p) {
      {
        var y = _.ReactDebugCurrentFrame, C = y.getStackAddendum();
        C !== "" && (d += "%s", p = p.concat([C]));
        var T = p.map(function(S) {
          return String(S);
        });
        T.unshift("Warning: " + d), Function.prototype.apply.call(console[t], console, T);
      }
    }
    var R = !1, F = !1, I = !1, L = !1, W = !1, J;
    J = /* @__PURE__ */ Symbol.for("react.module.reference");
    function re(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || W || t === a || t === m || t === u || L || t === k || R || F || I || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === J || t.getModuleId !== void 0));
    }
    function K(t, d, p) {
      var y = t.displayName;
      if (y)
        return y;
      var C = d.displayName || d.name || "";
      return C !== "" ? p + "(" + C + ")" : p;
    }
    function Y(t) {
      return t.displayName || "Context";
    }
    function P(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var d = t;
            return Y(d) + ".Consumer";
          case s:
            var p = t;
            return Y(p._context) + ".Provider";
          case c:
            return K(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : P(t.type) || "Memo";
          case h: {
            var C = t, T = C._payload, S = C._init;
            try {
              return P(S(T));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, ie = 0, we, me, le, ge, V, be, Oe;
    function q() {
    }
    q.__reactDisabledLog = !0;
    function Ge() {
      {
        if (ie === 0) {
          we = console.log, me = console.info, le = console.warn, ge = console.error, V = console.group, be = console.groupCollapsed, Oe = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: q,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ie++;
      }
    }
    function sn() {
      {
        if (ie--, ie === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, t, {
              value: we
            }),
            info: B({}, t, {
              value: me
            }),
            warn: B({}, t, {
              value: le
            }),
            error: B({}, t, {
              value: ge
            }),
            group: B({}, t, {
              value: V
            }),
            groupCollapsed: B({}, t, {
              value: be
            }),
            groupEnd: B({}, t, {
              value: Oe
            })
          });
        }
        ie < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ie = _.ReactCurrentDispatcher, Ue;
    function De(t, d, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (C) {
            var y = C.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Ae;
    {
      var Je = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Je();
    }
    function Ee(t, d) {
      if (!t || Be)
        return "";
      {
        var p = Ae.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Be = !0;
      var C = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var T;
      T = Ie.current, Ie.current = null, Ge();
      try {
        if (d) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (ne) {
              y = ne;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (ne) {
              y = ne;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            y = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && y && typeof ne.stack == "string") {
          for (var x = ne.stack.split(`
`), Z = y.stack.split(`
`), A = x.length - 1, M = Z.length - 1; A >= 1 && M >= 0 && x[A] !== Z[M]; )
            M--;
          for (; A >= 1 && M >= 0; A--, M--)
            if (x[A] !== Z[M]) {
              if (A !== 1 || M !== 1)
                do
                  if (A--, M--, M < 0 || x[A] !== Z[M]) {
                    var ue = `
` + x[A].replace(" at new ", " at ");
                    return t.displayName && ue.includes("<anonymous>") && (ue = ue.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, ue), ue;
                  }
                while (A >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Ie.current = T, sn(), Error.prepareStackTrace = C;
      }
      var ze = t ? t.displayName || t.name : "", Te = ze ? De(ze) : "";
      return typeof t == "function" && Ae.set(t, Te), Te;
    }
    function Me(t, d, p) {
      return Ee(t, !1);
    }
    function en(t) {
      var d = t.prototype;
      return !!(d && d.isReactComponent);
    }
    function se(t, d, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ee(t, en(t));
      if (typeof t == "string")
        return De(t);
      switch (t) {
        case m:
          return De("Suspense");
        case u:
          return De("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case c:
            return Me(t.render);
          case f:
            return se(t.type, d, p);
          case h: {
            var y = t, C = y._payload, T = y._init;
            try {
              return se(T(C), d, p);
            } catch {
            }
          }
        }
      return "";
    }
    var de = Object.prototype.hasOwnProperty, Se = {}, Ve = _.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var d = t._owner, p = se(t.type, t._source, d ? d.type : null);
        Ve.setExtraStackFrame(p);
      } else
        Ve.setExtraStackFrame(null);
    }
    function kn(t, d, p, y, C) {
      {
        var T = Function.call.bind(de);
        for (var S in t)
          if (T(t, S)) {
            var x = void 0;
            try {
              if (typeof t[S] != "function") {
                var Z = Error((y || "React class") + ": " + p + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Z.name = "Invariant Violation", Z;
              }
              x = t[S](d, S, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (A) {
              x = A;
            }
            x && !(x instanceof Error) && (Pe(C), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, S, typeof x), Pe(null)), x instanceof Error && !(x.message in Se) && (Se[x.message] = !0, Pe(C), g("Failed %s type: %s", p, x.message), Pe(null));
          }
      }
    }
    var Q = Array.isArray;
    function E(t) {
      return Q(t);
    }
    function z(t) {
      {
        var d = typeof Symbol == "function" && Symbol.toStringTag, p = d && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function ae(t) {
      try {
        return ce(t), !1;
      } catch {
        return !0;
      }
    }
    function ce(t) {
      return "" + t;
    }
    function U(t) {
      if (ae(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", z(t)), ce(t);
    }
    var G = _.ReactCurrentOwner, ve = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, je, Re;
    function rn(t) {
      if (de.call(t, "ref")) {
        var d = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (d && d.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function bn(t) {
      if (de.call(t, "key")) {
        var d = Object.getOwnPropertyDescriptor(t, "key").get;
        if (d && d.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function an(t, d) {
      typeof t.ref == "string" && G.current;
    }
    function fn(t, d) {
      {
        var p = function() {
          je || (je = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", d));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function En(t, d) {
      {
        var p = function() {
          Re || (Re = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", d));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var _n = function(t, d, p, y, C, T, S) {
      var x = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: d,
        ref: p,
        props: S,
        // Record the component responsible for creating this element.
        _owner: T
      };
      return x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(x, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(x, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: C
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    };
    function Fn(t, d, p, y, C) {
      {
        var T, S = {}, x = null, Z = null;
        p !== void 0 && (U(p), x = "" + p), bn(d) && (U(d.key), x = "" + d.key), rn(d) && (Z = d.ref, an(d));
        for (T in d)
          de.call(d, T) && !ve.hasOwnProperty(T) && (S[T] = d[T]);
        if (t && t.defaultProps) {
          var A = t.defaultProps;
          for (T in A)
            S[T] === void 0 && (S[T] = A[T]);
        }
        if (x || Z) {
          var M = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          x && fn(S, M), Z && En(S, M);
        }
        return _n(t, x, Z, C, y, G.current, S);
      }
    }
    var Ze = _.ReactCurrentOwner, gn = _.ReactDebugCurrentFrame;
    function Le(t) {
      if (t) {
        var d = t._owner, p = se(t.type, t._source, d ? d.type : null);
        gn.setExtraStackFrame(p);
      } else
        gn.setExtraStackFrame(null);
    }
    var dn;
    dn = !1;
    function cn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function Nn() {
      {
        if (Ze.current) {
          var t = P(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Bn(t) {
      return "";
    }
    var Sn = {};
    function An(t) {
      {
        var d = Nn();
        if (!d) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (d = `

Check the top-level render call using <` + p + ">.");
        }
        return d;
      }
    }
    function vn(t, d) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = An(d);
        if (Sn[p])
          return;
        Sn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Ze.current && (y = " It was passed a child from " + P(t._owner.type) + "."), Le(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Le(null);
      }
    }
    function xn(t, d) {
      {
        if (typeof t != "object")
          return;
        if (E(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            cn(y) && vn(y, d);
          }
        else if (cn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var C = j(t);
          if (typeof C == "function" && C !== t.entries)
            for (var T = C.call(t), S; !(S = T.next()).done; )
              cn(S.value) && vn(S.value, d);
        }
      }
    }
    function Ln(t) {
      {
        var d = t.type;
        if (d == null || typeof d == "string")
          return;
        var p;
        if (typeof d == "function")
          p = d.propTypes;
        else if (typeof d == "object" && (d.$$typeof === c || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        d.$$typeof === f))
          p = d.propTypes;
        else
          return;
        if (p) {
          var y = P(d);
          kn(p, t.props, "prop", y, t);
        } else if (d.PropTypes !== void 0 && !dn) {
          dn = !0;
          var C = P(d);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", C || "Unknown");
        }
        typeof d.getDefaultProps == "function" && !d.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var d = Object.keys(t.props), p = 0; p < d.length; p++) {
          var y = d[p];
          if (y !== "children" && y !== "key") {
            Le(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Le(null);
            break;
          }
        }
        t.ref !== null && (Le(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Le(null));
      }
    }
    var Cn = {};
    function wn(t, d, p, y, C, T) {
      {
        var S = re(t);
        if (!S) {
          var x = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (x += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Z = Bn();
          Z ? x += Z : x += Nn();
          var A;
          t === null ? A = "null" : E(t) ? A = "array" : t !== void 0 && t.$$typeof === n ? (A = "<" + (P(t.type) || "Unknown") + " />", x = " Did you accidentally export a JSX literal instead of a component?") : A = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", A, x);
        }
        var M = Fn(t, d, p, C, T);
        if (M == null)
          return M;
        if (S) {
          var ue = d.children;
          if (ue !== void 0)
            if (y)
              if (E(ue)) {
                for (var ze = 0; ze < ue.length; ze++)
                  xn(ue[ze], t);
                Object.freeze && Object.freeze(ue);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              xn(ue, t);
        }
        if (de.call(d, "key")) {
          var Te = P(t), ne = Object.keys(d).filter(function(Kn) {
            return Kn !== "key";
          }), un = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Cn[Te + un]) {
            var Rn = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, un, Te, Rn, Te), Cn[Te + un] = !0;
          }
        }
        return t === i ? Vn(M) : Ln(M), M;
      }
    }
    function zn(t, d, p) {
      return wn(t, d, p, !0);
    }
    function qn(t, d, p) {
      return wn(t, d, p, !1);
    }
    var Un = qn, Wn = zn;
    Ts.Fragment = i, Ts.jsx = Un, Ts.jsxs = Wn;
  })()), Ts;
}
var $S;
function zB() {
  return $S || ($S = 1, process.env.NODE_ENV === "production" ? Gm.exports = LB() : Gm.exports = VB()), Gm.exports;
}
var te = zB();
const UB = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getAddresses" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Recharge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getAddresses" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "customer_id" }, value: { kind: "Variable", name: { kind: "Name", value: "customerId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Addresses" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "addresses" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "payment_method_id" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "country_code" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "customer_id" } }, { kind: "Field", name: { kind: "Name", value: "discounts" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "value" } }, { kind: "Field", name: { kind: "Name", value: "value_type" } }] } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "order_attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "value" } }] } }, { kind: "Field", name: { kind: "Name", value: "order_note" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "presentment_currency" } }, { kind: "Field", name: { kind: "Name", value: "shipping_lines_conserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "price" } }] } }, { kind: "Field", name: { kind: "Name", value: "shipping_lines_override" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "price" } }] } }, { kind: "Field", name: { kind: "Name", value: "updated_at" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }] } }] } }] } }] } }] }, MB = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getChargeById" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "id" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Recharge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getChargeById" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "id" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Charge" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "charge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "scheduled_at" } }, { kind: "Field", name: { kind: "Name", value: "processed_at" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }, { kind: "Field", name: { kind: "Name", value: "currency" } }, { kind: "Field", name: { kind: "Name", value: "line_items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "variant_title" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "unit_price" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }] } }] } }] } }] } }] } }] } }] }, BB = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCharges" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "subscriptionId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "status" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "limit" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Recharge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getCharges" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "customer_id" }, value: { kind: "Variable", name: { kind: "Name", value: "customerId" } } }, { kind: "Argument", name: { kind: "Name", value: "subscription_id" }, value: { kind: "Variable", name: { kind: "Name", value: "subscriptionId" } } }, { kind: "Argument", name: { kind: "Name", value: "status" }, value: { kind: "Variable", name: { kind: "Name", value: "status" } } }, { kind: "Argument", name: { kind: "Name", value: "limit" }, value: { kind: "Variable", name: { kind: "Name", value: "limit" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Charges" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "charges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "scheduled_at" } }, { kind: "Field", name: { kind: "Name", value: "processed_at" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }, { kind: "Field", name: { kind: "Name", value: "currency" } }, { kind: "Field", name: { kind: "Name", value: "line_items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "variant_title" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "unit_price" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }] } }] } }] } }] } }] } }] } }] }, qB = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomerDetails" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Recharge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getStore" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Store" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "store" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "external_platform" } }, { kind: "Field", name: { kind: "Name", value: "customer_portal_base_url" } }, { kind: "Field", name: { kind: "Name", value: "merchant_portal_base_url" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "checkout_platform" } }, { kind: "Field", name: { kind: "Name", value: "external_platform" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "getCustomers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Customers" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customers" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "updated_at" } }, { kind: "Field", name: { kind: "Name", value: "external_customer_id" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ecommerce" } }] } }, { kind: "Field", name: { kind: "Name", value: "subscriptions_active_count" } }, { kind: "Field", name: { kind: "Name", value: "subscriptions_total_count" } }, { kind: "Field", name: { kind: "Name", value: "has_valid_payment_method" } }, { kind: "Field", name: { kind: "Name", value: "hash" } }] } }] } }] } }] } }] } }] }, HB = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getOrders" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "limit" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "addressId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Recharge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getOrders" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "customer_id" }, value: { kind: "Variable", name: { kind: "Name", value: "customerId" } } }, { kind: "Argument", name: { kind: "Name", value: "limit" }, value: { kind: "Variable", name: { kind: "Name", value: "limit" } } }, { kind: "Argument", name: { kind: "Name", value: "address_id" }, value: { kind: "Variable", name: { kind: "Name", value: "addressId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Orders" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orders" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "currency" } }, { kind: "Field", name: { kind: "Name", value: "is_prepaid" } }, { kind: "Field", name: { kind: "Name", value: "note" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "subtotal_price" } }, { kind: "Field", name: { kind: "Name", value: "total_discounts" } }, { kind: "Field", name: { kind: "Name", value: "total_duties" } }, { kind: "Field", name: { kind: "Name", value: "total_line_items_price" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }, { kind: "Field", name: { kind: "Name", value: "total_refunds" } }, { kind: "Field", name: { kind: "Name", value: "total_tax" } }, { kind: "Field", name: { kind: "Name", value: "total_weight_grams" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "charge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "external_transaction_id" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "payment_processor" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "billing_address" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "country_code" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }, { kind: "Field", name: { kind: "Name", value: "shipping_address" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "country_code" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }] } }] } }] } }] } }] } }] }, WB = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getSubscriptionById" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "id" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Recharge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getSubscriptionById" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "id" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Subscription_" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "subscription" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "product_title" } }, { kind: "Field", name: { kind: "Name", value: "variant_title" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "presentment_currency" } }, { kind: "Field", name: { kind: "Name", value: "is_prepaid" } }, { kind: "Field", name: { kind: "Name", value: "next_charge_scheduled_at" } }, { kind: "Field", name: { kind: "Name", value: "order_interval_frequency" } }, { kind: "Field", name: { kind: "Name", value: "order_interval_unit" } }, { kind: "Field", name: { kind: "Name", value: "charge_interval_frequency" } }, { kind: "Field", name: { kind: "Name", value: "cancellation_reason" } }, { kind: "Field", name: { kind: "Name", value: "cancelled_at" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }] } }] } }] } }] } }] } }] }, KB = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getSubscriptions" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "status" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "limit" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Recharge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getSubscriptions" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "customer_id" }, value: { kind: "Variable", name: { kind: "Name", value: "customerId" } } }, { kind: "Argument", name: { kind: "Name", value: "status" }, value: { kind: "Variable", name: { kind: "Name", value: "status" } } }, { kind: "Argument", name: { kind: "Name", value: "limit" }, value: { kind: "Variable", name: { kind: "Name", value: "limit" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Subscriptions" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "product_title" } }, { kind: "Field", name: { kind: "Name", value: "variant_title" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "presentment_currency" } }, { kind: "Field", name: { kind: "Name", value: "is_prepaid" } }, { kind: "Field", name: { kind: "Name", value: "next_charge_scheduled_at" } }, { kind: "Field", name: { kind: "Name", value: "order_interval_frequency" } }, { kind: "Field", name: { kind: "Name", value: "order_interval_unit" } }, { kind: "Field", name: { kind: "Name", value: "charge_interval_frequency" } }, { kind: "Field", name: { kind: "Name", value: "cancellation_reason" } }, { kind: "Field", name: { kind: "Name", value: "cancelled_at" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }] } }] } }] } }] } }] } }] }, GB = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "activateSubscription" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "id" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Recharge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "activateSubscription" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "id" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "__typename" } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Subscription_" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "subscription" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "cancelled_at" } }, { kind: "Field", name: { kind: "Name", value: "cancellation_reason" } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_BasicResponse" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, YB = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "cancelSubscription" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "id" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Recharge_SubscriptionCancelInput_Input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Recharge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "cancelSubscription" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "id" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "__typename" } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Subscription_" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "subscription" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "cancelled_at" } }, { kind: "Field", name: { kind: "Name", value: "cancellation_reason" } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_BasicResponse" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, JB = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "changeSubscriptionNextChargeDate" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "id" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Recharge_SubscriptionChangeNextChargeDateInput_Input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Recharge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "changeSubscriptionNextChargeDate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "id" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "__typename" } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Subscription_" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "subscription" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "next_charge_scheduled_at" } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_BasicResponse" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, QB = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "skipCharge" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "id" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Recharge_ChargeSkipInput_Input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Recharge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "skipCharge" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "id" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "__typename" } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Charge" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "charge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "scheduled_at" } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_BasicResponse" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, XB = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "unskipCharge" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "id" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Recharge_ChargeSkipInput_Input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Recharge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "unskipCharge" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "id" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "__typename" } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Charge" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "charge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "scheduled_at" } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_BasicResponse" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, ZB = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updateSubscription" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "id" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Recharge_SubscriptionUpdateInput_Input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Recharge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "updateSubscription" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "id" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "__typename" } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Subscription_" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "subscription" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "product_title" } }, { kind: "Field", name: { kind: "Name", value: "variant_title" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "next_charge_scheduled_at" } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_BasicResponse" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, eq = {
  "\n  query getAddresses($customerId: String) {\n    Recharge {\n      getAddresses(customer_id: $customerId) {\n        ... on Recharge_Addresses {\n          addresses {\n            id\n            payment_method_id\n            address1\n            address2\n            city\n            company\n            country_code\n            created_at\n            customer_id\n            discounts {\n              id\n              code\n              value\n              value_type\n            }\n            first_name\n            last_name\n            order_attributes {\n              name\n              value\n            }\n            order_note\n            phone\n            presentment_currency\n            shipping_lines_conserved {\n              code\n              title\n              price\n            }\n            shipping_lines_override {\n              code\n              title\n              price\n            }\n            updated_at\n            zip\n          }\n        }\n      }\n    }\n  }\n": UB,
  "\n  query getChargeById($id: Int!) {\n    Recharge {\n      getChargeById(id: $id) {\n        ... on Recharge_Charge {\n          charge {\n            id\n            status\n            scheduled_at\n            processed_at\n            total_price\n            currency\n            line_items {\n              title\n              variant_title\n              quantity\n              unit_price\n              total_price\n            }\n          }\n        }\n      }\n    }\n  }\n": MB,
  "\n  query getCharges(\n    $customerId: String\n    $subscriptionId: String\n    $status: String\n    $limit: String\n  ) {\n    Recharge {\n      getCharges(\n        customer_id: $customerId\n        subscription_id: $subscriptionId\n        status: $status\n        limit: $limit\n      ) {\n        ... on Recharge_Charges {\n          charges {\n            id\n            status\n            scheduled_at\n            processed_at\n            total_price\n            currency\n            line_items {\n              title\n              variant_title\n              quantity\n              unit_price\n              total_price\n            }\n          }\n        }\n      }\n    }\n  }\n": BB,
  "\n  query getCustomerDetails($email: String) {\n    Recharge {\n      getStore {\n        ... on Recharge_Store {\n          store {\n            id\n            name\n            external_platform\n            customer_portal_base_url\n            merchant_portal_base_url\n            identifier\n            checkout_platform\n            external_platform\n          }\n        }\n      }\n      getCustomers(email: $email) {\n        ... on Recharge_Customers {\n          customers {\n            id\n            email\n            phone\n            first_name\n            last_name\n            created_at\n            updated_at\n            external_customer_id {\n              ecommerce\n            }\n            subscriptions_active_count\n            subscriptions_total_count\n            has_valid_payment_method\n            hash\n          }\n        }\n      }\n    }\n  }\n": qB,
  "\n  query getOrders($customerId: String, $limit: String, $addressId: String) {\n    Recharge {\n      getOrders(\n        customer_id: $customerId\n        limit: $limit\n        address_id: $addressId\n      ) {\n        ... on Recharge_Orders {\n          orders {\n            id\n            created_at\n            currency\n            is_prepaid\n            note\n            status\n            subtotal_price\n            total_discounts\n            total_duties\n            total_line_items_price\n            total_price\n            total_refunds\n            total_tax\n            total_weight_grams\n            type\n            charge {\n              external_transaction_id {\n                payment_processor\n              }\n            }\n            billing_address {\n              address1\n              address2\n              city\n              company\n              country_code\n              first_name\n              last_name\n              phone\n              province\n              zip\n            }\n            shipping_address {\n              address1\n              address2\n              city\n              company\n              country_code\n              first_name\n              last_name\n              phone\n              province\n              zip\n            }\n          }\n        }\n      }\n    }\n  }\n": HB,
  "\n  query getSubscriptionById($id: Int!) {\n    Recharge {\n      getSubscriptionById(id: $id) {\n        ... on Recharge_Subscription_ {\n          subscription {\n            id\n            status\n            product_title\n            variant_title\n            quantity\n            price\n            presentment_currency\n            is_prepaid\n            next_charge_scheduled_at\n            order_interval_frequency\n            order_interval_unit\n            charge_interval_frequency\n            cancellation_reason\n            cancelled_at\n            created_at\n          }\n        }\n      }\n    }\n  }\n": WB,
  "\n  query getSubscriptions($customerId: String, $status: String, $limit: String) {\n    Recharge {\n      getSubscriptions(\n        customer_id: $customerId\n        status: $status\n        limit: $limit\n      ) {\n        ... on Recharge_Subscriptions {\n          subscriptions {\n            id\n            status\n            product_title\n            variant_title\n            quantity\n            price\n            presentment_currency\n            is_prepaid\n            next_charge_scheduled_at\n            order_interval_frequency\n            order_interval_unit\n            charge_interval_frequency\n            cancellation_reason\n            cancelled_at\n            created_at\n          }\n        }\n      }\n    }\n  }\n": KB,
  "\n  mutation activateSubscription($id: Int!) {\n    Recharge {\n      activateSubscription(id: $id) {\n        __typename\n        ... on Recharge_Subscription_ {\n          subscription {\n            id\n            status\n            cancelled_at\n            cancellation_reason\n          }\n        }\n        ... on Recharge_BasicResponse {\n          message\n        }\n      }\n    }\n  }\n": GB,
  "\n  mutation cancelSubscription(\n    $id: Int!\n    $input: Recharge_SubscriptionCancelInput_Input\n  ) {\n    Recharge {\n      cancelSubscription(id: $id, input: $input) {\n        __typename\n        ... on Recharge_Subscription_ {\n          subscription {\n            id\n            status\n            cancelled_at\n            cancellation_reason\n          }\n        }\n        ... on Recharge_BasicResponse {\n          message\n        }\n      }\n    }\n  }\n": YB,
  "\n  mutation changeSubscriptionNextChargeDate(\n    $id: Int!\n    $input: Recharge_SubscriptionChangeNextChargeDateInput_Input\n  ) {\n    Recharge {\n      changeSubscriptionNextChargeDate(id: $id, input: $input) {\n        __typename\n        ... on Recharge_Subscription_ {\n          subscription {\n            id\n            status\n            next_charge_scheduled_at\n          }\n        }\n        ... on Recharge_BasicResponse {\n          message\n        }\n      }\n    }\n  }\n": JB,
  "\n  mutation skipCharge($id: Int!, $input: Recharge_ChargeSkipInput_Input) {\n    Recharge {\n      skipCharge(id: $id, input: $input) {\n        __typename\n        ... on Recharge_Charge {\n          charge {\n            id\n            status\n            scheduled_at\n          }\n        }\n        ... on Recharge_BasicResponse {\n          message\n        }\n      }\n    }\n  }\n": QB,
  "\n  mutation unskipCharge($id: Int!, $input: Recharge_ChargeSkipInput_Input) {\n    Recharge {\n      unskipCharge(id: $id, input: $input) {\n        __typename\n        ... on Recharge_Charge {\n          charge {\n            id\n            status\n            scheduled_at\n          }\n        }\n        ... on Recharge_BasicResponse {\n          message\n        }\n      }\n    }\n  }\n": XB,
  "\n  mutation updateSubscription(\n    $id: Int!\n    $input: Recharge_SubscriptionUpdateInput_Input\n  ) {\n    Recharge {\n      updateSubscription(id: $id, input: $input) {\n        __typename\n        ... on Recharge_Subscription_ {\n          subscription {\n            id\n            status\n            product_title\n            variant_title\n            price\n            quantity\n            next_charge_scheduled_at\n          }\n        }\n        ... on Recharge_BasicResponse {\n          message\n        }\n      }\n    }\n  }\n": ZB
};
function Aa(e) {
  return eq[e] ?? {};
}
const nq = Aa(
  /* GraphQL */
  `
  query getCustomerDetails($email: String) {
    Recharge {
      getStore {
        ... on Recharge_Store {
          store {
            id
            name
            external_platform
            customer_portal_base_url
            merchant_portal_base_url
            identifier
            checkout_platform
            external_platform
          }
        }
      }
      getCustomers(email: $email) {
        ... on Recharge_Customers {
          customers {
            id
            email
            phone
            first_name
            last_name
            created_at
            updated_at
            external_customer_id {
              ecommerce
            }
            subscriptions_active_count
            subscriptions_total_count
            has_valid_payment_method
            hash
          }
        }
      }
    }
  }
`
), tq = Aa(
  /* GraphQL */
  `
  query getAddresses($customerId: String) {
    Recharge {
      getAddresses(customer_id: $customerId) {
        ... on Recharge_Addresses {
          addresses {
            id
            payment_method_id
            address1
            address2
            city
            company
            country_code
            created_at
            customer_id
            discounts {
              id
              code
              value
              value_type
            }
            first_name
            last_name
            order_attributes {
              name
              value
            }
            order_note
            phone
            presentment_currency
            shipping_lines_conserved {
              code
              title
              price
            }
            shipping_lines_override {
              code
              title
              price
            }
            updated_at
            zip
          }
        }
      }
    }
  }
`
), rq = Aa(
  /* GraphQL */
  `
  query getOrders($customerId: String, $limit: String, $addressId: String) {
    Recharge {
      getOrders(
        customer_id: $customerId
        limit: $limit
        address_id: $addressId
      ) {
        ... on Recharge_Orders {
          orders {
            id
            created_at
            currency
            is_prepaid
            note
            status
            subtotal_price
            total_discounts
            total_duties
            total_line_items_price
            total_price
            total_refunds
            total_tax
            total_weight_grams
            type
            charge {
              external_transaction_id {
                payment_processor
              }
            }
            billing_address {
              address1
              address2
              city
              company
              country_code
              first_name
              last_name
              phone
              province
              zip
            }
            shipping_address {
              address1
              address2
              city
              company
              country_code
              first_name
              last_name
              phone
              province
              zip
            }
          }
        }
      }
    }
  }
`
), iq = Aa(
  /* GraphQL */
  `
  query getSubscriptions($customerId: String, $status: String, $limit: String) {
    Recharge {
      getSubscriptions(
        customer_id: $customerId
        status: $status
        limit: $limit
      ) {
        ... on Recharge_Subscriptions {
          subscriptions {
            id
            status
            product_title
            variant_title
            quantity
            price
            presentment_currency
            is_prepaid
            next_charge_scheduled_at
            order_interval_frequency
            order_interval_unit
            charge_interval_frequency
            cancellation_reason
            cancelled_at
            created_at
          }
        }
      }
    }
  }
`
), aq = Aa(
  /* GraphQL */
  `
  mutation cancelSubscription(
    $id: Int!
    $input: Recharge_SubscriptionCancelInput_Input
  ) {
    Recharge {
      cancelSubscription(id: $id, input: $input) {
        __typename
        ... on Recharge_Subscription_ {
          subscription {
            id
            status
            cancelled_at
            cancellation_reason
          }
        }
        ... on Recharge_BasicResponse {
          message
        }
      }
    }
  }
`
), oq = Aa(
  /* GraphQL */
  `
  mutation activateSubscription($id: Int!) {
    Recharge {
      activateSubscription(id: $id) {
        __typename
        ... on Recharge_Subscription_ {
          subscription {
            id
            status
            cancelled_at
            cancellation_reason
          }
        }
        ... on Recharge_BasicResponse {
          message
        }
      }
    }
  }
`
);
function vy(e = !1, n) {
  const [r, i] = pe(e);
  return Qe(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copy: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const G1 = ({
  mutation: e,
  getResultTypename: n,
  successText: r,
  failureText: i,
  trackingAction: a,
  setIsMutationLoading: o,
  setIsOpen: s,
  refetchSubscriptions: l
}) => {
  const { track: c } = jn(), { useMutation: m, showNotification: u } = hn(), f = () => {
    o(!1), u({
      title: "Something went wrong",
      text: i,
      icon: "exclamation-triangle-filled",
      severity: "warning"
    }), s(!1);
  };
  return m(e, {
    onError: f,
    onCompleted: async (h) => {
      if (n(h) !== "Recharge_Subscription_") {
        f();
        return;
      }
      await l().finally(() => o(!1)), u({
        title: "Success",
        text: r,
        icon: "check-circle-filled",
        severity: "success"
      }), c(a), s(!1);
    }
  });
}, Y1 = (e) => `${e.charAt(0).toUpperCase()}${e.slice(1).toLowerCase()}`, Eg = "DD MMM YYYY @ HH:mm", sq = "_list_18ybb_1", lq = "_listItem_18ybb_4", dq = "_copyIcon_18ybb_12", cq = "_fullWidth_18ybb_17", ai = {
  list: sq,
  listItem: lq,
  copyIcon: dq,
  fullWidth: cq
}, ky = ({
  address: e,
  icon: n,
  title: r,
  isLoading: i = !1,
  hasMultipleAddresses: a = !1
}) => {
  const { isCopied: o, copy: s } = vy(), l = 14, {
    first_name: c,
    last_name: m,
    address1: u,
    address2: f,
    city: h,
    zip: k,
    country_code: w
  } = e ?? {}, N = `${c} ${m}`.trim() || void 0, j = `${h} ${k}`.trim() || void 0, _ = [N, u, f, j, w].filter(
    Boolean
  );
  return /* @__PURE__ */ te.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
    /* @__PURE__ */ te.jsxs(b, { gap: "200", children: [
      /* @__PURE__ */ te.jsx(he, { size: l, name: n }),
      i ? /* @__PURE__ */ te.jsx(mn, { size: l }) : /* @__PURE__ */ te.jsxs(b, { gap: "200", flexDirection: "column", children: [
        r && /* @__PURE__ */ te.jsx($.Paragraph, { variant: "3", children: r }),
        /* @__PURE__ */ te.jsx($.Paragraph, { variant: "4", children: _.map((g, O) => /* @__PURE__ */ te.jsx(lt, { children: g }, O)) })
      ] })
    ] }),
    !i && /* @__PURE__ */ te.jsxs(b, { gap: "100", children: [
      a && /* @__PURE__ */ te.jsx(Xe, { content: "The customer has multiple addresses, showing only the first here.", children: /* @__PURE__ */ te.jsx(
        he,
        {
          size: l,
          name: "exclamation",
          className: ai.copyIcon
        }
      ) }),
      /* @__PURE__ */ te.jsx(Xe, { content: `Copy ${r ? r.toLowerCase() : "address"}`, children: /* @__PURE__ */ te.jsx(
        he,
        {
          size: l,
          name: o ? "done" : "copy",
          onClick: () => s(_.join(", ")),
          className: ai.copyIcon
        }
      ) })
    ] })
  ] });
}, uq = "_wrapper_1nher_1", mq = {
  wrapper: uq
}, pq = ({
  customer: e,
  store: n
}) => {
  const { track: r } = jn(), { isCopied: i, copy: a } = vy(), { isCopied: o, copy: s } = vy(), { useQuery: l } = hn(), c = e?.id, {
    loading: m,
    error: u,
    data: f
  } = l(tq, {
    skip: !c,
    variables: {
      customerId: c?.toString()
    }
  }), h = f?.Recharge?.getAddresses, k = !m && h?.addresses?.[0] ? h.addresses[0] : void 0, w = (h?.addresses?.length ?? 0) > 1;
  if (Qe(() => {
    k && r("recharge:profile:received");
  }, [k, r]), u)
    return /* @__PURE__ */ te.jsx($n, { error: u });
  if (!e)
    return null;
  const {
    id: N,
    phone: j,
    email: _,
    first_name: g,
    last_name: O,
    created_at: R,
    has_valid_payment_method: F
  } = e, I = 14, L = n ? `https://${n.identifier}.admin.rechargeapps.com/merchant/customers/${N}` : null, W = `${g || ""} ${O || ""}`.trim() || "A customer has no name";
  return /* @__PURE__ */ te.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ te.jsxs(b, { className: mq.wrapper, gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ te.jsx($.Heading, { variant: "heading-2", children: W }),
    R && /* @__PURE__ */ te.jsxs(b, { gap: "200", justifyContent: "space-between", margin: "0 0 200", children: [
      /* @__PURE__ */ te.jsx($.Paragraph, { variant: "4", children: "Member since" }),
      /* @__PURE__ */ te.jsx($.Paragraph, { variant: "4", children: Gn(R).format(Eg) })
    ] }),
    _ && /* @__PURE__ */ te.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ te.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ te.jsx(he, { size: I, name: "mail" }),
        /* @__PURE__ */ te.jsx($.ExternalLink, { href: `mailto:${_}`, children: _ })
      ] }),
      /* @__PURE__ */ te.jsx(Xe, { content: "Copy email", children: /* @__PURE__ */ te.jsx(
        he,
        {
          size: I,
          name: i ? "done" : "copy",
          onClick: () => a(_),
          className: ai.copyIcon
        }
      ) })
    ] }),
    j && /* @__PURE__ */ te.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ te.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ te.jsx(he, { size: I, name: "phone" }),
        /* @__PURE__ */ te.jsx($.Paragraph, { variant: "4", children: j })
      ] }),
      /* @__PURE__ */ te.jsx(Xe, { content: "Copy phone number", children: /* @__PURE__ */ te.jsx(
        he,
        {
          size: I,
          name: o ? "done" : "copy",
          onClick: () => s(j),
          className: ai.copyIcon
        }
      ) })
    ] }),
    /* @__PURE__ */ te.jsx(
      ky,
      {
        address: k,
        icon: "home",
        isLoading: m,
        hasMultipleAddresses: w
      }
    ),
    /* @__PURE__ */ te.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ te.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ te.jsx(he, { size: I, name: "credit-card" }),
        /* @__PURE__ */ te.jsx($.Paragraph, { variant: "4", children: "Has valid payment method" })
      ] }),
      /* @__PURE__ */ te.jsx(
        he,
        {
          size: I,
          name: F ? "check-circle" : "close-circle-filled",
          color: F ? "green.500" : "red.500"
        }
      )
    ] }),
    L && /* @__PURE__ */ te.jsxs(b, { alignItems: "center", gap: "200", children: [
      /* @__PURE__ */ te.jsx(he, { size: I, name: "external-link" }),
      /* @__PURE__ */ te.jsx(
        $.ExternalLink,
        {
          href: L,
          target: "_blank",
          rel: "noreferrer",
          onClick: () => r("recharge:external:customer:overview:opened"),
          children: "View customer in Recharge"
        }
      )
    ] })
  ] }) });
}, fq = "_order_1dlaa_1", hq = "_orderIsOpen_1dlaa_9", yq = "_orderHeader_1dlaa_12", gq = "_note_1dlaa_16", Rs = {
  order: fq,
  orderIsOpen: hq,
  orderHeader: yq,
  note: gq
}, vq = ({
  order: e,
  isOpenByDefault: n,
  store: r
}) => {
  const { track: i } = jn(), [a, o] = pe(n), {
    id: s,
    status: l,
    charge: c,
    currency: m,
    note: u,
    created_at: f,
    billing_address: h,
    shipping_address: k,
    total_price: w,
    is_prepaid: N
  } = e, j = 14, _ = r ? `https://${r.identifier}.admin.rechargeapps.com/merchant/orders/${s}` : null, g = c?.external_transaction_id?.payment_processor || void 0;
  return /* @__PURE__ */ te.jsxs(
    b,
    {
      className: ct(Rs.order, {
        [Rs.orderIsOpen]: a
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ te.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Rs.orderHeader,
            onClick: () => o(!a),
            children: [
              /* @__PURE__ */ te.jsxs(b, { gap: "100", flexDirection: "column", children: [
                f && /* @__PURE__ */ te.jsx(b, { alignItems: "center", children: /* @__PURE__ */ te.jsx($.Paragraph, { variant: "4", children: Gn(f).format(Eg) }) }),
                /* @__PURE__ */ te.jsxs($.Paragraph, { variant: "1", children: [
                  "Order #",
                  s
                ] })
              ] }),
              /* @__PURE__ */ te.jsx(
                Qt,
                {
                  variant: "tertiary",
                  icon: a ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        a && /* @__PURE__ */ te.jsxs(b, { gap: "250", flexDirection: "column", margin: "200 0 0", children: [
          u && /* @__PURE__ */ te.jsx(Xe, { content: "Note", children: /* @__PURE__ */ te.jsx(
            $.Paragraph,
            {
              variant: "4",
              color: "secondary",
              className: Rs.note,
              children: u
            }
          ) }),
          l && /* @__PURE__ */ te.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ te.jsx(he, { size: j, name: "activity" }),
            /* @__PURE__ */ te.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ te.jsx($.Paragraph, { variant: "3", children: "Status" }),
              /* @__PURE__ */ te.jsx($.Paragraph, { variant: "4", children: Y1(l) })
            ] })
          ] }),
          /* @__PURE__ */ te.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ te.jsx(he, { size: j, name: "credit-card" }),
            /* @__PURE__ */ te.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ te.jsx($.Paragraph, { variant: "3", children: "Prepaid" }),
              /* @__PURE__ */ te.jsx($.Paragraph, { variant: "4", children: N ? "Yes" : "No" })
            ] })
          ] }),
          g && /* @__PURE__ */ te.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ te.jsx(he, { size: j, name: "cog" }),
            /* @__PURE__ */ te.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ te.jsx($.Paragraph, { variant: "3", children: "Payment processor" }),
              /* @__PURE__ */ te.jsx($.Paragraph, { variant: "4", children: g })
            ] })
          ] }),
          /* @__PURE__ */ te.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ te.jsx(he, { size: j, name: "chart-bar" }),
            /* @__PURE__ */ te.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ te.jsx($.Paragraph, { variant: "3", children: "Order value" }),
              /* @__PURE__ */ te.jsxs($.Paragraph, { variant: "4", children: [
                w,
                " ",
                m
              ] })
            ] })
          ] }),
          /* @__PURE__ */ te.jsx(
            ky,
            {
              address: h,
              icon: "home",
              title: "Billing address"
            }
          ),
          /* @__PURE__ */ te.jsx(
            ky,
            {
              address: k,
              icon: "map-pin",
              title: "Shipping address"
            }
          ),
          _ && /* @__PURE__ */ te.jsx(
            It,
            {
              variant: "secondary",
              style: {
                color: "var(--dixa-typography-color-link)",
                padding: "var(--dixa-size-spacer-100)"
              },
              navigate: () => window.open(_, "_blank")?.focus(),
              slotStart: /* @__PURE__ */ te.jsx(he, { name: "external-link" }),
              onClick: () => i("recharge:external:order:opened"),
              children: "View order in Recharge"
            }
          )
        ] })
      ]
    }
  );
}, kq = ({
  customerId: e,
  store: n
}) => {
  const { track: r } = jn(), { useQuery: i } = hn(), {
    loading: a,
    error: o,
    data: s
  } = i(rq, {
    skip: !e,
    variables: {
      customerId: e?.toString(),
      limit: "5"
    }
  }), l = s?.Recharge?.getOrders, c = !a && l?.orders && l.orders.length > 0 ? l.orders : [];
  if (!e)
    return null;
  if (o)
    return /* @__PURE__ */ te.jsx($n, { error: o });
  const m = n ? `https://${n.identifier}.admin.rechargeapps.com/merchant/orders/processed?limit=25` : null;
  return /* @__PURE__ */ te.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ te.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ te.jsx($.Heading, { variant: "heading-3", children: "Customer orders" }),
      !a && /* @__PURE__ */ te.jsx(Pn, { variant: "success", size: "small", children: c.length })
    ] }),
    /* @__PURE__ */ te.jsxs(b, { gap: "200", flexDirection: "column", children: [
      a && /* @__PURE__ */ te.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ te.jsx(mn, {}) }),
      !a && c.length === 0 && /* @__PURE__ */ te.jsx(
        b,
        {
          justifyContent: "center",
          margin: "200 0 300 0",
          "data-testid": "widget-no-orders",
          children: /* @__PURE__ */ te.jsx($.Paragraph, { color: "tertiary", children: "No orders found" })
        }
      ),
      !a && c.length > 0 && /* @__PURE__ */ te.jsx(b, { gap: "200", flexDirection: "column", children: c.map((u, f) => /* @__PURE__ */ te.jsx(
        vq,
        {
          order: u,
          isOpenByDefault: f === 0,
          store: n
        },
        `${f}-${u.id}`
      )) }),
      m && /* @__PURE__ */ te.jsx(
        It,
        {
          variant: "secondary",
          style: {
            color: "var(--dixa-typography-color-link)",
            padding: "var(--dixa-size-spacer-100)"
          },
          navigate: () => window.open(m, "_blank")?.focus(),
          slotStart: /* @__PURE__ */ te.jsx(he, { name: "external-link" }),
          onClick: () => r("recharge:external:orders:list:opened"),
          children: "View all orders in Recharge"
        }
      )
    ] })
  ] });
}, bq = [
  "Too expensive",
  "Quality issues",
  "Switching product",
  "No longer needed",
  "Delivery issues",
  "Other"
], ES = {
  reason: null,
  comments: "",
  sendEmail: !0
}, _q = ({
  subscriptionId: e,
  productTitle: n,
  isOpen: r,
  setIsOpen: i,
  isMutationLoading: a,
  setIsMutationLoading: o,
  refetchSubscriptions: s
}) => {
  const l = ut({
    defaultValues: ES
  }), [c, { reset: m }] = G1({
    mutation: aq,
    getResultTypename: (h) => h.Recharge?.cancelSubscription?.__typename,
    successText: "The subscription got cancelled.",
    failureText: "Could not cancel the subscription.",
    trackingAction: "recharge:subscription:cancelled",
    setIsMutationLoading: o,
    setIsOpen: i,
    refetchSubscriptions: s
  }), u = ft(
    (h) => {
      h.reason != null && (o(!0), c({
        variables: {
          id: e,
          input: {
            cancellation_reason: h.reason,
            cancellation_reason_comments: h.comments || void 0,
            send_email: h.sendEmail
          }
        }
      }));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [e]
  ), f = () => {
    i(!1), m(), l.reset(ES);
  };
  return /* @__PURE__ */ te.jsxs(bt, { isOpen: r, onClose: f, children: [
    /* @__PURE__ */ te.jsx(
      _t,
      {
        title: `Cancel subscription ${n}`,
        onClose: f
      }
    ),
    /* @__PURE__ */ te.jsx(xt, { children: /* @__PURE__ */ te.jsxs(et, { children: [
      /* @__PURE__ */ te.jsx(X, { children: /* @__PURE__ */ te.jsx(
        ur,
        {
          control: l.control,
          label: "Reason",
          name: "reason",
          rules: {
            required: {
              value: !0,
              message: "Please select a reason"
            }
          },
          componentProps: {
            placeholder: "Select a reason",
            equalityFn: (h, k) => h === k,
            getItemTitleByValue: (h) => h ?? ""
          },
          children: bq.map((h) => /* @__PURE__ */ te.jsx(mt.Item, { value: h, children: /* @__PURE__ */ te.jsx($.Paragraph, { children: h }) }, h))
        }
      ) }),
      /* @__PURE__ */ te.jsx(X, { children: /* @__PURE__ */ te.jsx(
        On,
        {
          name: "comments",
          label: "Comments (optional)",
          control: l.control
        }
      ) }),
      /* @__PURE__ */ te.jsx(X, { children: /* @__PURE__ */ te.jsx(He, { label: "Notify the customer by email", children: /* @__PURE__ */ te.jsx(yn, { control: l.control, name: "sendEmail" }) }) })
    ] }) }),
    /* @__PURE__ */ te.jsx(
      wt,
      {
        confirmProps: {
          disabled: !(l.formState.isValid && l.formState.isDirty),
          isLoading: a,
          loadingIndicator: /* @__PURE__ */ te.jsx(mn, { size: 16 })
        },
        confirmOnClick: l.handleSubmit(u),
        cancelOnClick: f,
        confirmName: "Cancel subscription",
        cancelName: "Back"
      }
    )
  ] });
}, xq = ({
  subscriptionId: e,
  productTitle: n,
  refetchSubscriptions: r
}) => {
  const [i, a] = pe(!1), [o, s] = pe(!1);
  return /* @__PURE__ */ te.jsxs(b, { width: "100%", children: [
    /* @__PURE__ */ te.jsx(
      tt,
      {
        variant: "secondary",
        onClick: () => a(!0),
        isLoading: o,
        loadingIndicator: /* @__PURE__ */ te.jsx(mn, { size: 16 }),
        slotStart: /* @__PURE__ */ te.jsx(
          he,
          {
            size: 14,
            name: "close-circle-filled",
            color: "red.500"
          }
        ),
        className: ai.fullWidth,
        children: "Cancel subscription"
      }
    ),
    /* @__PURE__ */ te.jsx(
      _q,
      {
        subscriptionId: e,
        productTitle: n,
        isOpen: i,
        setIsOpen: a,
        isMutationLoading: o,
        setIsMutationLoading: s,
        refetchSubscriptions: r
      }
    )
  ] });
}, Sq = ({
  subscriptionId: e,
  productTitle: n,
  isOpen: r,
  setIsOpen: i,
  isMutationLoading: a,
  setIsMutationLoading: o,
  refetchSubscriptions: s
}) => {
  const [l] = G1({
    mutation: oq,
    getResultTypename: (u) => u.Recharge?.activateSubscription?.__typename,
    successText: "The subscription got reactivated.",
    failureText: "Could not reactivate the subscription.",
    trackingAction: "recharge:subscription:reactivated",
    setIsMutationLoading: o,
    setIsOpen: i,
    refetchSubscriptions: s
  }), c = ft(
    () => {
      o(!0), l({
        variables: {
          id: e
        }
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [e]
  ), m = () => i(!1);
  return /* @__PURE__ */ te.jsxs(bt, { isOpen: r, onClose: m, children: [
    /* @__PURE__ */ te.jsx(
      _t,
      {
        title: `Reactivate subscription ${n}`,
        onClose: m
      }
    ),
    /* @__PURE__ */ te.jsx(xt, { children: /* @__PURE__ */ te.jsx($.Paragraph, { children: "Reactivating resumes this subscription. The customer will be charged again on the regular schedule." }) }),
    /* @__PURE__ */ te.jsx(
      wt,
      {
        confirmProps: {
          isLoading: a,
          loadingIndicator: /* @__PURE__ */ te.jsx(mn, { size: 16 })
        },
        confirmOnClick: c,
        cancelOnClick: m,
        confirmName: "Reactivate subscription",
        cancelName: "Back"
      }
    )
  ] });
}, Nq = ({
  subscriptionId: e,
  productTitle: n,
  refetchSubscriptions: r
}) => {
  const [i, a] = pe(!1), [o, s] = pe(!1);
  return /* @__PURE__ */ te.jsxs(b, { width: "100%", children: [
    /* @__PURE__ */ te.jsx(
      tt,
      {
        variant: "secondary",
        onClick: () => a(!0),
        isLoading: o,
        loadingIndicator: /* @__PURE__ */ te.jsx(mn, { size: 16 }),
        slotStart: /* @__PURE__ */ te.jsx(
          he,
          {
            size: 14,
            name: "check-circle-filled",
            color: "green.500"
          }
        ),
        className: ai.fullWidth,
        children: "Reactivate subscription"
      }
    ),
    /* @__PURE__ */ te.jsx(
      Sq,
      {
        subscriptionId: e,
        productTitle: n,
        isOpen: i,
        setIsOpen: a,
        isMutationLoading: o,
        setIsMutationLoading: s,
        refetchSubscriptions: r
      }
    )
  ] });
}, jq = "_subscription_1xxl7_1", wq = "_subscriptionIsOpen_1xxl7_9", Cq = "_subscriptionHeader_1xxl7_12", Ym = {
  subscription: jq,
  subscriptionIsOpen: wq,
  subscriptionHeader: Cq
}, Fq = "CANCELLED", Iq = ({
  subscription: e,
  isOpenByDefault: n,
  canCancel: r,
  canReactivate: i,
  store: a,
  refetchSubscriptions: o
}) => {
  const { track: s } = jn(), [l, c] = pe(n), {
    id: m,
    status: u,
    product_title: f,
    variant_title: h,
    price: k,
    presentment_currency: w,
    is_prepaid: N,
    next_charge_scheduled_at: j,
    order_interval_frequency: _,
    order_interval_unit: g,
    cancellation_reason: O,
    cancelled_at: R
  } = e, F = 14, I = u?.toUpperCase() === Fq || !!R, L = a && m ? `https://${a.identifier}.admin.rechargeapps.com/merchant/subscriptions/${m}/details` : null, W = _ && g ? `Every ${_} ${g}` : null;
  return /* @__PURE__ */ te.jsxs(
    b,
    {
      className: ct(Ym.subscription, {
        [Ym.subscriptionIsOpen]: l
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ te.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Ym.subscriptionHeader,
            onClick: () => c(!l),
            children: [
              /* @__PURE__ */ te.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ te.jsxs(b, { gap: "200", alignItems: "center", children: [
                  /* @__PURE__ */ te.jsxs($.Paragraph, { variant: "1", children: [
                    "Subscription #",
                    m
                  ] }),
                  I && /* @__PURE__ */ te.jsx(Pn, { variant: "error", size: "small", children: "Cancelled" })
                ] }),
                f && /* @__PURE__ */ te.jsx($.Paragraph, { variant: "4", color: "secondary", children: f })
              ] }),
              /* @__PURE__ */ te.jsx(
                Qt,
                {
                  variant: "tertiary",
                  icon: l ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        l && /* @__PURE__ */ te.jsxs(b, { gap: "250", flexDirection: "column", margin: "200 0 0", children: [
          u && /* @__PURE__ */ te.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ te.jsx(he, { size: F, name: "activity" }),
            /* @__PURE__ */ te.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ te.jsx($.Paragraph, { variant: "3", children: "Status" }),
              /* @__PURE__ */ te.jsx($.Paragraph, { variant: "4", children: Y1(u) })
            ] })
          ] }),
          h && /* @__PURE__ */ te.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ te.jsx(he, { size: F, name: "tag" }),
            /* @__PURE__ */ te.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ te.jsx($.Paragraph, { variant: "3", children: "Variant" }),
              /* @__PURE__ */ te.jsx($.Paragraph, { variant: "4", children: h })
            ] })
          ] }),
          /* @__PURE__ */ te.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ te.jsx(he, { size: F, name: "chart-bar" }),
            /* @__PURE__ */ te.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ te.jsx($.Paragraph, { variant: "3", children: "Price" }),
              /* @__PURE__ */ te.jsxs($.Paragraph, { variant: "4", children: [
                k,
                " ",
                w
              ] })
            ] })
          ] }),
          W && /* @__PURE__ */ te.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ te.jsx(he, { size: F, name: "sync" }),
            /* @__PURE__ */ te.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ te.jsx($.Paragraph, { variant: "3", children: "Frequency" }),
              /* @__PURE__ */ te.jsx($.Paragraph, { variant: "4", children: W })
            ] })
          ] }),
          !I && j && /* @__PURE__ */ te.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ te.jsx(he, { size: F, name: "calendar" }),
            /* @__PURE__ */ te.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ te.jsx($.Paragraph, { variant: "3", children: "Next charge" }),
              /* @__PURE__ */ te.jsx($.Paragraph, { variant: "4", children: Gn(j).format(Eg) })
            ] })
          ] }),
          /* @__PURE__ */ te.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ te.jsx(he, { size: F, name: "credit-card" }),
            /* @__PURE__ */ te.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ te.jsx($.Paragraph, { variant: "3", children: "Prepaid" }),
              /* @__PURE__ */ te.jsx($.Paragraph, { variant: "4", children: N ? "Yes" : "No" })
            ] })
          ] }),
          I && O && /* @__PURE__ */ te.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ te.jsx(he, { size: F, name: "info" }),
            /* @__PURE__ */ te.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ te.jsx($.Paragraph, { variant: "3", children: "Cancellation reason" }),
              /* @__PURE__ */ te.jsx($.Paragraph, { variant: "4", children: O })
            ] })
          ] }),
          r && !I && m && /* @__PURE__ */ te.jsx(
            xq,
            {
              subscriptionId: m,
              productTitle: f ?? `#${m}`,
              refetchSubscriptions: o
            }
          ),
          i && I && m && /* @__PURE__ */ te.jsx(
            Nq,
            {
              subscriptionId: m,
              productTitle: f ?? `#${m}`,
              refetchSubscriptions: o
            }
          ),
          L && /* @__PURE__ */ te.jsx(
            It,
            {
              variant: "secondary",
              style: {
                color: "var(--dixa-typography-color-link)",
                padding: "var(--dixa-size-spacer-100)"
              },
              navigate: () => window.open(L, "_blank")?.focus(),
              slotStart: /* @__PURE__ */ te.jsx(he, { name: "external-link" }),
              onClick: () => s("recharge:external:subscription:opened"),
              children: "View subscription in Recharge"
            }
          )
        ] })
      ]
    }
  );
}, $q = ({
  customerId: e,
  canCancel: n,
  canReactivate: r,
  store: i
}) => {
  const { track: a } = jn(), { useQuery: o } = hn(), {
    loading: s,
    error: l,
    data: c,
    refetch: m
  } = o(iq, {
    skip: !e,
    variables: {
      customerId: e?.toString(),
      limit: "10"
    }
  }), u = c?.Recharge?.getSubscriptions, f = !s && u?.subscriptions && u.subscriptions.length > 0 ? u.subscriptions : [];
  if (!e)
    return null;
  if (l)
    return /* @__PURE__ */ te.jsx($n, { error: l });
  const h = i ? `https://${i.identifier}.admin.rechargeapps.com/merchant/subscriptions` : null;
  return /* @__PURE__ */ te.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ te.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ te.jsx($.Heading, { variant: "heading-3", children: "Subscriptions" }),
      !s && /* @__PURE__ */ te.jsx(Pn, { variant: "success", size: "small", children: f.length })
    ] }),
    /* @__PURE__ */ te.jsxs(b, { gap: "200", flexDirection: "column", children: [
      s && /* @__PURE__ */ te.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ te.jsx(mn, {}) }),
      !s && f.length === 0 && /* @__PURE__ */ te.jsx(
        b,
        {
          justifyContent: "center",
          margin: "200 0 300 0",
          "data-testid": "widget-no-subscriptions",
          children: /* @__PURE__ */ te.jsx($.Paragraph, { color: "tertiary", children: "No subscriptions found" })
        }
      ),
      !s && f.length > 0 && /* @__PURE__ */ te.jsx(b, { gap: "200", flexDirection: "column", children: f.map((k, w) => /* @__PURE__ */ te.jsx(
        Iq,
        {
          subscription: k,
          isOpenByDefault: w === 0,
          canCancel: n,
          canReactivate: r,
          store: i,
          refetchSubscriptions: m
        },
        `${w}-${k.id}`
      )) }),
      h && /* @__PURE__ */ te.jsx(
        It,
        {
          variant: "secondary",
          style: {
            color: "var(--dixa-typography-color-link)",
            padding: "var(--dixa-size-spacer-100)"
          },
          navigate: () => window.open(h, "_blank")?.focus(),
          slotStart: /* @__PURE__ */ te.jsx(he, { name: "external-link" }),
          onClick: () => a("recharge:external:subscriptions:list:opened"),
          children: "View all subscriptions in Recharge"
        }
      )
    ] })
  ] });
}, Eq = ({
  customer: e
}) => {
  if (!e)
    return null;
  const {
    subscriptions_active_count: n,
    subscriptions_total_count: r
  } = e, i = r ?? 0, a = n ?? 0;
  return /* @__PURE__ */ te.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ te.jsx($.Heading, { variant: "heading-3", children: "Subscriptions overview" }),
    /* @__PURE__ */ te.jsxs(Ye, { className: ai.list, children: [
      /* @__PURE__ */ te.jsx(Ye.Text, { variant: "dense", className: ai.listItem, children: /* @__PURE__ */ te.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ te.jsx($.Paragraph, { variant: "4", children: "Total subscriptions" }),
        /* @__PURE__ */ te.jsx($.Paragraph, { variant: "4", children: i })
      ] }) }),
      /* @__PURE__ */ te.jsx(Ye.Text, { variant: "dense", className: ai.listItem, children: /* @__PURE__ */ te.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ te.jsx($.Paragraph, { variant: "4", children: "Active subscriptions" }),
        /* @__PURE__ */ te.jsx($.Paragraph, { variant: "4", children: a })
      ] }) })
    ] })
  ] });
}, Tq = ({
  conversationContext: e,
  settings: n
}) => {
  const { useQuery: r } = hn(), i = e?.customer?.email, a = n.displayCustomerDetails ?? !1, o = n.displaysubscriptionOverview ?? !1, s = n.displaySubscriptions ?? !1, l = n.enableCancelSubscription ?? !1, c = n.enableReactivateSubscription ?? !1, m = n.displayOrders ?? !1, u = !a && !o && !s && !m, {
    loading: f,
    error: h,
    data: k
  } = r(nq, {
    skip: !i,
    variables: {
      email: i
    }
  }), w = !f && k ? k?.Recharge?.getCustomers?.customers?.[0] : void 0, N = !f && k ? k?.Recharge?.getStore?.store ?? void 0 : void 0;
  if (h) {
    const j = h.graphQLErrors;
    return Ul({ errors: j }) ? /* @__PURE__ */ te.jsx(
      $.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        "data-testid": "widget-downstream-api-forbidden-error",
        children: "The token used for the integration does not have the necessary access rights. Please contact your administrator."
      }
    ) : Ml({ errors: j }) ? /* @__PURE__ */ te.jsx(
      $.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        "data-testid": "widget-downstream-api-authorization-error",
        children: "The integration could not authorize against Recharge. Please contact your administrator."
      }
    ) : /* @__PURE__ */ te.jsx($n, { error: h });
  }
  return f ? /* @__PURE__ */ te.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ te.jsx(mn, {}) }) : w ? u ? /* @__PURE__ */ te.jsx(
    $.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      align: "center",
      "data-testid": "widget-no-features",
      children: "All features toggles in the settings are disabled."
    }
  ) : /* @__PURE__ */ te.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        a && /* @__PURE__ */ te.jsx(pq, { customer: w, store: N }),
        o && /* @__PURE__ */ te.jsx(Eq, { customer: w }),
        s && /* @__PURE__ */ te.jsx(
          $q,
          {
            customerId: w.id,
            canCancel: l,
            canReactivate: c,
            store: N
          }
        ),
        m && /* @__PURE__ */ te.jsx(kq, { customerId: w.id, store: N })
      ]
    }
  ) : /* @__PURE__ */ te.jsx(
    $.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      align: "center",
      "data-testid": "widget-customer-not-found",
      children: "No data found for this customer in Recharge."
    }
  );
}, Tl = [
  {
    key: "rechargeAccessToken",
    label: "API token",
    type: "string",
    secret: !0,
    defaultValue: ""
  },
  {
    key: "displayCustomerDetails",
    label: "Displays details of a customer",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displaysubscriptionOverview",
    label: "Displays the subscription overview",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displaySubscriptions",
    label: "Displays the list of subscriptions",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "enableCancelSubscription",
    label: "Allows agents to cancel a subscription",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "enableReactivateSubscription",
    label: "Allows agents to reactivate a cancelled subscription",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayOrders",
    label: "Displays the last 5 orders",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  }
], Ii = ir(Tl), Rq = {
  enabled: !1,
  name: "",
  rechargeAccessToken: "",
  displayCustomerDetails: !0,
  displaysubscriptionOverview: !0,
  displaySubscriptions: !0,
  enableCancelSubscription: !0,
  enableReactivateSubscription: !0,
  displayOrders: !0
}, Dq = ({
  integrationId: e,
  handleRedirect: n,
  showNotification: r,
  automationCouplingState: i,
  renderConditionsEditor: a
}) => {
  const o = !e, s = ut({
    mode: "onChange",
    defaultValues: Rq
  }), {
    create: l,
    update: c,
    remove: m,
    isLoading: u,
    error: f,
    misconfigurationCause: h,
    setMisconfigurationCause: k
  } = mr({
    integrationId: e,
    integrationType: "RECHARGE",
    handleRedirect: n,
    showNotification: r
  }), {
    isLoading: w,
    error: N,
    isWidgetUnknown: j,
    refetch: _,
    widgetConfiguration: g
  } = pr({
    integrationId: e,
    fieldDefinitions: Tl,
    form: s,
    onMisconfigured: k
  }), { renderConditions: O, setRenderConditions: R, renderConditionsForSubmit: F } = fr({
    integrationId: e,
    widgetConfiguration: g,
    renderConditionsEditor: a
  }), I = (W) => yr(W, {
    fieldDefinitions: Tl,
    isCreationMode: o,
    create: l,
    update: c,
    renderConditions: F
  }), L = s.watch("name");
  return /* @__PURE__ */ te.jsxs(
    hr,
    {
      form: s,
      integrationId: e,
      onValidSubmit: I,
      error: N ?? f,
      onRetry: N ? _ : void 0,
      isLoading: u || w,
      isWidgetUnknown: j,
      children: [
        h && /* @__PURE__ */ te.jsx(gr, { cause: h }),
        /* @__PURE__ */ te.jsxs(et, { children: [
          /* @__PURE__ */ te.jsx(X, { children: /* @__PURE__ */ te.jsx(He, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ te.jsx(
            yn,
            {
              name: "enabled",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ te.jsx(X, { span: 3, children: /* @__PURE__ */ te.jsx(
            On,
            {
              name: "name",
              label: "Widget name",
              control: s.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ te.jsx(X, { span: 3 }),
          /* @__PURE__ */ te.jsx(X, { span: 3, children: /* @__PURE__ */ te.jsx(
            $r,
            {
              name: "rechargeAccessToken",
              label: Ii.rechargeAccessToken,
              control: s.control,
              isCreationMode: o,
              rules: { required: "API token is required" },
              componentProps: {
                placeholder: "Insert the Admin API token for Recharge",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ te.jsx(X, { span: 3 }),
          /* @__PURE__ */ te.jsx(X, { span: 3, children: /* @__PURE__ */ te.jsx(He, { label: Ii.displayCustomerDetails, children: /* @__PURE__ */ te.jsx(
            yn,
            {
              name: "displayCustomerDetails",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ te.jsx(X, { span: 3 }),
          /* @__PURE__ */ te.jsx(X, { span: 3, children: /* @__PURE__ */ te.jsx(He, { label: Ii.displaysubscriptionOverview, children: /* @__PURE__ */ te.jsx(
            yn,
            {
              name: "displaysubscriptionOverview",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ te.jsx(X, { span: 3 }),
          /* @__PURE__ */ te.jsx(X, { span: 3, children: /* @__PURE__ */ te.jsx(He, { label: Ii.displaySubscriptions, children: /* @__PURE__ */ te.jsx(
            yn,
            {
              name: "displaySubscriptions",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ te.jsx(X, { span: 3 }),
          /* @__PURE__ */ te.jsx(X, { span: 3, children: /* @__PURE__ */ te.jsx(He, { label: Ii.enableCancelSubscription, children: /* @__PURE__ */ te.jsx(
            yn,
            {
              name: "enableCancelSubscription",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ te.jsx(X, { span: 3 }),
          /* @__PURE__ */ te.jsx(X, { span: 3, children: /* @__PURE__ */ te.jsx(He, { label: Ii.enableReactivateSubscription, children: /* @__PURE__ */ te.jsx(
            yn,
            {
              name: "enableReactivateSubscription",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ te.jsx(X, { span: 3 }),
          /* @__PURE__ */ te.jsx(X, { span: 3, children: /* @__PURE__ */ te.jsx(He, { label: Ii.displayOrders, children: /* @__PURE__ */ te.jsx(
            yn,
            {
              name: "displayOrders",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ te.jsx(X, { span: 3 }),
          a && O !== null && /* @__PURE__ */ te.jsx(X, { children: a({
            value: O,
            onChange: R,
            configurationKey: g?.id
          }) })
        ] }),
        /* @__PURE__ */ te.jsx(
          vr,
          {
            integrationType: "RECHARGE",
            integrationId: e,
            widgetName: L,
            isCreationMode: o,
            isSubmitting: s.formState.isSubmitting,
            automationCouplingState: i,
            onConfirmDelete: () => m()
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode('@charset "UTF-8";._wrapper_l5y5y_54{gap:var(--dixa-size-spacer-250);margin-bottom:var(--dixa-size-spacer-300)}._inputWrapper_l5y5y_59{background-color:var(--dixa-color-neutral-100);border-radius:var(--dixa-size-border-radius-100);margin:var(--dixa-size-spacer-300) 0;gap:var(--dixa-size-spacer-250);padding:var(--dixa-size-spacer-300)}._inputField_l5y5y_67{text-align:center}._inputSeparator_l5y5y_71{color:var(--dixa-color-neutral-600);text-align:center}._buttonLink_l5y5y_76{color:var(--dixa-typography-color-link)}._noIssuesFound_l5y5y_80{color:var(--dixa-color-neutral-400);font-size:var(--dixa-typography-size-200)}._list_l5y5y_85{padding:0;overflow-y:auto;max-height:230px;background:linear-gradient(var(--dixa-color-neutral-000) 33%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),var(--dixa-color-neutral-000) 66%) 0 100%,radial-gradient(farthest-side at 50% 0,var(--dixa-color-neutral-200),rgba(0,0,0,0)),radial-gradient(farthest-side at 50% 100%,var(--dixa-color-neutral-200),rgba(0,0,0,0)) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-200),100% var(--dixa-size-spacer-200)}._listItem_l5y5y_95{background-color:transparent;padding:var(--dixa-size-spacer-100);box-shadow:inset 0 calc(-1 * var(--dixa-size-border-100)) 0 var(--dixa-color-neutral-200)}._listItem_l5y5y_95:last-child{box-shadow:none}._listItemHighlighted_l5y5y_103{border-left:var(--dixa-size-spacer-200) solid var(--dixa-color-orange-300)}._listItemEdit_l5y5y_106{cursor:pointer}._fullWidth_l5y5y_110{width:100%}._boxWrapper_l5y5y_114{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._clickableIcon_l5y5y_120{cursor:pointer;color:var(--dixa-typography-color-secondary)}._wrapper_1xucg_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._externalLink_1xucg_7{color:var(--dixa-typography-color-primary);font-size:var(--dixa-typography-size-200)}._list_rxh85_1{padding:0;overflow-y:auto;max-height:230px}._listItem_rxh85_6{cursor:pointer;font-size:var(--dixa-typography-size-100);background-color:transparent;padding:var(--dixa-size-spacer-200) var(--dixa-size-spacer-100);box-shadow:inset 0 calc(-1 * var(--dixa-size-border-100)) 0 var(--dixa-color-neutral-200)}._listItem_rxh85_6:last-child{box-shadow:none}._listItemHighlighted_rxh85_16{border-left:var(--dixa-size-spacer-200) solid var(--dixa-color-orange-300)}._modalBody_1clhs_1{width:400px}._reward_1gmba_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._reward_1gmba_1:hover{border-color:var(--dixa-color-neutral-400)}._clickable_1gmba_10{cursor:pointer}._voucherCode_1gmba_14{font-family:monospace}')), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Jm = { exports: {} }, go = {}, TS;
function Oq() {
  if (TS) return go;
  TS = 1;
  var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, c, m) {
    var u, f = {}, h = null, k = null;
    m !== void 0 && (h = "" + m), c.key !== void 0 && (h = "" + c.key), c.ref !== void 0 && (k = c.ref);
    for (u in c) i.call(c, u) && !o.hasOwnProperty(u) && (f[u] = c[u]);
    if (l && l.defaultProps) for (u in c = l.defaultProps, c) f[u] === void 0 && (f[u] = c[u]);
    return { $$typeof: n, type: l, key: h, ref: k, props: f, _owner: a.current };
  }
  return go.Fragment = r, go.jsx = s, go.jsxs = s, go;
}
var Ds = {}, RS;
function Pq() {
  return RS || (RS = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), c = /* @__PURE__ */ Symbol.for("react.forward_ref"), m = /* @__PURE__ */ Symbol.for("react.suspense"), u = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), k = /* @__PURE__ */ Symbol.for("react.offscreen"), w = Symbol.iterator, N = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var d = w && t[w] || t[N];
      return typeof d == "function" ? d : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var d = arguments.length, p = new Array(d > 1 ? d - 1 : 0), y = 1; y < d; y++)
          p[y - 1] = arguments[y];
        O("error", t, p);
      }
    }
    function O(t, d, p) {
      {
        var y = _.ReactDebugCurrentFrame, C = y.getStackAddendum();
        C !== "" && (d += "%s", p = p.concat([C]));
        var T = p.map(function(S) {
          return String(S);
        });
        T.unshift("Warning: " + d), Function.prototype.apply.call(console[t], console, T);
      }
    }
    var R = !1, F = !1, I = !1, L = !1, W = !1, J;
    J = /* @__PURE__ */ Symbol.for("react.module.reference");
    function re(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || W || t === a || t === m || t === u || L || t === k || R || F || I || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === J || t.getModuleId !== void 0));
    }
    function K(t, d, p) {
      var y = t.displayName;
      if (y)
        return y;
      var C = d.displayName || d.name || "";
      return C !== "" ? p + "(" + C + ")" : p;
    }
    function Y(t) {
      return t.displayName || "Context";
    }
    function P(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var d = t;
            return Y(d) + ".Consumer";
          case s:
            var p = t;
            return Y(p._context) + ".Provider";
          case c:
            return K(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : P(t.type) || "Memo";
          case h: {
            var C = t, T = C._payload, S = C._init;
            try {
              return P(S(T));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, ie = 0, we, me, le, ge, V, be, Oe;
    function q() {
    }
    q.__reactDisabledLog = !0;
    function Ge() {
      {
        if (ie === 0) {
          we = console.log, me = console.info, le = console.warn, ge = console.error, V = console.group, be = console.groupCollapsed, Oe = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: q,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ie++;
      }
    }
    function sn() {
      {
        if (ie--, ie === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, t, {
              value: we
            }),
            info: B({}, t, {
              value: me
            }),
            warn: B({}, t, {
              value: le
            }),
            error: B({}, t, {
              value: ge
            }),
            group: B({}, t, {
              value: V
            }),
            groupCollapsed: B({}, t, {
              value: be
            }),
            groupEnd: B({}, t, {
              value: Oe
            })
          });
        }
        ie < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ie = _.ReactCurrentDispatcher, Ue;
    function De(t, d, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (C) {
            var y = C.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Ae;
    {
      var Je = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Je();
    }
    function Ee(t, d) {
      if (!t || Be)
        return "";
      {
        var p = Ae.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Be = !0;
      var C = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var T;
      T = Ie.current, Ie.current = null, Ge();
      try {
        if (d) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (ne) {
              y = ne;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (ne) {
              y = ne;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            y = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && y && typeof ne.stack == "string") {
          for (var x = ne.stack.split(`
`), Z = y.stack.split(`
`), A = x.length - 1, M = Z.length - 1; A >= 1 && M >= 0 && x[A] !== Z[M]; )
            M--;
          for (; A >= 1 && M >= 0; A--, M--)
            if (x[A] !== Z[M]) {
              if (A !== 1 || M !== 1)
                do
                  if (A--, M--, M < 0 || x[A] !== Z[M]) {
                    var ue = `
` + x[A].replace(" at new ", " at ");
                    return t.displayName && ue.includes("<anonymous>") && (ue = ue.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, ue), ue;
                  }
                while (A >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Ie.current = T, sn(), Error.prepareStackTrace = C;
      }
      var ze = t ? t.displayName || t.name : "", Te = ze ? De(ze) : "";
      return typeof t == "function" && Ae.set(t, Te), Te;
    }
    function Me(t, d, p) {
      return Ee(t, !1);
    }
    function en(t) {
      var d = t.prototype;
      return !!(d && d.isReactComponent);
    }
    function se(t, d, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ee(t, en(t));
      if (typeof t == "string")
        return De(t);
      switch (t) {
        case m:
          return De("Suspense");
        case u:
          return De("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case c:
            return Me(t.render);
          case f:
            return se(t.type, d, p);
          case h: {
            var y = t, C = y._payload, T = y._init;
            try {
              return se(T(C), d, p);
            } catch {
            }
          }
        }
      return "";
    }
    var de = Object.prototype.hasOwnProperty, Se = {}, Ve = _.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var d = t._owner, p = se(t.type, t._source, d ? d.type : null);
        Ve.setExtraStackFrame(p);
      } else
        Ve.setExtraStackFrame(null);
    }
    function kn(t, d, p, y, C) {
      {
        var T = Function.call.bind(de);
        for (var S in t)
          if (T(t, S)) {
            var x = void 0;
            try {
              if (typeof t[S] != "function") {
                var Z = Error((y || "React class") + ": " + p + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Z.name = "Invariant Violation", Z;
              }
              x = t[S](d, S, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (A) {
              x = A;
            }
            x && !(x instanceof Error) && (Pe(C), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, S, typeof x), Pe(null)), x instanceof Error && !(x.message in Se) && (Se[x.message] = !0, Pe(C), g("Failed %s type: %s", p, x.message), Pe(null));
          }
      }
    }
    var Q = Array.isArray;
    function E(t) {
      return Q(t);
    }
    function z(t) {
      {
        var d = typeof Symbol == "function" && Symbol.toStringTag, p = d && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function ae(t) {
      try {
        return ce(t), !1;
      } catch {
        return !0;
      }
    }
    function ce(t) {
      return "" + t;
    }
    function U(t) {
      if (ae(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", z(t)), ce(t);
    }
    var G = _.ReactCurrentOwner, ve = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, je, Re;
    function rn(t) {
      if (de.call(t, "ref")) {
        var d = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (d && d.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function bn(t) {
      if (de.call(t, "key")) {
        var d = Object.getOwnPropertyDescriptor(t, "key").get;
        if (d && d.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function an(t, d) {
      typeof t.ref == "string" && G.current;
    }
    function fn(t, d) {
      {
        var p = function() {
          je || (je = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", d));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function En(t, d) {
      {
        var p = function() {
          Re || (Re = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", d));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var _n = function(t, d, p, y, C, T, S) {
      var x = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: d,
        ref: p,
        props: S,
        // Record the component responsible for creating this element.
        _owner: T
      };
      return x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(x, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(x, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: C
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    };
    function Fn(t, d, p, y, C) {
      {
        var T, S = {}, x = null, Z = null;
        p !== void 0 && (U(p), x = "" + p), bn(d) && (U(d.key), x = "" + d.key), rn(d) && (Z = d.ref, an(d));
        for (T in d)
          de.call(d, T) && !ve.hasOwnProperty(T) && (S[T] = d[T]);
        if (t && t.defaultProps) {
          var A = t.defaultProps;
          for (T in A)
            S[T] === void 0 && (S[T] = A[T]);
        }
        if (x || Z) {
          var M = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          x && fn(S, M), Z && En(S, M);
        }
        return _n(t, x, Z, C, y, G.current, S);
      }
    }
    var Ze = _.ReactCurrentOwner, gn = _.ReactDebugCurrentFrame;
    function Le(t) {
      if (t) {
        var d = t._owner, p = se(t.type, t._source, d ? d.type : null);
        gn.setExtraStackFrame(p);
      } else
        gn.setExtraStackFrame(null);
    }
    var dn;
    dn = !1;
    function cn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function Nn() {
      {
        if (Ze.current) {
          var t = P(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Bn(t) {
      return "";
    }
    var Sn = {};
    function An(t) {
      {
        var d = Nn();
        if (!d) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (d = `

Check the top-level render call using <` + p + ">.");
        }
        return d;
      }
    }
    function vn(t, d) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = An(d);
        if (Sn[p])
          return;
        Sn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Ze.current && (y = " It was passed a child from " + P(t._owner.type) + "."), Le(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Le(null);
      }
    }
    function xn(t, d) {
      {
        if (typeof t != "object")
          return;
        if (E(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            cn(y) && vn(y, d);
          }
        else if (cn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var C = j(t);
          if (typeof C == "function" && C !== t.entries)
            for (var T = C.call(t), S; !(S = T.next()).done; )
              cn(S.value) && vn(S.value, d);
        }
      }
    }
    function Ln(t) {
      {
        var d = t.type;
        if (d == null || typeof d == "string")
          return;
        var p;
        if (typeof d == "function")
          p = d.propTypes;
        else if (typeof d == "object" && (d.$$typeof === c || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        d.$$typeof === f))
          p = d.propTypes;
        else
          return;
        if (p) {
          var y = P(d);
          kn(p, t.props, "prop", y, t);
        } else if (d.PropTypes !== void 0 && !dn) {
          dn = !0;
          var C = P(d);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", C || "Unknown");
        }
        typeof d.getDefaultProps == "function" && !d.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var d = Object.keys(t.props), p = 0; p < d.length; p++) {
          var y = d[p];
          if (y !== "children" && y !== "key") {
            Le(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Le(null);
            break;
          }
        }
        t.ref !== null && (Le(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Le(null));
      }
    }
    var Cn = {};
    function wn(t, d, p, y, C, T) {
      {
        var S = re(t);
        if (!S) {
          var x = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (x += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Z = Bn();
          Z ? x += Z : x += Nn();
          var A;
          t === null ? A = "null" : E(t) ? A = "array" : t !== void 0 && t.$$typeof === n ? (A = "<" + (P(t.type) || "Unknown") + " />", x = " Did you accidentally export a JSX literal instead of a component?") : A = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", A, x);
        }
        var M = Fn(t, d, p, C, T);
        if (M == null)
          return M;
        if (S) {
          var ue = d.children;
          if (ue !== void 0)
            if (y)
              if (E(ue)) {
                for (var ze = 0; ze < ue.length; ze++)
                  xn(ue[ze], t);
                Object.freeze && Object.freeze(ue);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              xn(ue, t);
        }
        if (de.call(d, "key")) {
          var Te = P(t), ne = Object.keys(d).filter(function(Kn) {
            return Kn !== "key";
          }), un = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Cn[Te + un]) {
            var Rn = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, un, Te, Rn, Te), Cn[Te + un] = !0;
          }
        }
        return t === i ? Vn(M) : Ln(M), M;
      }
    }
    function zn(t, d, p) {
      return wn(t, d, p, !0);
    }
    function qn(t, d, p) {
      return wn(t, d, p, !1);
    }
    var Un = qn, Wn = zn;
    Ds.Fragment = i, Ds.jsx = Un, Ds.jsxs = Wn;
  })()), Ds;
}
var DS;
function Aq() {
  return DS || (DS = 1, process.env.NODE_ENV === "production" ? Jm.exports = Oq() : Jm.exports = Pq()), Jm.exports;
}
var _e = Aq(), J1 = /* @__PURE__ */ ((e) => (e.CustomAction = "custom_action", e.FacebookLike = "facebook_like", e.FacebookShare = "facebook_share", e.InstagramFollow = "instagram_follow", e.Manual = "manual", e.ReferralComplete = "referral_complete", e.TiktokFollow = "tiktok_follow", e.TwitterFollow = "twitter_follow", e.TwitterShare = "twitter_share", e.VisitUrl = "visit_url", e))(J1 || {}), ka = /* @__PURE__ */ ((e) => (e.Excluded = "excluded", e.Guest = "guest", e.Member = "member", e))(ka || {});
const Lq = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "adjustCustomerPoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NamedType", name: { kind: "Name", value: "RivoLoyalty_adjust_customer_points_request_Input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "RivoLoyalty" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "adjust_customer_points" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }] }] } }] } }] }, Vq = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomer" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "RivoLoyalty" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "return_customer" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "customer_identifier" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }, { kind: "Argument", name: { kind: "Name", value: "fields" }, value: { kind: "StringValue", value: "lifetime_earnings_tally,next_vip_tier", block: !1 } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "accepts_marketing" } }, { kind: "Field", name: { kind: "Name", value: "orders_count" } }, { kind: "Field", name: { kind: "Name", value: "verified_email" } }, { kind: "Field", name: { kind: "Name", value: "total_spent" } }, { kind: "Field", name: { kind: "Name", value: "loyalty_status" } }, { kind: "Field", name: { kind: "Name", value: "points_tally" } }, { kind: "Field", name: { kind: "Name", value: "credits_tally" } }, { kind: "Field", name: { kind: "Name", value: "vip_tier" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "threshold" } }] } }, { kind: "Field", name: { kind: "Name", value: "points_expire_at" } }, { kind: "Field", name: { kind: "Name", value: "next_vip_tier" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "threshold" } }, { kind: "Field", name: { kind: "Name", value: "to_spend_or_earn" } }] } }, { kind: "Field", name: { kind: "Name", value: "lifetime_earnings_tally" } }] } }] } }] } }] } }] } }] }, zq = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getFavoriteProducts" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "RivoLoyalty" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "list_customer_favorite_products" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "customer_id" }, value: { kind: "Variable", name: { kind: "Name", value: "customerId" } } }, { kind: "Argument", name: { kind: "Name", value: "data_source" }, value: { kind: "EnumValue", value: "shopify" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "product_id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "handle" } }] } }] } }] } }] } }] }, Uq = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getPointsRedemptions" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "RivoLoyalty" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "list_points_redemptions" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filters_LEFT_SQUARE_BRACE_customer_identifier_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "customerId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "points_amount" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "expires_at" } }, { kind: "Field", name: { kind: "Name", value: "used_at" } }, { kind: "Field", name: { kind: "Name", value: "refunded_at" } }, { kind: "Field", name: { kind: "Name", value: "revoked_at" } }] } }] } }] } }] } }] } }] }, Mq = {
  "\n  mutation adjustCustomerPoints(\n    $input: RivoLoyalty_adjust_customer_points_request_Input\n  ) {\n    RivoLoyalty {\n      adjust_customer_points(input: $input)\n    }\n  }\n": Lq,
  '\n  query getCustomer($email: String!) {\n    RivoLoyalty {\n      return_customer(\n        customer_identifier: $email\n        fields: "lifetime_earnings_tally,next_vip_tier"\n      ) {\n        data {\n          attributes {\n            id\n            email\n            first_name\n            last_name\n            accepts_marketing\n            orders_count\n            verified_email\n            total_spent\n            loyalty_status\n            points_tally\n            credits_tally\n            vip_tier {\n              name\n              threshold\n            }\n            points_expire_at\n            next_vip_tier {\n              name\n              threshold\n              to_spend_or_earn\n            }\n            lifetime_earnings_tally\n          }\n        }\n      }\n    }\n  }\n': Vq,
  "\n  query getFavoriteProducts($customerId: String!) {\n    RivoLoyalty {\n      list_customer_favorite_products(\n        customer_id: $customerId\n        data_source: shopify\n      ) {\n        data {\n          product_id\n          title\n          handle\n        }\n      }\n    }\n  }\n": zq,
  "\n  query getPointsRedemptions($customerId: String!) {\n    RivoLoyalty {\n      list_points_redemptions(\n        filters_LEFT_SQUARE_BRACE_customer_identifier_RIGHT_SQUARE_BRACE_: $customerId\n      ) {\n        data {\n          id\n          attributes {\n            points_amount\n            name\n            code\n            expires_at\n            used_at\n            refunded_at\n            revoked_at\n          }\n        }\n      }\n    }\n  }\n": Uq
};
function dd(e) {
  return Mq[e] ?? {};
}
const Bq = dd(
  /* GraphQL */
  `
  query getCustomer($email: String!) {
    RivoLoyalty {
      return_customer(
        customer_identifier: $email
        fields: "lifetime_earnings_tally,next_vip_tier"
      ) {
        data {
          attributes {
            id
            email
            first_name
            last_name
            accepts_marketing
            orders_count
            verified_email
            total_spent
            loyalty_status
            points_tally
            credits_tally
            vip_tier {
              name
              threshold
            }
            points_expire_at
            next_vip_tier {
              name
              threshold
              to_spend_or_earn
            }
            lifetime_earnings_tally
          }
        }
      }
    }
  }
`
), qq = dd(
  /* GraphQL */
  `
  query getFavoriteProducts($customerId: String!) {
    RivoLoyalty {
      list_customer_favorite_products(
        customer_id: $customerId
        data_source: shopify
      ) {
        data {
          product_id
          title
          handle
        }
      }
    }
  }
`
), Hq = dd(
  /* GraphQL */
  `
  query getPointsRedemptions($customerId: String!) {
    RivoLoyalty {
      list_points_redemptions(
        filters_LEFT_SQUARE_BRACE_customer_identifier_RIGHT_SQUARE_BRACE_: $customerId
      ) {
        data {
          id
          attributes {
            points_amount
            name
            code
            expires_at
            used_at
            refunded_at
            revoked_at
          }
        }
      }
    }
  }
`
), Wq = dd(
  /* GraphQL */
  `
  mutation adjustCustomerPoints(
    $input: RivoLoyalty_adjust_customer_points_request_Input
  ) {
    RivoLoyalty {
      adjust_customer_points(input: $input)
    }
  }
`
), Kq = "_list_l5y5y_85", Gq = "_listItem_l5y5y_95", Yq = "_listItemHighlighted_l5y5y_103", Jq = "_listItemEdit_l5y5y_106", Qq = "_clickableIcon_l5y5y_120", Cr = {
  list: Kq,
  listItem: Gq,
  listItemHighlighted: Yq,
  listItemEdit: Jq,
  clickableIcon: Qq
}, cd = "rivoLoyaltyShopifyApiHostName", Q1 = "https://admin.shopify.com";
function X1(e) {
  return e.split(".")[0];
}
const Xq = "_wrapper_1xucg_1", OS = {
  wrapper: Xq
}, Zq = ({
  customerDetails: e,
  rivoLoyaltyShopifyApiHostName: n
}) => {
  const { track: r } = jn(), { isCopied: i, copy: a } = Jt(), { attributes: o } = e, {
    first_name: s,
    last_name: l,
    email: c,
    verified_email: m
  } = o, u = 14, f = `${s || ""} ${l || ""}`.trim() || "No name found for customer";
  return /* @__PURE__ */ _e.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ _e.jsxs(b, { className: OS.wrapper, gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ _e.jsx(
      b,
      {
        justifyContent: "space-between",
        className: OS.block,
        alignItems: "center",
        children: /* @__PURE__ */ _e.jsx($.Heading, { variant: "heading-2", children: f })
      }
    ),
    c && /* @__PURE__ */ _e.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
      /* @__PURE__ */ _e.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ _e.jsx(he, { size: u, name: "mail" }),
        /* @__PURE__ */ _e.jsx($.ExternalLink, { href: `mailto:${c}`, children: c }),
        /* @__PURE__ */ _e.jsx(
          Xe,
          {
            content: m ? "Verified email" : "Email is not verified",
            children: /* @__PURE__ */ _e.jsx(b, { alignItems: "center", children: /* @__PURE__ */ _e.jsx(
              he,
              {
                size: u,
                color: m ? "green.500" : "red.500",
                name: m ? "check-circle" : "exclamation"
              }
            ) })
          }
        )
      ] }),
      /* @__PURE__ */ _e.jsx(Xe, { content: "Copy Email", children: /* @__PURE__ */ _e.jsx(
        he,
        {
          size: u,
          name: i ? "done" : "copy",
          onClick: () => a(c),
          className: Cr.clickableIcon
        }
      ) })
    ] }),
    /* @__PURE__ */ _e.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ _e.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ _e.jsx(he, { size: u, name: "sign-in" }),
        /* @__PURE__ */ _e.jsx($.Paragraph, { variant: "2", children: "Marketing consent" })
      ] }),
      /* @__PURE__ */ _e.jsx(
        he,
        {
          name: o.accepts_marketing ? "check-circle-filled" : "close-circle-filled",
          color: o.accepts_marketing ? "green.500" : "neutral.500"
        }
      )
    ] }),
    /* @__PURE__ */ _e.jsxs(b, { alignItems: "center", gap: "200", children: [
      /* @__PURE__ */ _e.jsx(he, { size: u, name: "external-link" }),
      /* @__PURE__ */ _e.jsx(
        $.ExternalLink,
        {
          href: e6(n, o.id),
          target: "_blank",
          rel: "noreferrer",
          onClick: () => {
            r("rivoloyalty:customer:clicked", {});
          },
          children: "View customer in Rivo Loyalty"
        }
      )
    ] })
  ] }) });
};
function e6(e, n) {
  const r = X1(e);
  return `${Q1}/store/${r}/apps/rivo-loyalty/customers/${n}`;
}
const n6 = "_list_rxh85_1", t6 = "_listItem_rxh85_6", PS = {
  list: n6,
  listItem: t6
}, r6 = ({
  customerId: e,
  rivoLoyaltyShopifyApiHostName: n
}) => {
  const { useQuery: r } = hn(), {
    loading: i,
    error: a,
    data: o
  } = r(qq, {
    skip: !e,
    variables: {
      customerId: e?.toString()
    }
  }), s = !i && o ? o.RivoLoyalty?.list_customer_favorite_products?.data ?? [] : [], l = 14, c = () => a ? /* @__PURE__ */ _e.jsx($n, { error: a }) : i ? /* @__PURE__ */ _e.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ _e.jsx(mn, {}) }) : s.length === 0 ? /* @__PURE__ */ _e.jsx($.Paragraph, { variant: "4", color: "secondary", children: "No favorite products found." }) : /* @__PURE__ */ _e.jsx(Ye, { className: PS.list, children: s.map((m) => /* @__PURE__ */ _e.jsxs(
    b,
    {
      alignItems: "center",
      gap: "200",
      className: PS.listItem,
      children: [
        /* @__PURE__ */ _e.jsx(he, { size: l, name: "external-link" }),
        /* @__PURE__ */ _e.jsx(
          $.ExternalLink,
          {
            href: i6(
              n,
              m.product_id
            ),
            target: "_blank",
            rel: "noreferrer",
            children: m.title
          }
        )
      ]
    },
    m.product_id
  )) });
  return /* @__PURE__ */ _e.jsx(_e.Fragment, { children: /* @__PURE__ */ _e.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ _e.jsx($.Heading, { variant: "heading-3", children: "Favorite products" }),
    c()
  ] }) });
};
function i6(e, n) {
  const r = X1(e);
  return `${Q1}/store/${r}/products/${n}`;
}
const a6 = "_modalBody_1clhs_1", o6 = {
  modalBody: a6
};
function s6(e, n) {
  if (isNaN(e))
    return "Points can not be empty";
  if (e < n.min)
    return `Points cannot be below ${n.min}`;
  if (e > n.max)
    return `Points can not exceed ${n.max}`;
}
function l6(e, n) {
  if (e === n)
    return "Change the value to update the points";
}
const d6 = J1, Os = {
  addPoints: {
    successEventName: "rivoloyalty:points:add:succeeded",
    successEventText: "Added points successfully",
    failEventName: "rivoloyalty:points:add:failed",
    failEventText: "Failed to add points, try again later."
  },
  removePoints: {
    successEventName: "rivoloyalty:points:remove:succeeded",
    successEventText: "Removed points successfully",
    failEventName: "rivoloyalty:points:remove:failed",
    failEventText: "Failed to remove points, try again later."
  }
}, c6 = ({
  customerIdentifier: e,
  isOpen: n,
  points: r,
  onClose: i,
  refetchCustomerData: a
}) => {
  const { useMutation: o, showNotification: s } = hn(), { track: l } = jn(), [c, m] = pe(r), [u, f] = pe(""), [h, k] = pe(!0), [w, N] = pe(), j = {
    min: 0,
    max: 1e5
  }, [_, { loading: g }] = o(
    Wq,
    {
      onCompleted: () => {
        const re = c > r ? Os.addPoints : Os.removePoints;
        s({
          title: "Success",
          text: re.successEventText,
          icon: "check-circle-filled",
          severity: "success"
        }), l(re.successEventName), J();
      }
    }
  ), O = () => {
    m(r), f(""), k(!0), N(void 0);
  };
  Qe(() => {
    n && O();
  }, [n]);
  const R = !!w, F = s6(c, j), I = l6(r, c), L = () => {
    if (c !== r) {
      const re = c > r ? Os.addPoints : Os.removePoints, K = !h;
      _({
        variables: {
          input: {
            // eslint-disable-next-line camelcase
            points_amount: c - r,
            // eslint-disable-next-line camelcase
            ...u && { internal_note: u },
            // eslint-disable-next-line camelcase
            customer_identifier: e?.toString(),
            source: d6.Manual,
            // eslint-disable-next-line camelcase
            skip_email: K
          }
        }
      }).catch(() => {
        l(re.failEventName), N([re.failEventText]);
      });
    }
  }, W = () => {
    O(), i();
  }, J = () => {
    a(), W();
  };
  return /* @__PURE__ */ _e.jsxs(
    bt,
    {
      isOpen: n,
      onClose: W,
      "data-testid": "rivo-loyalty-change-points-modal",
      children: [
        /* @__PURE__ */ _e.jsx(_t, { title: "Change points", onClose: W }),
        /* @__PURE__ */ _e.jsxs(xt, { className: o6.modalBody, children: [
          /* @__PURE__ */ _e.jsxs(et, { children: [
            /* @__PURE__ */ _e.jsx(X, { span: 6, "data-testid": "rivo-loyalty-points-input", children: /* @__PURE__ */ _e.jsx(
              Wr,
              {
                label: "New points balance",
                type: "number",
                placeholder: "Insert points balance",
                min: j.min,
                max: j.max,
                meta: {
                  error: F,
                  warning: I
                },
                input: {
                  name: "points",
                  value: c.toString(),
                  onChange: (re) => m(re?.target.valueAsNumber ?? 0)
                }
              }
            ) }),
            /* @__PURE__ */ _e.jsx(X, { span: 6, children: /* @__PURE__ */ _e.jsx(
              Wr,
              {
                label: "Internal note",
                placeholder: "Insert an internal note (optional)",
                input: {
                  name: "internalNote",
                  value: u,
                  onChange: (re) => f(re?.target.value ?? "")
                }
              }
            ) }),
            /* @__PURE__ */ _e.jsx(X, { span: 6, children: /* @__PURE__ */ _e.jsx(He, { label: "Notify the customer by email", children: /* @__PURE__ */ _e.jsx(
              ww,
              {
                input: {
                  name: "sendEmail",
                  value: "sendEmail",
                  checked: h,
                  onChange: () => k(!h)
                }
              }
            ) }) })
          ] }),
          !g && R && /* @__PURE__ */ _e.jsx(b, { margin: "200 0", flexDirection: "column", children: /* @__PURE__ */ _e.jsx(Ye, { children: w?.map((re, K) => /* @__PURE__ */ _e.jsx(
            Ye.Item,
            {
              variant: "dense",
              title: re,
              contentLeft: /* @__PURE__ */ _e.jsx(
                he,
                {
                  color: "red.500",
                  size: 16,
                  name: "exclamation-triangle-filled"
                }
              )
            },
            K
          )) }) })
        ] }),
        /* @__PURE__ */ _e.jsx(
          wt,
          {
            confirmName: "Save",
            confirmOnClick: () => L(),
            confirmProps: {
              isLoading: g,
              loadingIndicator: /* @__PURE__ */ _e.jsx(mn, { size: 16 }),
              disabled: !!(F || I)
            },
            cancelOnClick: W
          }
        )
      ]
    }
  );
}, sa = ({
  description: e,
  content: n,
  tooltip: r,
  isHighlighted: i = !1
}) => {
  if (n == null)
    return null;
  const a = Nw(n);
  return /* @__PURE__ */ _e.jsx(
    Ye.Text,
    {
      variant: "dense",
      className: ct(Cr.listItem, {
        [Cr.listItemHighlighted]: i
      }),
      children: /* @__PURE__ */ _e.jsx(Xe, { content: r, children: /* @__PURE__ */ _e.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ _e.jsx($.Paragraph, { variant: "4", children: e }),
        a ? n : Bi(n)
      ] }) })
    }
  );
}, AS = {
  [ka.Guest]: {
    name: "Guest",
    tooltip: "Customers who can participate in your loyalty program without creating a full account. They can earn and redeem points through email verification or one-time codes.",
    badgeColor: "info"
  },
  [ka.Member]: {
    name: "Member",
    tooltip: "Customers who have activated their loyalty membership and have full access to all program features, including account dashboards and advanced features.",
    badgeColor: "success"
  },
  [ka.Excluded]: {
    name: "Excluded",
    tooltip: "Customers who have been excluded from the loyalty program (typically through the “Rivo Excluded” tag or manual exclusion).",
    badgeColor: "warning"
  }
}, u6 = ({
  customer: e,
  allowAdjustLoyaltyPoints: n,
  refetchCustomerData: r
}) => {
  const { attributes: i } = e, a = i.loyalty_status ? AS[i.loyalty_status] : AS[ka.Guest], o = a?.name === ka.Excluded, s = i.lifetime_earnings_tally ?? 0, l = i.total_spent ?? 0, c = Math.trunc(i.points_tally ?? 0), m = i.next_vip_tier, u = i.next_vip_tier?.to_spend_or_earn ?? 0, f = m?.name ?? "None", [h, k] = pe(!1), w = 10, N = () => /* @__PURE__ */ _e.jsx(
    Ye.Text,
    {
      variant: "dense",
      className: ct(Cr.listItem),
      children: /* @__PURE__ */ _e.jsx(Xe, { content: a.tooltip, children: /* @__PURE__ */ _e.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ _e.jsx($.Paragraph, { variant: "4", children: "Loyalty status" }),
        /* @__PURE__ */ _e.jsx(Pn, { variant: a.badgeColor, size: "small", children: a.name })
      ] }) })
    }
  ), j = () => o ? N() : /* @__PURE__ */ _e.jsxs(_e.Fragment, { children: [
    /* @__PURE__ */ _e.jsx(
      Ye.Text,
      {
        variant: "dense",
        className: ct(
          Cr.listItem,
          Cr.listItemHighlighted,
          {
            [Cr.listItemEdit]: n
          }
        ),
        onClick: () => n ? k(!0) : void 0,
        children: /* @__PURE__ */ _e.jsx(Xe, { content: "The current balance of loyalty points for the customer.", children: /* @__PURE__ */ _e.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
          /* @__PURE__ */ _e.jsx($.Paragraph, { variant: "4", children: "Points balance" }),
          /* @__PURE__ */ _e.jsxs(
            b,
            {
              alignItems: "center",
              justifyContent: "space-between",
              gap: "100",
              children: [
                n && /* @__PURE__ */ _e.jsx(
                  he,
                  {
                    name: "pen",
                    size: w,
                    "aria-label": "Edit points"
                  }
                ),
                /* @__PURE__ */ _e.jsx($.Paragraph, { variant: "4", children: Bi(c) })
              ]
            }
          )
        ] }) })
      }
    ),
    u != null && f && /* @__PURE__ */ _e.jsx(
      sa,
      {
        description: `Points until ${f} tier`,
        tooltip: `Loyalty points until the customer advances to ${f} tier`,
        content: u.toFixed(2)
      }
    ),
    /* @__PURE__ */ _e.jsx(
      sa,
      {
        description: "Points expiry date",
        tooltip: "The timestamp when the customer's loyalty points are set to expire.",
        content: i.points_expire_at ?? "No expiry"
      }
    ),
    /* @__PURE__ */ _e.jsx(
      sa,
      {
        description: "Total points earned",
        tooltip: "The total number of loyalty points earned by the customer.",
        content: s?.toFixed(2)
      }
    ),
    /* @__PURE__ */ _e.jsx(
      sa,
      {
        description: "Total points spent",
        tooltip: "The total number of loyalty points spent by the customer.",
        content: l.toFixed(2)
      }
    ),
    N(),
    /* @__PURE__ */ _e.jsx(
      sa,
      {
        description: "VIP tier",
        tooltip: "The name of the customer's current VIP tier status.",
        content: i.vip_tier?.name ?? "None"
      }
    ),
    /* @__PURE__ */ _e.jsx(
      sa,
      {
        description: "Next VIP tier",
        tooltip: "The name of the customer's next VIP tier status.",
        content: f
      }
    )
  ] });
  return /* @__PURE__ */ _e.jsxs(_e.Fragment, { children: [
    /* @__PURE__ */ _e.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ _e.jsx($.Heading, { variant: "heading-3", children: "Loyalty" }),
      /* @__PURE__ */ _e.jsx(Ye, { className: Cr.list, children: j() })
    ] }),
    /* @__PURE__ */ _e.jsx(
      c6,
      {
        customerIdentifier: i.id,
        isOpen: h,
        points: c,
        onClose: () => k(!1),
        refetchCustomerData: r
      }
    )
  ] });
}, m6 = ({
  ordersCount: e
}) => /* @__PURE__ */ _e.jsx(_e.Fragment, { children: /* @__PURE__ */ _e.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ _e.jsx($.Heading, { variant: "heading-3", children: "Orders overview" }),
  /* @__PURE__ */ _e.jsx(Ye, { className: Cr.list, children: /* @__PURE__ */ _e.jsx(Ye.Text, { variant: "dense", className: Cr.listItem, children: /* @__PURE__ */ _e.jsxs(b, { justifyContent: "space-between", children: [
    /* @__PURE__ */ _e.jsx($.Paragraph, { variant: "4", children: "Total orders" }),
    /* @__PURE__ */ _e.jsx($.Paragraph, { variant: "4", children: e ?? 0 })
  ] }) }) })
] }) }), p6 = "_reward_1gmba_1", f6 = "_voucherCode_1gmba_14", LS = {
  reward: p6,
  voucherCode: f6
}, h6 = ({
  pointsRedemption: e
}) => {
  const { isCopied: n, copy: r } = Jt(), {
    name: i,
    code: a,
    points_amount: o
  } = e.attributes;
  return /* @__PURE__ */ _e.jsx(b, { gap: "100", flexDirection: "column", children: /* @__PURE__ */ _e.jsxs(b, { gap: "100", flexDirection: "column", className: LS.reward, children: [
    /* @__PURE__ */ _e.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ _e.jsxs(b, { gap: "100", alignItems: "center", children: [
        /* @__PURE__ */ _e.jsx(he, { name: "star", size: 12, color: "neutral.500" }),
        i
      ] }),
      /* @__PURE__ */ _e.jsxs(Pn, { size: "small", variant: "info", children: [
        o ?? 0,
        " points"
      ] })
    ] }),
    /* @__PURE__ */ _e.jsxs(
      b,
      {
        gap: "100",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        children: [
          /* @__PURE__ */ _e.jsxs(b, { gap: "100", flexDirection: "row", alignItems: "center", children: [
            /* @__PURE__ */ _e.jsx(he, { size: 14, name: "tag" }),
            /* @__PURE__ */ _e.jsx(b, { children: /* @__PURE__ */ _e.jsx($.Paragraph, { variant: "4", className: LS.voucherCode, children: a }) })
          ] }),
          /* @__PURE__ */ _e.jsx(Xe, { content: "Copy reward code", children: /* @__PURE__ */ _e.jsx(
            he,
            {
              size: 14,
              name: n ? "done" : "copy",
              className: Cr.clickableIcon,
              onClick: () => r(a)
            }
          ) })
        ]
      }
    )
  ] }) });
}, y6 = ({
  customer: e
}) => {
  const { useQuery: n } = hn(), {
    loading: r,
    error: i,
    data: a
  } = n(Hq, {
    skip: !e,
    variables: {
      customerId: e.attributes.id.toString()
    }
  }), o = (!r && e && a ? a?.RivoLoyalty?.list_points_redemptions?.data ?? [] : []).filter(
    ({ attributes: l }) => g6({
      usedAt: l.used_at,
      revokedAt: l.revoked_at,
      refundedAt: l.refunded_at
    }) === "Issued"
  ), s = () => i ? /* @__PURE__ */ _e.jsx($n, { error: i }) : r ? /* @__PURE__ */ _e.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ _e.jsx(mn, {}) }) : o.length > 0 ? /* @__PURE__ */ _e.jsx(b, { gap: "200", flexDirection: "column", children: o.map((l) => /* @__PURE__ */ _e.jsx(
    h6,
    {
      pointsRedemption: l
    },
    l.id
  )) }) : /* @__PURE__ */ _e.jsx($.Paragraph, { variant: "4", color: "secondary", children: "No loyalty rewards found." });
  return /* @__PURE__ */ _e.jsx(_e.Fragment, { children: /* @__PURE__ */ _e.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ _e.jsx($.Heading, { variant: "heading-3", children: "Available rewards" }),
    s()
  ] }) });
};
function g6(e) {
  return e.usedAt ? "Used" : e.revokedAt ? "Revoked" : e.refundedAt ? "Refunded" : "Issued";
}
const v6 = (e) => {
  const { conversationContext: n, settings: r } = e, {
    rivoLoyaltyShowOrders: i,
    rivoLoyaltyShowLoyalty: a,
    rivoLoyaltyAdjustLoyaltyPoints: o,
    rivoLoyaltyShowFavoriteProducts: s,
    rivoLoyaltyShowPointsRedemptions: l
  } = r, c = r[cd].toString(), { useQuery: m } = hn(), { track: u } = jn(), [f, h] = pe(!1), k = n?.customer?.email, {
    loading: w,
    error: N,
    data: j,
    refetch: _
  } = m(Bq, {
    skip: !k,
    variables: {
      email: k
    }
  }), g = !w && j ? j.RivoLoyalty?.return_customer?.data : void 0;
  Qe(() => {
    !w && g && !f && (u("rivoloyalty:customer:received"), h(!0));
  }, [w, g]);
  const O = () => /* @__PURE__ */ _e.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ _e.jsx($.Paragraph, { variant: "4", color: "secondary", children: "No customer profile found." }) });
  if (N) {
    const R = N.graphQLErrors;
    return Ca({ errors: R }) ? O() : Ul({ errors: R }) ? /* @__PURE__ */ _e.jsx(
      $.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        variant: "4",
        "data-testid": "widget-downstream-api-forbidden-error",
        children: "The API token used for the integration does not have the necessary access rights. Please contact your administrator."
      }
    ) : Ml({ errors: R }) ? /* @__PURE__ */ _e.jsx(
      $.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        variant: "4",
        "data-testid": "widget-downstream-api-authorization-error",
        children: "The integration could not authorize against Rivo Loyalty. Please contact your administrator."
      }
    ) : /* @__PURE__ */ _e.jsx($n, { error: N });
  }
  return w ? /* @__PURE__ */ _e.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ _e.jsx(mn, {}) }) : !k || !g ? O() : /* @__PURE__ */ _e.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        /* @__PURE__ */ _e.jsx(
          Zq,
          {
            customerDetails: g,
            rivoLoyaltyShopifyApiHostName: c
          }
        ),
        i && /* @__PURE__ */ _e.jsx(
          m6,
          {
            ordersCount: g.attributes?.orders_count ?? 0
          }
        ),
        a && /* @__PURE__ */ _e.jsx(
          u6,
          {
            customer: g,
            refetchCustomerData: _,
            allowAdjustLoyaltyPoints: !!o
          }
        ),
        s && /* @__PURE__ */ _e.jsx(
          r6,
          {
            customerId: g.attributes.id,
            rivoLoyaltyShopifyApiHostName: c
          }
        ),
        l && /* @__PURE__ */ _e.jsx(y6, { customer: g })
      ]
    }
  );
};
var as = (e) => e.type === "checkbox", Li = (e) => e instanceof Date, Yt = (e) => e == null;
const Z1 = (e) => typeof e == "object";
var vt = (e) => !Yt(e) && !Array.isArray(e) && Z1(e) && !Li(e), eF = (e) => vt(e) && e.target ? as(e.target) ? e.target.checked : e.target.value : e, k6 = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, nF = (e, n) => e.has(k6(n)), b6 = (e) => {
  const n = e.constructor && e.constructor.prototype;
  return vt(n) && n.hasOwnProperty("isPrototypeOf");
}, Tg = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function Pt(e) {
  let n;
  const r = Array.isArray(e), i = typeof FileList < "u" ? e instanceof FileList : !1;
  if (e instanceof Date)
    n = new Date(e);
  else if (e instanceof Set)
    n = new Set(e);
  else if (!(Tg && (e instanceof Blob || i)) && (r || vt(e)))
    if (n = r ? [] : {}, !r && !b6(e))
      n = e;
    else
      for (const a in e)
        e.hasOwnProperty(a) && (n[a] = Pt(e[a]));
  else
    return e;
  return n;
}
var ud = (e) => Array.isArray(e) ? e.filter(Boolean) : [], yt = (e) => e === void 0, tn = (e, n, r) => {
  if (!n || !vt(e))
    return r;
  const i = ud(n.split(/[,[\].]+?/)).reduce((a, o) => Yt(a) ? a : a[o], e);
  return yt(i) || i === e ? yt(e[n]) ? r : e[n] : i;
}, lr = (e) => typeof e == "boolean", Rg = (e) => /^\w*$/.test(e), tF = (e) => ud(e.replace(/["|']|\]/g, "").split(/\.|\[/)), at = (e, n, r) => {
  let i = -1;
  const a = Rg(n) ? [n] : tF(n), o = a.length, s = o - 1;
  for (; ++i < o; ) {
    const l = a[i];
    let c = r;
    if (i !== s) {
      const m = e[l];
      c = vt(m) || Array.isArray(m) ? m : isNaN(+a[i + 1]) ? {} : [];
    }
    if (l === "__proto__" || l === "constructor" || l === "prototype")
      return;
    e[l] = c, e = e[l];
  }
};
const Rl = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, Fr = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, ri = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, _6 = qe.createContext(null), Dg = () => qe.useContext(_6);
var rF = (e, n, r, i = !0) => {
  const a = {
    defaultValues: n._defaultValues
  };
  for (const o in e)
    Object.defineProperty(a, o, {
      get: () => {
        const s = o;
        return n._proxyFormState[s] !== Fr.all && (n._proxyFormState[s] = !i || Fr.all), r && (r[s] = !0), e[s];
      }
    });
  return a;
};
function x6(e) {
  const n = Dg(), { control: r = n.control, disabled: i, name: a, exact: o } = e || {}, [s, l] = qe.useState(r._formState), c = qe.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }), m = qe.useRef(a);
  return m.current = a, qe.useEffect(() => r._subscribe({
    name: m.current,
    formState: c.current,
    exact: o,
    callback: (u) => {
      !i && l({
        ...r._formState,
        ...u
      });
    }
  }), [r, i, o]), qe.useEffect(() => {
    c.current.isValid && r._setValid(!0);
  }, [r]), qe.useMemo(() => rF(s, r, c.current, !1), [s, r]);
}
var qr = (e) => typeof e == "string", iF = (e, n, r, i, a) => qr(e) ? (i && n.watch.add(e), tn(r, e, a)) : Array.isArray(e) ? e.map((o) => (i && n.watch.add(o), tn(r, o))) : (i && (n.watchAll = !0), r);
function S6(e) {
  const n = Dg(), { control: r = n.control, name: i, defaultValue: a, disabled: o, exact: s } = e || {}, l = qe.useRef(i), c = qe.useRef(a);
  l.current = i, qe.useEffect(() => r._subscribe({
    name: l.current,
    formState: {
      values: !0
    },
    exact: s,
    callback: (f) => !o && u(iF(l.current, r._names, f.values || r._formValues, !1, c.current))
  }), [r, o, s]);
  const [m, u] = qe.useState(r._getWatch(i, a));
  return qe.useEffect(() => r._removeUnmounted()), m;
}
function N6(e) {
  const n = Dg(), { name: r, disabled: i, control: a = n.control, shouldUnregister: o } = e, s = nF(a._names.array, r), l = S6({
    control: a,
    name: r,
    defaultValue: tn(a._formValues, r, tn(a._defaultValues, r, e.defaultValue)),
    exact: !0
  }), c = x6({
    control: a,
    name: r,
    exact: !0
  }), m = qe.useRef(e), u = qe.useRef(a.register(r, {
    ...e.rules,
    value: l,
    ...lr(e.disabled) ? { disabled: e.disabled } : {}
  })), f = qe.useMemo(() => Object.defineProperties({}, {
    invalid: {
      enumerable: !0,
      get: () => !!tn(c.errors, r)
    },
    isDirty: {
      enumerable: !0,
      get: () => !!tn(c.dirtyFields, r)
    },
    isTouched: {
      enumerable: !0,
      get: () => !!tn(c.touchedFields, r)
    },
    isValidating: {
      enumerable: !0,
      get: () => !!tn(c.validatingFields, r)
    },
    error: {
      enumerable: !0,
      get: () => tn(c.errors, r)
    }
  }), [c, r]), h = qe.useCallback((j) => u.current.onChange({
    target: {
      value: eF(j),
      name: r
    },
    type: Rl.CHANGE
  }), [r]), k = qe.useCallback(() => u.current.onBlur({
    target: {
      value: tn(a._formValues, r),
      name: r
    },
    type: Rl.BLUR
  }), [r, a._formValues]), w = qe.useCallback((j) => {
    const _ = tn(a._fields, r);
    _ && j && (_._f.ref = {
      focus: () => j.focus(),
      select: () => j.select(),
      setCustomValidity: (g) => j.setCustomValidity(g),
      reportValidity: () => j.reportValidity()
    });
  }, [a._fields, r]), N = qe.useMemo(() => ({
    name: r,
    value: l,
    ...lr(i) || c.disabled ? { disabled: c.disabled || i } : {},
    onChange: h,
    onBlur: k,
    ref: w
  }), [r, i, c.disabled, h, k, w, l]);
  return qe.useEffect(() => {
    const j = a._options.shouldUnregister || o;
    a.register(r, {
      ...m.current.rules,
      ...lr(m.current.disabled) ? { disabled: m.current.disabled } : {}
    });
    const _ = (g, O) => {
      const R = tn(a._fields, g);
      R && R._f && (R._f.mount = O);
    };
    if (_(r, !0), j) {
      const g = Pt(tn(a._options.defaultValues, r));
      at(a._defaultValues, r, g), yt(tn(a._formValues, r)) && at(a._formValues, r, g);
    }
    return !s && a.register(r), () => {
      (s ? j && !a._state.action : j) ? a.unregister(r) : _(r, !1);
    };
  }, [r, a, s, o]), qe.useEffect(() => {
    a._setDisabledField({
      disabled: i,
      name: r
    });
  }, [i, r, a]), qe.useMemo(() => ({
    field: N,
    formState: c,
    fieldState: f
  }), [N, c, f]);
}
var j6 = (e, n, r, i, a) => n ? {
  ...r[e],
  types: {
    ...r[e] && r[e].types ? r[e].types : {},
    [i]: a || !0
  }
} : {}, Oo = (e) => Array.isArray(e) ? e : [e], VS = () => {
  let e = [];
  return {
    get observers() {
      return e;
    },
    next: (n) => {
      for (const r of e)
        r.next && r.next(n);
    },
    subscribe: (n) => (e.push(n), {
      unsubscribe: () => {
        e = e.filter((r) => r !== n);
      }
    }),
    unsubscribe: () => {
      e = [];
    }
  };
}, by = (e) => Yt(e) || !Z1(e);
function yi(e, n) {
  if (by(e) || by(n))
    return e === n;
  if (Li(e) && Li(n))
    return e.getTime() === n.getTime();
  const r = Object.keys(e), i = Object.keys(n);
  if (r.length !== i.length)
    return !1;
  for (const a of r) {
    const o = e[a];
    if (!i.includes(a))
      return !1;
    if (a !== "ref") {
      const s = n[a];
      if (Li(o) && Li(s) || vt(o) && vt(s) || Array.isArray(o) && Array.isArray(s) ? !yi(o, s) : o !== s)
        return !1;
    }
  }
  return !0;
}
var Kt = (e) => vt(e) && !Object.keys(e).length, Og = (e) => e.type === "file", Ir = (e) => typeof e == "function", Dl = (e) => {
  if (!Tg)
    return !1;
  const n = e ? e.ownerDocument : 0;
  return e instanceof (n && n.defaultView ? n.defaultView.HTMLElement : HTMLElement);
}, aF = (e) => e.type === "select-multiple", Pg = (e) => e.type === "radio", w6 = (e) => Pg(e) || as(e), Qm = (e) => Dl(e) && e.isConnected;
function C6(e, n) {
  const r = n.slice(0, -1).length;
  let i = 0;
  for (; i < r; )
    e = yt(e) ? i++ : e[n[i++]];
  return e;
}
function F6(e) {
  for (const n in e)
    if (e.hasOwnProperty(n) && !yt(e[n]))
      return !1;
  return !0;
}
function Ft(e, n) {
  const r = Array.isArray(n) ? n : Rg(n) ? [n] : tF(n), i = r.length === 1 ? e : C6(e, r), a = r.length - 1, o = r[a];
  return i && delete i[o], a !== 0 && (vt(i) && Kt(i) || Array.isArray(i) && F6(i)) && Ft(e, r.slice(0, -1)), e;
}
var oF = (e) => {
  for (const n in e)
    if (Ir(e[n]))
      return !0;
  return !1;
};
function Ol(e, n = {}) {
  const r = Array.isArray(e);
  if (vt(e) || r)
    for (const i in e)
      Array.isArray(e[i]) || vt(e[i]) && !oF(e[i]) ? (n[i] = Array.isArray(e[i]) ? [] : {}, Ol(e[i], n[i])) : Yt(e[i]) || (n[i] = !0);
  return n;
}
function sF(e, n, r) {
  const i = Array.isArray(e);
  if (vt(e) || i)
    for (const a in e)
      Array.isArray(e[a]) || vt(e[a]) && !oF(e[a]) ? yt(n) || by(r[a]) ? r[a] = Array.isArray(e[a]) ? Ol(e[a], []) : { ...Ol(e[a]) } : sF(e[a], Yt(n) ? {} : n[a], r[a]) : r[a] = !yi(e[a], n[a]);
  return r;
}
var vo = (e, n) => sF(e, n, Ol(n));
const zS = {
  value: !1,
  isValid: !1
}, US = { value: !0, isValid: !0 };
var lF = (e) => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const n = e.filter((r) => r && r.checked && !r.disabled).map((r) => r.value);
      return { value: n, isValid: !!n.length };
    }
    return e[0].checked && !e[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      e[0].attributes && !yt(e[0].attributes.value) ? yt(e[0].value) || e[0].value === "" ? US : { value: e[0].value, isValid: !0 } : US
    ) : zS;
  }
  return zS;
}, dF = (e, { valueAsNumber: n, valueAsDate: r, setValueAs: i }) => yt(e) ? e : n ? e === "" ? NaN : e && +e : r && qr(e) ? new Date(e) : i ? i(e) : e;
const MS = {
  isValid: !1,
  value: null
};
var cF = (e) => Array.isArray(e) ? e.reduce((n, r) => r && r.checked && !r.disabled ? {
  isValid: !0,
  value: r.value
} : n, MS) : MS;
function BS(e) {
  const n = e.ref;
  return Og(n) ? n.files : Pg(n) ? cF(e.refs).value : aF(n) ? [...n.selectedOptions].map(({ value: r }) => r) : as(n) ? lF(e.refs).value : dF(yt(n.value) ? e.ref.value : n.value, e);
}
var I6 = (e, n, r, i) => {
  const a = {};
  for (const o of e) {
    const s = tn(n, o);
    s && at(a, o, s._f);
  }
  return {
    criteriaMode: r,
    names: [...e],
    fields: a,
    shouldUseNativeValidation: i
  };
}, Pl = (e) => e instanceof RegExp, ko = (e) => yt(e) ? e : Pl(e) ? e.source : vt(e) ? Pl(e.value) ? e.value.source : e.value : e, qS = (e) => ({
  isOnSubmit: !e || e === Fr.onSubmit,
  isOnBlur: e === Fr.onBlur,
  isOnChange: e === Fr.onChange,
  isOnAll: e === Fr.all,
  isOnTouch: e === Fr.onTouched
});
const HS = "AsyncFunction";
var $6 = (e) => !!e && !!e.validate && !!(Ir(e.validate) && e.validate.constructor.name === HS || vt(e.validate) && Object.values(e.validate).find((n) => n.constructor.name === HS)), E6 = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate), WS = (e, n, r) => !r && (n.watchAll || n.watch.has(e) || [...n.watch].some((i) => e.startsWith(i) && /^\.\w+/.test(e.slice(i.length))));
const Po = (e, n, r, i) => {
  for (const a of r || Object.keys(e)) {
    const o = tn(e, a);
    if (o) {
      const { _f: s, ...l } = o;
      if (s) {
        if (s.refs && s.refs[0] && n(s.refs[0], a) && !i || s.ref && n(s.ref, s.name) && !i)
          return !0;
        if (Po(l, n))
          break;
      } else if (vt(l) && Po(l, n))
        break;
    }
  }
};
function KS(e, n, r) {
  const i = tn(e, r);
  if (i || Rg(r))
    return {
      error: i,
      name: r
    };
  const a = r.split(".");
  for (; a.length; ) {
    const o = a.join("."), s = tn(n, o), l = tn(e, o);
    if (s && !Array.isArray(s) && r !== o)
      return { name: r };
    if (l && l.type)
      return {
        name: o,
        error: l
      };
    a.pop();
  }
  return {
    name: r
  };
}
var T6 = (e, n, r, i) => {
  r(e);
  const { name: a, ...o } = e;
  return Kt(o) || Object.keys(o).length >= Object.keys(n).length || Object.keys(o).find((s) => n[s] === (!i || Fr.all));
}, R6 = (e, n, r) => !e || !n || e === n || Oo(e).some((i) => i && (r ? i === n : i.startsWith(n) || n.startsWith(i))), D6 = (e, n, r, i, a) => a.isOnAll ? !1 : !r && a.isOnTouch ? !(n || e) : (r ? i.isOnBlur : a.isOnBlur) ? !e : (r ? i.isOnChange : a.isOnChange) ? e : !0, O6 = (e, n) => !ud(tn(e, n)).length && Ft(e, n), P6 = (e, n, r) => {
  const i = Oo(tn(e, r));
  return at(i, "root", n[r]), at(e, r, i), e;
}, al = (e) => qr(e);
function GS(e, n, r = "validate") {
  if (al(e) || Array.isArray(e) && e.every(al) || lr(e) && !e)
    return {
      type: r,
      message: al(e) ? e : "",
      ref: n
    };
}
var la = (e) => vt(e) && !Pl(e) ? e : {
  value: e,
  message: ""
}, YS = async (e, n, r, i, a, o) => {
  const { ref: s, refs: l, required: c, maxLength: m, minLength: u, min: f, max: h, pattern: k, validate: w, name: N, valueAsNumber: j, mount: _ } = e._f, g = tn(r, N);
  if (!_ || n.has(N))
    return {};
  const O = l ? l[0] : s, R = (Y) => {
    a && O.reportValidity && (O.setCustomValidity(lr(Y) ? "" : Y || ""), O.reportValidity());
  }, F = {}, I = Pg(s), L = as(s), W = I || L, J = (j || Og(s)) && yt(s.value) && yt(g) || Dl(s) && s.value === "" || g === "" || Array.isArray(g) && !g.length, re = j6.bind(null, N, i, F), K = (Y, P, B, ie = ri.maxLength, we = ri.minLength) => {
    const me = Y ? P : B;
    F[N] = {
      type: Y ? ie : we,
      message: me,
      ref: s,
      ...re(Y ? ie : we, me)
    };
  };
  if (o ? !Array.isArray(g) || !g.length : c && (!W && (J || Yt(g)) || lr(g) && !g || L && !lF(l).isValid || I && !cF(l).isValid)) {
    const { value: Y, message: P } = al(c) ? { value: !!c, message: c } : la(c);
    if (Y && (F[N] = {
      type: ri.required,
      message: P,
      ref: O,
      ...re(ri.required, P)
    }, !i))
      return R(P), F;
  }
  if (!J && (!Yt(f) || !Yt(h))) {
    let Y, P;
    const B = la(h), ie = la(f);
    if (!Yt(g) && !isNaN(g)) {
      const we = s.valueAsNumber || g && +g;
      Yt(B.value) || (Y = we > B.value), Yt(ie.value) || (P = we < ie.value);
    } else {
      const we = s.valueAsDate || new Date(g), me = (V) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + V), le = s.type == "time", ge = s.type == "week";
      qr(B.value) && g && (Y = le ? me(g) > me(B.value) : ge ? g > B.value : we > new Date(B.value)), qr(ie.value) && g && (P = le ? me(g) < me(ie.value) : ge ? g < ie.value : we < new Date(ie.value));
    }
    if ((Y || P) && (K(!!Y, B.message, ie.message, ri.max, ri.min), !i))
      return R(F[N].message), F;
  }
  if ((m || u) && !J && (qr(g) || o && Array.isArray(g))) {
    const Y = la(m), P = la(u), B = !Yt(Y.value) && g.length > +Y.value, ie = !Yt(P.value) && g.length < +P.value;
    if ((B || ie) && (K(B, Y.message, P.message), !i))
      return R(F[N].message), F;
  }
  if (k && !J && qr(g)) {
    const { value: Y, message: P } = la(k);
    if (Pl(Y) && !g.match(Y) && (F[N] = {
      type: ri.pattern,
      message: P,
      ref: s,
      ...re(ri.pattern, P)
    }, !i))
      return R(P), F;
  }
  if (w) {
    if (Ir(w)) {
      const Y = await w(g, r), P = GS(Y, O);
      if (P && (F[N] = {
        ...P,
        ...re(ri.validate, P.message)
      }, !i))
        return R(P.message), F;
    } else if (vt(w)) {
      let Y = {};
      for (const P in w) {
        if (!Kt(Y) && !i)
          break;
        const B = GS(await w[P](g, r), O, P);
        B && (Y = {
          ...B,
          ...re(P, B.message)
        }, R(B.message), i && (F[N] = Y));
      }
      if (!Kt(Y) && (F[N] = {
        ref: O,
        ...Y
      }, !i))
        return F;
    }
  }
  return R(!0), F;
};
const A6 = {
  mode: Fr.onSubmit,
  reValidateMode: Fr.onChange,
  shouldFocusError: !0
};
function L6(e = {}) {
  let n = {
    ...A6,
    ...e
  }, r = {
    submitCount: 0,
    isDirty: !1,
    isLoading: Ir(n.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: n.errors || {},
    disabled: n.disabled || !1
  };
  const i = {};
  let a = vt(n.defaultValues) || vt(n.values) ? Pt(n.values || n.defaultValues) || {} : {}, o = n.shouldUnregister ? {} : Pt(a), s = {
    action: !1,
    mount: !1,
    watch: !1
  }, l = {
    mount: /* @__PURE__ */ new Set(),
    disabled: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, c, m = 0;
  const u = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  };
  let f = {
    ...u
  };
  const h = {
    array: VS(),
    state: VS()
  }, k = qS(n.mode), w = qS(n.reValidateMode), N = n.criteriaMode === Fr.all, j = (Q) => (E) => {
    clearTimeout(m), m = setTimeout(Q, E);
  }, _ = async (Q) => {
    if (!n.disabled && (u.isValid || f.isValid || Q)) {
      const E = n.resolver ? Kt((await J()).errors) : await K(i, !0);
      E !== r.isValid && h.state.next({
        isValid: E
      });
    }
  }, g = (Q, E) => {
    !n.disabled && (u.isValidating || u.validatingFields || f.isValidating || f.validatingFields) && ((Q || Array.from(l.mount)).forEach((z) => {
      z && (E ? at(r.validatingFields, z, E) : Ft(r.validatingFields, z));
    }), h.state.next({
      validatingFields: r.validatingFields,
      isValidating: !Kt(r.validatingFields)
    }));
  }, O = (Q, E = [], z, ae, ce = !0, U = !0) => {
    if (ae && z && !n.disabled) {
      if (s.action = !0, U && Array.isArray(tn(i, Q))) {
        const G = z(tn(i, Q), ae.argA, ae.argB);
        ce && at(i, Q, G);
      }
      if (U && Array.isArray(tn(r.errors, Q))) {
        const G = z(tn(r.errors, Q), ae.argA, ae.argB);
        ce && at(r.errors, Q, G), O6(r.errors, Q);
      }
      if ((u.touchedFields || f.touchedFields) && U && Array.isArray(tn(r.touchedFields, Q))) {
        const G = z(tn(r.touchedFields, Q), ae.argA, ae.argB);
        ce && at(r.touchedFields, Q, G);
      }
      (u.dirtyFields || f.dirtyFields) && (r.dirtyFields = vo(a, o)), h.state.next({
        name: Q,
        isDirty: P(Q, E),
        dirtyFields: r.dirtyFields,
        errors: r.errors,
        isValid: r.isValid
      });
    } else
      at(o, Q, E);
  }, R = (Q, E) => {
    at(r.errors, Q, E), h.state.next({
      errors: r.errors
    });
  }, F = (Q) => {
    r.errors = Q, h.state.next({
      errors: r.errors,
      isValid: !1
    });
  }, I = (Q, E, z, ae) => {
    const ce = tn(i, Q);
    if (ce) {
      const U = tn(o, Q, yt(z) ? tn(a, Q) : z);
      yt(U) || ae && ae.defaultChecked || E ? at(o, Q, E ? U : BS(ce._f)) : we(Q, U), s.mount && _();
    }
  }, L = (Q, E, z, ae, ce) => {
    let U = !1, G = !1;
    const ve = {
      name: Q
    };
    if (!n.disabled) {
      if (!z || ae) {
        (u.isDirty || f.isDirty) && (G = r.isDirty, r.isDirty = ve.isDirty = P(), U = G !== ve.isDirty);
        const je = yi(tn(a, Q), E);
        G = !!tn(r.dirtyFields, Q), je ? Ft(r.dirtyFields, Q) : at(r.dirtyFields, Q, !0), ve.dirtyFields = r.dirtyFields, U = U || (u.dirtyFields || f.dirtyFields) && G !== !je;
      }
      if (z) {
        const je = tn(r.touchedFields, Q);
        je || (at(r.touchedFields, Q, z), ve.touchedFields = r.touchedFields, U = U || (u.touchedFields || f.touchedFields) && je !== z);
      }
      U && ce && h.state.next(ve);
    }
    return U ? ve : {};
  }, W = (Q, E, z, ae) => {
    const ce = tn(r.errors, Q), U = (u.isValid || f.isValid) && lr(E) && r.isValid !== E;
    if (n.delayError && z ? (c = j(() => R(Q, z)), c(n.delayError)) : (clearTimeout(m), c = null, z ? at(r.errors, Q, z) : Ft(r.errors, Q)), (z ? !yi(ce, z) : ce) || !Kt(ae) || U) {
      const G = {
        ...ae,
        ...U && lr(E) ? { isValid: E } : {},
        errors: r.errors,
        name: Q
      };
      r = {
        ...r,
        ...G
      }, h.state.next(G);
    }
  }, J = async (Q) => {
    g(Q, !0);
    const E = await n.resolver(o, n.context, I6(Q || l.mount, i, n.criteriaMode, n.shouldUseNativeValidation));
    return g(Q), E;
  }, re = async (Q) => {
    const { errors: E } = await J(Q);
    if (Q)
      for (const z of Q) {
        const ae = tn(E, z);
        ae ? at(r.errors, z, ae) : Ft(r.errors, z);
      }
    else
      r.errors = E;
    return E;
  }, K = async (Q, E, z = {
    valid: !0
  }) => {
    for (const ae in Q) {
      const ce = Q[ae];
      if (ce) {
        const { _f: U, ...G } = ce;
        if (U) {
          const ve = l.array.has(U.name), je = ce._f && $6(ce._f);
          je && u.validatingFields && g([ae], !0);
          const Re = await YS(ce, l.disabled, o, N, n.shouldUseNativeValidation && !E, ve);
          if (je && u.validatingFields && g([ae]), Re[U.name] && (z.valid = !1, E))
            break;
          !E && (tn(Re, U.name) ? ve ? P6(r.errors, Re, U.name) : at(r.errors, U.name, Re[U.name]) : Ft(r.errors, U.name));
        }
        !Kt(G) && await K(G, E, z);
      }
    }
    return z.valid;
  }, Y = () => {
    for (const Q of l.unMount) {
      const E = tn(i, Q);
      E && (E._f.refs ? E._f.refs.every((z) => !Qm(z)) : !Qm(E._f.ref)) && Be(Q);
    }
    l.unMount = /* @__PURE__ */ new Set();
  }, P = (Q, E) => !n.disabled && (Q && E && at(o, Q, E), !yi(Oe(), a)), B = (Q, E, z) => iF(Q, l, {
    ...s.mount ? o : yt(E) ? a : qr(Q) ? { [Q]: E } : E
  }, z, E), ie = (Q) => ud(tn(s.mount ? o : a, Q, n.shouldUnregister ? tn(a, Q, []) : [])), we = (Q, E, z = {}) => {
    const ae = tn(i, Q);
    let ce = E;
    if (ae) {
      const U = ae._f;
      U && (!U.disabled && at(o, Q, dF(E, U)), ce = Dl(U.ref) && Yt(E) ? "" : E, aF(U.ref) ? [...U.ref.options].forEach((G) => G.selected = ce.includes(G.value)) : U.refs ? as(U.ref) ? U.refs.length > 1 ? U.refs.forEach((G) => (!G.defaultChecked || !G.disabled) && (G.checked = Array.isArray(ce) ? !!ce.find((ve) => ve === G.value) : ce === G.value)) : U.refs[0] && (U.refs[0].checked = !!ce) : U.refs.forEach((G) => G.checked = G.value === ce) : Og(U.ref) ? U.ref.value = "" : (U.ref.value = ce, U.ref.type || h.state.next({
        name: Q,
        values: Pt(o)
      })));
    }
    (z.shouldDirty || z.shouldTouch) && L(Q, ce, z.shouldTouch, z.shouldDirty, !0), z.shouldValidate && be(Q);
  }, me = (Q, E, z) => {
    for (const ae in E) {
      const ce = E[ae], U = `${Q}.${ae}`, G = tn(i, U);
      (l.array.has(Q) || vt(ce) || G && !G._f) && !Li(ce) ? me(U, ce, z) : we(U, ce, z);
    }
  }, le = (Q, E, z = {}) => {
    const ae = tn(i, Q), ce = l.array.has(Q), U = Pt(E);
    at(o, Q, U), ce ? (h.array.next({
      name: Q,
      values: Pt(o)
    }), (u.isDirty || u.dirtyFields || f.isDirty || f.dirtyFields) && z.shouldDirty && h.state.next({
      name: Q,
      dirtyFields: vo(a, o),
      isDirty: P(Q, U)
    })) : ae && !ae._f && !Yt(U) ? me(Q, U, z) : we(Q, U, z), WS(Q, l) && h.state.next({ ...r }), h.state.next({
      name: s.mount ? Q : void 0,
      values: Pt(o)
    });
  }, ge = async (Q) => {
    s.mount = !0;
    const E = Q.target;
    let z = E.name, ae = !0;
    const ce = tn(i, z), U = (G) => {
      ae = Number.isNaN(G) || Li(G) && isNaN(G.getTime()) || yi(G, tn(o, z, G));
    };
    if (ce) {
      let G, ve;
      const je = E.type ? BS(ce._f) : eF(Q), Re = Q.type === Rl.BLUR || Q.type === Rl.FOCUS_OUT, rn = !E6(ce._f) && !n.resolver && !tn(r.errors, z) && !ce._f.deps || D6(Re, tn(r.touchedFields, z), r.isSubmitted, w, k), bn = WS(z, l, Re);
      at(o, z, je), Re ? (ce._f.onBlur && ce._f.onBlur(Q), c && c(0)) : ce._f.onChange && ce._f.onChange(Q);
      const an = L(z, je, Re), fn = !Kt(an) || bn;
      if (!Re && h.state.next({
        name: z,
        type: Q.type,
        values: Pt(o)
      }), rn)
        return (u.isValid || f.isValid) && (n.mode === "onBlur" ? Re && _() : Re || _()), fn && h.state.next({ name: z, ...bn ? {} : an });
      if (!Re && bn && h.state.next({ ...r }), n.resolver) {
        const { errors: En } = await J([z]);
        if (U(je), ae) {
          const _n = KS(r.errors, i, z), Fn = KS(En, i, _n.name || z);
          G = Fn.error, z = Fn.name, ve = Kt(En);
        }
      } else
        g([z], !0), G = (await YS(ce, l.disabled, o, N, n.shouldUseNativeValidation))[z], g([z]), U(je), ae && (G ? ve = !1 : (u.isValid || f.isValid) && (ve = await K(i, !0)));
      ae && (ce._f.deps && be(ce._f.deps), W(z, ve, G, an));
    }
  }, V = (Q, E) => {
    if (tn(r.errors, E) && Q.focus)
      return Q.focus(), 1;
  }, be = async (Q, E = {}) => {
    let z, ae;
    const ce = Oo(Q);
    if (n.resolver) {
      const U = await re(yt(Q) ? Q : ce);
      z = Kt(U), ae = Q ? !ce.some((G) => tn(U, G)) : z;
    } else Q ? (ae = (await Promise.all(ce.map(async (U) => {
      const G = tn(i, U);
      return await K(G && G._f ? { [U]: G } : G);
    }))).every(Boolean), !(!ae && !r.isValid) && _()) : ae = z = await K(i);
    return h.state.next({
      ...!qr(Q) || (u.isValid || f.isValid) && z !== r.isValid ? {} : { name: Q },
      ...n.resolver || !Q ? { isValid: z } : {},
      errors: r.errors
    }), E.shouldFocus && !ae && Po(i, V, Q ? ce : l.mount), ae;
  }, Oe = (Q) => {
    const E = {
      ...s.mount ? o : a
    };
    return yt(Q) ? E : qr(Q) ? tn(E, Q) : Q.map((z) => tn(E, z));
  }, q = (Q, E) => ({
    invalid: !!tn((E || r).errors, Q),
    isDirty: !!tn((E || r).dirtyFields, Q),
    error: tn((E || r).errors, Q),
    isValidating: !!tn(r.validatingFields, Q),
    isTouched: !!tn((E || r).touchedFields, Q)
  }), Ge = (Q) => {
    Q && Oo(Q).forEach((E) => Ft(r.errors, E)), h.state.next({
      errors: Q ? r.errors : {}
    });
  }, sn = (Q, E, z) => {
    const ae = (tn(i, Q, { _f: {} })._f || {}).ref, ce = tn(r.errors, Q) || {}, { ref: U, message: G, type: ve, ...je } = ce;
    at(r.errors, Q, {
      ...je,
      ...E,
      ref: ae
    }), h.state.next({
      name: Q,
      errors: r.errors,
      isValid: !1
    }), z && z.shouldFocus && ae && ae.focus && ae.focus();
  }, Ie = (Q, E) => Ir(Q) ? h.state.subscribe({
    next: (z) => Q(B(void 0, E), z)
  }) : B(Q, E, !0), Ue = (Q) => h.state.subscribe({
    next: (E) => {
      R6(Q.name, E.name, Q.exact) && T6(E, Q.formState || u, Pe, Q.reRenderRoot) && Q.callback({
        values: { ...o },
        ...r,
        ...E
      });
    }
  }).unsubscribe, De = (Q) => (s.mount = !0, f = {
    ...f,
    ...Q.formState
  }, Ue({
    ...Q,
    formState: f
  })), Be = (Q, E = {}) => {
    for (const z of Q ? Oo(Q) : l.mount)
      l.mount.delete(z), l.array.delete(z), E.keepValue || (Ft(i, z), Ft(o, z)), !E.keepError && Ft(r.errors, z), !E.keepDirty && Ft(r.dirtyFields, z), !E.keepTouched && Ft(r.touchedFields, z), !E.keepIsValidating && Ft(r.validatingFields, z), !n.shouldUnregister && !E.keepDefaultValue && Ft(a, z);
    h.state.next({
      values: Pt(o)
    }), h.state.next({
      ...r,
      ...E.keepDirty ? { isDirty: P() } : {}
    }), !E.keepIsValid && _();
  }, Ae = ({ disabled: Q, name: E }) => {
    (lr(Q) && s.mount || Q || l.disabled.has(E)) && (Q ? l.disabled.add(E) : l.disabled.delete(E));
  }, Je = (Q, E = {}) => {
    let z = tn(i, Q);
    const ae = lr(E.disabled) || lr(n.disabled);
    return at(i, Q, {
      ...z || {},
      _f: {
        ...z && z._f ? z._f : { ref: { name: Q } },
        name: Q,
        mount: !0,
        ...E
      }
    }), l.mount.add(Q), z ? Ae({
      disabled: lr(E.disabled) ? E.disabled : n.disabled,
      name: Q
    }) : I(Q, !0, E.value), {
      ...ae ? { disabled: E.disabled || n.disabled } : {},
      ...n.progressive ? {
        required: !!E.required,
        min: ko(E.min),
        max: ko(E.max),
        minLength: ko(E.minLength),
        maxLength: ko(E.maxLength),
        pattern: ko(E.pattern)
      } : {},
      name: Q,
      onChange: ge,
      onBlur: ge,
      ref: (ce) => {
        if (ce) {
          Je(Q, E), z = tn(i, Q);
          const U = yt(ce.value) && ce.querySelectorAll && ce.querySelectorAll("input,select,textarea")[0] || ce, G = w6(U), ve = z._f.refs || [];
          if (G ? ve.find((je) => je === U) : U === z._f.ref)
            return;
          at(i, Q, {
            _f: {
              ...z._f,
              ...G ? {
                refs: [
                  ...ve.filter(Qm),
                  U,
                  ...Array.isArray(tn(a, Q)) ? [{}] : []
                ],
                ref: { type: U.type, name: Q }
              } : { ref: U }
            }
          }), I(Q, !1, void 0, U);
        } else
          z = tn(i, Q, {}), z._f && (z._f.mount = !1), (n.shouldUnregister || E.shouldUnregister) && !(nF(l.array, Q) && s.action) && l.unMount.add(Q);
      }
    };
  }, Ee = () => n.shouldFocusError && Po(i, V, l.mount), Me = (Q) => {
    lr(Q) && (h.state.next({ disabled: Q }), Po(i, (E, z) => {
      const ae = tn(i, z);
      ae && (E.disabled = ae._f.disabled || Q, Array.isArray(ae._f.refs) && ae._f.refs.forEach((ce) => {
        ce.disabled = ae._f.disabled || Q;
      }));
    }, 0, !1));
  }, en = (Q, E) => async (z) => {
    let ae;
    z && (z.preventDefault && z.preventDefault(), z.persist && z.persist());
    let ce = Pt(o);
    if (h.state.next({
      isSubmitting: !0
    }), n.resolver) {
      const { errors: U, values: G } = await J();
      r.errors = U, ce = G;
    } else
      await K(i);
    if (l.disabled.size)
      for (const U of l.disabled)
        at(ce, U, void 0);
    if (Ft(r.errors, "root"), Kt(r.errors)) {
      h.state.next({
        errors: {}
      });
      try {
        await Q(ce, z);
      } catch (U) {
        ae = U;
      }
    } else
      E && await E({ ...r.errors }, z), Ee(), setTimeout(Ee);
    if (h.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: Kt(r.errors) && !ae,
      submitCount: r.submitCount + 1,
      errors: r.errors
    }), ae)
      throw ae;
  }, se = (Q, E = {}) => {
    tn(i, Q) && (yt(E.defaultValue) ? le(Q, Pt(tn(a, Q))) : (le(Q, E.defaultValue), at(a, Q, Pt(E.defaultValue))), E.keepTouched || Ft(r.touchedFields, Q), E.keepDirty || (Ft(r.dirtyFields, Q), r.isDirty = E.defaultValue ? P(Q, Pt(tn(a, Q))) : P()), E.keepError || (Ft(r.errors, Q), u.isValid && _()), h.state.next({ ...r }));
  }, de = (Q, E = {}) => {
    const z = Q ? Pt(Q) : a, ae = Pt(z), ce = Kt(Q), U = ce ? a : ae;
    if (E.keepDefaultValues || (a = z), !E.keepValues) {
      if (E.keepDirtyValues) {
        const G = /* @__PURE__ */ new Set([
          ...l.mount,
          ...Object.keys(vo(a, o))
        ]);
        for (const ve of Array.from(G))
          tn(r.dirtyFields, ve) ? at(U, ve, tn(o, ve)) : le(ve, tn(U, ve));
      } else {
        if (Tg && yt(Q))
          for (const G of l.mount) {
            const ve = tn(i, G);
            if (ve && ve._f) {
              const je = Array.isArray(ve._f.refs) ? ve._f.refs[0] : ve._f.ref;
              if (Dl(je)) {
                const Re = je.closest("form");
                if (Re) {
                  Re.reset();
                  break;
                }
              }
            }
          }
        for (const G of l.mount)
          le(G, tn(U, G));
      }
      o = Pt(U), h.array.next({
        values: { ...U }
      }), h.state.next({
        values: { ...U }
      });
    }
    l = {
      mount: E.keepDirtyValues ? l.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      disabled: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, s.mount = !u.isValid || !!E.keepIsValid || !!E.keepDirtyValues, s.watch = !!n.shouldUnregister, h.state.next({
      submitCount: E.keepSubmitCount ? r.submitCount : 0,
      isDirty: ce ? !1 : E.keepDirty ? r.isDirty : !!(E.keepDefaultValues && !yi(Q, a)),
      isSubmitted: E.keepIsSubmitted ? r.isSubmitted : !1,
      dirtyFields: ce ? {} : E.keepDirtyValues ? E.keepDefaultValues && o ? vo(a, o) : r.dirtyFields : E.keepDefaultValues && Q ? vo(a, Q) : E.keepDirty ? r.dirtyFields : {},
      touchedFields: E.keepTouched ? r.touchedFields : {},
      errors: E.keepErrors ? r.errors : {},
      isSubmitSuccessful: E.keepIsSubmitSuccessful ? r.isSubmitSuccessful : !1,
      isSubmitting: !1
    });
  }, Se = (Q, E) => de(Ir(Q) ? Q(o) : Q, E), Ve = (Q, E = {}) => {
    const z = tn(i, Q), ae = z && z._f;
    if (ae) {
      const ce = ae.refs ? ae.refs[0] : ae.ref;
      ce.focus && (ce.focus(), E.shouldSelect && Ir(ce.select) && ce.select());
    }
  }, Pe = (Q) => {
    r = {
      ...r,
      ...Q
    };
  }, kn = {
    control: {
      register: Je,
      unregister: Be,
      getFieldState: q,
      handleSubmit: en,
      setError: sn,
      _subscribe: Ue,
      _runSchema: J,
      _getWatch: B,
      _getDirty: P,
      _setValid: _,
      _setFieldArray: O,
      _setDisabledField: Ae,
      _setErrors: F,
      _getFieldArray: ie,
      _reset: de,
      _resetDefaultValues: () => Ir(n.defaultValues) && n.defaultValues().then((Q) => {
        Se(Q, n.resetOptions), h.state.next({
          isLoading: !1
        });
      }),
      _removeUnmounted: Y,
      _disableForm: Me,
      _subjects: h,
      _proxyFormState: u,
      get _fields() {
        return i;
      },
      get _formValues() {
        return o;
      },
      get _state() {
        return s;
      },
      set _state(Q) {
        s = Q;
      },
      get _defaultValues() {
        return a;
      },
      get _names() {
        return l;
      },
      set _names(Q) {
        l = Q;
      },
      get _formState() {
        return r;
      },
      get _options() {
        return n;
      },
      set _options(Q) {
        n = {
          ...n,
          ...Q
        };
      }
    },
    subscribe: De,
    trigger: be,
    register: Je,
    handleSubmit: en,
    watch: Ie,
    setValue: le,
    getValues: Oe,
    reset: Se,
    resetField: se,
    clearErrors: Ge,
    unregister: Be,
    setError: sn,
    setFocus: Ve,
    getFieldState: q
  };
  return {
    ...kn,
    formControl: kn
  };
}
function V6(e = {}) {
  const n = qe.useRef(void 0), r = qe.useRef(void 0), [i, a] = qe.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: Ir(e.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: e.errors || {},
    disabled: e.disabled || !1,
    defaultValues: Ir(e.defaultValues) ? void 0 : e.defaultValues
  });
  n.current || (n.current = {
    ...e.formControl ? e.formControl : L6(e),
    formState: i
  }, e.formControl && e.defaultValues && !Ir(e.defaultValues) && e.formControl.reset(e.defaultValues, e.resetOptions));
  const o = n.current.control;
  return o._options = e, qe.useLayoutEffect(() => o._subscribe({
    formState: o._proxyFormState,
    callback: () => a({ ...o._formState }),
    reRenderRoot: !0
  }), [o]), qe.useEffect(() => o._disableForm(e.disabled), [o, e.disabled]), qe.useEffect(() => {
    if (o._proxyFormState.isDirty) {
      const s = o._getDirty();
      s !== i.isDirty && o._subjects.state.next({
        isDirty: s
      });
    }
  }, [o, i.isDirty]), qe.useEffect(() => {
    e.values && !yi(e.values, r.current) ? (o._reset(e.values, o._options.resetOptions), r.current = e.values, a((s) => ({ ...s }))) : o._resetDefaultValues();
  }, [e.values, o]), qe.useEffect(() => {
    e.errors && !Kt(e.errors) && o._setErrors(e.errors);
  }, [e.errors, o]), qe.useEffect(() => {
    o._state.mount || (o._setValid(), o._state.mount = !0), o._state.watch && (o._state.watch = !1, o._subjects.state.next({ ...o._formState })), o._removeUnmounted();
  }), qe.useEffect(() => {
    e.shouldUnregister && o._subjects.state.next({
      values: o._getWatch()
    });
  }, [e.shouldUnregister, o]), n.current.formState = rF(i, o), n.current;
}
var Ps = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function uF(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Xm = { exports: {} }, bo = {}, JS;
function z6() {
  if (JS) return bo;
  JS = 1;
  var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, c, m) {
    var u, f = {}, h = null, k = null;
    m !== void 0 && (h = "" + m), c.key !== void 0 && (h = "" + c.key), c.ref !== void 0 && (k = c.ref);
    for (u in c) i.call(c, u) && !o.hasOwnProperty(u) && (f[u] = c[u]);
    if (l && l.defaultProps) for (u in c = l.defaultProps, c) f[u] === void 0 && (f[u] = c[u]);
    return { $$typeof: n, type: l, key: h, ref: k, props: f, _owner: a.current };
  }
  return bo.Fragment = r, bo.jsx = s, bo.jsxs = s, bo;
}
var As = {}, QS;
function U6() {
  return QS || (QS = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), c = /* @__PURE__ */ Symbol.for("react.forward_ref"), m = /* @__PURE__ */ Symbol.for("react.suspense"), u = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), k = /* @__PURE__ */ Symbol.for("react.offscreen"), w = Symbol.iterator, N = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var d = w && t[w] || t[N];
      return typeof d == "function" ? d : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var d = arguments.length, p = new Array(d > 1 ? d - 1 : 0), y = 1; y < d; y++)
          p[y - 1] = arguments[y];
        O("error", t, p);
      }
    }
    function O(t, d, p) {
      {
        var y = _.ReactDebugCurrentFrame, C = y.getStackAddendum();
        C !== "" && (d += "%s", p = p.concat([C]));
        var T = p.map(function(S) {
          return String(S);
        });
        T.unshift("Warning: " + d), Function.prototype.apply.call(console[t], console, T);
      }
    }
    var R = !1, F = !1, I = !1, L = !1, W = !1, J;
    J = /* @__PURE__ */ Symbol.for("react.module.reference");
    function re(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || W || t === a || t === m || t === u || L || t === k || R || F || I || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === J || t.getModuleId !== void 0));
    }
    function K(t, d, p) {
      var y = t.displayName;
      if (y)
        return y;
      var C = d.displayName || d.name || "";
      return C !== "" ? p + "(" + C + ")" : p;
    }
    function Y(t) {
      return t.displayName || "Context";
    }
    function P(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var d = t;
            return Y(d) + ".Consumer";
          case s:
            var p = t;
            return Y(p._context) + ".Provider";
          case c:
            return K(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : P(t.type) || "Memo";
          case h: {
            var C = t, T = C._payload, S = C._init;
            try {
              return P(S(T));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, ie = 0, we, me, le, ge, V, be, Oe;
    function q() {
    }
    q.__reactDisabledLog = !0;
    function Ge() {
      {
        if (ie === 0) {
          we = console.log, me = console.info, le = console.warn, ge = console.error, V = console.group, be = console.groupCollapsed, Oe = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: q,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ie++;
      }
    }
    function sn() {
      {
        if (ie--, ie === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, t, {
              value: we
            }),
            info: B({}, t, {
              value: me
            }),
            warn: B({}, t, {
              value: le
            }),
            error: B({}, t, {
              value: ge
            }),
            group: B({}, t, {
              value: V
            }),
            groupCollapsed: B({}, t, {
              value: be
            }),
            groupEnd: B({}, t, {
              value: Oe
            })
          });
        }
        ie < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ie = _.ReactCurrentDispatcher, Ue;
    function De(t, d, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (C) {
            var y = C.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Ae;
    {
      var Je = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Je();
    }
    function Ee(t, d) {
      if (!t || Be)
        return "";
      {
        var p = Ae.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Be = !0;
      var C = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var T;
      T = Ie.current, Ie.current = null, Ge();
      try {
        if (d) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (ne) {
              y = ne;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (ne) {
              y = ne;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            y = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && y && typeof ne.stack == "string") {
          for (var x = ne.stack.split(`
`), Z = y.stack.split(`
`), A = x.length - 1, M = Z.length - 1; A >= 1 && M >= 0 && x[A] !== Z[M]; )
            M--;
          for (; A >= 1 && M >= 0; A--, M--)
            if (x[A] !== Z[M]) {
              if (A !== 1 || M !== 1)
                do
                  if (A--, M--, M < 0 || x[A] !== Z[M]) {
                    var ue = `
` + x[A].replace(" at new ", " at ");
                    return t.displayName && ue.includes("<anonymous>") && (ue = ue.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, ue), ue;
                  }
                while (A >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Ie.current = T, sn(), Error.prepareStackTrace = C;
      }
      var ze = t ? t.displayName || t.name : "", Te = ze ? De(ze) : "";
      return typeof t == "function" && Ae.set(t, Te), Te;
    }
    function Me(t, d, p) {
      return Ee(t, !1);
    }
    function en(t) {
      var d = t.prototype;
      return !!(d && d.isReactComponent);
    }
    function se(t, d, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ee(t, en(t));
      if (typeof t == "string")
        return De(t);
      switch (t) {
        case m:
          return De("Suspense");
        case u:
          return De("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case c:
            return Me(t.render);
          case f:
            return se(t.type, d, p);
          case h: {
            var y = t, C = y._payload, T = y._init;
            try {
              return se(T(C), d, p);
            } catch {
            }
          }
        }
      return "";
    }
    var de = Object.prototype.hasOwnProperty, Se = {}, Ve = _.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var d = t._owner, p = se(t.type, t._source, d ? d.type : null);
        Ve.setExtraStackFrame(p);
      } else
        Ve.setExtraStackFrame(null);
    }
    function kn(t, d, p, y, C) {
      {
        var T = Function.call.bind(de);
        for (var S in t)
          if (T(t, S)) {
            var x = void 0;
            try {
              if (typeof t[S] != "function") {
                var Z = Error((y || "React class") + ": " + p + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Z.name = "Invariant Violation", Z;
              }
              x = t[S](d, S, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (A) {
              x = A;
            }
            x && !(x instanceof Error) && (Pe(C), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, S, typeof x), Pe(null)), x instanceof Error && !(x.message in Se) && (Se[x.message] = !0, Pe(C), g("Failed %s type: %s", p, x.message), Pe(null));
          }
      }
    }
    var Q = Array.isArray;
    function E(t) {
      return Q(t);
    }
    function z(t) {
      {
        var d = typeof Symbol == "function" && Symbol.toStringTag, p = d && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function ae(t) {
      try {
        return ce(t), !1;
      } catch {
        return !0;
      }
    }
    function ce(t) {
      return "" + t;
    }
    function U(t) {
      if (ae(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", z(t)), ce(t);
    }
    var G = _.ReactCurrentOwner, ve = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, je, Re;
    function rn(t) {
      if (de.call(t, "ref")) {
        var d = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (d && d.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function bn(t) {
      if (de.call(t, "key")) {
        var d = Object.getOwnPropertyDescriptor(t, "key").get;
        if (d && d.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function an(t, d) {
      typeof t.ref == "string" && G.current;
    }
    function fn(t, d) {
      {
        var p = function() {
          je || (je = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", d));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function En(t, d) {
      {
        var p = function() {
          Re || (Re = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", d));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var _n = function(t, d, p, y, C, T, S) {
      var x = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: d,
        ref: p,
        props: S,
        // Record the component responsible for creating this element.
        _owner: T
      };
      return x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(x, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(x, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: C
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    };
    function Fn(t, d, p, y, C) {
      {
        var T, S = {}, x = null, Z = null;
        p !== void 0 && (U(p), x = "" + p), bn(d) && (U(d.key), x = "" + d.key), rn(d) && (Z = d.ref, an(d));
        for (T in d)
          de.call(d, T) && !ve.hasOwnProperty(T) && (S[T] = d[T]);
        if (t && t.defaultProps) {
          var A = t.defaultProps;
          for (T in A)
            S[T] === void 0 && (S[T] = A[T]);
        }
        if (x || Z) {
          var M = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          x && fn(S, M), Z && En(S, M);
        }
        return _n(t, x, Z, C, y, G.current, S);
      }
    }
    var Ze = _.ReactCurrentOwner, gn = _.ReactDebugCurrentFrame;
    function Le(t) {
      if (t) {
        var d = t._owner, p = se(t.type, t._source, d ? d.type : null);
        gn.setExtraStackFrame(p);
      } else
        gn.setExtraStackFrame(null);
    }
    var dn;
    dn = !1;
    function cn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function Nn() {
      {
        if (Ze.current) {
          var t = P(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Bn(t) {
      return "";
    }
    var Sn = {};
    function An(t) {
      {
        var d = Nn();
        if (!d) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (d = `

Check the top-level render call using <` + p + ">.");
        }
        return d;
      }
    }
    function vn(t, d) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = An(d);
        if (Sn[p])
          return;
        Sn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Ze.current && (y = " It was passed a child from " + P(t._owner.type) + "."), Le(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Le(null);
      }
    }
    function xn(t, d) {
      {
        if (typeof t != "object")
          return;
        if (E(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            cn(y) && vn(y, d);
          }
        else if (cn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var C = j(t);
          if (typeof C == "function" && C !== t.entries)
            for (var T = C.call(t), S; !(S = T.next()).done; )
              cn(S.value) && vn(S.value, d);
        }
      }
    }
    function Ln(t) {
      {
        var d = t.type;
        if (d == null || typeof d == "string")
          return;
        var p;
        if (typeof d == "function")
          p = d.propTypes;
        else if (typeof d == "object" && (d.$$typeof === c || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        d.$$typeof === f))
          p = d.propTypes;
        else
          return;
        if (p) {
          var y = P(d);
          kn(p, t.props, "prop", y, t);
        } else if (d.PropTypes !== void 0 && !dn) {
          dn = !0;
          var C = P(d);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", C || "Unknown");
        }
        typeof d.getDefaultProps == "function" && !d.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var d = Object.keys(t.props), p = 0; p < d.length; p++) {
          var y = d[p];
          if (y !== "children" && y !== "key") {
            Le(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Le(null);
            break;
          }
        }
        t.ref !== null && (Le(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Le(null));
      }
    }
    var Cn = {};
    function wn(t, d, p, y, C, T) {
      {
        var S = re(t);
        if (!S) {
          var x = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (x += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Z = Bn();
          Z ? x += Z : x += Nn();
          var A;
          t === null ? A = "null" : E(t) ? A = "array" : t !== void 0 && t.$$typeof === n ? (A = "<" + (P(t.type) || "Unknown") + " />", x = " Did you accidentally export a JSX literal instead of a component?") : A = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", A, x);
        }
        var M = Fn(t, d, p, C, T);
        if (M == null)
          return M;
        if (S) {
          var ue = d.children;
          if (ue !== void 0)
            if (y)
              if (E(ue)) {
                for (var ze = 0; ze < ue.length; ze++)
                  xn(ue[ze], t);
                Object.freeze && Object.freeze(ue);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              xn(ue, t);
        }
        if (de.call(d, "key")) {
          var Te = P(t), ne = Object.keys(d).filter(function(Kn) {
            return Kn !== "key";
          }), un = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Cn[Te + un]) {
            var Rn = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, un, Te, Rn, Te), Cn[Te + un] = !0;
          }
        }
        return t === i ? Vn(M) : Ln(M), M;
      }
    }
    function zn(t, d, p) {
      return wn(t, d, p, !0);
    }
    function qn(t, d, p) {
      return wn(t, d, p, !1);
    }
    var Un = qn, Wn = zn;
    As.Fragment = i, As.jsx = Un, As.jsxs = Wn;
  })()), As;
}
var XS;
function M6() {
  return XS || (XS = 1, process.env.NODE_ENV === "production" ? Xm.exports = z6() : Xm.exports = U6()), Xm.exports;
}
var Ao = M6();
function B6(e) {
  return !e || typeof e == "boolean" || typeof e == "string" ? !!e : e.value;
}
var Zm, ZS;
function xi() {
  if (ZS) return Zm;
  ZS = 1;
  var e = Array.isArray;
  return Zm = e, Zm;
}
var ep, e0;
function mF() {
  if (e0) return ep;
  e0 = 1;
  var e = typeof Ps == "object" && Ps && Ps.Object === Object && Ps;
  return ep = e, ep;
}
var np, n0;
function Jr() {
  if (n0) return np;
  n0 = 1;
  var e = mF(), n = typeof self == "object" && self && self.Object === Object && self, r = e || n || Function("return this")();
  return np = r, np;
}
var tp, t0;
function os() {
  if (t0) return tp;
  t0 = 1;
  var e = Jr(), n = e.Symbol;
  return tp = n, tp;
}
var rp, r0;
function q6() {
  if (r0) return rp;
  r0 = 1;
  var e = os(), n = Object.prototype, r = n.hasOwnProperty, i = n.toString, a = e ? e.toStringTag : void 0;
  function o(s) {
    var l = r.call(s, a), c = s[a];
    try {
      s[a] = void 0;
      var m = !0;
    } catch {
    }
    var u = i.call(s);
    return m && (l ? s[a] = c : delete s[a]), u;
  }
  return rp = o, rp;
}
var ip, i0;
function H6() {
  if (i0) return ip;
  i0 = 1;
  var e = Object.prototype, n = e.toString;
  function r(i) {
    return n.call(i);
  }
  return ip = r, ip;
}
var ap, a0;
function La() {
  if (a0) return ap;
  a0 = 1;
  var e = os(), n = q6(), r = H6(), i = "[object Null]", a = "[object Undefined]", o = e ? e.toStringTag : void 0;
  function s(l) {
    return l == null ? l === void 0 ? a : i : o && o in Object(l) ? n(l) : r(l);
  }
  return ap = s, ap;
}
var op, o0;
function Ji() {
  if (o0) return op;
  o0 = 1;
  function e(n) {
    return n != null && typeof n == "object";
  }
  return op = e, op;
}
var sp, s0;
function Ag() {
  if (s0) return sp;
  s0 = 1;
  var e = La(), n = Ji(), r = "[object Symbol]";
  function i(a) {
    return typeof a == "symbol" || n(a) && e(a) == r;
  }
  return sp = i, sp;
}
var lp, l0;
function W6() {
  if (l0) return lp;
  l0 = 1;
  var e = xi(), n = Ag(), r = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, i = /^\w*$/;
  function a(o, s) {
    if (e(o))
      return !1;
    var l = typeof o;
    return l == "number" || l == "symbol" || l == "boolean" || o == null || n(o) ? !0 : i.test(o) || !r.test(o) || s != null && o in Object(s);
  }
  return lp = a, lp;
}
var dp, d0;
function Va() {
  if (d0) return dp;
  d0 = 1;
  function e(n) {
    var r = typeof n;
    return n != null && (r == "object" || r == "function");
  }
  return dp = e, dp;
}
var cp, c0;
function pF() {
  if (c0) return cp;
  c0 = 1;
  var e = La(), n = Va(), r = "[object AsyncFunction]", i = "[object Function]", a = "[object GeneratorFunction]", o = "[object Proxy]";
  function s(l) {
    if (!n(l))
      return !1;
    var c = e(l);
    return c == i || c == a || c == r || c == o;
  }
  return cp = s, cp;
}
var up, u0;
function K6() {
  if (u0) return up;
  u0 = 1;
  var e = Jr(), n = e["__core-js_shared__"];
  return up = n, up;
}
var mp, m0;
function G6() {
  if (m0) return mp;
  m0 = 1;
  var e = K6(), n = (function() {
    var i = /[^.]+$/.exec(e && e.keys && e.keys.IE_PROTO || "");
    return i ? "Symbol(src)_1." + i : "";
  })();
  function r(i) {
    return !!n && n in i;
  }
  return mp = r, mp;
}
var pp, p0;
function fF() {
  if (p0) return pp;
  p0 = 1;
  var e = Function.prototype, n = e.toString;
  function r(i) {
    if (i != null) {
      try {
        return n.call(i);
      } catch {
      }
      try {
        return i + "";
      } catch {
      }
    }
    return "";
  }
  return pp = r, pp;
}
var fp, f0;
function Y6() {
  if (f0) return fp;
  f0 = 1;
  var e = pF(), n = G6(), r = Va(), i = fF(), a = /[\\^$.*+?()[\]{}|]/g, o = /^\[object .+?Constructor\]$/, s = Function.prototype, l = Object.prototype, c = s.toString, m = l.hasOwnProperty, u = RegExp(
    "^" + c.call(m).replace(a, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function f(h) {
    if (!r(h) || n(h))
      return !1;
    var k = e(h) ? u : o;
    return k.test(i(h));
  }
  return fp = f, fp;
}
var hp, h0;
function J6() {
  if (h0) return hp;
  h0 = 1;
  function e(n, r) {
    return n?.[r];
  }
  return hp = e, hp;
}
var yp, y0;
function Qi() {
  if (y0) return yp;
  y0 = 1;
  var e = Y6(), n = J6();
  function r(i, a) {
    var o = n(i, a);
    return e(o) ? o : void 0;
  }
  return yp = r, yp;
}
var gp, g0;
function md() {
  if (g0) return gp;
  g0 = 1;
  var e = Qi(), n = e(Object, "create");
  return gp = n, gp;
}
var vp, v0;
function Q6() {
  if (v0) return vp;
  v0 = 1;
  var e = md();
  function n() {
    this.__data__ = e ? e(null) : {}, this.size = 0;
  }
  return vp = n, vp;
}
var kp, k0;
function X6() {
  if (k0) return kp;
  k0 = 1;
  function e(n) {
    var r = this.has(n) && delete this.__data__[n];
    return this.size -= r ? 1 : 0, r;
  }
  return kp = e, kp;
}
var bp, b0;
function Z6() {
  if (b0) return bp;
  b0 = 1;
  var e = md(), n = "__lodash_hash_undefined__", r = Object.prototype, i = r.hasOwnProperty;
  function a(o) {
    var s = this.__data__;
    if (e) {
      var l = s[o];
      return l === n ? void 0 : l;
    }
    return i.call(s, o) ? s[o] : void 0;
  }
  return bp = a, bp;
}
var _p, _0;
function eH() {
  if (_0) return _p;
  _0 = 1;
  var e = md(), n = Object.prototype, r = n.hasOwnProperty;
  function i(a) {
    var o = this.__data__;
    return e ? o[a] !== void 0 : r.call(o, a);
  }
  return _p = i, _p;
}
var xp, x0;
function nH() {
  if (x0) return xp;
  x0 = 1;
  var e = md(), n = "__lodash_hash_undefined__";
  function r(i, a) {
    var o = this.__data__;
    return this.size += this.has(i) ? 0 : 1, o[i] = e && a === void 0 ? n : a, this;
  }
  return xp = r, xp;
}
var Sp, S0;
function tH() {
  if (S0) return Sp;
  S0 = 1;
  var e = Q6(), n = X6(), r = Z6(), i = eH(), a = nH();
  function o(s) {
    var l = -1, c = s == null ? 0 : s.length;
    for (this.clear(); ++l < c; ) {
      var m = s[l];
      this.set(m[0], m[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = r, o.prototype.has = i, o.prototype.set = a, Sp = o, Sp;
}
var Np, N0;
function rH() {
  if (N0) return Np;
  N0 = 1;
  function e() {
    this.__data__ = [], this.size = 0;
  }
  return Np = e, Np;
}
var jp, j0;
function hF() {
  if (j0) return jp;
  j0 = 1;
  function e(n, r) {
    return n === r || n !== n && r !== r;
  }
  return jp = e, jp;
}
var wp, w0;
function pd() {
  if (w0) return wp;
  w0 = 1;
  var e = hF();
  function n(r, i) {
    for (var a = r.length; a--; )
      if (e(r[a][0], i))
        return a;
    return -1;
  }
  return wp = n, wp;
}
var Cp, C0;
function iH() {
  if (C0) return Cp;
  C0 = 1;
  var e = pd(), n = Array.prototype, r = n.splice;
  function i(a) {
    var o = this.__data__, s = e(o, a);
    if (s < 0)
      return !1;
    var l = o.length - 1;
    return s == l ? o.pop() : r.call(o, s, 1), --this.size, !0;
  }
  return Cp = i, Cp;
}
var Fp, F0;
function aH() {
  if (F0) return Fp;
  F0 = 1;
  var e = pd();
  function n(r) {
    var i = this.__data__, a = e(i, r);
    return a < 0 ? void 0 : i[a][1];
  }
  return Fp = n, Fp;
}
var Ip, I0;
function oH() {
  if (I0) return Ip;
  I0 = 1;
  var e = pd();
  function n(r) {
    return e(this.__data__, r) > -1;
  }
  return Ip = n, Ip;
}
var $p, $0;
function sH() {
  if ($0) return $p;
  $0 = 1;
  var e = pd();
  function n(r, i) {
    var a = this.__data__, o = e(a, r);
    return o < 0 ? (++this.size, a.push([r, i])) : a[o][1] = i, this;
  }
  return $p = n, $p;
}
var Ep, E0;
function fd() {
  if (E0) return Ep;
  E0 = 1;
  var e = rH(), n = iH(), r = aH(), i = oH(), a = sH();
  function o(s) {
    var l = -1, c = s == null ? 0 : s.length;
    for (this.clear(); ++l < c; ) {
      var m = s[l];
      this.set(m[0], m[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = r, o.prototype.has = i, o.prototype.set = a, Ep = o, Ep;
}
var Tp, T0;
function Lg() {
  if (T0) return Tp;
  T0 = 1;
  var e = Qi(), n = Jr(), r = e(n, "Map");
  return Tp = r, Tp;
}
var Rp, R0;
function lH() {
  if (R0) return Rp;
  R0 = 1;
  var e = tH(), n = fd(), r = Lg();
  function i() {
    this.size = 0, this.__data__ = {
      hash: new e(),
      map: new (r || n)(),
      string: new e()
    };
  }
  return Rp = i, Rp;
}
var Dp, D0;
function dH() {
  if (D0) return Dp;
  D0 = 1;
  function e(n) {
    var r = typeof n;
    return r == "string" || r == "number" || r == "symbol" || r == "boolean" ? n !== "__proto__" : n === null;
  }
  return Dp = e, Dp;
}
var Op, O0;
function hd() {
  if (O0) return Op;
  O0 = 1;
  var e = dH();
  function n(r, i) {
    var a = r.__data__;
    return e(i) ? a[typeof i == "string" ? "string" : "hash"] : a.map;
  }
  return Op = n, Op;
}
var Pp, P0;
function cH() {
  if (P0) return Pp;
  P0 = 1;
  var e = hd();
  function n(r) {
    var i = e(this, r).delete(r);
    return this.size -= i ? 1 : 0, i;
  }
  return Pp = n, Pp;
}
var Ap, A0;
function uH() {
  if (A0) return Ap;
  A0 = 1;
  var e = hd();
  function n(r) {
    return e(this, r).get(r);
  }
  return Ap = n, Ap;
}
var Lp, L0;
function mH() {
  if (L0) return Lp;
  L0 = 1;
  var e = hd();
  function n(r) {
    return e(this, r).has(r);
  }
  return Lp = n, Lp;
}
var Vp, V0;
function pH() {
  if (V0) return Vp;
  V0 = 1;
  var e = hd();
  function n(r, i) {
    var a = e(this, r), o = a.size;
    return a.set(r, i), this.size += a.size == o ? 0 : 1, this;
  }
  return Vp = n, Vp;
}
var zp, z0;
function yF() {
  if (z0) return zp;
  z0 = 1;
  var e = lH(), n = cH(), r = uH(), i = mH(), a = pH();
  function o(s) {
    var l = -1, c = s == null ? 0 : s.length;
    for (this.clear(); ++l < c; ) {
      var m = s[l];
      this.set(m[0], m[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = r, o.prototype.has = i, o.prototype.set = a, zp = o, zp;
}
var Up, U0;
function fH() {
  if (U0) return Up;
  U0 = 1;
  var e = yF(), n = "Expected a function";
  function r(i, a) {
    if (typeof i != "function" || a != null && typeof a != "function")
      throw new TypeError(n);
    var o = function() {
      var s = arguments, l = a ? a.apply(this, s) : s[0], c = o.cache;
      if (c.has(l))
        return c.get(l);
      var m = i.apply(this, s);
      return o.cache = c.set(l, m) || c, m;
    };
    return o.cache = new (r.Cache || e)(), o;
  }
  return r.Cache = e, Up = r, Up;
}
var Mp, M0;
function hH() {
  if (M0) return Mp;
  M0 = 1;
  var e = fH(), n = 500;
  function r(i) {
    var a = e(i, function(s) {
      return o.size === n && o.clear(), s;
    }), o = a.cache;
    return a;
  }
  return Mp = r, Mp;
}
var Bp, B0;
function yH() {
  if (B0) return Bp;
  B0 = 1;
  var e = hH(), n = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, r = /\\(\\)?/g, i = e(function(a) {
    var o = [];
    return a.charCodeAt(0) === 46 && o.push(""), a.replace(n, function(s, l, c, m) {
      o.push(c ? m.replace(r, "$1") : l || s);
    }), o;
  });
  return Bp = i, Bp;
}
var qp, q0;
function gF() {
  if (q0) return qp;
  q0 = 1;
  function e(n, r) {
    for (var i = -1, a = n == null ? 0 : n.length, o = Array(a); ++i < a; )
      o[i] = r(n[i], i, n);
    return o;
  }
  return qp = e, qp;
}
var Hp, H0;
function gH() {
  if (H0) return Hp;
  H0 = 1;
  var e = os(), n = gF(), r = xi(), i = Ag(), a = e ? e.prototype : void 0, o = a ? a.toString : void 0;
  function s(l) {
    if (typeof l == "string")
      return l;
    if (r(l))
      return n(l, s) + "";
    if (i(l))
      return o ? o.call(l) : "";
    var c = l + "";
    return c == "0" && 1 / l == -1 / 0 ? "-0" : c;
  }
  return Hp = s, Hp;
}
var Wp, W0;
function vH() {
  if (W0) return Wp;
  W0 = 1;
  var e = gH();
  function n(r) {
    return r == null ? "" : e(r);
  }
  return Wp = n, Wp;
}
var Kp, K0;
function za() {
  if (K0) return Kp;
  K0 = 1;
  var e = xi(), n = W6(), r = yH(), i = vH();
  function a(o, s) {
    return e(o) ? o : n(o, s) ? [o] : r(i(o));
  }
  return Kp = a, Kp;
}
var Gp, G0;
function yd() {
  if (G0) return Gp;
  G0 = 1;
  var e = Ag();
  function n(r) {
    if (typeof r == "string" || e(r))
      return r;
    var i = r + "";
    return i == "0" && 1 / r == -1 / 0 ? "-0" : i;
  }
  return Gp = n, Gp;
}
var Yp, Y0;
function vF() {
  if (Y0) return Yp;
  Y0 = 1;
  var e = za(), n = yd();
  function r(i, a) {
    a = e(a, i);
    for (var o = 0, s = a.length; i != null && o < s; )
      i = i[n(a[o++])];
    return o && o == s ? i : void 0;
  }
  return Yp = r, Yp;
}
var Jp, J0;
function kF() {
  if (J0) return Jp;
  J0 = 1;
  var e = Qi(), n = (function() {
    try {
      var r = e(Object, "defineProperty");
      return r({}, "", {}), r;
    } catch {
    }
  })();
  return Jp = n, Jp;
}
var Qp, Q0;
function bF() {
  if (Q0) return Qp;
  Q0 = 1;
  var e = kF();
  function n(r, i, a) {
    i == "__proto__" && e ? e(r, i, {
      configurable: !0,
      enumerable: !0,
      value: a,
      writable: !0
    }) : r[i] = a;
  }
  return Qp = n, Qp;
}
var Xp, X0;
function Vg() {
  if (X0) return Xp;
  X0 = 1;
  var e = bF(), n = hF(), r = Object.prototype, i = r.hasOwnProperty;
  function a(o, s, l) {
    var c = o[s];
    (!(i.call(o, s) && n(c, l)) || l === void 0 && !(s in o)) && e(o, s, l);
  }
  return Xp = a, Xp;
}
var Zp, Z0;
function zg() {
  if (Z0) return Zp;
  Z0 = 1;
  var e = 9007199254740991, n = /^(?:0|[1-9]\d*)$/;
  function r(i, a) {
    var o = typeof i;
    return a = a ?? e, !!a && (o == "number" || o != "symbol" && n.test(i)) && i > -1 && i % 1 == 0 && i < a;
  }
  return Zp = r, Zp;
}
var ef, eN;
function kH() {
  if (eN) return ef;
  eN = 1;
  var e = Vg(), n = za(), r = zg(), i = Va(), a = yd();
  function o(s, l, c, m) {
    if (!i(s))
      return s;
    l = n(l, s);
    for (var u = -1, f = l.length, h = f - 1, k = s; k != null && ++u < f; ) {
      var w = a(l[u]), N = c;
      if (w === "__proto__" || w === "constructor" || w === "prototype")
        return s;
      if (u != h) {
        var j = k[w];
        N = m ? m(j, w, k) : void 0, N === void 0 && (N = i(j) ? j : r(l[u + 1]) ? [] : {});
      }
      e(k, w, N), k = k[w];
    }
    return s;
  }
  return ef = o, ef;
}
var nf, nN;
function bH() {
  if (nN) return nf;
  nN = 1;
  var e = vF(), n = kH(), r = za();
  function i(a, o, s) {
    for (var l = -1, c = o.length, m = {}; ++l < c; ) {
      var u = o[l], f = e(a, u);
      s(f, u) && n(m, r(u, a), f);
    }
    return m;
  }
  return nf = i, nf;
}
var tf, tN;
function _H() {
  if (tN) return tf;
  tN = 1;
  function e(n, r) {
    return n != null && r in Object(n);
  }
  return tf = e, tf;
}
var rf, rN;
function xH() {
  if (rN) return rf;
  rN = 1;
  var e = La(), n = Ji(), r = "[object Arguments]";
  function i(a) {
    return n(a) && e(a) == r;
  }
  return rf = i, rf;
}
var af, iN;
function Ug() {
  if (iN) return af;
  iN = 1;
  var e = xH(), n = Ji(), r = Object.prototype, i = r.hasOwnProperty, a = r.propertyIsEnumerable, o = e(/* @__PURE__ */ (function() {
    return arguments;
  })()) ? e : function(s) {
    return n(s) && i.call(s, "callee") && !a.call(s, "callee");
  };
  return af = o, af;
}
var of, aN;
function Mg() {
  if (aN) return of;
  aN = 1;
  var e = 9007199254740991;
  function n(r) {
    return typeof r == "number" && r > -1 && r % 1 == 0 && r <= e;
  }
  return of = n, of;
}
var sf, oN;
function SH() {
  if (oN) return sf;
  oN = 1;
  var e = za(), n = Ug(), r = xi(), i = zg(), a = Mg(), o = yd();
  function s(l, c, m) {
    c = e(c, l);
    for (var u = -1, f = c.length, h = !1; ++u < f; ) {
      var k = o(c[u]);
      if (!(h = l != null && m(l, k)))
        break;
      l = l[k];
    }
    return h || ++u != f ? h : (f = l == null ? 0 : l.length, !!f && a(f) && i(k, f) && (r(l) || n(l)));
  }
  return sf = s, sf;
}
var lf, sN;
function NH() {
  if (sN) return lf;
  sN = 1;
  var e = _H(), n = SH();
  function r(i, a) {
    return i != null && n(i, a, e);
  }
  return lf = r, lf;
}
var df, lN;
function jH() {
  if (lN) return df;
  lN = 1;
  var e = bH(), n = NH();
  function r(i, a) {
    return e(i, a, function(o, s) {
      return n(i, s);
    });
  }
  return df = r, df;
}
var cf, dN;
function Bg() {
  if (dN) return cf;
  dN = 1;
  function e(n, r) {
    for (var i = -1, a = r.length, o = n.length; ++i < a; )
      n[o + i] = r[i];
    return n;
  }
  return cf = e, cf;
}
var uf, cN;
function wH() {
  if (cN) return uf;
  cN = 1;
  var e = os(), n = Ug(), r = xi(), i = e ? e.isConcatSpreadable : void 0;
  function a(o) {
    return r(o) || n(o) || !!(i && o && o[i]);
  }
  return uf = a, uf;
}
var mf, uN;
function CH() {
  if (uN) return mf;
  uN = 1;
  var e = Bg(), n = wH();
  function r(i, a, o, s, l) {
    var c = -1, m = i.length;
    for (o || (o = n), l || (l = []); ++c < m; ) {
      var u = i[c];
      a > 0 && o(u) ? a > 1 ? r(u, a - 1, o, s, l) : e(l, u) : s || (l[l.length] = u);
    }
    return l;
  }
  return mf = r, mf;
}
var pf, mN;
function FH() {
  if (mN) return pf;
  mN = 1;
  var e = CH();
  function n(r) {
    var i = r == null ? 0 : r.length;
    return i ? e(r, 1) : [];
  }
  return pf = n, pf;
}
var ff, pN;
function IH() {
  if (pN) return ff;
  pN = 1;
  function e(n, r, i) {
    switch (i.length) {
      case 0:
        return n.call(r);
      case 1:
        return n.call(r, i[0]);
      case 2:
        return n.call(r, i[0], i[1]);
      case 3:
        return n.call(r, i[0], i[1], i[2]);
    }
    return n.apply(r, i);
  }
  return ff = e, ff;
}
var hf, fN;
function $H() {
  if (fN) return hf;
  fN = 1;
  var e = IH(), n = Math.max;
  function r(i, a, o) {
    return a = n(a === void 0 ? i.length - 1 : a, 0), function() {
      for (var s = arguments, l = -1, c = n(s.length - a, 0), m = Array(c); ++l < c; )
        m[l] = s[a + l];
      l = -1;
      for (var u = Array(a + 1); ++l < a; )
        u[l] = s[l];
      return u[a] = o(m), e(i, this, u);
    };
  }
  return hf = r, hf;
}
var yf, hN;
function EH() {
  if (hN) return yf;
  hN = 1;
  function e(n) {
    return function() {
      return n;
    };
  }
  return yf = e, yf;
}
var gf, yN;
function _F() {
  if (yN) return gf;
  yN = 1;
  function e(n) {
    return n;
  }
  return gf = e, gf;
}
var vf, gN;
function TH() {
  if (gN) return vf;
  gN = 1;
  var e = EH(), n = kF(), r = _F(), i = n ? function(a, o) {
    return n(a, "toString", {
      configurable: !0,
      enumerable: !1,
      value: e(o),
      writable: !0
    });
  } : r;
  return vf = i, vf;
}
var kf, vN;
function RH() {
  if (vN) return kf;
  vN = 1;
  var e = 800, n = 16, r = Date.now;
  function i(a) {
    var o = 0, s = 0;
    return function() {
      var l = r(), c = n - (l - s);
      if (s = l, c > 0) {
        if (++o >= e)
          return arguments[0];
      } else
        o = 0;
      return a.apply(void 0, arguments);
    };
  }
  return kf = i, kf;
}
var bf, kN;
function DH() {
  if (kN) return bf;
  kN = 1;
  var e = TH(), n = RH(), r = n(e);
  return bf = r, bf;
}
var _f, bN;
function xF() {
  if (bN) return _f;
  bN = 1;
  var e = FH(), n = $H(), r = DH();
  function i(a) {
    return r(n(a, void 0, e), a + "");
  }
  return _f = i, _f;
}
var xf, _N;
function OH() {
  if (_N) return xf;
  _N = 1;
  var e = jH(), n = xF(), r = n(function(i, a) {
    return i == null ? {} : e(i, a);
  });
  return xf = r, xf;
}
var PH = OH();
const SF = /* @__PURE__ */ uF(PH), AH = [
  "control",
  "defaultValue",
  "name",
  "rules",
  "shouldUnregister"
];
function NF(e) {
  const n = SF(e, AH);
  return {
    controller: N6(n),
    controllerProps: n
  };
}
const LH = [
  "className",
  "description",
  "disabled",
  "helpIcon",
  "label",
  "noAlert",
  "noLabel",
  "style"
];
function VH(e) {
  const { controller: n, controllerProps: r } = NF(e), i = {
    ...SF(e, LH),
    required: B6(r.rules?.required),
    meta: {
      touched: n.fieldState.isTouched,
      error: n.fieldState.error?.message,
      success: e.meta?.success,
      warning: e.meta?.warning
    },
    labelFor: r.name,
    noLabel: e.noLabel,
    noAlert: e.noAlert
  };
  return {
    controller: n,
    controllerProps: r,
    fieldWrapperProps: i
  };
}
var Sf, xN;
function zH() {
  if (xN) return Sf;
  xN = 1;
  var e = fd();
  function n() {
    this.__data__ = new e(), this.size = 0;
  }
  return Sf = n, Sf;
}
var Nf, SN;
function UH() {
  if (SN) return Nf;
  SN = 1;
  function e(n) {
    var r = this.__data__, i = r.delete(n);
    return this.size = r.size, i;
  }
  return Nf = e, Nf;
}
var jf, NN;
function MH() {
  if (NN) return jf;
  NN = 1;
  function e(n) {
    return this.__data__.get(n);
  }
  return jf = e, jf;
}
var wf, jN;
function BH() {
  if (jN) return wf;
  jN = 1;
  function e(n) {
    return this.__data__.has(n);
  }
  return wf = e, wf;
}
var Cf, wN;
function qH() {
  if (wN) return Cf;
  wN = 1;
  var e = fd(), n = Lg(), r = yF(), i = 200;
  function a(o, s) {
    var l = this.__data__;
    if (l instanceof e) {
      var c = l.__data__;
      if (!n || c.length < i - 1)
        return c.push([o, s]), this.size = ++l.size, this;
      l = this.__data__ = new r(c);
    }
    return l.set(o, s), this.size = l.size, this;
  }
  return Cf = a, Cf;
}
var Ff, CN;
function HH() {
  if (CN) return Ff;
  CN = 1;
  var e = fd(), n = zH(), r = UH(), i = MH(), a = BH(), o = qH();
  function s(l) {
    var c = this.__data__ = new e(l);
    this.size = c.size;
  }
  return s.prototype.clear = n, s.prototype.delete = r, s.prototype.get = i, s.prototype.has = a, s.prototype.set = o, Ff = s, Ff;
}
var If, FN;
function WH() {
  if (FN) return If;
  FN = 1;
  function e(n, r) {
    for (var i = -1, a = n == null ? 0 : n.length; ++i < a && r(n[i], i, n) !== !1; )
      ;
    return n;
  }
  return If = e, If;
}
var $f, IN;
function ss() {
  if (IN) return $f;
  IN = 1;
  var e = Vg(), n = bF();
  function r(i, a, o, s) {
    var l = !o;
    o || (o = {});
    for (var c = -1, m = a.length; ++c < m; ) {
      var u = a[c], f = s ? s(o[u], i[u], u, o, i) : void 0;
      f === void 0 && (f = i[u]), l ? n(o, u, f) : e(o, u, f);
    }
    return o;
  }
  return $f = r, $f;
}
var Ef, $N;
function KH() {
  if ($N) return Ef;
  $N = 1;
  function e(n, r) {
    for (var i = -1, a = Array(n); ++i < n; )
      a[i] = r(i);
    return a;
  }
  return Ef = e, Ef;
}
var ol = { exports: {} }, Tf, EN;
function GH() {
  if (EN) return Tf;
  EN = 1;
  function e() {
    return !1;
  }
  return Tf = e, Tf;
}
ol.exports;
var TN;
function jF() {
  return TN || (TN = 1, (function(e, n) {
    var r = Jr(), i = GH(), a = n && !n.nodeType && n, o = a && !0 && e && !e.nodeType && e, s = o && o.exports === a, l = s ? r.Buffer : void 0, c = l ? l.isBuffer : void 0, m = c || i;
    e.exports = m;
  })(ol, ol.exports)), ol.exports;
}
var Rf, RN;
function YH() {
  if (RN) return Rf;
  RN = 1;
  var e = La(), n = Mg(), r = Ji(), i = "[object Arguments]", a = "[object Array]", o = "[object Boolean]", s = "[object Date]", l = "[object Error]", c = "[object Function]", m = "[object Map]", u = "[object Number]", f = "[object Object]", h = "[object RegExp]", k = "[object Set]", w = "[object String]", N = "[object WeakMap]", j = "[object ArrayBuffer]", _ = "[object DataView]", g = "[object Float32Array]", O = "[object Float64Array]", R = "[object Int8Array]", F = "[object Int16Array]", I = "[object Int32Array]", L = "[object Uint8Array]", W = "[object Uint8ClampedArray]", J = "[object Uint16Array]", re = "[object Uint32Array]", K = {};
  K[g] = K[O] = K[R] = K[F] = K[I] = K[L] = K[W] = K[J] = K[re] = !0, K[i] = K[a] = K[j] = K[o] = K[_] = K[s] = K[l] = K[c] = K[m] = K[u] = K[f] = K[h] = K[k] = K[w] = K[N] = !1;
  function Y(P) {
    return r(P) && n(P.length) && !!K[e(P)];
  }
  return Rf = Y, Rf;
}
var Df, DN;
function qg() {
  if (DN) return Df;
  DN = 1;
  function e(n) {
    return function(r) {
      return n(r);
    };
  }
  return Df = e, Df;
}
var sl = { exports: {} };
sl.exports;
var ON;
function Hg() {
  return ON || (ON = 1, (function(e, n) {
    var r = mF(), i = n && !n.nodeType && n, a = i && !0 && e && !e.nodeType && e, o = a && a.exports === i, s = o && r.process, l = (function() {
      try {
        var c = a && a.require && a.require("util").types;
        return c || s && s.binding && s.binding("util");
      } catch {
      }
    })();
    e.exports = l;
  })(sl, sl.exports)), sl.exports;
}
var Of, PN;
function JH() {
  if (PN) return Of;
  PN = 1;
  var e = YH(), n = qg(), r = Hg(), i = r && r.isTypedArray, a = i ? n(i) : e;
  return Of = a, Of;
}
var Pf, AN;
function wF() {
  if (AN) return Pf;
  AN = 1;
  var e = KH(), n = Ug(), r = xi(), i = jF(), a = zg(), o = JH(), s = Object.prototype, l = s.hasOwnProperty;
  function c(m, u) {
    var f = r(m), h = !f && n(m), k = !f && !h && i(m), w = !f && !h && !k && o(m), N = f || h || k || w, j = N ? e(m.length, String) : [], _ = j.length;
    for (var g in m)
      (u || l.call(m, g)) && !(N && // Safari 9 has enumerable `arguments.length` in strict mode.
      (g == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      k && (g == "offset" || g == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      w && (g == "buffer" || g == "byteLength" || g == "byteOffset") || // Skip index properties.
      a(g, _))) && j.push(g);
    return j;
  }
  return Pf = c, Pf;
}
var Af, LN;
function Wg() {
  if (LN) return Af;
  LN = 1;
  var e = Object.prototype;
  function n(r) {
    var i = r && r.constructor, a = typeof i == "function" && i.prototype || e;
    return r === a;
  }
  return Af = n, Af;
}
var Lf, VN;
function CF() {
  if (VN) return Lf;
  VN = 1;
  function e(n, r) {
    return function(i) {
      return n(r(i));
    };
  }
  return Lf = e, Lf;
}
var Vf, zN;
function QH() {
  if (zN) return Vf;
  zN = 1;
  var e = CF(), n = e(Object.keys, Object);
  return Vf = n, Vf;
}
var zf, UN;
function XH() {
  if (UN) return zf;
  UN = 1;
  var e = Wg(), n = QH(), r = Object.prototype, i = r.hasOwnProperty;
  function a(o) {
    if (!e(o))
      return n(o);
    var s = [];
    for (var l in Object(o))
      i.call(o, l) && l != "constructor" && s.push(l);
    return s;
  }
  return zf = a, zf;
}
var Uf, MN;
function FF() {
  if (MN) return Uf;
  MN = 1;
  var e = pF(), n = Mg();
  function r(i) {
    return i != null && n(i.length) && !e(i);
  }
  return Uf = r, Uf;
}
var Mf, BN;
function Kg() {
  if (BN) return Mf;
  BN = 1;
  var e = wF(), n = XH(), r = FF();
  function i(a) {
    return r(a) ? e(a) : n(a);
  }
  return Mf = i, Mf;
}
var Bf, qN;
function ZH() {
  if (qN) return Bf;
  qN = 1;
  var e = ss(), n = Kg();
  function r(i, a) {
    return i && e(a, n(a), i);
  }
  return Bf = r, Bf;
}
var qf, HN;
function eW() {
  if (HN) return qf;
  HN = 1;
  function e(n) {
    var r = [];
    if (n != null)
      for (var i in Object(n))
        r.push(i);
    return r;
  }
  return qf = e, qf;
}
var Hf, WN;
function nW() {
  if (WN) return Hf;
  WN = 1;
  var e = Va(), n = Wg(), r = eW(), i = Object.prototype, a = i.hasOwnProperty;
  function o(s) {
    if (!e(s))
      return r(s);
    var l = n(s), c = [];
    for (var m in s)
      m == "constructor" && (l || !a.call(s, m)) || c.push(m);
    return c;
  }
  return Hf = o, Hf;
}
var Wf, KN;
function Gg() {
  if (KN) return Wf;
  KN = 1;
  var e = wF(), n = nW(), r = FF();
  function i(a) {
    return r(a) ? e(a, !0) : n(a);
  }
  return Wf = i, Wf;
}
var Kf, GN;
function tW() {
  if (GN) return Kf;
  GN = 1;
  var e = ss(), n = Gg();
  function r(i, a) {
    return i && e(a, n(a), i);
  }
  return Kf = r, Kf;
}
var ll = { exports: {} };
ll.exports;
var YN;
function rW() {
  return YN || (YN = 1, (function(e, n) {
    var r = Jr(), i = n && !n.nodeType && n, a = i && !0 && e && !e.nodeType && e, o = a && a.exports === i, s = o ? r.Buffer : void 0, l = s ? s.allocUnsafe : void 0;
    function c(m, u) {
      if (u)
        return m.slice();
      var f = m.length, h = l ? l(f) : new m.constructor(f);
      return m.copy(h), h;
    }
    e.exports = c;
  })(ll, ll.exports)), ll.exports;
}
var Gf, JN;
function iW() {
  if (JN) return Gf;
  JN = 1;
  function e(n, r) {
    var i = -1, a = n.length;
    for (r || (r = Array(a)); ++i < a; )
      r[i] = n[i];
    return r;
  }
  return Gf = e, Gf;
}
var Yf, QN;
function aW() {
  if (QN) return Yf;
  QN = 1;
  function e(n, r) {
    for (var i = -1, a = n == null ? 0 : n.length, o = 0, s = []; ++i < a; ) {
      var l = n[i];
      r(l, i, n) && (s[o++] = l);
    }
    return s;
  }
  return Yf = e, Yf;
}
var Jf, XN;
function IF() {
  if (XN) return Jf;
  XN = 1;
  function e() {
    return [];
  }
  return Jf = e, Jf;
}
var Qf, ZN;
function Yg() {
  if (ZN) return Qf;
  ZN = 1;
  var e = aW(), n = IF(), r = Object.prototype, i = r.propertyIsEnumerable, a = Object.getOwnPropertySymbols, o = a ? function(s) {
    return s == null ? [] : (s = Object(s), e(a(s), function(l) {
      return i.call(s, l);
    }));
  } : n;
  return Qf = o, Qf;
}
var Xf, ej;
function oW() {
  if (ej) return Xf;
  ej = 1;
  var e = ss(), n = Yg();
  function r(i, a) {
    return e(i, n(i), a);
  }
  return Xf = r, Xf;
}
var Zf, nj;
function Jg() {
  if (nj) return Zf;
  nj = 1;
  var e = CF(), n = e(Object.getPrototypeOf, Object);
  return Zf = n, Zf;
}
var eh, tj;
function $F() {
  if (tj) return eh;
  tj = 1;
  var e = Bg(), n = Jg(), r = Yg(), i = IF(), a = Object.getOwnPropertySymbols, o = a ? function(s) {
    for (var l = []; s; )
      e(l, r(s)), s = n(s);
    return l;
  } : i;
  return eh = o, eh;
}
var nh, rj;
function sW() {
  if (rj) return nh;
  rj = 1;
  var e = ss(), n = $F();
  function r(i, a) {
    return e(i, n(i), a);
  }
  return nh = r, nh;
}
var th, ij;
function EF() {
  if (ij) return th;
  ij = 1;
  var e = Bg(), n = xi();
  function r(i, a, o) {
    var s = a(i);
    return n(i) ? s : e(s, o(i));
  }
  return th = r, th;
}
var rh, aj;
function lW() {
  if (aj) return rh;
  aj = 1;
  var e = EF(), n = Yg(), r = Kg();
  function i(a) {
    return e(a, r, n);
  }
  return rh = i, rh;
}
var ih, oj;
function TF() {
  if (oj) return ih;
  oj = 1;
  var e = EF(), n = $F(), r = Gg();
  function i(a) {
    return e(a, r, n);
  }
  return ih = i, ih;
}
var ah, sj;
function dW() {
  if (sj) return ah;
  sj = 1;
  var e = Qi(), n = Jr(), r = e(n, "DataView");
  return ah = r, ah;
}
var oh, lj;
function cW() {
  if (lj) return oh;
  lj = 1;
  var e = Qi(), n = Jr(), r = e(n, "Promise");
  return oh = r, oh;
}
var sh, dj;
function uW() {
  if (dj) return sh;
  dj = 1;
  var e = Qi(), n = Jr(), r = e(n, "Set");
  return sh = r, sh;
}
var lh, cj;
function mW() {
  if (cj) return lh;
  cj = 1;
  var e = Qi(), n = Jr(), r = e(n, "WeakMap");
  return lh = r, lh;
}
var dh, uj;
function Qg() {
  if (uj) return dh;
  uj = 1;
  var e = dW(), n = Lg(), r = cW(), i = uW(), a = mW(), o = La(), s = fF(), l = "[object Map]", c = "[object Object]", m = "[object Promise]", u = "[object Set]", f = "[object WeakMap]", h = "[object DataView]", k = s(e), w = s(n), N = s(r), j = s(i), _ = s(a), g = o;
  return (e && g(new e(new ArrayBuffer(1))) != h || n && g(new n()) != l || r && g(r.resolve()) != m || i && g(new i()) != u || a && g(new a()) != f) && (g = function(O) {
    var R = o(O), F = R == c ? O.constructor : void 0, I = F ? s(F) : "";
    if (I)
      switch (I) {
        case k:
          return h;
        case w:
          return l;
        case N:
          return m;
        case j:
          return u;
        case _:
          return f;
      }
    return R;
  }), dh = g, dh;
}
var ch, mj;
function pW() {
  if (mj) return ch;
  mj = 1;
  var e = Object.prototype, n = e.hasOwnProperty;
  function r(i) {
    var a = i.length, o = new i.constructor(a);
    return a && typeof i[0] == "string" && n.call(i, "index") && (o.index = i.index, o.input = i.input), o;
  }
  return ch = r, ch;
}
var uh, pj;
function fW() {
  if (pj) return uh;
  pj = 1;
  var e = Jr(), n = e.Uint8Array;
  return uh = n, uh;
}
var mh, fj;
function Xg() {
  if (fj) return mh;
  fj = 1;
  var e = fW();
  function n(r) {
    var i = new r.constructor(r.byteLength);
    return new e(i).set(new e(r)), i;
  }
  return mh = n, mh;
}
var ph, hj;
function hW() {
  if (hj) return ph;
  hj = 1;
  var e = Xg();
  function n(r, i) {
    var a = i ? e(r.buffer) : r.buffer;
    return new r.constructor(a, r.byteOffset, r.byteLength);
  }
  return ph = n, ph;
}
var fh, yj;
function yW() {
  if (yj) return fh;
  yj = 1;
  var e = /\w*$/;
  function n(r) {
    var i = new r.constructor(r.source, e.exec(r));
    return i.lastIndex = r.lastIndex, i;
  }
  return fh = n, fh;
}
var hh, gj;
function gW() {
  if (gj) return hh;
  gj = 1;
  var e = os(), n = e ? e.prototype : void 0, r = n ? n.valueOf : void 0;
  function i(a) {
    return r ? Object(r.call(a)) : {};
  }
  return hh = i, hh;
}
var yh, vj;
function vW() {
  if (vj) return yh;
  vj = 1;
  var e = Xg();
  function n(r, i) {
    var a = i ? e(r.buffer) : r.buffer;
    return new r.constructor(a, r.byteOffset, r.length);
  }
  return yh = n, yh;
}
var gh, kj;
function kW() {
  if (kj) return gh;
  kj = 1;
  var e = Xg(), n = hW(), r = yW(), i = gW(), a = vW(), o = "[object Boolean]", s = "[object Date]", l = "[object Map]", c = "[object Number]", m = "[object RegExp]", u = "[object Set]", f = "[object String]", h = "[object Symbol]", k = "[object ArrayBuffer]", w = "[object DataView]", N = "[object Float32Array]", j = "[object Float64Array]", _ = "[object Int8Array]", g = "[object Int16Array]", O = "[object Int32Array]", R = "[object Uint8Array]", F = "[object Uint8ClampedArray]", I = "[object Uint16Array]", L = "[object Uint32Array]";
  function W(J, re, K) {
    var Y = J.constructor;
    switch (re) {
      case k:
        return e(J);
      case o:
      case s:
        return new Y(+J);
      case w:
        return n(J, K);
      case N:
      case j:
      case _:
      case g:
      case O:
      case R:
      case F:
      case I:
      case L:
        return a(J, K);
      case l:
        return new Y();
      case c:
      case f:
        return new Y(J);
      case m:
        return r(J);
      case u:
        return new Y();
      case h:
        return i(J);
    }
  }
  return gh = W, gh;
}
var vh, bj;
function bW() {
  if (bj) return vh;
  bj = 1;
  var e = Va(), n = Object.create, r = /* @__PURE__ */ (function() {
    function i() {
    }
    return function(a) {
      if (!e(a))
        return {};
      if (n)
        return n(a);
      i.prototype = a;
      var o = new i();
      return i.prototype = void 0, o;
    };
  })();
  return vh = r, vh;
}
var kh, _j;
function _W() {
  if (_j) return kh;
  _j = 1;
  var e = bW(), n = Jg(), r = Wg();
  function i(a) {
    return typeof a.constructor == "function" && !r(a) ? e(n(a)) : {};
  }
  return kh = i, kh;
}
var bh, xj;
function xW() {
  if (xj) return bh;
  xj = 1;
  var e = Qg(), n = Ji(), r = "[object Map]";
  function i(a) {
    return n(a) && e(a) == r;
  }
  return bh = i, bh;
}
var _h, Sj;
function SW() {
  if (Sj) return _h;
  Sj = 1;
  var e = xW(), n = qg(), r = Hg(), i = r && r.isMap, a = i ? n(i) : e;
  return _h = a, _h;
}
var xh, Nj;
function NW() {
  if (Nj) return xh;
  Nj = 1;
  var e = Qg(), n = Ji(), r = "[object Set]";
  function i(a) {
    return n(a) && e(a) == r;
  }
  return xh = i, xh;
}
var Sh, jj;
function jW() {
  if (jj) return Sh;
  jj = 1;
  var e = NW(), n = qg(), r = Hg(), i = r && r.isSet, a = i ? n(i) : e;
  return Sh = a, Sh;
}
var Nh, wj;
function wW() {
  if (wj) return Nh;
  wj = 1;
  var e = HH(), n = WH(), r = Vg(), i = ZH(), a = tW(), o = rW(), s = iW(), l = oW(), c = sW(), m = lW(), u = TF(), f = Qg(), h = pW(), k = kW(), w = _W(), N = xi(), j = jF(), _ = SW(), g = Va(), O = jW(), R = Kg(), F = Gg(), I = 1, L = 2, W = 4, J = "[object Arguments]", re = "[object Array]", K = "[object Boolean]", Y = "[object Date]", P = "[object Error]", B = "[object Function]", ie = "[object GeneratorFunction]", we = "[object Map]", me = "[object Number]", le = "[object Object]", ge = "[object RegExp]", V = "[object Set]", be = "[object String]", Oe = "[object Symbol]", q = "[object WeakMap]", Ge = "[object ArrayBuffer]", sn = "[object DataView]", Ie = "[object Float32Array]", Ue = "[object Float64Array]", De = "[object Int8Array]", Be = "[object Int16Array]", Ae = "[object Int32Array]", Je = "[object Uint8Array]", Ee = "[object Uint8ClampedArray]", Me = "[object Uint16Array]", en = "[object Uint32Array]", se = {};
  se[J] = se[re] = se[Ge] = se[sn] = se[K] = se[Y] = se[Ie] = se[Ue] = se[De] = se[Be] = se[Ae] = se[we] = se[me] = se[le] = se[ge] = se[V] = se[be] = se[Oe] = se[Je] = se[Ee] = se[Me] = se[en] = !0, se[P] = se[B] = se[q] = !1;
  function de(Se, Ve, Pe, kn, Q, E) {
    var z, ae = Ve & I, ce = Ve & L, U = Ve & W;
    if (Pe && (z = Q ? Pe(Se, kn, Q, E) : Pe(Se)), z !== void 0)
      return z;
    if (!g(Se))
      return Se;
    var G = N(Se);
    if (G) {
      if (z = h(Se), !ae)
        return s(Se, z);
    } else {
      var ve = f(Se), je = ve == B || ve == ie;
      if (j(Se))
        return o(Se, ae);
      if (ve == le || ve == J || je && !Q) {
        if (z = ce || je ? {} : w(Se), !ae)
          return ce ? c(Se, a(z, Se)) : l(Se, i(z, Se));
      } else {
        if (!se[ve])
          return Q ? Se : {};
        z = k(Se, ve, ae);
      }
    }
    E || (E = new e());
    var Re = E.get(Se);
    if (Re)
      return Re;
    E.set(Se, z), O(Se) ? Se.forEach(function(an) {
      z.add(de(an, Ve, Pe, an, Se, E));
    }) : _(Se) && Se.forEach(function(an, fn) {
      z.set(fn, de(an, Ve, Pe, fn, Se, E));
    });
    var rn = U ? ce ? u : m : ce ? F : R, bn = G ? void 0 : rn(Se);
    return n(bn || Se, function(an, fn) {
      bn && (fn = an, an = Se[fn]), r(z, fn, de(an, Ve, Pe, fn, Se, E));
    }), z;
  }
  return Nh = de, Nh;
}
var jh, Cj;
function CW() {
  if (Cj) return jh;
  Cj = 1;
  function e(n) {
    var r = n == null ? 0 : n.length;
    return r ? n[r - 1] : void 0;
  }
  return jh = e, jh;
}
var wh, Fj;
function FW() {
  if (Fj) return wh;
  Fj = 1;
  function e(n, r, i) {
    var a = -1, o = n.length;
    r < 0 && (r = -r > o ? 0 : o + r), i = i > o ? o : i, i < 0 && (i += o), o = r > i ? 0 : i - r >>> 0, r >>>= 0;
    for (var s = Array(o); ++a < o; )
      s[a] = n[a + r];
    return s;
  }
  return wh = e, wh;
}
var Ch, Ij;
function IW() {
  if (Ij) return Ch;
  Ij = 1;
  var e = vF(), n = FW();
  function r(i, a) {
    return a.length < 2 ? i : e(i, n(a, 0, -1));
  }
  return Ch = r, Ch;
}
var Fh, $j;
function $W() {
  if ($j) return Fh;
  $j = 1;
  var e = za(), n = CW(), r = IW(), i = yd(), a = Object.prototype, o = a.hasOwnProperty;
  function s(l, c) {
    c = e(c, l);
    var m = -1, u = c.length;
    if (!u)
      return !0;
    for (; ++m < u; ) {
      var f = i(c[m]);
      if (f === "__proto__" && !o.call(l, "__proto__") || (f === "constructor" || f === "prototype") && m < u - 1)
        return !1;
    }
    var h = r(l, c);
    return h == null || delete h[i(n(c))];
  }
  return Fh = s, Fh;
}
var Ih, Ej;
function EW() {
  if (Ej) return Ih;
  Ej = 1;
  var e = La(), n = Jg(), r = Ji(), i = "[object Object]", a = Function.prototype, o = Object.prototype, s = a.toString, l = o.hasOwnProperty, c = s.call(Object);
  function m(u) {
    if (!r(u) || e(u) != i)
      return !1;
    var f = n(u);
    if (f === null)
      return !0;
    var h = l.call(f, "constructor") && f.constructor;
    return typeof h == "function" && h instanceof h && s.call(h) == c;
  }
  return Ih = m, Ih;
}
var $h, Tj;
function TW() {
  if (Tj) return $h;
  Tj = 1;
  var e = EW();
  function n(r) {
    return e(r) ? void 0 : r;
  }
  return $h = n, $h;
}
var Eh, Rj;
function RW() {
  if (Rj) return Eh;
  Rj = 1;
  var e = gF(), n = wW(), r = $W(), i = za(), a = ss(), o = TW(), s = xF(), l = TF(), c = 1, m = 2, u = 4, f = s(function(h, k) {
    var w = {};
    if (h == null)
      return w;
    var N = !1;
    k = e(k, function(_) {
      return _ = i(_, h), N || (N = _.length > 1), _;
    }), a(h, l(h), w), N && (w = n(w, c | m | u, o));
    for (var j = k.length; j--; )
      r(w, k[j]);
    return w;
  });
  return Eh = f, Eh;
}
RW();
var DW = _F();
const OW = /* @__PURE__ */ uF(DW), da = ({
  transformValue: e = OW,
  label: n,
  helpIcon: r,
  className: i,
  ...a
}) => {
  const {
    controller: { field: o },
    controllerProps: { name: s }
  } = NF(a);
  return /* @__PURE__ */ Ao.jsxs(b, { gap: "200", alignItems: "center", className: i, children: [
    /* @__PURE__ */ Ao.jsx(
      Vo,
      {
        ...o,
        id: s,
        checked: e(o.value),
        disabled: a.componentProps?.disabled,
        onChange: (l) => {
          a.componentProps?.onChange?.(l), o.onChange(e(l.target.checked));
        }
      }
    ),
    n && /* @__PURE__ */ Ao.jsx(jw, { htmlFor: s, helpIcon: r, children: n })
  ] });
}, Dj = (e) => {
  const { controller: n, controllerProps: r, fieldWrapperProps: i } = VH(e);
  return /* @__PURE__ */ Ao.jsx(He, { ...i, children: /* @__PURE__ */ Ao.jsx(
    cr,
    {
      ...e.componentProps,
      ...n.field,
      value: e.componentProps?.type === "number" && isNaN(n.field.value) ? "" : n.field.value ?? "",
      onBlur: (a) => {
        e.componentProps?.onBlur?.(a), n.field.onBlur();
      },
      onChange: (a) => {
        e.componentProps?.onChange?.(a), n.field.onChange(
          e.componentProps?.type === "number" ? a.target.valueAsNumber : a
        );
      },
      id: r.name,
      "aria-disabled": i.disabled,
      disabled: i.disabled,
      "aria-required": i.required,
      required: i.required,
      status: He.getStatus(i.meta)
    }
  ) });
}, Al = [
  {
    key: "rivoLoyaltyApiKey",
    label: "API key",
    defaultValue: "",
    secret: !0,
    type: "string"
  },
  {
    key: cd,
    label: "Shopify API host name",
    defaultValue: "",
    secret: !1,
    type: "string"
  },
  {
    key: "rivoLoyaltyShowOrders",
    label: "Show orders overview",
    defaultValue: !0,
    secret: !1,
    type: "boolean"
  },
  {
    key: "rivoLoyaltyShowLoyalty",
    label: "Show loyalty",
    defaultValue: !0,
    secret: !1,
    type: "boolean"
  },
  {
    key: "rivoLoyaltyAdjustLoyaltyPoints",
    label: "Allow adjusting loyalty points",
    defaultValue: !0,
    secret: !1,
    type: "boolean"
  },
  {
    key: "rivoLoyaltyShowFavoriteProducts",
    label: "Show favorite products",
    defaultValue: !0,
    secret: !1,
    type: "boolean"
  },
  {
    key: "rivoLoyaltyShowPointsRedemptions",
    label: "Show available rewards",
    defaultValue: !0,
    secret: !1,
    type: "boolean"
  }
], $i = ir(Al), Oj = "RIVOLOYALTY", Ls = "Rivo Loyalty", PW = {
  enabled: !1,
  name: "",
  rivoLoyaltyApiKey: "",
  [cd]: "",
  rivoLoyaltyShowOrders: !0,
  rivoLoyaltyShowLoyalty: !0,
  rivoLoyaltyAdjustLoyaltyPoints: !0,
  rivoLoyaltyShowFavoriteProducts: !0,
  rivoLoyaltyShowPointsRedemptions: !0
}, AW = ({
  integrationId: e,
  handleRedirect: n,
  showNotification: r,
  automationCouplingState: i,
  renderConditionsEditor: a
}) => {
  const o = !e, s = V6({
    mode: "onChange",
    defaultValues: PW
  }), {
    create: l,
    update: c,
    remove: m,
    isLoading: u,
    error: f,
    misconfigurationCause: h,
    setMisconfigurationCause: k
  } = mr({
    integrationId: e,
    integrationType: Oj,
    handleRedirect: n,
    showNotification: r
  }), {
    isLoading: w,
    error: N,
    isWidgetUnknown: j,
    refetch: _,
    widgetConfiguration: g
  } = pr({
    integrationId: e,
    fieldDefinitions: Al,
    form: s,
    onMisconfigured: k
  }), { renderConditions: O, setRenderConditions: R, renderConditionsForSubmit: F } = fr({
    integrationId: e,
    widgetConfiguration: g,
    renderConditionsEditor: a
  }), I = (W) => yr(W, {
    fieldDefinitions: Al,
    isCreationMode: o,
    create: l,
    update: c,
    renderConditions: F
  }), L = s.watch("name");
  return /* @__PURE__ */ _e.jsxs(
    hr,
    {
      form: s,
      integrationId: e,
      onValidSubmit: I,
      error: N ?? f,
      onRetry: N ? _ : void 0,
      isLoading: u || w,
      isWidgetUnknown: j,
      children: [
        h && /* @__PURE__ */ _e.jsx(gr, { cause: h }),
        /* @__PURE__ */ _e.jsxs(et, { children: [
          /* @__PURE__ */ _e.jsx(X, { children: /* @__PURE__ */ _e.jsx(He, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ _e.jsx(
            da,
            {
              name: "enabled",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ _e.jsx(X, { span: 3, children: /* @__PURE__ */ _e.jsx(
            Dj,
            {
              name: "name",
              label: "Widget name",
              control: s.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ _e.jsx(X, { span: 3 }),
          /* @__PURE__ */ _e.jsx(X, { span: 3, children: /* @__PURE__ */ _e.jsx(
            Dj,
            {
              name: "rivoLoyaltyShopifyApiHostName",
              label: $i[cd],
              control: s.control,
              rules: {
                required: "Shopify API host name is required",
                validate: (W) => zl(W) ?? void 0
              },
              componentProps: {
                placeholder: 'Host name of your Shopify shop, e.g. "my-webshop.myshopify.com"',
                prefix: "https://"
              }
            }
          ) }),
          /* @__PURE__ */ _e.jsx(X, { span: 3 }),
          /* @__PURE__ */ _e.jsx(X, { span: 3, children: /* @__PURE__ */ _e.jsx(
            $r,
            {
              name: "rivoLoyaltyApiKey",
              label: $i.rivoLoyaltyApiKey,
              control: s.control,
              isCreationMode: o,
              rules: { required: "API key is required" },
              componentProps: {
                placeholder: "Insert your Rivo API key",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ _e.jsx(X, { span: 3 }),
          /* @__PURE__ */ _e.jsx(X, { span: 3, children: /* @__PURE__ */ _e.jsx(He, { label: $i.rivoLoyaltyShowOrders, children: /* @__PURE__ */ _e.jsx(
            da,
            {
              name: "rivoLoyaltyShowOrders",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ _e.jsx(X, { span: 3 }),
          /* @__PURE__ */ _e.jsx(X, { span: 3, children: /* @__PURE__ */ _e.jsx(He, { label: $i.rivoLoyaltyShowLoyalty, children: /* @__PURE__ */ _e.jsx(
            da,
            {
              name: "rivoLoyaltyShowLoyalty",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ _e.jsx(X, { span: 3 }),
          /* @__PURE__ */ _e.jsx(X, { span: 3, children: /* @__PURE__ */ _e.jsx(He, { label: $i.rivoLoyaltyAdjustLoyaltyPoints, children: /* @__PURE__ */ _e.jsx(
            da,
            {
              name: "rivoLoyaltyAdjustLoyaltyPoints",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ _e.jsx(X, { span: 3 }),
          /* @__PURE__ */ _e.jsx(X, { span: 3, children: /* @__PURE__ */ _e.jsx(He, { label: $i.rivoLoyaltyShowFavoriteProducts, children: /* @__PURE__ */ _e.jsx(
            da,
            {
              name: "rivoLoyaltyShowFavoriteProducts",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ _e.jsx(X, { span: 3 }),
          /* @__PURE__ */ _e.jsx(X, { span: 3, children: /* @__PURE__ */ _e.jsx(He, { label: $i.rivoLoyaltyShowPointsRedemptions, children: /* @__PURE__ */ _e.jsx(
            da,
            {
              name: "rivoLoyaltyShowPointsRedemptions",
              control: s.control
            }
          ) }) }),
          a && O !== null && /* @__PURE__ */ _e.jsx(X, { children: a({
            value: O,
            onChange: R,
            configurationKey: g?.id
          }) })
        ] }),
        /* @__PURE__ */ _e.jsx(
          vr,
          {
            integrationType: Oj,
            integrationId: e,
            widgetName: L,
            isCreationMode: o,
            isSubmitting: s.formState.isSubmitting,
            automationCouplingState: i,
            onConfirmDelete: () => m(),
            confirmDeleteVariant: "danger",
            deleteConfirmationBody: /* @__PURE__ */ _e.jsxs(b, { gap: "400", children: [
              /* @__PURE__ */ _e.jsx(
                he,
                {
                  size: 24,
                  name: "exclamation-triangle-filled",
                  color: "red.500"
                }
              ),
              /* @__PURE__ */ _e.jsxs(b, { gap: "200", flexDirection: "column", children: [
                /* @__PURE__ */ _e.jsxs($.Heading, { withMarginBottom: !0, children: [
                  "By deleting the ",
                  Ls,
                  " integration, all links between Dixa and ",
                  Ls,
                  " are also deleted."
                ] }),
                /* @__PURE__ */ _e.jsxs($.Paragraph, { children: [
                  "All data in ",
                  Ls,
                  " stays untouched."
                ] }),
                /* @__PURE__ */ _e.jsxs($.Paragraph, { children: [
                  "Are you sure you want to delete the ",
                  Ls,
                  " ",
                  'integration "',
                  L,
                  '"?'
                ] })
              ] })
            ] })
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._banner_d9pot_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);margin-bottom:var(--dixa-size-spacer-400)}._list_d9pot_8{margin:var(--dixa-size-spacer-200) 0;padding-left:var(--dixa-size-spacer-500)}._list_d9pot_8 li{margin-bottom:var(--dixa-size-spacer-200)}._list_d9pot_8 li:last-child{margin-bottom:0}._list_alvh6_1{padding:0}._listItem_alvh6_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_alvh6_4:last-child{border-bottom:none}._listItemEdit_alvh6_11{cursor:pointer}._fullWidth_alvh6_15{width:100%}._boxWrapper_alvh6_19{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._modal_1vkwz_1{width:800px}._disabled_1vkwz_5 input{color:var(--dixa-typography-color-tertiary);background-color:var(--dixa-color-neutral-100);pointer-events:none}._wrapper_10fld_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300) var(--dixa-size-spacer-300) var(--dixa-size-spacer-250);background-color:var(--dixa-color-neutral-100)}._copyIcon_10fld_7{cursor:pointer;color:var(--dixa-typography-color-secondary)}._creationModal_pbe64_1{width:800px}._detailsModal_pbe64_5{width:600px}._percentageSuffix_pbe64_9{background-color:var(--dixa-color-neutral-100);padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-250)}._modal_11d6e_1{width:600px}._modalBody_11d6e_4{max-height:500px;overflow-y:auto}._codeContainer_11d6e_9{margin:var(--dixa-size-spacer-200) var(--dixa-size-spacer-100) 0 0;padding:var(--dixa-size-spacer-200);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100)}._modal_1wlra_1{width:800px}._clickableIcon_33mqm_1{cursor:pointer;color:var(--dixa-typography-color-secondary)}._productTableHeader_6h6pl_1>tr>th{height:var(--dixa-size-spacer-300)}._productImage_6h6pl_5{width:50px;height:50px}._copyIcon_1dlzg_1{cursor:pointer;color:var(--dixa-typography-color-secondary)}._modal_1mprq_1{width:900px}._modal_al73g_1{width:600px}._editIcon_1yp2k_1,._copyIcon_1yp2k_2,._icon_cddi1_1{cursor:pointer;color:var(--dixa-typography-color-secondary)}._link_cddi1_6{font-size:var(--dixa-typography-size-200)}._copyIcon_u5m0p_1{cursor:pointer;color:var(--dixa-typography-color-secondary)}._strikethrough_u5m0p_6{text-decoration:line-through}._order_u5m0p_10{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_u5m0p_10:hover,._orderIsOpen_u5m0p_18{border-color:var(--dixa-color-neutral-400)}._orderHeader_u5m0p_21{cursor:pointer}._segmentName_1dkhk_1{overflow:hidden;white-space:nowrap}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Th = { exports: {} }, _o = {}, Pj;
function LW() {
  if (Pj) return _o;
  Pj = 1;
  var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, c, m) {
    var u, f = {}, h = null, k = null;
    m !== void 0 && (h = "" + m), c.key !== void 0 && (h = "" + c.key), c.ref !== void 0 && (k = c.ref);
    for (u in c) i.call(c, u) && !o.hasOwnProperty(u) && (f[u] = c[u]);
    if (l && l.defaultProps) for (u in c = l.defaultProps, c) f[u] === void 0 && (f[u] = c[u]);
    return { $$typeof: n, type: l, key: h, ref: k, props: f, _owner: a.current };
  }
  return _o.Fragment = r, _o.jsx = s, _o.jsxs = s, _o;
}
var Vs = {}, Aj;
function VW() {
  return Aj || (Aj = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), c = /* @__PURE__ */ Symbol.for("react.forward_ref"), m = /* @__PURE__ */ Symbol.for("react.suspense"), u = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), k = /* @__PURE__ */ Symbol.for("react.offscreen"), w = Symbol.iterator, N = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var d = w && t[w] || t[N];
      return typeof d == "function" ? d : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var d = arguments.length, p = new Array(d > 1 ? d - 1 : 0), y = 1; y < d; y++)
          p[y - 1] = arguments[y];
        O("error", t, p);
      }
    }
    function O(t, d, p) {
      {
        var y = _.ReactDebugCurrentFrame, C = y.getStackAddendum();
        C !== "" && (d += "%s", p = p.concat([C]));
        var T = p.map(function(S) {
          return String(S);
        });
        T.unshift("Warning: " + d), Function.prototype.apply.call(console[t], console, T);
      }
    }
    var R = !1, F = !1, I = !1, L = !1, W = !1, J;
    J = /* @__PURE__ */ Symbol.for("react.module.reference");
    function re(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || W || t === a || t === m || t === u || L || t === k || R || F || I || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === J || t.getModuleId !== void 0));
    }
    function K(t, d, p) {
      var y = t.displayName;
      if (y)
        return y;
      var C = d.displayName || d.name || "";
      return C !== "" ? p + "(" + C + ")" : p;
    }
    function Y(t) {
      return t.displayName || "Context";
    }
    function P(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var d = t;
            return Y(d) + ".Consumer";
          case s:
            var p = t;
            return Y(p._context) + ".Provider";
          case c:
            return K(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : P(t.type) || "Memo";
          case h: {
            var C = t, T = C._payload, S = C._init;
            try {
              return P(S(T));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, ie = 0, we, me, le, ge, V, be, Oe;
    function q() {
    }
    q.__reactDisabledLog = !0;
    function Ge() {
      {
        if (ie === 0) {
          we = console.log, me = console.info, le = console.warn, ge = console.error, V = console.group, be = console.groupCollapsed, Oe = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: q,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ie++;
      }
    }
    function sn() {
      {
        if (ie--, ie === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, t, {
              value: we
            }),
            info: B({}, t, {
              value: me
            }),
            warn: B({}, t, {
              value: le
            }),
            error: B({}, t, {
              value: ge
            }),
            group: B({}, t, {
              value: V
            }),
            groupCollapsed: B({}, t, {
              value: be
            }),
            groupEnd: B({}, t, {
              value: Oe
            })
          });
        }
        ie < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ie = _.ReactCurrentDispatcher, Ue;
    function De(t, d, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (C) {
            var y = C.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Ae;
    {
      var Je = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Je();
    }
    function Ee(t, d) {
      if (!t || Be)
        return "";
      {
        var p = Ae.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Be = !0;
      var C = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var T;
      T = Ie.current, Ie.current = null, Ge();
      try {
        if (d) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (ne) {
              y = ne;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (ne) {
              y = ne;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            y = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && y && typeof ne.stack == "string") {
          for (var x = ne.stack.split(`
`), Z = y.stack.split(`
`), A = x.length - 1, M = Z.length - 1; A >= 1 && M >= 0 && x[A] !== Z[M]; )
            M--;
          for (; A >= 1 && M >= 0; A--, M--)
            if (x[A] !== Z[M]) {
              if (A !== 1 || M !== 1)
                do
                  if (A--, M--, M < 0 || x[A] !== Z[M]) {
                    var ue = `
` + x[A].replace(" at new ", " at ");
                    return t.displayName && ue.includes("<anonymous>") && (ue = ue.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, ue), ue;
                  }
                while (A >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Ie.current = T, sn(), Error.prepareStackTrace = C;
      }
      var ze = t ? t.displayName || t.name : "", Te = ze ? De(ze) : "";
      return typeof t == "function" && Ae.set(t, Te), Te;
    }
    function Me(t, d, p) {
      return Ee(t, !1);
    }
    function en(t) {
      var d = t.prototype;
      return !!(d && d.isReactComponent);
    }
    function se(t, d, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ee(t, en(t));
      if (typeof t == "string")
        return De(t);
      switch (t) {
        case m:
          return De("Suspense");
        case u:
          return De("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case c:
            return Me(t.render);
          case f:
            return se(t.type, d, p);
          case h: {
            var y = t, C = y._payload, T = y._init;
            try {
              return se(T(C), d, p);
            } catch {
            }
          }
        }
      return "";
    }
    var de = Object.prototype.hasOwnProperty, Se = {}, Ve = _.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var d = t._owner, p = se(t.type, t._source, d ? d.type : null);
        Ve.setExtraStackFrame(p);
      } else
        Ve.setExtraStackFrame(null);
    }
    function kn(t, d, p, y, C) {
      {
        var T = Function.call.bind(de);
        for (var S in t)
          if (T(t, S)) {
            var x = void 0;
            try {
              if (typeof t[S] != "function") {
                var Z = Error((y || "React class") + ": " + p + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Z.name = "Invariant Violation", Z;
              }
              x = t[S](d, S, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (A) {
              x = A;
            }
            x && !(x instanceof Error) && (Pe(C), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, S, typeof x), Pe(null)), x instanceof Error && !(x.message in Se) && (Se[x.message] = !0, Pe(C), g("Failed %s type: %s", p, x.message), Pe(null));
          }
      }
    }
    var Q = Array.isArray;
    function E(t) {
      return Q(t);
    }
    function z(t) {
      {
        var d = typeof Symbol == "function" && Symbol.toStringTag, p = d && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function ae(t) {
      try {
        return ce(t), !1;
      } catch {
        return !0;
      }
    }
    function ce(t) {
      return "" + t;
    }
    function U(t) {
      if (ae(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", z(t)), ce(t);
    }
    var G = _.ReactCurrentOwner, ve = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, je, Re;
    function rn(t) {
      if (de.call(t, "ref")) {
        var d = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (d && d.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function bn(t) {
      if (de.call(t, "key")) {
        var d = Object.getOwnPropertyDescriptor(t, "key").get;
        if (d && d.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function an(t, d) {
      typeof t.ref == "string" && G.current;
    }
    function fn(t, d) {
      {
        var p = function() {
          je || (je = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", d));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function En(t, d) {
      {
        var p = function() {
          Re || (Re = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", d));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var _n = function(t, d, p, y, C, T, S) {
      var x = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: d,
        ref: p,
        props: S,
        // Record the component responsible for creating this element.
        _owner: T
      };
      return x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(x, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(x, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: C
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    };
    function Fn(t, d, p, y, C) {
      {
        var T, S = {}, x = null, Z = null;
        p !== void 0 && (U(p), x = "" + p), bn(d) && (U(d.key), x = "" + d.key), rn(d) && (Z = d.ref, an(d));
        for (T in d)
          de.call(d, T) && !ve.hasOwnProperty(T) && (S[T] = d[T]);
        if (t && t.defaultProps) {
          var A = t.defaultProps;
          for (T in A)
            S[T] === void 0 && (S[T] = A[T]);
        }
        if (x || Z) {
          var M = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          x && fn(S, M), Z && En(S, M);
        }
        return _n(t, x, Z, C, y, G.current, S);
      }
    }
    var Ze = _.ReactCurrentOwner, gn = _.ReactDebugCurrentFrame;
    function Le(t) {
      if (t) {
        var d = t._owner, p = se(t.type, t._source, d ? d.type : null);
        gn.setExtraStackFrame(p);
      } else
        gn.setExtraStackFrame(null);
    }
    var dn;
    dn = !1;
    function cn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function Nn() {
      {
        if (Ze.current) {
          var t = P(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Bn(t) {
      return "";
    }
    var Sn = {};
    function An(t) {
      {
        var d = Nn();
        if (!d) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (d = `

Check the top-level render call using <` + p + ">.");
        }
        return d;
      }
    }
    function vn(t, d) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = An(d);
        if (Sn[p])
          return;
        Sn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Ze.current && (y = " It was passed a child from " + P(t._owner.type) + "."), Le(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Le(null);
      }
    }
    function xn(t, d) {
      {
        if (typeof t != "object")
          return;
        if (E(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            cn(y) && vn(y, d);
          }
        else if (cn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var C = j(t);
          if (typeof C == "function" && C !== t.entries)
            for (var T = C.call(t), S; !(S = T.next()).done; )
              cn(S.value) && vn(S.value, d);
        }
      }
    }
    function Ln(t) {
      {
        var d = t.type;
        if (d == null || typeof d == "string")
          return;
        var p;
        if (typeof d == "function")
          p = d.propTypes;
        else if (typeof d == "object" && (d.$$typeof === c || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        d.$$typeof === f))
          p = d.propTypes;
        else
          return;
        if (p) {
          var y = P(d);
          kn(p, t.props, "prop", y, t);
        } else if (d.PropTypes !== void 0 && !dn) {
          dn = !0;
          var C = P(d);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", C || "Unknown");
        }
        typeof d.getDefaultProps == "function" && !d.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var d = Object.keys(t.props), p = 0; p < d.length; p++) {
          var y = d[p];
          if (y !== "children" && y !== "key") {
            Le(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Le(null);
            break;
          }
        }
        t.ref !== null && (Le(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Le(null));
      }
    }
    var Cn = {};
    function wn(t, d, p, y, C, T) {
      {
        var S = re(t);
        if (!S) {
          var x = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (x += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Z = Bn();
          Z ? x += Z : x += Nn();
          var A;
          t === null ? A = "null" : E(t) ? A = "array" : t !== void 0 && t.$$typeof === n ? (A = "<" + (P(t.type) || "Unknown") + " />", x = " Did you accidentally export a JSX literal instead of a component?") : A = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", A, x);
        }
        var M = Fn(t, d, p, C, T);
        if (M == null)
          return M;
        if (S) {
          var ue = d.children;
          if (ue !== void 0)
            if (y)
              if (E(ue)) {
                for (var ze = 0; ze < ue.length; ze++)
                  xn(ue[ze], t);
                Object.freeze && Object.freeze(ue);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              xn(ue, t);
        }
        if (de.call(d, "key")) {
          var Te = P(t), ne = Object.keys(d).filter(function(Kn) {
            return Kn !== "key";
          }), un = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Cn[Te + un]) {
            var Rn = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, un, Te, Rn, Te), Cn[Te + un] = !0;
          }
        }
        return t === i ? Vn(M) : Ln(M), M;
      }
    }
    function zn(t, d, p) {
      return wn(t, d, p, !0);
    }
    function qn(t, d, p) {
      return wn(t, d, p, !1);
    }
    var Un = qn, Wn = zn;
    Vs.Fragment = i, Vs.jsx = Un, Vs.jsxs = Wn;
  })()), Vs;
}
var Lj;
function zW() {
  return Lj || (Lj = 1, process.env.NODE_ENV === "production" ? Th.exports = LW() : Th.exports = VW()), Th.exports;
}
var v = zW();
const Vj = "__PairingContext__", UW = () => globalThis[Vj] ?? (() => {
  const e = Fy({});
  return globalThis[Vj] = e, e;
})(), MW = UW(), BW = () => ql(MW), qW = "_banner_d9pot_1", HW = "_list_d9pot_8", zj = {
  banner: qW,
  list: HW
}, Uj = "https://apps.shopify.com/dixa-dashboard", WW = {
  install: {
    description: "Connect your Shopify store to Dixa with just a few clicks.",
    listHeading: "How it works:",
    listType: "ol",
    listItems: [
      'Click "Install Dixa app in Shopify" below to start the connection',
      "You'll be redirected to the Shopify App Store to install the Dixa app",
      "After installing, the connection is set up automatically",
      "Return to the Settings > Integrations overview to see your newly connected Shopify integration"
    ],
    buttonText: "Install Dixa app in Shopify",
    buttonVariant: "primary"
  },
  migration: {
    description: "This integration uses a legacy connection method. We recommend upgrading to the Dixa Shopify app for a simpler, more reliable connection that doesn't require manual credential management.",
    listHeading: "Benefits of upgrading:",
    listType: "ul",
    listItems: [
      "No need to manage Client ID and Client Secret",
      "Automatic token refresh handled by the app",
      "Easier setup for new stores"
    ],
    buttonText: "Upgrade via Shopify App Store",
    buttonVariant: "primary"
  }
}, Ll = ({
  label: e,
  bannerVariant: n = "install"
}) => {
  const { initiateFromDixa: r } = BW(), [i, a] = pe(!1), [o, s] = pe(null), l = WW[n], c = async () => {
    if (n === "install" && r) {
      a(!0), s(null);
      try {
        const u = await r();
        window.open(
          u ?? Uj,
          "_blank",
          "noopener,noreferrer"
        );
      } catch {
        s("Failed to start the connection. Please try again.");
      } finally {
        a(!1);
      }
      return;
    }
    window.open(Uj, "_blank", "noopener,noreferrer");
  }, m = l.listType === "ol" ? "ol" : "ul";
  return /* @__PURE__ */ v.jsx(X, { children: /* @__PURE__ */ v.jsxs(b, { gap: "300", flexDirection: "column", className: zj.banner, children: [
    /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-2", children: e }),
    /* @__PURE__ */ v.jsxs(b, { alignItems: "center", gap: "200", children: [
      /* @__PURE__ */ v.jsx(b, { children: /* @__PURE__ */ v.jsx(he, { size: 30, name: "shopify", color: "green.500" }) }),
      /* @__PURE__ */ v.jsx($.Paragraph, { children: l.description })
    ] }),
    /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: l.listHeading }),
      /* @__PURE__ */ v.jsx($.Paragraph, { as: "div", children: /* @__PURE__ */ v.jsx(m, { className: zj.list, children: l.listItems.map((u, f) => /* @__PURE__ */ v.jsx("li", { children: u }, f)) }) })
    ] }),
    o && /* @__PURE__ */ v.jsx($.Paragraph, { color: "danger", children: o }),
    /* @__PURE__ */ v.jsx(b, { margin: "200 0 0 0", children: /* @__PURE__ */ v.jsx(
      tt,
      {
        onClick: c,
        icon: "external-link",
        variant: l.buttonVariant,
        disabled: i,
        children: i ? /* @__PURE__ */ v.jsxs(b, { alignItems: "center", gap: "200", children: [
          /* @__PURE__ */ v.jsx(mn, { size: 16 }),
          "Connecting…"
        ] }) : l.buttonText
      }
    ) })
  ] }) });
}, Ko = [
  {
    key: "apiHostName",
    label: "API host name",
    type: "string",
    secret: !1,
    defaultValue: ""
  },
  {
    key: "displayRefundOrder",
    label: "Display the refund order button",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "displayPartialRefundOrder",
    label: "Displays the partial refund order button",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayCancelOrder",
    label: "Displays the cancel order button",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "enableEditShippingAddress",
    label: 'Enable the "edit shipping address" button',
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayOrdersOverview",
    label: "Displays short orders overview",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayEmailMarketingConsent",
    label: "Displays the email and phone marketing consent status of the customer",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displaySegmentMembership",
    label: "Displays the segment memberships of the customer",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayDiscountCodes",
    label: "Displays available discount codes",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayDiscountCodeCreation",
    label: "Displays the discount code creation button",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayCreateOrder",
    label: "Displays the create order button",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayCreateDraftOrder",
    label: "Displays the create draft order button",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayDuplicateOrder",
    label: "Displays the duplicate order button",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "apiAccessToken",
    label: "API Access Token",
    type: "string",
    secret: !0,
    defaultValue: ""
  },
  {
    key: "shopifyClientId",
    label: "Client ID",
    type: "string",
    secret: !0,
    defaultValue: ""
  },
  {
    key: "shopifyClientSecret",
    label: "Client Secret",
    type: "string",
    secret: !0,
    defaultValue: ""
  }
], Mj = "SHOPIFY", zs = ir(Ko), KW = [
  "displayRefundOrder",
  "displayPartialRefundOrder",
  "displayCancelOrder",
  "enableEditShippingAddress",
  "displayOrdersOverview",
  "displayEmailMarketingConsent",
  "displaySegmentMembership",
  "displayDiscountCodes",
  "displayDiscountCodeCreation",
  "displayCreateOrder",
  "displayCreateDraftOrder",
  "displayDuplicateOrder"
], GW = {
  enabled: !1,
  name: "",
  ...Bl(
    [],
    Ko
  )
}, YW = ({
  integrationId: e,
  handleRedirect: n,
  showNotification: r,
  automationCouplingState: i,
  renderConditionsEditor: a
}) => {
  const o = !e, s = ut({
    mode: "onChange",
    defaultValues: GW
  }), {
    create: l,
    update: c,
    remove: m,
    isLoading: u,
    error: f,
    misconfigurationCause: h,
    setMisconfigurationCause: k
  } = mr({
    integrationId: e,
    integrationType: Mj,
    handleRedirect: n,
    showNotification: r
  }), {
    isLoading: w,
    error: N,
    isWidgetUnknown: j,
    refetch: _,
    widgetConfiguration: g
  } = pr({
    integrationId: e,
    fieldDefinitions: Ko,
    form: s,
    onMisconfigured: k
  }), { renderConditions: O, setRenderConditions: R, renderConditionsForSubmit: F } = fr({
    integrationId: e,
    widgetConfiguration: g,
    renderConditionsEditor: a
  }), I = g?.additionalProperties, L = I?.tokenSource === "marketplace_app", W = !!I?.isUsingOAuth, J = !L, re = (Y) => yr(Y, {
    fieldDefinitions: Ko,
    isCreationMode: o,
    create: l,
    update: c,
    renderConditions: F
  }), K = s.watch("name");
  return /* @__PURE__ */ v.jsx(
    hr,
    {
      form: s,
      integrationId: e,
      onValidSubmit: re,
      error: N ?? f,
      onRetry: N ? _ : void 0,
      isLoading: u || w,
      isWidgetUnknown: j,
      children: o ? /* @__PURE__ */ v.jsx(et, { children: /* @__PURE__ */ v.jsx(
        Ll,
        {
          label: "Connect your Shopify store",
          bannerVariant: "install"
        }
      ) }) : /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
        h && /* @__PURE__ */ v.jsx(gr, { cause: h }),
        /* @__PURE__ */ v.jsxs(et, { children: [
          J && /* @__PURE__ */ v.jsx(
            Ll,
            {
              label: "Upgrade to simplified connection",
              bannerVariant: "migration"
            }
          ),
          /* @__PURE__ */ v.jsx(X, { children: /* @__PURE__ */ v.jsx(He, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ v.jsx(
            yn,
            {
              name: "enabled",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ v.jsx(X, { span: 3, children: /* @__PURE__ */ v.jsx(
            On,
            {
              name: "name",
              label: "Widget name",
              control: s.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ v.jsx(X, { span: 3 }),
          J && W && /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
            /* @__PURE__ */ v.jsx(X, { span: 3, children: /* @__PURE__ */ v.jsx(
              $r,
              {
                name: "shopifyClientId",
                label: zs.shopifyClientId,
                control: s.control,
                isCreationMode: o,
                rules: { required: "Client ID is required" },
                componentProps: {
                  placeholder: "Client ID from Shopify",
                  autoComplete: "off"
                }
              }
            ) }),
            /* @__PURE__ */ v.jsx(X, { span: 3 }),
            /* @__PURE__ */ v.jsx(X, { span: 3, children: /* @__PURE__ */ v.jsx(
              $r,
              {
                name: "shopifyClientSecret",
                label: zs.shopifyClientSecret,
                control: s.control,
                isCreationMode: o,
                rules: { required: "Client Secret is required" },
                componentProps: {
                  placeholder: "Client Secret from Shopify",
                  autoComplete: "off"
                }
              }
            ) }),
            /* @__PURE__ */ v.jsx(X, { span: 3 })
          ] }),
          J && !W && /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
            /* @__PURE__ */ v.jsx(X, { span: 3, children: /* @__PURE__ */ v.jsx(
              $r,
              {
                name: "apiAccessToken",
                label: zs.apiAccessToken,
                control: s.control,
                isCreationMode: o,
                rules: { required: "API access token is required" },
                componentProps: {
                  placeholder: "API access token from Shopify",
                  autoComplete: "off"
                }
              }
            ) }),
            /* @__PURE__ */ v.jsx(X, { span: 3 })
          ] }),
          L ? /* @__PURE__ */ v.jsx(X, { span: 3, children: /* @__PURE__ */ v.jsx(
            On,
            {
              name: "apiHostName",
              label: "Connected Shopify store",
              control: s.control,
              componentProps: {
                readOnly: !0,
                autoComplete: "off",
                prefix: "https://"
              }
            }
          ) }) : /* @__PURE__ */ v.jsx(X, { span: 3, children: /* @__PURE__ */ v.jsx(
            On,
            {
              name: "apiHostName",
              label: "API host name",
              control: s.control,
              rules: {
                required: "API host name is required",
                validate: (Y) => zl(Y) || !0
              },
              componentProps: {
                placeholder: 'Host name of your shop, e.g. "my-webshop.myshopify.com"',
                autoComplete: "off",
                prefix: "https://"
              }
            }
          ) }),
          /* @__PURE__ */ v.jsx(X, { span: 3 }),
          KW.map((Y) => /* @__PURE__ */ v.jsxs(wI, { children: [
            /* @__PURE__ */ v.jsx(X, { span: 3, children: /* @__PURE__ */ v.jsx(He, { label: zs[Y], children: /* @__PURE__ */ v.jsx(
              yn,
              {
                name: Y,
                control: s.control
              }
            ) }) }),
            /* @__PURE__ */ v.jsx(X, { span: 3 })
          ] }, Y)),
          a && O !== null && /* @__PURE__ */ v.jsx(X, { children: a({
            value: O,
            onChange: R,
            configurationKey: g?.id
          }) })
        ] }),
        /* @__PURE__ */ v.jsx(
          vr,
          {
            integrationType: Mj,
            integrationId: e,
            widgetName: K,
            isCreationMode: o,
            isSubmitting: s.formState.isSubmitting,
            automationCouplingState: i,
            onConfirmDelete: () => m()
          }
        )
      ] })
    }
  );
}, JW = (e) => /* @__PURE__ */ v.jsx(Ll, { ...e, bannerVariant: "install" }), QW = (e) => /* @__PURE__ */ v.jsx(Ll, { ...e, bannerVariant: "migration" }), XW = [
  {
    key: "shopifyClientId",
    label: "Client ID",
    placeholder: "Client ID from Shopify",
    required: !0,
    secret: !0,
    type: "input"
  },
  {
    key: "shopifyClientSecret",
    label: "Client Secret",
    placeholder: "Client Secret from Shopify",
    required: !0,
    secret: !0,
    type: "input"
  }
], ZW = [
  {
    key: "apiAccessToken",
    label: "API Access Token",
    placeholder: "API access token from Shopify",
    required: !0,
    secret: !0,
    type: "input"
  }
], e9 = [
  {
    key: "marketplaceInstallBanner",
    label: "Connect your Shopify store",
    secret: !1,
    type: "custom",
    component: JW
  }
], n9 = [
  {
    key: "apiHostName",
    label: "Connected Shopify store",
    placeholder: "",
    required: !1,
    secret: !1,
    type: "input",
    prefix: "https://",
    readOnly: !0
  }
], Bj = [
  {
    key: "migrationBanner",
    label: "Upgrade to simplified connection",
    secret: !1,
    type: "custom",
    component: QW,
    additionalProperties: { renderAboveForm: !0 }
  }
], RF = [
  {
    key: "displayRefundOrder",
    label: "Display the refund order button",
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "displayPartialRefundOrder",
    label: "Displays the partial refund order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayCancelOrder",
    label: "Displays the cancel order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "enableEditShippingAddress",
    label: 'Enable the "edit shipping address" button',
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayOrdersOverview",
    label: "Displays short orders overview",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    // We keep the key name to the first version which only showed marketing
    // consent for email in order to not change the existing integration setting
    // for customers. The current version shows both email and phone marketing consent.
    key: "displayEmailMarketingConsent",
    label: "Displays the email and phone marketing consent status of the customer",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displaySegmentMembership",
    label: "Displays the segment memberships of the customer",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayDiscountCodes",
    label: "Displays available discount codes",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayDiscountCodeCreation",
    label: "Displays the discount code creation button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayCreateOrder",
    label: "Displays the create order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayCreateDraftOrder",
    label: "Displays the create draft order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayDuplicateOrder",
    label: "Displays the duplicate order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  }
], qj = [
  {
    key: "apiHostName",
    label: "API host name",
    placeholder: 'Host name of your shop, e.g. "my-webshop.myshopify.com"',
    required: !0,
    secret: !1,
    type: "input",
    prefix: "https://",
    customValidation: (e) => zl(e)
  },
  ...RF
];
var ma = /* @__PURE__ */ ((e) => (e.Invalid = "INVALID", e.NotSubscribed = "NOT_SUBSCRIBED", e.Pending = "PENDING", e.Subscribed = "SUBSCRIBED", e.Unsubscribed = "UNSUBSCRIBED", e))(ma || {}), Ui = /* @__PURE__ */ ((e) => (e.ConfirmedOptIn = "CONFIRMED_OPT_IN", e.SingleOptIn = "SINGLE_OPT_IN", e.Unknown = "UNKNOWN", e))(Ui || {}), Mr = /* @__PURE__ */ ((e) => (e.NotSubscribed = "NOT_SUBSCRIBED", e.Pending = "PENDING", e.Redacted = "REDACTED", e.Subscribed = "SUBSCRIBED", e.Unsubscribed = "UNSUBSCRIBED", e))(Mr || {}), DF = /* @__PURE__ */ ((e) => (e.All = "ALL", e))(DF || {}), _y = /* @__PURE__ */ ((e) => (e.Active = "ACTIVE", e.Expired = "EXPIRED", e.Scheduled = "SCHEDULED", e))(_y || {}), Oi = /* @__PURE__ */ ((e) => (e.Customer = "CUSTOMER", e.Declined = "DECLINED", e.Fraud = "FRAUD", e.Inventory = "INVENTORY", e.Other = "OTHER", e.Staff = "STAFF", e))(Oi || {}), Mi = /* @__PURE__ */ ((e) => (e.Authorized = "AUTHORIZED", e.Expired = "EXPIRED", e.Paid = "PAID", e.PartiallyPaid = "PARTIALLY_PAID", e.PartiallyRefunded = "PARTIALLY_REFUNDED", e.Pending = "PENDING", e.Refunded = "REFUNDED", e.Voided = "VOIDED", e))(Mi || {}), dl = /* @__PURE__ */ ((e) => (e.Fulfilled = "FULFILLED", e.Partial = "PARTIAL", e.Restocked = "RESTOCKED", e))(dl || {}), OF = /* @__PURE__ */ ((e) => (e.Authorization = "AUTHORIZATION", e.Capture = "CAPTURE", e.Change = "CHANGE", e.EmvAuthorization = "EMV_AUTHORIZATION", e.Refund = "REFUND", e.Sale = "SALE", e.SuggestedRefund = "SUGGESTED_REFUND", e.Void = "VOID", e))(OF || {});
const t9 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "refundCreate" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_RefundInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "refundCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, r9 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "orderUpdate" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderUpdate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "order" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shippingAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, i9 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "orderCancel" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "notifyCustomer" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "orderId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "reason" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderCancelReason" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "refundMethod" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderCancelRefundMethodInput" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "restock" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "staffNote" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderCancel" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "notifyCustomer" }, value: { kind: "Variable", name: { kind: "Name", value: "notifyCustomer" } } }, { kind: "Argument", name: { kind: "Name", value: "orderId" }, value: { kind: "Variable", name: { kind: "Name", value: "orderId" } } }, { kind: "Argument", name: { kind: "Name", value: "reason" }, value: { kind: "Variable", name: { kind: "Name", value: "reason" } } }, { kind: "Argument", name: { kind: "Name", value: "refundMethod" }, value: { kind: "Variable", name: { kind: "Name", value: "refundMethod" } } }, { kind: "Argument", name: { kind: "Name", value: "restock" }, value: { kind: "Variable", name: { kind: "Name", value: "restock" } } }, { kind: "Argument", name: { kind: "Name", value: "staffNote" }, value: { kind: "Variable", name: { kind: "Name", value: "staffNote" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "job" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "done" } }] } }, { kind: "Field", name: { kind: "Name", value: "orderCancelUserErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, a9 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createCustomer" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_CustomerInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customerCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "Field", name: { kind: "Name", value: "customer" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "defaultEmailAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "emailAddress" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultPhoneNumber" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "phoneNumber" } }, { kind: "Field", name: { kind: "Name", value: "marketingState" } }, { kind: "Field", name: { kind: "Name", value: "marketingOptInLevel" } }] } }, { kind: "Field", name: { kind: "Name", value: "taxExempt" } }, { kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "amountSpent" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }] } }] } }] }, o9 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createOrder" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "order" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderCreateOrderInput" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "options" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderCreateOptionsInput" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "order" }, value: { kind: "Variable", name: { kind: "Name", value: "order" } } }, { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "order" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }, { kind: "Field", name: { kind: "Name", value: "displayFulfillmentStatus" } }, { kind: "Field", name: { kind: "Name", value: "displayFinancialStatus" } }, { kind: "Field", name: { kind: "Name", value: "totalPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, s9 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createDraftOrder" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DraftOrderInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "draftOrderCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "draftOrder" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "totalPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, l9 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createDiscountCode" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeBasicInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountCodeBasicCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "basicCodeDiscount" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "codeDiscountNode" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "codeDiscount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeBasic" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "1" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "startsAt" } }, { kind: "Field", name: { kind: "Name", value: "endsAt" } }, { kind: "Field", name: { kind: "Name", value: "usageLimit" } }, { kind: "Field", name: { kind: "Name", value: "appliesOncePerCustomer" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, d9 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "orderMarkAsPaid" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderMarkAsPaidInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderMarkAsPaid" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "order" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, c9 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "refundLineItems" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_RefundInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "refundCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "refund" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "totalRefundedSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, u9 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updateOrder" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderUpdate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "order" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }] } }] } }] } }] } }] }, m9 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "segments" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "first" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "segments" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] }, p9 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "customerSegmentMembership" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "segmentIds" } }, type: { kind: "NonNullType", type: { kind: "ListType", type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customerSegmentMembership" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "customerId" }, value: { kind: "Variable", name: { kind: "Name", value: "customerId" } } }, { kind: "Argument", name: { kind: "Name", value: "segmentIds" }, value: { kind: "Variable", name: { kind: "Name", value: "segmentIds" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "memberships" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "segmentId" } }, { kind: "Field", name: { kind: "Name", value: "isMember" } }] } }] } }] } }] } }] }, f9 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "shopifyCustomerData" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shop" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "countriesInShippingZones" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "countryCodes" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "customers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "1" } }, { kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "defaultEmailAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "emailAddress" } }, { kind: "Field", name: { kind: "Name", value: "marketingOptInLevel" } }, { kind: "Field", name: { kind: "Name", value: "marketingState" } }, { kind: "Field", name: { kind: "Name", value: "marketingUpdatedAt" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultPhoneNumber" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "phoneNumber" } }, { kind: "Field", name: { kind: "Name", value: "marketingOptInLevel" } }, { kind: "Field", name: { kind: "Name", value: "marketingState" } }, { kind: "Field", name: { kind: "Name", value: "marketingUpdatedAt" } }] } }, { kind: "Field", name: { kind: "Name", value: "numberOfOrders" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "verifiedEmail" } }, { kind: "Field", name: { kind: "Name", value: "amountSpent" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }] } }] } }] } }] } }] } }] } }] }, h9 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "shopifyCustomerOrders" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orders" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "5" } }, { kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }, { kind: "Argument", name: { kind: "Name", value: "sortKey" }, value: { kind: "EnumValue", value: "CREATED_AT" } }, { kind: "Argument", name: { kind: "Name", value: "reverse" }, value: { kind: "BooleanValue", value: !0 } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }, { kind: "Field", name: { kind: "Name", value: "displayFulfillmentStatus" } }, { kind: "Field", name: { kind: "Name", value: "displayFinancialStatus" } }, { kind: "Field", name: { kind: "Name", value: "cancelledAt" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "discountCodes" } }, { kind: "Field", name: { kind: "Name", value: "netPaymentSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "totalRefundedSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "billingAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }] } }, { kind: "Field", name: { kind: "Name", value: "shippingAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }] } }, { kind: "Field", name: { kind: "Name", value: "suggestedRefund" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "suggestFullRefund" }, value: { kind: "BooleanValue", value: !0 } }, { kind: "Argument", name: { kind: "Name", value: "refundShipping" }, value: { kind: "BooleanValue", value: !0 } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amountSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "subtotalSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "totalTaxSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "shipping" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amountSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "maximumRefundableSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "suggestedTransactions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "accountNumber" } }, { kind: "Field", name: { kind: "Name", value: "gateway" } }, { kind: "Field", name: { kind: "Name", value: "kind" } }, { kind: "Field", name: { kind: "Name", value: "parentTransaction" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }, { kind: "Field", name: { kind: "Name", value: "amountSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "refundLineItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "lineItem" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "shippingLines" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "5" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "discountedPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "fulfillments" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "2" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "trackingInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "lineItems" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "15" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "variantTitle" } }, { kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "image" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "url" } }] } }, { kind: "Field", name: { kind: "Name", value: "product" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountedUnitPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "refunds" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "totalRefunded" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "refundLineItems" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "250" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "lineItem" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }] } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "currentTotalPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "currentTotalDiscountsSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }] } }] } }] } }] } }] }, y9 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchDiscountCodes" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "first" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "after" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountNodes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }, { kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }, { kind: "Argument", name: { kind: "Name", value: "after" }, value: { kind: "Variable", name: { kind: "Name", value: "after" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pageInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "hasNextPage" } }, { kind: "Field", name: { kind: "Name", value: "endCursor" } }] } }, { kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "discount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "__typename" } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeApp" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "100" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeBasic" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "100" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "customerGets" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "value" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "__typename" } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountPercentage" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "percentage" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountAmount" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeBxgy" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "100" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeFreeShipping" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "100" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }] } }] } }] } }] } }] } }] } }] }, g9 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchProducts" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "productCount" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "mediaCount" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "products" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "productCount" } } }, { kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "onlineStoreUrl" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "totalInventory" } }, { kind: "Field", name: { kind: "Name", value: "priceRangeV2" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "maxVariantPrice" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "minVariantPrice" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "media" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "mediaCount" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "alt" } }, { kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "mediaContentType" } }, { kind: "Field", name: { kind: "Name", value: "preview" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "image" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "altText" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }] } }] } }] } }] } }] } }] } }] }, v9 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "shopifySuggestedRefund" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "orderId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "refundLineItems" } }, type: { kind: "ListType", type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_RefundLineItemInput" } } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "refundShipping" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "suggestFullRefund" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "order" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "orderId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "suggestedRefund" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "refundLineItems" }, value: { kind: "Variable", name: { kind: "Name", value: "refundLineItems" } } }, { kind: "Argument", name: { kind: "Name", value: "refundShipping" }, value: { kind: "Variable", name: { kind: "Name", value: "refundShipping" } } }, { kind: "Argument", name: { kind: "Name", value: "suggestFullRefund" }, value: { kind: "Variable", name: { kind: "Name", value: "suggestFullRefund" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amountSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "subtotalSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "totalTaxSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "shipping" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amountSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "maximumRefundableSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "suggestedTransactions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "accountNumber" } }, { kind: "Field", name: { kind: "Name", value: "gateway" } }, { kind: "Field", name: { kind: "Name", value: "kind" } }, { kind: "Field", name: { kind: "Name", value: "parentTransaction" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }, { kind: "Field", name: { kind: "Name", value: "amountSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "refundLineItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "lineItem" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }] } }] } }] } }] } }] } }] } }] }, k9 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "test" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shop" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "description" } }] } }] } }] } }] }, b9 = {
  "\n  mutation refundCreate($input: Shopify_RefundInput!) {\n    Shopify {\n      refundCreate(input: $input) {\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": t9,
  "\n  mutation orderUpdate($input: Shopify_OrderInput!) {\n    Shopify {\n      orderUpdate(input: $input) {\n        order {\n          shippingAddress {\n            firstName\n            lastName\n            company\n            address1\n            address2\n            city\n            countryCodeV2\n            provinceCode\n            zip\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": r9,
  "\n  mutation orderCancel(\n    $notifyCustomer: Boolean\n    $orderId: ID!\n    $reason: Shopify_OrderCancelReason!\n    $refundMethod: Shopify_OrderCancelRefundMethodInput!\n    $restock: Boolean!\n    $staffNote: String!\n  ) {\n    Shopify {\n      orderCancel(\n        notifyCustomer: $notifyCustomer\n        orderId: $orderId\n        reason: $reason\n        refundMethod: $refundMethod\n        restock: $restock\n        staffNote: $staffNote\n      ) {\n        job {\n          id\n          done\n        }\n        orderCancelUserErrors {\n          code\n          field\n          message\n        }\n      }\n    }\n  }\n": i9,
  "\n  mutation createCustomer($input: Shopify_CustomerInput!) {\n    Shopify {\n      customerCreate(input: $input) {\n        userErrors {\n          field\n          message\n        }\n        customer {\n          id\n          defaultEmailAddress {\n            emailAddress\n          }\n          defaultPhoneNumber {\n            phoneNumber\n            marketingState\n            marketingOptInLevel\n          }\n          taxExempt\n          firstName\n          lastName\n          amountSpent {\n            amount\n            currencyCode\n          }\n        }\n      }\n    }\n  }\n": a9,
  "\n  mutation createOrder(\n    $order: Shopify_OrderCreateOrderInput!\n    $options: Shopify_OrderCreateOptionsInput\n  ) {\n    Shopify {\n      orderCreate(order: $order, options: $options) {\n        order {\n          id\n          name\n          createdAt\n          displayFulfillmentStatus\n          displayFinancialStatus\n          totalPriceSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n            shopMoney {\n              amount\n              currencyCode\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": o9,
  "\n  mutation createDraftOrder($input: Shopify_DraftOrderInput!) {\n    Shopify {\n      draftOrderCreate(input: $input) {\n        draftOrder {\n          id\n          name\n          createdAt\n          tags\n          status\n          totalPriceSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n            shopMoney {\n              amount\n              currencyCode\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": s9,
  "\n  mutation createDiscountCode($input: Shopify_DiscountCodeBasicInput!) {\n    Shopify {\n      discountCodeBasicCreate(basicCodeDiscount: $input) {\n        codeDiscountNode {\n          id\n          codeDiscount {\n            ... on Shopify_DiscountCodeBasic {\n              codes(first: 1) {\n                nodes {\n                  code\n                }\n              }\n              title\n              status\n              startsAt\n              endsAt\n              usageLimit\n              appliesOncePerCustomer\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": l9,
  "\n  mutation orderMarkAsPaid($input: Shopify_OrderMarkAsPaidInput!) {\n    Shopify {\n      orderMarkAsPaid(input: $input) {\n        order {\n          id\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": d9,
  "\n  mutation refundLineItems($input: Shopify_RefundInput!) {\n    Shopify {\n      refundCreate(input: $input) {\n        refund {\n          id\n          totalRefundedSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": c9,
  "\n  mutation updateOrder($input: Shopify_OrderInput!) {\n    Shopify {\n      orderUpdate(input: $input) {\n        order {\n          id\n          tags\n        }\n      }\n    }\n  }\n": u9,
  "\n  query segments($first: Int!) {\n    Shopify {\n      segments(first: $first) {\n        edges {\n          node {\n            id\n            name\n          }\n        }\n      }\n    }\n  }\n": m9,
  "\n  query customerSegmentMembership($customerId: ID!, $segmentIds: [ID!]!) {\n    Shopify {\n      customerSegmentMembership(\n        customerId: $customerId\n        segmentIds: $segmentIds\n      ) {\n        memberships {\n          segmentId\n          isMember\n        }\n      }\n    }\n  }\n": p9,
  "\n  query shopifyCustomerData($query: String!) {\n    Shopify {\n      shop {\n        countriesInShippingZones {\n          countryCodes\n        }\n      }\n\n      customers(first: 1, query: $query) {\n        edges {\n          node {\n            id\n            displayName\n            firstName\n            lastName\n            defaultEmailAddress {\n              emailAddress\n              marketingOptInLevel\n              marketingState\n              marketingUpdatedAt\n            }\n            defaultPhoneNumber {\n              phoneNumber\n              marketingOptInLevel\n              marketingState\n              marketingUpdatedAt\n            }\n            numberOfOrders\n            tags\n            verifiedEmail\n            amountSpent {\n              amount\n              currencyCode\n            }\n            defaultAddress {\n              firstName\n              lastName\n              address1\n              address2\n              city\n              country\n              zip\n              phone\n              provinceCode\n              countryCodeV2\n            }\n          }\n        }\n      }\n    }\n  }\n": f9,
  "\n  query shopifyCustomerOrders($query: String!) {\n    Shopify {\n      orders(first: 5, query: $query, sortKey: CREATED_AT, reverse: true) {\n        edges {\n          node {\n            id\n            name\n            createdAt\n            displayFulfillmentStatus\n            displayFinancialStatus\n            cancelledAt\n            tags\n            discountCodes\n            netPaymentSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n            }\n            totalRefundedSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n            }\n            billingAddress {\n              firstName\n              lastName\n              company\n              address1\n              address2\n              city\n              country\n              countryCodeV2\n              province\n              provinceCode\n              zip\n              phone\n            }\n            shippingAddress {\n              firstName\n              lastName\n              company\n              address1\n              address2\n              city\n              country\n              countryCodeV2\n              province\n              provinceCode\n              zip\n              phone\n            }\n            suggestedRefund(suggestFullRefund: true, refundShipping: true) {\n              amountSet {\n                presentmentMoney {\n                  amount\n                  currencyCode\n                }\n              }\n              subtotalSet {\n                presentmentMoney {\n                  amount\n                  currencyCode\n                }\n              }\n              totalTaxSet {\n                presentmentMoney {\n                  amount\n                  currencyCode\n                }\n              }\n              shipping {\n                amountSet {\n                  presentmentMoney {\n                    amount\n                    currencyCode\n                  }\n                }\n                maximumRefundableSet {\n                  presentmentMoney {\n                    amount\n                    currencyCode\n                  }\n                }\n              }\n              suggestedTransactions {\n                accountNumber\n                gateway\n                kind\n                parentTransaction {\n                  id\n                }\n                amountSet {\n                  presentmentMoney {\n                    amount\n                    currencyCode\n                  }\n                }\n              }\n              refundLineItems {\n                lineItem {\n                  id\n                  quantity\n                }\n              }\n            }\n            shippingLines(first: 5) {\n              edges {\n                node {\n                  title\n                  code\n                  source\n                  discountedPriceSet {\n                    shopMoney {\n                      amount\n                      currencyCode\n                    }\n                  }\n                }\n              }\n            }\n            fulfillments(first: 2) {\n              trackingInfo {\n                company\n                number\n                url\n              }\n            }\n            lineItems(first: 15) {\n              edges {\n                node {\n                  id\n                  title\n                  quantity\n                  variantTitle\n                  sku\n                  image {\n                    url\n                  }\n                  product {\n                    id\n                  }\n                  discountedUnitPriceSet {\n                    shopMoney {\n                      amount\n                      currencyCode\n                    }\n                  }\n                }\n              }\n            }\n            refunds {\n              totalRefunded {\n                amount\n                currencyCode\n              }\n              refundLineItems(first: 250) {\n                edges {\n                  node {\n                    id\n                    quantity\n                    lineItem {\n                      id\n                      title\n                    }\n                  }\n                }\n              }\n            }\n            currentTotalPriceSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n              shopMoney {\n                amount\n                currencyCode\n              }\n            }\n            currentTotalDiscountsSet {\n              shopMoney {\n                amount\n                currencyCode\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": h9,
  "\n  query searchDiscountCodes($query: String, $first: Int, $after: String) {\n    Shopify {\n      discountNodes(query: $query, first: $first, after: $after) {\n        pageInfo {\n          hasNextPage\n          endCursor\n        }\n        nodes {\n          id\n          discount {\n            __typename\n\n            ... on Shopify_DiscountCodeApp {\n              title\n              status\n              codes(first: 100) {\n                nodes {\n                  code\n                }\n              }\n            }\n\n            ... on Shopify_DiscountCodeBasic {\n              title\n              status\n              codes(first: 100) {\n                nodes {\n                  code\n                }\n              }\n              customerGets {\n                value {\n                  __typename\n\n                  ... on Shopify_DiscountPercentage {\n                    percentage\n                  }\n\n                  ... on Shopify_DiscountAmount {\n                    amount {\n                      amount\n                      currencyCode\n                    }\n                  }\n                }\n              }\n            }\n\n            ... on Shopify_DiscountCodeBxgy {\n              title\n              status\n              codes(first: 100) {\n                nodes {\n                  code\n                }\n              }\n            }\n\n            ... on Shopify_DiscountCodeFreeShipping {\n              title\n              status\n              codes(first: 100) {\n                nodes {\n                  code\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": y9,
  "\n  query searchProducts($query: String!, $productCount: Int, $mediaCount: Int) {\n    Shopify {\n      products(first: $productCount, query: $query) {\n        nodes {\n          id\n          title\n          description\n          onlineStoreUrl\n          status\n          tags\n          title\n          totalInventory\n          priceRangeV2 {\n            maxVariantPrice {\n              amount\n              currencyCode\n            }\n            minVariantPrice {\n              amount\n              currencyCode\n            }\n          }\n          media(first: $mediaCount) {\n            nodes {\n              alt\n              id\n              status\n              mediaContentType\n              preview {\n                image {\n                  id\n                  altText\n                  url\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": g9,
  "\n  query shopifySuggestedRefund(\n    $orderId: ID!\n    $refundLineItems: [Shopify_RefundLineItemInput!]\n    $refundShipping: Boolean\n    $suggestFullRefund: Boolean\n  ) {\n    Shopify {\n      order(id: $orderId) {\n        id\n        suggestedRefund(\n          refundLineItems: $refundLineItems\n          refundShipping: $refundShipping\n          suggestFullRefund: $suggestFullRefund\n        ) {\n          amountSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n          }\n          subtotalSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n          }\n          totalTaxSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n          }\n          shipping {\n            amountSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n            }\n            maximumRefundableSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n            }\n          }\n          suggestedTransactions {\n            accountNumber\n            gateway\n            kind\n            parentTransaction {\n              id\n            }\n            amountSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n            }\n          }\n          refundLineItems {\n            lineItem {\n              id\n              quantity\n            }\n          }\n        }\n      }\n    }\n  }\n": v9,
  "\n  query test {\n    Shopify {\n      shop {\n        name\n        email\n        description\n      }\n    }\n  }\n": k9
};
function ar(e) {
  return b9[e] ?? {};
}
const _9 = ar(
  /* GraphQL */
  `
  query shopifyCustomerData($query: String!) {
    Shopify {
      shop {
        countriesInShippingZones {
          countryCodes
        }
      }

      customers(first: 1, query: $query) {
        edges {
          node {
            id
            displayName
            firstName
            lastName
            defaultEmailAddress {
              emailAddress
              marketingOptInLevel
              marketingState
              marketingUpdatedAt
            }
            defaultPhoneNumber {
              phoneNumber
              marketingOptInLevel
              marketingState
              marketingUpdatedAt
            }
            numberOfOrders
            tags
            verifiedEmail
            amountSpent {
              amount
              currencyCode
            }
            defaultAddress {
              firstName
              lastName
              address1
              address2
              city
              country
              zip
              phone
              provinceCode
              countryCodeV2
            }
          }
        }
      }
    }
  }
`
), x9 = ar(
  /* GraphQL */
  `
  query shopifyCustomerOrders($query: String!) {
    Shopify {
      orders(first: 5, query: $query, sortKey: CREATED_AT, reverse: true) {
        edges {
          node {
            id
            name
            createdAt
            displayFulfillmentStatus
            displayFinancialStatus
            cancelledAt
            tags
            discountCodes
            netPaymentSet {
              presentmentMoney {
                amount
                currencyCode
              }
            }
            totalRefundedSet {
              presentmentMoney {
                amount
                currencyCode
              }
            }
            billingAddress {
              firstName
              lastName
              company
              address1
              address2
              city
              country
              countryCodeV2
              province
              provinceCode
              zip
              phone
            }
            shippingAddress {
              firstName
              lastName
              company
              address1
              address2
              city
              country
              countryCodeV2
              province
              provinceCode
              zip
              phone
            }
            suggestedRefund(suggestFullRefund: true, refundShipping: true) {
              amountSet {
                presentmentMoney {
                  amount
                  currencyCode
                }
              }
              subtotalSet {
                presentmentMoney {
                  amount
                  currencyCode
                }
              }
              totalTaxSet {
                presentmentMoney {
                  amount
                  currencyCode
                }
              }
              shipping {
                amountSet {
                  presentmentMoney {
                    amount
                    currencyCode
                  }
                }
                maximumRefundableSet {
                  presentmentMoney {
                    amount
                    currencyCode
                  }
                }
              }
              suggestedTransactions {
                accountNumber
                gateway
                kind
                parentTransaction {
                  id
                }
                amountSet {
                  presentmentMoney {
                    amount
                    currencyCode
                  }
                }
              }
              refundLineItems {
                lineItem {
                  id
                  quantity
                }
              }
            }
            shippingLines(first: 5) {
              edges {
                node {
                  title
                  code
                  source
                  discountedPriceSet {
                    shopMoney {
                      amount
                      currencyCode
                    }
                  }
                }
              }
            }
            fulfillments(first: 2) {
              trackingInfo {
                company
                number
                url
              }
            }
            lineItems(first: 15) {
              edges {
                node {
                  id
                  title
                  quantity
                  variantTitle
                  sku
                  image {
                    url
                  }
                  product {
                    id
                  }
                  discountedUnitPriceSet {
                    shopMoney {
                      amount
                      currencyCode
                    }
                  }
                }
              }
            }
            refunds {
              totalRefunded {
                amount
                currencyCode
              }
              refundLineItems(first: 250) {
                edges {
                  node {
                    id
                    quantity
                    lineItem {
                      id
                      title
                    }
                  }
                }
              }
            }
            currentTotalPriceSet {
              presentmentMoney {
                amount
                currencyCode
              }
              shopMoney {
                amount
                currencyCode
              }
            }
            currentTotalDiscountsSet {
              shopMoney {
                amount
                currencyCode
              }
            }
          }
        }
      }
    }
  }
`
), S9 = ar(
  /* GraphQL */
  `
  query shopifySuggestedRefund(
    $orderId: ID!
    $refundLineItems: [Shopify_RefundLineItemInput!]
    $refundShipping: Boolean
    $suggestFullRefund: Boolean
  ) {
    Shopify {
      order(id: $orderId) {
        id
        suggestedRefund(
          refundLineItems: $refundLineItems
          refundShipping: $refundShipping
          suggestFullRefund: $suggestFullRefund
        ) {
          amountSet {
            presentmentMoney {
              amount
              currencyCode
            }
          }
          subtotalSet {
            presentmentMoney {
              amount
              currencyCode
            }
          }
          totalTaxSet {
            presentmentMoney {
              amount
              currencyCode
            }
          }
          shipping {
            amountSet {
              presentmentMoney {
                amount
                currencyCode
              }
            }
            maximumRefundableSet {
              presentmentMoney {
                amount
                currencyCode
              }
            }
          }
          suggestedTransactions {
            accountNumber
            gateway
            kind
            parentTransaction {
              id
            }
            amountSet {
              presentmentMoney {
                amount
                currencyCode
              }
            }
          }
          refundLineItems {
            lineItem {
              id
              quantity
            }
          }
        }
      }
    }
  }
`
), N9 = ar(
  /* GraphQL */
  `
  query segments($first: Int!) {
    Shopify {
      segments(first: $first) {
        edges {
          node {
            id
            name
          }
        }
      }
    }
  }
`
), j9 = ar(
  /* GraphQL */
  `
  query customerSegmentMembership($customerId: ID!, $segmentIds: [ID!]!) {
    Shopify {
      customerSegmentMembership(
        customerId: $customerId
        segmentIds: $segmentIds
      ) {
        memberships {
          segmentId
          isMember
        }
      }
    }
  }
`
), Zg = ar(
  /* GraphQL */
  `
  query searchProducts($query: String!, $productCount: Int, $mediaCount: Int) {
    Shopify {
      products(first: $productCount, query: $query) {
        nodes {
          id
          title
          description
          onlineStoreUrl
          status
          tags
          title
          totalInventory
          priceRangeV2 {
            maxVariantPrice {
              amount
              currencyCode
            }
            minVariantPrice {
              amount
              currencyCode
            }
          }
          media(first: $mediaCount) {
            nodes {
              alt
              id
              status
              mediaContentType
              preview {
                image {
                  id
                  altText
                  url
                }
              }
            }
          }
        }
      }
    }
  }
`
), w9 = ar(
  /* GraphQL */
  `
  query searchDiscountCodes($query: String, $first: Int, $after: String) {
    Shopify {
      discountNodes(query: $query, first: $first, after: $after) {
        pageInfo {
          hasNextPage
          endCursor
        }
        nodes {
          id
          discount {
            __typename

            ... on Shopify_DiscountCodeApp {
              title
              status
              codes(first: 100) {
                nodes {
                  code
                }
              }
            }

            ... on Shopify_DiscountCodeBasic {
              title
              status
              codes(first: 100) {
                nodes {
                  code
                }
              }
              customerGets {
                value {
                  __typename

                  ... on Shopify_DiscountPercentage {
                    percentage
                  }

                  ... on Shopify_DiscountAmount {
                    amount {
                      amount
                      currencyCode
                    }
                  }
                }
              }
            }

            ... on Shopify_DiscountCodeBxgy {
              title
              status
              codes(first: 100) {
                nodes {
                  code
                }
              }
            }

            ... on Shopify_DiscountCodeFreeShipping {
              title
              status
              codes(first: 100) {
                nodes {
                  code
                }
              }
            }
          }
        }
      }
    }
  }
`
), C9 = ar(
  /* GraphQL */
  `
  mutation orderUpdate($input: Shopify_OrderInput!) {
    Shopify {
      orderUpdate(input: $input) {
        order {
          shippingAddress {
            firstName
            lastName
            company
            address1
            address2
            city
            countryCodeV2
            provinceCode
            zip
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`
), F9 = ar(
  /* GraphQL */
  `
  mutation refundCreate($input: Shopify_RefundInput!) {
    Shopify {
      refundCreate(input: $input) {
        userErrors {
          field
          message
        }
      }
    }
  }
`
), I9 = ar(
  /* GraphQL */
  `
  mutation orderCancel(
    $notifyCustomer: Boolean
    $orderId: ID!
    $reason: Shopify_OrderCancelReason!
    $refundMethod: Shopify_OrderCancelRefundMethodInput!
    $restock: Boolean!
    $staffNote: String!
  ) {
    Shopify {
      orderCancel(
        notifyCustomer: $notifyCustomer
        orderId: $orderId
        reason: $reason
        refundMethod: $refundMethod
        restock: $restock
        staffNote: $staffNote
      ) {
        job {
          id
          done
        }
        orderCancelUserErrors {
          code
          field
          message
        }
      }
    }
  }
`
), $9 = ar(
  /* GraphQL */
  `
  mutation updateOrder($input: Shopify_OrderInput!) {
    Shopify {
      orderUpdate(input: $input) {
        order {
          id
          tags
        }
      }
    }
  }
`
), E9 = ar(
  /* GraphQL */
  `
  mutation createCustomer($input: Shopify_CustomerInput!) {
    Shopify {
      customerCreate(input: $input) {
        userErrors {
          field
          message
        }
        customer {
          id
          defaultEmailAddress {
            emailAddress
          }
          defaultPhoneNumber {
            phoneNumber
            marketingState
            marketingOptInLevel
          }
          taxExempt
          firstName
          lastName
          amountSpent {
            amount
            currencyCode
          }
        }
      }
    }
  }
`
), T9 = ar(
  /* GraphQL */
  `
  mutation createDiscountCode($input: Shopify_DiscountCodeBasicInput!) {
    Shopify {
      discountCodeBasicCreate(basicCodeDiscount: $input) {
        codeDiscountNode {
          id
          codeDiscount {
            ... on Shopify_DiscountCodeBasic {
              codes(first: 1) {
                nodes {
                  code
                }
              }
              title
              status
              startsAt
              endsAt
              usageLimit
              appliesOncePerCustomer
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`
), PF = Kl`
  mutation createOrder(
    $order: Shopify_OrderCreateOrderInput!
    $options: Shopify_OrderCreateOptionsInput
  ) {
    Shopify {
      orderCreate(order: $order, options: $options) {
        order {
          id
          name
          createdAt
          displayFulfillmentStatus
          displayFinancialStatus
          totalPriceSet {
            presentmentMoney {
              amount
              currencyCode
            }
            shopMoney {
              amount
              currencyCode
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`, R9 = Kl`
  mutation createDraftOrder($input: Shopify_DraftOrderInput!) {
    Shopify {
      draftOrderCreate(input: $input) {
        draftOrder {
          id
          name
          createdAt
          tags
          status
          totalPriceSet {
            presentmentMoney {
              amount
              currencyCode
            }
            shopMoney {
              amount
              currencyCode
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`, AF = ar(
  /* GraphQL */
  `
  mutation orderMarkAsPaid($input: Shopify_OrderMarkAsPaidInput!) {
    Shopify {
      orderMarkAsPaid(input: $input) {
        order {
          id
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`
), D9 = ({
  conversationContext: e,
  forcePhoneLookup: n
}) => {
  const { useQuery: r } = hn(), i = e.customer?.email, a = e.customer?.phone_number, o = i ? `email:"${i}"` : null, s = a ? `phone:"${a}"` : null, l = n ? s : o ?? s, {
    loading: c,
    error: m,
    data: u,
    refetch: f,
    networkStatus: h
  } = r(_9, {
    skip: !l,
    variables: {
      query: l
    },
    notifyOnNetworkStatusChange: !0
  });
  return {
    isCustomerLoading: c,
    customerError: m,
    customerData: u,
    refetchCustomer: f,
    customerNetworkStatus: h
  };
}, O9 = () => {
  const { useLazyQuery: e } = hn(), [
    n,
    {
      loading: r,
      error: i,
      data: a,
      refetch: o
    }
  ] = e(x9);
  return {
    getCustomerOrders: n,
    isCustomerOrdersLoading: r,
    customerOrdersError: i,
    customerOrders: a,
    refetchCustomerOrders: o
  };
};
function Hr(e = !1, n) {
  const [r, i] = pe(e);
  return Qe(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copy: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const LF = (e, n) => (n ?? []).map(({ amountSet: r, gateway: i, parentTransaction: a }) => ({
  amount: String(r?.presentmentMoney?.amount ?? "0.00"),
  gateway: i ?? "",
  kind: OF.Refund,
  orderId: e,
  parentId: a?.id
})), VF = ({
  orderId: e,
  transactions: n,
  refundLineItems: r,
  refundShipping: i,
  note: a,
  notify: o = !0
}) => ({
  orderId: e,
  notify: o,
  note: a,
  refundLineItems: r,
  transactions: n,
  shipping: {
    fullRefund: i
  }
}), P9 = ({
  ordersData: e
}) => {
  const n = (r) => r?.fulfillments?.length > 0 ? r.fulfillments[0].trackingInfo : [];
  return e.map(({ node: r }) => ({
    id: r.id,
    name: r.name,
    createdAt: new Date(r.createdAt),
    cancelledAt: r.cancelledAt ? new Date(r.cancelledAt) : void 0,
    status: `${r.displayFulfillmentStatus?.toLowerCase()}, ${r.displayFinancialStatus?.toLowerCase()}${r.cancelledAt ? ", cancelled" : ""}`,
    displayFinancialStatus: r.displayFinancialStatus,
    currentTotalPriceSet: r.currentTotalPriceSet,
    currentTotalDiscountsSet: r.currentTotalDiscountsSet,
    value: r.netPaymentSet?.presentmentMoney?.amount,
    currencyCode: r.netPaymentSet?.presentmentMoney?.currencyCode,
    shippingAddress: r.shippingAddress,
    billingAddress: r.billingAddress,
    lineItems: r.lineItems?.edges?.map(({ node: i }) => i),
    suggestedRefund: {
      orderId: r.id,
      amount: r.suggestedRefund?.amountSet?.presentmentMoney?.amount,
      subtotal: r.suggestedRefund?.subtotalSet?.presentmentMoney?.amount,
      tax: r.suggestedRefund?.totalTaxSet?.presentmentMoney?.amount,
      currency: r.suggestedRefund?.amountSet?.presentmentMoney?.currencyCode,
      notify: !0,
      refundLineItems: r.suggestedRefund?.refundLineItems.map(
        ({ lineItem: i }) => ({
          lineItemId: i.id,
          quantity: i.quantity
        })
      ),
      transactions: LF(
        r.id,
        r.suggestedRefund?.suggestedTransactions
      ),
      shipping: {
        fullRefund: !0,
        amount: r.suggestedRefund?.shipping?.amountSet?.presentmentMoney?.amount,
        maximumRefundable: r.suggestedRefund?.shipping?.maximumRefundableSet?.presentmentMoney?.amount
      }
    },
    trackingInfos: n(r),
    shippingLines: r.shippingLines?.edges?.map(({ node: i }) => i),
    tags: r.tags,
    discountCodes: r.discountCodes,
    refunds: r.refunds
  }));
}, Hj = [
  {
    value: Mi.Pending,
    label: "Pending",
    description: "The payment is pending"
  },
  {
    value: Mi.Authorized,
    label: "Authorized",
    description: "The payment has been authorized but not captured"
  },
  {
    value: Mi.Paid,
    label: "Paid",
    description: "The payment has been completed"
  }
], Wj = [
  {
    value: dl.Fulfilled,
    label: "Fulfilled",
    description: "Every line item in the order has been fulfilled"
  },
  {
    value: dl.Partial,
    label: "Partial",
    description: "At least one line item in the order has been fulfilled"
  },
  {
    value: dl.Restocked,
    label: "Restocked",
    description: "Every line item in the order has been restocked and the order canceled"
  }
], zF = (e) => e.length === 0 ? "" : e.map((n) => `id:${n.split("/").pop()}`).join(" OR "), pa = (e) => A9(L9(e)), A9 = (e) => Object.fromEntries(
  Object.entries(e ?? {}).filter(([, n]) => n != null)
), L9 = (e) => {
  const n = e;
  if (typeof n == "object" && "countryCodeV2" in n) {
    const { countryCodeV2: r, ...i } = n;
    return {
      ...i,
      ...r && { countryCode: r }
    };
  }
  return e;
}, UF = ({
  orderId: e,
  refundShipping: n,
  refundLineItems: r,
  suggestFullRefund: i,
  skip: a
}) => {
  const { useQuery: o } = hn(), {
    data: s,
    previousData: l,
    loading: c,
    error: m
  } = o(S9, {
    skip: a,
    fetchPolicy: "cache-and-network",
    notifyOnNetworkStatusChange: !0,
    variables: {
      orderId: e,
      refundShipping: n,
      refundLineItems: r,
      suggestFullRefund: i
    }
  }), u = a ? void 0 : s?.Shopify?.order?.suggestedRefund ?? l?.Shopify?.order?.suggestedRefund;
  return { suggestedRefund: Xn(() => {
    if (u)
      return {
        amount: String(u.amountSet.presentmentMoney.amount),
        subtotal: String(u.subtotalSet.presentmentMoney.amount),
        tax: String(u.totalTaxSet.presentmentMoney.amount),
        currency: u.amountSet.presentmentMoney.currencyCode,
        shipping: {
          amount: String(
            u.shipping.amountSet.presentmentMoney.amount
          ),
          maximumRefundable: String(
            u.shipping.maximumRefundableSet.presentmentMoney.amount
          )
        },
        transactions: LF(
          e,
          u.suggestedTransactions
        ),
        refundLineItems: u.refundLineItems.map(
          ({ lineItem: f }) => ({
            lineItemId: f.id,
            quantity: f.quantity
          })
        )
      };
  }, [u, e]), isLoading: c, error: m };
}, V9 = {
  nodes: [],
  hasMoreResults: !1
}, MF = (e) => "codes" in e.discount, Kj = (e) => MF(e) ? e.discount.codes.nodes[0]?.code ?? "" : "", z9 = (e) => [...e].sort(
  (n, r) => Kj(n).localeCompare(Kj(r))
), U9 = (e) => {
  const n = e?.Shopify?.discountNodes, r = (n?.nodes ?? []).filter(
    MF
  );
  return {
    nodes: z9(r),
    hasMoreResults: !!n?.pageInfo?.hasNextPage
  };
}, M9 = 300, Gj = 2, B9 = 250, BF = ({
  enabled: e = !0
} = {}) => {
  const { useLazyQuery: n, showNotification: r } = hn(), [i, a] = pe(""), [o, s] = pe([]), [l, c] = pe(!1), [m, u] = pe(!1), f = Er(null), h = Er(0), [k] = n(w9, {
    fetchPolicy: "no-cache"
  }), w = (j) => {
    s(j.nodes), c(j.hasMoreResults);
  }, N = async (j, _) => {
    const g = h.current + 1;
    h.current = g, u(!0);
    try {
      const O = await k({
        variables: { query: j, first: B9 }
      });
      if (g !== h.current)
        return;
      if (O.error)
        throw O.error;
      const R = U9(O.data);
      _ && (f.current = R), w(R);
    } catch {
      if (g !== h.current)
        return;
      w(V9), r({
        title: "Something went wrong",
        text: "Could not search for discount codes. Please try again.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    } finally {
      g === h.current && u(!1);
    }
  };
  return bi(
    () => {
      if (!e)
        return;
      const j = i.trim(), _ = j.length === 0;
      if (!(!_ && j.length < Gj)) {
        if (_ && f.current) {
          w(f.current);
          return;
        }
        N(
          _ ? void 0 : j,
          _
        );
      }
    },
    M9,
    [i, e]
  ), {
    discountNodes: o,
    isLoading: m,
    hasMoreResults: l,
    filter: i,
    setFilter: a,
    minSearchCharacters: Gj
  };
}, q9 = "_list_alvh6_1", H9 = "_listItem_alvh6_4", W9 = "_fullWidth_alvh6_15", K9 = "_boxWrapper_alvh6_19", Mt = {
  list: q9,
  listItem: H9,
  fullWidth: W9,
  boxWrapper: K9
}, G9 = "_modal_1vkwz_1", Y9 = "_disabled_1vkwz_5", Rh = {
  modal: G9,
  disabled: Y9
}, Yj = [
  {
    label: "Single Opt-In",
    description: "After providing their information, the customer receives marketing information without any intermediate steps.",
    value: Ui.SingleOptIn
  },
  {
    label: "Confirmed Opt-In",
    description: "After providing their information, the customer receives a confirmation and is required to perform a intermediate step before receiving marketing information.",
    value: Ui.ConfirmedOptIn
  },
  {
    label: "Unknown",
    description: "The customer receives marketing information but how they were opted in is unknown.",
    value: Ui.Unknown
  }
], Jj = [
  {
    label: "Not Subscribed",
    description: "The customer hasn’t subscribed to SMS marketing.",
    value: Mr.NotSubscribed
  },
  {
    label: "Pending",
    description: "The customer is in the process of subscribing to SMS marketing.",
    value: Mr.Pending
  },
  {
    label: "Redacted",
    description: "The customer’s personal data is erased. This value is internally-set and read-only.",
    value: Mr.Redacted
  },
  {
    label: "Subscribed",
    description: "The customer is subscribed to SMS marketing.",
    value: Mr.Subscribed
  },
  {
    label: "Unsubscribed",
    description: "The customer isn’t currently subscribed to SMS marketing but was previously subscribed.",
    value: Mr.Unsubscribed
  }
], J9 = ({
  conversationContext: e,
  isOpen: n,
  setIsOpen: r,
  isMutationLoading: i,
  setIsMutationLoading: a,
  refetchCustomer: o
}) => {
  const { track: s } = jn(), { useMutation: l, showNotification: c } = hn(), [m, u] = pe(), [f, h] = pe(), [k, w] = L_(!0), [N, j] = L_(!0), _ = !!m, g = e.customer?.email, O = e.customer?.phone_number, R = e.customer?.given_name, F = e.customer?.family_name, I = {
    email: g ?? "",
    phone: O ?? "",
    firstName: R ?? "",
    lastName: F ?? "",
    smsMarketingState: null,
    smsMarketingOptInLevel: null
  }, L = ut({
    defaultValues: I
  });
  Qe(() => {
    f?.forEach((P) => {
      const B = P?.field?.[0];
      B && (L.setError(B, {
        type: "server",
        message: P.message
      }), L.setFocus(B));
    });
  }, [f, L]);
  const [W, { error: J, reset: re }] = l(E9, {
    onError: (P) => {
      u(P.message), a(!1), c({
        title: "Something went wrong",
        text: "The customer creation was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    onCompleted: async (P) => {
      const B = P?.Shopify?.customerCreate?.userErrors || [];
      B.length > 0 ? (h(B), a(!1), c({
        title: "Something went wrong",
        text: "The customer creation was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      })) : (setTimeout(async () => {
        await o(), a(!1);
      }, 3e3), c({
        title: "Success",
        text: "The customer creation was successful.",
        icon: "check-circle-filled",
        severity: "success"
      }), s("shopify:profile:created"), r(!1));
    }
  }), K = ft(
    (P) => {
      a(!0), u(void 0), W({
        variables: {
          input: {
            firstName: P.firstName,
            lastName: P.lastName,
            ...k && { email: P.email },
            ...N && { phone: P.phone },
            ...P.smsMarketingState && {
              smsMarketingConsent: {
                marketingState: P.smsMarketingState,
                marketingOptInLevel: P.smsMarketingOptInLevel
              }
            }
          }
        }
      });
    },
    [W, a, N, k]
  ), Y = () => {
    r(!1), re(), u(void 0), L.reset(I);
  };
  return /* @__PURE__ */ v.jsxs(bt, { isOpen: n, onClose: Y, className: Rh.modal, children: [
    /* @__PURE__ */ v.jsx(_t, { title: "Create new customer", onClose: Y }),
    /* @__PURE__ */ v.jsx(xt, { children: /* @__PURE__ */ v.jsxs(et, { children: [
      /* @__PURE__ */ v.jsx(X, { span: 3, children: /* @__PURE__ */ v.jsx(
        On,
        {
          label: "First name",
          name: "firstName",
          control: L.control,
          rules: {
            required: "First name is required"
          }
        }
      ) }),
      /* @__PURE__ */ v.jsx(X, { span: 3, children: /* @__PURE__ */ v.jsx(
        On,
        {
          label: "Last name",
          name: "lastName",
          control: L.control,
          rules: {
            required: "Last name is required"
          }
        }
      ) }),
      /* @__PURE__ */ v.jsx(X, { children: /* @__PURE__ */ v.jsx(
        On,
        {
          label: "Email",
          name: "email",
          control: L.control,
          rules: {
            required: k ? "Email is required" : void 0
          },
          componentProps: {
            className: ct({
              [Rh.disabled]: !k
            }),
            prefix: {
              type: "custom",
              value: /* @__PURE__ */ v.jsx(
                Vo,
                {
                  disabled: !N,
                  name: "hasEmail",
                  value: "email",
                  checked: k,
                  onChange: () => w()
                }
              )
            }
          }
        }
      ) }),
      /* @__PURE__ */ v.jsx(X, { children: /* @__PURE__ */ v.jsx(
        On,
        {
          label: "Phone",
          name: "phone",
          control: L.control,
          rules: {
            required: N ? "Phone is required" : void 0
          },
          componentProps: {
            className: ct({
              [Rh.disabled]: !N
            }),
            prefix: {
              type: "custom",
              value: /* @__PURE__ */ v.jsx(
                Vo,
                {
                  disabled: !k,
                  name: "hasPhone",
                  value: "phone",
                  checked: N,
                  onChange: () => j()
                }
              )
            }
          }
        }
      ) }),
      /* @__PURE__ */ v.jsx(X, { children: /* @__PURE__ */ v.jsx(
        ur,
        {
          control: L.control,
          label: "SMS marketing state",
          name: "smsMarketingState",
          rules: {
            required: {
              value: !0,
              message: "Please select a marketing state"
            }
          },
          componentProps: {
            placeholder: "Select a marketing state",
            equalityFn: (P, B) => P === B,
            getItemTitleByValue: (P) => {
              const B = Jj.find(
                (ie) => ie.value === P
              );
              return /* @__PURE__ */ v.jsxs(
                b,
                {
                  flexDirection: "column",
                  gap: "100",
                  margin: "100 0 200",
                  children: [
                    /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: B.label }),
                    /* @__PURE__ */ v.jsx($.Paragraph, { color: "secondary", children: B.description })
                  ]
                }
              );
            }
          },
          children: Jj.map((P) => /* @__PURE__ */ v.jsx(mt.Item, { value: P.value, children: /* @__PURE__ */ v.jsxs(b, { flexDirection: "column", gap: "100", children: [
            /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: P.label }),
            /* @__PURE__ */ v.jsx($.Paragraph, { color: "secondary", children: P.description })
          ] }) }, P.value))
        }
      ) }),
      /* @__PURE__ */ v.jsx(X, { children: /* @__PURE__ */ v.jsx(
        ur,
        {
          control: L.control,
          label: "SMS marketing opt-in level",
          name: "smsMarketingOptInLevel",
          rules: {
            required: {
              value: !0,
              message: "Please select a marketing opt-in level"
            }
          },
          componentProps: {
            placeholder: "Select a marketing opt-in level",
            equalityFn: (P, B) => P === B,
            getItemTitleByValue: (P) => {
              const B = Yj.find(
                (ie) => ie.value === P
              );
              return /* @__PURE__ */ v.jsxs(
                b,
                {
                  flexDirection: "column",
                  gap: "100",
                  margin: "100 0 200",
                  children: [
                    /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: B.label }),
                    /* @__PURE__ */ v.jsx($.Paragraph, { color: "secondary", children: B.description })
                  ]
                }
              );
            }
          },
          children: Yj.map((P) => /* @__PURE__ */ v.jsx(mt.Item, { value: P.value, children: /* @__PURE__ */ v.jsxs(b, { flexDirection: "column", gap: "100", children: [
            /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: P.label }),
            /* @__PURE__ */ v.jsx($.Paragraph, { color: "secondary", children: P.description })
          ] }) }, P.value))
        }
      ) }),
      _ && /* @__PURE__ */ v.jsx(X, { children: /* @__PURE__ */ v.jsxs(b, { flexDirection: "row", gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ v.jsx(he, { name: "close-circle-filled", color: "red.500" }),
        /* @__PURE__ */ v.jsx($.Paragraph, { children: m })
      ] }) })
    ] }) }),
    /* @__PURE__ */ v.jsx(
      wt,
      {
        confirmProps: {
          disabled: !(L.formState.isValid && L.formState.isDirty),
          isLoading: i,
          loadingIndicator: /* @__PURE__ */ v.jsx(mn, { size: 16 })
        },
        confirmOnClick: L.handleSubmit(K),
        cancelOnClick: Y,
        confirmName: J ? "Close" : "Save",
        cancelName: J ? void 0 : "Cancel"
      }
    )
  ] });
}, Q9 = ({
  conversationContext: e,
  refetchCustomer: n
}) => {
  const [r, i] = pe(!1), [a, o] = pe(!1);
  return /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
    /* @__PURE__ */ v.jsx(
      tt,
      {
        variant: "secondary",
        onClick: () => i(!0),
        isLoading: a,
        loadingIndicator: /* @__PURE__ */ v.jsx(mn, { size: 16 }),
        slotStart: /* @__PURE__ */ v.jsx(he, { size: 14, name: "user-plus", color: "green.500" }),
        className: Mt.fullWidth,
        children: "Create new Shopify profile"
      }
    ),
    /* @__PURE__ */ v.jsx(
      J9,
      {
        isOpen: r,
        setIsOpen: i,
        isMutationLoading: a,
        setIsMutationLoading: o,
        conversationContext: e,
        refetchCustomer: n
      }
    )
  ] });
}, ev = (e) => {
  const n = e?.match(/shopify\/\w+\/(\d+)/);
  return n ? n[1] : null;
}, xy = "DD MMM YYYY @ HH:mm", X9 = "_wrapper_10fld_1", Z9 = "_copyIcon_10fld_7", Us = {
  wrapper: X9,
  copyIcon: Z9
}, e7 = ({
  customer: e,
  shopifyDomain: n,
  refresh: r,
  loading: i,
  networkStatus: a
}) => {
  const { isCopied: o, copy: s } = Hr(), { isCopied: l, copy: c } = Hr(), { track: m } = jn();
  if (!e)
    return null;
  const {
    id: u,
    displayName: f,
    defaultEmailAddress: h,
    defaultPhoneNumber: k,
    tags: w = [],
    verifiedEmail: N
  } = e, j = h?.emailAddress, _ = k?.phoneNumber, g = ev(u), O = `https://${n}/admin/customers/${g ?? ""}`, R = i && a === rr.refetch, F = 14;
  return /* @__PURE__ */ v.jsxs(b, { gap: "300", flexDirection: "column", children: [
    /* @__PURE__ */ v.jsxs(b, { className: Us.wrapper, gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: f }),
        R ? /* @__PURE__ */ v.jsx(mn, { size: F }) : /* @__PURE__ */ v.jsx(Xe, { content: "Reload customer", children: /* @__PURE__ */ v.jsx(
          he,
          {
            size: F,
            name: "sync",
            onClick: () => {
              m("shopify:refreshed", { shopifyId: u }), r();
            },
            className: Us.copyIcon
          }
        ) })
      ] }),
      j && /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ v.jsxs(b, { alignItems: "center", gap: "200", children: [
          /* @__PURE__ */ v.jsx(he, { size: F, name: "mail" }),
          /* @__PURE__ */ v.jsx($.ExternalLink, { href: `mailto:${j}`, children: j }),
          /* @__PURE__ */ v.jsx(
            Xe,
            {
              content: N ? "Verified email" : "Email is not verified",
              children: /* @__PURE__ */ v.jsx(b, { alignItems: "center", children: /* @__PURE__ */ v.jsx(
                he,
                {
                  size: F,
                  color: N ? "green.500" : "red.500",
                  name: N ? "check-circle" : "exclamation"
                }
              ) })
            }
          )
        ] }),
        /* @__PURE__ */ v.jsx(Xe, { content: "Copy Email", children: /* @__PURE__ */ v.jsx(
          he,
          {
            size: F,
            name: o ? "done" : "copy",
            onClick: () => s(j),
            className: Us.copyIcon
          }
        ) })
      ] }),
      _ && /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ v.jsxs(b, { alignItems: "center", gap: "200", children: [
          /* @__PURE__ */ v.jsx(he, { size: F, name: "phone" }),
          /* @__PURE__ */ v.jsx($.ExternalLink, { href: `tel:${_}`, children: _ })
        ] }),
        /* @__PURE__ */ v.jsx(Xe, { content: "Copy phone number", children: /* @__PURE__ */ v.jsx(
          he,
          {
            size: F,
            name: l ? "done" : "copy",
            onClick: () => c(_),
            className: Us.copyIcon
          }
        ) })
      ] }),
      /* @__PURE__ */ v.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ v.jsx(he, { size: F, name: "external-link" }),
        /* @__PURE__ */ v.jsx(
          $.ExternalLink,
          {
            href: O,
            target: "_blank",
            rel: "noreferrer",
            children: "View customer in Shopify"
          }
        )
      ] })
    ] }),
    w.length > 0 && /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
      /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: "Tags" }),
      /* @__PURE__ */ v.jsx(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: w.map((I) => /* @__PURE__ */ v.jsx(Jn, { children: I }, `${u}-${I}`)) })
    ] })
  ] });
}, n7 = "_creationModal_pbe64_1", t7 = "_detailsModal_pbe64_5", r7 = "_percentageSuffix_pbe64_9", Dh = {
  creationModal: n7,
  detailsModal: t7,
  percentageSuffix: r7
}, i7 = () => {
  const e = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  return Array.from(
    { length: 12 },
    () => e.charAt(Math.floor(Math.random() * e.length))
  ).join("");
}, a7 = (e) => {
  const n = e.customerGetsOption === "percentage" ? e.customerGets / 100 : e.customerGets, r = (() => {
    switch (e.minimumRequirementOption) {
      case "quantity":
        return "greaterThanOrEqualToQuantity";
      case "subtotal":
        return "greaterThanOrEqualToSubtotal";
      default:
        return null;
    }
  })(), i = e.maximumUsage;
  return {
    code: e.code,
    title: e.title,
    usageLimit: i === "only-once" ? 1 : null,
    appliesOncePerCustomer: i === "once-per-customer",
    customerGets: {
      value: {
        [e.customerGetsOption]: e.customerGetsOption === "discountAmount" ? { amount: n } : n
      },
      items: {
        all: !0
      }
    },
    context: {
      all: DF.All
    },
    ...r && {
      minimumRequirement: {
        [e.minimumRequirementOption]: {
          [r]: e.minimumRequirementOption === "quantity" ? e.minimumRequirementValue?.toString() : e.minimumRequirementValue
        }
      }
    },
    startsAt: (/* @__PURE__ */ new Date()).toISOString()
  };
}, Qj = [
  {
    label: "Percentage",
    description: "The percentage value of the discount.",
    value: "percentage"
  },
  {
    label: "Amount",
    description: "The value of the discount.",
    value: "discountAmount"
  }
], Xj = [
  {
    label: "None",
    description: "No minimum requirements.",
    value: "none"
  },
  {
    label: "Quantity",
    description: "Minimum required quantity of items.",
    value: "quantity"
  },
  {
    label: "Subtotal",
    description: "Minimum required order subtotal.",
    value: "subtotal"
  }
], Zj = [
  {
    label: "No limit",
    value: "no-limit",
    description: "The discount code can be used unlimited times."
  },
  {
    label: "Only once",
    value: "only-once",
    description: "The discount code can only be used once."
  },
  {
    label: "Once per customer",
    value: "once-per-customer",
    description: "The discount code can be used once per customer."
  }
], o7 = ({
  codeDiscount: e
}) => {
  const n = e?.codes?.nodes?.[0]?.code, { isCopied: r, copy: i } = Jt(), a = e?.usageLimit ? `${e?.usageLimit} uses remaining` : "No limit";
  return /* @__PURE__ */ v.jsxs(b, { flexDirection: "column", gap: "400", children: [
    /* @__PURE__ */ v.jsxs(Ye, { children: [
      /* @__PURE__ */ v.jsx(Ye.Text, { children: /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ v.jsx($.Paragraph, { variant: "1", children: "Title" }),
        /* @__PURE__ */ v.jsx($.Paragraph, { variant: "2", color: "secondary", children: e?.title })
      ] }) }),
      /* @__PURE__ */ v.jsx(Ye.Text, { children: /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ v.jsx($.Paragraph, { variant: "1", children: "Status" }),
        /* @__PURE__ */ v.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ v.jsx(
            he,
            {
              name: e?.status === "ACTIVE" ? "check-circle-filled" : "circle-filled",
              color: e?.status === "ACTIVE" ? "green.500" : "neutral.500"
            }
          ),
          /* @__PURE__ */ v.jsx($.Paragraph, { variant: "2", color: "secondary", children: e?.status })
        ] })
      ] }) }),
      /* @__PURE__ */ v.jsx(Ye.Text, { children: /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ v.jsx($.Paragraph, { variant: "1", children: "Usage limit" }),
        /* @__PURE__ */ v.jsx($.Paragraph, { variant: "2", color: "secondary", children: a })
      ] }) }),
      /* @__PURE__ */ v.jsx(Ye.Text, { children: /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ v.jsx($.Paragraph, { variant: "1", children: "Applies once per customer" }),
        /* @__PURE__ */ v.jsx($.Paragraph, { variant: "2", color: "secondary", children: e?.appliesOncePerCustomer ? "Yes" : "No" })
      ] }) }),
      /* @__PURE__ */ v.jsx(Ye.Text, { children: /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ v.jsx($.Paragraph, { variant: "1", children: "Starts at" }),
        /* @__PURE__ */ v.jsx($.Paragraph, { variant: "2", color: "secondary", children: Gn(e?.startsAt).format($t) })
      ] }) })
    ] }),
    /* @__PURE__ */ v.jsx(He, { label: "Discount code", children: /* @__PURE__ */ v.jsx(
      cr,
      {
        readOnly: !0,
        value: n,
        suffix: {
          type: "button",
          button: {
            icon: r ? "done" : "copy",
            onClick: () => {
              i(n);
            }
          }
        }
      }
    ) })
  ] });
}, s7 = "shopify-discount-code-form", ew = {
  title: "",
  code: "",
  customerGets: void 0,
  customerGetsOption: "percentage",
  minimumRequirementOption: "none",
  minimumRequirementValue: void 0,
  maximumUsage: "only-once"
}, l7 = ({
  isOpen: e,
  setIsOpen: n
}) => {
  const { track: r } = jn(), { useMutation: i, showNotification: a } = hn(), [o, s] = pe(
    []
  ), [l, c] = pe(), m = ut({
    mode: "all",
    defaultValues: ew
  });
  Qe(() => {
    o?.forEach((F) => {
      const I = F?.field?.[1];
      I && m.setError(I, {
        type: "server",
        message: F.message
      });
    });
  }, [o, m]);
  const u = !!l, f = m.watch("minimumRequirementOption"), h = m.watch("customerGetsOption"), k = Xn(() => {
    switch (f) {
      case "quantity":
        return "Minimum quantity";
      case "subtotal":
        return "Minimum subtotal";
      default:
        return "";
    }
  }, [f]), [
    w,
    {
      loading: N,
      error: j,
      reset: _
    }
  ] = i(T9, {
    onError: () => {
      a({
        title: "Something went wrong",
        text: "The discount code creation was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    onCompleted: (F) => {
      const I = F?.Shopify?.discountCodeBasicCreate?.userErrors;
      if (I && I.length > 0)
        s(I);
      else {
        const L = F?.Shopify?.discountCodeBasicCreate?.codeDiscountNode?.codeDiscount;
        L && "codes" in L && c(L), a({
          title: "Success",
          text: "The discount code was created successfully.",
          icon: "check-circle-filled",
          severity: "success"
        }), r("shopify:discount:code:created"), s([]);
      }
    }
  }), g = () => {
    m.setValue("code", i7(), {
      shouldDirty: !0,
      shouldValidate: !0,
      shouldTouch: !0
    });
  }, O = (F) => {
    w({
      variables: {
        input: a7(F)
      }
    });
  }, R = () => {
    m.reset(ew), s([]), _(), c(void 0), n(!1);
  };
  return /* @__PURE__ */ v.jsxs(
    bt,
    {
      isOpen: e,
      onClose: R,
      className: ct({
        [Dh.creationModal]: !u,
        [Dh.detailsModal]: u
      }),
      children: [
        /* @__PURE__ */ v.jsx(
          _t,
          {
            title: u ? "Discount code details" : "Create new discount code",
            onClose: R
          }
        ),
        /* @__PURE__ */ v.jsxs(xt, { children: [
          u && /* @__PURE__ */ v.jsx(o7, { codeDiscount: l }),
          !u && /* @__PURE__ */ v.jsxs("form", { noValidate: !0, id: s7, onSubmit: m.handleSubmit(O), children: [
            /* @__PURE__ */ v.jsx(b, { margin: "0 0 400", children: /* @__PURE__ */ v.jsx(
              Iy,
              {
                variant: "info",
                description: /* @__PURE__ */ v.jsx($.Paragraph, { children: "This code will be eligible for all customers." })
              }
            ) }),
            /* @__PURE__ */ v.jsxs(et, { children: [
              /* @__PURE__ */ v.jsx(X, { children: /* @__PURE__ */ v.jsx(
                On,
                {
                  label: "Title",
                  name: "title",
                  control: m.control,
                  rules: {
                    required: "Please enter a title"
                  },
                  componentProps: {
                    placeholder: "Enter a title"
                  }
                }
              ) }),
              /* @__PURE__ */ v.jsx(X, { span: 3, children: /* @__PURE__ */ v.jsx(
                ur,
                {
                  control: m.control,
                  label: "Discount type",
                  name: "customerGetsOption",
                  rules: {
                    required: "Please select a discount type"
                  },
                  componentProps: {
                    placeholder: "Select a discount type",
                    equalityFn: (F, I) => F === I,
                    onChange: () => {
                      m.setValue("customerGets", void 0), m.clearErrors("customerGets");
                    },
                    getItemTitleByValue: (F) => {
                      const I = Qj.find(
                        (L) => L.value === F
                      );
                      return /* @__PURE__ */ v.jsx(b, { margin: "0 0 100", children: /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: I?.label }) });
                    }
                  },
                  children: Qj.map((F) => /* @__PURE__ */ v.jsx(mt.Item, { value: F.value, children: /* @__PURE__ */ v.jsxs(b, { flexDirection: "column", gap: "100", children: [
                    /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: F.label }),
                    /* @__PURE__ */ v.jsx($.Paragraph, { color: "secondary", children: F.description })
                  ] }) }, F.value))
                }
              ) }),
              /* @__PURE__ */ v.jsx(X, { span: 3, children: /* @__PURE__ */ v.jsx(
                On,
                {
                  label: "Discount value",
                  name: "customerGets",
                  control: m.control,
                  rules: {
                    required: "Please enter a value",
                    validate: (F) => {
                      if (F) {
                        if (h === "percentage" && (F < 0 || F > 100))
                          return "Percentage must be between 0 and 100";
                        if (h === "discountAmount" && F < 0)
                          return "Discount amount must be greater than 0";
                      }
                    }
                  },
                  componentProps: {
                    placeholder: "Enter a value",
                    type: "number",
                    ...h === "percentage" && {
                      suffix: {
                        type: "custom",
                        noWrap: !0,
                        value: /* @__PURE__ */ v.jsx(
                          b,
                          {
                            alignItems: "center",
                            className: Dh.percentageSuffix,
                            children: "%"
                          }
                        )
                      }
                    }
                  }
                }
              ) }),
              /* @__PURE__ */ v.jsx(X, { children: /* @__PURE__ */ v.jsx(
                On,
                {
                  label: "Code",
                  name: "code",
                  control: m.control,
                  rules: {
                    required: "Please enter a code"
                  },
                  componentProps: {
                    placeholder: "Enter a code or click to the right to generate",
                    suffix: {
                      type: "button",
                      button: {
                        icon: "sync",
                        onClick: g
                      }
                    }
                  }
                }
              ) }),
              /* @__PURE__ */ v.jsx(X, { span: 3, children: /* @__PURE__ */ v.jsx(
                ur,
                {
                  control: m.control,
                  label: "Minimum purchase requirements",
                  name: "minimumRequirementOption",
                  rules: {
                    required: "Please select a minimum requirement option"
                  },
                  componentProps: {
                    placeholder: "Select a minimum purchase requirement",
                    equalityFn: (F, I) => F === I,
                    onChange: () => {
                      m.setValue("minimumRequirementValue", void 0), m.clearErrors("minimumRequirementValue");
                    },
                    getItemTitleByValue: (F) => {
                      const I = Xj.find(
                        (L) => L.value === F
                      );
                      return /* @__PURE__ */ v.jsx(b, { margin: "0 0 100", children: /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: I?.label }) });
                    }
                  },
                  children: Xj.map((F) => /* @__PURE__ */ v.jsx(mt.Item, { value: F.value, children: /* @__PURE__ */ v.jsxs(b, { flexDirection: "column", gap: "100", children: [
                    /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: F.label }),
                    /* @__PURE__ */ v.jsx($.Paragraph, { color: "secondary", children: F.description })
                  ] }) }, F.value))
                }
              ) }),
              /* @__PURE__ */ v.jsx(X, { span: 3, children: /* @__PURE__ */ v.jsx(
                On,
                {
                  name: "minimumRequirementValue",
                  label: k,
                  control: m.control,
                  disabled: f === "none",
                  rules: {
                    required: {
                      value: f !== "none",
                      message: "Please enter a value"
                    },
                    validate: (F) => {
                      if (F && f !== "none" && F < 0)
                        return `Minimum ${f} must be greater than 0`;
                    }
                  },
                  componentProps: {
                    type: "number",
                    placeholder: "Enter a value"
                  }
                }
              ) }),
              /* @__PURE__ */ v.jsx(X, { children: /* @__PURE__ */ v.jsx(
                ur,
                {
                  name: "maximumUsage",
                  label: "Maximum usage",
                  control: m.control,
                  componentProps: {
                    placeholder: "Select a maximum usage",
                    equalityFn: (F, I) => F === I,
                    getItemTitleByValue: (F) => {
                      const I = Zj.find(
                        (L) => L.value === F
                      );
                      return /* @__PURE__ */ v.jsx(b, { margin: "0 0 100", children: /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: I?.label }) });
                    }
                  },
                  children: Zj.map((F) => /* @__PURE__ */ v.jsx(mt.Item, { value: F.value, children: /* @__PURE__ */ v.jsxs(b, { flexDirection: "column", gap: "100", children: [
                    /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: F.label }),
                    /* @__PURE__ */ v.jsx($.Paragraph, { color: "secondary", children: F.description })
                  ] }) }, F.value))
                }
              ) })
            ] })
          ] }),
          j && /* @__PURE__ */ v.jsx($n, { error: j })
        ] }),
        /* @__PURE__ */ v.jsx(
          wt,
          {
            confirmProps: {
              disabled: !u && !(m.formState.isValid && m.formState.isDirty),
              isLoading: N,
              loadingIndicator: /* @__PURE__ */ v.jsx(mn, { size: 16 })
            },
            confirmName: u ? "Close" : "Save",
            confirmOnClick: u ? R : m.handleSubmit(O),
            cancelOnClick: u ? void 0 : R
          }
        )
      ]
    }
  );
}, d7 = ({ code: e }) => {
  const { isCopied: n, copy: r } = Hr();
  return /* @__PURE__ */ v.jsxs(
    b,
    {
      justifyContent: "space-between",
      alignItems: "center",
      gap: "200",
      width: "100%",
      children: [
        /* @__PURE__ */ v.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ v.jsx(he, { size: 12, name: "shopify", color: "green.500" }),
          /* @__PURE__ */ v.jsx($.Paragraph, { variant: "3", children: e })
        ] }),
        /* @__PURE__ */ v.jsx(
          Qt,
          {
            icon: n ? "done" : "copy",
            onClick: () => r(e),
            variant: "secondary"
          }
        )
      ]
    }
  );
}, c7 = ({
  discountCode: e
}) => {
  const { discount: n } = e;
  if (!("codes" in n))
    return null;
  const r = n?.codes?.nodes ?? [];
  return /* @__PURE__ */ v.jsxs(b, { flexDirection: "column", gap: "100", children: [
    /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: n.title }),
    /* @__PURE__ */ v.jsx(Ye, { children: r.map((i) => /* @__PURE__ */ v.jsx(Ye.Item, { className: Mt.listItem, children: /* @__PURE__ */ v.jsx(d7, { code: i.code }) }, i.code)) })
  ] });
}, u7 = "_modal_11d6e_1", m7 = "_modalBody_11d6e_4", p7 = "_codeContainer_11d6e_9", Oh = {
  modal: u7,
  modalBody: m7,
  codeContainer: p7
}, f7 = ({
  isOpen: e,
  setIsOpen: n
}) => {
  const {
    discountNodes: r,
    isLoading: i,
    filter: a,
    setFilter: o,
    minSearchCharacters: s
  } = BF({ enabled: e }), l = r.length === 0, c = () => {
    o(""), n(!1);
  };
  return /* @__PURE__ */ v.jsxs(bt, { isOpen: e, onClose: c, className: Oh.modal, children: [
    /* @__PURE__ */ v.jsx(_t, { title: "Discount codes", onClose: c }),
    /* @__PURE__ */ v.jsxs(xt, { className: Oh.modalBody, children: [
      /* @__PURE__ */ v.jsx(
        cr,
        {
          type: "search",
          icon: "search",
          value: a,
          placeholder: `Search discount codes (min. ${s} characters)`,
          onChange: (m) => {
            o(m.target.value);
          }
        }
      ),
      i && /* @__PURE__ */ v.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ v.jsx(mn, {}) }),
      !i && l && /* @__PURE__ */ v.jsx(
        zo,
        {
          title: "No discount codes found.",
          description: "There are no discount codes to display. You can create a new discount code with the 'Create new' button in our integration."
        }
      ),
      !i && !l && r.map((m) => /* @__PURE__ */ v.jsx("div", { className: Oh.codeContainer, children: /* @__PURE__ */ v.jsx(c7, { discountCode: m }) }, m.id))
    ] }),
    /* @__PURE__ */ v.jsx(wt, { confirmName: "Close", confirmOnClick: c })
  ] });
}, h7 = ({
  displayDiscountCodeCreation: e
}) => {
  const [n, r] = pe(!1), [i, a] = pe(!1);
  return /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
    /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: "Discount codes" }),
      /* @__PURE__ */ v.jsxs(b, { gap: "100", flexDirection: "row", alignItems: "center", width: "100%", children: [
        /* @__PURE__ */ v.jsx(b, { flex: "1", children: /* @__PURE__ */ v.jsx(
          tt,
          {
            variant: "secondary",
            icon: "gift",
            onClick: () => a(!0),
            style: { width: "100%" },
            children: "View discount codes"
          }
        ) }),
        e && /* @__PURE__ */ v.jsx(b, { flex: "1", children: /* @__PURE__ */ v.jsx(
          tt,
          {
            variant: "secondary",
            icon: "plus",
            onClick: () => r(!0),
            style: { width: "100%" },
            children: "Create new"
          }
        ) })
      ] })
    ] }),
    /* @__PURE__ */ v.jsx(
      f7,
      {
        isOpen: i,
        setIsOpen: a
      }
    ),
    /* @__PURE__ */ v.jsx(
      l7,
      {
        isOpen: n,
        setIsOpen: r
      }
    )
  ] });
}, y7 = ({
  customer: e
}) => {
  if (!e)
    return null;
  const { defaultEmailAddress: n, defaultPhoneNumber: r } = e, i = (h) => h ? xw(h.replaceAll("_", " ")) : "No state available", a = (h) => {
    switch (h) {
      case ma.Invalid:
      case ma.NotSubscribed:
      case Mr.NotSubscribed:
        return "red.500";
      case ma.Pending:
      case Mr.Pending:
      case ma.Unsubscribed:
      case Mr.Unsubscribed:
        return "orange.500";
      case ma.Subscribed:
      case Mr.Subscribed:
        return "green.500";
      default:
        return "neutral.500";
    }
  }, o = (h) => {
    switch (h) {
      case Ui.SingleOptIn:
      case Ui.ConfirmedOptIn:
        return "green.500";
      case Ui.Unknown:
      default:
        return "neutral.200";
    }
  }, {
    marketingState: s,
    marketingUpdatedAt: l,
    marketingOptInLevel: c
  } = n ?? {}, {
    marketingState: m,
    marketingUpdatedAt: u,
    marketingOptInLevel: f
  } = r ?? {};
  return /* @__PURE__ */ v.jsxs(b, { gap: "300", flexDirection: "column", children: [
    /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: "Marketing consent" }),
    /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "row", children: [
        /* @__PURE__ */ v.jsx(he, { name: "mail", color: "neutral.500" }),
        /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-4", children: "Email" })
      ] }),
      l && /* @__PURE__ */ v.jsx(Xe, { content: "Last updated at", children: /* @__PURE__ */ v.jsx(Pn, { size: "small", variant: "info", children: Gn(l).format(xy) }) }),
      /* @__PURE__ */ v.jsxs(b, { gap: "100", flexDirection: "row", children: [
        /* @__PURE__ */ v.jsx(Xe, { content: "Opt-In state", children: /* @__PURE__ */ v.jsx(Jn, { color: o(c), children: i(c) }) }),
        /* @__PURE__ */ v.jsx(Xe, { content: "Marketing state", children: /* @__PURE__ */ v.jsx(Jn, { color: a(s), children: i(s) }) })
      ] })
    ] }),
    /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
        /* @__PURE__ */ v.jsx(he, { name: "phone", color: "neutral.500" }),
        /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-4", children: "Phone" })
      ] }),
      u && /* @__PURE__ */ v.jsx(Xe, { content: "Last updated at", children: /* @__PURE__ */ v.jsx(Pn, { size: "small", variant: "info", children: Gn(u).format(xy) }) }),
      /* @__PURE__ */ v.jsxs(b, { gap: "100", flexDirection: "row", children: [
        /* @__PURE__ */ v.jsx(Xe, { content: "Opt-In state", children: /* @__PURE__ */ v.jsx(Jn, { color: o(f), children: i(f) }) }),
        /* @__PURE__ */ v.jsx(Xe, { content: "Marketing state", children: /* @__PURE__ */ v.jsx(Jn, { color: a(m), children: i(m) }) })
      ] })
    ] })
  ] });
}, g7 = (e) => {
  const { discount: n } = e;
  switch (n.__typename) {
    case "Shopify_DiscountCodeBasic": {
      if (n.status !== _y.Active)
        return null;
      const r = n.codes.nodes[0]?.code;
      if (!r)
        return null;
      const { value: i } = n.customerGets;
      return i.__typename === "Shopify_DiscountPercentage" ? {
        code: r,
        kind: "percentage",
        percentage: Number((i.percentage * 100).toFixed(2))
      } : i.__typename === "Shopify_DiscountAmount" ? {
        code: r,
        kind: "fixedAmount",
        amount: String(i.amount.amount),
        currencyCode: i.amount.currencyCode
      } : null;
    }
    case "Shopify_DiscountCodeFreeShipping": {
      if (n.status !== _y.Active)
        return null;
      const r = n.codes.nodes[0]?.code;
      return r ? { code: r, kind: "freeShipping" } : null;
    }
    default:
      return null;
  }
}, v7 = (e) => {
  const n = e.map(g7).filter(
    (i) => !!i
  ), r = /* @__PURE__ */ new Map();
  return n.forEach((i) => {
    r.has(i.code) || r.set(i.code, i);
  }), Array.from(r.values());
}, qF = (e) => {
  if (e)
    switch (e.kind) {
      case "percentage":
        return {
          itemPercentageDiscountCode: {
            code: e.code,
            percentage: e.percentage
          }
        };
      case "fixedAmount":
        return {
          itemFixedDiscountCode: {
            code: e.code,
            amountSet: {
              shopMoney: {
                amount: e.amount,
                currencyCode: e.currencyCode
              }
            }
          }
        };
      case "freeShipping":
        return { freeShippingDiscountCode: { code: e.code } };
      default:
        return;
    }
}, k7 = (e) => e ? [e.code] : void 0, Sy = (e) => {
  switch (e.kind) {
    case "percentage":
      return `${e.percentage}% off`;
    case "fixedAmount":
      return `${e.amount} ${e.currencyCode} off`;
    case "freeShipping":
      return "Free shipping";
    default:
      return "";
  }
}, HF = ({
  enabled: e
}) => {
  const n = Dr(), { discountNodes: r, isLoading: i, filter: a, setFilter: o, minSearchCharacters: s } = BF({ enabled: e }), l = Xn(
    () => v7(r),
    [r]
  ), c = a.trim().length > 0;
  if (!i && !c && l.length === 0)
    return null;
  const m = !i && l.length === 0;
  return /* @__PURE__ */ v.jsx(
    ur,
    {
      label: "Discount code",
      control: n.control,
      name: "discountCode",
      componentProps: {
        clearable: !0,
        placeholder: "Search discount codes",
        tabIndex: 0,
        equalityFn: (u, f) => u?.code === f?.code,
        getItemTitleByValue: (u) => u ? /* @__PURE__ */ v.jsxs($.Paragraph, { children: [
          u.code,
          " · ",
          Sy(u)
        ] }) : null,
        filter: {
          value: a,
          placeholder: `Search discount codes (min. ${s} characters)`,
          onChange: (u) => {
            o(u.target.value);
          }
        },
        onToggleDropdown: (u) => {
          !u && a !== "" && o("");
        }
      },
      children: /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
        i && /* @__PURE__ */ v.jsx(mt.Item, { noFixedSelectionStateSpace: !0, children: /* @__PURE__ */ v.jsx(b, { justifyContent: "center", padding: "300", children: /* @__PURE__ */ v.jsx(mn, {}) }) }),
        !i && l.map((u) => /* @__PURE__ */ v.jsx(mt.Item, { value: u, children: /* @__PURE__ */ v.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            gap: "200",
            children: [
              c ? /* @__PURE__ */ v.jsx(
                Cw,
                {
                  text: u.code,
                  highlight: a
                }
              ) : /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: u.code }),
              /* @__PURE__ */ v.jsx($.Paragraph, { variant: "5", color: "tertiary", children: Sy(u) })
            ]
          }
        ) }, u.code)),
        m && /* @__PURE__ */ v.jsx(mt.Item, { noFixedSelectionStateSpace: !0, children: /* @__PURE__ */ v.jsx(
          zo,
          {
            title: "No discount codes found",
            description: "Try changing your search criteria."
          }
        ) })
      ] })
    }
  );
}, Ei = ({
  control: e,
  name: n,
  label: r,
  placeholder: i,
  required: a = !1,
  apiUserError: o
}) => /* @__PURE__ */ v.jsx(
  Nt,
  {
    name: n,
    control: e,
    rules: {
      required: a ? {
        value: !0,
        message: "This field is required"
      } : !1
    },
    render: ({ field: s, fieldState: l }) => /* @__PURE__ */ v.jsx(
      Wr,
      {
        required: a,
        label: r,
        input: s,
        placeholder: i,
        meta: {
          warning: l?.error?.message,
          error: l?.error?.message || o?.[s.name]
        }
      }
    )
  }
), b7 = "_modal_1wlra_1", _7 = {
  modal: b7
};
function nw(e) {
  try {
    return new Intl.DisplayNames(["en"], { type: "region" }).of(
      e.toUpperCase()
    ) ?? e;
  } catch {
    return e;
  }
}
const tw = [
  "AF",
  "AX",
  "AL",
  "DZ",
  "AD",
  "AO",
  "AI",
  "AG",
  "AR",
  "AM",
  "AW",
  "AC",
  "AU",
  "AT",
  "AZ",
  "BS",
  "BH",
  "BD",
  "BB",
  "BY",
  "BE",
  "BZ",
  "BJ",
  "BM",
  "BT",
  "BO",
  "BA",
  "BW",
  "BV",
  "BR",
  "IO",
  "BN",
  "BG",
  "BF",
  "BI",
  "KH",
  "CA",
  "CV",
  "BQ",
  "KY",
  "CF",
  "TD",
  "CL",
  "CN",
  "CX",
  "CC",
  "CO",
  "KM",
  "CG",
  "CD",
  "CK",
  "CR",
  "HR",
  "CU",
  "CW",
  "CY",
  "CZ",
  "CI",
  "DK",
  "DJ",
  "DM",
  "DO",
  "EC",
  "EG",
  "SV",
  "GQ",
  "ER",
  "EE",
  "SZ",
  "ET",
  "FK",
  "FO",
  "FJ",
  "FI",
  "FR",
  "GF",
  "PF",
  "TF",
  "GA",
  "GM",
  "GE",
  "DE",
  "GH",
  "GI",
  "GR",
  "GL",
  "GD",
  "GP",
  "GT",
  "GG",
  "GN",
  "GW",
  "GY",
  "HT",
  "HM",
  "VA",
  "HN",
  "HK",
  "HU",
  "IS",
  "IN",
  "ID",
  "IR",
  "IQ",
  "IE",
  "IM",
  "IL",
  "IT",
  "JM",
  "JP",
  "JE",
  "JO",
  "KZ",
  "KE",
  "KI",
  "KP",
  "XK",
  "KW",
  "KG",
  "LA",
  "LV",
  "LB",
  "LS",
  "LR",
  "LY",
  "LI",
  "LT",
  "LU",
  "MO",
  "MG",
  "MW",
  "MY",
  "MV",
  "ML",
  "MT",
  "MQ",
  "MR",
  "MU",
  "YT",
  "MX",
  "MD",
  "MC",
  "MN",
  "ME",
  "MS",
  "MA",
  "MZ",
  "MM",
  "NA",
  "NR",
  "NP",
  "NL",
  "AN",
  "NC",
  "NZ",
  "NI",
  "NE",
  "NG",
  "NU",
  "NF",
  "MK",
  "NO",
  "OM",
  "PK",
  "PS",
  "PA",
  "PG",
  "PY",
  "PE",
  "PH",
  "PN",
  "PL",
  "PT",
  "QA",
  "CM",
  "RE",
  "RO",
  "RU",
  "RW",
  "BL",
  "SH",
  "KN",
  "LC",
  "MF",
  "PM",
  "WS",
  "SM",
  "ST",
  "SA",
  "SN",
  "RS",
  "SC",
  "SL",
  "SG",
  "SX",
  "SK",
  "SI",
  "SB",
  "SO",
  "ZA",
  "GS",
  "KR",
  "SS",
  "ES",
  "LK",
  "VC",
  "SD",
  "SR",
  "SJ",
  "SE",
  "CH",
  "SY",
  "TW",
  "TJ",
  "TZ",
  "TH",
  "TL",
  "TG",
  "TK",
  "TO",
  "TT",
  "TA",
  "TN",
  "TR",
  "TM",
  "TC",
  "TV",
  "UG",
  "UA",
  "AE",
  "GB",
  "US",
  "UM",
  "UY",
  "UZ",
  "VU",
  "VE",
  "VN",
  "VG",
  "WF",
  "EH",
  "YE",
  "ZM",
  "ZW",
  "ZZ"
], rw = "shopify-shiping-address-form", x7 = ({
  title: e,
  address: n,
  isOpen: r,
  setIsOpen: i,
  orderId: a,
  shopifyId: o,
  shippingCountryCodes: s,
  onChange: l,
  refetchOrders: c
}) => {
  const { useMutation: m, showNotification: u } = hn(), { track: f } = jn(), [h, k] = pe(!1), [w, N] = pe({}), j = !l, [
    _,
    { error: g, reset: O }
  ] = m(C9, {
    onError: () => {
      k(!1), u({
        title: "Something went wrong",
        text: "The address change was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    onCompleted: (K) => {
      k(!1);
      const Y = K?.Shopify?.orderUpdate?.userErrors;
      if (Y != null && Y.length > 0) {
        const P = Y.reduce(
          (B, ie) => {
            const we = ie.field;
            if (we == null || we.length === 0)
              return B;
            const me = we[we.length - 1];
            return me != null && (B[me] = ie.message), B;
          },
          {}
        );
        N(P);
      } else
        u({
          title: "Success",
          text: "The address change was successful.",
          icon: "check-circle-filled",
          severity: "success"
        }), c(), re();
    }
  }), R = ft(
    () => ({
      firstName: n?.firstName || "",
      lastName: n?.lastName || "",
      company: n?.company || "",
      address1: n?.address1 || "",
      address2: n?.address2 || "",
      city: n?.city || "",
      countryCodeV2: tw.find(
        (K) => K === n?.countryCodeV2
      ),
      provinceCode: n?.province || "",
      zip: n?.zip || ""
    }),
    [n]
  ), { control: F, handleSubmit: I, formState: L, reset: W } = ut({
    mode: "all",
    defaultValues: R()
  }), J = I((K) => {
    if (j) {
      if (k(!0), !o || !a) {
        k(!1);
        return;
      }
      f("shopify:order:edit:shipping:address:modal:submitted", {
        shopifyId: o,
        orderId: a
      });
      const { countryCodeV2: Y, ...P } = K, B = {
        ...P,
        countryCode: Y
      };
      _({
        variables: {
          input: {
            id: a,
            shippingAddress: B
          }
        }
      });
    } else
      l(K), re();
  });
  Qe(() => {
    r && W(R());
  }, [r, n, W, R]);
  const re = () => {
    W(R()), N({}), O(), i(!1);
  };
  return /* @__PURE__ */ v.jsxs(
    bt,
    {
      isOpen: r,
      onClose: re,
      className: _7.modal,
      "data-testid": "edit-shipping-address-modal",
      children: [
        /* @__PURE__ */ v.jsx(_t, { title: e, onClose: () => re() }),
        /* @__PURE__ */ v.jsx(xt, { children: /* @__PURE__ */ v.jsxs("form", { noValidate: !0, id: rw, onSubmit: J, children: [
          g && /* @__PURE__ */ v.jsx($n, { error: g }),
          /* @__PURE__ */ v.jsxs(et, { children: [
            /* @__PURE__ */ v.jsx(X, { span: 3, children: /* @__PURE__ */ v.jsx(
              Ei,
              {
                required: !0,
                control: F,
                name: "firstName",
                label: "First name",
                placeholder: "Insert your first name",
                apiUserError: w
              }
            ) }),
            /* @__PURE__ */ v.jsx(X, { span: 3, children: /* @__PURE__ */ v.jsx(
              Ei,
              {
                required: !0,
                control: F,
                name: "lastName",
                label: "Last name",
                placeholder: "Insert your last name",
                apiUserError: w
              }
            ) }),
            /* @__PURE__ */ v.jsx(X, { span: 6, children: /* @__PURE__ */ v.jsx(
              Ei,
              {
                control: F,
                name: "company",
                label: "Company",
                placeholder: "Insert your company name"
              }
            ) }),
            /* @__PURE__ */ v.jsx(X, { span: 6, children: /* @__PURE__ */ v.jsx(
              Ei,
              {
                required: !0,
                control: F,
                name: "address1",
                label: "Address",
                placeholder: "Insert your address",
                apiUserError: w
              }
            ) }),
            /* @__PURE__ */ v.jsx(X, { span: 6, children: /* @__PURE__ */ v.jsx(
              Ei,
              {
                control: F,
                name: "address2",
                label: "Additional address details",
                placeholder: "Insert more address details"
              }
            ) }),
            /* @__PURE__ */ v.jsx(X, { span: 3, children: /* @__PURE__ */ v.jsx(
              Ei,
              {
                required: !0,
                control: F,
                name: "zip",
                label: "Zip / postal code",
                placeholder: "Insert your zip / postal code",
                apiUserError: w
              }
            ) }),
            /* @__PURE__ */ v.jsx(X, { span: 3, children: /* @__PURE__ */ v.jsx(
              Ei,
              {
                required: !0,
                control: F,
                name: "city",
                label: "City",
                placeholder: "Insert your city",
                apiUserError: w
              }
            ) }),
            /* @__PURE__ */ v.jsx(X, { span: 6, children: /* @__PURE__ */ v.jsx(
              ur,
              {
                name: "countryCodeV2",
                control: F,
                label: "Country",
                rules: {
                  required: {
                    value: !0,
                    message: "Please select a country"
                  }
                },
                componentProps: {
                  placeholder: "Select your country",
                  getItemTitleByValue: (K) => K ? nw(K) : ""
                },
                children: tw.filter((K) => s.includes(K)).map((K) => /* @__PURE__ */ v.jsx(mt.Item, { value: K, children: /* @__PURE__ */ v.jsx($.Paragraph, { children: nw(K) }) }, K))
              }
            ) })
          ] })
        ] }) }),
        /* @__PURE__ */ v.jsx(
          wt,
          {
            confirmProps: {
              disabled: !(L.isValid && L.isDirty),
              type: "submit",
              form: rw,
              isLoading: h,
              loadingIndicator: /* @__PURE__ */ v.jsx(mn, { size: 16 })
            },
            confirmOnClick: () => {
              g && re();
            },
            cancelOnClick: () => {
              o && a && !g && f("shopify:order:edit:shipping:address:modal:canceled", {
                shopifyId: o,
                orderId: a
              }), re();
            },
            confirmName: g ? "Close" : "Save",
            cancelName: g ? void 0 : "Cancel"
          }
        )
      ]
    }
  );
}, S7 = "_clickableIcon_33mqm_1", Ph = {
  clickableIcon: S7
}, iw = ({
  formFieldName: e,
  ...n
}) => {
  const r = Dr(), { field: i } = Yy({
    control: r.control,
    name: e
  });
  return /* @__PURE__ */ v.jsx(
    Ny,
    {
      enableEditAddress: !0,
      openByDefault: !0,
      onChange: i.onChange,
      ...n
    }
  );
}, Ny = ({
  labelText: e,
  address: n,
  orderId: r,
  shopifyId: i,
  shippingCountryCodes: a,
  enableEditAddress: o,
  icon: s = "home",
  onChange: l,
  refetchOrders: c,
  openByDefault: m = !1
}) => {
  const [u, f] = pe(!1), [h, k] = pe(m), { isCopied: w, copy: N } = Hr(), { track: j } = jn(), _ = 14, g = o && (!!r || !!l), O = [n?.zip || "", n?.city || ""].filter(Boolean).join(" "), R = [n?.firstName || "", n?.lastName || ""].filter(Boolean).join(" "), F = n?.countryCodeV2 && _I(n.countryCodeV2), I = ft(() => [
    R,
    n?.company,
    n?.address1,
    n?.address2,
    O,
    n?.province,
    F
  ].filter(Boolean).join(`
`), [n, R, O, F]);
  if (!n)
    return null;
  const L = () => {
    i && r && j("shopify:order:edit:shipping:address:modal:opened", {
      shopifyId: i,
      orderId: r
    }), f(!0);
  };
  return /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
    /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ v.jsxs(b, { gap: "250", flexDirection: "row", children: [
        /* @__PURE__ */ v.jsx(he, { size: _, name: s, color: "green.500" }),
        /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "column", children: [
          /* @__PURE__ */ v.jsxs(
            b,
            {
              gap: "100",
              flexDirection: "row",
              onClick: () => k(!h),
              className: Ph.clickableIcon,
              alignItems: "center",
              children: [
                /* @__PURE__ */ v.jsx($.Paragraph, { variant: "3", children: e }),
                /* @__PURE__ */ v.jsx(
                  he,
                  {
                    size: _,
                    name: h ? "angle-down" : "angle-right"
                  }
                )
              ]
            }
          ),
          h && /* @__PURE__ */ v.jsxs(b, { gap: "100", flexDirection: "column", children: [
            R && /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: R }),
            n?.company && /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: n.company }),
            n?.address1 && /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: n.address1 }),
            n?.address2 && /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: n.address2 }),
            O && /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: O }),
            n?.province && /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: n.province }),
            F && /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: F })
          ] })
        ] })
      ] }),
      /* @__PURE__ */ v.jsxs(b, { gap: "250", flexDirection: "row", children: [
        g && /* @__PURE__ */ v.jsx(Xe, { content: `Edit ${e.toLowerCase()}`, children: /* @__PURE__ */ v.jsx(
          he,
          {
            size: _,
            name: "pen",
            onClick: () => L(),
            className: Ph.clickableIcon
          }
        ) }),
        /* @__PURE__ */ v.jsx(Xe, { content: `Copy ${e.toLowerCase()}`, children: /* @__PURE__ */ v.jsx(
          he,
          {
            size: _,
            name: w ? "done" : "copy",
            onClick: () => N(I()),
            className: Ph.clickableIcon
          }
        ) })
      ] })
    ] }),
    g && /* @__PURE__ */ v.jsx(
      x7,
      {
        title: `Edit ${e}`,
        address: n,
        isOpen: u,
        setIsOpen: f,
        orderId: r,
        shopifyId: i,
        shippingCountryCodes: a,
        onChange: l,
        refetchOrders: c
      }
    )
  ] });
}, WF = ({
  withAddresses: e = !0,
  selectedProductIds: n
}) => {
  const r = Dr(), i = gi({ control: r.control, name: "lineItems" }), a = gi({
    control: r.control,
    name: "billingAddress"
  }), o = gi({
    control: r.control,
    name: "shippingAddress"
  }), s = gi({
    control: r.control,
    name: "discountCode"
  }), l = Xn(() => n ? n.length === 0 ? [] : (i || []).filter(
    (u) => n.includes(u.id)
  ) : i, [i, n]), c = Xn(() => !l || l.length === 0 ? 0 : l.reduce((u, f) => {
    const h = f.priceRangeV2?.minVariantPrice?.amount || 0, k = f.quantity || 0;
    return u + h * k;
  }, 0), [l]), m = l?.[0]?.priceRangeV2?.minVariantPrice?.currencyCode || "";
  return /* @__PURE__ */ v.jsxs(b, { flexDirection: "column", gap: "300", children: [
    e && /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
      /* @__PURE__ */ v.jsxs($.Paragraph, { variant: "3", children: [
        a?.firstName,
        " ",
        a?.lastName
      ] }),
      /* @__PURE__ */ v.jsx(
        iw,
        {
          formFieldName: "billingAddress",
          address: a,
          labelText: "Billing address",
          shippingCountryCodes: [],
          refetchOrders: () => Promise.resolve({})
        }
      ),
      /* @__PURE__ */ v.jsx(
        iw,
        {
          formFieldName: "shippingAddress",
          address: o,
          labelText: "Shipping address",
          shippingCountryCodes: [],
          icon: "map-pin",
          refetchOrders: () => Promise.resolve({})
        }
      )
    ] }),
    /* @__PURE__ */ v.jsx(Wl, {}),
    /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ v.jsx($.Paragraph, { variant: "3", children: "Subtotal" }),
      /* @__PURE__ */ v.jsx($.Paragraph, { variant: "3", children: `${c.toFixed(2)} ${m}` })
    ] }),
    s && /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
      /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ v.jsxs($.Paragraph, { variant: "4", children: [
          "Discount (",
          s.code,
          ")"
        ] }),
        /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: Sy(s) })
      ] }),
      /* @__PURE__ */ v.jsx($.Paragraph, { color: "tertiary", variant: "5", children: "The discount will be deducted after the order is created." })
    ] }),
    /* @__PURE__ */ v.jsx($.Paragraph, { color: "tertiary", variant: "5", children: "Tax and shipping will be calculated by Shopify based on customer address and store settings." })
  ] });
}, N7 = "_productTableHeader_6h6pl_1", j7 = "_productImage_6h6pl_5", Lo = {
  productTableHeader: N7,
  productImage: j7
}, nv = (e) => e.media?.nodes?.[0]?.preview?.image?.url || null, w7 = ({
  product: e,
  index: n,
  onRemove: r
}) => {
  const i = Dr(), a = e.priceRangeV2.minVariantPrice.amount, o = e.priceRangeV2.minVariantPrice.currencyCode, s = `lineItems.${n}.quantity`, l = i.watch(s), c = nv(e);
  return /* @__PURE__ */ v.jsxs(ot.Tr, { children: [
    /* @__PURE__ */ v.jsx(ot.Td, { children: /* @__PURE__ */ v.jsxs(b, { gap: "200", alignItems: "center", children: [
      c && /* @__PURE__ */ v.jsx(
        Fa,
        {
          src: c,
          alt: e.title,
          className: Lo.productImage
        }
      ),
      /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: e.title })
    ] }) }),
    /* @__PURE__ */ v.jsx(ot.Td, { children: /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: e.totalInventory }) }),
    /* @__PURE__ */ v.jsx(ot.Td, { children: /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: `${a} ${o}` }) }),
    /* @__PURE__ */ v.jsx(ot.Td, { children: /* @__PURE__ */ v.jsx(
      On,
      {
        noLabel: !0,
        noAlert: !0,
        name: s,
        control: i.control,
        componentProps: {
          type: "number",
          min: 1,
          max: e.totalInventory,
          tabIndex: 0
        }
      },
      `${s}-${l}`
    ) }),
    /* @__PURE__ */ v.jsx(ot.Td, { children: /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: `${a * l} ${o}` }) }),
    /* @__PURE__ */ v.jsx(ot.Td, { children: /* @__PURE__ */ v.jsx(b, { justifyContent: "flex-end", children: /* @__PURE__ */ v.jsx(Qt, { icon: "trash", variant: "secondary", onClick: r }) }) })
  ] });
}, C7 = 300, xo = 2, F7 = 25, I7 = ({
  onProductSelected: e
}) => {
  const { useLazyQuery: n, showNotification: r } = hn(), [i, a] = pe(""), [o, s] = pe([]), l = Dr(), c = l.watch("selectedProductId"), [m, { loading: u, networkStatus: f }] = n(Zg, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onCompleted: (N) => {
      const j = N?.Shopify?.products?.nodes || [];
      s(
        j.filter((_) => !!_).sort((_, g) => _.title.localeCompare(g.title))
      );
    },
    onError: () => {
      s([]), r({
        title: "Something went wrong",
        text: "Could not search for products. Please try again.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    }
  });
  bi(
    () => {
      i.trim().length >= xo && !u && f === rr.ready ? m({
        variables: {
          query: i.trim(),
          productCount: F7,
          mediaCount: 1
        }
      }) : i.trim().length < xo && s([]);
    },
    C7,
    [i]
  ), Qe(() => {
    if (!c) return;
    const N = o.find(
      (j) => j.id === c
    );
    N && e(N), l.setValue("selectedProductId", void 0);
  }, [c, o, l, e]);
  const h = u && f !== rr.ready, k = i.trim().length >= xo, w = !o.length && !h && k;
  return /* @__PURE__ */ v.jsx(
    ur,
    {
      noAlert: !0,
      label: "Product selection",
      control: l.control,
      name: "selectedProductId",
      componentProps: {
        placeholder: `Search products (min. ${xo} characters)`,
        tabIndex: 0,
        getItemTitleByValue: (N) => {
          const j = o.find(
            (_) => _.id === N
          );
          return j ? /* @__PURE__ */ v.jsx($.Paragraph, { children: j.title }) : null;
        },
        filter: {
          value: i,
          onChange: (N) => {
            a(N.target.value);
          }
        },
        onToggleDropdown: (N) => {
          !N && i !== "" && a("");
        }
      },
      children: /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
        h && /* @__PURE__ */ v.jsx(mt.Item, { noFixedSelectionStateSpace: !0, children: /* @__PURE__ */ v.jsx(b, { justifyContent: "center", padding: "300", children: /* @__PURE__ */ v.jsx(mn, {}) }) }),
        !h && o.map((N) => {
          const j = N.totalInventory <= 0, _ = nv(N);
          return /* @__PURE__ */ v.jsx(
            mt.Item,
            {
              value: N.id,
              isDisabled: j,
              children: /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
                /* @__PURE__ */ v.jsxs(b, { gap: "200", alignItems: "center", children: [
                  _ && /* @__PURE__ */ v.jsx(
                    Fa,
                    {
                      src: _,
                      alt: N.title,
                      className: Lo.productImage
                    }
                  ),
                  i ? /* @__PURE__ */ v.jsx(
                    Cw,
                    {
                      text: N.title,
                      highlight: i
                    }
                  ) : /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: N.title })
                ] }),
                /* @__PURE__ */ v.jsx($.Paragraph, { variant: "5", children: j ? "Out of stock" : `${N.totalInventory} in stock` })
              ] })
            },
            N.id
          );
        }),
        w && /* @__PURE__ */ v.jsx(mt.Item, { noFixedSelectionStateSpace: !0, children: /* @__PURE__ */ v.jsx(
          zo,
          {
            title: "No products found",
            description: "Try changing your search criteria."
          }
        ) }),
        !k && !h && /* @__PURE__ */ v.jsx(mt.Item, { noFixedSelectionStateSpace: !0, children: /* @__PURE__ */ v.jsx(
          zo,
          {
            title: "Search for products",
            description: `Type at least ${xo} characters to search.`
          }
        ) })
      ] })
    }
  );
}, tv = ({
  loading: e = !1,
  selectionMode: n = !1,
  hideDeleteButton: r = !1,
  hideProductSelect: i = !1,
  selectedProductIds: a = [],
  disabledProductIds: o = [],
  maxQuantities: s,
  onToggleSelect: l,
  onToggleSelectAll: c
}) => {
  const m = Dr(), u = m.watch("lineItems"), f = !!u?.length, h = n && f ? u.filter(
    (j) => !o.includes(j?.id)
  ) : [], k = h.length > 0 && h.every(
    (j) => a.includes(j?.id)
  ), w = h.some(
    (j) => a.includes(j?.id)
  ) && !k, N = ft(
    (j) => {
      const _ = m.getValues("lineItems"), g = _.findIndex(
        (O) => O?.id === j.id
      );
      if (g > -1) {
        const O = m.getValues(`lineItems.${g}.quantity`) || 0, R = [..._];
        R[g] = {
          ...R[g],
          quantity: O + 1
        }, m.setValue("lineItems", R);
      } else
        m.setValue("lineItems", [
          ..._,
          { ...j, quantity: 1 }
        ]);
    },
    [m]
  );
  return /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "column", children: [
    !i && /* @__PURE__ */ v.jsx(I7, { onProductSelected: N }),
    !f && e && /* @__PURE__ */ v.jsx(
      b,
      {
        margin: "200 0",
        justifyContent: "center",
        padding: "300",
        className: Mt.boxWrapper,
        children: /* @__PURE__ */ v.jsx(mn, {})
      }
    ),
    !f && !e && /* @__PURE__ */ v.jsx(
      b,
      {
        margin: "200 0",
        justifyContent: "center",
        className: Mt.boxWrapper,
        children: /* @__PURE__ */ v.jsx(
          zo,
          {
            title: "No products selected",
            description: "Select a product above for your new order"
          }
        )
      }
    ),
    f && /* @__PURE__ */ v.jsx(b, { margin: "300 0", children: /* @__PURE__ */ v.jsxs(
      ot,
      {
        hoverable: !0,
        framed: !1,
        headerWithBackground: !1,
        className: Lo.productTable,
        children: [
          /* @__PURE__ */ v.jsx(ot.Thead, { className: Lo.productTableHeader, children: /* @__PURE__ */ v.jsxs(ot.Tr, { children: [
            n && /* @__PURE__ */ v.jsx(ot.Th, { children: /* @__PURE__ */ v.jsx(
              dv,
              {
                checked: k,
                indeterminate: w,
                onChange: () => c?.(!k)
              }
            ) }),
            /* @__PURE__ */ v.jsx(ot.Th, { children: "Product" }),
            /* @__PURE__ */ v.jsx(ot.Th, { children: "In stock" }),
            /* @__PURE__ */ v.jsx(ot.Th, { children: "Price" }),
            /* @__PURE__ */ v.jsx(ot.Th, { children: "Quantity" }),
            /* @__PURE__ */ v.jsx(ot.Th, { children: "Total" }),
            !r && /* @__PURE__ */ v.jsx(ot.Th, {})
          ] }) }),
          /* @__PURE__ */ v.jsx(ot.Tbody, { children: u?.map((j, _) => {
            if (!n)
              return /* @__PURE__ */ v.jsx(
                w7,
                {
                  product: j,
                  index: _,
                  onRemove: () => {
                    const Y = u.filter(
                      (P, B) => B !== _
                    );
                    m.setValue("lineItems", Y);
                  }
                },
                `${j?.id}-${_}`
              );
            const g = j, O = g.priceRangeV2.minVariantPrice.amount, R = g.priceRangeV2.minVariantPrice.currencyCode, F = `lineItems.${_}.quantity`, I = m.watch(F) || 0, L = O * I, W = nv(g), J = a.includes(g.id), re = o.includes(g.id), K = s?.[g.id] ?? g.totalInventory;
            return /* @__PURE__ */ v.jsxs(
              ot.Tr,
              {
                style: re ? { opacity: 0.5 } : void 0,
                children: [
                  /* @__PURE__ */ v.jsx(ot.Td, { children: /* @__PURE__ */ v.jsx(
                    dv,
                    {
                      checked: J,
                      disabled: re,
                      onChange: () => l?.(g.id, !J)
                    }
                  ) }),
                  /* @__PURE__ */ v.jsx(ot.Td, { children: /* @__PURE__ */ v.jsxs(b, { gap: "200", alignItems: "center", children: [
                    W && /* @__PURE__ */ v.jsx(
                      Fa,
                      {
                        src: W,
                        alt: g.title,
                        className: Lo.productImage
                      }
                    ),
                    /* @__PURE__ */ v.jsxs(b, { flexDirection: "column", children: [
                      /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: g.title }),
                      re && /* @__PURE__ */ v.jsx($.Paragraph, { variant: "5", children: "Already refunded" })
                    ] })
                  ] }) }),
                  /* @__PURE__ */ v.jsx(ot.Td, { children: /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: g.totalInventory }) }),
                  /* @__PURE__ */ v.jsx(ot.Td, { children: /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: `${O} ${R}` }) }),
                  /* @__PURE__ */ v.jsx(ot.Td, { children: /* @__PURE__ */ v.jsx(
                    On,
                    {
                      noLabel: !0,
                      noAlert: !0,
                      disabled: re || K <= 1,
                      name: F,
                      control: m.control,
                      componentProps: {
                        type: "number",
                        min: 1,
                        max: K,
                        tabIndex: 0
                      }
                    },
                    `${F}-${m.watch(F)}`
                  ) }),
                  /* @__PURE__ */ v.jsx(ot.Td, { children: /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: `${L} ${R}` }) }),
                  !r && /* @__PURE__ */ v.jsx(ot.Td, { children: /* @__PURE__ */ v.jsx(b, { justifyContent: "flex-end", children: /* @__PURE__ */ v.jsx(
                    Qt,
                    {
                      icon: "trash",
                      variant: "secondary",
                      onClick: () => {
                        const Y = u.filter(
                          (P, B) => B !== _
                        );
                        m.setValue("lineItems", Y), J && l?.(g.id, !1);
                      }
                    }
                  ) }) })
                ]
              },
              `${g.id}-${_}`
            );
          }) })
        ]
      }
    ) })
  ] });
}, KF = ({
  previousOrderStatus: e
} = {}) => {
  const n = Dr();
  return /* @__PURE__ */ v.jsx(
    ur,
    {
      label: "Payment Status",
      name: "financialStatus",
      control: n.control,
      rules: {
        required: {
          value: !0,
          message: "Please select a payment status"
        }
      },
      componentProps: {
        placeholder: "Select payment status",
        tabIndex: 0,
        getItemTitleByValue: (r) => {
          const i = Hj.find(
            (a) => a.value === r
          );
          return i ? /* @__PURE__ */ v.jsxs(
            b,
            {
              flexDirection: "row",
              gap: "200",
              alignItems: "center",
              margin: "0 0 100 0",
              children: [
                /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: i.label }),
                /* @__PURE__ */ v.jsxs($.Paragraph, { variant: "5", color: "secondary", children: [
                  "(",
                  i.description,
                  ")"
                ] })
              ]
            }
          ) : null;
        }
      },
      children: Hj.map((r) => {
        const i = e && r.value === e;
        return /* @__PURE__ */ v.jsx(mt.Item, { value: r.value, children: /* @__PURE__ */ v.jsxs(b, { flexDirection: "column", gap: "100", children: [
          /* @__PURE__ */ v.jsxs(b, { flexDirection: "row", gap: "200", alignItems: "center", children: [
            /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: r.label }),
            i && /* @__PURE__ */ v.jsx($.Paragraph, { variant: "5", color: "secondary", children: "(previous order status)" })
          ] }),
          /* @__PURE__ */ v.jsx($.Paragraph, { variant: "5", color: "secondary", children: r.description })
        ] }) }, r.value);
      })
    }
  );
}, GF = () => {
  const e = Dr();
  return /* @__PURE__ */ v.jsx(
    ur,
    {
      label: "Fulfillment Status",
      helpIcon: {
        text: "Defaults to 'unfulfilled' if nothing is selected"
      },
      name: "fulfillmentStatus",
      control: e.control,
      componentProps: {
        clearable: !0,
        placeholder: "Select fulfillment status",
        tabIndex: 0,
        getItemTitleByValue: (n) => {
          const r = Wj.find(
            (i) => i.value === n
          );
          return r ? /* @__PURE__ */ v.jsxs(b, { gap: "200", alignItems: "center", margin: "0 0 100 0", children: [
            /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: r.label }),
            /* @__PURE__ */ v.jsxs($.Paragraph, { variant: "5", color: "secondary", children: [
              "(",
              r.description,
              ")"
            ] })
          ] }) : null;
        }
      },
      children: Wj.map((n) => /* @__PURE__ */ v.jsx(mt.Item, { value: n.value, children: /* @__PURE__ */ v.jsxs(b, { flexDirection: "column", gap: "100", children: [
        /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: n.label }),
        /* @__PURE__ */ v.jsx($.Paragraph, { variant: "5", color: "secondary", children: n.description })
      ] }) }, n.value))
    }
  );
}, $7 = "_modal_1mprq_1", E7 = {
  modal: $7
}, Ah = "create-shopify-order-form", T7 = ({
  isOpen: e,
  shopifyCustomer: n,
  displayCreateDraftOrder: r,
  setIsOpen: i,
  refetchCustomerOrders: a
}) => {
  const { useMutation: o, showNotification: s } = hn(), { track: l } = jn(), [c, m] = pe(!1), [
    u,
    f
  ] = pe(!1), h = {
    firstName: n.defaultAddress?.firstName,
    lastName: n.defaultAddress?.lastName,
    address1: n.defaultAddress?.address1,
    address2: n.defaultAddress?.address2,
    city: n.defaultAddress?.city,
    zip: n.defaultAddress?.zip,
    countryCodeV2: n.defaultAddress?.countryCodeV2,
    phone: n.defaultAddress?.phone
  }, k = {
    selectedProductId: void 0,
    lineItems: [],
    customNote: "",
    tags: [],
    billingAddress: h,
    shippingAddress: h,
    financialStatus: Mi.Pending,
    fulfillmentStatus: void 0,
    discountCode: void 0
  }, [w, N] = pe([]), j = ut({
    mode: "all",
    defaultValues: k
  }), _ = j.watch("lineItems").length > 0, g = () => {
    j.reset(k), N([]), i(!1);
  };
  Qe(() => {
    w.length > 0 && j.setValue("tags", w, { shouldDirty: !0 });
  }, [w, j]);
  const O = Er(!1), R = () => {
    a(), m(!1), s({
      title: "Success",
      text: "The order was created successfully.",
      icon: "check-circle-filled",
      severity: "success"
    }), l("shopify:order:create:succeeded"), g();
  }, F = () => {
    a(), m(!1), s({
      title: "Order created but not marked as paid",
      text: "The order was created but recording the payment failed. You can mark it as paid in Shopify.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    }), g();
  }, I = () => {
    m(!1), s({
      title: "Something went wrong",
      text: "The order creation was not successful.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    }), l("shopify:order:create:failed"), g();
  }, [L] = o(AF, {
    onError: F,
    onCompleted: (B) => {
      const ie = B.Shopify?.orderMarkAsPaid?.userErrors;
      if (ie && ie.length > 0) {
        F();
        return;
      }
      R();
    }
  }), [W, { error: J }] = o(PF, {
    onError: I,
    onCompleted: (B) => {
      const ie = B.Shopify?.orderCreate, we = ie?.order?.id;
      if (ie?.userErrors?.length || !we) {
        I();
        return;
      }
      if (O.current) {
        L({ variables: { input: { id: we } } });
        return;
      }
      R();
    }
  }), [re, { error: K }] = o(
    R9,
    {
      onError: () => {
        f(!1), s({
          title: "Something went wrong",
          text: "The draft order creation was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), l("shopify:order:create:draft:failed"), g();
      },
      onCompleted: () => {
        a(), f(!1), s({
          title: "Success",
          text: "The draft order creation was successful.",
          icon: "check-circle-filled",
          severity: "success"
        }), l("shopify:order:create:draft:succeeded"), g();
      }
    }
  ), Y = (B) => {
    const ie = B.lineItems.map((ge) => ({
      productId: ge.id,
      requiresShipping: !0,
      priceSet: {
        shopMoney: {
          amount: ge.priceRangeV2.maxVariantPrice.amount,
          currencyCode: ge.priceRangeV2.maxVariantPrice.currencyCode
        }
      },
      quantity: ge.quantity
    }));
    m(!0);
    const we = pa(B?.billingAddress), me = pa(
      B?.shippingAddress
    ), le = B.financialStatus === Mi.Paid;
    O.current = le, W({
      variables: {
        order: {
          lineItems: ie,
          customer: {
            toAssociate: {
              id: n?.id
            }
          },
          note: B.customNote,
          tags: B.tags,
          financialStatus: le ? void 0 : B.financialStatus,
          fulfillmentStatus: B.fulfillmentStatus,
          discountCode: qF(B.discountCode),
          shippingAddress: me,
          billingAddress: we
        }
      }
    });
  }, P = (B) => {
    const ie = B.lineItems.map((le) => ({
      title: le.title,
      requiresShipping: !0,
      originalUnitPriceWithCurrency: {
        amount: le.priceRangeV2.maxVariantPrice.amount,
        currencyCode: le.priceRangeV2.maxVariantPrice.currencyCode
      },
      quantity: le.quantity
    }));
    f(!0);
    const we = pa(B?.billingAddress), me = pa(
      B?.shippingAddress
    );
    re({
      variables: {
        input: {
          email: n.defaultEmailAddress?.emailAddress,
          note: B.customNote,
          tags: B.tags,
          lineItems: ie,
          discountCodes: k7(B.discountCode),
          shippingAddress: me,
          billingAddress: we
        }
      }
    });
  };
  return /* @__PURE__ */ v.jsxs(
    bt,
    {
      isOpen: e,
      onClose: g,
      className: E7.modal,
      allowEscClose: !1,
      children: [
        /* @__PURE__ */ v.jsx(_t, { title: "Create new order", onClose: g }),
        /* @__PURE__ */ v.jsxs(xt, { children: [
          /* @__PURE__ */ v.jsx(Gy, { ...j, children: /* @__PURE__ */ v.jsx("form", { id: Ah, children: /* @__PURE__ */ v.jsxs(et, { children: [
            /* @__PURE__ */ v.jsx(X, { children: /* @__PURE__ */ v.jsx(tv, {}) }),
            /* @__PURE__ */ v.jsx(X, { children: /* @__PURE__ */ v.jsx(
              Nt,
              {
                name: "tags",
                render: ({ fieldState: { error: B } }) => /* @__PURE__ */ v.jsx(
                  He,
                  {
                    label: "Tags",
                    meta: {
                      error: B?.message
                    },
                    children: /* @__PURE__ */ v.jsx(
                      "div",
                      {
                        tabIndex: 0,
                        onKeyDown: (ie) => {
                          ie.key === "Enter" && (ie.preventDefault(), ie.stopPropagation());
                        },
                        children: /* @__PURE__ */ v.jsx(
                          Hl,
                          {
                            placeholder: "Type and hit enter to add tags",
                            selectedTags: w,
                            onChange: (ie) => {
                              N(ie);
                            }
                          },
                          `tags-input-${e}`
                        )
                      }
                    )
                  }
                )
              }
            ) }),
            /* @__PURE__ */ v.jsx(X, { span: 4, children: /* @__PURE__ */ v.jsxs(b, { flexDirection: "column", gap: "300", children: [
              /* @__PURE__ */ v.jsx(KF, {}),
              /* @__PURE__ */ v.jsx(GF, {}),
              /* @__PURE__ */ v.jsx(HF, { enabled: e }),
              /* @__PURE__ */ v.jsx(
                On,
                {
                  label: "Custom note",
                  name: "customNote",
                  componentProps: {
                    placeholder: "Enter custom note",
                    tabIndex: 0
                  }
                }
              )
            ] }) }),
            /* @__PURE__ */ v.jsx(X, { span: 2, children: /* @__PURE__ */ v.jsx(He, { label: "Details", noAlert: !0, children: /* @__PURE__ */ v.jsx(
              b,
              {
                flexDirection: "column",
                gap: "200",
                justifyContent: "end",
                className: Mt.boxWrapper,
                children: /* @__PURE__ */ v.jsx(WF, {})
              }
            ) }) })
          ] }) }) }),
          (J || K) && /* @__PURE__ */ v.jsx($n, { error: J || K })
        ] }),
        /* @__PURE__ */ v.jsx(
          wt,
          {
            confirmProps: {
              type: "submit",
              form: Ah,
              disabled: !_ || c,
              isLoading: c,
              loadingIndicator: /* @__PURE__ */ v.jsx(mn, { size: 16 }),
              tabIndex: 0
            },
            confirmName: "Create order",
            confirmOnClick: j.handleSubmit(Y),
            ...r && {
              confirmSecondaryName: "Create draft order",
              confirmSecondaryOnClick: () => {
                j.handleSubmit(P)();
              },
              confirmSecondaryProps: {
                type: "submit",
                form: Ah,
                disabled: !_ || u,
                isLoading: u,
                loadingIndicator: /* @__PURE__ */ v.jsx(mn, { size: 16 }),
                tabIndex: 0
              }
            }
          }
        )
      ]
    }
  );
}, R7 = "_modal_al73g_1", D7 = {
  modal: R7
}, aw = [
  {
    label: "Customer",
    value: Oi.Customer,
    description: "The customer wanted to cancel the order."
  },
  {
    label: "Declined",
    value: Oi.Declined,
    description: "Payment was declined."
  },
  {
    label: "Fraud",
    value: Oi.Fraud,
    description: "The order was fraudulent."
  },
  {
    label: "Inventory",
    value: Oi.Inventory,
    description: "There was insufficient inventory."
  },
  {
    label: "Other",
    value: Oi.Other,
    description: "The order was canceled for an unlisted reason."
  },
  {
    label: "Staff",
    value: Oi.Staff,
    description: "Staff made an error."
  }
], O7 = ({
  orderId: e,
  isOpen: n,
  orderName: r,
  setIsOpen: i,
  isMutationLoading: a,
  setIsMutationLoading: o,
  refetchOrders: s
}) => {
  const { track: l } = jn(), { useMutation: c, showNotification: m } = hn(), [u, f] = pe([]), h = u.length > 0, k = {
    orderId: e,
    reason: null,
    refundMethod: {
      originalPaymentMethodsRefund: !0
    },
    restock: !0,
    notifyCustomer: !1,
    staffNote: ""
  }, w = ut({
    defaultValues: k
  }), [N, { error: j, reset: _ }] = c(I9, {
    onError: () => {
      o(!1), m({
        title: "Something went wrong",
        text: "Could not cancel the order.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), i(!1);
    },
    onCompleted: async (R) => {
      const F = R.Shopify?.orderCancel?.orderCancelUserErrors || [];
      if (F.length > 0)
        o(!1), f(F), m({
          title: "Something went wrong",
          text: "Could not cancel the order.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        });
      else {
        const I = R.Shopify?.orderCancel?.job?.done;
        setTimeout(async () => {
          await s().finally(() => o(!1));
        }, I ? 0 : 4e3), m({
          title: "Success",
          text: `${I ? "The order got cancelled" : "The order is being cancelled. It might take some time until it is reflected in the order details."}`,
          icon: "check-circle-filled",
          severity: "success"
        }), l("shopify:order:cancelled"), i(!1);
      }
    }
  }), g = ft(
    (R) => {
      R.reason != null && (o(!0), N({
        variables: {
          orderId: R.orderId,
          reason: R.reason,
          refundMethod: R.refundMethod,
          restock: R.restock,
          notifyCustomer: R.notifyCustomer,
          staffNote: R.staffNote ?? ""
        }
      }));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [e]
  ), O = () => {
    i(!1), _(), f([]), w.reset(k);
  };
  return /* @__PURE__ */ v.jsxs(bt, { isOpen: n, onClose: O, className: D7.modal, children: [
    /* @__PURE__ */ v.jsx(_t, { title: `Cancel order ${r}`, onClose: O }),
    /* @__PURE__ */ v.jsx(xt, { children: /* @__PURE__ */ v.jsxs(et, { children: [
      /* @__PURE__ */ v.jsx(X, { children: /* @__PURE__ */ v.jsx(
        ur,
        {
          control: w.control,
          label: "Reason",
          name: "reason",
          rules: {
            required: {
              value: !0,
              message: "Please select a reason"
            }
          },
          componentProps: {
            placeholder: "Select a reason",
            equalityFn: (R, F) => R === F,
            getItemTitleByValue: (R) => {
              if (!R)
                return "";
              const F = aw.find(
                (I) => I.value === R
              );
              return /* @__PURE__ */ v.jsxs(b, { flexDirection: "row", gap: "200", children: [
                /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: F.label }),
                /* @__PURE__ */ v.jsx($.Paragraph, { color: "secondary", children: F.description })
              ] });
            }
          },
          children: aw.map((R) => /* @__PURE__ */ v.jsx(mt.Item, { value: R.value, children: /* @__PURE__ */ v.jsxs(b, { flexDirection: "row", gap: "200", children: [
            /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: R.label }),
            /* @__PURE__ */ v.jsx($.Paragraph, { color: "secondary", children: R.description })
          ] }) }, R.value))
        }
      ) }),
      /* @__PURE__ */ v.jsx(X, { children: /* @__PURE__ */ v.jsx(He, { label: "Refund order", children: /* @__PURE__ */ v.jsx(
        yn,
        {
          control: w.control,
          name: "refundMethod.originalPaymentMethodsRefund"
        }
      ) }) }),
      /* @__PURE__ */ v.jsx(X, { children: /* @__PURE__ */ v.jsx(He, { label: "Restock items", children: /* @__PURE__ */ v.jsx(yn, { control: w.control, name: "restock" }) }) }),
      /* @__PURE__ */ v.jsx(X, { children: /* @__PURE__ */ v.jsx(He, { label: "Notify the customer", children: /* @__PURE__ */ v.jsx(yn, { control: w.control, name: "notifyCustomer" }) }) }),
      /* @__PURE__ */ v.jsx(X, { children: /* @__PURE__ */ v.jsx(
        On,
        {
          name: "staffNote",
          label: "Staff note",
          control: w.control
        }
      ) }),
      h && /* @__PURE__ */ v.jsx(X, { children: /* @__PURE__ */ v.jsx(b, { gap: "200", flexDirection: "column", children: u.map((R) => /* @__PURE__ */ v.jsxs(
        b,
        {
          flexDirection: "row",
          gap: "200",
          alignItems: "center",
          children: [
            /* @__PURE__ */ v.jsx(he, { name: "close-circle-filled", color: "red.500" }),
            /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: R.code }),
            /* @__PURE__ */ v.jsxs($.Paragraph, { children: [
              "(",
              R.field?.join(","),
              ") ",
              R.message
            ] })
          ]
        },
        R.code
      )) }) })
    ] }) }),
    /* @__PURE__ */ v.jsx(
      wt,
      {
        confirmProps: {
          disabled: !(w.formState.isValid && w.formState.isDirty),
          isLoading: a,
          loadingIndicator: /* @__PURE__ */ v.jsx(mn, { size: 16 })
        },
        confirmOnClick: w.handleSubmit(g),
        cancelOnClick: O,
        confirmName: j ? "Close" : "Cancel order",
        cancelName: j ? void 0 : "Cancel"
      }
    )
  ] });
}, P7 = ({
  orderId: e,
  orderName: n,
  refetchOrders: r,
  disabled: i
}) => {
  const [a, o] = pe(!1), [s, l] = pe(!1);
  return /* @__PURE__ */ v.jsxs(b, { width: "100%", children: [
    /* @__PURE__ */ v.jsx(
      tt,
      {
        variant: "secondary",
        onClick: () => o(!0),
        isLoading: s,
        loadingIndicator: /* @__PURE__ */ v.jsx(mn, { size: 16 }),
        disabled: i,
        slotStart: /* @__PURE__ */ v.jsx(
          he,
          {
            size: 14,
            name: "close-circle-filled",
            color: "red.500"
          }
        ),
        className: Mt.fullWidth,
        children: "Cancel"
      }
    ),
    /* @__PURE__ */ v.jsx(
      O7,
      {
        orderId: e,
        orderName: n,
        isOpen: a,
        setIsOpen: o,
        isMutationLoading: s,
        setIsMutationLoading: l,
        refetchOrders: r
      }
    )
  ] });
}, A7 = "_modal_1mprq_1", L7 = {
  modal: A7
}, V7 = ({
  order: e,
  orderName: n,
  isOpen: r,
  shopifyId: i,
  setIsOpen: a,
  refetchOrders: o
}) => {
  const { useMutation: s, showNotification: l, useQuery: c } = hn(), { track: m } = jn(), [u, f] = pe(!1), [h, k] = pe(e?.tags || []), w = "duplicate-shopify-order-form", N = (me) => ({
    firstName: me?.firstName,
    lastName: me?.lastName,
    company: me?.company,
    address1: me?.address1,
    address2: me?.address2,
    city: me?.city,
    provinceCode: me?.provinceCode,
    zip: me?.zip,
    countryCode: me?.countryCodeV2,
    phone: me?.phone
  }), j = {
    selectedProductId: void 0,
    lineItems: [],
    customNote: "",
    tags: e?.tags || [],
    billingAddress: N(
      e?.billingAddress ?? e?.shippingAddress
    ),
    shippingAddress: N(e?.shippingAddress),
    financialStatus: void 0,
    fulfillmentStatus: void 0,
    discountCode: void 0
  }, _ = ut({
    mode: "all",
    defaultValues: j
  }), g = _.watch("lineItems").length > 0, O = Xn(
    () => (e?.lineItems || []).map((me) => me.product?.id).filter((me) => !!me),
    [e]
  ), R = Xn(
    () => zF(O),
    [O]
  ), {
    data: F,
    loading: I,
    error: L
  } = c(Zg, {
    skip: !R,
    variables: {
      query: R,
      productCount: O.length,
      mediaCount: 1
    }
  });
  Qe(() => {
    L && l({
      title: "Something went wrong",
      text: "Could not load products for this order.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    });
  }, [L, l]), Qe(() => {
    if (!r || I || !F || _.getValues("lineItems")?.length)
      return;
    const me = F?.Shopify?.products?.nodes || [], le = [];
    e?.lineItems?.forEach((ge) => {
      const V = me.find(
        (be) => be.id === ge.product?.id
      );
      V && le.push({
        ...V,
        quantity: ge.quantity || 1,
        sku: ge.sku,
        discountedUnitPrice: ge.discountedUnitPriceSet?.shopMoney
      });
    }), le.length > 0 && _.setValue("lineItems", le, { shouldDirty: !0 });
  }, [r, F, I, e, _]), Qe(() => {
    (h.length > 0 || (_.getValues("tags") || []).length > 0) && _.setValue("tags", h, { shouldDirty: !0 });
  }, [h, _]);
  const W = Er(!1), J = () => {
    o(), f(!1), l({
      title: "Success",
      text: "The order was duplicated successfully.",
      icon: "check-circle-filled",
      severity: "success"
    }), m("shopify:order:duplicate:succeeded"), we();
  }, re = () => {
    o(), f(!1), l({
      title: "Order duplicated but not marked as paid",
      text: "The order was duplicated but recording the payment failed. You can mark it as paid in Shopify.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    }), we();
  }, K = () => {
    f(!1), l({
      title: "Something went wrong",
      text: "The order duplication was not successful.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    }), m("shopify:order:duplicate:failed"), we();
  }, [Y] = s(AF, {
    onError: re,
    onCompleted: (me) => {
      const le = me.Shopify?.orderMarkAsPaid?.userErrors;
      if (le && le.length > 0) {
        re();
        return;
      }
      J();
    }
  }), [P, { error: B }] = s(PF, {
    onError: K,
    onCompleted: (me) => {
      const le = me.Shopify?.orderCreate, ge = le?.order?.id;
      if (le?.userErrors?.length || !ge) {
        K();
        return;
      }
      if (W.current) {
        Y({ variables: { input: { id: ge } } });
        return;
      }
      J();
    }
  }), ie = (me) => {
    const le = me.lineItems.map((be) => ({
      productId: be.id,
      requiresShipping: !0,
      priceSet: {
        shopMoney: {
          amount: be.discountedUnitPrice?.amount ?? be.priceRangeV2.maxVariantPrice.amount,
          currencyCode: be.discountedUnitPrice?.currencyCode ?? be.priceRangeV2.maxVariantPrice.currencyCode
        }
      },
      quantity: be.quantity,
      sku: be.sku
    })), ge = (e?.shippingLines ?? []).map(
      (be) => ({
        title: be.title,
        code: be.code,
        source: be.source,
        priceSet: {
          shopMoney: {
            amount: be.discountedPriceSet?.shopMoney?.amount ?? "0.00",
            currencyCode: be.discountedPriceSet?.shopMoney?.currencyCode ?? "USD"
          }
        }
      })
    );
    f(!0);
    const V = me.financialStatus === Mi.Paid;
    W.current = V, P({
      variables: {
        order: {
          customer: {
            toAssociate: {
              id: i
            }
          },
          lineItems: le,
          shippingLines: ge,
          note: me.customNote,
          tags: me.tags,
          financialStatus: V ? void 0 : me.financialStatus,
          fulfillmentStatus: me.fulfillmentStatus,
          discountCode: qF(me.discountCode),
          shippingAddress: pa(me?.shippingAddress),
          billingAddress: pa(me?.billingAddress)
        }
      }
    });
  }, we = () => {
    _.reset(j), k(e?.tags || []), a(!1);
  };
  return /* @__PURE__ */ v.jsxs(
    bt,
    {
      isOpen: r,
      onClose: we,
      className: L7.modal,
      allowEscClose: !1,
      children: [
        /* @__PURE__ */ v.jsx(_t, { title: `Duplicate order ${n}`, onClose: we }),
        /* @__PURE__ */ v.jsxs(xt, { children: [
          /* @__PURE__ */ v.jsx(Gy, { ..._, children: /* @__PURE__ */ v.jsx("form", { id: w, children: /* @__PURE__ */ v.jsxs(et, { children: [
            /* @__PURE__ */ v.jsx(X, { children: /* @__PURE__ */ v.jsx(tv, { loading: I }) }),
            /* @__PURE__ */ v.jsx(X, { children: /* @__PURE__ */ v.jsx(
              Nt,
              {
                name: "tags",
                render: ({ fieldState: { error: me } }) => /* @__PURE__ */ v.jsx(
                  He,
                  {
                    label: "Tags",
                    meta: {
                      error: me?.message
                    },
                    children: /* @__PURE__ */ v.jsx(
                      "div",
                      {
                        tabIndex: 0,
                        onKeyDown: (le) => {
                          le.key === "Enter" && (le.preventDefault(), le.stopPropagation());
                        },
                        children: /* @__PURE__ */ v.jsx(
                          Hl,
                          {
                            placeholder: "Type and hit enter to add tags",
                            selectedTags: h,
                            onChange: (le) => {
                              k(le);
                            }
                          },
                          `tags-input-${r}`
                        )
                      }
                    )
                  }
                )
              }
            ) }),
            /* @__PURE__ */ v.jsx(X, { children: /* @__PURE__ */ v.jsx(HF, { enabled: r }) }),
            /* @__PURE__ */ v.jsx(X, { span: 4, children: /* @__PURE__ */ v.jsxs(b, { flexDirection: "column", gap: "300", children: [
              /* @__PURE__ */ v.jsx(
                KF,
                {
                  previousOrderStatus: e?.displayFinancialStatus
                }
              ),
              /* @__PURE__ */ v.jsx(GF, {}),
              /* @__PURE__ */ v.jsx(
                On,
                {
                  label: "Custom note",
                  name: "customNote",
                  componentProps: {
                    placeholder: "Enter custom note",
                    tabIndex: 0
                  }
                }
              )
            ] }) }),
            /* @__PURE__ */ v.jsx(X, { span: 2, children: /* @__PURE__ */ v.jsx(He, { label: "Details", noAlert: !0, children: /* @__PURE__ */ v.jsx(
              b,
              {
                flexDirection: "column",
                gap: "200",
                justifyContent: "end",
                className: Mt.boxWrapper,
                children: /* @__PURE__ */ v.jsx(WF, {})
              }
            ) }) })
          ] }) }) }),
          B && /* @__PURE__ */ v.jsx($n, { error: B })
        ] }),
        /* @__PURE__ */ v.jsx(
          wt,
          {
            confirmProps: {
              type: "submit",
              form: w,
              disabled: !g || u || I,
              isLoading: u || I,
              loadingIndicator: /* @__PURE__ */ v.jsx(mn, { size: 16 }),
              tabIndex: 0
            },
            confirmName: "Create order",
            confirmOnClick: _.handleSubmit(ie)
          }
        )
      ]
    }
  );
}, z7 = "_copyIcon_1dlzg_1", U7 = {
  copyIcon: z7
}, M7 = ({
  orderId: e,
  lineItems: n,
  refundedQuantities: r = {}
}) => {
  const { isCopied: i, copy: a } = Hr();
  if (!n || n?.length === 0)
    return null;
  const o = Object.values(r).some(
    (c) => c > 0
  ), s = n.every(
    ({ id: c, quantity: m }) => (r[c] || 0) >= m
  ), l = n.map(
    ({ title: c, quantity: m, variantTitle: u }) => u ? `${m}x ${c} (${u})` : `${m}x ${c}`
  ).join(`
`);
  return /* @__PURE__ */ v.jsxs(b, { gap: "100", flexDirection: "column", children: [
    /* @__PURE__ */ v.jsxs(
      b,
      {
        gap: "250",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        children: [
          /* @__PURE__ */ v.jsxs(b, { gap: "250", flexDirection: "row", alignItems: "center", children: [
            /* @__PURE__ */ v.jsx(he, { size: 14, name: "shopify", color: "green.500" }),
            /* @__PURE__ */ v.jsx($.Paragraph, { variant: "3", children: "Line items" })
          ] }),
          /* @__PURE__ */ v.jsx(Xe, { content: "Copy line items", children: /* @__PURE__ */ v.jsx(
            he,
            {
              size: 14,
              name: i ? "done" : "copy",
              onClick: () => a(l),
              className: U7.copyIcon
            }
          ) })
        ]
      }
    ),
    o && /* @__PURE__ */ v.jsx(
      b,
      {
        gap: "100",
        flexDirection: "row",
        margin: "200 0 0",
        justifyContent: "center",
        children: /* @__PURE__ */ v.jsx(Jn, { color: "red.500", children: s ? "The order has been refunded" : "Order has refunded items" })
      }
    ),
    /* @__PURE__ */ v.jsx(Ye, { children: n.map(({ id: c, title: m, quantity: u, variantTitle: f, image: h }) => {
      const k = r[c], w = k > 0, N = k > 1 ? `Refunded (${k} items)` : "Refunded";
      return /* @__PURE__ */ v.jsx(
        Ye.Item,
        {
          contentLeft: /* @__PURE__ */ v.jsxs(b, { gap: "200", children: [
            /* @__PURE__ */ v.jsx($.Paragraph, { children: u }),
            /* @__PURE__ */ v.jsx($.Paragraph, { children: "×" })
          ] }),
          title: /* @__PURE__ */ v.jsxs($.Paragraph, { variant: "4", children: [
            m,
            " ",
            f && `(${f})`,
            w && /* @__PURE__ */ v.jsx($.Paragraph, { variant: "3", color: "red.500", children: N })
          ] }),
          contentRight: h?.url && /* @__PURE__ */ v.jsx(Fa, { src: `${h?.url}&height=48`, alt: m })
        },
        `list-${e}-${c}`
      );
    }) })
  ] });
}, B7 = Kl`
  mutation refundLineItems($input: Shopify_RefundInput!) {
    Shopify {
      refundCreate(input: $input) {
        refund {
          id
          totalRefundedSet {
            presentmentMoney {
              amount
              currencyCode
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`, q7 = (e) => {
  const n = [];
  return e.refunds.forEach((r) => {
    const i = r.refundLineItems.edges.filter(
      (a) => a.node.id !== null
    );
    i.length > 0 && n.push({
      ...r,
      refundLineItems: {
        ...r.refundLineItems,
        edges: i
      }
    });
  }), n;
}, YF = (e) => {
  const n = {}, r = q7(e);
  return e.lineItems?.forEach((i) => {
    n[i.id] = 0;
  }), r.forEach((i) => {
    i.refundLineItems.edges.forEach((a) => {
      const o = a.node;
      if (o.id !== null) {
        const s = o.lineItem.id;
        n[s] += o.quantity;
      }
    });
  }), n;
}, Ms = (e, n) => `${Number(e || 0).toFixed(2)} ${n}`, JF = ({
  refund: e,
  currencyCode: n,
  refundShipping: r,
  onToggleShipping: i,
  isLoading: a = !1
}) => {
  const o = e?.currency || n, s = Number(e?.shipping.maximumRefundable || 0) > 0, l = s && r;
  return /* @__PURE__ */ v.jsxs(b, { flexDirection: "column", gap: "300", children: [
    /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: "Subtotal" }),
      /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: Ms(e?.subtotal || "0", o) })
    ] }),
    /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: "Tax" }),
      /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: Ms(e?.tax || "0", o) })
    ] }),
    /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
      /* @__PURE__ */ v.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ v.jsx(
          Vo,
          {
            name: "refundShipping",
            value: "shipping",
            checked: l,
            disabled: !s || a,
            onChange: () => i(!r)
          }
        ),
        /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", subdued: !l, children: "Refund shipping" })
      ] }),
      /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", subdued: !l, children: Ms(e?.shipping.amount || "0", o) })
    ] }),
    /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ v.jsx($.Paragraph, { variant: "3", children: "Total refund" }),
      /* @__PURE__ */ v.jsx($.Paragraph, { variant: "3", children: Ms(e?.amount || "0", o) })
    ] })
  ] });
}, H7 = "_modal_1mprq_1", W7 = {
  modal: H7
}, ow = "partial-refund-shopify-order-form", K7 = ({
  order: e,
  orderName: n,
  isOpen: r,
  setIsOpen: i,
  refetchOrders: a
}) => {
  const { useMutation: o, showNotification: s } = hn(), { track: l } = jn(), { useQuery: c } = hn(), [m, u] = pe(!1), [f, h] = pe([]), [k, w] = pe(!1), N = Xn(
    () => e?.refunds ? YF(e) : {},
    [e]
  ), j = Xn(
    () => (e?.lineItems || []).filter((le) => (N[le.id] || 0) >= (le.quantity || 0)).map((le) => le.product?.id).filter((le) => !!le),
    [e, N]
  ), _ = Xn(() => {
    const le = {};
    return (e?.lineItems || []).forEach((ge) => {
      if (ge.product?.id) {
        const V = N[ge.id] || 0, be = Math.max(
          0,
          (ge.quantity || 0) - V
        );
        le[ge.product.id] = be;
      }
    }), le;
  }, [e, N]), g = Xn(
    () => (e?.lineItems || []).map((le) => le.product?.id).filter((le) => !!le),
    [e]
  ), O = Xn(
    () => zF(g),
    [g]
  ), {
    data: R,
    loading: F,
    error: I
  } = c(Zg, {
    skip: !O,
    variables: {
      query: O,
      productCount: g.length,
      mediaCount: 1
    }
  });
  Qe(() => {
    I && s({
      title: "Something went wrong",
      text: "Could not load products for this order.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    });
  }, [I, s]);
  const L = {
    selectedProductId: void 0,
    lineItems: [],
    customNote: ""
  }, W = ut({
    mode: "all",
    defaultValues: L
  }), J = f.length > 0;
  Qe(() => {
    !J && k && w(!1);
  }, [J, k]);
  const re = gi({
    control: W.control,
    name: "lineItems"
  }), K = Xn(
    () => (re || []).filter(
      (le) => f.includes(le.id)
    ).map((le) => {
      const ge = e?.lineItems?.find(
        (q) => q.product?.id === le.id
      ), V = N[ge?.id || ""] || 0, be = (ge?.quantity || 0) - V, Oe = Math.max(
        0,
        Math.min(be, le.quantity || 0)
      );
      return ge && Oe > 0 ? { lineItemId: ge.id, quantity: Oe } : void 0;
    }).filter(
      (le) => !!le
    ),
    [re, f, e, N]
  ), { suggestedRefund: Y, isLoading: P } = UF({
    orderId: e.id,
    refundShipping: k,
    refundLineItems: K,
    skip: !J
  }), [B, { error: ie }] = o(
    B7,
    {
      onError: () => {
        s({
          title: "Something went wrong",
          text: "The partial refund was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), l("shopify:order:partial:refund:failed"), me();
      },
      onCompleted: () => {
        a(), s({
          title: "Success",
          text: "The partial refund was created successfully.",
          icon: "check-circle-filled",
          severity: "success"
        }), l("shopify:order:partial:refund:succeeded"), me();
      }
    }
  );
  Qe(() => {
    if (!r || F || !R || W.getValues("lineItems")?.length)
      return;
    const le = R?.Shopify?.products?.nodes || [], ge = [];
    e?.lineItems?.forEach((V) => {
      const be = le.find(
        (Oe) => Oe.id === V.product?.id
      );
      if (be) {
        const Oe = N[V.id] || 0, q = (V.quantity || 1) - Oe;
        ge.push({
          ...be,
          quantity: q > 0 ? q : V.quantity || 1
        });
      }
    }), ge.length > 0 && (W.setValue("lineItems", ge, { shouldDirty: !0 }), h([]));
  }, [
    r,
    R,
    F,
    e,
    W,
    N
  ]);
  const we = (le) => {
    u(!0), B({
      variables: {
        input: VF({
          orderId: e.id,
          transactions: Y?.transactions,
          refundLineItems: K,
          refundShipping: k,
          note: le.customNote || void 0,
          notify: !0
        })
      }
    });
  }, me = () => {
    W.reset(L), u(!1), i(!1);
  };
  return /* @__PURE__ */ v.jsxs(bt, { isOpen: r, onClose: me, className: W7.modal, children: [
    /* @__PURE__ */ v.jsx(_t, { title: `Refund order ${n}`, onClose: me }),
    /* @__PURE__ */ v.jsxs(xt, { children: [
      /* @__PURE__ */ v.jsx(Gy, { ...W, children: /* @__PURE__ */ v.jsx("form", { id: ow, children: /* @__PURE__ */ v.jsxs(et, { children: [
        /* @__PURE__ */ v.jsx(X, { children: /* @__PURE__ */ v.jsx(
          tv,
          {
            loading: F,
            selectionMode: !0,
            hideDeleteButton: !0,
            hideProductSelect: !0,
            selectedProductIds: f,
            disabledProductIds: j,
            maxQuantities: _,
            onToggleSelect: (le, ge) => {
              h((V) => ge ? Array.from(/* @__PURE__ */ new Set([...V, le])) : V.filter((be) => be !== le));
            },
            onToggleSelectAll: (le) => {
              const ge = (W.getValues("lineItems") || []).map((V) => V.id).filter((V) => !j.includes(V));
              h(le ? ge : []);
            }
          }
        ) }),
        /* @__PURE__ */ v.jsx(X, { span: 4, children: /* @__PURE__ */ v.jsx(b, { flexDirection: "column", gap: "300", children: /* @__PURE__ */ v.jsx(
          On,
          {
            label: "Custom note",
            name: "customNote",
            componentProps: {
              placeholder: "Enter custom note (optional)",
              tabIndex: 0
            }
          }
        ) }) }),
        /* @__PURE__ */ v.jsx(X, { span: 2, children: /* @__PURE__ */ v.jsx(He, { label: "Details", noAlert: !0, children: /* @__PURE__ */ v.jsx(
          b,
          {
            flexDirection: "column",
            gap: "200",
            justifyContent: "end",
            className: Mt.boxWrapper,
            children: /* @__PURE__ */ v.jsx(
              JF,
              {
                refund: Y,
                currencyCode: e.currencyCode,
                refundShipping: k,
                onToggleShipping: w,
                isLoading: P
              }
            )
          }
        ) }) })
      ] }) }) }),
      ie && /* @__PURE__ */ v.jsx($n, { error: ie })
    ] }),
    /* @__PURE__ */ v.jsx(
      wt,
      {
        confirmProps: {
          type: "submit",
          form: ow,
          disabled: !J || m || F || P || !Y,
          isLoading: m || F,
          loadingIndicator: /* @__PURE__ */ v.jsx(mn, { size: 16 }),
          tabIndex: 0
        },
        confirmName: "Refund selected",
        confirmOnClick: W.handleSubmit(we)
      }
    )
  ] });
}, G7 = "_modal_al73g_1", Y7 = {
  modal: G7
}, J7 = ({
  order: e,
  shopifyId: n,
  orderLink: r,
  isOpen: i,
  setIsOpen: a,
  refetchOrders: o
}) => {
  const { useMutation: s, showNotification: l } = hn(), { track: c } = jn(), { id: m, name: u, currencyCode: f } = e, [h, k] = pe(!0), [w, N] = pe(), { suggestedRefund: j, isLoading: _ } = UF({
    orderId: m,
    suggestFullRefund: !0,
    refundShipping: h,
    skip: !i
  }), [g, { loading: O }] = s(
    F9,
    {
      onError: (I) => N(I),
      onCompleted: (I) => {
        const L = I.Shopify?.refundCreate?.userErrors;
        if (L && L.length > 0) {
          N(
            new Ew({
              graphQLErrors: L.map((W) => ({
                message: W.message
              }))
            })
          );
          return;
        }
        l({
          title: "Order refunded",
          text: `You refunded order ${u}`,
          icon: "check-circle-filled",
          severity: "success"
        }), o(), R();
      }
    }
  ), R = () => {
    k(!0), N(void 0), a(!1);
  }, F = () => {
    j && (c("shopify:order:refund:confirmed", { shopifyId: n, orderId: m }), g({
      variables: {
        input: VF({
          orderId: m,
          transactions: j.transactions,
          refundLineItems: j.refundLineItems,
          refundShipping: h,
          notify: e.suggestedRefund.notify
        })
      }
    }));
  };
  return /* @__PURE__ */ v.jsxs(bt, { isOpen: i, onClose: R, className: Y7.modal, children: [
    /* @__PURE__ */ v.jsx(_t, { title: `Refund order ${u}`, onClose: R }),
    /* @__PURE__ */ v.jsx(xt, { children: /* @__PURE__ */ v.jsxs(b, { flexDirection: "column", gap: "300", children: [
      /* @__PURE__ */ v.jsx(
        JF,
        {
          refund: j,
          currencyCode: f,
          refundShipping: h,
          onToggleShipping: k,
          isLoading: _
        }
      ),
      w && /* @__PURE__ */ v.jsxs(b, { flexDirection: "column", children: [
        /* @__PURE__ */ v.jsx($n, { error: w }),
        /* @__PURE__ */ v.jsx(
          It,
          {
            variant: "secondary",
            style: {
              color: "var(--dixa-typography-color-link)",
              padding: "var(--dixa-size-spacer-100)"
            },
            navigate: () => window.open(r, "_blank")?.focus(),
            slotStart: /* @__PURE__ */ v.jsx(he, { name: "external-link" }),
            children: "View order in Shopify"
          }
        )
      ] })
    ] }) }),
    /* @__PURE__ */ v.jsx(
      wt,
      {
        confirmProps: {
          disabled: !j || _ || O,
          isLoading: O || _,
          loadingIndicator: /* @__PURE__ */ v.jsx(mn, { size: 16 }),
          tabIndex: 0
        },
        confirmName: "Confirm order refund",
        confirmOnClick: F
      }
    )
  ] });
}, Q7 = ({
  order: e,
  shopifyId: n,
  orderLink: r,
  refetchOrders: i
}) => {
  const { showModal: a } = hn(), { track: o } = jn(), { suggestedRefund: s, id: l } = e, [c, m] = pe(!1), u = parseFloat(String(s?.amount)), f = !isNaN(u) && u > 0, h = ft(() => {
    o("shopify:order:refund:requested", { shopifyId: n, orderId: l }), f ? m(!0) : a({
      headline: `Refund Order ${e.name}`,
      children: /* @__PURE__ */ v.jsx($.Paragraph, { children: "No refund can be issued because no payment has been captured for this order. The order's financial status is currently pending." }),
      confirmLabel: "Close",
      confirmVariant: "secondary",
      onConfirm: () => {
      }
    });
  }, [n, l, e.name, f, a, o]);
  return /* @__PURE__ */ v.jsxs(b, { width: "100%", children: [
    /* @__PURE__ */ v.jsx(
      tt,
      {
        variant: "secondary",
        onClick: h,
        disabled: s?.refundLineItems?.length === 0 || !f,
        slotStart: /* @__PURE__ */ v.jsx(he, { size: 14, name: "undo" }),
        className: Mt.fullWidth,
        children: "Full refund"
      }
    ),
    /* @__PURE__ */ v.jsx(
      J7,
      {
        order: e,
        shopifyId: n,
        orderLink: r,
        isOpen: c,
        setIsOpen: m,
        refetchOrders: i
      }
    )
  ] });
}, X7 = "_modal_al73g_1", Z7 = {
  modal: X7
}, eK = ({
  orderId: e,
  tags: n,
  isOpen: r,
  setIsOpen: i,
  refetchOrders: a
}) => {
  const { track: o } = jn(), { useMutation: s, showNotification: l } = hn(), [c, m] = pe(n), [u, f] = pe(!1), h = ut({
    defaultValues: {
      tags: n
    }
  });
  Qe(() => {
    c && h.setValue("tags", c, { shouldDirty: !0 });
  }, [c]);
  const [k, { error: w, reset: N }] = s($9, {
    onError: () => {
      f(!1), l({
        title: "Something went wrong",
        text: "The tags change was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), i(!1);
    },
    onCompleted: async () => {
      await a(), f(!1), l({
        title: "Success",
        text: "The tags change was successful.",
        icon: "check-circle-filled",
        severity: "success"
      }), o("shopify:order:tags:updated"), i(!1);
    }
  }), j = ft(
    (g) => {
      f(!0), k({
        variables: {
          input: {
            id: e,
            tags: g.tags
          }
        }
      }).then((O) => {
        const R = O.data?.Shopify?.orderUpdate?.order?.tags ?? g.tags;
        h.reset({ tags: R });
      });
    },
    [e, h, k]
  ), _ = () => {
    i(!1), N();
  };
  return /* @__PURE__ */ v.jsxs(bt, { isOpen: r, onClose: _, className: Z7.modal, children: [
    /* @__PURE__ */ v.jsx(_t, { title: "Manage tags for order", onClose: _ }),
    /* @__PURE__ */ v.jsxs(xt, { children: [
      /* @__PURE__ */ v.jsx(et, { children: /* @__PURE__ */ v.jsx(X, { children: /* @__PURE__ */ v.jsx(
        Nt,
        {
          control: h.control,
          name: "tags",
          render: ({ fieldState: { error: g } }) => /* @__PURE__ */ v.jsx(
            He,
            {
              label: "Tags",
              meta: {
                error: g?.message
              },
              children: /* @__PURE__ */ v.jsx(
                Hl,
                {
                  placeholder: "Add tags here",
                  selectedTags: n,
                  onChange: (O) => m(O)
                }
              )
            }
          )
        }
      ) }) }),
      w && /* @__PURE__ */ v.jsx($n, { error: w })
    ] }),
    /* @__PURE__ */ v.jsx(
      wt,
      {
        confirmProps: {
          disabled: !(h.formState.isValid && h.formState.isDirty),
          isLoading: u,
          loadingIndicator: /* @__PURE__ */ v.jsx(mn, { size: 16 })
        },
        confirmOnClick: h.handleSubmit(j),
        cancelOnClick: _,
        confirmName: w ? "Close" : "Save",
        cancelName: w ? void 0 : "Cancel"
      }
    )
  ] });
}, nK = "_editIcon_1yp2k_1", tK = "_copyIcon_1yp2k_2", sw = {
  editIcon: nK,
  copyIcon: tK
}, rK = ({
  orderId: e,
  tags: n,
  refetchOrders: r
}) => {
  const [i, a] = pe(!1), { isCopied: o, copy: s } = Hr(), l = 14, c = n.length > 0;
  return /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
    /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ v.jsxs(b, { gap: "250", flexDirection: "row", children: [
        /* @__PURE__ */ v.jsx(he, { size: l, name: "tag", color: "green.500" }),
        /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "column", children: [
          /* @__PURE__ */ v.jsx($.Paragraph, { variant: "3", children: "Tags" }),
          /* @__PURE__ */ v.jsxs(b, { gap: "100", flexDirection: "row", flexWrap: "wrap", children: [
            !c && /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", color: "tertiary", children: "No tags here yet" }),
            c && n.map((m, u) => /* @__PURE__ */ v.jsx(Pn, { size: "small", variant: "primary", children: m }, u))
          ] })
        ] })
      ] }),
      /* @__PURE__ */ v.jsxs(b, { gap: "250", flexDirection: "row", children: [
        /* @__PURE__ */ v.jsx(Xe, { content: "Edit tags", children: /* @__PURE__ */ v.jsx(
          he,
          {
            size: l,
            name: "pen",
            className: sw.editIcon,
            onClick: () => a(!0)
          }
        ) }),
        c && /* @__PURE__ */ v.jsx(Xe, { content: "Copy tags", children: /* @__PURE__ */ v.jsx(
          he,
          {
            size: l,
            name: o ? "done" : "copy",
            className: sw.copyIcon,
            onClick: () => s(n.join(", "))
          }
        ) })
      ] })
    ] }),
    /* @__PURE__ */ v.jsx(
      eK,
      {
        orderId: e,
        tags: n,
        isOpen: i,
        setIsOpen: a,
        refetchOrders: r
      }
    )
  ] });
}, iK = "_icon_cddi1_1", aK = "_link_cddi1_6", lw = {
  icon: iK,
  link: aK
}, oK = ({ trackingInfo: e }) => {
  const { isCopied: n, copy: r } = Hr(), { company: i, number: a, url: o } = e;
  return /* @__PURE__ */ v.jsx(
    Ye.Item,
    {
      contentLeft: /* @__PURE__ */ v.jsx($.Paragraph, { variant: "3", children: a }),
      title: /* @__PURE__ */ v.jsx(
        $.ExternalLink,
        {
          href: o,
          target: "_blank",
          rel: "noreferrer",
          className: lw.link,
          children: i
        }
      ),
      contentRight: a && /* @__PURE__ */ v.jsx(Xe, { content: "Copy tracking code", children: /* @__PURE__ */ v.jsx(
        he,
        {
          size: 14,
          name: n ? "done" : "copy",
          onClick: () => r(a.toString()),
          className: lw.icon
        }
      ) })
    }
  );
}, sK = ({
  trackingInfos: e
}) => !e || e?.length === 0 ? null : /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ v.jsxs(b, { gap: "250", flexDirection: "row", children: [
    /* @__PURE__ */ v.jsx(he, { size: 14, name: "eye", color: "green.500" }),
    /* @__PURE__ */ v.jsx($.Paragraph, { variant: "3", children: "Tracking" })
  ] }),
  /* @__PURE__ */ v.jsx(Ye, { children: e.map((n) => /* @__PURE__ */ v.jsx(oK, { trackingInfo: n }, n.number)) })
] }), lK = "_copyIcon_u5m0p_1", dK = "_strikethrough_u5m0p_6", cK = "_order_u5m0p_10", uK = "_orderIsOpen_u5m0p_18", mK = "_orderHeader_u5m0p_21", Ti = {
  copyIcon: lK,
  strikethrough: dK,
  order: cK,
  orderIsOpen: uK,
  orderHeader: mK
}, pK = ({
  order: e,
  shopifyId: n,
  openByDefault: r,
  customerCountryCodes: i,
  enableEditShippingAddress: a,
  displayRefund: o,
  displayCancel: s,
  shopifyDomain: l,
  displayDuplicateOrder: c,
  displayPartialRefundOrder: m,
  refetchOrders: u
}) => {
  const { track: f } = jn(), { isCopied: h, copy: k } = Hr(), { isCopied: w, copy: N } = Hr(), { isCopied: j, copy: _ } = Hr(), [g, O] = pe(!1), [R, F] = pe(!1), [I, L] = pe(r), {
    id: W,
    name: J,
    createdAt: re,
    status: K,
    currentTotalPriceSet: Y,
    currencyCode: P,
    lineItems: B,
    billingAddress: ie,
    shippingAddress: we,
    trackingInfos: me,
    tags: le,
    discountCodes: ge,
    currentTotalDiscountsSet: V
  } = e, be = !!we, Oe = ev(W), q = `https://${l}/admin/orders/${Oe ?? ""}`, Ge = Y?.shopMoney?.amount ?? 0, sn = K.includes("cancelled"), Ie = (en) => new Intl.NumberFormat(void 0, {
    style: "currency",
    currency: P
  }).format(en), Ue = Number(
    V?.shopMoney?.amount ?? 0
  ), De = Ue > 0, Be = ge?.join(", ") ?? "", Ae = Ie(Number(Ge)), Je = Ie(
    Number(Ge) + Ue
  ), Ee = e?.refunds ? YF(e) : {}, Me = !!B?.length && B.every((en) => (Ee[en.id] || 0) >= (en.quantity || 0));
  return /* @__PURE__ */ v.jsxs(
    b,
    {
      className: ct(Ti.order, {
        [Ti.orderIsOpen]: I
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ v.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Ti.orderHeader,
            onClick: () => L(!I),
            children: [
              /* @__PURE__ */ v.jsxs(b, { gap: "100", flexDirection: "column", children: [
                re && /* @__PURE__ */ v.jsx(b, { alignItems: "center", children: /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: Gn(re).format(xy) }) }),
                /* @__PURE__ */ v.jsxs($.Paragraph, { variant: "1", children: [
                  "Order ",
                  J
                ] })
              ] }),
              /* @__PURE__ */ v.jsx(
                Qt,
                {
                  variant: "tertiary",
                  icon: I ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        I && /* @__PURE__ */ v.jsxs(b, { gap: "250", flexDirection: "column", margin: "200 0 0", children: [
          /* @__PURE__ */ v.jsxs(
            b,
            {
              gap: "250",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "flex-start",
              children: [
                /* @__PURE__ */ v.jsxs(b, { gap: "250", flexDirection: "row", alignItems: "flex-start", children: [
                  /* @__PURE__ */ v.jsx(he, { size: 14, name: "info", color: "green.500" }),
                  /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "column", children: [
                    /* @__PURE__ */ v.jsx($.Paragraph, { variant: "3", children: "Order number" }),
                    /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: J.replace("#", "") })
                  ] })
                ] }),
                /* @__PURE__ */ v.jsx(Xe, { content: "Copy order number", children: /* @__PURE__ */ v.jsx(
                  he,
                  {
                    size: 14,
                    name: h ? "done" : "copy",
                    onClick: () => k(J.replace("#", "")),
                    className: Ti.copyIcon
                  }
                ) })
              ]
            }
          ),
          /* @__PURE__ */ v.jsxs(
            b,
            {
              gap: "250",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "flex-start",
              children: [
                /* @__PURE__ */ v.jsxs(b, { gap: "250", flexDirection: "row", alignItems: "flex-start", children: [
                  /* @__PURE__ */ v.jsx(he, { size: 14, name: "activity", color: "green.500" }),
                  /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "column", children: [
                    /* @__PURE__ */ v.jsx($.Paragraph, { variant: "3", children: "Order status" }),
                    /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: K })
                  ] })
                ] }),
                /* @__PURE__ */ v.jsx(Xe, { content: "Copy order status", children: /* @__PURE__ */ v.jsx(
                  he,
                  {
                    size: 14,
                    name: j ? "done" : "copy",
                    onClick: () => _(K),
                    className: Ti.copyIcon
                  }
                ) })
              ]
            }
          ),
          /* @__PURE__ */ v.jsxs(
            b,
            {
              gap: "250",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "flex-start",
              children: [
                /* @__PURE__ */ v.jsxs(b, { gap: "250", flexDirection: "row", alignItems: "flex-start", children: [
                  /* @__PURE__ */ v.jsx(he, { size: 14, name: "chart-bar", color: "green.500" }),
                  /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "column", children: [
                    /* @__PURE__ */ v.jsx($.Paragraph, { variant: "3", children: "Order value" }),
                    De && /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", className: Ti.strikethrough, children: Je }),
                    /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
                      /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: Ae }),
                      Be && /* @__PURE__ */ v.jsxs($.Paragraph, { variant: "4", color: "tertiary", children: [
                        "(",
                        Be,
                        ")"
                      ] })
                    ] })
                  ] })
                ] }),
                /* @__PURE__ */ v.jsx(Xe, { content: "Copy order value", children: /* @__PURE__ */ v.jsx(
                  he,
                  {
                    size: 14,
                    name: w ? "done" : "copy",
                    onClick: () => N(Ge),
                    className: Ti.copyIcon
                  }
                ) })
              ]
            }
          ),
          /* @__PURE__ */ v.jsx(
            rK,
            {
              orderId: W,
              tags: le,
              refetchOrders: u
            }
          ),
          /* @__PURE__ */ v.jsx(
            Ny,
            {
              openByDefault: !be,
              labelText: "Billing address",
              address: ie,
              shippingCountryCodes: i,
              refetchOrders: u
            }
          ),
          /* @__PURE__ */ v.jsx(
            Ny,
            {
              openByDefault: be,
              shopifyId: n,
              orderId: W,
              icon: "map-pin",
              labelText: "Shipping address",
              address: we,
              shippingCountryCodes: i,
              enableEditAddress: a,
              refetchOrders: u
            }
          ),
          /* @__PURE__ */ v.jsx(
            M7,
            {
              orderId: W,
              lineItems: B,
              refundedQuantities: Ee
            }
          ),
          /* @__PURE__ */ v.jsx(sK, { trackingInfos: me }),
          (o || m) && /* @__PURE__ */ v.jsxs(b, { flexDirection: "row", gap: "200", children: [
            o && /* @__PURE__ */ v.jsx(
              Q7,
              {
                order: e,
                shopifyId: n,
                refetchOrders: u,
                orderLink: q
              }
            ),
            m && /* @__PURE__ */ v.jsx(b, { width: "100%", children: /* @__PURE__ */ v.jsx(
              tt,
              {
                variant: "secondary",
                icon: "undo",
                onClick: () => F(!0),
                className: Mt.fullWidth,
                disabled: sn || Me,
                children: "Partial refund"
              }
            ) })
          ] }),
          (c || s) && /* @__PURE__ */ v.jsxs(b, { flexDirection: "row", gap: "200", children: [
            c && /* @__PURE__ */ v.jsx(b, { width: "100%", children: /* @__PURE__ */ v.jsx(
              tt,
              {
                variant: "secondary",
                icon: "plus",
                onClick: () => O(!0),
                className: Mt.fullWidth,
                children: "Duplicate"
              }
            ) }),
            s && /* @__PURE__ */ v.jsx(
              P7,
              {
                orderId: W,
                orderName: J,
                disabled: sn,
                refetchOrders: u
              }
            )
          ] }),
          /* @__PURE__ */ v.jsx(
            It,
            {
              variant: "secondary",
              style: {
                color: "var(--dixa-typography-color-link)",
                padding: "var(--dixa-size-spacer-100)"
              },
              navigate: () => window.open(q, "_blank")?.focus(),
              slotStart: /* @__PURE__ */ v.jsx(he, { name: "external-link" }),
              onClick: () => f("shopify:view:order:clicked", {
                shopifyId: n,
                orderId: W
              }),
              children: "View order in Shopify"
            }
          )
        ] }),
        g && /* @__PURE__ */ v.jsx(
          V7,
          {
            order: e,
            shopifyId: n,
            orderName: J,
            isOpen: g,
            setIsOpen: O,
            refetchOrders: u
          }
        ),
        R && /* @__PURE__ */ v.jsx(
          K7,
          {
            order: e,
            orderName: J,
            isOpen: R,
            setIsOpen: F,
            refetchOrders: () => {
              u();
            }
          }
        )
      ]
    }
  );
}, fK = ({
  customerCountryCodes: e,
  shopifyDomain: n,
  displayRefund: r,
  displayCancel: i,
  displayCreateOrder: a,
  displayCreateDraftOrder: o,
  displayDuplicateOrder: s,
  displayPartialRefundOrder: l,
  enableEditShippingAddress: c,
  shopifyCustomer: m
}) => {
  const { track: u } = jn(), [f, h] = pe([]), [k, w] = pe(!1), N = ev(m?.id), j = `https://${n}/admin/orders?customer_id=${N ?? ""}`, {
    getCustomerOrders: _,
    isCustomerOrdersLoading: g,
    customerOrdersError: O,
    customerOrders: R,
    refetchCustomerOrders: F
  } = O9();
  return Qe(() => {
    !g && N && _({
      variables: {
        query: `customer_id:${N}`
      }
    });
  }, [N]), Qe(() => {
    const I = R?.Shopify?.orders?.edges;
    I && h(P9({ ordersData: I }));
  }, [R]), m ? O ? /* @__PURE__ */ v.jsx($n, { error: O }) : /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: "Customer orders" }),
      !g && /* @__PURE__ */ v.jsx(Pn, { variant: "success", size: "small", children: f.length })
    ] }),
    a && /* @__PURE__ */ v.jsx(
      tt,
      {
        variant: "secondary",
        icon: "plus",
        onClick: () => w(!0),
        children: "Create new order"
      }
    ),
    /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "column", children: [
      g && /* @__PURE__ */ v.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ v.jsx(mn, {}) }),
      !g && f.length === 0 && /* @__PURE__ */ v.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ v.jsx($.Paragraph, { color: "tertiary", children: "No orders found" }) }),
      !g && f.length > 0 && /* @__PURE__ */ v.jsx(b, { gap: "200", flexDirection: "column", children: f.map((I, L) => /* @__PURE__ */ v.jsx(
        pK,
        {
          order: I,
          openByDefault: L === 0,
          shopifyId: m?.id,
          displayRefund: r,
          displayCancel: i,
          enableEditShippingAddress: c,
          customerCountryCodes: e,
          refetchOrders: F,
          shopifyDomain: n,
          displayDuplicateOrder: s,
          displayPartialRefundOrder: l
        },
        `${L}-${I.id}`
      )) }),
      /* @__PURE__ */ v.jsx(
        It,
        {
          variant: "secondary",
          style: {
            color: "var(--dixa-typography-color-link)",
            padding: "var(--dixa-size-spacer-100)"
          },
          navigate: () => window.open(j, "_blank")?.focus(),
          slotStart: /* @__PURE__ */ v.jsx(he, { name: "external-link" }),
          onClick: () => u("shopify:view:all:orders:clicked", {
            shopifyId: m?.id
          }),
          children: "View all orders in Shopify"
        }
      )
    ] }),
    a && /* @__PURE__ */ v.jsx(
      T7,
      {
        isOpen: k,
        setIsOpen: w,
        shopifyCustomer: m,
        refetchCustomerOrders: F,
        displayCreateDraftOrder: o
      }
    )
  ] }) : null;
}, hK = ({
  totalOrders: e,
  amountSpent: n
}) => {
  const r = n?.amount ?? 0, i = n?.currencyCode ?? "", a = `${Number.parseFloat(r).toFixed(
    2
  )} ${i}`;
  return /* @__PURE__ */ v.jsx(v.Fragment, { children: /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: "Orders overview" }),
    /* @__PURE__ */ v.jsxs(Ye, { className: Mt.list, children: [
      /* @__PURE__ */ v.jsx(Ye.Text, { variant: "dense", className: Mt.listItem, children: /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: "Total orders" }),
        /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: e })
      ] }) }),
      /* @__PURE__ */ v.jsx(Ye.Text, { variant: "dense", className: Mt.listItem, children: /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: "Total revenue" }),
        /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: a })
      ] }) })
    ] })
  ] }) });
}, yK = "_segmentName_1dkhk_1", gK = {
  segmentName: yK
}, vK = 100, Bs = 10, kK = ({
  shopifyId: e
}) => {
  const { useQuery: n, useLazyQuery: r } = hn(), [i, a] = pe([]), [o, s] = pe(Bs), [l, c] = pe(!1), m = Xn(
    () => i.filter((N) => N.isMember).length,
    [i]
  ), { loading: u, error: f } = n(
    N9,
    {
      skip: !e,
      variables: {
        first: vK
      },
      onCompleted: (N) => {
        const j = N?.Shopify?.segments?.edges;
        if (j && j.length > 0) {
          const _ = j.map(({ node: g }) => ({
            ...g,
            isMember: !1
          })).sort((g, O) => g.name.localeCompare(O.name));
          a(_), h({
            variables: {
              customerId: e,
              segmentIds: _.map((g) => g.id)
            }
          });
        }
      }
    }
  ), [
    h,
    { loading: k, error: w }
  ] = r(j9, {
    onCompleted: (N) => {
      const j = N?.Shopify?.customerSegmentMembership?.memberships;
      if (j && j.length > 0) {
        const _ = i.map((g) => {
          const O = j.find(
            (R) => R.segmentId === g.id
          );
          return {
            ...g,
            ...O?.isMember && { isMember: O.isMember }
          };
        }).sort(
          (g, O) => g.isMember === O.isMember ? 0 : g.isMember ? -1 : 1
        );
        a(_);
      }
    }
  });
  return Qe(() => {
    s(l ? i.length : Bs);
  }, [l]), e ? /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: "Segment membership" }),
      !u && /* @__PURE__ */ v.jsx(Pn, { variant: "success", size: "small", children: m })
    ] }),
    u && /* @__PURE__ */ v.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ v.jsx(mn, {}) }),
    !u && i.length === 0 && /* @__PURE__ */ v.jsx($.Paragraph, { color: "tertiary", margin: "200 0 300 0", align: "center", children: "No segments found" }),
    f && /* @__PURE__ */ v.jsx($n, { error: f }),
    w && /* @__PURE__ */ v.jsx($n, { error: w }),
    !u && i.length > 0 && /* @__PURE__ */ v.jsxs(Ye, { className: Mt.list, children: [
      i.slice(0, o).map(({ id: N, name: j, isMember: _ }) => /* @__PURE__ */ v.jsx(Ye.Text, { className: Mt.listItem, children: /* @__PURE__ */ v.jsx(
        Xe,
        {
          content: `${_ ? "Member of" : "Not a member of"} ${j}`,
          children: /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", children: [
            /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", className: gK.segmentName, children: j }),
            k && /* @__PURE__ */ v.jsx(mn, { size: 12 }),
            !k && /* @__PURE__ */ v.jsx(b, { children: /* @__PURE__ */ v.jsx(
              he,
              {
                color: _ ? "green.500" : "neutral.300",
                name: "shopify"
              }
            ) })
          ] })
        }
      ) }, N)),
      i.length > Bs && /* @__PURE__ */ v.jsx(b, { justifyContent: "center", margin: "200 0 0", children: /* @__PURE__ */ v.jsx(
        tt,
        {
          variant: "secondary",
          onClick: () => c(!l),
          icon: l ? "angle-up" : "angle-down",
          children: l ? "Show less" : `Show ${i.length - Bs} more`
        }
      ) })
    ] })
  ] }) : null;
}, bK = ({
  conversationContext: e,
  settings: n
}) => {
  const [r, i] = pe(!1);
  Qe(() => {
    i(!1);
  }, [
    e.customer?.phone_number,
    e.customer?.email
  ]);
  const {
    isCustomerLoading: a,
    customerError: o,
    customerData: s,
    refetchCustomer: l,
    customerNetworkStatus: c
  } = D9({ conversationContext: e, forcePhoneLookup: r }), [m, u] = pe(), [f, h] = pe(
    []
  ), k = n.apiHostName, w = n.displayRefundOrder ?? !1, N = n.displayCancelOrder ?? !1, j = n.enableEditShippingAddress ?? !1, _ = n.displayEmailMarketingConsent ?? !1, g = n.displayOrdersOverview ?? !1, O = n.displaySegmentMembership ?? !1, R = n.displayDiscountCodeCreation ?? !1, F = n.displayDiscountCodes ?? !1, I = n.displayCreateOrder ?? !1, L = n.displayDuplicateOrder ?? !1, W = n.displayCreateDraftOrder ?? !1, J = n.displayPartialRefundOrder ?? !1;
  if (Qe(() => {
    const re = s?.Shopify?.customers?.edges[0]?.node, K = !!e.customer?.phone_number && !!e.customer?.email;
    re && !a ? (h(
      s?.Shopify?.shop?.countriesInShippingZones?.countryCodes || []
    ), u(re)) : !re && !a && K && !r ? i(!0) : u(void 0);
  }, [s, e]), !a && o)
    return /* @__PURE__ */ v.jsx($n, { error: o, retry: l });
  if (!a && !o && !m) {
    const re = `https://${k}/admin/customers?search=${e.customer?.name || ""}`;
    return /* @__PURE__ */ v.jsxs(
      b,
      {
        margin: "200 0 300",
        gap: "300",
        flexDirection: "column",
        "data-testid": "widget-customer-not-found",
        children: [
          /* @__PURE__ */ v.jsx($.Paragraph, { color: "secondary", children: "We cannot find the customer in Shopify." }),
          /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "column", children: [
            /* @__PURE__ */ v.jsx(
              Q9,
              {
                refetchCustomer: l,
                conversationContext: e
              }
            ),
            /* @__PURE__ */ v.jsx(
              It,
              {
                variant: "secondary",
                style: {
                  color: "var(--dixa-typography-color-link)",
                  padding: "var(--dixa-size-spacer-100)"
                },
                navigate: () => window.open(re, "_blank")?.focus(),
                slotStart: /* @__PURE__ */ v.jsx(he, { name: "external-link" }),
                children: "Search customers in Shopify"
              }
            )
          ] })
        ]
      }
    );
  }
  return a && c !== rr.refetch ? /* @__PURE__ */ v.jsx(b, { margin: "200 0 300", justifyContent: "center", children: /* @__PURE__ */ v.jsx(mn, {}) }) : /* @__PURE__ */ v.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300",
      "data-testid": "widget-wrapper",
      children: [
        /* @__PURE__ */ v.jsx(
          e7,
          {
            customer: m,
            shopifyDomain: k,
            refresh: l,
            loading: a,
            networkStatus: c
          }
        ),
        g && /* @__PURE__ */ v.jsx(
          hK,
          {
            totalOrders: m?.numberOfOrders,
            amountSpent: m?.amountSpent
          }
        ),
        O && /* @__PURE__ */ v.jsx(kK, { shopifyId: m?.id }),
        _ && /* @__PURE__ */ v.jsx(y7, { customer: m }),
        F && /* @__PURE__ */ v.jsx(
          h7,
          {
            displayDiscountCodeCreation: R
          }
        ),
        /* @__PURE__ */ v.jsx(
          fK,
          {
            shopifyCustomer: m,
            shopifyDomain: k,
            displayRefund: w,
            displayCancel: N,
            displayCreateOrder: I,
            displayCreateDraftOrder: W,
            enableEditShippingAddress: j,
            customerCountryCodes: f,
            displayDuplicateOrder: L,
            displayPartialRefundOrder: J
          }
        )
      ]
    }
  );
}, Dt = [];
for (let e = 0; e < 256; ++e)
  Dt.push((e + 256).toString(16).slice(1));
function _K(e, n = 0) {
  return (Dt[e[n + 0]] + Dt[e[n + 1]] + Dt[e[n + 2]] + Dt[e[n + 3]] + "-" + Dt[e[n + 4]] + Dt[e[n + 5]] + "-" + Dt[e[n + 6]] + Dt[e[n + 7]] + "-" + Dt[e[n + 8]] + Dt[e[n + 9]] + "-" + Dt[e[n + 10]] + Dt[e[n + 11]] + Dt[e[n + 12]] + Dt[e[n + 13]] + Dt[e[n + 14]] + Dt[e[n + 15]]).toLowerCase();
}
const xK = new Uint8Array(16);
function SK() {
  return crypto.getRandomValues(xK);
}
function NK(e, n, r) {
  return crypto.randomUUID ? crypto.randomUUID() : jK(e);
}
function jK(e, n, r) {
  e = e || {};
  const i = e.random ?? e.rng?.() ?? SK();
  if (i.length < 16)
    throw new Error("Random bytes length must be >= 16");
  return i[6] = i[6] & 15 | 64, i[8] = i[8] & 63 | 128, _K(i);
}
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode('@charset "UTF-8";._pointer_pn2q5_54{cursor:pointer;color:var(--dixa-typography-color-secondary)}._list_pn2q5_59{padding:0;overflow-y:auto;max-height:230px;background:linear-gradient(var(--dixa-color-neutral-000) 33%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),var(--dixa-color-neutral-000) 66%) 0 100%,radial-gradient(farthest-side at 50% 0,var(--dixa-color-neutral-200),rgba(0,0,0,0)),radial-gradient(farthest-side at 50% 100%,var(--dixa-color-neutral-200),rgba(0,0,0,0)) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-200),100% var(--dixa-size-spacer-200)}._listItem_pn2q5_69{cursor:pointer;background-color:transparent;padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_pn2q5_69:last-child{border-bottom:none}._modalBody_1clhs_1{width:400px}._wrapper_1ge6c_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._textVariant_1ge6c_7{color:var(--dixa-typography-color-secondary);font-size:var(--dixa-typography-size-300)}._block_1ge6c_12{margin-bottom:var(--dixa-size-spacer-250)}._wrapper_yud4a_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._list_yud4a_7{padding:0}._listItem_yud4a_11{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItemTooltip_yud4a_15{cursor:pointer}._listItemTimestamp_yud4a_18{font-size:var(--dixa-typography-size-200);color:var(--dixa-typography-color-tertiary)}._listItem_yud4a_11:last-child{border-bottom:none}._tagHover_kzbzk_1:hover{cursor:pointer;border-color:var(--dixa-color-neutral-400)}._channelUnsubscribed_kzbzk_6{color:var(--dixa-color-neutral-500)}._list_zu4s7_1{padding:var(--dixa-size-spacer-100)}._listItem_zu4s7_4{padding:var(--dixa-size-spacer-200) var(--dixa-size-spacer-100)}._listSum_zu4s7_7{margin-top:var(--dixa-size-spacer-200);border-top:var(--dixa-size-border-100) solid var(--dixa-color-neutral-400)}._transaction_1kr8d_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._transaction_1kr8d_1:hover,._transactionIsOpen_1kr8d_9{border-color:var(--dixa-color-neutral-400)}._transactionHeader_1kr8d_12{cursor:pointer}._transactionHeaderSubLine_1kr8d_15{font-size:var(--dixa-typography-size-200);color:var(--dixa-typography-color-tertiary)}._transactionHeaderAlignItemRight_1kr8d_19{margin-left:auto;margin-right:var(--dixa-size-spacer-200)}._message_4z55u_54{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._message_4z55u_54:hover,._messageIsOpen_4z55u_62{border-color:var(--dixa-color-neutral-400)}._messageHeader_4z55u_66{cursor:pointer}._messageText_4z55u_70{max-height:150px;overflow:scroll;padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-200);border:1px solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);overflow:auto}._messageText_4z55u_70::-webkit-scrollbar{width:7px;height:7px}._messageText_4z55u_70::-webkit-scrollbar-track{background-color:var(--dixa-color-neutral-000)}._messageText_4z55u_70::-webkit-scrollbar-thumb{background-color:var(--dixa-color-neutral-400);border-radius:4px}._messageText_4z55u_70::-webkit-scrollbar-thumb:hover{background-color:var(--dixa-color-neutral-500)}._buttonLink_4z55u_93{color:var(--dixa-typography-color-link)}._order_19t4p_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_19t4p_1:hover,._orderIsOpen_19t4p_9{border-color:var(--dixa-color-neutral-400)}._orderHeader_19t4p_12{cursor:pointer}._orderIconColor_19t4p_15{color:var(--dixa-color-green-500)}._delivery_1m9nb_1{word-break:break-all}._deliveryCode_1m9nb_4{font-family:var(--dixa-typography-family-code);color:var(--dixa-typography-color-tertiary)}')), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Lh = { exports: {} }, So = {}, dw;
function wK() {
  if (dw) return So;
  dw = 1;
  var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, c, m) {
    var u, f = {}, h = null, k = null;
    m !== void 0 && (h = "" + m), c.key !== void 0 && (h = "" + c.key), c.ref !== void 0 && (k = c.ref);
    for (u in c) i.call(c, u) && !o.hasOwnProperty(u) && (f[u] = c[u]);
    if (l && l.defaultProps) for (u in c = l.defaultProps, c) f[u] === void 0 && (f[u] = c[u]);
    return { $$typeof: n, type: l, key: h, ref: k, props: f, _owner: a.current };
  }
  return So.Fragment = r, So.jsx = s, So.jsxs = s, So;
}
var qs = {}, cw;
function CK() {
  return cw || (cw = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), c = /* @__PURE__ */ Symbol.for("react.forward_ref"), m = /* @__PURE__ */ Symbol.for("react.suspense"), u = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), k = /* @__PURE__ */ Symbol.for("react.offscreen"), w = Symbol.iterator, N = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var d = w && t[w] || t[N];
      return typeof d == "function" ? d : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var d = arguments.length, p = new Array(d > 1 ? d - 1 : 0), y = 1; y < d; y++)
          p[y - 1] = arguments[y];
        O("error", t, p);
      }
    }
    function O(t, d, p) {
      {
        var y = _.ReactDebugCurrentFrame, C = y.getStackAddendum();
        C !== "" && (d += "%s", p = p.concat([C]));
        var T = p.map(function(S) {
          return String(S);
        });
        T.unshift("Warning: " + d), Function.prototype.apply.call(console[t], console, T);
      }
    }
    var R = !1, F = !1, I = !1, L = !1, W = !1, J;
    J = /* @__PURE__ */ Symbol.for("react.module.reference");
    function re(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || W || t === a || t === m || t === u || L || t === k || R || F || I || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === J || t.getModuleId !== void 0));
    }
    function K(t, d, p) {
      var y = t.displayName;
      if (y)
        return y;
      var C = d.displayName || d.name || "";
      return C !== "" ? p + "(" + C + ")" : p;
    }
    function Y(t) {
      return t.displayName || "Context";
    }
    function P(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var d = t;
            return Y(d) + ".Consumer";
          case s:
            var p = t;
            return Y(p._context) + ".Provider";
          case c:
            return K(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : P(t.type) || "Memo";
          case h: {
            var C = t, T = C._payload, S = C._init;
            try {
              return P(S(T));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, ie = 0, we, me, le, ge, V, be, Oe;
    function q() {
    }
    q.__reactDisabledLog = !0;
    function Ge() {
      {
        if (ie === 0) {
          we = console.log, me = console.info, le = console.warn, ge = console.error, V = console.group, be = console.groupCollapsed, Oe = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: q,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ie++;
      }
    }
    function sn() {
      {
        if (ie--, ie === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, t, {
              value: we
            }),
            info: B({}, t, {
              value: me
            }),
            warn: B({}, t, {
              value: le
            }),
            error: B({}, t, {
              value: ge
            }),
            group: B({}, t, {
              value: V
            }),
            groupCollapsed: B({}, t, {
              value: be
            }),
            groupEnd: B({}, t, {
              value: Oe
            })
          });
        }
        ie < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ie = _.ReactCurrentDispatcher, Ue;
    function De(t, d, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (C) {
            var y = C.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Ae;
    {
      var Je = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Je();
    }
    function Ee(t, d) {
      if (!t || Be)
        return "";
      {
        var p = Ae.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Be = !0;
      var C = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var T;
      T = Ie.current, Ie.current = null, Ge();
      try {
        if (d) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (ne) {
              y = ne;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (ne) {
              y = ne;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            y = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && y && typeof ne.stack == "string") {
          for (var x = ne.stack.split(`
`), Z = y.stack.split(`
`), A = x.length - 1, M = Z.length - 1; A >= 1 && M >= 0 && x[A] !== Z[M]; )
            M--;
          for (; A >= 1 && M >= 0; A--, M--)
            if (x[A] !== Z[M]) {
              if (A !== 1 || M !== 1)
                do
                  if (A--, M--, M < 0 || x[A] !== Z[M]) {
                    var ue = `
` + x[A].replace(" at new ", " at ");
                    return t.displayName && ue.includes("<anonymous>") && (ue = ue.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, ue), ue;
                  }
                while (A >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Ie.current = T, sn(), Error.prepareStackTrace = C;
      }
      var ze = t ? t.displayName || t.name : "", Te = ze ? De(ze) : "";
      return typeof t == "function" && Ae.set(t, Te), Te;
    }
    function Me(t, d, p) {
      return Ee(t, !1);
    }
    function en(t) {
      var d = t.prototype;
      return !!(d && d.isReactComponent);
    }
    function se(t, d, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ee(t, en(t));
      if (typeof t == "string")
        return De(t);
      switch (t) {
        case m:
          return De("Suspense");
        case u:
          return De("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case c:
            return Me(t.render);
          case f:
            return se(t.type, d, p);
          case h: {
            var y = t, C = y._payload, T = y._init;
            try {
              return se(T(C), d, p);
            } catch {
            }
          }
        }
      return "";
    }
    var de = Object.prototype.hasOwnProperty, Se = {}, Ve = _.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var d = t._owner, p = se(t.type, t._source, d ? d.type : null);
        Ve.setExtraStackFrame(p);
      } else
        Ve.setExtraStackFrame(null);
    }
    function kn(t, d, p, y, C) {
      {
        var T = Function.call.bind(de);
        for (var S in t)
          if (T(t, S)) {
            var x = void 0;
            try {
              if (typeof t[S] != "function") {
                var Z = Error((y || "React class") + ": " + p + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Z.name = "Invariant Violation", Z;
              }
              x = t[S](d, S, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (A) {
              x = A;
            }
            x && !(x instanceof Error) && (Pe(C), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, S, typeof x), Pe(null)), x instanceof Error && !(x.message in Se) && (Se[x.message] = !0, Pe(C), g("Failed %s type: %s", p, x.message), Pe(null));
          }
      }
    }
    var Q = Array.isArray;
    function E(t) {
      return Q(t);
    }
    function z(t) {
      {
        var d = typeof Symbol == "function" && Symbol.toStringTag, p = d && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function ae(t) {
      try {
        return ce(t), !1;
      } catch {
        return !0;
      }
    }
    function ce(t) {
      return "" + t;
    }
    function U(t) {
      if (ae(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", z(t)), ce(t);
    }
    var G = _.ReactCurrentOwner, ve = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, je, Re;
    function rn(t) {
      if (de.call(t, "ref")) {
        var d = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (d && d.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function bn(t) {
      if (de.call(t, "key")) {
        var d = Object.getOwnPropertyDescriptor(t, "key").get;
        if (d && d.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function an(t, d) {
      typeof t.ref == "string" && G.current;
    }
    function fn(t, d) {
      {
        var p = function() {
          je || (je = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", d));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function En(t, d) {
      {
        var p = function() {
          Re || (Re = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", d));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var _n = function(t, d, p, y, C, T, S) {
      var x = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: d,
        ref: p,
        props: S,
        // Record the component responsible for creating this element.
        _owner: T
      };
      return x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(x, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(x, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: C
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    };
    function Fn(t, d, p, y, C) {
      {
        var T, S = {}, x = null, Z = null;
        p !== void 0 && (U(p), x = "" + p), bn(d) && (U(d.key), x = "" + d.key), rn(d) && (Z = d.ref, an(d));
        for (T in d)
          de.call(d, T) && !ve.hasOwnProperty(T) && (S[T] = d[T]);
        if (t && t.defaultProps) {
          var A = t.defaultProps;
          for (T in A)
            S[T] === void 0 && (S[T] = A[T]);
        }
        if (x || Z) {
          var M = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          x && fn(S, M), Z && En(S, M);
        }
        return _n(t, x, Z, C, y, G.current, S);
      }
    }
    var Ze = _.ReactCurrentOwner, gn = _.ReactDebugCurrentFrame;
    function Le(t) {
      if (t) {
        var d = t._owner, p = se(t.type, t._source, d ? d.type : null);
        gn.setExtraStackFrame(p);
      } else
        gn.setExtraStackFrame(null);
    }
    var dn;
    dn = !1;
    function cn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function Nn() {
      {
        if (Ze.current) {
          var t = P(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Bn(t) {
      return "";
    }
    var Sn = {};
    function An(t) {
      {
        var d = Nn();
        if (!d) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (d = `

Check the top-level render call using <` + p + ">.");
        }
        return d;
      }
    }
    function vn(t, d) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = An(d);
        if (Sn[p])
          return;
        Sn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Ze.current && (y = " It was passed a child from " + P(t._owner.type) + "."), Le(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Le(null);
      }
    }
    function xn(t, d) {
      {
        if (typeof t != "object")
          return;
        if (E(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            cn(y) && vn(y, d);
          }
        else if (cn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var C = j(t);
          if (typeof C == "function" && C !== t.entries)
            for (var T = C.call(t), S; !(S = T.next()).done; )
              cn(S.value) && vn(S.value, d);
        }
      }
    }
    function Ln(t) {
      {
        var d = t.type;
        if (d == null || typeof d == "string")
          return;
        var p;
        if (typeof d == "function")
          p = d.propTypes;
        else if (typeof d == "object" && (d.$$typeof === c || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        d.$$typeof === f))
          p = d.propTypes;
        else
          return;
        if (p) {
          var y = P(d);
          kn(p, t.props, "prop", y, t);
        } else if (d.PropTypes !== void 0 && !dn) {
          dn = !0;
          var C = P(d);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", C || "Unknown");
        }
        typeof d.getDefaultProps == "function" && !d.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var d = Object.keys(t.props), p = 0; p < d.length; p++) {
          var y = d[p];
          if (y !== "children" && y !== "key") {
            Le(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Le(null);
            break;
          }
        }
        t.ref !== null && (Le(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Le(null));
      }
    }
    var Cn = {};
    function wn(t, d, p, y, C, T) {
      {
        var S = re(t);
        if (!S) {
          var x = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (x += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Z = Bn();
          Z ? x += Z : x += Nn();
          var A;
          t === null ? A = "null" : E(t) ? A = "array" : t !== void 0 && t.$$typeof === n ? (A = "<" + (P(t.type) || "Unknown") + " />", x = " Did you accidentally export a JSX literal instead of a component?") : A = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", A, x);
        }
        var M = Fn(t, d, p, C, T);
        if (M == null)
          return M;
        if (S) {
          var ue = d.children;
          if (ue !== void 0)
            if (y)
              if (E(ue)) {
                for (var ze = 0; ze < ue.length; ze++)
                  xn(ue[ze], t);
                Object.freeze && Object.freeze(ue);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              xn(ue, t);
        }
        if (de.call(d, "key")) {
          var Te = P(t), ne = Object.keys(d).filter(function(Kn) {
            return Kn !== "key";
          }), un = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Cn[Te + un]) {
            var Rn = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, un, Te, Rn, Te), Cn[Te + un] = !0;
          }
        }
        return t === i ? Vn(M) : Ln(M), M;
      }
    }
    function zn(t, d, p) {
      return wn(t, d, p, !0);
    }
    function qn(t, d, p) {
      return wn(t, d, p, !1);
    }
    var Un = qn, Wn = zn;
    qs.Fragment = i, qs.jsx = Un, qs.jsxs = Wn;
  })()), qs;
}
var uw;
function FK() {
  return uw || (uw = 1, process.env.NODE_ENV === "production" ? Lh.exports = wK() : Lh.exports = CK()), Lh.exports;
}
var D = FK(), QF = /* @__PURE__ */ ((e) => (e.Adjustment = "Adjustment", e.Automation = "Automation", e.BonusBalanceAdjustment = "BonusBalanceAdjustment", e.BonusPromotion = "BonusPromotion", e.BonusPromotionReturn = "BonusPromotionReturn", e.Manual = "Manual", e.PointTransactionCancellation = "PointTransactionCancellation", e.Purchase = "Purchase", e.ReceiptAdjustment = "ReceiptAdjustment", e.Return = "Return", e.RewardVoucher = "RewardVoucher", e.UpdateBalance = "UpdateBalance", e))(QF || {}), jy = /* @__PURE__ */ ((e) => (e.Addition = "Addition", e.Cancellation = "Cancellation", e.Deduction = "Deduction", e.Expiry = "Expiry", e))(jy || {});
const IK = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updatePreferences" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_contactAttributes_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactsV_ContactPatch" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }] } }] } }] }, $K = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updatePoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_AddPointTransactionRequestModel_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "PointTransaction_AddPointTransacion" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }] }] } }] } }] }, EK = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getContactById" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactsV_GetContactById" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" } }, { kind: "Field", name: { kind: "Name", value: "meta" } }, { kind: "Field", name: { kind: "Name", value: "preferences" } }, { kind: "Field", name: { kind: "Name", value: "consents" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "value" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "comment" } }] } }] } }] } }] } }] }, TK = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getContactOverviewById" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactOverview_GetContactOverviewAsync" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }] }] } }] } }] }, RK = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getContactId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "mobilePhone" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactOverview_GetContactIdAsync" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }, { kind: "Argument", name: { kind: "Name", value: "mobilePhone" }, value: { kind: "Variable", name: { kind: "Name", value: "mobilePhone" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ContactOverview_GetContactIdAsync_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_String_container" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "String" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ApiExceptionMultipleMatchesResponse" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errorCode" } }, { kind: "Field", name: { kind: "Name", value: "message" } }, { kind: "Field", name: { kind: "Name", value: "requestId" } }, { kind: "Field", name: { kind: "Name", value: "messageDetails" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "multipleMatchesFound" } }] } }] } }] } }] } }] } }] } }] }, DK = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getLatestMessagesByContactId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "count" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactMessage_GetSmsMessagesByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ListResultOfApiMessage" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "messageId" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sendDateTime" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "isTransactional" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "messageLink" } }, { kind: "Field", name: { kind: "Name", value: "messageText" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "ContactMessage_GetPostalMessagesByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ListResultOfApiMessage" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "messageId" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sendDateTime" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "isTransactional" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "messageLink" } }, { kind: "Field", name: { kind: "Name", value: "messageText" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "ContactMessage_GetEmailMessagesByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ListResultOfApiMessage" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "messageId" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sendDateTime" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "isTransactional" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "messageLink" } }, { kind: "Field", name: { kind: "Name", value: "messageText" } }] } }] } }] } }] } }] } }] }, OK = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomerTransactions" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "offset" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "count" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Transactions_GetTransactionsWithArticlesByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "offset" }, value: { kind: "Variable", name: { kind: "Name", value: "offset" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "totalCount" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "createdDate" } }, { kind: "Field", name: { kind: "Name", value: "transactionNumber" } }, { kind: "Field", name: { kind: "Name", value: "storeName" } }, { kind: "Field", name: { kind: "Name", value: "numberOfItems" } }, { kind: "Field", name: { kind: "Name", value: "netPriceSum" } }, { kind: "Field", name: { kind: "Name", value: "localNetPriceSum" } }, { kind: "Field", name: { kind: "Name", value: "localCurrency" } }, { kind: "Field", name: { kind: "Name", value: "lineItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "article" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "localPrice" } }, { kind: "Field", name: { kind: "Name", value: "type" } }] } }] } }] } }] } }] } }] }, PK = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getOrdersByContactId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "offset" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "count" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Orders_GetAllByContact" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "offset" }, value: { kind: "Variable", name: { kind: "Name", value: "offset" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "totalCount" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderId" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }, { kind: "Field", name: { kind: "Name", value: "lastChangedAt" } }, { kind: "Field", name: { kind: "Name", value: "channel" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "externalStatus" } }, { kind: "Field", name: { kind: "Name", value: "totalPrice" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }, { kind: "Field", name: { kind: "Name", value: "lineItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "totalPrice" } }, { kind: "Field", name: { kind: "Name", value: "article" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "imageUri" } }, { kind: "Field", name: { kind: "Name", value: "targetUri" } }] } }] } }] } }] } }] } }] } }] } }] }, AK = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getPoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "PointAccountV_GetPointAccounts" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_PointAccountModelV3" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "balance" } }] } }] } }] } }] } }] }, LK = {
  "\n  mutation updatePreferences(\n    $contactId: Voyado_UUID!\n    $input: Voyado_contactAttributes_Input!\n  ) {\n    Voyado {\n      ContactsV_ContactPatch(contactId: $contactId, input: $input) {\n        id\n      }\n    }\n  }\n": IK,
  "\n  mutation updatePoints($input: Voyado_AddPointTransactionRequestModel_Input!) {\n    Voyado {\n      PointTransaction_AddPointTransacion(input: $input)\n    }\n  }\n": $K,
  "\n  query getContactById($contactId: Voyado_UUID!) {\n    Voyado {\n      ContactsV_GetContactById(contactId: $contactId) {\n        id\n        attributes\n        meta\n        preferences\n        consents {\n          id\n          date\n          value\n          source\n          comment\n        }\n      }\n    }\n  }\n": EK,
  "\n  query getContactOverviewById($contactId: String!) {\n    Voyado {\n      ContactOverview_GetContactOverviewAsync(contactId: $contactId)\n    }\n  }\n": TK,
  "\n  query getContactId($email: String!, $mobilePhone: String!) {\n    Voyado {\n      ContactOverview_GetContactIdAsync(\n        email: $email\n        mobilePhone: $mobilePhone\n      ) {\n        ... on Voyado_ContactOverview_GetContactIdAsync_response {\n          ... on Voyado_String_container {\n            String\n          }\n          ... on Voyado_ApiExceptionMultipleMatchesResponse {\n            errorCode\n            message\n            requestId\n            messageDetails {\n              multipleMatchesFound\n            }\n          }\n        }\n      }\n    }\n  }\n": RK,
  "\n  query getLatestMessagesByContactId($contactId: Voyado_UUID!, $count: Int) {\n    Voyado {\n      ContactMessage_GetSmsMessagesByContactId(\n        contactId: $contactId\n        count: $count\n      ) {\n        ... on Voyado_ListResultOfApiMessage {\n          count\n          items {\n            messageId\n            name\n            sendDateTime\n            type\n            source\n            isTransactional\n            status\n            messageLink\n            messageText\n          }\n        }\n      }\n      ContactMessage_GetPostalMessagesByContactId(\n        contactId: $contactId\n        count: $count\n      ) {\n        ... on Voyado_ListResultOfApiMessage {\n          count\n          items {\n            messageId\n            name\n            sendDateTime\n            type\n            source\n            isTransactional\n            status\n            messageLink\n            messageText\n          }\n        }\n      }\n      ContactMessage_GetEmailMessagesByContactId(\n        contactId: $contactId\n        count: $count\n      ) {\n        ... on Voyado_ListResultOfApiMessage {\n          count\n          items {\n            messageId\n            name\n            sendDateTime\n            type\n            source\n            isTransactional\n            status\n            messageLink\n            messageText\n          }\n        }\n      }\n    }\n  }\n": DK,
  "\n  query getCustomerTransactions(\n    $contactId: Voyado_UUID!\n    $offset: Int\n    $count: Int\n  ) {\n    Voyado {\n      Transactions_GetTransactionsWithArticlesByContactId(\n        contactId: $contactId\n        offset: $offset\n        count: $count\n      ) {\n        count\n        totalCount\n        items {\n          id\n          createdDate\n          transactionNumber\n          storeName\n          numberOfItems\n          netPriceSum\n          localNetPriceSum\n          localCurrency\n          lineItems {\n            quantity\n            article {\n              name\n            }\n            localPrice\n            type\n          }\n        }\n      }\n    }\n  }\n": OK,
  "\n  query getOrdersByContactId(\n    $contactId: Voyado_UUID!\n    $offset: Int\n    $count: Int\n  ) {\n    Voyado {\n      Orders_GetAllByContact(\n        contactId: $contactId\n        offset: $offset\n        count: $count\n      ) {\n        totalCount\n        items {\n          orderId\n          createdAt\n          lastChangedAt\n          channel\n          status\n          externalStatus\n          totalPrice\n          currencyCode\n          lineItems {\n            items {\n              id\n              quantity\n              totalPrice\n              article {\n                sku\n                name\n                description\n                imageUri\n                targetUri\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": PK,
  "\n  query getPoints($contactId: Voyado_UUID!) {\n    Voyado {\n      PointAccountV_GetPointAccounts(contactId: $contactId) {\n        ... on Voyado_PointAccountModelV3 {\n          id\n          balance\n        }\n      }\n    }\n  }\n": AK
};
function si(e) {
  return LK[e] ?? {};
}
const VK = si(
  /* GraphQL */
  `
  query getContactById($contactId: Voyado_UUID!) {
    Voyado {
      ContactsV_GetContactById(contactId: $contactId) {
        id
        attributes
        meta
        preferences
        consents {
          id
          date
          value
          source
          comment
        }
      }
    }
  }
`
), zK = si(
  /* GraphQL */
  `
  query getContactOverviewById($contactId: String!) {
    Voyado {
      ContactOverview_GetContactOverviewAsync(contactId: $contactId)
    }
  }
`
), UK = si(
  /* GraphQL */
  `
  query getContactId($email: String!, $mobilePhone: String!) {
    Voyado {
      ContactOverview_GetContactIdAsync(
        email: $email
        mobilePhone: $mobilePhone
      ) {
        ... on Voyado_ContactOverview_GetContactIdAsync_response {
          ... on Voyado_String_container {
            String
          }
          ... on Voyado_ApiExceptionMultipleMatchesResponse {
            errorCode
            message
            requestId
            messageDetails {
              multipleMatchesFound
            }
          }
        }
      }
    }
  }
`
), MK = si(
  /* GraphQL */
  `
  query getLatestMessagesByContactId($contactId: Voyado_UUID!, $count: Int) {
    Voyado {
      ContactMessage_GetSmsMessagesByContactId(
        contactId: $contactId
        count: $count
      ) {
        ... on Voyado_ListResultOfApiMessage {
          count
          items {
            messageId
            name
            sendDateTime
            type
            source
            isTransactional
            status
            messageLink
            messageText
          }
        }
      }
      ContactMessage_GetPostalMessagesByContactId(
        contactId: $contactId
        count: $count
      ) {
        ... on Voyado_ListResultOfApiMessage {
          count
          items {
            messageId
            name
            sendDateTime
            type
            source
            isTransactional
            status
            messageLink
            messageText
          }
        }
      }
      ContactMessage_GetEmailMessagesByContactId(
        contactId: $contactId
        count: $count
      ) {
        ... on Voyado_ListResultOfApiMessage {
          count
          items {
            messageId
            name
            sendDateTime
            type
            source
            isTransactional
            status
            messageLink
            messageText
          }
        }
      }
    }
  }
`
), BK = si(
  /* GraphQL */
  `
  query getCustomerTransactions(
    $contactId: Voyado_UUID!
    $offset: Int
    $count: Int
  ) {
    Voyado {
      Transactions_GetTransactionsWithArticlesByContactId(
        contactId: $contactId
        offset: $offset
        count: $count
      ) {
        count
        totalCount
        items {
          id
          createdDate
          transactionNumber
          storeName
          numberOfItems
          netPriceSum
          localNetPriceSum
          localCurrency
          lineItems {
            quantity
            article {
              name
            }
            localPrice
            type
          }
        }
      }
    }
  }
`
), qK = si(
  /* GraphQL */
  `
  query getOrdersByContactId(
    $contactId: Voyado_UUID!
    $offset: Int
    $count: Int
  ) {
    Voyado {
      Orders_GetAllByContact(
        contactId: $contactId
        offset: $offset
        count: $count
      ) {
        totalCount
        items {
          orderId
          createdAt
          lastChangedAt
          channel
          status
          externalStatus
          totalPrice
          currencyCode
          lineItems {
            items {
              id
              quantity
              totalPrice
              article {
                sku
                name
                description
                imageUri
                targetUri
              }
            }
          }
        }
      }
    }
  }
`
), HK = si(
  /* GraphQL */
  `
  query getPoints($contactId: Voyado_UUID!) {
    Voyado {
      PointAccountV_GetPointAccounts(contactId: $contactId) {
        ... on Voyado_PointAccountModelV3 {
          id
          balance
        }
      }
    }
  }
`
), WK = si(
  /* GraphQL */
  `
  mutation updatePreferences(
    $contactId: Voyado_UUID!
    $input: Voyado_contactAttributes_Input!
  ) {
    Voyado {
      ContactsV_ContactPatch(contactId: $contactId, input: $input) {
        id
      }
    }
  }
`
), KK = si(
  /* GraphQL */
  `
  mutation updatePoints($input: Voyado_AddPointTransactionRequestModel_Input!) {
    Voyado {
      PointTransaction_AddPointTransacion(input: $input)
    }
  }
`
), GK = ({
  contactId: e
}) => {
  const { useQuery: n } = hn(), { track: r } = jn(), [i, a] = pe(), [o, s] = pe(), [l, c] = pe(), {
    loading: m,
    error: u,
    data: f,
    refetch: h
  } = n(VK, {
    skip: !e,
    variables: { contactId: e }
  });
  return Qe(() => {
    const k = f?.Voyado?.ContactsV_GetContactById;
    !m && k && typeof k == "object" && ("id" in k && r("voyado:profile:received", { hasProfile: !0 }), "attributes" in k && a(k.attributes), "preferences" in k && s(k.preferences), "consents" in k && c(
      k?.consents?.filter(
        (w) => w !== null
      ) || void 0
    )), !m && (!k || typeof k != "object") && r("voyado:profile:received", { hasProfile: !1 });
  }, [f?.Voyado, m]), Xn(
    () => ({
      isLoading: m,
      error: u,
      refetch: h,
      attributes: i,
      preferences: o,
      consents: l
    }),
    [u, i, o, l]
  );
};
function cl(e = !1, n) {
  const [r, i] = pe(e);
  return Qe(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copy: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const YK = {
  count: 0,
  items: []
}, JK = ({
  contactId: e
}) => {
  const { useQuery: n } = hn(), { track: r } = jn(), [i, a] = pe(YK), {
    loading: o,
    error: s,
    data: l
  } = n(MK, {
    skip: !e,
    variables: { contactId: e, count: 5 }
  });
  return Qe(() => {
    if (!o && (l?.Voyado?.ContactMessage_GetSmsMessagesByContactId || l?.Voyado?.ContactMessage_GetPostalMessagesByContactId || l?.Voyado?.ContactMessage_GetEmailMessagesByContactId)) {
      const c = l?.Voyado?.ContactMessage_GetEmailMessagesByContactId, m = l?.Voyado?.ContactMessage_GetSmsMessagesByContactId, u = l?.Voyado?.ContactMessage_GetPostalMessagesByContactId, f = {
        count: (m?.count ?? 0) + (u?.count ?? 0) + (c?.count ?? 0),
        items: [
          ...m.items ?? [],
          ...c.items ?? [],
          ...u.items ?? []
        ]
      };
      a(f), r("voyado:messages:received", {
        emailsReceived: c.count ?? 0,
        smsReceived: m.count ?? 0,
        postalReceived: u.count ?? 0,
        total: f.count ?? 0
      });
    }
  }, [l?.Voyado, o]), {
    isLoading: o,
    error: s,
    lastMessages: i
  };
}, QK = {
  count: 0,
  totalCount: 0,
  items: []
}, XK = ({
  contactId: e
}) => {
  const { useQuery: n } = hn(), { track: r } = jn(), [i, a] = pe(
    QK
  ), {
    loading: o,
    error: s,
    data: l
  } = n(BK, {
    skip: !e,
    variables: { contactId: e, count: 5 }
  });
  return Qe(() => {
    const c = l?.Voyado?.Transactions_GetTransactionsWithArticlesByContactId;
    if (!o && c) {
      a(
        c
      );
      const { count: m } = c;
      m && r("voyado:transactions:received", { count: m });
    }
  }, [l?.Voyado, o]), {
    isLoading: o,
    error: s,
    transactions: i
  };
}, ZK = ({
  conversationContext: e
}) => {
  const { useQuery: n } = hn(), [r, i] = pe(void 0), [a, o] = pe(!1), { customer: s } = e, l = !!s?.email || !!s?.phone_number, {
    loading: c,
    error: m,
    data: u,
    refetch: f
  } = n(UK, {
    skip: !l,
    variables: {
      email: s?.email ?? "",
      mobilePhone: s?.phone_number ?? ""
    }
  });
  return Qe(() => {
    const h = u?.Voyado?.ContactOverview_GetContactIdAsync;
    h?.__typename === "Voyado_ApiExceptionMultipleMatchesResponse" && h?.messageDetails?.multipleMatchesFound && h?.messageDetails?.multipleMatchesFound.length > 0 && (o(!0), i(void 0)), h?.__typename === "Voyado_String_container" && h?.String && (o(!1), i(h.String));
  }, [u?.Voyado, c]), {
    isLoading: c,
    contactId: r,
    hasMultipleContacts: a,
    error: m,
    refetch: f
  };
}, eG = ({
  contactId: e,
  skip: n
}) => {
  const { useQuery: r } = hn(), [i, a] = pe(
    void 0
  ), {
    loading: o,
    error: s,
    data: l,
    refetch: c
  } = r(zK, {
    skip: !e || n,
    variables: { contactId: e }
  });
  return Qe(() => {
    const m = l?.Voyado?.ContactOverview_GetContactOverviewAsync;
    if (!o && m && Object.hasOwn(m, "memberlevel")) {
      const u = m?.memberlevel;
      a({
        levelName: u?.levelName,
        remainingToUpgrade: u?.remainingToUpgrade,
        basedOnRewardPoints: u?.basedOnRewardPoints,
        levelId: u?.levelId,
        latestChange: u?.latestChange,
        expires: u?.expires
      });
    } else
      a(void 0);
  }, [l?.Voyado, o]), Xn(
    () => ({
      isLoading: o,
      error: s,
      memberLevel: i,
      refetch: c
    }),
    [o, s, i, c]
  );
}, nG = "_pointer_pn2q5_54", tG = "_list_pn2q5_59", rG = "_listItem_pn2q5_69", pt = {
  pointer: nG,
  list: tG,
  listItem: rG
}, iG = "_modalBody_1clhs_1", aG = {
  modalBody: iG
}, oG = ({
  isOpen: e,
  onClose: n,
  pointsAccount: r,
  setHasPointsBeenUpdated: i,
  refetchPointsQuery: a
}) => {
  const { useMutation: o, showNotification: s } = hn(), { track: l } = jn(), c = r?.id, m = r?.balance ?? 0, u = {
    balance: m?.toString() ?? "0",
    description: "",
    transactionType: null
  }, { control: f, setValue: h, reset: k } = ut({
    defaultValues: u,
    mode: "onChange"
  }), w = gi({ control: f }), N = parseInt(w?.balance ?? "0", 10), j = m === N, _ = j ? "Change the value to update the points" : "", g = N < 0, O = g ? "Points can not be negative" : "", R = w.description === "", F = R ? "Description can not be empty" : "";
  Qe(() => {
    N > m ? h(
      "transactionType",
      jy.Addition
    ) : N < m && h(
      "transactionType",
      jy.Deduction
    );
  }, [m, N, h]);
  const [I, { loading: L, error: W, reset: J }] = o(KK, {
    onCompleted: () => {
      s({
        title: "Success",
        text: "Points updated successfully",
        icon: "check-circle-filled",
        severity: "success"
      });
    }
  }), re = () => {
    if (c) {
      const Y = NK();
      I({
        variables: {
          input: {
            accountId: c,
            transactionId: Y,
            amount: Math.abs(N - m),
            transactionType: w.transactionType,
            description: w.description,
            source: QF.UpdateBalance
          }
        }
      }).then(async (P) => {
        P?.errors ? l("voyado:update:points:failed") : (l("voyado:update:points:succeeded"), i(!0), await a(), K());
      }).catch(() => {
        l("voyado:update:points:failed");
      });
    }
  }, K = () => {
    k(u), J(), n();
  };
  return /* @__PURE__ */ D.jsxs(
    bt,
    {
      isOpen: e,
      onClose: K,
      "data-testid": "change-points-modal",
      children: [
        /* @__PURE__ */ D.jsx(_t, { title: "Update points balance", onClose: K }),
        /* @__PURE__ */ D.jsxs(xt, { className: aG.modalBody, children: [
          /* @__PURE__ */ D.jsxs(et, { children: [
            /* @__PURE__ */ D.jsx(X, { span: 6, children: /* @__PURE__ */ D.jsx(
              Nt,
              {
                name: "balance",
                control: f,
                render: ({ field: Y }) => /* @__PURE__ */ D.jsx(
                  Wr,
                  {
                    label: "New points balance",
                    type: "number",
                    placeholder: "Insert new points",
                    min: 0,
                    max: 1e5,
                    meta: {
                      warning: _ || O
                    },
                    input: {
                      ...Y,
                      value: Y.value.toString(),
                      onChange: (P) => Y.onChange(P)
                    }
                  }
                )
              }
            ) }),
            /* @__PURE__ */ D.jsx(X, { span: 6, children: /* @__PURE__ */ D.jsx(
              Nt,
              {
                name: "description",
                control: f,
                render: ({ field: Y }) => /* @__PURE__ */ D.jsx(
                  Wr,
                  {
                    required: !0,
                    label: "Description",
                    placeholder: "Insert a description",
                    input: Y,
                    meta: {
                      warning: F
                    }
                  }
                )
              }
            ) })
          ] }),
          W && /* @__PURE__ */ D.jsx($n, { error: W })
        ] }),
        /* @__PURE__ */ D.jsx(
          wt,
          {
            confirmName: "Save",
            confirmOnClick: () => re(),
            confirmProps: {
              isLoading: L,
              disabled: j || g || R,
              loadingIndicator: /* @__PURE__ */ D.jsx(mn, { size: 16 })
            },
            cancelOnClick: K
          }
        )
      ]
    }
  );
}, sG = "_wrapper_1ge6c_1", lG = "_block_1ge6c_12", mw = {
  wrapper: sG,
  block: lG
}, dG = ({
  contactAttributes: e,
  contactId: n
}) => {
  const { useQuery: r } = hn(), { isCopied: i, copy: a } = cl(), { isCopied: o, copy: s } = cl(), { isCopied: l, copy: c } = cl(), [m, u] = pe(!1), [f, h] = pe(), [k, w] = pe(!1), {
    loading: N,
    data: j,
    refetch: _
  } = r(HK, {
    variables: {
      contactId: n
    },
    skip: !n
  });
  Qe(() => {
    if (j) {
      const ie = j?.Voyado?.PointAccountV_GetPointAccounts;
      ie && ie?.length > 0 && h(ie[0]);
    }
  }, [j]);
  const g = !!f?.id, O = f?.balance ?? 0;
  if (!e)
    return null;
  const {
    firstName: R,
    lastName: F,
    street: I,
    zipCode: L,
    city: W,
    country: J,
    isRegistrationCompleted: re,
    email: K,
    mobilePhone: Y
  } = e, P = 14, B = `${R || ""} ${F || ""}`.trim() || "Anonymous";
  return /* @__PURE__ */ D.jsxs(b, { flexDirection: "column", className: mw.wrapper, children: [
    /* @__PURE__ */ D.jsxs(
      b,
      {
        justifyContent: "space-between",
        className: mw.block,
        alignItems: "center",
        children: [
          /* @__PURE__ */ D.jsx($.Heading, { variant: "heading-2", children: B }),
          N && /* @__PURE__ */ D.jsx(mn, { size: 12 }),
          g && !N && /* @__PURE__ */ D.jsxs(b, { gap: "100", alignItems: "center", children: [
            /* @__PURE__ */ D.jsxs(Pn, { size: "small", variant: "warning", children: [
              O,
              " points"
            ] }),
            /* @__PURE__ */ D.jsx(Xe, { content: "Update points balance", children: /* @__PURE__ */ D.jsx(
              he,
              {
                name: "pen",
                size: 12,
                onClick: () => u(!0),
                className: pt.pointer
              }
            ) }),
            k && /* @__PURE__ */ D.jsx(Xe, { content: "It might take a while until the updated points are available. Please refresh the integration by collapsing and expanding the widget in the sidebar.", children: /* @__PURE__ */ D.jsx(
              he,
              {
                name: "info",
                size: 12,
                className: pt.pointer
              }
            ) })
          ] })
        ]
      }
    ),
    (I || W || L || J || Y || K) && /* @__PURE__ */ D.jsxs(b, { gap: "200", flexDirection: "column", children: [
      Y && /* @__PURE__ */ D.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ D.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ D.jsx(he, { size: P, name: "phone" }),
          /* @__PURE__ */ D.jsx($.Paragraph, { variant: "4", children: Y })
        ] }),
        /* @__PURE__ */ D.jsx(
          he,
          {
            size: P,
            name: o ? "done" : "copy",
            onClick: () => s(Y),
            className: pt.pointer
          }
        )
      ] }),
      K && /* @__PURE__ */ D.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ D.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ D.jsx(he, { size: P, name: "mail" }),
          /* @__PURE__ */ D.jsx($.Paragraph, { variant: "4", children: K })
        ] }),
        /* @__PURE__ */ D.jsx(
          he,
          {
            size: P,
            name: i ? "done" : "copy",
            onClick: () => a(K),
            className: pt.pointer
          }
        )
      ] }),
      (I || W || L || J) && /* @__PURE__ */ D.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ D.jsxs(b, { gap: "200", children: [
          /* @__PURE__ */ D.jsx(he, { size: P, name: "home" }),
          /* @__PURE__ */ D.jsxs($.Paragraph, { variant: "4", color: "secondary", children: [
            /* @__PURE__ */ D.jsx(lt, { children: I }),
            /* @__PURE__ */ D.jsxs(lt, { children: [
              L,
              " ",
              W
            ] }),
            /* @__PURE__ */ D.jsx(lt, { children: J })
          ] })
        ] }),
        /* @__PURE__ */ D.jsx(
          he,
          {
            size: P,
            name: l ? "done" : "copy",
            onClick: () => c(`${I}, ${L} ${W}, ${J}`),
            className: pt.pointer
          }
        )
      ] }),
      /* @__PURE__ */ D.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ D.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ D.jsx(he, { size: P, name: "sign-in" }),
          /* @__PURE__ */ D.jsx($.Paragraph, { variant: "4", children: "Is registration completed" })
        ] }),
        /* @__PURE__ */ D.jsx(
          he,
          {
            name: re ? "check-circle-filled" : "close-circle-filled",
            color: re ? "green.500" : "neutral.500"
          }
        )
      ] })
    ] }),
    g && /* @__PURE__ */ D.jsx(
      oG,
      {
        isOpen: m,
        pointsAccount: f,
        onClose: () => u(!1),
        setHasPointsBeenUpdated: w,
        refetchPointsQuery: _
      }
    )
  ] });
}, cG = "_list_yud4a_7", uG = "_listItem_yud4a_11", mG = "_listItemTooltip_yud4a_15", pG = "_listItemTimestamp_yud4a_18", Hs = {
  list: cG,
  listItem: uG,
  listItemTooltip: mG,
  listItemTimestamp: pG
}, fG = ({
  contactConsents: e
}) => !e || e.length === 0 ? null : /* @__PURE__ */ D.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ D.jsx($.Heading, { variant: "heading-3", children: "Consents" }),
  /* @__PURE__ */ D.jsx(Ye, { className: Hs.list, children: e.map((n, r) => /* @__PURE__ */ D.jsx(Ye.Text, { variant: "dense", className: Hs.listItem, children: /* @__PURE__ */ D.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
    /* @__PURE__ */ D.jsx(Xe, { content: n?.comment, children: /* @__PURE__ */ D.jsxs(
      b,
      {
        gap: "200",
        alignItems: "center",
        className: ct({
          [Hs.listItemTooltip]: n?.comment
        }),
        children: [
          /* @__PURE__ */ D.jsx($.Paragraph, { variant: "4", children: n.id }),
          /* @__PURE__ */ D.jsx($.Paragraph, { className: Hs.listItemTimestamp, children: Gn(n.date).format($t) }),
          n?.comment && /* @__PURE__ */ D.jsx(he, { name: "info", color: "neutral.400" })
        ]
      }
    ) }),
    /* @__PURE__ */ D.jsx(
      he,
      {
        name: n.value ? "check-circle-filled" : "close-circle-filled",
        color: n.value ? "green.500" : "red.500"
      }
    )
  ] }) }, r)) })
] }), hG = ({
  memberLevel: e
}) => {
  const n = e?.levelName ?? null, r = e?.remainingToUpgrade ?? null, i = e?.basedOnRewardPoints ?? null, a = e?.latestChange ? Gn(e.latestChange).format($t) : null, o = e?.expires ? `${Gn(e.expires).fromNow()} (${Gn(e.expires).format($t)})` : null, s = !n && !a && !r && !i && !o;
  return /* @__PURE__ */ D.jsx(b, { gap: "200", flexDirection: "column", children: /* @__PURE__ */ D.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ D.jsxs(b, { alignItems: "center", gap: "100", children: [
      /* @__PURE__ */ D.jsx($.Heading, { variant: "heading-3", children: "Member level" }),
      /* @__PURE__ */ D.jsx(Xe, { content: "Voyado updates the member level data in a nightly batch process", children: /* @__PURE__ */ D.jsx(
        he,
        {
          name: "question",
          size: 14,
          className: pt.pointer
        }
      ) })
    ] }),
    /* @__PURE__ */ D.jsx(b, { flexDirection: "column", children: /* @__PURE__ */ D.jsxs(Ye, { className: pt.list, children: [
      s && /* @__PURE__ */ D.jsx(Ye.Text, { variant: "dense", className: pt.listItem, children: /* @__PURE__ */ D.jsx($.Paragraph, { variant: "4", color: "secondary", children: "No member level properties found" }) }),
      n && /* @__PURE__ */ D.jsx(Ye.Text, { variant: "dense", className: pt.listItem, children: /* @__PURE__ */ D.jsx(Xe, { content: "", children: /* @__PURE__ */ D.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ D.jsx($.Paragraph, { variant: "4", children: "Level" }),
        /* @__PURE__ */ D.jsx(Pn, { variant: "info", size: "small", children: e?.levelName ?? "" })
      ] }) }) }),
      i && /* @__PURE__ */ D.jsx(Ye.Text, { variant: "dense", className: pt.listItem, children: /* @__PURE__ */ D.jsx(Xe, { content: "Voyado updates the member level data once a day in a nightly job", children: /* @__PURE__ */ D.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ D.jsx($.Paragraph, { variant: "4", children: "Based on reward points" }),
        /* @__PURE__ */ D.jsx(Pn, { variant: "success", size: "small", children: i })
      ] }) }) }),
      r && /* @__PURE__ */ D.jsx(Ye.Text, { variant: "dense", className: pt.listItem, children: /* @__PURE__ */ D.jsx(Xe, { content: "", children: /* @__PURE__ */ D.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ D.jsx($.Paragraph, { variant: "4", children: "Remaining to upgrade" }),
        /* @__PURE__ */ D.jsx(Pn, { variant: "success", size: "small", children: r })
      ] }) }) }),
      a && /* @__PURE__ */ D.jsx(Ye.Text, { variant: "dense", className: pt.listItem, children: /* @__PURE__ */ D.jsx(Xe, { content: "", children: /* @__PURE__ */ D.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ D.jsx($.Paragraph, { variant: "4", children: "Latest change" }),
        /* @__PURE__ */ D.jsx($.Paragraph, { variant: "5", color: "secondary", children: a })
      ] }) }) }),
      o && /* @__PURE__ */ D.jsx(Ye.Text, { variant: "dense", className: pt.listItem, children: /* @__PURE__ */ D.jsx(Xe, { content: "", children: /* @__PURE__ */ D.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ D.jsx($.Paragraph, { variant: "4", children: "Expires" }),
        /* @__PURE__ */ D.jsx($.Paragraph, { variant: "5", color: "secondary", children: o })
      ] }) }) })
    ] }) })
  ] }) });
}, yG = "_tagHover_kzbzk_1", gG = "_channelUnsubscribed_kzbzk_6", pw = {
  tagHover: yG,
  channelUnsubscribed: gG
}, Vh = ({
  isSubscribed: e,
  channelName: n,
  channelIcon: r,
  contactId: i,
  contactPreferences: a,
  refetchContact: o
}) => {
  const { track: s } = jn(), { useMutation: l } = hn(), [c, m] = pe(!1), [u, { loading: f }] = l(WK), h = async ({
    newPreference: w,
    isSubscribed: N,
    channelType: j
  }) => {
    m(!0), (await u({
      variables: {
        contactId: i,
        input: {
          preferences: {
            ...a,
            ...w
          }
        }
      }
    }))?.data?.Voyado.ContactsV_ContactPatch?.id ? N ? s("voyado:channel:unsubscribe:succeeded", { channel: j }) : s("voyado:channel:subscribe:succeeded", { channel: j }) : N ? s("voyado:channel:unsubscribe:failed", { channel: j }) : s("voyado:channel:subscribe:failed", { channel: j }), setTimeout(async () => {
      await o().finally(() => m(!1));
    }, 1e3);
  }, k = c || f;
  return /* @__PURE__ */ D.jsx(Xe, { content: e ? "Unsubscribe" : "Subscribe", children: /* @__PURE__ */ D.jsx(
    Jn,
    {
      className: pw.tagHover,
      color: e ? "green.500" : "neutral.200",
      children: /* @__PURE__ */ D.jsxs(
        b,
        {
          "data-testid": `widget-preference-${e ? "subscribed" : "unsubscribed"}`,
          gap: "200",
          alignItems: "center",
          className: ct({
            [pw.channelUnsubscribed]: !e
          }),
          onClick: () => {
            e ? s("voyado:channel:unsubscribe:clicked", {
              channel: n.toUpperCase()
            }) : s("voyado:channel:subscribe:clicked", {
              channel: n.toUpperCase()
            }), h({
              newPreference: { [`accepts${n}`]: !e },
              isSubscribed: e,
              channelType: n.toUpperCase()
            });
          },
          children: [
            k ? /* @__PURE__ */ D.jsx(mn, { size: 16 }) : /* @__PURE__ */ D.jsx(he, { size: 16, name: r }),
            n
          ]
        }
      )
    }
  ) });
}, vG = ({
  contactPreferences: e,
  contactId: n,
  refetchContact: r
}) => {
  if (!e || !n)
    return null;
  const { acceptsEmail: i, acceptsPostal: a, acceptsSms: o } = e;
  return /* @__PURE__ */ D.jsx(b, { gap: "200", flexDirection: "column", children: /* @__PURE__ */ D.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ D.jsx($.Heading, { variant: "heading-3", children: "Subscriptions" }),
    /* @__PURE__ */ D.jsxs(b, { gap: "100", flexDirection: "row", children: [
      /* @__PURE__ */ D.jsx(
        Vh,
        {
          channelName: "Email",
          channelIcon: "mail",
          isSubscribed: i,
          contactId: n,
          contactPreferences: e,
          refetchContact: r
        }
      ),
      /* @__PURE__ */ D.jsx(
        Vh,
        {
          channelName: "Sms",
          channelIcon: "sms",
          isSubscribed: o,
          contactId: n,
          contactPreferences: e,
          refetchContact: r
        }
      ),
      /* @__PURE__ */ D.jsx(
        Vh,
        {
          channelName: "Postal",
          channelIcon: "paper-plane",
          isSubscribed: a,
          contactId: n,
          contactPreferences: e,
          refetchContact: r
        }
      )
    ] })
  ] }) });
}, kG = ({
  contactId: e,
  settings: n
}) => {
  const {
    showCustomerAttributes: r,
    showPreferences: i,
    showAudiences: a,
    showConsents: o,
    showMemberLevel: s
  } = n, {
    isLoading: l,
    error: c,
    refetch: m,
    attributes: u,
    preferences: f,
    consents: h
  } = GK({ contactId: e }), {
    isLoading: k,
    error: w,
    memberLevel: N
  } = eG({ contactId: e, skip: !s }), j = k || l, _ = Xn(
    () => h?.filter(
      (g) => g !== null
    ),
    [h]
  );
  return c || w ? Ca({
    errors: c?.graphQLErrors || w?.graphQLErrors || []
  }) ? /* @__PURE__ */ D.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ D.jsx($.Paragraph, { color: "secondary", children: "No contact informations found" }) }) : /* @__PURE__ */ D.jsx($n, { error: c || w }) : !r && !i && !a && !o && !s ? /* @__PURE__ */ D.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ D.jsx($.Paragraph, { color: "secondary", children: "All contact related features in the settings are disabled." }) }) : j ? /* @__PURE__ */ D.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ D.jsx(mn, {}) }) : /* @__PURE__ */ D.jsxs(D.Fragment, { children: [
    r && /* @__PURE__ */ D.jsx(
      dG,
      {
        contactAttributes: u,
        contactId: e
      }
    ),
    s && /* @__PURE__ */ D.jsx(hG, { memberLevel: N }),
    i && /* @__PURE__ */ D.jsx(
      vG,
      {
        refetchContact: m,
        contactPreferences: f,
        contactId: e
      }
    ),
    o && /* @__PURE__ */ D.jsx(fG, { contactConsents: _ })
  ] });
}, wy = (e, n) => `${e ? e.toFixed(2) : "0.00"} ${n}`, bG = "_list_zu4s7_1", _G = "_listItem_zu4s7_4", xG = "_listSum_zu4s7_7", Ws = {
  list: bG,
  listItem: _G,
  listSum: xG
}, SG = ({
  lineItems: e,
  localCurrency: n,
  localNetPriceSum: r
}) => /* @__PURE__ */ D.jsxs(Ye, { className: Ws.list, children: [
  e?.map(({ quantity: i, article: a, localPrice: o, type: s }, l) => /* @__PURE__ */ D.jsx(Ye.Text, { variant: "dense", className: Ws.listItem, children: /* @__PURE__ */ D.jsx(Xe, { content: s, children: /* @__PURE__ */ D.jsxs(b, { justifyContent: "space-between", gap: "200", children: [
    /* @__PURE__ */ D.jsxs(b, { flex: "0 0 auto", gap: "200", children: [
      /* @__PURE__ */ D.jsx($.Paragraph, { variant: "4", children: i }),
      /* @__PURE__ */ D.jsx($.Paragraph, { variant: "4", children: "×" })
    ] }),
    /* @__PURE__ */ D.jsx(b, { flex: "auto", children: /* @__PURE__ */ D.jsx($.Paragraph, { variant: "4", children: a?.name }) }),
    o && n && /* @__PURE__ */ D.jsx(b, { flex: "0 0 auto", gap: "100", children: /* @__PURE__ */ D.jsx($.Paragraph, { variant: "4", children: wy(o, n) }) })
  ] }) }) }, l)),
  /* @__PURE__ */ D.jsx(
    Ye.Text,
    {
      variant: "dense",
      className: ct(Ws.listItem, Ws.listSum),
      children: /* @__PURE__ */ D.jsxs(b, { gap: "100", justifyContent: "space-between", children: [
        /* @__PURE__ */ D.jsx($.Paragraph, { variant: "3", children: "Sum" }),
        /* @__PURE__ */ D.jsx($.Paragraph, { variant: "3", children: wy(r, n) })
      ] })
    },
    "theSumOfItAll"
  )
] }), NG = "_transaction_1kr8d_1", jG = "_transactionIsOpen_1kr8d_9", wG = "_transactionHeader_1kr8d_12", CG = "_transactionHeaderSubLine_1kr8d_15", FG = "_transactionHeaderAlignItemRight_1kr8d_19", ca = {
  transaction: NG,
  transactionIsOpen: jG,
  transactionHeader: wG,
  transactionHeaderSubLine: CG,
  transactionHeaderAlignItemRight: FG
}, IG = ({
  transaction: e,
  openByDefault: n
}) => {
  const [r, i] = pe(n), {
    transactionNumber: a,
    createdDate: o,
    storeName: s,
    numberOfItems: l,
    storeType: c,
    lineItems: m,
    localCurrency: u,
    localNetPriceSum: f
  } = e, h = u ?? "", k = f ?? 0, w = m?.length ? m : [];
  return /* @__PURE__ */ D.jsxs(
    b,
    {
      className: ct(ca.transaction, {
        [ca.transactionIsOpen]: r
      }),
      gap: "300",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ D.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: ca.transactionHeader,
            onClick: () => i(!r),
            "data-testid": "contact-transaction-header",
            children: [
              /* @__PURE__ */ D.jsxs(b, { style: { flexGrow: 1 }, children: [
                /* @__PURE__ */ D.jsxs(b, { flexDirection: "column", gap: "100", children: [
                  o && /* @__PURE__ */ D.jsx(Pn, { size: "small", variant: "info", children: Gn(o).format($t) }),
                  /* @__PURE__ */ D.jsxs(
                    $.Heading,
                    {
                      variant: "heading-4",
                      className: ca.transactionHeaderSubLine,
                      children: [
                        "ID: ",
                        a
                      ]
                    }
                  )
                ] }),
                /* @__PURE__ */ D.jsxs(
                  b,
                  {
                    flexDirection: "column",
                    gap: "100",
                    className: ca.transactionHeaderAlignItemRight,
                    children: [
                      /* @__PURE__ */ D.jsx($.Heading, { variant: "heading-4", children: wy(k, h) }),
                      /* @__PURE__ */ D.jsxs(
                        $.Heading,
                        {
                          variant: "heading-4",
                          className: ca.transactionHeaderSubLine,
                          children: [
                            l,
                            " line ",
                            `${l === 1 ? "item" : "items"}`
                          ]
                        }
                      )
                    ]
                  }
                )
              ] }),
              /* @__PURE__ */ D.jsx(b, { flexDirection: "column", children: /* @__PURE__ */ D.jsx(
                Qt,
                {
                  variant: "tertiary",
                  icon: r ? "angle-up" : "angle-down"
                }
              ) })
            ]
          }
        ),
        r && /* @__PURE__ */ D.jsxs(
          b,
          {
            gap: "300",
            flexDirection: "column",
            "data-testid": "contact-transaction-content",
            children: [
              /* @__PURE__ */ D.jsx(Wl, {}),
              /* @__PURE__ */ D.jsxs(b, { gap: "100", flexDirection: "column", children: [
                s && /* @__PURE__ */ D.jsx($.Heading, { variant: "heading-2", children: s }),
                c && /* @__PURE__ */ D.jsx(Jn, { children: /* @__PURE__ */ D.jsx(b, { alignItems: "center", children: c }) }),
                /* @__PURE__ */ D.jsx(
                  SG,
                  {
                    lineItems: w,
                    localCurrency: h,
                    localNetPriceSum: k
                  }
                )
              ] })
            ]
          }
        )
      ]
    }
  );
}, $G = ({
  contactId: e
}) => {
  const {
    isLoading: n,
    error: r,
    transactions: i
  } = XK({ contactId: e });
  if (!e)
    return null;
  const { items: a, totalCount: o } = i, s = o ?? 0;
  return r ? /* @__PURE__ */ D.jsx($n, { error: r }) : /* @__PURE__ */ D.jsxs(
    b,
    {
      gap: "200",
      flexDirection: "column",
      "data-testid": "contact-transactions-wrapper",
      children: [
        /* @__PURE__ */ D.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
          /* @__PURE__ */ D.jsx($.Heading, { variant: "heading-3", children: "Transactions" }),
          !n && s > 0 && /* @__PURE__ */ D.jsx(Pn, { size: "small", variant: "success", children: s })
        ] }),
        n ? /* @__PURE__ */ D.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ D.jsx(mn, {}) }) : /* @__PURE__ */ D.jsxs(D.Fragment, { children: [
          s === 0 && /* @__PURE__ */ D.jsx(b, { justifyContent: "center", padding: "200", children: /* @__PURE__ */ D.jsx($.Paragraph, { variant: "4", color: "secondary", children: "There are no transactions for this contact" }) }),
          s > 0 && a?.map((l, c) => /* @__PURE__ */ D.jsx(
            IG,
            {
              transaction: l,
              openByDefault: c === 0
            },
            c
          ))
        ] })
      ]
    }
  );
}, EG = "_message_4z55u_54", TG = "_messageIsOpen_4z55u_62", RG = "_messageHeader_4z55u_66", DG = "_messageText_4z55u_70", OG = "_buttonLink_4z55u_93", No = {
  message: EG,
  messageIsOpen: TG,
  messageHeader: RG,
  messageText: DG,
  buttonLink: OG
}, zh = {
  status: {
    Delivered: "check-circle",
    Waiting: "clock",
    Hardbounce: "close-circle-filled",
    Softbounce: "close"
  },
  type: {
    EmailMessage: "mail",
    SmsMessage: "sms",
    PostalMessage: "paper-plane"
  },
  source: {
    Automation: "chat-bot",
    Manual: "user",
    System: "eye"
  }
}, Uh = (e, n) => n && e in zh && n in zh[e] ? zh[e][n] : null, PG = ({
  message: e,
  openByDefault: n
}) => {
  const [r, i] = pe(n), { track: a } = jn();
  if (!e)
    return null;
  const {
    name: o,
    sendDateTime: s,
    type: l,
    source: c,
    isTransactional: m,
    status: u,
    messageLink: f,
    messageText: h
  } = e, k = l ? Uh("type", l) : null, w = c ? Uh("source", c) : null, N = u ? Uh("status", u) : null, j = l?.replace("Message", "");
  return /* @__PURE__ */ D.jsxs(
    b,
    {
      className: ct(No.message, {
        [No.messageIsOpen]: r
      }),
      gap: "300",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ D.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: No.messageHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ D.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ D.jsxs(b, { gap: "200", alignItems: "center", children: [
                  k && /* @__PURE__ */ D.jsxs(D.Fragment, { children: [
                    /* @__PURE__ */ D.jsx(he, { name: k, size: 16 }),
                    " ",
                    j
                  ] }),
                  s && /* @__PURE__ */ D.jsx(Pn, { size: "small", variant: "info", children: Gn(s).format($t) })
                ] }),
                o
              ] }),
              /* @__PURE__ */ D.jsx(
                Qt,
                {
                  variant: "tertiary",
                  icon: r ? "angle-up" : "angle-down"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ D.jsxs(b, { gap: "300", flexDirection: "column", children: [
          /* @__PURE__ */ D.jsx(Wl, {}),
          /* @__PURE__ */ D.jsxs(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [
            N && /* @__PURE__ */ D.jsx(Jn, { children: /* @__PURE__ */ D.jsxs(b, { alignItems: "center", gap: "200", children: [
              /* @__PURE__ */ D.jsx(he, { name: N }),
              " ",
              u
            ] }) }),
            w && /* @__PURE__ */ D.jsx(Jn, { children: /* @__PURE__ */ D.jsxs(b, { alignItems: "center", gap: "200", children: [
              /* @__PURE__ */ D.jsx(he, { name: w }),
              " ",
              c
            ] }) }),
            m && /* @__PURE__ */ D.jsx(Jn, { children: /* @__PURE__ */ D.jsxs(b, { alignItems: "center", gap: "200", children: [
              /* @__PURE__ */ D.jsx(he, { name: "exchange" }),
              " Transactional"
            ] }) })
          ] }),
          /* @__PURE__ */ D.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ D.jsx($.Paragraph, { variant: "4", color: "secondary", children: "Message text" }),
            /* @__PURE__ */ D.jsx($.Paragraph, { variant: "4", className: No.messageText, children: h })
          ] }),
          f && /* @__PURE__ */ D.jsx(
            It,
            {
              slotEnd: /* @__PURE__ */ D.jsx(he, { name: "external-link" }),
              variant: "tertiary",
              className: No.buttonLink,
              navigate: () => {
                j && a("voyado:message:external-link:opened", {
                  channel: j.toUpperCase()
                }), window.open(f, "_blank")?.focus();
              },
              children: "Open message in new tab"
            }
          )
        ] })
      ]
    }
  );
}, AG = ({
  contactId: e
}) => {
  const {
    isLoading: n,
    error: r,
    lastMessages: i
  } = JK({ contactId: e });
  if (!e)
    return null;
  if (r)
    return /* @__PURE__ */ D.jsx($n, { error: r });
  const { count: a, items: o } = i, s = (a && a) ?? 0, l = s > 0;
  return /* @__PURE__ */ D.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ D.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ D.jsx($.Heading, { variant: "heading-3", children: "Last Messages" }),
      !n && l && /* @__PURE__ */ D.jsx(Pn, { variant: "success", size: "small", children: s })
    ] }),
    /* @__PURE__ */ D.jsx(b, { gap: "200", flexDirection: "column", children: n ? /* @__PURE__ */ D.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ D.jsx(mn, {}) }) : /* @__PURE__ */ D.jsxs(D.Fragment, { children: [
      l && o?.map((c, m) => /* @__PURE__ */ D.jsx(
        PG,
        {
          message: c || void 0,
          openByDefault: m === 0
        },
        m
      )),
      !l && /* @__PURE__ */ D.jsx(b, { justifyContent: "center", margin: "200", children: /* @__PURE__ */ D.jsx($.Paragraph, { variant: "4", color: "secondary", children: "No messages available" }) })
    ] }) })
  ] });
}, gd = ({
  value: e,
  currencyCode: n
}) => `${Number.parseFloat((e ?? 0).toString()).toFixed(2)} ${n ?? ""}`, fw = ({
  labelText: e,
  address: n,
  icon: r = "home"
}) => {
  const { isCopied: i, copy: a } = cl(), o = [n?.title, n?.firstname, n?.lastname].filter(Boolean).join(" "), s = ft(() => [
    o,
    n?.streetAddress,
    n?.streetAddress2,
    n?.postalCode,
    n?.region,
    n?.city,
    n?.country
  ].filter(Boolean).join(`
`), [n, o]);
  if (!n)
    return null;
  const l = 14;
  return /* @__PURE__ */ D.jsxs(b, { justifyContent: "space-between", children: [
    /* @__PURE__ */ D.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ D.jsx(he, { size: l, name: r, color: "green.500" }),
      /* @__PURE__ */ D.jsxs(b, { gap: "200", flexDirection: "column", children: [
        /* @__PURE__ */ D.jsx($.Paragraph, { variant: "3", children: e }),
        /* @__PURE__ */ D.jsxs(b, { gap: "100", flexDirection: "column", children: [
          o && /* @__PURE__ */ D.jsx($.Paragraph, { variant: "4", children: o }),
          n?.streetAddress && /* @__PURE__ */ D.jsx($.Paragraph, { variant: "4", children: n.streetAddress }),
          n?.streetAddress2 && /* @__PURE__ */ D.jsx($.Paragraph, { variant: "4", children: n.streetAddress2 }),
          n?.postalCode && /* @__PURE__ */ D.jsx($.Paragraph, { variant: "4", children: n?.postalCode }),
          n?.region && /* @__PURE__ */ D.jsx($.Paragraph, { variant: "4", children: n.region }),
          n?.city && /* @__PURE__ */ D.jsx($.Paragraph, { variant: "4", children: n.city }),
          n?.country && /* @__PURE__ */ D.jsx($.Paragraph, { variant: "4", children: n.country })
        ] })
      ] })
    ] }),
    /* @__PURE__ */ D.jsx(Xe, { content: `Copy ${e.toLowerCase()}`, children: /* @__PURE__ */ D.jsx(
      he,
      {
        size: l,
        name: i ? "done" : "copy",
        onClick: () => a(s()),
        className: pt.pointer
      }
    ) })
  ] });
}, LG = "_order_19t4p_1", VG = "_orderIsOpen_19t4p_9", zG = "_orderHeader_19t4p_12", UG = "_orderIconColor_19t4p_15", zr = {
  order: LG,
  orderIsOpen: VG,
  orderHeader: zG,
  orderIconColor: UG
}, MG = "_delivery_1m9nb_1", BG = "_deliveryCode_1m9nb_4", Mh = {
  delivery: MG,
  deliveryCode: BG
}, qG = ({
  delivery: e
}) => {
  const { isCopied: n, copy: r } = Jt();
  if (!e)
    return null;
  const { method: i, trackingNumber: a, trackingUri: o, deliveryDate: s } = e, l = 14;
  return /* @__PURE__ */ D.jsxs(b, { gap: "250", flexDirection: "row", children: [
    /* @__PURE__ */ D.jsx(
      he,
      {
        size: l,
        name: "eye",
        className: zr.orderIconColor
      }
    ),
    /* @__PURE__ */ D.jsxs(b, { flexDirection: "column", gap: "200", width: "100%", children: [
      /* @__PURE__ */ D.jsx($.Paragraph, { variant: "3", children: "Delivery" }),
      /* @__PURE__ */ D.jsx(
        Xe,
        {
          content: /* @__PURE__ */ D.jsxs($.Paragraph, { variant: "4", color: "inherit", children: [
            "Arrives: ",
            Gn(s).format($t)
          ] }),
          children: /* @__PURE__ */ D.jsxs(b, { gap: "100", flexDirection: "column", children: [
            o ? /* @__PURE__ */ D.jsx(
              $.ExternalLink,
              {
                href: o,
                target: "_blank",
                rel: "noreferrer",
                children: /* @__PURE__ */ D.jsxs(
                  b,
                  {
                    gap: "100",
                    alignItems: "center",
                    className: Mh.delivery,
                    children: [
                      /* @__PURE__ */ D.jsx(he, { name: "external-link", size: l }),
                      i
                    ]
                  }
                )
              }
            ) : i,
            /* @__PURE__ */ D.jsx(
              $.Paragraph,
              {
                variant: "4",
                className: ct(Mh.delivery, Mh.deliveryCode),
                children: a
              }
            )
          ] })
        }
      )
    ] }),
    a && /* @__PURE__ */ D.jsx(Xe, { content: "Copy tracking code", children: /* @__PURE__ */ D.jsx(
      he,
      {
        size: l,
        name: n ? "done" : "copy",
        onClick: () => r(a.toString()),
        className: pt.pointer
      }
    ) })
  ] });
}, HG = ({
  fees: e,
  currencyCode: n
}) => {
  if (!e)
    return null;
  const r = e?.items ?? [];
  return /* @__PURE__ */ D.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ D.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ D.jsx(
        he,
        {
          size: 14,
          name: "file-text",
          className: zr.orderIconColor
        }
      ),
      /* @__PURE__ */ D.jsx($.Paragraph, { variant: "3", children: "Fees" })
    ] }),
    /* @__PURE__ */ D.jsx(Ye, { className: pt.list, children: r?.map((i, a) => /* @__PURE__ */ D.jsx(Ye.Item, { className: pt.listItem, children: /* @__PURE__ */ D.jsxs(
      b,
      {
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
        children: [
          /* @__PURE__ */ D.jsxs(b, { flexDirection: "column", gap: "100", children: [
            /* @__PURE__ */ D.jsx($.Paragraph, { variant: "5", children: i?.type }),
            /* @__PURE__ */ D.jsx($.Paragraph, { variant: "4", children: i?.description })
          ] }),
          /* @__PURE__ */ D.jsx(b, { flexDirection: "column", gap: "100", children: i?.taxes?.items?.map((o, s) => /* @__PURE__ */ D.jsxs(
            b,
            {
              gap: "100",
              flexDirection: "column",
              className: pt.listItemAlignRight,
              children: [
                /* @__PURE__ */ D.jsx($.Paragraph, { variant: "5", children: `${o?.description} ${o?.percent}%` }),
                /* @__PURE__ */ D.jsx($.Paragraph, { variant: "4", children: gd({ value: o?.amount, currencyCode: n }) })
              ]
            },
            `tax-${s}`
          )) })
        ]
      }
    ) }, `fees-${a}`)) })
  ] });
}, WG = ({
  lineItems: e,
  currencyCode: n
}) => {
  if (!e)
    return null;
  const r = e?.items ?? [];
  return /* @__PURE__ */ D.jsxs(b, { gap: "100", flexDirection: "column", children: [
    /* @__PURE__ */ D.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ D.jsx(
        he,
        {
          size: 14,
          name: "tag",
          className: zr.orderIconColor
        }
      ),
      /* @__PURE__ */ D.jsx($.Paragraph, { variant: "3", children: "Line items" })
    ] }),
    /* @__PURE__ */ D.jsx(Ye, { className: pt.list, children: r?.map((i) => /* @__PURE__ */ D.jsx(
      Ye.Item,
      {
        className: pt.listItem,
        contentLeft: /* @__PURE__ */ D.jsxs(b, { gap: "200", children: [
          /* @__PURE__ */ D.jsx($.Paragraph, { variant: "4", children: i?.quantity }),
          /* @__PURE__ */ D.jsx($.Paragraph, { variant: "4", children: "×" })
        ] }),
        title: /* @__PURE__ */ D.jsx(
          Xe,
          {
            content: /* @__PURE__ */ D.jsx($.Paragraph, { variant: "3", color: "inherit", children: i?.article?.sku }),
            children: /* @__PURE__ */ D.jsxs(b, { gap: "100", flexDirection: "column", children: [
              /* @__PURE__ */ D.jsx($.Paragraph, { variant: "4", children: i?.article?.name }),
              /* @__PURE__ */ D.jsx(b, { children: /* @__PURE__ */ D.jsx(Pn, { size: "small", variant: "info", children: gd({
                value: i?.totalPrice,
                currencyCode: n
              }) }) })
            ] })
          }
        ),
        contentRight: i?.article?.imageUri && /* @__PURE__ */ D.jsx(
          Fa,
          {
            src: i?.article?.imageUri,
            alt: i?.article?.name,
            style: { height: "48px" }
          }
        )
      },
      `list-${i?.id}`
    )) })
  ] });
}, KG = ({
  payments: e,
  currencyCode: n
}) => {
  if (!e)
    return null;
  const r = e?.items ?? [];
  return /* @__PURE__ */ D.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ D.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ D.jsx(
        he,
        {
          size: 14,
          name: "credit-card",
          className: zr.orderIconColor
        }
      ),
      /* @__PURE__ */ D.jsx($.Paragraph, { variant: "3", children: "Payment methods" })
    ] }),
    /* @__PURE__ */ D.jsx(Ye, { className: pt.list, children: r?.map((i, a) => /* @__PURE__ */ D.jsx(
      Ye.Item,
      {
        className: pt.listItem,
        children: /* @__PURE__ */ D.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            children: [
              /* @__PURE__ */ D.jsxs(b, { flexDirection: "column", gap: "100", children: [
                /* @__PURE__ */ D.jsx($.Paragraph, { variant: "5", children: i?.description }),
                /* @__PURE__ */ D.jsx($.Paragraph, { variant: "4", children: i?.method })
              ] }),
              /* @__PURE__ */ D.jsxs(
                b,
                {
                  gap: "100",
                  flexDirection: "column",
                  className: pt.listItemAlignRight,
                  children: [
                    /* @__PURE__ */ D.jsx($.Paragraph, { variant: "5", children: Gn(i?.paidAt).format($t) }),
                    /* @__PURE__ */ D.jsx($.Paragraph, { variant: "4", children: gd({ value: i?.amount, currencyCode: n }) })
                  ]
                }
              )
            ]
          }
        )
      },
      `payments-${a}`
    )) })
  ] });
}, GG = ({
  order: e,
  openByDefault: n
}) => {
  const [r, i] = pe(n);
  if (!e)
    return null;
  const {
    orderId: a,
    status: o,
    externalStatus: s,
    currencyCode: l,
    channel: c,
    createdAt: m,
    lastChangedAt: u,
    lineItems: f,
    billingAddress: h,
    deliveryAddress: k,
    totalPrice: w
  } = e, N = 14;
  return /* @__PURE__ */ D.jsxs(
    b,
    {
      className: ct(zr.order, {
        [zr.orderIsOpen]: r
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ D.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: zr.orderHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ D.jsxs(b, { gap: "100", flexDirection: "column", children: [
                m && /* @__PURE__ */ D.jsx(b, { alignItems: "center", children: /* @__PURE__ */ D.jsx($.Paragraph, { variant: "4", children: Gn(m).format($t) }) }),
                /* @__PURE__ */ D.jsx($.Paragraph, { variant: "1", children: a })
              ] }),
              /* @__PURE__ */ D.jsx(
                Qt,
                {
                  variant: "tertiary",
                  icon: r ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ D.jsxs(b, { gap: "250", flexDirection: "column", margin: "200 0 0", children: [
          /* @__PURE__ */ D.jsxs(b, { gap: "250", children: [
            /* @__PURE__ */ D.jsx(
              he,
              {
                size: N,
                name: "activity",
                className: zr.orderIconColor
              }
            ),
            /* @__PURE__ */ D.jsxs(b, { flexDirection: "column", gap: "200", children: [
              /* @__PURE__ */ D.jsx($.Paragraph, { variant: "3", children: "Order status" }),
              /* @__PURE__ */ D.jsxs(b, { gap: "100", alignItems: "center", flexWrap: "wrap", children: [
                o && /* @__PURE__ */ D.jsx(Xe, { content: "Internal status", children: /* @__PURE__ */ D.jsx(Pn, { size: "small", variant: "info", children: /* @__PURE__ */ D.jsx(D.Fragment, { children: o }) }) }),
                s && /* @__PURE__ */ D.jsx(Xe, { content: "External status", children: /* @__PURE__ */ D.jsx(Pn, { size: "small", variant: "info", children: /* @__PURE__ */ D.jsx(D.Fragment, { children: s }) }) }),
                /* @__PURE__ */ D.jsx(Xe, { content: "Last updated at", children: /* @__PURE__ */ D.jsx($.Paragraph, { as: "span", variant: "5", children: Gn(u).format($t) }) })
              ] })
            ] })
          ] }),
          /* @__PURE__ */ D.jsxs(b, { gap: "250", children: [
            /* @__PURE__ */ D.jsx(
              he,
              {
                size: N,
                name: "chart-bar",
                className: zr.orderIconColor
              }
            ),
            /* @__PURE__ */ D.jsxs(b, { flexDirection: "column", gap: "200", children: [
              /* @__PURE__ */ D.jsx($.Paragraph, { variant: "3", children: "Order value" }),
              /* @__PURE__ */ D.jsx($.Paragraph, { variant: "4", children: gd({
                value: w,
                currencyCode: l
              }) })
            ] })
          ] }),
          c && /* @__PURE__ */ D.jsxs(b, { gap: "250", children: [
            /* @__PURE__ */ D.jsx(
              he,
              {
                size: N,
                name: "channels",
                className: zr.orderIconColor
              }
            ),
            /* @__PURE__ */ D.jsxs(b, { flexDirection: "column", gap: "200", children: [
              /* @__PURE__ */ D.jsx($.Paragraph, { variant: "3", children: "Channel" }),
              /* @__PURE__ */ D.jsx($.Paragraph, { variant: "4", children: /* @__PURE__ */ D.jsx(Pn, { size: "small", variant: "info", children: /* @__PURE__ */ D.jsx(D.Fragment, { children: c }) }) })
            ] })
          ] }),
          /* @__PURE__ */ D.jsx(fw, { labelText: "Billing address", address: h }),
          /* @__PURE__ */ D.jsx(
            fw,
            {
              icon: "map-pin",
              labelText: "Delivery address",
              address: k
            }
          ),
          /* @__PURE__ */ D.jsx(qG, { delivery: e.delivery }),
          /* @__PURE__ */ D.jsx(WG, { lineItems: f, currencyCode: l }),
          /* @__PURE__ */ D.jsx(HG, { fees: e.fees, currencyCode: l }),
          /* @__PURE__ */ D.jsx(
            KG,
            {
              payments: e.payments,
              currencyCode: l
            }
          )
        ] })
      ]
    }
  );
}, YG = ({
  error: e,
  itemCount: n,
  children: r
}) => e ? n === 0 || Ca({
  errors: e.graphQLErrors
}) ? /* @__PURE__ */ D.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ D.jsx($.Paragraph, { variant: "4", color: "secondary", children: "There are no orders for this contact" }) }) : /* @__PURE__ */ D.jsx($n, { error: e }) : /* @__PURE__ */ D.jsx(D.Fragment, { children: r }), JG = ({
  contactId: e
}) => {
  const { useQuery: n } = hn(), [r, i] = pe([]), { track: a } = jn(), {
    loading: o,
    error: s,
    data: l
  } = n(qK, {
    skip: !e,
    variables: {
      contactId: e
    }
  });
  return Qe(() => {
    if (l?.Voyado) {
      const c = l?.Voyado.Orders_GetAllByContact;
      if (!o && c?.items) {
        i(c.items);
        const { totalCount: m } = c;
        m && a("voyado:orders:received", { count: m });
      }
    }
  }, [l?.Voyado]), e ? /* @__PURE__ */ D.jsxs(b, { gap: "200", flexDirection: "column", margin: "200 0 300 0", children: [
    /* @__PURE__ */ D.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ D.jsx($.Heading, { variant: "heading-3", children: "Orders" }),
      r.length > 0 && /* @__PURE__ */ D.jsx(Pn, { size: "small", variant: "success", children: r.length })
    ] }),
    o ? /* @__PURE__ */ D.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ D.jsx(mn, {}) }) : /* @__PURE__ */ D.jsx(YG, { error: s, itemCount: r.length, children: r.map((c, m) => /* @__PURE__ */ D.jsx(
      GG,
      {
        order: c,
        openByDefault: m === 0
      },
      m
    )) })
  ] }) : null;
}, QG = ({
  conversationContext: e,
  settings: n
}) => {
  const { isLoading: r, contactId: i, hasMultipleContacts: a, error: o } = ZK({
    conversationContext: e
  }), s = !e?.customer?.email && !e?.customer?.phone_number, l = !!i, {
    showCustomerAttributes: c,
    showPreferences: m,
    showAudiences: u,
    showConsents: f,
    showLastMessages: h,
    showCustomerTransactions: k,
    showOrders: w
  } = n;
  return s ? /* @__PURE__ */ D.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "widget-no-contact-message",
      children: /* @__PURE__ */ D.jsx($.Paragraph, { variant: "4", color: "secondary", children: "No email nor phone number are available in this conversation to look up a profile." })
    }
  ) : a ? /* @__PURE__ */ D.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "multiple-contacts-found-message",
      children: /* @__PURE__ */ D.jsx($.Paragraph, { variant: "4", color: "secondary", children: "We found multiple profile IDs that match your email or phone number. To display customer informations, we need a unique profile id. Please make sure that the customers data is normalized." })
    }
  ) : o ? Ca({
    errors: o.graphQLErrors
  }) ? /* @__PURE__ */ D.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ D.jsx($.Paragraph, { variant: "4", color: "secondary", children: "No profile found" }) }) : /* @__PURE__ */ D.jsx($n, { error: o }) : !c && !m && !u && !f && !h && !k ? /* @__PURE__ */ D.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ D.jsx($.Paragraph, { variant: "4", color: "secondary", children: "All features toggles in the widget settings are disabled." }) }) : r ? /* @__PURE__ */ D.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ D.jsx(mn, {}) }) : /* @__PURE__ */ D.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        /* @__PURE__ */ D.jsx(kG, { contactId: i, settings: n }),
        h && /* @__PURE__ */ D.jsx(AG, { contactId: i }),
        k && /* @__PURE__ */ D.jsx($G, { contactId: i }),
        w && /* @__PURE__ */ D.jsx(JG, { contactId: i }),
        !l && /* @__PURE__ */ D.jsx(b, { justifyContent: "center", padding: "200", children: /* @__PURE__ */ D.jsx($.Paragraph, { variant: "4", color: "secondary", children: "No contact found." }) })
      ]
    }
  );
}, Vl = [
  {
    key: "voyadoApiKey",
    label: "API key",
    type: "string",
    secret: !0,
    defaultValue: ""
  },
  {
    key: "apiHostName",
    label: "API URL",
    type: "string",
    secret: !1,
    defaultValue: ""
  },
  {
    key: "showCustomerAttributes",
    label: "Show the customer attributes",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showPreferences",
    label: "Show preferences",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showAudiences",
    label: "Show audiences",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showConsents",
    label: "Show consents",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showLastMessages",
    label: "Show the last 5 messages",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showCustomerTransactions",
    label: "Show customer transactions",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showOrders",
    label: "Show orders by contact",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showMemberLevel",
    label: "Show member level",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  }
], Ar = ir(Vl), XG = {
  enabled: !1,
  name: "",
  voyadoApiKey: "",
  apiHostName: "",
  showCustomerAttributes: !0,
  showPreferences: !0,
  showAudiences: !0,
  showConsents: !0,
  showLastMessages: !0,
  showCustomerTransactions: !0,
  showOrders: !0,
  showMemberLevel: !0
}, ZG = ({
  integrationId: e,
  handleRedirect: n,
  showNotification: r,
  automationCouplingState: i,
  renderConditionsEditor: a
}) => {
  const o = !e, s = ut({
    mode: "onChange",
    defaultValues: XG
  }), {
    create: l,
    update: c,
    remove: m,
    isLoading: u,
    error: f,
    misconfigurationCause: h,
    setMisconfigurationCause: k
  } = mr({
    integrationId: e,
    integrationType: "VOYADO",
    handleRedirect: n,
    showNotification: r
  }), {
    isLoading: w,
    error: N,
    isWidgetUnknown: j,
    refetch: _,
    widgetConfiguration: g
  } = pr({
    integrationId: e,
    fieldDefinitions: Vl,
    form: s,
    onMisconfigured: k
  }), { renderConditions: O, setRenderConditions: R, renderConditionsForSubmit: F } = fr({
    integrationId: e,
    widgetConfiguration: g,
    renderConditionsEditor: a
  }), I = (W) => yr(W, {
    fieldDefinitions: Vl,
    isCreationMode: o,
    create: l,
    update: c,
    renderConditions: F
  }), L = s.watch("name");
  return /* @__PURE__ */ D.jsxs(
    hr,
    {
      form: s,
      integrationId: e,
      onValidSubmit: I,
      error: N ?? f,
      onRetry: N ? _ : void 0,
      isLoading: u || w,
      isWidgetUnknown: j,
      children: [
        h && /* @__PURE__ */ D.jsx(gr, { cause: h }),
        /* @__PURE__ */ D.jsxs(et, { children: [
          /* @__PURE__ */ D.jsx(X, { children: /* @__PURE__ */ D.jsx(He, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ D.jsx(
            yn,
            {
              name: "enabled",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ D.jsx(X, { span: 3, children: /* @__PURE__ */ D.jsx(
            On,
            {
              name: "name",
              label: "Widget name",
              control: s.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ D.jsx(X, { span: 3 }),
          /* @__PURE__ */ D.jsx(X, { span: 3, children: /* @__PURE__ */ D.jsx(
            $r,
            {
              name: "voyadoApiKey",
              label: Ar.voyadoApiKey,
              control: s.control,
              isCreationMode: o,
              rules: { required: "API key is required" },
              componentProps: {
                placeholder: "API key from Voyado",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ D.jsx(X, { span: 3 }),
          /* @__PURE__ */ D.jsx(X, { span: 3, children: /* @__PURE__ */ D.jsx(
            On,
            {
              name: "apiHostName",
              label: Ar.apiHostName,
              control: s.control,
              rules: { required: "API URL is required" },
              componentProps: {
                placeholder: "The URL of the Voyado API",
                autoComplete: "off",
                prefix: "https://"
              }
            }
          ) }),
          /* @__PURE__ */ D.jsx(X, { span: 3 }),
          /* @__PURE__ */ D.jsx(X, { span: 3, children: /* @__PURE__ */ D.jsx(He, { label: Ar.showCustomerAttributes, children: /* @__PURE__ */ D.jsx(
            yn,
            {
              name: "showCustomerAttributes",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ D.jsx(X, { span: 3 }),
          /* @__PURE__ */ D.jsx(X, { span: 3, children: /* @__PURE__ */ D.jsx(He, { label: Ar.showPreferences, children: /* @__PURE__ */ D.jsx(
            yn,
            {
              name: "showPreferences",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ D.jsx(X, { span: 3 }),
          /* @__PURE__ */ D.jsx(X, { span: 3, children: /* @__PURE__ */ D.jsx(He, { label: Ar.showAudiences, children: /* @__PURE__ */ D.jsx(
            yn,
            {
              name: "showAudiences",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ D.jsx(X, { span: 3 }),
          /* @__PURE__ */ D.jsx(X, { span: 3, children: /* @__PURE__ */ D.jsx(He, { label: Ar.showConsents, children: /* @__PURE__ */ D.jsx(
            yn,
            {
              name: "showConsents",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ D.jsx(X, { span: 3 }),
          /* @__PURE__ */ D.jsx(X, { span: 3, children: /* @__PURE__ */ D.jsx(He, { label: Ar.showLastMessages, children: /* @__PURE__ */ D.jsx(
            yn,
            {
              name: "showLastMessages",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ D.jsx(X, { span: 3 }),
          /* @__PURE__ */ D.jsx(X, { span: 3, children: /* @__PURE__ */ D.jsx(He, { label: Ar.showCustomerTransactions, children: /* @__PURE__ */ D.jsx(
            yn,
            {
              name: "showCustomerTransactions",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ D.jsx(X, { span: 3 }),
          /* @__PURE__ */ D.jsx(X, { span: 3, children: /* @__PURE__ */ D.jsx(He, { label: Ar.showOrders, children: /* @__PURE__ */ D.jsx(
            yn,
            {
              name: "showOrders",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ D.jsx(X, { span: 3 }),
          /* @__PURE__ */ D.jsx(X, { span: 3, children: /* @__PURE__ */ D.jsx(He, { label: Ar.showMemberLevel, children: /* @__PURE__ */ D.jsx(
            yn,
            {
              name: "showMemberLevel",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ D.jsx(X, { span: 3 }),
          a && O !== null && /* @__PURE__ */ D.jsx(X, { children: a({
            value: O,
            onChange: R,
            configurationKey: g?.id
          }) })
        ] }),
        /* @__PURE__ */ D.jsx(
          vr,
          {
            integrationType: "VOYADO",
            integrationId: e,
            widgetName: L,
            isCreationMode: o,
            isSubmitting: s.formState.isSubmitting,
            automationCouplingState: i,
            onConfirmDelete: () => m()
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode('@charset "UTF-8";._copyIcon_1pfts_54{cursor:pointer;color:var(--dixa-typography-color-secondary)}._list_1pfts_59{padding:0;overflow-y:auto;max-height:230px;background:linear-gradient(var(--dixa-color-neutral-000) 33%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),var(--dixa-color-neutral-000) 66%) 0 100%,radial-gradient(farthest-side at 50% 0,var(--dixa-color-neutral-200),rgba(0,0,0,0)),radial-gradient(farthest-side at 50% 100%,var(--dixa-color-neutral-200),rgba(0,0,0,0)) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-200),100% var(--dixa-size-spacer-200)}._listItem_1pfts_69{cursor:pointer;background-color:transparent;padding:var(--dixa-size-spacer-100);box-shadow:inset 0 calc(-1 * var(--dixa-size-border-100)) 0 var(--dixa-color-neutral-200)}._listItem_1pfts_69:last-child{box-shadow:none}._listItemHighlighted_1pfts_78{border-left:8px solid var(--dixa-color-orange-300)}._wrapper_1xucg_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._externalLink_1xucg_7{color:var(--dixa-typography-color-primary);font-size:var(--dixa-typography-size-200)}._settingsWrapper_1ycvy_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);margin-bottom:var(--dixa-size-spacer-300)}._settingsWrapperHeader_1ycvy_6{cursor:pointer;padding:var(--dixa-size-spacer-300)}._settingsWrapperContent_1ycvy_10{border-top:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);padding:var(--dixa-size-spacer-300);line-height:var(--dixa-typography-line-height-400)}._settingsWrapperContent_1ycvy_10 ol{margin-bottom:0}._settingsWrapperContentCode_1ycvy_18{background-color:var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-100);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);font-family:var(--dixa-typography-family-code);font-size:var(--dixa-typography-size-200)}._settingsWrapperContentCURL_1ycvy_26{overflow:auto;padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-300);font-family:var(--dixa-typography-family-code);color:var(--dixa-typography-color-secondary);background-color:var(--dixa-color-neutral-100);border-radius:var(--dixa-size-border-radius-100);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300)}')), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Bh = { exports: {} }, jo = {}, hw;
function e8() {
  if (hw) return jo;
  hw = 1;
  var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, c, m) {
    var u, f = {}, h = null, k = null;
    m !== void 0 && (h = "" + m), c.key !== void 0 && (h = "" + c.key), c.ref !== void 0 && (k = c.ref);
    for (u in c) i.call(c, u) && !o.hasOwnProperty(u) && (f[u] = c[u]);
    if (l && l.defaultProps) for (u in c = l.defaultProps, c) f[u] === void 0 && (f[u] = c[u]);
    return { $$typeof: n, type: l, key: h, ref: k, props: f, _owner: a.current };
  }
  return jo.Fragment = r, jo.jsx = s, jo.jsxs = s, jo;
}
var Ks = {}, yw;
function n8() {
  return yw || (yw = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), c = /* @__PURE__ */ Symbol.for("react.forward_ref"), m = /* @__PURE__ */ Symbol.for("react.suspense"), u = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), k = /* @__PURE__ */ Symbol.for("react.offscreen"), w = Symbol.iterator, N = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var d = w && t[w] || t[N];
      return typeof d == "function" ? d : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var d = arguments.length, p = new Array(d > 1 ? d - 1 : 0), y = 1; y < d; y++)
          p[y - 1] = arguments[y];
        O("error", t, p);
      }
    }
    function O(t, d, p) {
      {
        var y = _.ReactDebugCurrentFrame, C = y.getStackAddendum();
        C !== "" && (d += "%s", p = p.concat([C]));
        var T = p.map(function(S) {
          return String(S);
        });
        T.unshift("Warning: " + d), Function.prototype.apply.call(console[t], console, T);
      }
    }
    var R = !1, F = !1, I = !1, L = !1, W = !1, J;
    J = /* @__PURE__ */ Symbol.for("react.module.reference");
    function re(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || W || t === a || t === m || t === u || L || t === k || R || F || I || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === J || t.getModuleId !== void 0));
    }
    function K(t, d, p) {
      var y = t.displayName;
      if (y)
        return y;
      var C = d.displayName || d.name || "";
      return C !== "" ? p + "(" + C + ")" : p;
    }
    function Y(t) {
      return t.displayName || "Context";
    }
    function P(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var d = t;
            return Y(d) + ".Consumer";
          case s:
            var p = t;
            return Y(p._context) + ".Provider";
          case c:
            return K(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : P(t.type) || "Memo";
          case h: {
            var C = t, T = C._payload, S = C._init;
            try {
              return P(S(T));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, ie = 0, we, me, le, ge, V, be, Oe;
    function q() {
    }
    q.__reactDisabledLog = !0;
    function Ge() {
      {
        if (ie === 0) {
          we = console.log, me = console.info, le = console.warn, ge = console.error, V = console.group, be = console.groupCollapsed, Oe = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: q,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ie++;
      }
    }
    function sn() {
      {
        if (ie--, ie === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, t, {
              value: we
            }),
            info: B({}, t, {
              value: me
            }),
            warn: B({}, t, {
              value: le
            }),
            error: B({}, t, {
              value: ge
            }),
            group: B({}, t, {
              value: V
            }),
            groupCollapsed: B({}, t, {
              value: be
            }),
            groupEnd: B({}, t, {
              value: Oe
            })
          });
        }
        ie < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ie = _.ReactCurrentDispatcher, Ue;
    function De(t, d, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (C) {
            var y = C.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Ae;
    {
      var Je = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Je();
    }
    function Ee(t, d) {
      if (!t || Be)
        return "";
      {
        var p = Ae.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Be = !0;
      var C = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var T;
      T = Ie.current, Ie.current = null, Ge();
      try {
        if (d) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (ne) {
              y = ne;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (ne) {
              y = ne;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            y = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && y && typeof ne.stack == "string") {
          for (var x = ne.stack.split(`
`), Z = y.stack.split(`
`), A = x.length - 1, M = Z.length - 1; A >= 1 && M >= 0 && x[A] !== Z[M]; )
            M--;
          for (; A >= 1 && M >= 0; A--, M--)
            if (x[A] !== Z[M]) {
              if (A !== 1 || M !== 1)
                do
                  if (A--, M--, M < 0 || x[A] !== Z[M]) {
                    var ue = `
` + x[A].replace(" at new ", " at ");
                    return t.displayName && ue.includes("<anonymous>") && (ue = ue.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, ue), ue;
                  }
                while (A >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Ie.current = T, sn(), Error.prepareStackTrace = C;
      }
      var ze = t ? t.displayName || t.name : "", Te = ze ? De(ze) : "";
      return typeof t == "function" && Ae.set(t, Te), Te;
    }
    function Me(t, d, p) {
      return Ee(t, !1);
    }
    function en(t) {
      var d = t.prototype;
      return !!(d && d.isReactComponent);
    }
    function se(t, d, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ee(t, en(t));
      if (typeof t == "string")
        return De(t);
      switch (t) {
        case m:
          return De("Suspense");
        case u:
          return De("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case c:
            return Me(t.render);
          case f:
            return se(t.type, d, p);
          case h: {
            var y = t, C = y._payload, T = y._init;
            try {
              return se(T(C), d, p);
            } catch {
            }
          }
        }
      return "";
    }
    var de = Object.prototype.hasOwnProperty, Se = {}, Ve = _.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var d = t._owner, p = se(t.type, t._source, d ? d.type : null);
        Ve.setExtraStackFrame(p);
      } else
        Ve.setExtraStackFrame(null);
    }
    function kn(t, d, p, y, C) {
      {
        var T = Function.call.bind(de);
        for (var S in t)
          if (T(t, S)) {
            var x = void 0;
            try {
              if (typeof t[S] != "function") {
                var Z = Error((y || "React class") + ": " + p + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Z.name = "Invariant Violation", Z;
              }
              x = t[S](d, S, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (A) {
              x = A;
            }
            x && !(x instanceof Error) && (Pe(C), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, S, typeof x), Pe(null)), x instanceof Error && !(x.message in Se) && (Se[x.message] = !0, Pe(C), g("Failed %s type: %s", p, x.message), Pe(null));
          }
      }
    }
    var Q = Array.isArray;
    function E(t) {
      return Q(t);
    }
    function z(t) {
      {
        var d = typeof Symbol == "function" && Symbol.toStringTag, p = d && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function ae(t) {
      try {
        return ce(t), !1;
      } catch {
        return !0;
      }
    }
    function ce(t) {
      return "" + t;
    }
    function U(t) {
      if (ae(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", z(t)), ce(t);
    }
    var G = _.ReactCurrentOwner, ve = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, je, Re;
    function rn(t) {
      if (de.call(t, "ref")) {
        var d = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (d && d.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function bn(t) {
      if (de.call(t, "key")) {
        var d = Object.getOwnPropertyDescriptor(t, "key").get;
        if (d && d.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function an(t, d) {
      typeof t.ref == "string" && G.current;
    }
    function fn(t, d) {
      {
        var p = function() {
          je || (je = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", d));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function En(t, d) {
      {
        var p = function() {
          Re || (Re = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", d));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var _n = function(t, d, p, y, C, T, S) {
      var x = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: d,
        ref: p,
        props: S,
        // Record the component responsible for creating this element.
        _owner: T
      };
      return x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(x, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(x, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: C
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    };
    function Fn(t, d, p, y, C) {
      {
        var T, S = {}, x = null, Z = null;
        p !== void 0 && (U(p), x = "" + p), bn(d) && (U(d.key), x = "" + d.key), rn(d) && (Z = d.ref, an(d));
        for (T in d)
          de.call(d, T) && !ve.hasOwnProperty(T) && (S[T] = d[T]);
        if (t && t.defaultProps) {
          var A = t.defaultProps;
          for (T in A)
            S[T] === void 0 && (S[T] = A[T]);
        }
        if (x || Z) {
          var M = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          x && fn(S, M), Z && En(S, M);
        }
        return _n(t, x, Z, C, y, G.current, S);
      }
    }
    var Ze = _.ReactCurrentOwner, gn = _.ReactDebugCurrentFrame;
    function Le(t) {
      if (t) {
        var d = t._owner, p = se(t.type, t._source, d ? d.type : null);
        gn.setExtraStackFrame(p);
      } else
        gn.setExtraStackFrame(null);
    }
    var dn;
    dn = !1;
    function cn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function Nn() {
      {
        if (Ze.current) {
          var t = P(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Bn(t) {
      return "";
    }
    var Sn = {};
    function An(t) {
      {
        var d = Nn();
        if (!d) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (d = `

Check the top-level render call using <` + p + ">.");
        }
        return d;
      }
    }
    function vn(t, d) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = An(d);
        if (Sn[p])
          return;
        Sn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Ze.current && (y = " It was passed a child from " + P(t._owner.type) + "."), Le(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Le(null);
      }
    }
    function xn(t, d) {
      {
        if (typeof t != "object")
          return;
        if (E(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            cn(y) && vn(y, d);
          }
        else if (cn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var C = j(t);
          if (typeof C == "function" && C !== t.entries)
            for (var T = C.call(t), S; !(S = T.next()).done; )
              cn(S.value) && vn(S.value, d);
        }
      }
    }
    function Ln(t) {
      {
        var d = t.type;
        if (d == null || typeof d == "string")
          return;
        var p;
        if (typeof d == "function")
          p = d.propTypes;
        else if (typeof d == "object" && (d.$$typeof === c || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        d.$$typeof === f))
          p = d.propTypes;
        else
          return;
        if (p) {
          var y = P(d);
          kn(p, t.props, "prop", y, t);
        } else if (d.PropTypes !== void 0 && !dn) {
          dn = !0;
          var C = P(d);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", C || "Unknown");
        }
        typeof d.getDefaultProps == "function" && !d.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var d = Object.keys(t.props), p = 0; p < d.length; p++) {
          var y = d[p];
          if (y !== "children" && y !== "key") {
            Le(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Le(null);
            break;
          }
        }
        t.ref !== null && (Le(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Le(null));
      }
    }
    var Cn = {};
    function wn(t, d, p, y, C, T) {
      {
        var S = re(t);
        if (!S) {
          var x = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (x += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Z = Bn();
          Z ? x += Z : x += Nn();
          var A;
          t === null ? A = "null" : E(t) ? A = "array" : t !== void 0 && t.$$typeof === n ? (A = "<" + (P(t.type) || "Unknown") + " />", x = " Did you accidentally export a JSX literal instead of a component?") : A = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", A, x);
        }
        var M = Fn(t, d, p, C, T);
        if (M == null)
          return M;
        if (S) {
          var ue = d.children;
          if (ue !== void 0)
            if (y)
              if (E(ue)) {
                for (var ze = 0; ze < ue.length; ze++)
                  xn(ue[ze], t);
                Object.freeze && Object.freeze(ue);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              xn(ue, t);
        }
        if (de.call(d, "key")) {
          var Te = P(t), ne = Object.keys(d).filter(function(Kn) {
            return Kn !== "key";
          }), un = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Cn[Te + un]) {
            var Rn = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, un, Te, Rn, Te), Cn[Te + un] = !0;
          }
        }
        return t === i ? Vn(M) : Ln(M), M;
      }
    }
    function zn(t, d, p) {
      return wn(t, d, p, !0);
    }
    function qn(t, d, p) {
      return wn(t, d, p, !1);
    }
    var Un = qn, Wn = zn;
    Ks.Fragment = i, Ks.jsx = Un, Ks.jsxs = Wn;
  })()), Ks;
}
var gw;
function t8() {
  return gw || (gw = 1, process.env.NODE_ENV === "production" ? Bh.exports = e8() : Bh.exports = n8()), Bh.exports;
}
var Ne = t8();
const r8 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomerDetails" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "phone" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "limit" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "externalIds" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "storeId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "expand" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Yotpo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getCustomers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }, { kind: "Argument", name: { kind: "Name", value: "phone_number" }, value: { kind: "Variable", name: { kind: "Name", value: "phone" } } }, { kind: "Argument", name: { kind: "Name", value: "limit" }, value: { kind: "Variable", name: { kind: "Name", value: "limit" } } }, { kind: "Argument", name: { kind: "Name", value: "external_ids" }, value: { kind: "Variable", name: { kind: "Name", value: "externalIds" } } }, { kind: "Argument", name: { kind: "Name", value: "store_id" }, value: { kind: "Variable", name: { kind: "Name", value: "storeId" } } }, { kind: "Argument", name: { kind: "Name", value: "expand" }, value: { kind: "Variable", name: { kind: "Name", value: "expand" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Yotpo_getCustomers_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Yotpo_Customers" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customers" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "external_id" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "phone_number" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "gender" } }, { kind: "Field", name: { kind: "Name", value: "account_created_at" } }, { kind: "Field", name: { kind: "Name", value: "account_updated_at" } }, { kind: "Field", name: { kind: "Name", value: "default_language" } }, { kind: "Field", name: { kind: "Name", value: "dafault_currency" } }, { kind: "Field", name: { kind: "Name", value: "lists" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "since" } }] } }, { kind: "Field", name: { kind: "Name", value: "yotpo_ugc" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "total_reviews" } }, { kind: "Field", name: { kind: "Name", value: "avg_product_rating" } }, { kind: "Field", name: { kind: "Name", value: "avg_site_rating" } }, { kind: "Field", name: { kind: "Name", value: "total_avg_rating" } }, { kind: "Field", name: { kind: "Name", value: "sentiment_avg_product" } }, { kind: "Field", name: { kind: "Name", value: "sentiment_avg_site" } }, { kind: "Field", name: { kind: "Name", value: "total_avg_sentiment" } }, { kind: "Field", name: { kind: "Name", value: "top_topics" } }, { kind: "Field", name: { kind: "Name", value: "last_star_rating" } }, { kind: "Field", name: { kind: "Name", value: "last_review_date" } }, { kind: "Field", name: { kind: "Name", value: "last_sentiment" } }] } }, { kind: "Field", name: { kind: "Name", value: "yotpo_loyalty" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "points_earned" } }, { kind: "Field", name: { kind: "Name", value: "points_balance" } }, { kind: "Field", name: { kind: "Name", value: "last_seen_at" } }, { kind: "Field", name: { kind: "Name", value: "total_redemptions" } }, { kind: "Field", name: { kind: "Name", value: "total_points_redeemed" } }, { kind: "Field", name: { kind: "Name", value: "vip_tier_name" } }, { kind: "Field", name: { kind: "Name", value: "successful_referrals" } }, { kind: "Field", name: { kind: "Name", value: "referrals_made_and_clicked" } }, { kind: "Field", name: { kind: "Name", value: "is_referred_by_other_customer" } }, { kind: "Field", name: { kind: "Name", value: "points_expire_date" } }, { kind: "Field", name: { kind: "Name", value: "credit_balance_amount" } }, { kind: "Field", name: { kind: "Name", value: "credit_balance_customer_currency" } }, { kind: "Field", name: { kind: "Name", value: "is_opt_in" } }, { kind: "Field", name: { kind: "Name", value: "opt_in_date" } }, { kind: "Field", name: { kind: "Name", value: "opt_out_date" } }, { kind: "Field", name: { kind: "Name", value: "has_store_account" } }, { kind: "Field", name: { kind: "Name", value: "referred_by_customer" } }, { kind: "Field", name: { kind: "Name", value: "vip_entry_date" } }, { kind: "Field", name: { kind: "Name", value: "vip_expiration_date" } }, { kind: "Field", name: { kind: "Name", value: "next_points_expire_on" } }, { kind: "Field", name: { kind: "Name", value: "next_points_expire_amount" } }] } }, { kind: "Field", name: { kind: "Name", value: "yotpo_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "active_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }, { kind: "Field", name: { kind: "Name", value: "paused_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }, { kind: "Field", name: { kind: "Name", value: "failed_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }, { kind: "Field", name: { kind: "Name", value: "expired_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }] } }] } }] } }] } }] } }] } }] } }] }, i8 = {
  "\n  query getCustomerDetails(\n    $email: String\n    $phone: String\n    $limit: Int\n    $externalIds: String\n    $storeId: String!\n    $expand: String\n  ) {\n    Yotpo {\n      getCustomers(\n        email: $email\n        phone_number: $phone\n        limit: $limit\n        external_ids: $externalIds\n        store_id: $storeId\n        expand: $expand\n      ) {\n        ... on Yotpo_getCustomers_response {\n          ... on Yotpo_Customers {\n            customers {\n              external_id\n              email\n              phone_number\n              first_name\n              last_name\n              gender\n              account_created_at\n              account_updated_at\n              default_language\n              dafault_currency\n              lists {\n                id\n                since\n              }\n              yotpo_ugc {\n                total_reviews\n                avg_product_rating\n                avg_site_rating\n                total_avg_rating\n                sentiment_avg_product\n                sentiment_avg_site\n                total_avg_sentiment\n                top_topics\n                last_star_rating\n                last_review_date\n                last_sentiment\n              }\n              yotpo_loyalty {\n                points_earned\n                points_balance\n                last_seen_at\n                total_redemptions\n                total_points_redeemed\n                vip_tier_name\n                successful_referrals\n                referrals_made_and_clicked\n                is_referred_by_other_customer\n                points_expire_date\n                credit_balance_amount\n                credit_balance_customer_currency\n                is_opt_in\n                opt_in_date\n                opt_out_date\n                has_store_account\n                referred_by_customer\n                vip_entry_date\n                vip_expiration_date\n                next_points_expire_on\n                next_points_expire_amount\n              }\n              yotpo_subscriptions {\n                active_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                paused_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                failed_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                expired_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                canceled_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": r8
};
function a8(e) {
  return i8[e] ?? {};
}
const o8 = a8(
  /* GraphQL */
  `
  query getCustomerDetails(
    $email: String
    $phone: String
    $limit: Int
    $externalIds: String
    $storeId: String!
    $expand: String
  ) {
    Yotpo {
      getCustomers(
        email: $email
        phone_number: $phone
        limit: $limit
        external_ids: $externalIds
        store_id: $storeId
        expand: $expand
      ) {
        ... on Yotpo_getCustomers_response {
          ... on Yotpo_Customers {
            customers {
              external_id
              email
              phone_number
              first_name
              last_name
              gender
              account_created_at
              account_updated_at
              default_language
              dafault_currency
              lists {
                id
                since
              }
              yotpo_ugc {
                total_reviews
                avg_product_rating
                avg_site_rating
                total_avg_rating
                sentiment_avg_product
                sentiment_avg_site
                total_avg_sentiment
                top_topics
                last_star_rating
                last_review_date
                last_sentiment
              }
              yotpo_loyalty {
                points_earned
                points_balance
                last_seen_at
                total_redemptions
                total_points_redeemed
                vip_tier_name
                successful_referrals
                referrals_made_and_clicked
                is_referred_by_other_customer
                points_expire_date
                credit_balance_amount
                credit_balance_customer_currency
                is_opt_in
                opt_in_date
                opt_out_date
                has_store_account
                referred_by_customer
                vip_entry_date
                vip_expiration_date
                next_points_expire_on
                next_points_expire_amount
              }
              yotpo_subscriptions {
                active_subscriptions {
                  externalProductId
                  externalVariantId
                }
                paused_subscriptions {
                  externalProductId
                  externalVariantId
                }
                failed_subscriptions {
                  externalProductId
                  externalVariantId
                }
                expired_subscriptions {
                  externalProductId
                  externalVariantId
                }
                canceled_subscriptions {
                  externalProductId
                  externalVariantId
                }
              }
            }
          }
        }
      }
    }
  }
`
), s8 = "_copyIcon_1pfts_54", l8 = "_list_1pfts_59", d8 = "_listItem_1pfts_69", c8 = "_listItemHighlighted_1pfts_78", wa = {
  copyIcon: s8,
  list: l8,
  listItem: d8,
  listItemHighlighted: c8
}, u8 = "_wrapper_1xucg_1", m8 = "_externalLink_1xucg_7", qh = {
  wrapper: u8,
  externalLink: m8
}, p8 = ({
  customerDetails: e
}) => {
  const { isCopied: n, copy: r } = Jt(), { isCopied: i, copy: a } = Jt();
  if (!e)
    return null;
  const {
    first_name: o,
    last_name: s,
    email: l,
    phone_number: c,
    account_created_at: m
  } = e, u = 14, f = `${o || ""} ${s || ""}`.trim() || "A customer has no name";
  return /* @__PURE__ */ Ne.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ Ne.jsxs(b, { className: qh.wrapper, gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Ne.jsx(
      b,
      {
        justifyContent: "space-between",
        className: qh.block,
        alignItems: "center",
        children: /* @__PURE__ */ Ne.jsx($.Heading, { variant: "heading-2", children: f })
      }
    ),
    m && /* @__PURE__ */ Ne.jsxs(b, { gap: "200", justifyContent: "space-between", margin: "0 0 200", children: [
      /* @__PURE__ */ Ne.jsx($.Paragraph, { variant: "4", children: "Member since" }),
      /* @__PURE__ */ Ne.jsx($.Paragraph, { variant: "4", children: Gn(m).format($t) })
    ] }),
    l && /* @__PURE__ */ Ne.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Ne.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ Ne.jsx(he, { size: u, name: "mail" }),
        /* @__PURE__ */ Ne.jsx("span", { className: qh.externalLink, children: l })
      ] }),
      /* @__PURE__ */ Ne.jsx(Xe, { content: "Copy email", children: /* @__PURE__ */ Ne.jsx(b, { alignItems: "center", children: /* @__PURE__ */ Ne.jsx(
        he,
        {
          size: u,
          name: n ? "done" : "copy",
          onClick: () => r(l),
          className: wa.copyIcon
        }
      ) }) })
    ] }),
    c && /* @__PURE__ */ Ne.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Ne.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ Ne.jsx(he, { size: u, name: "phone" }),
        /* @__PURE__ */ Ne.jsx($.Paragraph, { variant: "4", children: c })
      ] }),
      /* @__PURE__ */ Ne.jsx(Xe, { content: "Copy phone number", children: /* @__PURE__ */ Ne.jsx(b, { alignItems: "center", children: /* @__PURE__ */ Ne.jsx(
        he,
        {
          size: u,
          name: i ? "done" : "copy",
          onClick: () => a(c),
          className: wa.copyIcon
        }
      ) }) })
    ] })
  ] }) });
}, Zn = ({
  description: e,
  content: n,
  tooltip: r,
  isHighlighted: i = !1
}) => {
  if (n == null)
    return null;
  const a = Nw(n);
  return /* @__PURE__ */ Ne.jsx(
    Ye.Text,
    {
      variant: "dense",
      className: ct(wa.listItem, {
        [wa.listItemHighlighted]: i
      }),
      children: /* @__PURE__ */ Ne.jsx(Xe, { content: r, children: /* @__PURE__ */ Ne.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ Ne.jsx($.Paragraph, { variant: "4", children: e }),
        a ? n : Bi(n)
      ] }) })
    }
  );
}, f8 = ({
  loyalty: e
}) => /* @__PURE__ */ Ne.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ Ne.jsx($.Heading, { variant: "heading-3", children: "Loyalty" }),
  !e && /* @__PURE__ */ Ne.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ Ne.jsx($.Paragraph, { variant: "4", color: "secondary", children: "No loyalty data available" }) }),
  e && /* @__PURE__ */ Ne.jsxs(Ye, { className: wa.list, children: [
    /* @__PURE__ */ Ne.jsx(
      Zn,
      {
        isHighlighted: !0,
        description: "Successful referrals",
        tooltip: "The total number of successful referrals made by the customer.",
        content: e.successful_referrals
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      Zn,
      {
        isHighlighted: !0,
        description: "Referrals made and clicked",
        tooltip: "The total number of referrals made by the customer and clicked on by others.",
        content: e.referrals_made_and_clicked
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      Zn,
      {
        description: "Points earned",
        tooltip: "The total number of loyalty points earned by the customer.",
        content: e.points_earned
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      Zn,
      {
        description: "Points balance",
        tooltip: "The current balance of loyalty points for the customer.",
        content: e.points_balance
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      Zn,
      {
        description: "Last seen",
        tooltip: "The timestamp when the customer was last seen or engaged with the loyalty program.",
        content: e.last_seen_at
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      Zn,
      {
        description: "Total redemptions",
        tooltip: "The total number of times the customer has redeemed loyalty points.",
        content: e.total_redemptions
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      Zn,
      {
        description: "Total points redeemed",
        tooltip: "The total number of loyalty points redeemed by the customer.",
        content: e.total_points_redeemed
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      Zn,
      {
        description: "VIP tier",
        tooltip: "The name of the customer's current VIP tier status.",
        content: e.vip_tier_name
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      Zn,
      {
        description: "Referred by other customer",
        tooltip: "Indicates whether the customer was referred by another customer.",
        content: e.is_referred_by_other_customer
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      Zn,
      {
        description: "Points expiry date",
        tooltip: "The timestamp when the customer's loyalty points are set to expire.",
        content: e.next_points_expire_on || e.points_expire_date
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      Zn,
      {
        description: "Points expiry amount",
        tooltip: "The number of points that are about to expire",
        content: e.next_points_expire_amount
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      Zn,
      {
        description: "Credit balance amount",
        tooltip: "The amount of store credit available to the customer in the default currency of the store.",
        content: e.credit_balance_amount
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      Zn,
      {
        description: "Credit balance customer currency",
        tooltip: "The store credit amount in the customer's preferred currency.",
        content: e.credit_balance_customer_currency
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      Zn,
      {
        description: "Opt in",
        tooltip: "Indicates whether the customer has opted into the loyalty program.",
        content: e.is_opt_in
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      Zn,
      {
        description: "Opt in date",
        tooltip: "The timestamp for when the customer opted into the loyalty program.",
        content: e.opt_in_date
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      Zn,
      {
        description: "Opt out date",
        tooltip: "The timestamp for when the customer opted out of the loyalty program.",
        content: e.opt_out_date
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      Zn,
      {
        description: "Has store account",
        tooltip: "Indicates whether the customer has a store account.",
        content: e.has_store_account
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      Zn,
      {
        description: "Referred by customer",
        tooltip: "The email address of the customer who referred this customer to the loyalty program.",
        content: e.referred_by_customer
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      Zn,
      {
        description: "VIP entry date",
        tooltip: "The timestamp for when the customer entered the VIP tier.",
        content: e.vip_entry_date
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      Zn,
      {
        description: "VIP expiration date",
        tooltip: "The timestamp for when the customer's VIP tier membership is set to expire.",
        content: e.vip_expiration_date
      }
    )
  ] })
] }), h8 = 0.8, y8 = 0.4, vw = (e) => {
  if (e != null)
    return e >= h8 ? /* @__PURE__ */ Ne.jsx(Pn, { variant: "success", size: "small", children: "Positive" }) : e <= y8 ? /* @__PURE__ */ Ne.jsx(Pn, { variant: "error", size: "small", children: "Negative" }) : /* @__PURE__ */ Ne.jsx(Pn, { variant: "warning", size: "small", children: "Neutral" });
}, g8 = ({
  userGeneratedContent: e
}) => /* @__PURE__ */ Ne.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ Ne.jsx($.Heading, { variant: "heading-3", children: "User generated content" }),
  !e && /* @__PURE__ */ Ne.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ Ne.jsx($.Paragraph, { variant: "4", color: "secondary", children: "No user generated content available" }) }),
  e && /* @__PURE__ */ Ne.jsxs(Ye, { className: wa.list, children: [
    /* @__PURE__ */ Ne.jsx(
      Zn,
      {
        isHighlighted: !0,
        description: "Total reviews",
        tooltip: "The total number of reviews submitted by the customer.",
        content: e.total_reviews
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      Zn,
      {
        isHighlighted: !0,
        description: "Total average rating",
        tooltip: "The total average rating given by the customer (combining products and site/store ratings).",
        content: e.total_avg_rating?.toFixed(2)
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      Zn,
      {
        isHighlighted: !0,
        description: "Total average sentiment score",
        tooltip: "The total average sentiment score given by the customer (combining products and site/store scores).",
        content: vw(e.total_avg_sentiment)
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      Zn,
      {
        description: "Average product rating",
        tooltip: "The average product rating given by the customer.",
        content: e.avg_product_rating
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      Zn,
      {
        description: "Average site rating",
        tooltip: "The average rating of the site/store given by the customer.",
        content: e.avg_site_rating?.toFixed(2)
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      Zn,
      {
        description: "Last sentiment",
        tooltip: "The sentiment score of the customer's last review.",
        content: vw(e.last_sentiment)
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      Zn,
      {
        description: "Last star rating",
        tooltip: "The star rating of the customer's last review.",
        content: e.last_star_rating
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      Zn,
      {
        description: "Last review date",
        tooltip: "The timestamp for when the customer last submitted a review.",
        content: Gn(e.last_review_date).format(
          $t
        )
      }
    ),
    /* @__PURE__ */ Ne.jsx(
      Zn,
      {
        description: "Topics",
        tooltip: "An list of top topics (themes) mentioned in all of the customer's reviews.",
        content: /* @__PURE__ */ Ne.jsx(
          b,
          {
            gap: "100",
            width: "80%",
            flexWrap: "wrap",
            justifyContent: "flex-end",
            children: e.top_topics?.map((n, r) => /* @__PURE__ */ Ne.jsx(Pn, { variant: "info", size: "small", children: /* @__PURE__ */ Ne.jsx(Ne.Fragment, { children: n }) }, r))
          }
        )
      }
    )
  ] })
] }), v8 = ({
  conversationContext: e,
  settings: n
}) => {
  const { useQuery: r } = hn(), { track: i } = jn(), [a, o] = pe(), [s, l] = pe(!1), c = e?.customer?.email, m = e?.customer?.phone_number, u = !c && !m, f = n?.yotpoStoreId, h = n?.showCustomerDetails ?? !1, k = n?.showUserGeneratedContent ?? !1, w = n?.displayLoyalty ?? !1, N = n?.displaySubscriptions ?? !1, j = !f, _ = !h && !k && !w && !N, {
    loading: g,
    error: O,
    data: R
  } = r(o8, {
    skip: u || j,
    variables: {
      ...c && { email: c },
      ...!c && m && { phone: m },
      storeId: f,
      expand: "all"
    }
  });
  if (Qe(() => {
    const F = R?.Yotpo?.getCustomers?.customers?.[0];
    F ? (o(F), l(!1), i("yotpo:customer:received")) : l(!0);
  }, [R?.Yotpo, g]), j)
    return /* @__PURE__ */ Ne.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ Ne.jsx(
      $n,
      {
        error: new Ew({
          graphQLErrors: [
            {
              message: "Integration needs to be re-/authorized in the settings."
            }
          ]
        }),
        hideCopyButton: !0
      }
    ) });
  if (u)
    return /* @__PURE__ */ Ne.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200 0 300 0",
        "data-testid": "widget-no-contact-message",
        children: /* @__PURE__ */ Ne.jsx($.Paragraph, { variant: "4", color: "secondary", children: "No email nor phone number are available in this conversation to look up a profile." })
      }
    );
  if (_)
    return /* @__PURE__ */ Ne.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200 0 300 0",
        "data-testid": "widget-no-features",
        children: /* @__PURE__ */ Ne.jsx($.Paragraph, { variant: "4", color: "secondary", children: "All features toggles in the widget settings are disabled." })
      }
    );
  if (g)
    return /* @__PURE__ */ Ne.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ Ne.jsx(mn, {}) });
  if (s)
    return /* @__PURE__ */ Ne.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ Ne.jsx($.Paragraph, { variant: "4", color: "secondary", children: "No customer profile found." }) });
  if (O) {
    const F = O.graphQLErrors;
    return Ul({ errors: F }) ? /* @__PURE__ */ Ne.jsx(
      $.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        variant: "4",
        "data-testid": "widget-downstream-api-forbidden-error",
        children: "The API token used for the integration does not have the necessary access rights. Please contact your administrator."
      }
    ) : Ml({ errors: F }) ? /* @__PURE__ */ Ne.jsx(
      $.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        variant: "4",
        "data-testid": "widget-downstream-api-authorization-error",
        children: "The integration could not authorize against Yotpo. Please contact your administrator."
      }
    ) : /* @__PURE__ */ Ne.jsx($n, { error: O });
  }
  return /* @__PURE__ */ Ne.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        h && /* @__PURE__ */ Ne.jsx(p8, { customerDetails: a }),
        k && /* @__PURE__ */ Ne.jsx(
          g8,
          {
            userGeneratedContent: a?.yotpo_ugc
          }
        ),
        w && /* @__PURE__ */ Ne.jsx(f8, { loyalty: a?.yotpo_loyalty })
      ]
    }
  );
}, k8 = "_settingsWrapper_1ycvy_1", b8 = "_settingsWrapperHeader_1ycvy_6", _8 = "_settingsWrapperContent_1ycvy_10", x8 = "_settingsWrapperContentCode_1ycvy_18", S8 = "_settingsWrapperContentCURL_1ycvy_26", wo = {
  settingsWrapper: k8,
  settingsWrapperHeader: b8,
  settingsWrapperContent: _8,
  settingsWrapperContentCode: x8,
  settingsWrapperContentCURL: S8
}, XF = ({
  handleChangeText: e
}) => {
  const [n, r] = pe(!1), { isCopied: i, copy: a } = Jt(), { control: o } = ut({
    defaultValues: {
      storeId: "",
      secret: ""
    },
    mode: "onChange"
  }), s = gi({
    control: o
  }), l = s.storeId !== "" && s.secret !== "", c = ft(() => {
    const m = s.storeId, u = s.secret;
    return `curl --request POST \\
  --url https://api.yotpo.com/core/v3/stores/${m || "store_id"}/access_tokens \\
  --header 'Content-Type: application/json' \\
  --header 'accept: application/json'${u ? ` \\
  --data '{"secret":"${u}"}'` : ""}`;
  }, [s.storeId, s.secret]);
  return /* @__PURE__ */ Ne.jsx(Ne.Fragment, { children: /* @__PURE__ */ Ne.jsx(X, { span: 6, children: /* @__PURE__ */ Ne.jsxs(b, { flexDirection: "column", className: wo.settingsWrapper, children: [
    /* @__PURE__ */ Ne.jsxs(
      b,
      {
        gap: "200",
        alignItems: "center",
        className: wo.settingsWrapperHeader,
        onClick: () => r(!n),
        children: [
          /* @__PURE__ */ Ne.jsx($.Heading, { variant: "heading-3", children: "How to get the Yotpo access token" }),
          /* @__PURE__ */ Ne.jsx(he, { name: n ? "angle-down" : "angle-right" })
        ]
      }
    ),
    n && /* @__PURE__ */ Ne.jsxs(
      b,
      {
        flexDirection: "column",
        className: wo.settingsWrapperContent,
        children: [
          /* @__PURE__ */ Ne.jsx(b, { margin: "0 0 400", children: /* @__PURE__ */ Ne.jsx(
            Iy,
            {
              variant: "announcement",
              headline: "In order to get the Yotpo access token, you have to follow the steps below",
              description: /* @__PURE__ */ Ne.jsxs("ol", { children: [
                /* @__PURE__ */ Ne.jsx("li", { children: "Insert the Yotpo store ID and secret below in the input fields" }),
                /* @__PURE__ */ Ne.jsx("li", { children: "Once the fields are filled in, the CURL command will appear below and you can copy and run it in your terminal" }),
                /* @__PURE__ */ Ne.jsxs("li", { children: [
                  "The response should look like this",
                  " ",
                  /* @__PURE__ */ Ne.jsx("span", { className: wo.settingsWrapperContentCode, children: '{ "access_token": "this-is-your-token" }' })
                ] }),
                /* @__PURE__ */ Ne.jsxs("li", { children: [
                  "Copy the token without quotes and paste it in the",
                  " ",
                  /* @__PURE__ */ Ne.jsx("i", { children: "Yotpo access token" }),
                  " input field below"
                ] }),
                /* @__PURE__ */ Ne.jsx("li", { children: "Click the save button" })
              ] })
            }
          ) }),
          /* @__PURE__ */ Ne.jsx(
            Nt,
            {
              name: "storeId",
              control: o,
              render: ({ field: m }) => /* @__PURE__ */ Ne.jsx(
                Wr,
                {
                  label: "Yotpo store ID",
                  placeholder: "Please insert the store ID",
                  input: {
                    ...m,
                    onChange: (u) => {
                      m.onChange(u), e({
                        target: {
                          name: "yotpoStoreId",
                          value: u?.target.value ?? ""
                        }
                      });
                    }
                  }
                }
              )
            }
          ),
          /* @__PURE__ */ Ne.jsx(
            Nt,
            {
              name: "secret",
              control: o,
              render: ({ field: m }) => /* @__PURE__ */ Ne.jsx(
                Wr,
                {
                  label: "Yotpo secret",
                  placeholder: "Please insert the secret",
                  input: m
                }
              )
            }
          ),
          l && /* @__PURE__ */ Ne.jsxs(Ne.Fragment, { children: [
            /* @__PURE__ */ Ne.jsx(He, { label: "Generated CURL command", noAlert: !0, children: /* @__PURE__ */ Ne.jsx(
              b,
              {
                as: "pre",
                gap: "200",
                margin: "100 0 250",
                className: wo.settingsWrapperContentCURL,
                children: c()
              }
            ) }),
            /* @__PURE__ */ Ne.jsx(b, { alignContent: "start", children: /* @__PURE__ */ Ne.jsx(
              Xe,
              {
                content: i ? "Copied!" : "Copy CURL command",
                children: /* @__PURE__ */ Ne.jsx(
                  tt,
                  {
                    variant: "secondary",
                    icon: i ? "check-circle" : "copy",
                    onClick: () => a(c()),
                    children: "Copy CURL"
                  }
                )
              }
            ) })
          ] })
        ]
      }
    )
  ] }) }) });
}, Go = [
  // The store id is populated by the OAuth flow, not edited in the form. It is
  // kept here so the runtime widget render can resolve it and so it round-trips
  // on update.
  {
    key: "yotpoStoreId",
    label: "Yotpo store ID",
    type: "string",
    secret: !1,
    defaultValue: ""
  },
  // Secret, only written when editing a legacy token-authenticated widget.
  // Excluded from the read path; omitted from the update payload unless the
  // user re-enters it (preserving the stored value).
  {
    key: "yotpoAccessToken",
    label: "Yotpo access token",
    type: "string",
    secret: !0,
    defaultValue: ""
  },
  {
    key: "showCustomerDetails",
    label: "Show customer details",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showUserGeneratedContent",
    label: "Show user generated content",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayLoyalty",
    label: "Show loyalty data",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  }
], N8 = [
  /**
   * The store ID will be fetched through the OAuth flow, so there's no real
   * reason to show it
   */
  {
    key: "yotpoStoreId",
    label: "Yotpo store ID",
    placeholder: "",
    readOnly: !0,
    required: !1,
    secret: !1,
    type: "hidden",
    hideOnCreate: !0
  },
  {
    key: "authorizeWithOauth",
    label: "Authorize with OAuth",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: vi
  }
], j8 = [
  {
    key: "accessTokenComponent",
    label: "Retrieve Yotpo access token",
    secret: !1,
    type: "custom",
    component: XF
  },
  {
    key: "yotpoStoreId",
    label: "Yotpo store ID",
    placeholder: 'See "How to get the Yotpo access token" above.',
    readOnly: !0,
    required: !0,
    secret: !1,
    type: "input"
  },
  {
    key: "yotpoAccessToken",
    label: "Yotpo access token",
    placeholder: "Insert the Yotpo access token",
    required: !0,
    secret: !0,
    type: "input"
  }
], Co = ir(Go), Hh = "YOTPO", w8 = {
  enabled: !1,
  name: "",
  ...Bl(
    [],
    Go
  )
}, C8 = ({
  integrationId: e,
  configuration: n,
  handleRedirect: r,
  showNotification: i,
  automationCouplingState: a,
  renderConditionsEditor: o
}) => {
  const s = !e, l = ut({
    mode: "onChange",
    defaultValues: w8
  }), {
    create: c,
    update: m,
    remove: u,
    isLoading: f,
    error: h,
    misconfigurationCause: k,
    setMisconfigurationCause: w
  } = mr({
    integrationId: e,
    integrationType: Hh,
    handleRedirect: r,
    showNotification: i
  }), {
    isLoading: N,
    error: j,
    isWidgetUnknown: _,
    refetch: g,
    widgetConfiguration: O
  } = pr({
    integrationId: e,
    fieldDefinitions: Go,
    form: l,
    onMisconfigured: w
  }), { renderConditions: R, setRenderConditions: F, renderConditionsForSubmit: I } = fr({
    integrationId: e,
    widgetConfiguration: O,
    renderConditionsEditor: o
  }), L = s || !!O?.additionalProperties?.isUsingOAuth, W = (re) => yr(re, {
    fieldDefinitions: Go,
    isCreationMode: s,
    create: c,
    update: m,
    renderConditions: I
  }), J = l.watch("name");
  return /* @__PURE__ */ Ne.jsxs(
    hr,
    {
      form: l,
      integrationId: e,
      onValidSubmit: W,
      error: j ?? h,
      onRetry: j ? g : void 0,
      isLoading: f || N,
      isWidgetUnknown: _,
      children: [
        k && /* @__PURE__ */ Ne.jsx(gr, { cause: k }),
        /* @__PURE__ */ Ne.jsxs(et, { children: [
          /* @__PURE__ */ Ne.jsx(X, { children: /* @__PURE__ */ Ne.jsx(He, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ Ne.jsx(
            yn,
            {
              name: "enabled",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ Ne.jsx(X, { span: 3, children: /* @__PURE__ */ Ne.jsx(
            On,
            {
              name: "name",
              label: "Widget name",
              control: l.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ Ne.jsx(X, { span: 3 }),
          !L && /* @__PURE__ */ Ne.jsxs(Ne.Fragment, { children: [
            /* @__PURE__ */ Ne.jsx(
              XF,
              {
                handleChangeText: (re) => l.setValue("yotpoStoreId", re?.target.value ?? "")
              }
            ),
            /* @__PURE__ */ Ne.jsx(X, { span: 3, children: /* @__PURE__ */ Ne.jsx(
              On,
              {
                name: "yotpoStoreId",
                label: Co.yotpoStoreId,
                control: l.control,
                rules: { required: "Yotpo store ID is required" },
                componentProps: {
                  placeholder: 'See "How to get the Yotpo access token" above.',
                  readOnly: !0,
                  autoComplete: "off"
                }
              }
            ) }),
            /* @__PURE__ */ Ne.jsx(X, { span: 3 }),
            /* @__PURE__ */ Ne.jsx(X, { span: 3, children: /* @__PURE__ */ Ne.jsx(
              $r,
              {
                name: "yotpoAccessToken",
                label: Co.yotpoAccessToken,
                control: l.control,
                isCreationMode: s,
                rules: { required: "Yotpo access token is required" },
                componentProps: {
                  placeholder: "Insert the Yotpo access token",
                  autoComplete: "off"
                }
              }
            ) }),
            /* @__PURE__ */ Ne.jsx(X, { span: 3 })
          ] }),
          /* @__PURE__ */ Ne.jsx(X, { span: 3, children: /* @__PURE__ */ Ne.jsx(He, { label: Co.showCustomerDetails, children: /* @__PURE__ */ Ne.jsx(
            yn,
            {
              name: "showCustomerDetails",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ Ne.jsx(X, { span: 3 }),
          /* @__PURE__ */ Ne.jsx(X, { span: 3, children: /* @__PURE__ */ Ne.jsx(He, { label: Co.showUserGeneratedContent, children: /* @__PURE__ */ Ne.jsx(
            yn,
            {
              name: "showUserGeneratedContent",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ Ne.jsx(X, { span: 3 }),
          /* @__PURE__ */ Ne.jsx(X, { span: 3, children: /* @__PURE__ */ Ne.jsx(He, { label: Co.displayLoyalty, children: /* @__PURE__ */ Ne.jsx(
            yn,
            {
              name: "displayLoyalty",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ Ne.jsx(X, { span: 3 }),
          L && !s && e && /* @__PURE__ */ Ne.jsx(
            vi,
            {
              configuration: n,
              integrationId: e,
              integrationType: Hh,
              label: "Authorize with OAuth"
            }
          ),
          o && R !== null && /* @__PURE__ */ Ne.jsx(X, { children: o({
            value: R,
            onChange: F,
            configurationKey: O?.id
          }) })
        ] }),
        /* @__PURE__ */ Ne.jsx(
          vr,
          {
            integrationType: Hh,
            integrationId: e,
            widgetName: J,
            isCreationMode: s,
            isSubmitting: l.formState.isSubmitting,
            automationCouplingState: a,
            onConfirmDelete: () => u()
          }
        )
      ]
    }
  );
}, F8 = ({
  hasShopifyOAuth: e = !1,
  isShopifyMarketplaceApp: n = !1,
  isCreationMode: r = !1
}) => r ? {
  authSettings: e9,
  featureSettings: []
} : n ? {
  authSettings: n9,
  featureSettings: [...RF]
} : e ? {
  authSettings: [
    ...Bj,
    ...XW
  ],
  featureSettings: [...qj]
} : {
  authSettings: [
    ...Bj,
    ...ZW
  ],
  featureSettings: [...qj]
}, ZF = (e, n) => ({
  hasOAuth: r = !1,
  isCreationMode: i = !1
}) => r || i ? e : n, I8 = ZF(
  N8,
  j8
), $8 = ZF(
  bV,
  _V
), eI = (e = {
  SHOPIFY: {},
  YOTPO: {},
  KLAVIYO: {}
}) => {
  const { SHOPIFY: n, YOTPO: r, KLAVIYO: i } = e, {
    authSettings: a,
    featureSettings: o
  } = F8(n), s = I8(r), l = $8(i);
  return {
    SHOPIFY: {
      widget: bK,
      icon: "shopify",
      iconColors: {
        contentColor: "rgb(148, 190, 69)",
        backgroundColor: "rgba(148, 190, 69, 0.1)"
      },
      fieldDefinitions: Ko,
      WidgetSettings: YW,
      // Kept for backwards compatibility with the older declarative
      // configuration types. The active settings UI is `WidgetSettings`.
      settingsConfiguration: [
        ...a,
        ...o
      ]
    },
    JIRA: {
      widget: K2,
      icon: "jira",
      iconColors: {
        contentColor: "rgb(38, 132, 255)",
        backgroundColor: "rgba(38, 132, 255, 0.075)"
      },
      fieldDefinitions: Sl,
      WidgetSettings: J2
    },
    GITHUB: {
      widget: YP,
      icon: "github",
      iconColors: {
        contentColor: "rgb(87, 96, 106)",
        backgroundColor: "rgba(221, 244, 255, 0.75)"
      },
      fieldDefinitions: bl,
      WidgetSettings: QP
    },
    MIUROS: {
      widget: OB,
      icon: "miuros",
      iconColors: {
        contentColor: "rgb(246, 135, 179)",
        backgroundColor: "rgba(246, 135, 179, 0.15)"
      },
      fieldDefinitions: El,
      WidgetSettings: AB
    },
    KLAVIYO: {
      widget: kV,
      icon: "klaviyo",
      iconColors: {
        contentColor: "rgb(0, 0, 0)",
        backgroundColor: "rgba(0, 0, 0, 0.075)"
      },
      fieldDefinitions: Na,
      WidgetSettings: IV,
      // Kept for backwards compatibility with the older declarative
      // configuration types. The active settings UI is `WidgetSettings`.
      settingsConfiguration: [...l]
    },
    LINEAR: {
      widget: e5,
      icon: "linear",
      iconColors: {
        contentColor: "rgb(94, 106, 210)",
        backgroundColor: "rgba(94, 106, 210, 0.15)"
      },
      fieldDefinitions: Il,
      WidgetSettings: t5
    },
    VOYADO: {
      widget: QG,
      icon: "voyado",
      iconColors: {
        contentColor: "rgb(0, 0, 0)",
        backgroundColor: "rgba(0, 0, 0, 0.075)"
      },
      fieldDefinitions: Vl,
      WidgetSettings: ZG
    },
    LOYALTYLION: {
      widget: R5,
      icon: "loyaltylion",
      iconColors: {
        contentColor: "rgb(36, 31, 79)",
        backgroundColor: "rgba(36, 31, 79, 0.075)"
      },
      fieldDefinitions: $l,
      WidgetSettings: O5
    },
    RECHARGE: {
      widget: Tq,
      icon: "recharge",
      iconColors: {
        contentColor: "rgb(57, 1, 241)",
        backgroundColor: "rgba(57, 1, 241, 0.075)"
      },
      fieldDefinitions: Tl,
      WidgetSettings: Dq
    },
    BRAZE: {
      widget: xO,
      icon: "braze",
      iconColors: {
        contentColor: "rgb(48, 2, 102)",
        backgroundColor: "rgba(48, 2, 102, 0.075)"
      },
      fieldDefinitions: qo,
      WidgetSettings: NO
    },
    YOTPO: {
      widget: v8,
      icon: "yotpo",
      iconColors: {
        contentColor: "rgb(0, 66, 228)",
        backgroundColor: "rgba(0, 66, 228, 0.075)"
      },
      fieldDefinitions: Go,
      WidgetSettings: C8,
      // Kept for backwards compatibility with the older declarative
      // configuration types. The active settings UI is `WidgetSettings`.
      settingsConfiguration: [...s]
    },
    INGRID: {
      widget: NA,
      icon: "ingrid",
      iconColors: {
        contentColor: "rgb(0, 0, 0)",
        backgroundColor: "rgba(0, 0, 0, 0.075)"
      },
      fieldDefinitions: _l,
      WidgetSettings: wA
    },
    RIVOLOYALTY: {
      widget: v6,
      icon: "rivoloyalty",
      iconColors: {
        contentColor: "rgb(0, 0, 0)",
        backgroundColor: "rgba(0, 0, 0, 0.075)"
      },
      fieldDefinitions: Al,
      WidgetSettings: AW
    }
  };
}, E8 = (e, n) => {
  const r = n.find(
    (i) => i.key === e.key
  )?.value;
  return e.type === "boolean" ? xI(r, e.defaultValue) : SI(r, e.defaultValue);
}, T8 = (e, n) => e.map((r) => ({
  key: r.key,
  value: E8(r, n)
})), R8 = ({ fieldDefinitions: e }, n) => T8(
  (e ?? []).filter(({ secret: r }) => !r),
  n
), D8 = (e) => {
  const n = eI();
  return e.map(
    ({
      id: r,
      type: i,
      name: a,
      settings: o,
      misconfigured: s,
      renderConditions: l,
      integrationKey: c
    }) => {
      const u = n[i];
      return {
        id: r,
        type: i,
        name: a,
        settings: R8(u, o),
        misconfigured: s,
        renderConditions: l,
        icon: u.icon,
        iconColors: u.iconColors,
        widget: u.widget,
        integrationKey: c
      };
    }
  );
}, O8 = ({
  widget: e,
  index: n,
  configuration: r,
  conversationContext: i,
  showNotification: a,
  onToggleFn: o,
  isOpenFn: s,
  isMinimized: l,
  isUnmatched: c,
  renderVisibilityToggleElement: m,
  renderDragElement: u,
  renderConditionMatchedIndicator: f
}) => {
  const { track: h } = jn(), k = RT(), w = Er(null), {
    id: N,
    name: j,
    type: _,
    widget: g,
    settings: O,
    misconfigured: R,
    renderConditions: F,
    icon: I,
    iconColors: L,
    integrationKey: W
  } = Xn(
    () => D8([e])[0],
    [e]
  ), J = `partner-integration-${_}`, re = /* @__PURE__ */ Qn.jsx($y, { icon: I, color: L }), K = O?.reduce(
    (Y, P) => (Y[P.key] = P.value, Y),
    {}
  );
  return l ? /* @__PURE__ */ Qn.jsx("div", { className: "icon-holder", children: re }, `partner-icon-${N}`) : /* @__PURE__ */ Qn.jsxs(
    xr,
    {
      onToggle: () => {
        h(
          s(W) ? "widget:collapse:closed" : "widget:collapse:opened",
          { widgetId: N, widgetType: _.toLowerCase() }
        ), o(W);
      },
      isOpen: s(W),
      className: J,
      containerRef: w,
      children: [
        /* @__PURE__ */ Qn.jsx(
          xr.Header,
          {
            className: ct({ [PT.unmatchedHeader]: c }),
            wrap: "normal",
            avatar: re,
            slotBeforeTitle: u?.(W, n, w),
            slotAfterTitle: /* @__PURE__ */ Qn.jsx(Qn.Fragment, { children: m?.(W) }),
            children: /* @__PURE__ */ Qn.jsxs(b, { alignItems: "center", flexDirection: "row", gap: "200", children: [
              j,
              f?.(F ?? [], N)
            ] })
          }
        ),
        /* @__PURE__ */ Qn.jsx(xr.Content, { children: R ? /* @__PURE__ */ Qn.jsx($n, { isMisconfigured: !0 }) : /* @__PURE__ */ Qn.jsx(
          Fw.Provider,
          {
            value: {
              onError: (Y, P) => console.warn(
                `Something went wrong with a partner widget of type '${_}' and id '${N}'`,
                Y,
                P
              )
            },
            children: /* @__PURE__ */ Qn.jsx(
              cC,
              {
                integrationId: N,
                type: _,
                configuration: r,
                showNotification: a,
                showModal: k,
                children: CI(g, {
                  conversationContext: i,
                  settings: K
                })
              }
            )
          }
        ) })
      ]
    },
    W
  );
}, fY = ({
  widgets: e,
  configuration: n,
  conversationContext: r,
  showNotification: i,
  onToggleFn: a,
  isOpenFn: o,
  isMinimized: s,
  renderVisibilityToggleElement: l,
  renderDragElement: c,
  renderConditionMatchedIndicator: m,
  widgetAnnotations: u
}) => /* @__PURE__ */ Qn.jsx(DT, { children: e.map((f, h) => /* @__PURE__ */ Qn.jsx(
  O8,
  {
    widget: f,
    index: h,
    configuration: n,
    conversationContext: r,
    showNotification: i,
    onToggleFn: a,
    isOpenFn: o,
    isMinimized: s,
    isUnmatched: u?.get(f.id) === !1,
    renderVisibilityToggleElement: l,
    renderDragElement: c,
    renderConditionMatchedIndicator: m
  },
  f.integrationKey
)) }), hY = ({
  configuration: e,
  integrationId: n,
  type: r,
  handleRedirect: i,
  showNotification: a,
  automationCouplingState: o,
  renderConditionsEditor: s
}) => {
  const l = eI()[r]?.WidgetSettings;
  return /* @__PURE__ */ Qn.jsx(
    Fw.Provider,
    {
      value: {
        onError: (c, m) => console.warn(
          `Something went wrong with the partner widget settings of type ${r} and id ${n}`,
          c,
          m
        )
      },
      children: /* @__PURE__ */ Qn.jsx(
        cC,
        {
          integrationId: n,
          type: r,
          configuration: e,
          showNotification: a,
          children: /* @__PURE__ */ Qn.jsx(Qn.Fragment, { children: l && /* @__PURE__ */ Qn.jsx(
            l,
            {
              configuration: e,
              integrationId: n,
              handleRedirect: i,
              showNotification: a,
              automationCouplingState: o,
              renderConditionsEditor: s
            }
          ) })
        }
      )
    }
  );
}, kw = "__PairingContext__", nI = globalThis[kw] ?? (() => {
  const e = Fy({});
  return globalThis[kw] = e, e;
})(), yY = () => ql(nI), gY = ({
  value: e,
  children: n
}) => /* @__PURE__ */ Qn.jsx(nI.Provider, { value: e, children: n }), P8 = Kl`
  query getWidgetConfigurations {
    Management {
      widgetConfigurations {
        id
        type
        enabled
        name
        misconfigured
        renderConditions
        settings {
          key
          value
        }
      }
    }
  }
`;
function vY(e, { skip: n = !1 } = {}) {
  const [r, i] = pe([]), [a, o] = pe(!1);
  return Qe(() => {
    if (n) {
      o(!1);
      return;
    }
    let s = !1;
    return o(!0), dC(e).query({
      query: P8
    }).then(({ data: l }) => {
      s || (i(
        (l?.Management?.widgetConfigurations ?? []).filter(
          (c) => c != null
        ).map((c) => ({
          ...c,
          integrationKey: `partner-integration-${c.id}`
        }))
      ), o(!1));
    }).catch(() => {
      s || o(!1);
    }), () => {
      s = !0;
    };
  }, [e, n]), {
    isLoading: a,
    widgets: r
  };
}
var Gs = { exports: {} }, bw;
function A8() {
  if (bw) return Gs.exports;
  bw = 1;
  var e = typeof Reflect == "object" ? Reflect : null, n = e && typeof e.apply == "function" ? e.apply : function(F, I, L) {
    return Function.prototype.apply.call(F, I, L);
  }, r;
  e && typeof e.ownKeys == "function" ? r = e.ownKeys : Object.getOwnPropertySymbols ? r = function(F) {
    return Object.getOwnPropertyNames(F).concat(Object.getOwnPropertySymbols(F));
  } : r = function(F) {
    return Object.getOwnPropertyNames(F);
  };
  function i(R) {
    console && console.warn && console.warn(R);
  }
  var a = Number.isNaN || function(F) {
    return F !== F;
  };
  function o() {
    o.init.call(this);
  }
  Gs.exports = o, Gs.exports.once = _, o.EventEmitter = o, o.prototype._events = void 0, o.prototype._eventsCount = 0, o.prototype._maxListeners = void 0;
  var s = 10;
  function l(R) {
    if (typeof R != "function")
      throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof R);
  }
  Object.defineProperty(o, "defaultMaxListeners", {
    enumerable: !0,
    get: function() {
      return s;
    },
    set: function(R) {
      if (typeof R != "number" || R < 0 || a(R))
        throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + R + ".");
      s = R;
    }
  }), o.init = function() {
    (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
  }, o.prototype.setMaxListeners = function(F) {
    if (typeof F != "number" || F < 0 || a(F))
      throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + F + ".");
    return this._maxListeners = F, this;
  };
  function c(R) {
    return R._maxListeners === void 0 ? o.defaultMaxListeners : R._maxListeners;
  }
  o.prototype.getMaxListeners = function() {
    return c(this);
  }, o.prototype.emit = function(F) {
    for (var I = [], L = 1; L < arguments.length; L++) I.push(arguments[L]);
    var W = F === "error", J = this._events;
    if (J !== void 0)
      W = W && J.error === void 0;
    else if (!W)
      return !1;
    if (W) {
      var re;
      if (I.length > 0 && (re = I[0]), re instanceof Error)
        throw re;
      var K = new Error("Unhandled error." + (re ? " (" + re.message + ")" : ""));
      throw K.context = re, K;
    }
    var Y = J[F];
    if (Y === void 0)
      return !1;
    if (typeof Y == "function")
      n(Y, this, I);
    else
      for (var P = Y.length, B = w(Y, P), L = 0; L < P; ++L)
        n(B[L], this, I);
    return !0;
  };
  function m(R, F, I, L) {
    var W, J, re;
    if (l(I), J = R._events, J === void 0 ? (J = R._events = /* @__PURE__ */ Object.create(null), R._eventsCount = 0) : (J.newListener !== void 0 && (R.emit(
      "newListener",
      F,
      I.listener ? I.listener : I
    ), J = R._events), re = J[F]), re === void 0)
      re = J[F] = I, ++R._eventsCount;
    else if (typeof re == "function" ? re = J[F] = L ? [I, re] : [re, I] : L ? re.unshift(I) : re.push(I), W = c(R), W > 0 && re.length > W && !re.warned) {
      re.warned = !0;
      var K = new Error("Possible EventEmitter memory leak detected. " + re.length + " " + String(F) + " listeners added. Use emitter.setMaxListeners() to increase limit");
      K.name = "MaxListenersExceededWarning", K.emitter = R, K.type = F, K.count = re.length, i(K);
    }
    return R;
  }
  o.prototype.addListener = function(F, I) {
    return m(this, F, I, !1);
  }, o.prototype.on = o.prototype.addListener, o.prototype.prependListener = function(F, I) {
    return m(this, F, I, !0);
  };
  function u() {
    if (!this.fired)
      return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
  }
  function f(R, F, I) {
    var L = { fired: !1, wrapFn: void 0, target: R, type: F, listener: I }, W = u.bind(L);
    return W.listener = I, L.wrapFn = W, W;
  }
  o.prototype.once = function(F, I) {
    return l(I), this.on(F, f(this, F, I)), this;
  }, o.prototype.prependOnceListener = function(F, I) {
    return l(I), this.prependListener(F, f(this, F, I)), this;
  }, o.prototype.removeListener = function(F, I) {
    var L, W, J, re, K;
    if (l(I), W = this._events, W === void 0)
      return this;
    if (L = W[F], L === void 0)
      return this;
    if (L === I || L.listener === I)
      --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete W[F], W.removeListener && this.emit("removeListener", F, L.listener || I));
    else if (typeof L != "function") {
      for (J = -1, re = L.length - 1; re >= 0; re--)
        if (L[re] === I || L[re].listener === I) {
          K = L[re].listener, J = re;
          break;
        }
      if (J < 0)
        return this;
      J === 0 ? L.shift() : N(L, J), L.length === 1 && (W[F] = L[0]), W.removeListener !== void 0 && this.emit("removeListener", F, K || I);
    }
    return this;
  }, o.prototype.off = o.prototype.removeListener, o.prototype.removeAllListeners = function(F) {
    var I, L, W;
    if (L = this._events, L === void 0)
      return this;
    if (L.removeListener === void 0)
      return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : L[F] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete L[F]), this;
    if (arguments.length === 0) {
      var J = Object.keys(L), re;
      for (W = 0; W < J.length; ++W)
        re = J[W], re !== "removeListener" && this.removeAllListeners(re);
      return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
    }
    if (I = L[F], typeof I == "function")
      this.removeListener(F, I);
    else if (I !== void 0)
      for (W = I.length - 1; W >= 0; W--)
        this.removeListener(F, I[W]);
    return this;
  };
  function h(R, F, I) {
    var L = R._events;
    if (L === void 0)
      return [];
    var W = L[F];
    return W === void 0 ? [] : typeof W == "function" ? I ? [W.listener || W] : [W] : I ? j(W) : w(W, W.length);
  }
  o.prototype.listeners = function(F) {
    return h(this, F, !0);
  }, o.prototype.rawListeners = function(F) {
    return h(this, F, !1);
  }, o.listenerCount = function(R, F) {
    return typeof R.listenerCount == "function" ? R.listenerCount(F) : k.call(R, F);
  }, o.prototype.listenerCount = k;
  function k(R) {
    var F = this._events;
    if (F !== void 0) {
      var I = F[R];
      if (typeof I == "function")
        return 1;
      if (I !== void 0)
        return I.length;
    }
    return 0;
  }
  o.prototype.eventNames = function() {
    return this._eventsCount > 0 ? r(this._events) : [];
  };
  function w(R, F) {
    for (var I = new Array(F), L = 0; L < F; ++L)
      I[L] = R[L];
    return I;
  }
  function N(R, F) {
    for (; F + 1 < R.length; F++)
      R[F] = R[F + 1];
    R.pop();
  }
  function j(R) {
    for (var F = new Array(R.length), I = 0; I < F.length; ++I)
      F[I] = R[I].listener || R[I];
    return F;
  }
  function _(R, F) {
    return new Promise(function(I, L) {
      function W(re) {
        R.removeListener(F, J), L(re);
      }
      function J() {
        typeof R.removeListener == "function" && R.removeListener("error", W), I([].slice.call(arguments));
      }
      O(R, F, J, { once: !0 }), F !== "error" && g(R, W, { once: !0 });
    });
  }
  function g(R, F, I) {
    typeof R.on == "function" && O(R, "error", F, I);
  }
  function O(R, F, I, L) {
    if (typeof R.on == "function")
      L.once ? R.once(F, I) : R.on(F, I);
    else if (typeof R.addEventListener == "function")
      R.addEventListener(F, function W(J) {
        L.once && R.removeEventListener(F, W), I(J);
      });
    else
      throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof R);
  }
  return Gs.exports;
}
var L8 = A8();
function kY() {
  const e = new L8.EventEmitter();
  return e && typeof window < "u" ? window._partner = {
    events: e
  } : console.warn(
    "Initialization of partner-integration events was not successfull."
  ), e;
}
export {
  IT as GraphQLClientProvider,
  nI as PairingContext,
  gY as PairingProvider,
  O8 as PartnerIntegrationCard,
  DT as PartnerIntegrationModalProvider,
  fY as PartnerIntegrations,
  hY as PartnerIntegrationsSettings,
  eI as getWidgetDefinitions,
  kY as initializePartnerEventEmitter,
  yY as usePairing,
  RT as usePartnerIntegrationModal,
  vY as usePartnerIntegrationWidgetConfigurations
};
